(function () {
  angular.module('app', [
    'ui.router',
    'oc.lazyLoad',
    'ngResource',
    'ngCookies',
    'ngTable',
    'ui.bootstrap',
    'highcharts-ng',
    'ngMessages',
    'angular-loading-bar',
    'ngAnimate',
    'ngSanitize',
    'ui.select',
    'angular-jwt',
    'ngFileSaver'
  ]);
})();
(function () {
  angular
    .module('app')
    .config(httpCatch)
    .config(function ($httpProvider) {
      $httpProvider.defaults.headers.delete = {
        "Content-Type": "application/json;charset=utf-8"
      }
    })
    .config(resourceConfig)
    .config(jwtConfig)
    .config(datepickerConfig)
    .config(routerExpand)
    .run(initRunFunc);

  function httpCatch($httpProvider) {
    // $httpProvider.defaults.withCredentials = true
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    // 捕获http请求异常
    $httpProvider.interceptors.push(['$q', '$timeout', '$location', function ($q, $timeout, $location) {
      return {
        'request': function (config) {
          if (['PUT', 'DELETE', 'POST'].indexOf(config.method) != -1) {
            var v = angular.element('.submit');
            if (v.length > 0) {
              v.attr('disabled', true);
              v.find('i').hide();
              v.find('i.loader').show()
            }
          }
          return config
        },
        'response': function (response) {
          if (['PUT', 'DELETE', 'POST'].indexOf(response.config.method) != -1) {
            var v = angular.element('.submit');
            if (v.length > 0) {
              v.attr('disabled', false);
              v.find('i').show();
              v.find('i.loader').hide();
            }
          }
          return response
        },
        'responseError': function (rejection, $state) {
          if (['PUT', 'DELETE', 'POST'].indexOf(rejection.config.method) != -1) {
            var v = angular.element('.submit');
            if (v.length > 0) {
              v.attr('disabled', false);
              v.find('i').show();
              v.find('i.loader').hide();
            }
          }

          if (rejection.status == 401) {
            errorTip('无权操作');

          } else if (rejection.status !== 200 && rejection.status !== 201) {
            if (typeof rejection.data.message == 'object') {
              var errorStr = '';
              var idx = 0;
              angular.forEach(rejection.data.message, function (val, key) {
                if (idx == 0) {
                  errorStr += val;
                } else {
                  errorStr = errorStr + ';' + val;
                }
              });
              errorTip(errorStr)
            } else if (typeof rejection.data.message == 'string') {
              errorTip(rejection.data.message)
            }
            return $q.reject(rejection);
          }
          $timeout(function () {
            try {
              // swal('ERROR', rejection.data.message, 'error')
              if (angular.isDefined(rejection.data.redirect)) {
                $location.path(rejection.data.redirect)
              }
            } catch (e) {}
          });
          return $q.reject(rejection)
        }
      }
    }])
  }

  function jwtConfig($httpProvider, jwtInterceptorProvider, jwtOptionsProvider) {
    var REQUEST_WITHOUT_JWT = ['/login', '.css', '.html', '.js', '.woff', '/refresh'];
    jwtOptionsProvider.config({
      whiteListedDomains: ['admin.datagrand.net:10000', 'localhost', 'admin.datagrand.net'],
      tokenGetter: ['options', 'jwtHelper', 'HOST', '$state', '$http', function (options, jwtHelper, HOST, $state, $http) {
        var token = localStorage.getItem('token');
        var refreshToken = localStorage.getItem('refreshToken');

        function loginAgain() {
          function goLogin() {
            $state.go('login');
          }
          setTimeout(goLogin, 2000);
        }

        function checkIsIgnore(value) {
          return options.url.substr(options.url.length - value.length) == value;
        }
        // Not Sending the JWT for Specific Requests
        if (REQUEST_WITHOUT_JWT.some(checkIsIgnore)) {
          return null;
        } else {
          if (localStorage.getItem('token') == null) {
            loginAgain();
            return null;
          }
          if (jwtHelper.isTokenExpired(token)) {
            return $http({
              url: HOST + 'refresh',
              method: 'POST',
              headers: {
                'Authorization': 'Bearer ' + refreshToken
              }
            }).then(function (data) {
              localStorage.removeItem('token');
              localStorage.removeItem('refreshToken');
              localStorage.setItem('token', data.data.access_token);
              localStorage.setItem('refreshToken', data.data.refresh_token);
              return data.data.access_token
            }, function (data) {
              loginAgain();
            })
          } else {
            return localStorage.getItem('token');
          }
        }
      }]
    });
    $httpProvider.interceptors.push('jwtInterceptor');
  }

  function resourceConfig($resourceProvider) {
    $resourceProvider.defaults.actions = {
      saveArray: {
        method: 'POST',
        isArray: true
      },
      modify: {
        method: 'PATCH'
      },
      create: {
        method: 'POST'
      },
      save: {
        method: 'POST'
      },
      get: {
        method: 'GET'
      },
      query: {
        method: 'GET',
        isArray: true
      },
      update: {
        method: 'PUT'
      },
      delete: {
        method: 'DELETE'
      }
    };
  }

  function routerExpand($stateProvider) {
    $stateProvider.lazyLoad = function (state) {
      // var name = state.name;
      // var controllerUrl = state.controllerUrl;
      // state.name = name;
      // state.resolve = {
      //   loadMyFiles: ['$ocLazyLoad', function ($ocLazyLoad) {
      //     return $ocLazyLoad.load({
      //       name: name,
      //       files: [
      //         controllerUrl
      //       ]
      //     });
      //   }]
      // };
      return state;
    };
    $stateProvider.fullPath = function (path, type) {
      if (type === 'tpl') {
        return 'src/module/' + path + '.html'
      }
      return 'src/module/' + path + '.controller.js'
    };
    $stateProvider.childRegisteredState = function (array, module) {
      array.map(function (item) {
        item.name = module + '.' + item.name;
        item.url = '/' + item.url;
        item.controller = module + '.' + item.controller;
        item.templateUrl = $stateProvider.fullPath(module + '/' + item.templateUrl, 'tpl');
        item.controllerUrl = $stateProvider.fullPath(module + '/' + item.controllerUrl, 'ctrl');
        $stateProvider.state($stateProvider.lazyLoad(item));
      })
    };
  }

  function datepickerConfig(uibDatepickerPopupConfig) {
    uibDatepickerPopupConfig.currentText = '今天';
    uibDatepickerPopupConfig.clearText = '清除';
    uibDatepickerPopupConfig.toggleWeeksText = "week?";
    uibDatepickerPopupConfig.closeText = '取消';
  }

  function initRunFunc(staticService) {
    staticService.setChannel();
    staticService.setSaler();
  }

  swal.setDefaults({
    confirmButtonText: "确定",
    cancelButtonText: "取消"
  });
})();
(function () {
  'use strict';
  /**
   * ------------------------------------------------------------------
   * 系统管理>人工审核>弹出编辑器
   * ------------------------------------------------------------------
   */
  angular
    .module('app')
    .controller('manualReviewEditor', manualReviewEditor);

  manualReviewEditor.inject = ['$scope', '$uibModalInstance', 'select_data'];

  function manualReviewEditor($scope, $uibModalInstance, select_data) {
    var vm = $scope;
    vm.params = angular.copy(select_data);
    vm.params.nlpType = select_data.auditTypeSelect;
    vm.method = {
      ok: function () {
        $uibModalInstance.close(vm.params);
      },
      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },
      select_ad: function (index) {
        vm.params.is_ad = index;
      },
      select_nonsense: function (index) {
        vm.params.is_nonsense = index;
      },
      select_porn: function (index) {
        vm.params.is_porn = index;
      },
      select_politic: function (index) {
        vm.params.is_politic = index;
      },
      select_reaction: function (index) {
        vm.params.is_reaction = index;
      }
    };

  }

})();
(function () {
    angular
        .module('app')
        .controller('strategyEffectStatistics.dayOverall', strategyEffectStatisticsDayOverallCtrl);
    strategyEffectStatisticsDayOverallCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];

    function strategyEffectStatisticsDayOverallCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var DayOverallReq = Resource.RecStrategy.DayOverallList;

        vm.appReflect = [];
        vm.rec_type = [{
            'key': 'personal'
        }, {
            'key': 'relate'
        }, {
            'key': 'hot'
        }];
        vm.tableInited = false; //初始化

        vm.query = {
            sort: undefined,
            appid: undefined,
            scene_type: undefined,
            rec_type: undefined
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });
        vm.filterDate = {
            start: calcDateService.basedToday(-6) + ' 00:00:00',
            end: calcDateService.basedToday(0) + ' 23:59:59'
        };

        vm.search = function () {
            // if (!vm.params.appInfo) {
            //     errorTip("appname不能为空");
            //     return;
            // }

            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    vm.query.sort = Object.keys(params.sorting())[0];
                    var key = Object.values(params.sorting())[0];
                    if (key) {
                        vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                    }
                    //日期
                    vm.query.start_time = vm.filterDate.start;
                    vm.query.end_time = vm.filterDate.end;
                    vm.query.appid = undefined;
                    if (vm.params.appInfo) {
                        vm.query.appid = vm.params.appInfo.appid;
                    }
                    if (vm.params.rec_type) {
                        vm.query.rec_type = vm.params.rec_type.key;
                    }
                    var req = angular.extend({}, pageParams, vm.query);
                    DayOverallReq.get(req, function (data) { //需要更改
                        params.total(data.total);
                        $defer.resolve(data.items);
                    });
                }
            });
        }
        vm.reset = function () {
            vm.query = {
                appid: undefined,
                rec_type: undefined,
                scene_type: undefined
            }

            vm.params = {
                appInfo: undefined,
                rec_type: undefined

            }
            //刷新数据
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }
        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }
        //init data
        tableInit();
        vm.tableInited = true;
    }
})();
function iterationAccordionItem() {
  var itemDom = '.panel.box';
  var topBox = $('.box-group.iteration-accordion[accordion-level="0"]');
  var item = topBox.find(itemDom);
  item.bind('click', function (event) {
    item.removeClass('active');
    $(this).addClass('active');
    $(this).parents(itemDom).addClass('active');
    event.stopPropagation();
  });
}

$(window).on('hashchange', function () {
  var topBox = $('.box-group.iteration-accordion[accordion-level="0"]');
  if (topBox.length > 0) {
    setTimeout(iterationAccordionItem, 1000);
  }
});

setTimeout(iterationAccordionItem, 1000);
// $(function () {
//   var i = 0;
//   var scrollTable = '.scroll-table';

//   // check scroll table exist
//   function checkScrollTable() {
//     if ($(scrollTable).length == 0 && i < 20) {
//       i++
//       setTimeout(checkScrollTable, 50);
//     } else if ($(scrollTable).length > 0) {
//       setTimeout(handleTable, 100);
//     }
//   }

//   // watch url change
//   $(window).on('hashchange', function () {
//     i = 0
//     $('body').css('overflow-y', 'auto');
//     setTimeout(checkScrollTable, 200);
//   });

//   // handle table scroll
//   function handleTable() {
//     var table = $(scrollTable);
//     var offsetTop = table.offset().top;

//     $('body').css('overflow-y', 'hidden');
//     table.css({
//       position: 'fixed',
//       top: offsetTop
//     });
//   }

//   checkScrollTable();

// });

(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider, $urlRouterProvider) {

    var fullModulePath = $stateProvider.fullPath;

    var homeState = $stateProvider.lazyLoad({
      name: 'home',
      url: '/',
      controller: 'HomeCtrl',
      templateUrl: fullModulePath('home/home', 'tpl'),
      controllerUrl: fullModulePath('home/home', 'ctrl')
    });
    $stateProvider.state(homeState);

    var loginState = $stateProvider.lazyLoad({
      name: 'login',
      url: '/login',
      controller: 'LoginCtrl',
      templateUrl: fullModulePath('login/login', 'tpl'),
      controllerUrl: fullModulePath('login/login', 'ctrl')
    });
    $stateProvider.state(loginState);

    var orderState = $stateProvider.lazyLoad({
      name: 'order',
      url: '/order',
      controller: 'orderCtrl',
      templateUrl: fullModulePath('order/order', 'tpl'),
      controllerUrl: fullModulePath('order/order', 'ctrl')
    });
    $stateProvider.state(orderState);

    var contactState = $stateProvider.lazyLoad({
      name: 'contact',
      url: '/contact',
      controller: 'contact',
      templateUrl: fullModulePath('contact/contact', 'tpl'),
      controllerUrl: fullModulePath('contact/contact', 'ctrl')
    });
    $stateProvider.state(contactState);

    var clientState = $stateProvider.lazyLoad({
      name: 'client',
      url: '/client',
      controller: 'client',
      templateUrl: fullModulePath('client/client', 'tpl'),
      controllerUrl: fullModulePath('client/client', 'ctrl')
    });
    $stateProvider.state(clientState);

    var publicState = $stateProvider.lazyLoad({
      name: 'public',
      url: '/public',
      controller: 'public',
      templateUrl: fullModulePath('public/public', 'tpl'),
      controllerUrl: fullModulePath('public/public', 'ctrl')
    });
    $stateProvider.state(publicState);

    var managementState = $stateProvider.lazyLoad({
      name: 'management',
      url: '/management',
      controller: 'management',
      templateUrl: fullModulePath('management/management', 'tpl'),
      controllerUrl: fullModulePath('management/management', 'ctrl')
    });
    $stateProvider.state(managementState);

    var textReviewState = $stateProvider.lazyLoad({
      name: 'textReview',
      url: '/text-review',
      controller: 'textReview',
      templateUrl: fullModulePath('textReview/textReview', 'tpl'),
      controllerUrl: fullModulePath('textReview/textReview', 'ctrl')
    });

    $stateProvider.state(textReviewState);

    var reviewDictState = $stateProvider.lazyLoad({
      name: 'reviewDict',
      url: '/review-dict',
      controller: 'reviewDict',
      templateUrl: fullModulePath('reviewDict/reviewDict', 'tpl'),
      controllerUrl: fullModulePath('reviewDict/reviewDict', 'ctrl')
    });

    $stateProvider.state(reviewDictState);

    var NLPState = $stateProvider.lazyLoad({
      name: 'nlp',
      url: '/nlp/wordseg',
      controller: 'nlp',
      templateUrl: fullModulePath('nlp/nlp', 'tpl'),
      controllerUrl: fullModulePath('nlp/nlp', 'ctrl')
    });

    $stateProvider.state(NLPState);

    var recDebugState = $stateProvider.lazyLoad({
      name: 'recDebug',
      url: '/recDebug',
      controller: 'recDebugCtrl',
      templateUrl: fullModulePath('recDebug/recDebug', 'tpl'),
      controllerUrl: fullModulePath('recDebug/recDebug', 'ctrl')
    });

    $stateProvider.state(recDebugState);

    var recConfigState = $stateProvider.lazyLoad({
      name: 'recConfig',
      url: '/recConfig',
      controller: 'recConfigCtrl',
      templateUrl: fullModulePath('recConfig/recConfig', 'tpl'),
      controllerUrl: fullModulePath('recConfig/recConfig', 'ctrl')
    });

    $stateProvider.state(recConfigState);

    var strategyEffectStatisticsState = $stateProvider.lazyLoad({
      name: 'strategyEffectStatistics',
      url: '/strategyEffectStatistics',
      controller: 'strategyEffectStatisticsCtrl',
      templateUrl: fullModulePath('strategyEffectStatistics/strategyEffectStatistics', 'tpl'),
      controllerUrl: fullModulePath('strategyEffectStatistics/strategyEffectStatistics', 'ctrl')
    });

    $stateProvider.state(strategyEffectStatisticsState);

    var strategyPerformanceStatisticsState = $stateProvider.lazyLoad({
      name: 'strategyPerformanceStatistics',
      url: '/strategyPerformanceStatistics',
      controller: 'strategyPerformanceStatisticsCtrl',
      templateUrl: fullModulePath('strategyPerformanceStatistics/strategyPerformanceStatistics', 'tpl'),
      controllerUrl: fullModulePath('strategyPerformanceStatistics/strategyPerformanceStatistics', 'ctrl')
    });

    $stateProvider.state(strategyPerformanceStatisticsState);

    var dataUpReportState = $stateProvider.lazyLoad({
      name: 'dataUpReport',
      url: '/dataUpReport',
      controller: 'dataUpReportCtrl',
      templateUrl: fullModulePath('dataUpReport/dataUpReport', 'tpl'),
      controllerUrl: fullModulePath('dataUpReport/dataUpReport', 'ctrl')
    });

    $stateProvider.state(dataUpReportState);
    
    var offlineState= $stateProvider.lazyLoad({
      name: 'offline',
      url: '/offline',
      controller: 'offlineCtrl',
      templateUrl: fullModulePath('offline/offline', 'tpl'),
      controllerUrl: fullModulePath('offline/offline', 'ctrl')
    });

    $stateProvider.state(offlineState);

    var userPublicState = $stateProvider.lazyLoad({
      name: 'userPublic',
      url: '/userPublic',
      controller: 'userPublic',
      templateUrl: fullModulePath('userPublic/changePassword', 'tpl'),
      controllerUrl: fullModulePath('userPublic/changePassword', 'ctrl')
    });

    $stateProvider.state(userPublicState);

    var crawlState = $stateProvider.lazyLoad({
      name: 'crawl',
      url: '/crawl',
      controller: 'crawlCtrl',
      templateUrl: fullModulePath('crawl/crawl', 'tpl'),
      controllerUrl: fullModulePath('crawl/crawl', 'ctrl')
    });
    $stateProvider.state(crawlState);

    var corpusAnnotationState = $stateProvider.lazyLoad({
      name: 'corpusAnnotation',
      url: '/corpusAnnotation',
      controller: 'corpusAnnotationCtrl',
      templateUrl: fullModulePath('corpusAnnotation/corpusAnnotation', 'tpl'),
      controllerUrl: fullModulePath('corpusAnnotation/corpusAnnotation', 'ctrl')
    });
    $stateProvider.state(corpusAnnotationState);

    var project = $stateProvider.lazyLoad({
      name: 'project',
      url: '/project',
      controller: 'projectCtrl',
      templateUrl: fullModulePath('project/project', 'tpl'),
      controllerUrl: fullModulePath('project/project', 'ctrl')
    });
    $stateProvider.state(project);

    var serviceAlarm = $stateProvider.lazyLoad({
      name: 'serviceAlarm',
      url: '/service_alarm',
      controller: 'serviceAlarmCtrl',
      templateUrl: fullModulePath('serviceAlarm/serviceAlarm', 'tpl'),
      controllerUrl: fullModulePath('serviceAlarm/serviceAlarm', 'ctrl')
    });
    $stateProvider.state(serviceAlarm);

    var searchConfig = $stateProvider.lazyLoad({
      name: 'searchConfig',
      url: '/search_config',
      controller: 'searchConfigCtrl',
      templateUrl: fullModulePath('searchConfig/searchConfig', 'tpl'),
      controllerUrl: fullModulePath('searchConfig/searchConfig', 'ctrl')
    });
    $stateProvider.state(searchConfig);

    var activityStatistics = $stateProvider.lazyLoad({
      name: 'activityStatistics',
      url: '/activity_statistics',
      controller: 'activityStatisticsCtrl',
      templateUrl: fullModulePath('activityStatistics/activityStatistics', 'tpl'),
      controllerUrl: fullModulePath('activityStatistics/activityStatistics', 'ctrl')
    });
    $stateProvider.state(activityStatistics);

    var account = $stateProvider.lazyLoad({
      name: 'account',
      url: '/account',
      controller: 'accountCtrl',
      templateUrl: fullModulePath('account/account', 'tpl'),
      controllerUrl: fullModulePath('account/account', 'ctrl')
    });
    $stateProvider.state(account);
    
    var configManage = $stateProvider.lazyLoad({
      name: 'configManage',
      url: '/configManage',
      controller: 'configManageCtrl',
      templateUrl: fullModulePath('configManage/configManage', 'tpl'),
      controllerUrl: fullModulePath('configManage/configManage', 'ctrl')
    });
    $stateProvider.state(configManage);

    $urlRouterProvider.otherwise('/');
  }
})();
(function () {
    'use strict';
    angular
      .module('app')
      .config(routerConfig);
  
    function routerConfig($stateProvider) {
          var dataUpReportChild = [{
            name: 'totalProductUpReport',
            url: 'totalProductUpReport',
            controller: 'totalProductUpReport',
            templateUrl: 'totalProductUpReport/totalProductUpReport',
            controllerUrl: 'totalProductUpReport/totalProductUpReport'
          }, {
            name: 'appProductUpReport',
            url: 'appProductUpReport',
            controller: 'appProductUpReport',
            templateUrl: 'appProductUpReport/appProductUpReport',
            controllerUrl: 'appProductUpReport/appProductUpReport'
          }, {
            name: 'dayActionUpReport',
            url: 'dayActionUpReport',
            controller: 'dayActionUpReport',
            templateUrl: 'dayActionUpReport/dayActionUpReport',
            controllerUrl: 'dayActionUpReport/dayActionUpReport'
          }, {
            name: 'hourlyActionUpReport',
            url: 'hourlyActionUpReport',
            controller: 'hourlyActionUpReport',
            templateUrl: 'hourlyActionUpReport/hourlyActionUpReport',
            controllerUrl: 'hourlyActionUpReport/hourlyActionUpReport'
          }, {
            name: 'totalActionUpReport',
            url: 'totalActionUpReport',
            controller: 'totalActionUpReport',
            templateUrl: 'totalActionUpReport/totalActionUpReport',
            controllerUrl: 'totalActionUpReport/totalActionUpReport'
          }];
          $stateProvider.childRegisteredState(dataUpReportChild, 'dataUpReport');
    }
  })();
var tipConfig = {
  class: 'tip',
  timer: 1500,
  longTimer: 3000
}

function baseTip(title, type, time) {
  swal({
    title: title,
    type: type,
    showConfirmButton: true,
    confirmButtonContext: '确定',
    customClass: tipConfig.class + ' ' + type,
    timer: time,
    animation: 'slide-from-top'
  });
}

function baseCallbackTip(title, success, error) {
  swal({
    title: title,
    type: 'warning',
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  }, function () {
    setTimeout(function () {
      if (success) {
        success()
      }
    }, 50);
  }, function () {
    setTimeout(function () {
      if (error) {
        error()
      }
    }, 50);
  });
}

function errorTip(text) {
  baseTip(text, 'error', null);
}

function successTip(text) {
  baseTip(text, 'success', tipConfig.timer);
}

function warningTip(text, success, error) {
  if (!!success) {
    baseCallbackTip(text, success, error);
  } else {
    baseTip(text, 'warning', null);

  }
}
;
(function () {
  String.prototype.strLength = function (string) {
    var length = 0;
    for (var i = 0; i < this.length; i++) {
      if (this.substr(i, 1) == string) {
        length++
      }
    }
    return length;
  }
})();
function hideSidebar() {
    setTimeout(function () {
        $('#toggleSide').click()
    }, 2000);
}


(function () {
  $(window).on('hashchange', function () {
    $('body').scrollTop(0);
    $(window).scrollTop(0);
  });
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.resource.resource.item', managementResourceResourceItem);

  managementResourceResourceItem.inject = ['$scope', '$state', '$stateParams', 'Resource', 'ngTableParams'];

  function managementResourceResourceItem($scope, $state, $stateParams, Resource, ngTableParams) {
    var vm = $scope;
    var resource_id = $stateParams.resource_id;
    var ResourceItem = Resource.Management.Resource;

    vm.isCreate = resource_id ? false : true;
    vm.isEdit = vm.isCreate ? false : true;
    vm.legend = resource_id ? '查看' : '新建';

    // get data
    if (resource_id) {
      ResourceItem.get({
        primaryKey: $stateParams.resource_id
      }, {}, function (data) {
        vm.resource = data;
        vm.title = angular.copy(data.resource_name);
      });
    } else {
      vm.resource = {}
    }

    vm.edit = function () {
      vm.isEdit = false;
      vm.legend = '编辑';
    };

    vm.back = function () {
      $state.go('management.resource.resource');
    };

    vm.cancel = function () {
      if (vm.isCreate) {
        vm.back();
      } else {
        vm.isEdit = true;
      }
    };

    vm.delete = function () {
      vm.resource.status = 0;
      ResourceItem.update({
        primaryKey: $stateParams.resource_id
      }, vm.resource, function () {
        vm.back();
      })
    };


    vm.update = function () {
      if (vm.resource.status != 0 && vm.resource.status != 1) {
        vm.resource.status = 1;
      }
      if (vm.isCreate) {
        ResourceItem.save(vm.resource, function () {
          vm.back();
        })
      } else {
        vm.resource.resource_id = resource_id;
        ResourceItem.update({
          primaryKey: $stateParams.resource_id
        }, vm.resource, function () {
          vm.back();
        });
      }
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.resource.group.item', managementResourceGroupItem);

  managementResourceGroupItem.inject = ['$scope', '$state', '$stateParams', 'Resource', 'ngTableParams'];

  function managementResourceGroupItem($scope, $state, $stateParams, Resource, ngTableParams) {
    var vm = $scope;
    var id = $stateParams.id;
    var ResourceGroupItem = Resource.Management.ResourceGroupItem;
    var GroupResource = Resource.Management.GroupResource;
    var ResourceList = Resource.Management.ResourceList;
    var GroupAddResource = Resource.Management.GroupAddResource;
    vm.resourceCheckedList = [];
    vm.resourceOriginExistedList = [];
    vm.addResourceList = [];

    vm.isCreate = id  ? false : true;
    vm.isEdit = vm.isCreate ? false : true;
    vm.legend = id ? '查看' : '新建';

    // get data
    if (id) {
      ResourceGroupItem.get({
        id: $stateParams.id
      }, function (data) {
        vm.resourceGroup = data;
        vm.title = angular.copy(data.name);
      });
      vm.resourceGroupList = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer) {
          GroupResource.query({
            resourcegroup_id: id
          }, function (data) {
            data.map(function (value) {
              vm.resourceOriginExistedList.push(value.id);
            });
            $defer.resolve(data);
          });
        }
      });
    } else {
      vm.resourceGroup = {}
    }

    vm.resourceIsExisted = function (id) {
      return vm.resourceOriginExistedList.indexOf(id) > -1;
    };

    function resourceList() {
      vm.resourceList = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer) {
          ResourceList.query({}, function (data) {
            data.map(function (value, index) {
              if (vm.resourceOriginExistedList.indexOf(value.id) > -1) {
                vm.resourceCheckedList[index] = value.id
              }
            });
            $defer.resolve(data);
          });
        }
      });
    }

    vm.edit = function () {
      vm.isEdit = false;
      vm.legend = '编辑';
      if (!id) {
        return false;
      }
      GroupResource.query({
        resourcegroup_id: id
      }, function (data) {
        data.map(function (value) {
          vm.resourceOriginExistedList.push(value.id);
        });
        resourceList();
      });
    };
    vm.edit();
    vm.back = function () {
      $state.go('management.resource.group');
    };

    vm.cancel = function () {
      if (vm.isCreate) {
        vm.back();
      } else {
        vm.isEdit = true;
      }
    };

    vm.delete = function () {
      ResourceGroupItem.update({
        id: id,
        del: 1
      }, function () {
        vm.back();
      })
    };


    vm.update = function () {
      if (!vm.resourceGroup.del) {
        vm.resourceGroup.del = 0;
      }
      if (vm.isCreate) {
        ResourceGroupItem.save(vm.resourceGroup, function () {
          vm.back();
        })
      } else {
        vm.resourceGroup.id = id;
        ResourceGroupItem.update(vm.resourceGroup, function () {
          vm.back();
        });
      }
      vm.resourceCheckedList.map(function (value) {
        if (value) {
          vm.addResourceList.push(value);
        }
      });
      if (vm.addResourceList.length) {
        GroupAddResource.save({
          resourcegroup_id: id,
          resource_ids: vm.addResourceList.join(',')
        })
      }
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('mergeRecConfigDialog', actionConfigItem);
    function actionConfigItem($scope, Resource, $stateParams, data, $state, $q, $uibModalInstance) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;

        var MergeConfigItemRes = Resource.RecConfig.MergeConfigItem; //item 数据
        var MergeConfigListRes = Resource.RecConfig.MergeConfigList;  //新创建

        var ActionTypeListRes = Resource.RecConfig.ActionTypeList;
        vm.data = {
        //    data_type: 'user_item_action'
        };
        vm.params = {
            action_temp: '',
            appInfo: undefined,
            mode: undefined,
            time_threshold_min: undefined,
            time_threshold_max: undefined
        }

        vm.isCreate = !data.id;
        vm.id = data.id;  //itemId
        vm.showSelect = false;
        vm.appReflect = [];
        vm.action_list_tmp = [];
        vm.action_type_list = [];
        // //不加holder的话 重新select时状态不能更新
        // //十分费解
        // vm.holder = {
        //     appInfo: undefined
        // }

        $q.all([
            AppnameReflectRes.get({}).$promise,
            ActionTypeListRes.get({
                start: 0,
                number: 10000
            }).$promise
        ]).then(function (data) {
            angular.forEach(data[0].appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });

            angular.forEach(data[1].ret_list, function (item) {
                vm.action_type_list.push(item.action_type)
            });
        });

        if (!!vm.id) {
            MergeConfigItemRes.get({
                primaryKey: vm.id
            }, function (data) {
                vm.data = data;   //赋值
                vm.action_list_tmp = processActionListIntoList(vm.data.action_type_list);
                setAppInfo(data);
            });
        }

        function setAppInfo(data) {
            if (vm.appReflect.length < 1) {
                setTimeout(function () {
                    setAppInfo(data);
                }, 100);
            } else {
                angular.forEach(vm.appReflect, function (app) {
                    if (app.appid == data.appid) {
                        vm.params.appInfo = app; //初始化 appInfo
                        vm.params.mode = data.mode.toString();
                        vm.params.time_threshold_min = parseInt(data.time_threshold_min);
                        vm.params.time_threshold_max = parseInt(data.time_threshold_max);
                    }
                });
            }
        }

        vm.removeItem = function (actionType, index) {
            vm.action_list_tmp.splice(index, 1)
        }

        vm.add = function () {
            if (!vm.params.action_temp) {
                errorTip('未检测到输入action');
                return;
            }
            var isFinded = false;
            angular.forEach(vm.action_list_tmp, function (action) {
                if (vm.params.action_temp == action) {
                    isFinded = true;
                }
            });

            if (!isFinded) {
                vm.action_list_tmp.push(vm.params.action_temp);
                vm.params.action_temp = '';
            } else {
                errorTip('该action列表中已出现');
                return;
            }
        }

        //select change 
        vm.change = function (args) {
            console.log(args);
            if (vm.isCreate) {
                if (args === '3') {
                    vm.params.time_threshold_min = -120;
                    vm.params.time_threshold_max = 7200;
                } else {
                    vm.params.time_threshold_min = undefined;
                    vm.params.time_threshold_max = undefined;
                }
            }
        }

        vm.save = function () {

            if (!vm.params.appInfo) {
                errorTip('appid不允许为空');
                return;
            }
            if (!vm.params.mode) {
                errorTip('请选择mode');
                return;
            }

            if (vm.params.mode == 1)  //不需要 action_type_list
            {
                if (parseInt(vm.params.time_threshold_min) >= parseInt(vm.params.time_threshold_max)) {
                    errorTip('开始时间要小于结束时间');
                    return;
                }
                vm.data.action_type_list = '';
                vm.data.time_threshold_min = vm.params.time_threshold_min.toString();
                vm.data.time_threshold_max = vm.params.time_threshold_max.toString();


            } else   // 2 或者 3    3 的时候  范围取默认值 -120  7200
            {
                var hasError = false;

                if (!!vm.params.action_temp) {
                    vm.add();
                }


                if (vm.action_list_tmp.length < 1) {
                    hasError = true;
                }

                angular.forEach(vm.action_list_tmp, function (actionType) {
                    if (!actionType) {
                        hasError = true;
                    }
                });
                if (hasError) {
                    errorTip('action不允许为空');
                    return;
                }

                vm.data.action_type_list = vm.action_list_tmp.join(';');

                if (vm.params.mode == 3) {
                    vm.data.time_threshold_min = '-120';
                    vm.data.time_threshold_max = '7200';
                } else {
                    vm.data.time_threshold_min = vm.params.time_threshold_min.toString();
                    vm.data.time_threshold_max = vm.params.time_threshold_max.toString();
                }

            }

            vm.data.appid = vm.params.appInfo.appid;
            vm.data.mode = vm.params.mode;



            if (vm.isCreate) {
                MergeConfigListRes.save(vm.data, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                MergeConfigItemRes.update({
                    primaryKey: vm.id
                }, vm.data, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }

        vm.toggleShowSelect = function () {
            vm.showSelect = !vm.showSelect;
        }


        function processActionListIntoList(actionListStr) {
            var actionList = [];
            if (!!actionListStr || typeof (actionListStr) === 'string') {
                actionList = actionListStr.split(';');
            }

            return actionList
        }

        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('hotRecConfigDialog', hotRecConfigDialog);
    // hotRecConfigDialog.$inject = ['$scope', 'data', 'Resource', '$uibModalInstance'];

    function hotRecConfigDialog($scope, data, Resource, $uibModalInstance) {
        var vm = $scope;
        var HotRecConfigItemRes = Resource.RecConfig.HotRecConfigItem;
        var HotRecConfigListRes = Resource.RecConfig.HotRecConfigList;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var defaultConfigReflect = {
            'data_type_config': {
                data_type: undefined,
                field: undefined,
                weight: undefined
            },
            'time_config': {
                time: undefined,
                weight: undefined
            },
            'ctr_config': {
                time: undefined,
                weight: undefined
            }
        }

        vm.tempExpire = 72;
        vm.params = {};
        vm.appReflect = [];
        vm.isCreate = !data.id;
        vm.itemid = data.id;
        vm.params = {
            appInfo: undefined,
            effect_range: {
                daily: 1,
                hourly: 0
            },
            data_type_config: [{
                data_type: 'user_item_action',
                field: 'view',
                weight: 1
            }, {
                data_type: 'user_item_action',
                field: 'rec_click',
                weight: 1
            }, {
                data_type: 'item_info',
                field: 'item_modify_time',
                weight: 1
            }, {
                data_type: 'item_info',
                field: 'score',
                weight: 1
            }],
            save_type: 0,
            time_config: [{
                time: "1",
                weight: 1
            }],
            diversity: 1,
            rec_num: 1024,
            sort_all: 0,
            sort_cate: 0,
            sort_newrec: 0,
            tempExpire: 72,
            expire: 259200,
            ctr_config: [{
                time: "1",
                weight: 1
            }]
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });

        if (!vm.isCreate) {
            HotRecConfigItemRes.get({
                primaryKey: vm.itemid
            }, function (data) {
                vm.params = data;
                vm.params.data_type_config = JSON.parse(data.data_type_config);
                vm.params.effect_range = JSON.parse(data.effect_range);
                vm.params.time_config = JSON.parse(data.time_config);
                vm.params.ctr_config = JSON.parse(data.ctr_config);
                vm.params.tempExpire = parseInt(data.expire / 3600);
                
                initAppInfo();
            })
        }

        function initAppInfo() {
            if (!vm.appReflect || vm.appReflect.length < 1) {
                setTimeout(function () {
                    initAppInfo();
                }, 50);
            } else {
                angular.forEach(vm.appReflect, function (reflect) {
                    if (reflect.appid == vm.params.appid) {
                        vm.params.appInfo = reflect;
                    }
                });
            }
        }

        vm.deleteConfig = function (idx, configName) {
            vm.params[configName].splice(idx, 1);

            if (vm.params[configName].length < 1) {
                vm.params[configName].push(angular.copy(defaultConfigReflect[configName]));
            }
        }

        vm.addConfig = function (configName) {
            vm.params[configName].push(angular.copy(defaultConfigReflect[configName]));
        }

        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

        vm.confirm = function () {
            vm.params;
            var queryParams;
            var status = verify();

            if (!status) {
                return;
            }
            queryParams = getQueryParams();

            if (vm.isCreate) {
                HotRecConfigListRes.save(queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                HotRecConfigItemRes.update({
                    primaryKey: vm.itemid
                }, queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }

        vm.existTime = function (time, list) {
            var finded = false;

            angular.forEach(list, function (item) {
                if (item.time == time) {
                    finded = true;
                }
            });

            return finded;
        }

        function verify() {
            if (!vm.params.appInfo) {
                errorTip("未填写appid");
                return false;
            }

            if (!vm.params.effect_range.daily && !vm.params.effect_range.hourly) {
                errorTip("生效范围不允许为空");
                return false;
            }

            if (checkDataTypeLack()) {
                errorTip("data_type_list不允许为空");
                return false;
            }

            if (checkFieldRepeat()) {
                errorTip("data_type_list中不允许出现重复的field");
                return false;
            }

            // if (!vm.params.sort_all && !vm.params.sort_cate && !vm.params.sort_newrec) {
            //     errorTip("排序方式至少选择一种");
            //     return false;
            // }

            return true;
        }

        function checkDataTypeLack() {
            var hasError = false;
            if (vm.params.data_type_config.length < 1) {
                return true;
            }

            angular.forEach(vm.params.data_type_config, function (item) {
                angular.forEach(item, function (val, key) {
                    if (!val) {
                        hasError = true;
                    }
                })
            });

            return hasError;
        }

        function checkFieldRepeat() {
            var fieldList = vm.params.data_type_config.map(function (item) {
                return item.field;
            });

            for (var i = 0; i < fieldList.length; i++) {
                if (fieldList.indexOf(fieldList[i]) != fieldList.lastIndexOf(fieldList[i])) {
                    return true;
                }
            };
            return false;
        }

        function getQueryParams() {
            var params = angular.copy(vm.params);

            params.data_type_config = JSON.stringify(params.data_type_config);
            params.effect_range = JSON.stringify(params.effect_range);
            params.time_config = JSON.stringify(params.time_config);
            params.ctr_config = JSON.stringify(params.ctr_config);
            params.appid = parseInt(params.appInfo.appid);
            params.rec_num = parseInt(params.rec_num);
            params.expire = parseInt(params.tempExpire * 3600);
            delete(params.appInfo);

            return params;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('recConfig.actionConfig.item', actionConfigItem);

    actionConfigItem.$inject = ['$scope', 'Resource', '$stateParams', '$state', '$q'];

    function actionConfigItem($scope, Resource, $stateParams, $state, $q) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var ActionConfigItemRes = Resource.RecConfig.ActionConfigItem;
        var ActionConfigListRes = Resource.RecConfig.ActionConfigList;
        var ActionTypeListRes = Resource.RecConfig.ActionTypeList;

        vm.data = {
            data_type: 'user_item_action'
        };
        vm.params = {
            action_temp: ''
        }
        vm.showSelect = false;
        vm.appReflect = [];
        vm.id = $stateParams.id;
        vm.isCreate = !$stateParams.id;
        vm.action_list_tmp = [];
        vm.action_type_list = [];
        //不加holder的话 重新select时状态不能更新
        //十分费解
        vm.holder = {
            appInfo: undefined
        }

        $q.all([
            AppnameReflectRes.get({}).$promise,
            ActionTypeListRes.get({
                start: 0,
                number: 10000
            }).$promise
        ]).then(function (data) {
            angular.forEach(data[0].appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });

            angular.forEach(data[1].ret_list, function (item) {
                vm.action_type_list.push(item.action_type)
            });
        });

        if (!!vm.id) {
            ActionConfigItemRes.get({
                primaryKey: vm.id
            }, function (data) {
                vm.data = data;
                vm.action_list_tmp = processActionListIntoList(vm.data.action_list);
                setAppInfo(data);
            });
        }

        function setAppInfo(data) {
            if (vm.appReflect.length < 1) {
                setTimeout(function () {
                    setAppInfo(data);
                }, 100);
            } else {
                angular.forEach(vm.appReflect, function (app) {
                    if (app.appid == data.appid) {
                        vm.holder.appInfo = app;
                    }
                });
            }
        }

        vm.removeItem = function (actionType, index) {
            vm.action_list_tmp.splice(index, 1)
        }

        vm.add = function () {
            if (!vm.params.action_temp) {
                errorTip('未检测到输入action');
                return;
            }
            var isFinded = false;
            angular.forEach(vm.action_list_tmp, function (action) {
                if (vm.params.action_temp == action) {
                    isFinded = true;
                }
            });

            if (!isFinded) {
                vm.action_list_tmp.push(vm.params.action_temp);
                vm.params.action_temp = '';
            } else {
                errorTip('该action列表中已出现');
                return;
            }
        }

        vm.save = function () {
            var hasError = false;

            if (!!vm.params.action_temp) {
                vm.add();
            }


            if (vm.action_list_tmp.length < 1) {
                hasError = true;
            }

            angular.forEach(vm.action_list_tmp, function (actionType) {
                if (!actionType) {
                    hasError = true;
                }
            });

            if (hasError) {
                errorTip('action不允许为空');
                return;
            }

            vm.data.action_list = vm.action_list_tmp.join(';');
            vm.data.appid = vm.holder.appInfo.appid;

            if (vm.isCreate) {
                ActionConfigListRes.save(vm.data, function (data) {
                    successTip(data.message);
                    $state.go('recConfig.actionConfig');
                });
            } else {
                ActionConfigItemRes.update({
                    primaryKey: vm.id
                }, vm.data, function (data) {
                    successTip(data.message);
                    $state.go('recConfig.actionConfig');
                });
            }
        }

        vm.toggleShowSelect = function () {
            vm.showSelect = !vm.showSelect;
        }


        function processActionListIntoList(actionListStr) {
            var actionList = [];
            if (!!actionListStr || typeof (actionListStr) === 'string') {
                actionList = actionListStr.split(';');
            }

            return actionList
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('aboutRecConfigDialog', hotRecConfigDialog);
    // hotRecConfigDialog.$inject = ['$scope', 'data', 'Resource', '$uibModalInstance'];

    function hotRecConfigDialog($scope, data, Resource, $uibModalInstance) {
        var vm = $scope;
        var HotRecConfigItemRes = Resource.RecConfig.HotRecConfigItem;
        var HotRecConfigListRes = Resource.RecConfig.HotRecConfigList;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var defaultConfigReflect = {
            'data_type_config': {
                data_type: undefined,
                field: undefined,
                weight: undefined
            },
            'time_config': {
                time: undefined,
                weight: undefined
            },
            'ctr_config': {
                time: undefined,
                weight: undefined
            }
        }

        vm.tempExpire = 72;
        vm.params = {};
        vm.appReflect = [];
        vm.isCreate = !data.id;
        vm.itemid = data.id;
        vm.params = {
            appInfo: undefined,
            effect_range: {
                daily: 1,
                hourly: 0
            },
            data_type_config: [{
                data_type: 'user_item_action',
                field: 'all',
                weight: 1
            }, {
                data_type: 'item_info',
                field: 'item_modify_time',
                weight: 1
            }, {
                data_type: 'item_info',
                field: 'score',
                weight: 1
            }],
            save_type: 0,
            time_config: [{
                time: "1",
                weight: 1
            }],
            diversity: 1,
            rec_num: 1024,
            sort_all: 0,
            sort_cate: 0,
            sort_newrec: 0,
            tempExpire: 72,
            expire: 259200,
            ctr_config: [{
                time: "1",
                weight: 1
            }]
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });

        if (!vm.isCreate) {
            HotRecConfigItemRes.get({
                primaryKey: vm.itemid
            }, function (data) {
                vm.params = data;
                vm.params.data_type_config = JSON.parse(data.data_type_config);
                vm.params.effect_range = JSON.parse(data.effect_range);
                vm.params.time_config = JSON.parse(data.time_config);
                vm.params.ctr_config = JSON.parse(data.ctr_config);
                vm.params.tempExpire = parseInt(data.expire / 3600);
                
                initAppInfo();
            })
        }

        function initAppInfo() {
            if (!vm.appReflect || vm.appReflect.length < 1) {
                setTimeout(function () {
                    initAppInfo();
                }, 50);
            } else {
                angular.forEach(vm.appReflect, function (reflect) {
                    if (reflect.appid == vm.params.appid) {
                        vm.params.appInfo = reflect;
                    }
                });
            }
        }

        vm.deleteConfig = function (idx, configName) {
            vm.params[configName].splice(idx, 1);

            if (vm.params[configName].length < 1) {
                vm.params[configName].push(angular.copy(defaultConfigReflect[configName]));
            }
        }

        vm.addConfig = function (configName) {
            vm.params[configName].push(angular.copy(defaultConfigReflect[configName]));
        }

        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

        vm.confirm = function () {
            vm.params;
            var queryParams;
            var status = verify();

            if (!status) {
                return;
            }
            queryParams = getQueryParams();

            if (vm.isCreate) {
                HotRecConfigListRes.save(queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                HotRecConfigItemRes.update({
                    primaryKey: vm.itemid
                }, queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }

        vm.existTime = function (time, list) {
            var finded = false;

            angular.forEach(list, function (item) {
                if (item.time == time) {
                    finded = true;
                }
            });

            return finded;
        }

        function verify() {
            if (!vm.params.appInfo) {
                errorTip("未填写appid");
                return false;
            }

            if (!vm.params.effect_range.daily && !vm.params.effect_range.hourly) {
                errorTip("生效范围不允许为空");
                return false;
            }

            if (checkDataTypeLack()) {
                errorTip("data_type_list不允许为空");
                return false;
            }

            if (checkFieldRepeat()) {
                errorTip("data_type_list中不允许出现重复的field");
                return false;
            }

            // if (!vm.params.sort_all && !vm.params.sort_cate && !vm.params.sort_newrec) {
            //     errorTip("排序方式至少选择一种");
            //     return false;
            // }

            return true;
        }

        function checkDataTypeLack() {
            var hasError = false;
            if (vm.params.data_type_config.length < 1) {
                return true;
            }

            angular.forEach(vm.params.data_type_config, function (item) {
                angular.forEach(item, function (val, key) {
                    if (!val) {
                        hasError = true;
                    }
                })
            });

            return hasError;
        }

        function checkFieldRepeat() {
            var fieldList = vm.params.data_type_config.map(function (item) {
                return item.field;
            });

            for (var i = 0; i < fieldList.length; i++) {
                if (fieldList.indexOf(fieldList[i]) != fieldList.lastIndexOf(fieldList[i])) {
                    return true;
                }
            };
            return false;
        }

        function getQueryParams() {
            var params = angular.copy(vm.params);

            params.data_type_config = JSON.stringify(params.data_type_config);
            params.effect_range = JSON.stringify(params.effect_range);
            params.time_config = JSON.stringify(params.time_config);
            params.ctr_config = JSON.stringify(params.ctr_config);
            params.appid = parseInt(params.appInfo.appid);
            params.rec_num = parseInt(params.rec_num);
            params.expire = parseInt(params.tempExpire * 3600);
            delete(params.appInfo);

            return params;
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .controller('applicationDialog', applicationDialog);

  function applicationDialog($scope, Resource, $uibModalInstance, applicationDialogData, calcDateService, formService) {
    var vm = $scope;
    var Config = Resource.Common.Reflect;
    var ItemDetail = Resource.Project.TestApplication.Item;
    var ItemUpdate = Resource.Project.TestApplication.ItemUpdate;
    var ItemCreate = Resource.Project.TestApplication.ItemCreate;

    vm.is_edit = !applicationDialogData ? false : true;
    vm.legend = !applicationDialogData ? '新建申请' : '编辑申请';

    vm.period = {
      start: calcDateService.basedToday(0),
      end: calcDateService.basedToday(14)
    };

    vm.dateConfig = {
      canChange: true,
      minDate: calcDateService.basedToday(0),
      maxDate: calcDateService.basedToday(60),
      change: function () {
        if (!vm.dateConfig.canChange) {
          return false;
        }
      }
    };
    var primaryKey = {
      primaryKey: applicationDialogData
    };
    Config.get({}, function (data) {
      vm.channelList = data.channel_id;
      Object.keys(vm.channelList).map(function(key){
        if (vm.channelList[key] === '市场') {
          vm.marketChannelId = key;
        }
      });
      if (vm.is_edit) {
        vm.dateConfig.canChange = false;
        ItemDetail.get(primaryKey, function (data) {
          vm.application = data;
          var channelName = '';
          if (vm.application.channel_id === 0){
            channelName = '';
          } else {
            channelName = vm.channelList[vm.application.channel_id];
          }
          if (['销售', '其他', '市场', ''].indexOf(channelName) === -1) {
            vm.application.channel_id = vm.marketChannelId;
          }
          vm.period = {
            start: data.start_time,
            end: data.deadline_time
          };
          vm.dateConfig.canChange = true;
        });
      } else {
        vm.application = vm.newApplication;
        vm.application.channel_id = vm.marketChannelId;
      }
    });

    vm.newApplication = {
      // 客户信息
      company_name: '',
      project_name: '',
      industry: '',
      channel_id: 0,
      source: null,
      effective_time: vm.period.start,
      deadline_time: vm.period.end,
      // 功能开关
      check_config: 0,
      classify_config: 0,
      rec_config: 0,
      search_config: 0,
      sentiment_config: 0,
      spider_config: 0,
      tag_config: 0,
      // 项目人员信息
      custom_email: '',
      custom_manager: '',
      custom_position: '',
      custom_tel: '',
      other_email: []
    };

    vm.functionList = [{
      key: 'check_config',
      name: '文本自动审核'
    }, {
      key: 'classify_config',
      name: '文本自动分类'
    }, {
      key: 'tag_config',
      name: '文本标签提取'
    }, {
      key: 'sentiment_config',
      name: '文本情感分析'
    }, {
      key: 'rec_config',
      name: '推荐引擎'
    }, {
      key: 'search_config',
      name: '搜索引擎'
    }, {
      key: 'spider_config',
      name: '数据抓取'
    }];



    vm.addEmail = function () {
      vm.application.other_email.push('');
    };
    vm.removeEmail = function (index) {
      vm.application.other_email.splice(index, 1);
    };

    // form 相关
    vm.setForm = function (form) {
      vm.applicationForm = form;
    };

    vm.formVerification = function (key) {
      return formService.error(key, vm.applicationForm);
    };

    vm.doTouched = function () {
      vm.applicationForm.function.$setTouched();
    };

    vm.functionRequire = function () {
      return vm.application.check_config ||
        vm.application.classify_config ||
        vm.application.tag_config ||
        vm.application.sentiment_config ||
        vm.application.rec_config ||
        vm.application.search_config ||
        vm.application.spider_config
    };

    vm.checkFunction = function () {
      return vm.functionList.some(function (value) {
        return vm.application[value.key] == 1
      });
    };

    vm.checkFunctionRequired = function () {
      return vm.applicationForm.function.$touched && !vm.checkFunction();
    };


    vm.cancel = function () {
      vm.back();
    };

    vm.submit = function () {
      vm.application.deadline_time = vm.period.end;
      vm.application.channel_id = vm.application.channel_id == 0 ? null : vm.application.channel_id;
      if (vm.is_edit) {
        ItemDetail.update(primaryKey, angular.extend({}, vm.newApplication, vm.application), function () {
          successTip('修改成功');
          vm.back(true)
        });
      } else {
        ItemDetail.save({}, vm.application, function () {
          successTip('新建成功');
          vm.back(true);
        });
      }
    };

    vm.back = function (data) {
      data ? $uibModalInstance.close(data) : $uibModalInstance.close();
    };
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .controller('accountApplicationDialog', accountApplicationDialog);
  accountApplicationDialog.inject = ['$scope', 'Resource', '$uibModalInstance', 'accountApplicationDialogData', 'calcDateService', '$filter'];

  function accountApplicationDialog($scope, Resource, $uibModalInstance, accountApplicationDialogData, calcDateService, $filter) {
    var vm = $scope;
    var ItemDetail = Resource.Project.TestApplication.Item;
    var Application = Resource.Project.TestApplication.Application;
    var Role = Resource.Common.Role;
    var id = accountApplicationDialogData;

    vm.legend = '账号开通';
    vm.function = {};
    ItemDetail.get({
      primaryKey: id
    }, function (data) {
      vm.application = data;
      vm.application.apply_id = id;
      vm.application.status = '测试';
      vm.application.static_config = 0;
    });

    Role.query({
      group_name: '项目部'
    }, function (data) {
      vm.role = data;
      vm.application.saler_front = data[0].user_id;
    });

    // form 相关
    vm.setForm = function (form) {
      vm.accountApplicationForm = form;
    };

    vm.doTouched = function () {
      vm.accountApplicationForm.function.$setTouched();
    };

    vm.functionRequire = function () {
      return vm.application.check_config ||
        vm.application.classify_config ||
        vm.application.tag_config ||
        vm.application.sentiment_config ||
        vm.application.rec_config ||
        vm.application.search_config ||
        vm.application.spider_config
    };

    vm.checkFunction = function () {
      return vm.functionList.some(function (value) {
        return vm.application[value.key] == 1;
      });
    };

    vm.checkFunctionRequired = function () {
      if (vm.accountApplicationForm.function) {
        return vm.accountApplicationForm.function.$touched && !vm.checkFunction();
      }
    };

    vm.functionList = [{
      key: 'check_config',
      name: '文本自动审核'
    }, {
      key: 'classify_config',
      name: '文本自动分类'
    }, {
      key: 'tag_config',
      name: '文本标签提取'
    }, {
      key: 'sentiment_config',
      name: '文本情感分析'
    }, {
      key: 'rec_config',
      name: '推荐引擎'
    }, {
      key: 'search_config',
      name: '搜索引擎'
    }, {
      key: 'spider_config',
      name: '数据抓取'
    }];

    vm.cancel = function () {
      vm.back();
    };

    vm.submit = function () {
      vm.application.username = vm.application.app_name;
      Application.save({}, vm.application, function () {
        successTip('开通成功');
        vm.back(true);
      });
    };

    vm.back = function (data) {
      data ? $uibModalInstance.close(data) : $uibModalInstance.close();
    };
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('recResultDialog', recResultDialogItem);
    function recResultDialogItem($scope, Resource, $stateParams, data, $state, $q, $uibModalInstance, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;

        var OfflineRecItemRes = Resource.OfflineModule.RecList; //item 数据
        var OfflineRecListRes = Resource.OfflineModule.RecList; //新创建


        vm.data = {
        };
        vm.params = {
            time_mode: 'day',
            appInfo: undefined,
            cf: undefined,
            rec: undefined
        }
        vm.data_date = calcDateService.basedToday(-1);
        vm.isCreate = !data.id;
        vm.id = data.id;  //itemId
        vm.showSelect = false;
        vm.appReflect = [];

        $q.all([
            AppnameReflectRes.get({}).$promise
        ]).then(function (data) {
            angular.forEach(data[0].appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });


        vm.save = function () {
            if (!vm.params.appInfo) {
                errorTip('appid不能为空');
                return;
            }
            vm.data.appid = parseInt(vm.params.appInfo.appid);
            vm.data.time_mode = vm.params.time_mode;
            vm.data.is_cf = vm.params.cf === undefined ? 0 : vm.params.cf; // 0 or 1
            vm.data.is_rec = vm.params.rec === undefined ? 0 : vm.params.rec;
            if (vm.isCreate) {   //true
                OfflineRecListRes.save(vm.data, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                OfflineRecItemRes.update({
                    primaryKey: vm.id
                }, vm.data, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }
        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('hotResultDialog', hotResultDialogItem);
    function hotResultDialogItem($scope, Resource, $stateParams, data, $state, $q, $uibModalInstance, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;

        var OfflineHotItemRes = Resource.OfflineModule.HotList; //item 数据
        var OfflineHotListRes = Resource.OfflineModule.HotList; //新创建
        vm.data = {
        };
        vm.params = {
            appInfo: undefined,
            time_mode: 'day'  //默认值
        }
        vm.data_date = calcDateService.basedToday(0);
        vm.isCreate = !data.id;
        vm.id = data.id;  //itemId
        vm.showSelect = false;
        vm.appReflect = [];

        $q.all([
            AppnameReflectRes.get({}).$promise
        ]).then(function (data) {
            angular.forEach(data[0].appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });



        vm.save = function () {

            if (!vm.params.appInfo) {
                errorTip('appid不能为空');
                return;
            }
            vm.data.appid = parseInt(vm.params.appInfo.appid);
            vm.data.time_mode = vm.params.time_mode;

            if (vm.isCreate) {
                OfflineHotListRes.save(vm.data, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                OfflineHotItemRes.update({
                    primaryKey: vm.id
                }, vm.data, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }
        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('dataDialog', dataConfigItem);
    function dataConfigItem($scope, Resource, $stateParams, data, $state, $q, $uibModalInstance, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;

        var OfflineDataItemRes = Resource.OfflineModule.DataList; //item   暂时不更新
        var OfflineDataListRes = Resource.OfflineModule.DataList;

        vm.data = {  //请求数据
        };
        vm.params = {
            action_temp: '',
            appInfo: undefined,
            item_info: undefined,
            user_item: undefined
        }
        vm.data_date = calcDateService.basedToday(0);
        vm.isCreate = !data.id;
        vm.id = data.id;  // itemId 
        vm.appReflect = [];

        $q.all([
            AppnameReflectRes.get({}).$promise
        ]).then(function (data) {
            angular.forEach(data[0].appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });
        vm.save = function () {
            if (!vm.params.appInfo) {
                errorTip('appid不能为空');
                return;
            }
            vm.data.appid = parseInt(vm.params.appInfo.appid);
            vm.data.date = vm.data_date;
            vm.data.item_info = vm.params.item_info === undefined ? 0 : vm.params.item_info; // 0 or 1
            vm.data.user_item = vm.params.user_item === undefined ? 0 : vm.params.user_item;

            if (vm.isCreate) {  //true
                OfflineDataListRes.save(vm.data, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {  //edit
                OfflineDataItemRes.update({
                    primaryKey: vm.id
                }, vm.data, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }
        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.user.item', managementUserItem);

  managementUserItem.inject = ['$scope', '$stateParams', 'Resource', '$state', 'HOST', '$http'];

  function managementUserItem($scope, $stateParams, Resource, $state, HOST, $http) {
    var vm = $scope;
    var id = $stateParams.id;
    var User = Resource.Management.User;
    vm.isCreate = id ? false : true;
    vm.isEdit = vm.isCreate ? false : true;
    vm.legend = id ? '查看' : '新建';

    if (id) {
      User.get({
        id: $stateParams.id
      }, function (data) {
        vm.user = data;
        vm.title = angular.copy(data.nickname);
      });
    } else {
      vm.user = {}
    }

    vm.edit = function () {
      vm.isEdit = false;
      vm.legend = '编辑';
    };
    vm.back = function () {
      $state.go('management.user');
    };

    vm.cancel = function () {
      if (vm.isCreate) {
        vm.back();
      } else {
        vm.isEdit = true;
      }
    };

    vm.delete = function () {
      var req = {
        method: 'DELETE',
        url: HOST + 'user',
        data: {
          id: vm.user.admin_staffid
        },
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      };
      $http(req).then(function () {
        vm.back();
      });
    };


    vm.update = function () {
      if (!vm.user.is_online) {
        vm.user.is_online = 0
      }
      if (vm.isCreate) {
        User.save(vm.user, function () {
          vm.back();
        })
      } else {
        vm.user.id = id;
        User.update(vm.user, function () {
          vm.back();
        });
      }
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.role.item', managementRoleItem);

  managementRoleItem.inject = ['$scope', '$state', '$stateParams', 'Resource', '$http', 'HOST', '$q'];

  function managementRoleItem($scope, $state, $stateParams, Resource, $http, HOST, $q) {
    var vm = $scope;
    var id = $stateParams.id;

    var Role = Resource.Management.Role;
    var RoleResourceList = Resource.Management.RoleResourceList;
    var ResourceList = Resource.Management.ResourceList;
    var UserList = Resource.Management.User.List;
    var RoleUserList = Resource.Management.RoleUserList;
    var RoleAddUser = Resource.Management.RoleAddUser;
    var tag_str_list = ['post', 'delete', 'get', 'put'];
    var methodReflect = {
      'post': 1,
      'delete': 2,
      'get': 4,
      'put': 8
    }

    vm.isCreate = id ? false : true;
    vm.isEdit = true;
    vm.legend = id ? '查看' : '新建';
    vm.userCheckedList = [];
    vm.userOriginExistedList = [];

    vm.edit = function () {
      vm.isEdit = false;
      vm.legend = '编辑';
    };

    vm.back = function () {
      $state.go('management.role');
    };

    vm.delete = function () {
      Role.update({
        id: id,
        status: 0
      }, function () {
        vm.back();
      })
    };

    vm.check = function (item, method) {
      return item[method];
    }

    vm.select = function (item, method) {
      var tempVal;
      var isAll = true;
      if (method == 'all') {
        tempVal = item[method] === true ? true : false;
        angular.forEach(tag_str_list, function (tag) {
          item[tag] = tempVal;
        });

        return;
      } else {
        angular.forEach(tag_str_list, function (tag, index) {
          if (!item[tag]) {
            isAll = false;
          }
        });

        item['all'] = isAll;
      }
    }

    vm.update = function () {
      var roleResource;
      var roleUsers;
      vm.role.status = vm.role.status ? 0 : 1;

      if (vm.isCreate) {
        Role.save(vm.role, function (data) {
          vm.role.role_id = data.role_id;
          vm.isCreate = false;
          resourceInit();
          roleInit();
          vm.role.status = vm.role.status == 0 ? true : false;
        });
      } else {
        roleResource = getUpdateRoleResource();
        roleUsers = getUpdateRoleUser();
        $q.all([
          Role.update({
            primaryKey: vm.role.role_id
          }, vm.role).$promise,
          RoleResourceList.save({
            primaryKey: vm.role.role_id
          }, roleResource).$promise,
          RoleAddUser.save({
            primaryKey: vm.role.role_id
          }, roleUsers).$promise
        ]).then(function (data) {
          vm.back();
        });
      }
    }

    vm.userIsExisted = function (id) {
      return vm.userOriginExistedList.indexOf(id) > -1;
    };

    function getUpdateRoleResource() {
      var roleResourceItem = {};
      var roleResourceList = [];
      angular.forEach(vm.resourceList, function (item) {
        roleResourceItem[item.resource_id] = getAuthVal(item);
      });

      return {
        'role_resource': roleResourceItem
      };
    }

    function getAuthVal(item) {
      var auth = 0;
      angular.forEach(tag_str_list, function (tag, index) {
        if (item[tag]) {
          auth += Math.pow(2, index);
        }
      });

      return auth;
    }

    function getUpdateRoleUser() {
      var user_id_list = []
      angular.forEach(vm.userCheckedList, function (user_id) {
        if (!!user_id) {
          user_id_list.push(user_id)
        }
      });
      return {
        'user_ids': user_id_list.join(',')
      };
    }

    function initAuth(item, auth) {
      var tag_str_list = ['post', 'delete', 'get', 'put', 'all']
      if (!!auth) {
        angular.forEach(tag_str_list, function (tag_str, index) {
          if (tag_str == 'all') {
            item[tag_str] = auth == 15 ? true : false
          } else {
            item[tag_str] = (auth & (Math.pow(2, index))) != 0 ? true : false;
          }
        });
      } else {
        angular.forEach(tag_str_list, function (tag_str) {
          item[tag_str] = false;
        });
      }
      return item;
    }

    function initRoleResource(resourceList, roleResourceList) {
      vm.resourceList = [];
      angular.forEach(resourceList, function(item) {
        if (item.status == 1) {
          return vm.resourceList.push(item);
        }
      })
       resourceList.map(function (item) {
      });
      angular.forEach(vm.resourceList, function (item) {
        item = initAuth(item);
        angular.forEach(roleResourceList, function (roleResourceItem) {
          if (item.resource_id === roleResourceItem.resource_id) {
            item = initAuth(item, roleResourceItem.auth);
          }
        })
      });
    }

    function initRoleUsers(user_list, user_is_role_list) {
      vm.UserList = user_list;
      angular.forEach(user_list, function (user) {
        vm.userOriginExistedList.push(null);
      });

      angular.forEach(user_is_role_list, function (user_is_role) {
        angular.forEach(vm.UserList, function (user, idx) {
          if (user.admin_staffid == user_is_role.user_id) {
            vm.userOriginExistedList[idx] = user_is_role.user_id
          }
        })
      });

      vm.userCheckedList = angular.copy(vm.userOriginExistedList)
    }

    function resourceInit() {
      $q.all([
        ResourceList.get({}).$promise,
        RoleResourceList.get({
          primaryKey: vm.role.role_id
        }, {}).$promise
      ]).then(function (data) {

        initRoleResource(data[0].ret_list, data[1].ret_list)
      });
    }

    function roleInit() {
      $q.all([
        UserList.get({}).$promise,
        RoleUserList.query({
          primaryKey: vm.role.role_id
        }, {}).$promise
      ]).then(function (data) {
        initRoleUsers(data[0].ret_list, data[1]);
      })
    }

    function init() {
      if (id) {
        // get data
        $q.all([
          Role.get({
            primaryKey: $stateParams.id
          }, {}).$promise,
          ResourceList.get({}).$promise,
          RoleResourceList.get({
            primaryKey: $stateParams.id
          }, {}).$promise,
          UserList.get({}).$promise,
          RoleUserList.query({
            primaryKey: $stateParams.id
          }, {}).$promise
        ]).then(function (data) {
          data[0].status = data[0].status == 0 ? true : false;
          vm.role = data[0];
          initRoleResource(data[1].ret_list, data[2].ret_list);
          initRoleUsers(data[3].ret_list, data[4]);
        });

        vm.edit();
      } else {
        vm.role = {
          role_name: '',
          status: false
        };
        vm.isEdit = false;
        vm.legend = '新建';
      }
    }

    init();
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.resource.resource', managementResourceResource);

  managementResourceResource.inject = ['$scope', 'Resource', 'ngTableParams', 'WarpState', '$state'];

  function managementResourceResource($scope, Resource, ngTableParams, WarpState, $state) {
    var vm = $scope;
    var ResourceList = Resource.Management.ResourceList;

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        ResourceList.get({}, function (data) {
          $defer.resolve(data.ret_list);
        });
      }
    });

    vm.create = function () {
      $state.go('management.resource.resource').then(function () {
        $state.go('management.resource.resource.item');
      });
    };

    vm.reload = function () {
      vm.tableParams.reload();
    };

    WarpState.activeCurrentState('management.resource.resource', vm.reload);
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.resource.group', managementResourceGroup);

  managementResourceGroup.inject = ['$scope', 'Resource', 'ngTableParams', 'WarpState', '$state'];

  function managementResourceGroup($scope, Resource, ngTableParams, WarpState, $state) {
    var vm = $scope;
    var ResourceGroupList = Resource.Management.ResourceGroupList;

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer) {
        ResourceGroupList.query({}, function (data) {
          $defer.resolve(data);
        });
      }
    });

    vm.create = function () {
      $state.go('management.resource.group').then(function () {
        $state.go('management.resource.group.item');
      });
    };

    vm.reload = function () {
      vm.tableParams.reload();
    };

    WarpState.activeCurrentState('management.resource.group', vm.reload);
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('menuDialog', menuDialog);


  function menuDialog($scope, $uibModalInstance, menuDailogData, Resource, routerList) {
    var vm = $scope;
    vm.isCreate = menuDailogData ? false : true;
    var ResourceList = Resource.Management.ResourceList;
    var RoleList = Resource.Management.RoleList;

    vm.tmp = {
      link: null,
      role_list: null
    };
    vm.routerList = routerList();
    RoleList.query({}, function (data) {
      vm.roleList = data;
      if (!vm.menu) {
        vm.menu = newMenu;
        vm.menu.resource_id = data[0].id;
      } else if (vm.menu.role_list) {
        var role_id_list = filterRoleIdList(vm.menu.role_list.split(','));
        vm.tmp.role_list = []
        angular.forEach(vm.roleList, function(role) {
          if(role_id_list.indexOf(role.role_id) > -1) {
            vm.tmp.role_list.push(role)
          }
        })
      }
    });

    function filterRoleIdList(role_id_list) {
      return role_id_list.map(function(role_id) {
        return parseInt(role_id);
      })
    }

    if (!vm.isCreate) {
      vm.title = '编辑菜单';
      vm.menu = angular.copy(menuDailogData);
      if (vm.menu.link) {
        vm.routerList.map(function (value) {
          if (value.link == vm.menu.link) {
            vm.tmp.link = value;
          }
        })
      }
      
    } else {
      vm.title = '新建菜单';
      vm.menu = newMenu;
      vm.tmp.link = vm.routerList[0];
    }

    var newMenu = {
      desc: null,
      icon_class: null,
      link: null,
      name: null,
      menu_list: [],
      role_list: null,
      status: 1
    };

    vm.update = function () {
      var role_id_list = [];
      if (vm.tmp.link) {
        vm.menu.link = vm.tmp.link.link;
      }

      if (vm.tmp.role_list) {
        angular.forEach(vm.tmp.role_list, function(role) {
          role_id_list.push(role.role_id) 
        });
        vm.menu.role_list = role_id_list.join(',')
      }
      
      $uibModalInstance.close(vm.menu);
    };

    vm.create = function () {
      $uibModalInstance.close({
        content: vm.nlpCreateFrom.content,
        content_sep_machine: vm.wordPOSPreview
      });
    };

    vm.close = function () {
      $uibModalInstance.close();
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('mailTemplateDialog', mailTemplateDialog);

  function mailTemplateDialog($scope, $uibModalInstance, Resource, dataService, mailTemplateDialogData) {
    var vm = $scope;
    var Item = Resource.Mail.Item;
    var List = Resource.Mail.List;
    var id = mailTemplateDialogData;

    vm.mailType = dataService.mailType;

    vm.mail = {
      html: '',
      name: ''
    };

    vm.title = '新建邮件模板';
    if (angular.isNumber(id)) {
      vm.title = '编辑邮件模板';
      Item.get({
        primaryKey: id
      }, function (data) {
        vm.mail = data;
      });
    }

    vm.confirm = function () {
      if (angular.isNumber(id)) {
        Item.update({
          primaryKey: id
        }, vm.mail, function () {
          successTip('修改成功');
          vm.close(true)
        })
      } else {
        List.save(vm.mail, function () {
          successTip('新建成功');
          vm.close(true)
        })
      };
    };

    vm.close = function (data) {
      if (data) {
        $uibModalInstance.close(data);
      } else {
        $uibModalInstance.close();
      }
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('channelDialog', channelDialog);

  channelDialog.inject = ['$scope', '$uibModalInstance', 'Resource'];

  function channelDialog($scope, $uibModalInstance, Resource) {
    var vm = $scope;
    var Item = Resource.Channel.List;
    vm.channel = {
      name: '',
      is_del: 0
    }
    vm.confirm = function () {
      if (vm.channel.name.trim().length == 0) {
        errorTip('请输入渠道名');
        return false;
      }
      Item.save(vm.channel, function () {
        successTip('新建成功');
        vm.close(true)
      })
    }

    vm.close = function (data) {
      if (data) {
        $uibModalInstance.close(data);
      } else {
        $uibModalInstance.close();
      }
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('channelDialog', channelDialog);

  channelDialog.inject = ['$scope', '$uibModalInstance', 'Resource'];

  function channelDialog($scope, $uibModalInstance, Resource) {
    var vm = $scope;
    var Item = Resource.Channel.List;
    vm.channel = {
      name: '',
      is_del: 0
    }
    vm.confirm = function () {
      if (vm.channel.name.trim().length == 0) {
        errorTip('请输入渠道名');
        return false;
      }
      Item.save(vm.channel, function () {
        successTip('新建成功');
        vm.close(true)
      })
    }

    vm.close = function (data) {
      if (data) {
        $uibModalInstance.close(data);
      } else {
        $uibModalInstance.close();
      }
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.advanced.item', managementAdvancedItem);

  managementAdvancedItem.inject = ['$scope', '$stateParams', 'Resource', '$state', 'HOST', '$http'];

  function managementAdvancedItem($scope, $stateParams, Resource, $state, HOST, $http) {
    var vm = $scope;
    vm.id = $stateParams.id;

    // var User = Resource.Management.User;
    var User = Resource.Management.User.Item;
    var RoleList = Resource.Management.RoleList;
    var UserRole = Resource.Management.UserRole;
    var UserAddRole = Resource.Management.UserAddRole;

    vm.roleCheckedList = [];
    vm.roleOriginExistedList = [];
    vm.addRoleList = [];

    vm.role = '';
    vm.isCreate = vm.id ? false : true;
    vm.isEdit = true;
    vm.legend = vm.id ? '查看' : '新建';

    if (vm.id) {
      User.get({
        // id: vm.id
        primaryKey: vm.id
      }, function (data) {
        vm.user = data;
        vm.title = angular.copy(data.nickname);
      });
      UserRole.query({
        // id: vm.id
        primaryKey: vm.id
      }, {
        user_id: vm.id
      }, function (data) {
        data.map(function (value) {
          vm.roleOriginExistedList.push(value.role_id);
        });
        vm.UserRole = data;
        getRoleList();
      });
    } else {
      vm.user = {
        is_online: 1
      }
    }

    function getRoleList() {
      RoleList.query({}, function (data) {
        data.map(function (value, index) {
          if (vm.roleOriginExistedList.indexOf(value.role_id) > -1) {
            vm.roleCheckedList[index] = value.role_id
          }
        });
        vm.RoleList = data;
      });
    }

    vm.roleIsExisted = function (id) {
      return vm.roleOriginExistedList.indexOf(id) > -1;
    };

    vm.edit = function () {
      vm.isEdit = false;
      vm.legend = '编辑';
      getRoleList();
    };

    vm.edit();


    vm.back = function () {
      $state.go('management.advanced');
    };

    vm.delete = function () {
      var req = {
        method: 'DELETE',
        url: HOST + 'user',
        data: {
          id: vm.user.admin_staffid
        },
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      };
      $http(req).then(function () {
        vm.back();
      });
    };


    vm.update = function () {
      if (!vm.user.is_online) {
        vm.user.is_online = 0
      }
      if (vm.isCreate) {
        User.save(vm.user, function (data) {
          vm.id = data.admin_staffid;
          vm.user = data;
          vm.isCreate = false;
          vm.edit();
        })
      } else {
        vm.roleCheckedList.map(function (value) {
          if (value) {
            vm.addRoleList.push(Number(value));
          }
        });
        UserRole.save({
          // id: vm.id
          primaryKey: vm.id
        }, {
          role_ids: vm.addRoleList.join(',')
        });
        vm.user.id = vm.id;
        User.update(vm.user, function () {
          vm.back();
        });
      }
    }
  }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('timeConfigDialog', timeConfigDialog);
    // hotRecConfigDialog.$inject = ['$scope', 'data', 'Resource', '$uibModalInstance'];

    function timeConfigDialog($scope, data, Resource, $uibModalInstance) {
        var vm = $scope;
        var timeConfigListRes = Resource.configManage.timeConfigList;
        var timeConfigItemRes = Resource.configManage.timeConfigItem;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var defaultConfigReflect = {};

        vm.appReflect = [];
        vm.isCreate = !data.id;
        vm.itemid = data.id;
        vm.recTypes = [{
                name: '个性化推荐',
                value: 'personal'
            },{
                name:'相关推荐',
                value:'relate'
            },{
                name:'热门推荐',
                value:'hot'
            } 
        ];
        vm.sceneTypes = ['IOS', 'Android', 'H5'];

        vm.params = {
            appInfo: undefined,
            rec_type: '',
            scene_type: '',
            specify_cate: [{
                name: "娱乐"
            }, {
                name: '体育'
            }, {
                name: "军事"
            }],
            timeliness_strategy: 1,
            day_limit: ''
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });

        if (!vm.isCreate) {
            timeConfigItemRes.get({
                primaryKey: vm.itemid
            }, function (data) {
                if (data.specify_cate === '') {
                    vm.params = data;
                    vm.params.specify_cate = true;
                } else {
                    var list = data.specify_cate.split(";");
                    data.specify_cate = data.specify_cate.split(";");
                    vm.params = data;
                    vm.params.specify_cate = [];
                    list.forEach(function (item) {
                        vm.params.specify_cate.push({
                            name: item
                        });
                    });
                }
                initAppInfo();
            })
        }

        function initAppInfo() {
            if (!vm.appReflect || vm.appReflect.length < 1) {
                setTimeout(function () {
                    initAppInfo();
                }, 50);
            } else {
                angular.forEach(vm.appReflect, function (reflect) {
                    if (reflect.appid == vm.params.appid) {
                        vm.params.appInfo = reflect;
                    }
                });
            }
        }

        vm.deleteConfig = function (idx, configName) {
            console.log('delete params ', vm.params.specify_cate);
            vm.params[configName].splice(idx, 1);
            if (vm.params[configName].length < 1) {
                vm.params[configName].push(angular.copy(defaultConfigReflect[configName]));
            }
        }



        vm.addConfig = function (configName) {
            vm.params[configName].push({
                name: ''
            });
        };

        vm.selectCate = function () {
            if (!vm.params.specify_cate) {
                vm.params.specify_cate = [{
                    name: "娱乐"
                }, {
                    name: '体育'
                }, {
                    name: "军事"
                }]
            }
        }

        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

        vm.confirm = function () {
            vm.params;
            var queryParams;
            var status = verify();

            if (!status) {
                return;
            }
            queryParams = getQueryParams();

            if (vm.isCreate) {
                timeConfigListRes.save(queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                timeConfigItemRes.update({
                    primaryKey: vm.itemid
                }, queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }

        function verify() {
            if (!vm.params.appInfo) {
                errorTip("未填写appid");
                return false;
            }

            if (!vm.params.rec_type) {
                errorTip("推荐类型不允许为空");
                return false;
            }

            return true;
        }

        function getQueryParams() {
            var params = angular.copy(vm.params);
            if (params.specify_cate === true) {
                params.specify_cate = '';
            } else {
                var arr = [];
                params.specify_cate.forEach(function (item) {
                    arr.push(item.name);
                });
                params.specify_cate = arr.join(";");
            }

            params.appname = params.appInfo.app_name;
            params.appid = params.appInfo.appid;
            delete(params.appInfo);

            return params;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('relatedSuggestConfigDialog', relatedSuggestConfigDialog);

    function relatedSuggestConfigDialog($scope, data, Resource, $uibModalInstance) {
        var vm = $scope;
        var relateConfigItemRes = Resource.configManage.relateConfigItem;
        var relateConfigListRes = Resource.configManage.relateConfigList;
        var AppnameReflectRes = Resource.Order.AppnameReflect;

        vm.appReflect = [];
        vm.isCreate = !data.id;
        vm.itemid = data.id;
        vm.params = {
            appInfo: undefined,
            is_day: 1,
            is_hour: 1,
            day_action_detail: [{
                action_type: 'rec_click',
                weight: 10,
                alg_mark: '110',
                user_max_op: 2000,
                item_min_show: 2,
                min_item_pair_freq: 2,
                min_total_item_pair_cnt: 2
            }],
            hour_action_detail: [{
                action_type: 'rec_click',
                weight: 10,
                alg_mark: '110',
                user_max_op: 2000,
                item_min_show: 2,
                min_item_pair_freq: 2,
                min_total_item_pair_cnt: 2
            }],
            day_cnt: '',
            result_len: '',
            expire_time: '',
            is_same_cate_first: 0,
            is_same_tag_first: 0
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });

        if (!vm.isCreate) {
            relateConfigItemRes.get({
                primaryKey: vm.itemid
            }, function (data) {
                vm.params = data;
                vm.params.day_action_detail = JSON.parse(vm.params.day_action_detail);
                vm.params.hour_action_detail = JSON.parse(vm.params.hour_action_detail);
                if (vm.params.day_action_detail.length === 0) {
                    vm.params.is_day = 0;
                } else {
                    vm.params.is_day = 1;
                }
                if (vm.params.hour_action_detail.length === 0) {
                    vm.params.is_hour = 0;
                } else {
                    vm.params.is_hour = 1;
                }
                initAppInfo();
            })
        }

        function initAppInfo() {
            if (!vm.appReflect || vm.appReflect.length < 1) {
                setTimeout(function () {
                    initAppInfo();
                }, 50);
            } else {
                angular.forEach(vm.appReflect, function (reflect) {
                    if (reflect.appid == vm.params.appid) {
                        vm.params.appInfo = reflect;
                    }
                });
            }
        }

        vm.deleteConfig = function (idx, configName) {
            vm.params[configName].splice(idx, 1);

        }

        vm.addConfig = function (configName) {
            vm.params[configName].push({});
        }

        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

        vm.confirm = function () {
            vm.params;
            var queryParams;
            var status = verify();

            if (!status) {
                return;
            }
            queryParams = getQueryParams();

            if (vm.isCreate) {
                relateConfigListRes.save(queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                relateConfigItemRes.update({
                    primaryKey: vm.itemid
                }, queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }

        function verify() {
            if (!vm.params.appInfo) {
                errorTip("未填写appid");
                return false;
            }
            if (checkDayActionRepeat()) {
                errorTip("action_type不允许出现重复");
                return false;
            }
            if (checkHourActionRepeat()) {
                errorTip("action_type不允许出现重复");
                return false;
            }
            return true;
        }

        function checkDayActionRepeat() {
            if (!vm.params.day_action_detail) {
                var dayActionTypeList = vm.params.day_action_detail.map(function (item) {
                    return item.action_type;
                });
                for (var i = 0; i < dayActionTypeList.length; i++) {
                    if (dayActionTypeList.indexOf(dayActionTypeList[i]) != dayActionTypeList.lastIndexOf(dayActionTypeList[i])) {
                        return true;
                    }
                };
            }
        }

        function checkHourActionRepeat() {
            if (!vm.params.hour_action_detail) {
                var hourActionTypeList = vm.params.hour_action_detail.map(function (item) {
                    return item.action_type;
                });
                for (var i = 0; i < hourActionTypeList.length; i++) {
                    if (hourActionTypeList.indexOf(hourActionTypeList[i]) != hourActionTypeList.lastIndexOf(hourActionTypeList[i])) {
                        return true;
                    }
                };
            }



        }


        function getQueryParams() {
            var params = angular.copy(vm.params);
            if (params.is_day == 1) {
                params.day_action_detail = angular.toJson(params.day_action_detail);
            } else {
                params.day_action_detail = angular.toJson([]);
            };
            if (params.is_hour == 1) {
                params.hour_action_detail = angular.toJson(params.hour_action_detail);
            } else {
                params.hour_action_detail = angular.toJson([]);
            };

            params.appname = params.appInfo.app_name;
            params.appid = params.appInfo.appid;

            delete(params.appInfo);
            delete(params.is_day);
            delete(params.is_hour);

            return params;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('diversityConfigDialog', diversityConfigDialog);

    function diversityConfigDialog($scope, data, Resource, $uibModalInstance) {
        var vm = $scope;
        var diversityConfigItemRes = Resource.configManage.diversityConfigItem;
        var diversityConfigListRes = Resource.configManage.diversityConfigList;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var defaultConfigReflect = {};

        vm.recTypes = [{
            name:'个性化推荐',
            value:'personal'
        }, {
            name:'相关推荐',
            value:'relate'
        },{
            name:'热门推荐',
            value:'hot'
        }];
        vm.sceneTypes = ['IOS', 'Android', 'H5'];
        vm.appReflect = [];
        vm.isCreate = !data.id;
        vm.itemid = data.id;
        vm.params = {
            appInfo: undefined,
            rec_type:'',
            scene_type:'',
            attribute: 'category',
            diversity_type: 'cnt',
            upper_limit:''
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });

        if (!vm.isCreate) {
            diversityConfigItemRes.get({
                primaryKey: vm.itemid
            }, function (data) {
                vm.params = data;

                initAppInfo();
            })
        }

        function initAppInfo() {
            if (!vm.appReflect || vm.appReflect.length < 1) {
                setTimeout(function () {
                    initAppInfo();
                }, 50);
            } else {
                angular.forEach(vm.appReflect, function (reflect) {
                    if (reflect.appid == vm.params.appid) {
                        vm.params.appInfo = reflect;
                    }
                });
            }
        }

        vm.deleteConfig = function (idx, configName) {
            vm.params[configName].splice(idx, 1);

            if (vm.params[configName].length < 1) {
                vm.params[configName].push(angular.copy(defaultConfigReflect[configName]));
            }
        }

        vm.addConfig = function (configName) {
            vm.params[configName].push(angular.copy(defaultConfigReflect[configName]));
        }

        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

        vm.confirm = function () {
            vm.params;
            var queryParams;
            var status = verify();

            if (!status) {
                return;
            }
            queryParams = getQueryParams();
            if (vm.isCreate) {
                diversityConfigListRes.save(queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                diversityConfigItemRes.update({
                    primaryKey: vm.itemid
                }, queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }

        function verify() {
            if (!vm.params.appInfo) {
                errorTip("未填写appid");
                return false;
            }

            if (!vm.params.rec_type) {
                errorTip("推荐类型不允许为空");
                return false;
            }
            return true;
        }

        function getQueryParams() {
            var params = angular.copy(vm.params);
            params.appname = params.appInfo.app_name;
            params.appid = params.appInfo.appid;
            delete(params.appInfo);
            
            return params;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('basicConfigDialog', basicConfigDialog);

    function basicConfigDialog($scope, data, Resource, $uibModalInstance) {
        var vm = $scope;
        var basicConfigItemRes = Resource.configManage.basicConfigItem;
        var basicConfigListRes = Resource.configManage.basicConfigList;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var defaultConfigReflect = {
            action_list:[{name:''}]
        };
        vm.appReflect = [];
        vm.isCreate = !data.id;
        vm.itemid = data.id;
        vm.recTypes = [{
            name:'个性化推荐',
            value:'personal'
        }, {
            name:'相关推荐',
            value:'relate'
        },{
            name:'热门推荐',
            value:'hot'
        }];
        vm.sceneTypes = ['IOS', 'Android', 'H5'];

        vm.params = {
            appInfo: undefined,
            action_list: [{name:'rec_click'}, {name:'like'}, {name:'collect'}],
            is_open_page: 0,
            is_filter_show: 1,
            rec_type: '',
            scene_type: '',
            is_filter_click: 1,
            title_similarity: ''
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    app_name: val.app_name
                });
            });
        });

        if (!vm.isCreate) {
            basicConfigItemRes.get({
                primaryKey: vm.itemid
            }, function (data) {
                var list = data.action_list.split(";");
                data.action_list = data.action_list.split(";");
                vm.params = data;
                console.log(data.action_list);
                vm.params.action_list = [];
                list.forEach(function(item){
                    vm.params.action_list.push({name:item});
                })
                console.log(vm.params.action_list);
                initAppInfo();
            })
        }

        function initAppInfo() {
            if (!vm.appReflect || vm.appReflect.length < 1) {
                setTimeout(function () {
                    initAppInfo();
                }, 50);
            } else {
                angular.forEach(vm.appReflect, function (reflect) {
                    if (reflect.appid == vm.params.appid) {
                        vm.params.appInfo = reflect;
                    }
                });
            }
        }

        vm.deleteConfig = function (idx, configName) {
            vm.params[configName].splice(idx, 1);
            if (vm.params[configName].length < 1) {
                vm.params[configName].push(angular.copy(defaultConfigReflect[configName]));
            }
        }

        vm.addConfig = function (configName) {
            console.log(angular.copy(defaultConfigReflect[configName]));
            vm.params[configName].push({name: ''});
        }

        vm.cancel = function (info) {
            $uibModalInstance.close(info);
        };

        vm.confirm = function () {
            vm.params;
            var queryParams;
            var status = verify();

            if (!status) {
                return;
            }
            queryParams = getQueryParams();
            if (vm.isCreate) {
                basicConfigListRes.save(queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            } else {
                basicConfigItemRes.update({
                    primaryKey: vm.itemid
                }, queryParams, function (data) {
                    successTip(data.message);
                    vm.cancel('reload');
                });
            }
        }

        // vm.$watch('params.title_similarity', function (newValue, oldValue) {
        //     console.log('old', oldValue, newValue)
        //     if ( !newValue  && newValue != 0){
        //         vm.params.title_similarity = 1;
        //     }
            
        //  });

        function verify() {
            if (!vm.params.appInfo) {
                errorTip("未填写appid");
                return false;
            }

            if (!vm.params.rec_type) {
                errorTip("推荐类型不允许为空");
                return false;
            }

            return true;
        }

        function getQueryParams() {
            var params = angular.copy(vm.params);
            var arr =[];
            params.action_list.forEach(function(item){
                arr.push(item.name);
            })
            params.action_list = arr.join(";");
            params.appname = params.appInfo.app_name;
            params.appid = params.appInfo.appid;
            delete(params.appInfo);

            return params;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('funcReviewDialog', funcReviewDialog);

    function funcReviewDialog($scope, data, Resource, $uibModalInstance) {
        var vm = $scope;
        var AppApplyModifyDetailRes = Resource.Apply.AppApplyModifyDetail;
        vm.baseData = data;
        vm.applyType = vm.baseData.apply_type;
        
        AppApplyModifyDetailRes.query({
            primaryKey: data.id
        }, function (data) {
             vm.funcData = data;
        });

        vm.back = function (data) {
            data ? $uibModalInstance.close(data) : $uibModalInstance.close();
        };
    }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .controller('accountDialog', accountDialog);
  accountDialog.inject = ['$scope', '$location', 'APP_CONFIG', 'Resource', '$stateParams', 'dataService', '$state', '$uibModalInstance', 'accountDialogData'];

  function accountDialog($scope, $location, APP_CONFIG, Resource, $stateParams, dataService, $state, $uibModalInstance, accountDialogData) {
    var vm = $scope;
    var AppInfoItem = Resource.Recommendation.AppInfoItem;
    var AppRegistration = Resource.Recommendation.AppRegistration;
    var GetSaler = Resource.Customer.Saler;
    var Config = Resource.Common.Reflect;
    var ChannelList = Resource.Channel.List;
    var GetSaler = Resource.Management.GetSaler;
    GetSaler.query({}, function (data) {
      vm.managers = data;
    });

    vm.appid = isNaN(accountDialogData) ? 0 : accountDialogData;
    vm.appid > 0 ? vm.is_edit = true : vm.is_edit = false;
    var id = accountDialogData;

    vm.isCreate = id ? false : true;
    vm.isEdit = false;
    vm.legend = id ? '编辑' : '新建';

    vm.sources = dataService.sources;
    vm.Number = function (string) {
      return parseInt(string);
    };
    var primaryKey = {
      primaryKey: vm.appid
    };
    Config.get({}, function (data) {
      vm.channelList = data.channel_id;
      Object.keys(vm.channelList).map(function(key){
        if (vm.channelList[key] === '市场') {
          vm.marketChannelId = key;
        }
      });
      if (vm.is_edit) {
        AppInfoItem.get(primaryKey, function (account) {
          vm.account = account.app_func_config;
          vm.account.nlpdetail = angular.extend(newAccount.nlpdetail, account.app_func_config.nlpdetail);
          vm.account.func_thold = angular.extend(newAccount.func_thold, account.app_func_config.func_thold);
          vm.account.app_name = account.app_name;
          vm.account.passwd = account.pwd_tmp;
          vm.account.is_online = account.is_online;
          var channelName = '';
          if (vm.account.channel_id === 0){
            channelName = '';
          } else {
            channelName = vm.channelList[vm.account.channel_id];
          }
          if (['销售', '其他', '市场', ''].indexOf(channelName) === -1) {
            vm.account.channel_id = vm.marketChannelId;
          }
          handleStatus(vm.account.status);
        });
      } else {
        vm.account = newAccount;
        handleStatus();
      }
    });

    var newAccount = {
      username: '',
      app_name: '',
      passwd: '888888',
      is_online: 1,
      rec_config: '0',
      search_config: '0',
      nlp_config: '0',
      spider_config: '0',
      static_config: '0',
      is_ecshop: 0,
      nlpdetail: {
        insult: 0,
        ad: 0,
        nonsense: 0,
        porn: 0,
        politic: 0,
        reaction: 0,
        classify: 0,
        tagging: 0,
        sentiment: 0
      },
      func_thold: {
        rec: 0,
        search: 0,
        spider: 0,
        static: 0,
        ad: 0,
        nonsense: 0,
        insult: 0,
        politic: 0,
        reaction: 0,
        porn: 0,
        classify: 0,
        tagging: 0,
        sentiment: 0,
      },
      status: '上线',
      channel_id: null
    }



    vm.edit = function () {
      vm.isEdit = false;
      vm.legend = '编辑';
    };

    vm.cancel = function () {
      vm.back();
    };

    vm.post_process = function () {
      vm.account.username = vm.account.app_name;
      vm.account.func_thold.nonsense = vm.account.func_thold.ad;
      vm.account.func_thold.politic = vm.account.func_thold.porn;
      vm.account.func_thold.reaction = vm.account.func_thold.porn;
    };

    function handleStatus(status) {
      vm.statuses = vm.account.is_online ? ['测试', '上线'] : ['暂停', '停止'];
      vm.account.status = status || vm.statuses[0];
    }

    vm.changeStatus = function () {
      handleStatus();
    }

    vm.save = function () {
      vm.post_process();
      if (vm.is_edit) {
        AppInfoItem.update(primaryKey, vm.account, function () {
          successTip('修改成功');
          vm.back({
            data: vm.account,
            type: 'update'
          })
        });
      } else {
        AppRegistration.save({}, vm.account, function () {
          successTip('新建成功');
          vm.back({type: 'post'});
        });
      }
    };

    vm.back = function (data) {
      data ? $uibModalInstance.close(data) : $uibModalInstance.close();
    };
  }
})();
(function () {
    'use strict';
    angular
      .module('app')
      .controller('client.API.item', recommendationAPIItem);


    function recommendationAPIItem($scope, APP_CONFIG, Resource, ngTableParams, $stateParams, $filter, calcDateService, csvSaver) {
      var vm = $scope;
      vm.period = {
        start: calcDateService.basedToday(-7),
        end: calcDateService.basedToday(0)
      }
      var APIItem = Resource.Customer.APIItem;
      var fixDate = function () {
        if (vm.period.start.length > 11) {
          vm.period.start = vm.period.start(0, 10)
        }
        if (vm.period.end.length > 11) {
          vm.period.end = vm.period.end(0, 10)
        }
        return vm.period
      }
      
      vm.appid = $stateParams.id;
      
      vm.download = function(){
        APIItem.get({
          appid: vm.appid,
          start_date: vm.period.start,
          end_date: vm.period.end,
          is_exported: 1
        }, function(data){
          csvSaver(data.data, data.file_name);
        })
      }
      
      vm.getSum = function (e) {
        vm.sum.nlp += e.nlp;
        vm.sum.search += e.search;
        vm.sum.rec += e.rec;
        vm.sum.spider += e.spider;
        vm.sum.static += e.static;
        vm.sum.ad += e.ad;
        vm.sum.nonsense += e.nonsense;
        vm.sum.porn += e.porn;
        vm.sum.politic += e.politic;
        vm.sum.reaction += e.reaction;
        vm.sum.classify += e.classify;
        vm.sum.tagging += e.tagging;
        vm.sum.sentiment += e.sentiment;
      }

      vm.drawChart = function (item) {
        vm.chartData.xAxis.categories.push(item.data_time.slice(0, 10))
        vm.chartData.series[0].data.push(item.static)
        vm.chartData.series[1].data.push(item.search);
        vm.chartData.series[2].data.push(item.rec);
        vm.chartData.series[3].data.push(item.spider);
        vm.chartData.series[4].data.push(item.ad);
        vm.chartData.series[5].data.push(item.porn);
        vm.chartData.series[6].data.push(item.politic);
        vm.chartData.series[7].data.push(item.reaction);
        vm.chartData.series[8].data.push(item.nonsense);
        vm.chartData.series[9].data.push(item.classify);
        vm.chartData.series[10].data.push(item.tagging);
        vm.chartData.series[11].data.push(item.sentiment);
      }

      vm.tableParams = new ngTableParams({
        page: 1,
        count: 10000
      }, {
        getData: function ($defer, params) {
          if (params.settings().vm == null) {
            params.settings().vm = vm
          }
          var req = {
            start_date: fixDate().start,
            end_date: fixDate().end,
            appid: $stateParams.id
          }
          APIItem.get(req, function (data) {
            vm.cleanData()
            params.total(data.total)
            $defer.resolve(vm.detail = data)
            vm.detail.items = $filter('orderBy')(data.items, 'data_time')
            vm.detail.items.forEach(vm.getSum)
            vm.detail.items.forEach(vm.drawChart)
          });
        }
      })

      vm.canSearch = false
      vm.timeoutCanSearch = function () {
        vm.canSearch = true
      }
      setTimeout(vm.timeoutCanSearch, 1500)

      vm.cleanData = function () {
        vm.sum = {
          nlp: 0,
          search: 0,
          rec: 0,
          spider: 0,
          static: 0,
          classify: 0,
          tagging: 0,
          sentiment: 0,
          ad: 0,
          nonsense: 0,
          porn: 0,
          politic: 0,
          reaction: 0
        }
        vm.chartData = {
          series: [{
            name: '数据上报',
            data: []
          }, {
            name: '搜索',
            data: []
          }, {
            name: '推荐',
            data: []
          }, {
            name: '爬虫',
            data: []
          }, {
            name: '广告',
            data: []
          }, {
            name: '涉黄',
            data: []
          }, {
            name: '涉政',
            data: []
          }, {
            name: '反动',
            data: []
          }, {
            name: '低质量',
            data: []
          }, {
            name: '分类',
            data: []
          }, {
            name: '标签',
            data: []
          }, {
            name: '情感',
            data: []
          }],
          options: {
            chart: {
              type: 'line'
            }
          },
          credits: {
            enabled: false
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: []
          }
        }
      }

      vm.search = function () {
        if (vm.canSearch) {
          vm.tableParams.reload()
        }
      }
    }
})();
(function() {
    'use strict';
    angular
        .module('app')
        .controller('examineCtrl', examineCtrl);

        function examineCtrl($scope, Resource, $uibModalInstance, calcDateService) {
            var vm = $scope;
            vm.fileMaxSize = 10;//10MB
            vm.params = {
                isFirst: true,
                isLast: false,
                currentTplIndex: 0
            };

            vm.forms = {
                managerSale: undefined,
                managerProduct: undefined
            };

            vm.dialogSubViewArr = [
                'accountInfo',
                'accountFunc',
                'accountOpen'
            ];

            vm.screenshotpos = {
                recommand: undefined,
                search: undefined
            }

            vm.cancel = function () {
                $uibModalInstance.close();
            };

            vm.back = function() {
                var len = vm.dialogSubViewArr.length;
                if(vm.params.currentTplIndex == 1) {
                    vm.params.isFirst = true;
                } else {
                    vm.params.isLast = false;
                }
                vm.params.currentTplIndex -= 1;
            }
            
            vm.next = function() {
                var len = vm.dialogSubViewArr.length;
                if(vm.params.currentTplIndex + 1 == len) {
                    $uibModalInstance.close();
                } else {
                    vm.params.isFirst = false;
                    if(vm.params.currentTplIndex + 2 == len) {
                        vm.params.isLast = true;
                    }
                    vm.params.currentTplIndex += 1;
                }
            }

            vm.fileVerification = function(type) {
                var file = vm.screenshotpos[type];
                file = file && file[0];
                var sizeError = file && file.size > vm.fileMaxSize * 1024000;
                var formatError = file && !(/.(pdf|docx|doc)/.test(file.name));
                sizeError = formatError ? undefined : sizeError;
                return {
                    sizeError: sizeError,
                    formatError: formatError
                };
            }

            vm.formVerification = function() {
                return  vm.params.isLast && (!vm.forms.managerSale || !vm.forms.managerProduct);
            }
        }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('account.unonlineDetail', onlineItem);


    function onlineItem($scope, APP_CONFIG, Resource, ngTableParams, $stateParams, $filter, calcDateService, csvSaver) {
        var vm = $scope;
        vm.isEdit = false;
        vm.isShowBaseInfo = false;
        vm.isShowCusInfo = false;
        vm.isShowOther = false;
        vm.isShowText = false;
        vm.isShowRecommend = false;
        vm.isShowSearch = false;
        vm.isShowOtherFun = false;
        vm.edit = function (args) {
            switch (args) {
                case 'baseInfo':
                    editBaseInfo();
                    break;
                case 'cusInfo':
                    editCusInfo();
                    break;
                case 'other':
                    vm.isShowOther = !vm.isShowOther;
                    break;
                case 'text':
                    vm.isShowText = !vm.isShowText;
                    break;
                case 'recommend':
                    vm.isShowRecommend = !vm.isShowRecommend;
                    break;
                case 'search':
                    vm.isShowSearch = !vm.isShowSearch;
                    break;
                case 'otherFun':
                    vm.isShowOtherFun = !vm.isShowOtherFun;
                    break;

                default:

            }
        }

        vm.cancel = function (args) {
            switch (args) {
                case 'baseInfo':
                    vm.isShowBaseInfo = !vm.isShowBaseInfo;
                    vm.isEdit = false;
                    break;
                case 'cusInfo':
                    vm.isShowCusInfo = !vm.isShowCusInfo;
                    vm.isEdit = false;
                    break;
                case 'other':
                    vm.isShowOther = !vm.isShowOther;
                    break;
                case 'text':
                    vm.isShowText = !vm.isShowText;
                    break;
                case 'recommend':
                    vm.isShowRecommend = !vm.isShowRecommend;
                    break;
                case 'search':
                    vm.isShowSearch = !vm.isShowSearch;
                    break;
                case 'otherFun':
                    vm.isShowOtherFun = !vm.isShowOtherFun;
                    break;
                default:

            }
        }

        function editBaseInfo() {
            vm.isShowBaseInfo = !vm.isShowBaseInfo;
            vm.isEdit = vm.isShowBaseInfo === true ? true : false; //其他选项的编辑状态
            // if(vm.isShowBaseInfo) // 正在显示
            // {
            //     vm.isEdit=true;
            // }else{
            //     vm.isEdit=false;
            // }  
        }
        function editCusInfo() {
            vm.isShowCusInfo = !vm.isShowCusInfo;
            vm.isEdit = vm.isShowCusInfo === true ? true : false; //其他选项的编辑状态
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('otherAccountCtrl', otherAccountCtrl);

        otherAccountCtrl.inject = ['$scope', 'Resource', '$uibModalInstance'];

    function otherAccountCtrl($scope, Resource, $uibModalInstance) {
        var vm = $scope;

        vm.cancel = function () {
            $uibModalInstance.close();
        };
        
        vm.forms = {
            productName: undefined,
            appname: undefined,
            accountType: undefined,
            state: undefined,
        };

        vm.tableData = [
            {checkboxName: '黄反识别', inputExist: true},
            {checkboxName: '垃圾评论过滤', inputExist: true},
            {checkboxName: '文本分类', inputExist: true},
            {checkboxName: '文本标签提取', inputExist: true},
            {checkboxName: '文本情感分析', inputExist: true},
            {checkboxName: '推荐引擎', inputExist: false},
            {checkboxName: '搜素引擎', inputExist: false},
            {checkboxName: '数据抓取', inputExist: true},
        ];

        vm.formVerification = function() {
            var isAllNull = false;
            var forms = vm.forms;
            for(var key in forms) {
                if(!forms[key] ) {
                    isAllNull = true;
                }
            }
            return isAllNull;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('account.onlineDetail', onlineItem);


    function onlineItem($scope, APP_CONFIG, Resource, ngTableParams, $stateParams, $filter, calcDateService, csvSaver) {
        var vm = $scope;
        var Config = Resource.Common.Reflect;


        //基本信息 数据准备
        vm.account = {
            type: '1',
            status: '1',
            company_name :'乐天'
        };

        //控制显示开关
        vm.isEdit = false;
        vm.isShowBaseInfo = false;
        vm.isShowCusInfo = false;
        vm.isShowOther = false;
        vm.isShowText = false;
        vm.isShowRecommend = false;
        vm.isShowSearch = false;
        vm.isShowOtherFun = false;

        vm.app_name = "哈哈";
        vm.app_id = "123345";
        vm.company_name = "达观数据";
        //账号类型
        vm.accountTypeList = [{
            key: '1',
            name: '客户账号'
        }, {
            key: '2',
            name: '内部账号'
        }, {
            key: '3',
            name: '合作账号'
        }];
        //账号状态
        vm.statuses = [{
            key: '1',
            name: '测试'
        }, {
            key: '2',
            name: '上线'
        }, {
            key: '3',
            name: '关闭'
        }];
        //所属行业
        vm.industryList = [{
            key: '1',
            name: '科技'
        }, {
            key: '2',
            name: '汽车'
        }, {
            key: '3',
            name: '工业'
        }, {
            key: '4',
            name: '制造'
        }, {
            key: '5',
            name: '零售'
        }, {
            key: '6',
            name: '金融'
        }, {
            key: '7',
            name: '咨询'
        }, {
            key: '8',
            name: '电商'
        }, {
            key: '9',
            name: '媒体'
        },
        {
            key: '10',
            name: '法律'
        }, {
            key: '9',
            name: '文娱'
        },
        {
            key: '11',
            name: '教育'
        }, {
            key: '12',
            name: '其他'
        }];

        //时间配置
        vm.period = {
            start: calcDateService.basedToday(0),
            end: calcDateService.basedToday(14)
        };
        vm.dateConfig = {
            canChange: true,
            minDate: calcDateService.basedToday(0),
            maxDate: calcDateService.basedToday(60),
            change: function () {
                if (!vm.dateConfig.canChange) {
                    return false;
                }
            }
        };
        //账号状态
        vm.paymentList = [{
            key: '1',
            name: '月付'
        }, {
            key: '2',
            name: '季付'
        }, {
            key: '3',
            name: '半年付'
        }, {
            key: '4',
            name: '年付'
        }, {
            key: '5',
            name: '预充值'
        }, {
            key: '6',
            name: '其他'
        }];

        //文本  应用行业
        vm.textApplyList = [{
            key: '1',
            name: '直播'
        }, {
            key: '2',
            name: '其他'
        }];

        //弹出浮窗
        $(function () {
            $("[data-toggle='popover']").popover();
        });
        vm.edit = function (args) {
            switch (args) {
                case 'baseInfo':
                    vm.isShowBaseInfo = !vm.isShowBaseInfo;
                    vm.isEdit = vm.isShowBaseInfo === true ? true : false; //其他选项的编辑状态
                    break;
                case 'cusInfo':
                    vm.isShowCusInfo = !vm.isShowCusInfo;
                    vm.isEdit = vm.isShowCusInfo === true ? true : false; //其他选项的编辑状态
                    break;
                case 'other':
                    vm.isShowOther = !vm.isShowOther;
                    vm.isEdit = vm.isShowOther === true ? true : false;
                    break;
                case 'text':
                    vm.isShowText = !vm.isShowText;
                    vm.isEdit = vm.isShowText === true ? true : false;
                    break;
                case 'recommend':
                    vm.isShowRecommend = !vm.isShowRecommend;
                    vm.isEdit = vm.isShowRecommend === true ? true : false;
                    break;
                case 'search':
                    vm.isShowSearch = !vm.isShowSearch;
                    vm.isEdit = vm.isShowSearch === true ? true : false;
                    break;
                case 'otherFun':
                    vm.isShowOtherFun = !vm.isShowOtherFun;
                    vm.isEdit = vm.isShowOtherFun === true ? true : false;
                    break;

                default:

            }
        }

        vm.cancel = function (args) {
            switch (args) {
                case 'baseInfo':
                    vm.isShowBaseInfo = !vm.isShowBaseInfo;
                    vm.isEdit = false;
                    break;
                case 'cusInfo':
                    vm.isShowCusInfo = !vm.isShowCusInfo;
                    vm.isEdit = false;
                    break;
                case 'other':
                    vm.isShowOther = !vm.isShowOther;
                    vm.isEdit = false;
                    break;
                case 'text':
                    vm.isShowText = !vm.isShowText;
                    vm.isEdit = false;
                    break;
                case 'recommend':
                    vm.isShowRecommend = !vm.isShowRecommend;
                    vm.isEdit = false;
                    break;
                case 'search':
                    vm.isShowSearch = !vm.isShowSearch;
                    vm.isEdit = false;
                    break;
                case 'otherFun':
                    vm.isShowOtherFun = !vm.isShowOtherFun;
                    vm.isEdit = false;
                    break;
                default:

            }
        }
        //保存操作
        vm.save = function (args) {
            switch (args) {
                case 'baseInfo':
                    saveBaseInfo();
                    break;
                case 'cusInfo':
                    saveCusInfo();
                    break;
                case 'other':
                    saveOther();
                    break;
                case 'text':
                    saveText();
                    break;
                case 'recommend':
                    saveRecommend();
                    break;
                case 'search':
                    saveSearch();
                    break;
                case 'otherFun':
                    saveOtherFun();
                    break;
                default:

            }
        }

        //基本信息保存
        function saveBaseInfo() {
            //数据校验操作
            //控制显示操作  
            vm.isShowBaseInfo = !vm.isShowBaseInfo;
            vm.isEdit = false;//其他选项的编辑状态


           //保存后再更新下数据

        }


        //客户资料
        function saveCusInfo() {
            vm.isShowCusInfo = !vm.isShowCusInfo;
            //编辑报错操作  
            vm.isEdit = false;//其他选项的编辑状态
        }
        //其他信息保存
        function saveOther() {
            //数据校验操作
            //控制显示操作  
            vm.isShowOther = !vm.isShowOther;
            vm.isEdit = false;//其他选项的编辑状态
        }


        //文本分类
        function saveText() {
            vm.isShowText = !vm.isShowText;
            //编辑报错操作  
            vm.isEdit = false;//其他选项的编辑状态
        }
        //推荐信息保存
        function saveRecommend() {
            //数据校验操作
            //控制显示操作  
            vm.isShowRecommend = !vm.isShowRecommend;
            vm.isEdit = false;//其他选项的编辑状态
        }


        //搜索信息保存
        function saveSearch() {
            vm.isShowSearch = !vm.isShowSearch;
            //编辑报错操作  
            vm.isEdit = false;//其他选项的编辑状态
        }

        //其他功能保存
        function saveOtherFun() {
            //数据校验操作
            //控制显示操作  
            vm.isShowOtherFun = !vm.isShowOtherFun;
            vm.isEdit = false;//其他选项的编辑状态
        }



        //开通关联账号信息
        vm.addRelationAccount = function () {

        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('account.accountDetail', onlineItem);


    function onlineItem($scope, APP_CONFIG, Resource, ngTableParams, $stateParams, $filter, calcDateService, csvSaver) {
        var vm = $scope;

    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('clientAccountCtrl', clientAccountCtrl);

        clientAccountCtrl.inject = ['$scope', 'Resource', '$uibModalInstance', 'calcDateService'];

    function clientAccountCtrl($scope, Resource, $uibModalInstance, calcDateService) {
        var vm = $scope;
        vm.params = {
            isFirst: true,
            isLast: false,
            currentTplIndex: 0
        };
        vm.emailList = ['email0'];
        vm.testDetailList = [0];
        vm.dialogSubViewArr = [
            'fillInfo',
            'funcOpenInitial',
            'funcOpenDetails',
            'funcOpenSubmit'
        ];
      
        vm.funcOpenEnable = {
            textExamine: false,
            textClassification: false,
            textLabelExtraction: false,
            textEmotionalAnalysis: false,
            personalizedRecommEngine: false,
            verticalSearchEngine: false,
            dataCapture: false
        }
        vm.checkBox = {
            textSpecificFunc: {
                identify: undefined,
                rubbishFilter: undefined
            },
            textExamine: {
                longText: undefined,
                shortText: undefined,
            },
            vSearchSpecificFunc: {
                keywordSearch: undefined,
                keywordAutoComplete: undefined,
                relationSearch: undefined,
                hotSearch: undefined
            }
        };
        vm.limitNumber = {
            textExamine: undefined,
            textClassification: undefined,
            textLabelExtraction: undefined,
            textEmotionalAnalysis: undefined
        }
        vm.engineRecomm = {
            test0: {
                testSpecificFunc: undefined,
                testScene: undefined,
                testMethod: undefined,
                screenshotinsertpos: undefined,
                screenshotpos: undefined,
                flowdispatch: undefined,
                testindex: undefined
            }
        };
        vm.forms = {
            step1: {
                companyName: undefined,
                productName: undefined,
                appname: undefined,
                address: {
                    provinceName: undefined,
                    cityName: undefined
                },
                industry: undefined,
                clientSource: undefined,
                emails: {
                    email0: undefined
                },
            },
            step2: {
                textSpecificFunc: undefined,
                applyIndustry: undefined,
                applyScene: undefined,
                textExamine: undefined,
                callBadName: undefined,
                testStrategy: undefined,
                testData: undefined,
                vSearchSpecificFunc: undefined,
                vSearchvStrategy: undefined
            },
            step3: {
                
            }
        };
        //dropdown
        vm.industry = ['科技','汽车','工业','制造','零售','金融','咨询','电商','媒体','法律','文娱','教育','其他'];
        vm.applyIndustry = ['直播','其他'];
        vm.testSpecificFunc = ['个性化推荐','相关推荐','热门推荐'];
        vm.testScene = ['pc','ios','android','h5'];
        
        vm.filterDate = {
            start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
            end: calcDateService.basedDate(new Date(), 0)
        }

        vm.cancel = function () {
            $uibModalInstance.close();
        };

        vm.back = function() {
            var len = vm.dialogSubViewArr.length;
            if(vm.params.currentTplIndex == 1) {
                vm.params.isFirst = true;
            } else {
                vm.params.isLast = false;
            }
            vm.params.currentTplIndex -= 1;
        }
        
        vm.next = function() {
            var len = vm.dialogSubViewArr.length;
            if(vm.params.currentTplIndex + 1 == len) {
                $uibModalInstance.close();
            } else {
                vm.params.isFirst = false;
                if(vm.params.currentTplIndex + 2 == len) {
                    vm.params.isLast = true;
                }
                vm.params.currentTplIndex += 1;
            }
        }

        vm.formVerification = function() {
            var step = vm.params.isFirst ? 'step1' : (vm.params.isLast ? 'step3' : 'step2');
            step = vm.forms[step];
            var isAllNull = false;
            hasOwnAttr(step);
            function hasOwnAttr(step) {
                for(var key in step) {
                    if($.isPlainObject(step[key])) {
                        hasOwnAttr(step[key]);
                    }
                    if(!step[key] && key != 'areaName') {//精确到市 排除市的下一级 区名
                        isAllNull = true;
                    }
                }
            }
            if(vm.params.currentTplIndex == 1) {
                isAllNull = false;
            }
            return isAllNull;
        }

        vm.addEmails = function() {
            var len = vm.emailList.length;
            if(len == 5) {
                return;
            }
            vm.emailList.push('email' + len);
            vm.forms.step1.emails['email' + len] = undefined;
        }
        vm.removeEmail = function(index) {
            var eml = vm.emailList[index];
            vm.emailList.splice(index, 1);
            delete vm.forms.step1.emails[eml];
        }

        vm.getCheckboxValArr = function(props) {
            var attr = [];
            for(var k in vm.checkBox[props]) {
                var val = vm.checkBox[props][k];
                if(val) {
                    attr.push(val);
                }
            }
            vm.forms.step2[props] = attr.length > 0 ? attr.join(';') : undefined;
        }
        
        vm.addTestDetails = function() {
            var len = vm.testDetailList.length;
            vm.testDetailList.push(len);
            vm.engineRecomm['test'+len] = {screenshotpos: undefined};
        }
        vm.removeTestDetails = function(index) {
            var tl = vm.testDetailList[index];
            vm.testDetailList.splice(index, 1);
            delete vm.engineRecomm['test'+tl];
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('changeTelDialog', changeTelDialog);


  function changeTelDialog($scope, $uibModalInstance, changeTelDialogData, Resource) {
    var vm = $scope;
    vm.tel = angular.copy(changeTelDialogData);
    var Personal = Resource.Common.Personal;

    vm.update = function () {
      Personal.update(vm.tel, function () {
        successTip('修改成功');
      }, function (data) {
        errorTip(data.data.message);
      });
      $uibModalInstance.close();
    };

    vm.close = function () {
      $uibModalInstance.close();
    };

  }
})();
(function () {
  'use strict';
  /**
   * ------------------------------------------------------------------
   * 系统管理/人工审核
   * ------------------------------------------------------------------
   */

  angular
    .module('app')
    .controller('textReview.manualReview', textReviewManualReview);

  textReviewManualReview.$inject = ['ngTableParams', '$scope', '$uibModal', 'Resource', '$filter', 'calcDateService'];

  function textReviewManualReview(ngTableParams, $scope, $uibModal, Resource, $filter, calcDateService) {
    var vm = $scope;
    // API
    var AdminAuditList = Resource.TextReview.AdminAuditList;
    var AdminFeedback = Resource.TextReview.AdminFeedbackItem;
    var AdminFeedbackList = Resource.TextReview.AdminFeedbackList
    // 审核类型
    vm.auditType = [{
      name: '广告评论',
      value: 'ad',
      modelName: 'is_ad',
      radio: [{
        text: '广告评论（0.5-1）',
        value: '{start: 500, end: 1000}'
      }, {
        text: '正常文本（0-0.5）',
        value: '{start: 0, end: 499}'
      }]
    }, {
      name: '低质量文本',
      value: 'nonsense',
      modelName: 'is_nonsense',
      radio: [{
        text: '低质量文本（0.5-1）',
        value: '{start: 500, end: 1000}'
      }, {
        text: '正常文本（0-0.5）',
        value: '{start: 0, end: 499}'
      }]
    }, {
      name: '涉黄文本',
      value: 'porn',
      modelName: 'is_porn',
      radio: [{
        text: '涉黄文本（0.75-1）',
        value: '{start: 750, end: 1000}'
      }, {
        text: '轻微涉黄文本（0.5-0.75）',
        value: '{start: 500, end: 749}'
      }, {
        text: '正常文本（0-0.5）',
        value: '{start: 0, end: 499}'
      }]
    }, {
      name: '涉政文本',
      value: 'politic',
      modelName: 'is_politic',
      radio: [{
        text: '涉政文本（0.75-1）',
        value: '{start: 750, end: 1000}'
      }, {
        text: '轻微涉政文本（0.5-0.75）',
        value: '{start: 500, end: 749}'
      }, {
        text: '正常文本（0-0.5）',
        value: '{start: 0, end: 499}'
      }]
    }, {
      name: '反动文本',
      value: 'reaction',
      modelName: 'is_reaction',
      radio: [{
        text: '反动文本（0.75-1）',
        value: '{start: 750, end: 1000}'
      }, {
        text: '轻微反动文本（0.5-0.75）',
        value: '{start: 500, end: 749}'
      }, {
        text: '正常文本（0-0.5）',
        value: '{start: 0, end: 499}'
      }]
    }];

    // 翻页器初始数据
    var pageParams = {
      number: 10,
      chartNumber: 100
    };

    // 排序类别
    vm.sortItem = 'timestamp';
    // 排序顺序
    vm.reverse = 1;
    // 最大搜索日期
    vm.maxDate = calcDateService.basedToday(0);
    // 默认搜索参数
    vm.query_params = {
      is_ad: {
        start: 0,
        end: 1000
      },
      is_nonsense: {
        start: 0,
        end: 1000
      },
      is_porn: {
        start: 0,
        end: 1000
      },
      is_politic: {
        start: 0,
        end: 1000
      },
      is_reaction: {
        start: 0,
        end: 1000
      },
      date: {
        start: calcDateService.basedToday(-7),
        end: calcDateService.basedToday(-1),
      },
    };

    // 默认审核类型
    vm.auditTypeSelect = 'ad';
    // 默认搜索类型
    vm.searchTypeSelect = 'id';

    vm.feedback_data = [];
    vm.total_num = 0;
    vm.tableParams = new ngTableParams({
      page: 1,
      count: pageParams.number
    }, {
        total: 0,
        getData: function ($defer, params) {
          var params_ = params.url();
          var start = (params_.page - 1) * pageParams.number;
          var number = pageParams.number;
          var randerTable = function (data) {
            if (angular.isNumber(data.ret_number)) {
              vm.total_num = data.ret_number;
            }
            params.total(data.ret_number);
            $defer.resolve(data.ret_list);
            angular.forEach(data.ret_list, function (item) {
              var d = new Date(item.timestamp * 1000);
              item.timestr = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            });
            vm.feedback_data = $filter('orderBy')(data.ret_list, '-num_used');
          };
          var pushData = function (data) {
            var newData = angular.extend({}, data, {
              number: number,
              start: start,
              query: vm.keyword ? vm.keyword : null,
              start_date: vm.query_params.date.start + ' 00:00:00',
              end_date: vm.query_params.date.end + ' 23:59:59',
              sort: vm.sortItem,
              q_appname: vm.appName ? vm.appName : null,
              reverse: !!vm.sortItem ? vm.reverse : null,
              userFeedback: vm.userFeedback,
              nlp_type: vm.auditTypeSelect
            });
            if (vm.sortItem == 'timestamp') {
              newData.reverse = 1;
            }
            if (vm.auditTypeSelect === 'ad' || vm.auditTypeSelect === 'nonsense') {
              newData.search_type = 'comment';
            } else {
              newData.search_type = 'audit';
            }
            newData['weight_start'] = vm.query_params['is_' + vm.auditTypeSelect].start;
            newData['weight_end'] = vm.query_params['is_' + vm.auditTypeSelect].end;

            delete newData.is_ad;
            delete newData.is_nonsense;
            return newData;
          };

          vm.queryParams = pushData({});

          if (vm.searchByWeight) {
            getWeightQueryParams();
          }

          AdminAuditList.get(vm.queryParams, function (data) {
            randerTable(data);
            vm.total = data.ret_number;
          });
        }
      });

    // 切换排序项目
    // vm.changeSortState = function (idx) {
    //   var sortList = ['weight_ad', 'weight_nonsense', 'porn', 'politic', 'reaction'];
    //   if (vm.sortItem != sortList[idx]) {
    //     vm.sortItem = sortList[idx];
    //     vm.reverse = 1;
    //   } else if (vm.reverse == 0) {
    //     vm.sortItem = 'timestamp';
    //   } else {
    //     vm.reverse = 1 - vm.reverse;
    //   }
    //   vm.query();
    // };

    // 搜索
    vm.query = function () {
      if (vm.weightEnd || vm.weightStart) {
        vm.queryByWeight();
        return;
      }
      vm.tableParams.page(1);
      vm.tableParams.reload();
    };

    // 清除权重
    vm.clearWeight = function () {
      vm.weightEnd = null;
      vm.weightStart = null;
      vm.searchByWeight = false;
    };

    vm.watchWeight = function (key) {
      vm[key] = vm[key].replace(/[^0-9.]/g, '');
      var number = vm[key].substr(2);
      if (vm[key] !== null && vm[key].length <= 2 && vm[key] != '0') {
        if (vm[key].substr(0, 1) == '0') {
          if (vm[key] == '0.') {
            vm[key] = '0';
          } else {
            vm[key] = ['0.', vm[key].replace('0', '')].join('');
          }
        } else if (vm[key].length >= 1) {
          vm[key] = ['0.', vm[key]].join('');
        }
      } else if (vm[key] == '0.' || vm[key] == '0') {
        vm[key] = '0';
      } else if (vm[key].length > 2 && vm[key].length < 6) {
        vm[key] = '0.' + number.replace(/[.]/g, '');
      } else if (vm[key].length === 6) {
        vm[key] = vm[key].substr(0, 5);
      }
    };

    // 列表中依据数值显示对应文本
    vm.showText = function (number) {
      switch (vm.auditTypeSelect) {
        case 'ad':
          return number > 0.499 ? '广告评论' : '正常文本';
          break;
        case 'nonsense':
          return number > 0.499 ? '低质量文本' : '正常文本';
          break;
        case 'porn':
          if (number > 0.749) {
            return '涉黄文本'
          } else if (number < 0.5) {
            return '正常文本'
          } else {
            return '轻微涉黄文本'
          }
          break;
        case 'politic':
          if (number > 0.749) {
            return '涉政文本'
          } else if (number < 0.5) {
            return '正常文本'
          } else {
            return '轻微涉政文本'
          }
          break;
        case 'reaction':
          if (number > 0.749) {
            return '反动文本'
          } else if (number < 0.5) {
            return '正常文本'
          } else {
            return '轻微反动文本'
          }
          break;
      }
    };

    vm.showNumber = function (number) {
      if (number) {
        return '(' + number.toString().substr(0, 5) + ')';
      } else {
        return '(0.000)';
      }
    };
    // 按照自定义权重搜索
    vm.queryByWeight = function () {
      vm.clearRadioValue();
      // 自定义权重参数都为空
      if (!vm.weightStart && !vm.weightEnd) {
        warningTip('请输入正确的数值');
        return;
      }
      vm.weightStart = !vm.weightStart ? 0 : vm.weightStart;
      vm.weightEnd = !vm.weightEnd ? 0 : vm.weightEnd;
      vm.searchByWeight = true;
      vm.tableParams.page(1);
      vm.tableParams.reload();
    };

    // 清除排序项目
    // vm.cleanSort = function () {
    //   vm.sortItem = 'timestamp';
    // };

    // 获取权重
    var getWeightQueryParams = function () {
      var start = handleWeight(vm.weightStart);
      var end = handleWeight(vm.weightEnd);
      var getWeightStart = function () {
        return start < end ? start : end;
      };
      var getWeightEnd = function () {
        return end < start ? start : end;
      };
      vm.queryParams.weight_start = getWeightStart();
      vm.queryParams.weight_end = getWeightEnd();
    };

    // 重置所有 raido 数据
    vm.clearRadioValue = function () {
      angular.forEach(vm.auditType, function (value) {
        vm.query_params['is_' + value.value] = {
          start: 0,
          end: 1000
        };
      });
    };

    // 权重补零
    var handleWeight = function (number) {
      var number = number.toString().substr(2);
      var numberLength = number.toString().length;
      var fullLength = 3;
      if (numberLength !== fullLength && number !== 0) {
        var string = new Array(fullLength - numberLength + 1).join('0')
        var number = number + string.toString();
      }
      return Number(number);
    };

    vm.what = function (index, auditTypeSelect) {
      var changeFeedbackModalInstance = $uibModal.open({
        'animation': true,
        'templateUrl': 'change_junk_feedback_dialog',
        'controller': 'manualReviewEditor',
        'resolve': {
          select_data: function () {
            return {
              'content': vm.feedback_data[index].content,
              'is_ad': vm.feedback_data[index].user_feedback_info ? vm.feedback_data[index].user_feedback_info.is_ad : null,
              'is_nonsense': vm.feedback_data[index].user_feedback_info ? vm.feedback_data[index].user_feedback_info.is_nonsense : null,
              'is_reaction': $scope.feedback_data[index].user_feedback_info ? $scope.feedback_data[index].user_feedback_info.is_reaction : null,
              'is_porn': $scope.feedback_data[index].user_feedback_info ? $scope.feedback_data[index].user_feedback_info.is_porn : null,
              'is_politic': $scope.feedback_data[index].user_feedback_info ? $scope.feedback_data[index].user_feedback_info.is_politic : null,
              auditTypeSelect: auditTypeSelect
            };
          }
        }
      });

      changeFeedbackModalInstance.result.then(function (data) {
        var defaultParam = {
          nlp_type: data.nlpType,
          appid: vm.feedback_data[index].appid,
          content: vm.feedback_data[index].content,
          requestid: vm.feedback_data[index].request_id,
          title: vm.feedback_data[index].title,
          user: vm.feedback_data[index].user,
          textid: vm.feedback_data[index].textid,
          origin_static_info: {},
          user_feedback_info: {}
        };
        var isKey = 'is_' + vm.auditTypeSelect;
        if (vm.auditTypeSelect === 'ad' || vm.auditTypeSelect === 'nonsense') {
          defaultParam.origin_static_info[isKey] = vm.feedback_data[index][isKey];
          defaultParam.origin_static_info['weight_' + vm.auditTypeSelect] = vm.feedback_data[index].result['weight_' + vm.auditTypeSelect];
          defaultParam.user_feedback_info[isKey] = data[isKey];
        } else {
          defaultParam.origin_static_info[isKey] = vm.feedback_data[index][isKey];
          defaultParam.origin_static_info[vm.auditTypeSelect] = vm.feedback_data[index].result[vm.auditTypeSelect];
          defaultParam.user_feedback_info[isKey] = data[isKey];
        }
        if (vm.feedback_data[index].nlp_feedbackid == null) {
          AdminFeedbackList.save(defaultParam, function (data) {
            vm.feedback_data[index].user_feedback_info = data.user_feedback_info;
            vm.feedback_data[index].nlp_feedbackid = data.nlp_feedbackid;
          }, function (data) {
            alert(data.data.message);
          });
        } else {
          defaultParam.nlp_feedbackid = vm.feedback_data[index].nlp_feedbackid;
          AdminFeedback.update({ primaryKey: defaultParam.nlp_feedbackid }, defaultParam, function (data) {
            vm.feedback_data[index].user_feedback_info = data.user_feedback_info;
          }, function (data) {
            alert(data.data.message);
          });
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('textReview.feedback', textReviewFeedback);

  textReviewFeedback.$inject = ['ngTableParams', '$scope', 'Resource', 'calcDateService'];

  function textReviewFeedback(ngTableParams, $scope, Resource, calcDateService) {
    var vm = $scope;
    var AdminFeedbacksList = Resource.TextReview.AdminFeedbackList;
    // DATA
    vm.data = {
      // 审核类型
      reviewTypeList: [{
        value: 'ad',
        name: '广告评论'
      }, {
        value: 'nonsense',
        name: '低质量文本'
      }, {
        value: 'porn',
        name: '涉黄文本'
      }, {
        value: 'politic',
        name: '涉政文本'
      }, {
        value: 'reaction',
        name: '反动文本'
      }],
      // 默认审核类型
      reviewTypeSelected: 'ad',
      // 反馈类型
      feedbackTypeList: [{
        value: 1,
        name: '用户反馈'
      }, {
        value: 0,
        name: '内部审核反馈'
      }],
      feedbackTypeSelected: 1
    };


    // ALL REQUEST PARAMS
    vm.params = {
      // 翻页器初始数据
      page: {
        number: 10,
        start: 0
      },
      maxDate: calcDateService.basedToday(0),
      sortItem: 'timestamp',
      reverse: 1,
      date: {
        start: calcDateService.basedToday(-7) + ' 00:00:00',
        end: calcDateService.basedToday(-1) + ' 23:59:59'
      }
    };

    vm.tableParams = new ngTableParams({
      page: 1,
      count: vm.params.page.number
    }, {
      getData: function ($defer, params) {
        var pageParams = params.url();
        var param = {
          start_date: vm.params.date.start,
          end_date: vm.params.date.end,
          nlp_type: vm.data.reviewTypeSelected,
          feedback_type: vm.data.feedbackTypeSelected,
          start: (pageParams.page - 1) * vm.params.page.number,
          number: vm.params.page.number
        };
        AdminFeedbacksList.get(param, function (data) {
          $defer.resolve(data.ret_list);
          params.total(data.ret_number);
          vm.total = data.ret_number;
        })
      }
    });
    // ALL METHOD
    vm.method = {
      // 搜索
      query: function () {
        vm.tableParams.page(1);
        vm.tableParams.reload();
      },
      showNumber: function (number) {
        if (number == null) {
          return '(0.000)'
        } else if (number == undefined) {
          return;
        }

        function addZero(number) {
          var number = number.toString();
          if (number.length < 6) {
            for (var i = 1; i < 6 - number.length;) {
              number += '0';
            }
            return number;
          }
        }

        if (number) {
          if (number.toString().indexOf('.') > -1) {
            return '(' + addZero(number.toString().substr(0, 5)) + ')';
          } else if (number == 1 || number == '1.000') {
            return '(1.000)'
          } else {
            return '(' + addZero((number / 1000).toString().substr(0, 5)) + ')';
          }
        } else if (number == undefined) {
          return '';
        } else {
          return '(0.000)';
        }
      },
      // 列表中依据数值显示对应文本
      showText: function (number) {
        if (number === undefined) {
          return;
        }
        if (number == null) {
          return '正常文本';
        }
        var time = number.toString().indexOf('.') > -1 ?  1000 : 1;
        var number = Number(number);
        switch (vm.data.reviewTypeSelected) {
          case 'ad':
            return number > (499 / time) ? '广告评论' : '正常文本';
            break;
          case 'nonsense':
            return number > (499 / time) ? '低质量文本' : '正常文本';
            break;
          case 'porn':
            if (number > (749 / time)) {
              return '涉黄文本'
            } else if (number < (500 / time)) {
              return '正常文本'
            } else {
              return '轻微涉黄文本'
            }
            break;
          case 'politic':
            if (number > (749 / time)) {
              return '涉政文本'
            } else if (number < (500 / time)) {
              return '正常文本'
            } else {
              return '轻微涉政文本'
            }
            break;
          case 'reaction':
            if (number > (749 / time)) {
              return '反动文本'
            } else if (number < (500 / time)) {
              return '正常文本'
            } else {
              return '轻微反动文本'
            }
            break;
        }
      }
    };
  }

})();

(function () {
    angular
      .module('app')
      .controller('strategyPerformanceStatistics.wholeTimeProcess', strategyPerformanceStatisticsWholeTimeProcessCtrl);
      strategyPerformanceStatisticsWholeTimeProcessCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
  
    function strategyPerformanceStatisticsWholeTimeProcessCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
      var vm = $scope;
      var AppnameReflectRes = Resource.Order.AppnameReflect;
      var TimeWholeProcessRes = Resource.PerformanceStrategy.TimeWholeProcess;
  
      vm.appReflect = [];
      vm.tableInited = false; //初始化
      
      vm.query = {
          start_time: undefined,
          end_time: undefined,
          sort: undefined,
          reverse: undefined
      }
      vm.params = {
          lineState: 'nearline'
      }

      vm.filterDate = {
        start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
        end: calcDateService.basedDate(new Date(), 0)
      };

      AppnameReflectRes.get({}, function (data) {
          angular.forEach(data.appid, function (val, key) {
              vm.appReflect.push({
                  appid: key,
                  appname: val.app_name
              });
          });
      });

      vm.update = function () {

          if (!vm.tableInited) {
              tableInit();
              vm.tableInited = true;
          } else {
              vm.ngTableParams.page(1);
              vm.ngTableParams.reload();
          }
      }

      function tableInit() {
          vm.ngTableParams = new ngTableParams({
              page: 1,
              count: 10
          }, {
              getData: function ($defer, params) {
                  var pageParams = {
                      start: (params.page() - 1) * params.count(),
                      number: params.count()
                  };
                  vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                  var key = Object.values(params.sorting())[0];
                  if (key) {
                      vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                  }
                  //日期
                  vm.query.start_time = vm.filterDate.start;
                  vm.query.end_time = vm.filterDate.end;
                  vm.query.type = vm.params.lineState;
                  var req = angular.extend({}, pageParams, vm.query);
                  TimeWholeProcessRes.get(req, function (data) { //需要更改
                      params.total(data.total);
                      $defer.resolve(data.items.map(function(item) {
                          item.line = vm.params.lineState;
                          return item;
                      }));
                  });
              }
          });
      }

      function getDateStr(date, isFull) {
          var dateStr, year = date.getFullYear(),
              month = date.getMonth() + 1,
              days = date.getDate(),
              hours = date.getHours(),
              minutes = date.getMinutes(),
              seconds = date.getSeconds();
          if (!date) {
              return "";
          }

          dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
          if (isFull) {
              dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
          }
          return dateStr;
      }

      function formatDateNum(num) {
          if (num / 10 < 1) {
              return '0' + num;
          } else {
              return num.toString()
          }
      }

      vm.changeDateWord = function (date) {
          if (date) {
              return date.substring(0, 10);
          }
      }
      //init data
      tableInit();
      vm.tableInited = true;
  
    }
  })();
  
  
(function () {
    angular
        .module('app')
        .controller('strategyPerformanceStatistics.hourlyWhole', strategyPerformanceStatisticsHourlyWholeCtrl);
        strategyPerformanceStatisticsHourlyWholeCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];

    function strategyPerformanceStatisticsHourlyWholeCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var HourlyWholeListRes = Resource.PerformanceStrategy.HourlyWholeList;
        vm.appReflect = [];
        vm.tableInited = false; //初始化
        
        vm.query = {
            appid: undefined,
            hour: undefined,
            start_time: undefined,
            end_time: undefined,
            sort: undefined,
            reverse: undefined
        }
        vm.params = {
            appInfo: undefined,
            hour_ori: undefined,
            lineState: 'nearline'
        }

        vm.filterDate = {
            start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
            end: calcDateService.basedDate(new Date(), 0)
        };

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });

        vm.search = function () {

            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                if (vm.params.hour_ori) {
                    if (vm.params.hour_ori.length == 1) {
                        vm.query.hour = '0' + vm.params.hour_ori;
                    } else {
                        vm.query.hour = vm.params.hour_ori;
                    }
                }
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                    var key = Object.values(params.sorting())[0];
                    if (key) {
                        vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                    }
                    //日期
                    vm.query.start_time = vm.filterDate.start;
                    vm.query.end_time = vm.filterDate.end;
                    vm.query.type = vm.params.lineState;
                    vm.query.appid = undefined;
                    if (vm.params.appInfo) {
                        vm.query.appid = vm.params.appInfo.appid;
                    }
                    var req = angular.extend({}, pageParams, vm.query);
                    HourlyWholeListRes.get(req, function (data) { //需要更改
                        params.total(data.total);
                        $defer.resolve(data.items.map(function(item) {
                            item.line = vm.params.lineState;
                            return item;
                        }));
                    });
                }
            });
        }

        vm.reset = function () {
            vm.query = {
                appid: undefined,
                hour: undefined,
                start_time: undefined,
                end_time: undefined,
                sort: undefined,
                reverse: undefined
            }

            vm.params.appInfo = undefined;
            vm.params.hour_ori = undefined;
            
            //刷新数据
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }

        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }


        //初始化数据
        tableInit();
        vm.tableInited = true;

    }
})();
(function () {
    angular
        .module('app')
        .controller('strategyPerformanceStatistics.hourlyApp', strategyPerformanceStatisticsHourlyCtrl);
        strategyPerformanceStatisticsHourlyCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];

    function strategyPerformanceStatisticsHourlyCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var HourlyListRes = Resource.PerformanceStrategy.HourlyList;
        vm.appReflect = [];
        vm.tableInited = false; //初始化
        
        vm.query = {
            appid: undefined,
            hour: undefined,
            start_time: undefined,
            end_time: undefined,
            sort: undefined,
            reverse: undefined
        }
        vm.params = {
            appInfo: undefined,
            hour_ori: undefined,
            lineState: 'nearline'
        }

        vm.filterDate = {
            start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
            end: calcDateService.basedDate(new Date(), 0)
        };

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });

        vm.search = function () {

            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                if (vm.params.hour_ori) {
                    if (vm.params.hour_ori.length == 1) {
                        vm.query.hour = '0' + vm.params.hour_ori;
                    } else {
                        vm.query.hour = vm.params.hour_ori;
                    }
                }
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                    var key = Object.values(params.sorting())[0];
                    if (key) {
                        vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                    }
                    //日期
                    vm.query.start_time = vm.filterDate.start;
                    vm.query.end_time = vm.filterDate.end;
                    vm.query.type = vm.params.lineState;
                    vm.query.appid = undefined;
                    if (vm.params.appInfo) {
                        vm.query.appid = vm.params.appInfo.appid;
                    }
                    var req = angular.extend({}, pageParams, vm.query);
                    HourlyListRes.get(req, function (data) { //需要更改
                        params.total(data.total);
                        $defer.resolve(data.items.map(function(item) {
                            item.line = vm.params.lineState;
                            return item;
                        }));
                    });
                }
            });
        }

        vm.reset = function () {
            vm.query = {
                appid: undefined,
                hour: undefined,
                start_time: undefined,
                end_time: undefined,
                sort: undefined,
                reverse: undefined
            }

            vm.params.appInfo = undefined;
            vm.params.hour_ori = undefined;
            
            //刷新数据
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }


        //初始化数据
        tableInit();
        vm.tableInited = true;

    }
})();
(function () {
    angular
      .module('app')
      .controller('strategyPerformanceStatistics.dayWhole', strategyPerformanceStatisticsDayWholeWholeCtrl);
      strategyPerformanceStatisticsDayWholeWholeCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
  
    function strategyPerformanceStatisticsDayWholeWholeCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
      var vm = $scope;
      var AppnameReflectRes = Resource.Order.AppnameReflect;
      var DayWholeListRes = Resource.PerformanceStrategy.DayWholeList;
  
      vm.appReflect = [];
      vm.tableInited = false; //初始化
      
      vm.query = {
          start_time: undefined,
          end_time: undefined,
          sort: undefined,
          reverse: undefined
      }
      vm.params = {
          lineState: 'nearline'
      }

      vm.filterDate = {
        start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
        end: calcDateService.basedDate(new Date(), 0)
      };

      AppnameReflectRes.get({}, function (data) {
          angular.forEach(data.appid, function (val, key) {
              vm.appReflect.push({
                  appid: key,
                  appname: val.app_name
              });
          });
      });

      vm.update = function () {

          if (!vm.tableInited) {
              tableInit();
              vm.tableInited = true;
          } else {
              vm.ngTableParams.page(1);
              vm.ngTableParams.reload();
          }
      }

      function tableInit() {
          vm.ngTableParams = new ngTableParams({
              page: 1,
              count: 10
          }, {
              getData: function ($defer, params) {
                  var pageParams = {
                      start: (params.page() - 1) * params.count(),
                      number: params.count()
                  };
                  vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                  var key = Object.values(params.sorting())[0];
                  if (key) {
                      vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                  }
                  //日期
                  vm.query.start_time = vm.filterDate.start;
                  vm.query.end_time = vm.filterDate.end;
                  vm.query.type = vm.params.lineState;
                  var req = angular.extend({}, pageParams, vm.query);
                  DayWholeListRes.get(req, function (data) { //需要更改
                      params.total(data.total);
                      $defer.resolve(data.items.map(function(item) {
                          item.line = vm.params.lineState;
                          return item;
                      }));
                  });
              }
          });
      }

      function getDateStr(date, isFull) {
          var dateStr, year = date.getFullYear(),
              month = date.getMonth() + 1,
              days = date.getDate(),
              hours = date.getHours(),
              minutes = date.getMinutes(),
              seconds = date.getSeconds();
          if (!date) {
              return "";
          }

          dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
          if (isFull) {
              dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
          }
          return dateStr;
      }

      function formatDateNum(num) {
          if (num / 10 < 1) {
              return '0' + num;
          } else {
              return num.toString()
          }
      }

      vm.changeDateWord = function (date) {
          if (date) {
              return date.substring(0, 10);
          }
      }
      //init data
      tableInit();
      vm.tableInited = true;
  
    }
  })();
  
  
(function () {
    angular
      .module('app')
      .controller('strategyPerformanceStatistics.dayApp', strategyPerformanceStatisticsDayCtrl);
      strategyPerformanceStatisticsDayCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
  
    function strategyPerformanceStatisticsDayCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
      var vm = $scope;
      var AppnameReflectRes = Resource.Order.AppnameReflect;
      var DayListRes = Resource.PerformanceStrategy.DayList;
  
      vm.appReflect = [];
      vm.tableInited = false; //初始化
      
      vm.query = {
          appid: undefined,
          start_time: undefined,
          end_time: undefined,
          sort: undefined,
          reverse: undefined
      }
      vm.params = {
          appInfo: undefined,
          lineState: 'nearline'
      }

      vm.filterDate = {
        start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
        end: calcDateService.basedDate(new Date(), 0)
      };

      AppnameReflectRes.get({}, function (data) {
          angular.forEach(data.appid, function (val, key) {
              vm.appReflect.push({
                  appid: key,
                  appname: val.app_name
              });
          });
      });

      vm.search = function () {

          if (!vm.tableInited) {
              tableInit();
              vm.tableInited = true;
          } else {
              vm.ngTableParams.page(1);
              vm.ngTableParams.reload();
          }
      }

      function tableInit() {
          vm.ngTableParams = new ngTableParams({
              page: 1,
              count: 10
          }, {
              getData: function ($defer, params) {
                  var pageParams = {
                      start: (params.page() - 1) * params.count(),
                      number: params.count()
                  };
                  vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                  var key = Object.values(params.sorting())[0];
                  if (key) {
                      vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                  }
                  //日期
                  vm.query.start_time = vm.filterDate.start;
                  vm.query.end_time = vm.filterDate.end;
                  vm.query.type = vm.params.lineState;
                  vm.query.appid = undefined;
                  if (vm.params.appInfo) {
                      vm.query.appid = vm.params.appInfo.appid;
                  }
                  var req = angular.extend({}, pageParams, vm.query);
                  DayListRes.get(req, function (data) { //需要更改
                      params.total(data.total);
                      $defer.resolve(data.items.map(function(item) {
                          item.line = vm.params.lineState;
                          return item;
                      }));
                  });
              }
          });
      }
      vm.reset = function () {
          vm.query = {
              appid: undefined,
              start_time: undefined,
              end_time: undefined,
              sort: undefined,
              reverse: undefined
          }

          vm.params.appInfo = undefined;
          
          //刷新数据
          if (!vm.tableInited) {
              tableInit();
              vm.tableInited = true;
          } else {
              vm.ngTableParams.page(1);
              vm.ngTableParams.reload();
          }

      }

      function getDateStr(date, isFull) {
          var dateStr, year = date.getFullYear(),
              month = date.getMonth() + 1,
              days = date.getDate(),
              hours = date.getHours(),
              minutes = date.getMinutes(),
              seconds = date.getSeconds();
          if (!date) {
              return "";
          }

          dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
          if (isFull) {
              dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
          }
          return dateStr;
      }

      function formatDateNum(num) {
          if (num / 10 < 1) {
              return '0' + num;
          } else {
              return num.toString()
          }
      }

      vm.changeDateWord = function (date) {
          if (date) {
              return date.substring(0, 10);
          }
      }
      //init data
      tableInit();
      vm.tableInited = true;
  
    }
  })();
  
  
(function () {
    angular
      .module('app')
      .controller('strategyPerformanceStatistics.appTimeProcess', strategyPerformanceStatisticsAppTimeProcessCtrl);
      strategyPerformanceStatisticsAppTimeProcessCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
  
    function strategyPerformanceStatisticsAppTimeProcessCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
      var vm = $scope;
      var AppnameReflectRes = Resource.Order.AppnameReflect;
      var TimeProcessRes = Resource.PerformanceStrategy.TimeProcess;
  
      vm.appReflect = [];
      vm.tableInited = false; //初始化
      
      vm.query = {
          appid: undefined,
          start_time: undefined,
          end_time: undefined,
          sort: undefined,
          reverse: undefined
      }
      vm.params = {
          appInfo: undefined,
          lineState: 'nearline'
      }

      vm.filterDate = {
        start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
        end: calcDateService.basedDate(new Date(), 0)
      };

      AppnameReflectRes.get({}, function (data) {
          angular.forEach(data.appid, function (val, key) {
              vm.appReflect.push({
                  appid: key,
                  appname: val.app_name
              });
          });
      });

      vm.search = function () {

          if (!vm.tableInited) {
              tableInit();
              vm.tableInited = true;
          } else {
              vm.ngTableParams.page(1);
              vm.ngTableParams.reload();
          }
      }

      function tableInit() {
          vm.ngTableParams = new ngTableParams({
              page: 1,
              count: 10
          }, {
              getData: function ($defer, params) {
                  var pageParams = {
                      start: (params.page() - 1) * params.count(),
                      number: params.count()
                  };
                  vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                  var key = Object.values(params.sorting())[0];
                  if (key) {
                      vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                  }
                  //日期
                  vm.query.start_time = vm.filterDate.start;
                  vm.query.end_time = vm.filterDate.end;
                  vm.query.type = vm.params.lineState;
                  vm.query.appid = undefined;
                  if (vm.params.appInfo) {
                      vm.query.appid = vm.params.appInfo.appid;
                  }
                  var req = angular.extend({}, pageParams, vm.query);
                  TimeProcessRes.get(req, function (data) { //需要更改
                      params.total(data.total);
                      $defer.resolve(data.items.map(function(item) {
                          item.line = vm.params.lineState;
                          return item;
                      }));
                  });
              }
          });
      }
      vm.reset = function () {
          vm.query = {
              appid: undefined,
              start_time: undefined,
              end_time: undefined,
              sort: undefined,
              reverse: undefined
          }

          vm.params.appInfo = undefined;
          
          //刷新数据
          if (!vm.tableInited) {
              tableInit();
              vm.tableInited = true;
          } else {
              vm.ngTableParams.page(1);
              vm.ngTableParams.reload();
          }

      }

      function getDateStr(date, isFull) {
          var dateStr, year = date.getFullYear(),
              month = date.getMonth() + 1,
              days = date.getDate(),
              hours = date.getHours(),
              minutes = date.getMinutes(),
              seconds = date.getSeconds();
          if (!date) {
              return "";
          }

          dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
          if (isFull) {
              dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
          }
          return dateStr;
      }

      function formatDateNum(num) {
          if (num / 10 < 1) {
              return '0' + num;
          } else {
              return num.toString()
          }
      }

      vm.changeDateWord = function (date) {
          if (date) {
              return date.substring(0, 10);
          }
      }
      //init data
      tableInit();
      vm.tableInited = true;
  
    }
  })();
  
  
(function () {
  angular
    .module('app')
    .controller('strategyEffectStatistics.whiteList', strategyEffectStatisticsWhiteListCtrl);
  strategyEffectStatisticsWhiteListCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
  function strategyEffectStatisticsWhiteListCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
    var vm = $scope;
    var AppnameReflectRes = Resource.Order.AppnameReflect;
    var WhiteListReq = Resource.RecStrategy.WhiteList;
    var AddWhiteyListReq = Resource.RecStrategy.AddWhite;
    var DelWhiteyListReq = Resource.RecStrategy.Delwhitelist;

    vm.appReflect = [];
    vm.tableInited = false; //初始化

    vm.search = {
      query: undefined
    }

    AppnameReflectRes.get({}, function (data) {
      angular.forEach(data.appid, function (val, key) {
        vm.appReflect.push({
          appid: key,
          appname: val.app_name
        });
      });
    });

    vm.searchMethod = function () {
      if (!vm.tableInited) {
        tableInit();
        vm.tableInited = true;
      } else {
        vm.ngTableParams.page(1);
        vm.ngTableParams.reload();
      }
    }


    function tableInit() {
      vm.ngTableParams = new ngTableParams({
        page: 1,
        count: 10
      }, {
          getData: function ($defer, params) {
            var pageParams = {
              start: (params.page() - 1) * params.count(),
              number: params.count()
            };

            var req = angular.extend({}, pageParams, vm.search);
            WhiteListReq.get(req, function (data) { //需要更改
              params.total(data.total);
              $defer.resolve(data.items);
            });
          }
        });
    }
    vm.add = function () {
      if (!vm.params.appInfo) {
        errorTip("appname不存在，请重新输入");
        return;
      }
      AddWhiteyListReq.create({
      }, { 'appid': vm.params.appInfo.appid }, function (data) {
        successTip(data.message);
        vm.reset();   //清空数据

        if (!vm.tableInited) {
          tableInit();
          vm.tableInited = true;
        } else {
          vm.ngTableParams.page(1);
          vm.ngTableParams.reload();
        }

      });
    }
    vm.reset = function () {
      vm.params = {
        appInfo: undefined
      }
    }
    vm.del = function (item) {

      warningTip('确定要删除该条数据吗？', function () {
        DelWhiteyListReq.delete({
          primaryKey: item.id
        }, {}, function (data) {
          successTip(data.message);
          vm.ngTableParams.page(1);
          vm.ngTableParams.reload();
        });
      });
    }
    vm.reset();
    vm.changeDateWord = function (date) {
      if (date) {
        return date.substring(0, 10);
      }
    }

    tableInit();
    vm.tableInited = true;

  }
})();
(function () {
    angular
        .module('app')
        .controller('strategyEffectStatistics.hourlyOverall', strategyEffectStatisticsHourlyOverallCtrl);
    strategyEffectStatisticsHourlyOverallCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
    function strategyEffectStatisticsHourlyOverallCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var HourlyOverallReq = Resource.RecStrategy.HourlyOverallList;

        vm.appReflect = [];
        vm.rec_type = [{ 'key': 'personal' }, { 'key': 'relate' }, { 'key': 'hot' }];
        vm.tableInited = false; //初始化  
        vm.query = {
            sort: undefined,
            appid: undefined,
            scene_type: undefined,
            rec_type: undefined,
            hour: undefined

        }
        vm.params = {
            appInfo: undefined,
            rec_type: undefined,
            hour_ori:undefined

        }
        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });
        vm.filterDate = {
            start: calcDateService.basedToday(0) + ' 00:00:00',
            end: calcDateService.basedToday(0) + ' 23:59:59'
        };

        vm.search = function () {
            // if (!vm.params.appInfo) {
            //     errorTip("appname不能为空");
            //     return;
            // }

            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {

                if (vm.params.hour_ori) {
                    if (vm.params.hour_ori.length == 1) {

                        
                        vm.query.hour='0' + vm.params.hour_ori;
    
                    } else {
                        vm.query.hour=vm.params.hour_ori;
                    }
                }
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                    getData: function ($defer, params) {
                        var pageParams = {
                            start: (params.page() - 1) * params.count(),
                            number: params.count()
                        };
                        vm.query.sort = Object.keys(params.sorting())[0];
                        var key = Object.values(params.sorting())[0];
                        if (key) {
                            vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                        }
                        //日期
                        vm.query.start_time = vm.filterDate.start;
                        vm.query.end_time = vm.filterDate.end;
                        vm.query.appid=undefined;
                        if (vm.params.appInfo) {
                            vm.query.appid = vm.params.appInfo.appid;
                        }
                        if (vm.params.rec_type) {
                            vm.query.rec_type = vm.params.rec_type.key;
                        }
                        var req = angular.extend({}, pageParams, vm.query);
                        HourlyOverallReq.get(req, function (data) {   //需要更改
                            vm.reverse = !vm.reverse; //排序标示更改
                            params.total(data.total);
                            $defer.resolve(data.items);
                        });
                    }
                });
        }
        vm.reset = function () {
            vm.query = {
                scene_type: undefined,
                hour: undefined,
                rec_type:undefined,
                appid:undefined
            }

            vm.params = {
                appInfo: undefined,
                rec_type: undefined,
                hour_ori:undefined

            }
                //刷新数据
                if (!vm.tableInited) {
                    tableInit();
                    vm.tableInited = true;
                } else {
                    vm.ngTableParams.page(1);
                    vm.ngTableParams.reload();
                }

        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }
        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }
        //init data
        tableInit();
        vm.tableInited = true;

    }
})();



(function () {
    angular
        .module('app')
        .controller('strategyEffectStatistics.hourly', strategyEffectStatisticsHourlyCtrl);
    strategyEffectStatisticsHourlyCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];

    function strategyEffectStatisticsHourlyCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var RecStrategyReq = Resource.RecStrategy.HourlyList;

        vm.appReflect = [];
        vm.rec_type = [{
            'key': 'personal'
        }, {
            'key': 'relate'
        }, {
            'key': 'hot'
        }];
        vm.tableInited = false; //初始化
        vm.query = {
            sort: undefined,
            reverse: undefined,
            appid: undefined,
            scene_type: undefined,
            rec_type: undefined,
            alg_type: undefined,
            hour: undefined

        }
        vm.params = {
            appInfo: undefined,
            rec_type: undefined,
            hour_ori: undefined
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });
        vm.filterDate = {
            start: calcDateService.basedToday(0) + ' 00:00:00',
            end: calcDateService.basedToday(0) + ' 23:59:59'
        };

        vm.search = function () {
            // if (!vm.params.appInfo) {
            //     errorTip("appname不能为空");
            //     return;
            // }

            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                if (vm.params.hour_ori) {
                    if (vm.params.hour_ori.length == 1) {
                        vm.query.hour = '0' + vm.params.hour_ori;
                    } else {
                        vm.query.hour = vm.params.hour_ori;
                    }
                }
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                    var key = Object.values(params.sorting())[0];
                    if (key) {
                        vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                    }
                    //日期
                    vm.query.start_time = vm.filterDate.start;
                    vm.query.end_time = vm.filterDate.end;
                    vm.query.appid = undefined;
                    if (vm.params.appInfo) {
                        vm.query.appid = vm.params.appInfo.appid;
                    }
                    if (vm.params.rec_type) {
                        vm.query.rec_type = vm.params.rec_type.key;
                    }
                    var req = angular.extend({}, pageParams, vm.query);
                    RecStrategyReq.get(req, function (data) { //需要更改
                        params.total(data.total);
                        $defer.resolve(data.items);
                    });
                }
            });
        }
        vm.reset = function () {
            vm.query = {
                scene_type: undefined,
                alg_type: undefined,
                rec_type: undefined,
                hour: undefined,
                appid: undefined
            }

            vm.params = {
                appInfo: undefined,
                rec_type: undefined,
                hour_ori: undefined

            }
            //刷新数据
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }

        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }


        //初始化数据
        tableInit();
        vm.tableInited = true;



        //  vm.reset();
    }
})();
(function () {
  angular
    .module('app')
    .controller('strategyEffectStatistics.day', strategyEffectStatisticsDayCtrl);
  strategyEffectStatisticsDayCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];

  function strategyEffectStatisticsDayCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
    var vm = $scope;
    var AppnameReflectRes = Resource.Order.AppnameReflect;
    var DayListReq = Resource.RecStrategy.DayList;

    vm.appReflect = [];
    vm.rec_type = [{ 'key': 'personal' }, { 'key': 'relate' }, { 'key': 'hot' }];
    vm.tableInited = false; //初始化

    vm.query = {
      sort: undefined,
      appid: undefined,
      scene_type: undefined,
      rec_type: undefined,
      alg_type: undefined

    }

    AppnameReflectRes.get({}, function (data) {
      angular.forEach(data.appid, function (val, key) {
        vm.appReflect.push({
          appid: key,
          appname: val.app_name
        });
      });
    });
    vm.filterDate = {
      start: calcDateService.basedToday(-6) + ' 00:00:00',
      end: calcDateService.basedToday(0) + ' 23:59:59'
    };

    vm.search = function () {
      // if (!vm.params.appInfo) {
      //   errorTip("appname不能为空");
      //   return;
      // }



      if (!vm.tableInited) {
        tableInit();
        vm.tableInited = true;
      } else {
        vm.ngTableParams.page(1);
        vm.ngTableParams.reload();
      }
    }

    function tableInit() {
      vm.ngTableParams = new ngTableParams({
        page: 1,
        count: 10
      }, {
          getData: function ($defer, params) {
            var pageParams = {
              start: (params.page() - 1) * params.count(),
              number: params.count()
            };
            vm.query.sort = Object.keys(params.sorting())[0];
            var key = Object.values(params.sorting())[0];
            if (key) {
              vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
            }

            //日期
            vm.query.start_time = vm.filterDate.start;
            vm.query.end_time = vm.filterDate.end;
            vm.query.appid = undefined;
            if (vm.params.appInfo) {
              vm.query.appid = vm.params.appInfo.appid;
            }
            if (vm.params.rec_type) {
              vm.query.rec_type = vm.params.rec_type.key;
            }
            var req = angular.extend({}, pageParams, vm.query);
            DayListReq.get(req, function (data) {   //需要更改
              params.total(data.total);
              $defer.resolve(data.items);
            });
          }
        });
    }
    vm.reset = function () {
      vm.query = {
        scene_type: undefined,
        alg_type: undefined,
        appid: undefined,
        rec_type: undefined
      }

      vm.params = {
        appInfo: undefined,
        rec_type: undefined

      }
      //刷新数据
      if (!vm.tableInited) {
        tableInit();
        vm.tableInited = true;
      } else {
        vm.ngTableParams.page(1);
        vm.ngTableParams.reload();
      }


    }

    function getDateStr(date, isFull) {
      var dateStr, year = date.getFullYear(),
        month = date.getMonth() + 1,
        days = date.getDate(),
        hours = date.getHours(),
        minutes = date.getMinutes(),
        seconds = date.getSeconds();
      if (!date) {
        return "";
      }

      dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
      if (isFull) {
        dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
      }
      return dateStr;
    }

    function formatDateNum(num) {
      if (num / 10 < 1) {
        return '0' + num;
      } else {
        return num.toString()
      }
    }
    vm.changeDateWord = function (date) {
      if (date) {
        return date.substring(0, 10);
      }
    }
    //init data
    tableInit();
    vm.tableInited = true;

  }
})();


(function () {
  'use strict';
  angular
    .module('app')
    .controller('serviceAlarmDialog', serviceAlarmDialog);

  function serviceAlarmDialog($scope, Resource, dataService, $uibModalInstance, serviceAlarmDialogData) {
    var vm = $scope;
    vm.ALARM_STATUS_MAPPING = dataService.alarm_mapping.alarm_status;
    vm.ALARM_TYPE_MAPPING = dataService.alarm_mapping.alarm_type;
    vm.ALARM_API_MAPPING = dataService.alarm_mapping.alarm_api;
    var ServiceAlarmItem = Resource.ServiceAlarm.Item;
    var Config = Resource.Common.Reflect;
    Config.get(function (data) {
      vm.manager = data.manager_id;
    });
    vm.canEditReason = true;
    vm.isManager = serviceAlarmDialogData.isManager;
    vm.type = serviceAlarmDialogData.type;
    vm.handleHighLightString = function (string) {
      var highLightString = string.substring(string.indexOf('调用') + 2);
      var spanString = '<span class="ui-select-highlight">' + highLightString.substr(1) + '</span>';
      return string.replace(highLightString, '量' + spanString);
    };
    vm.legend = {review: '审核', detail: '详情', follow: '跟进'}[vm.type];
    var primaryKey = {
      primaryKey: serviceAlarmDialogData.id
    };
    ServiceAlarmItem.get(primaryKey, function (data) {
      vm.serviceAlarmItem = data;
      if (vm.type === 'follow' && vm.serviceAlarmItem.status === 0) {
        vm.serviceAlarmItem.status = 1;
      }
      if(vm.serviceAlarmItem.reason !== '') {
        vm.canEditReason = false;
      }
    });

    vm.updateStatus = function (status) {
      ServiceAlarmItem.update(primaryKey, {
        status: status
      }, function () {
        successTip('修改成功');
        vm.back(true)
      })
    };

    vm.cancel = function () {
      vm.back();
    };
    vm.statusList = [{
      status: 1,
      text: '跟进中'
    }, {
      status: 2,
      text: '已解决'
    }];
    vm.save = function () {
      if (vm.serviceAlarmItem.follow_detail.length === 0 && vm.serviceAlarmItem.status === 0) {
        vm.serviceAlarmItem.status = 1;
      }
      ServiceAlarmItem.update(primaryKey, {
        reason: vm.serviceAlarmItem.reason,
        follow_detail_reason: vm.serviceAlarmItem.detailReason,
        status: vm.serviceAlarmItem.status
      }, function () {
        successTip('修改成功');
        vm.back(true)
      })
    };

    vm.back = function (data) {
      data ? $uibModalInstance.close(data) : $uibModalInstance.close();
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('searchConfig.item', searchConfigItem);

  function searchConfigItem($scope, Resource, $stateParams, $state, $uibModal) {
    var vm = $scope;
    var SearchConfigItem = Resource.SearchConfig.Item;
    var SearchList = Resource.SearchConfig.List;
    var SearchIndexItem = Resource.SearchConfig.SearchIndexConfigItem;
    vm.PARENT_STATE = 'searchConfig';
    vm.FIELDS_LIST = ['index_fields', 'return_fields', 'suggest_fields'];
    vm.id = $stateParams.id;
    vm.isCreate = !$stateParams.id;
    vm.item = vm.tmp = {};

    vm.FIELDS_LIST.map(function (t) {
      vm.tmp[t] = '';
      vm.item[t] = [];
    });

    function init() {
      if (vm.id) {
        SearchConfigItem.get({primaryKey: vm.id}, function (data) {
          vm.item = data;
        }, function (error) {
          errorTip(error);
        });
      }
    }


    vm.removeItem = function (name) {
      SearchIndexItem.delete({
        id: vm.id,
        name: name
      }, function (data) {
        successTip(data.message);
        $state.reload();
      }, function (data) {
        errorTip(data.message);
      });
    };

    vm.checkDisabledClass = function (keyword) {
      return vm.item[keyword].indexOf(vm.tmp[keyword]) > -1 || !vm.tmp[keyword];
    };

    vm.backParent = function (reload) {
      $state.go(vm.PARENT_STATE, {reload: reload});
    };

    vm.save = function () {
      if (vm.isCreate) {
        SearchList.save(
          vm.item,
          function (data) {
            successTip(data.message);
            vm.backParent(true);
          },
          function (data) {
            errorTip(data.message);
          });
      } else {
        SearchConfigItem.update(
          {primaryKey: vm.id},
          vm.item,
          function (data) {
            successTip(data.message);
            vm.backParent(true);
          },
          function (data) {
            errorTip(data.message);
          });
      }
    };

    vm.editField = function (name, id, fieldType) {
      var searchConfigDialog = $uibModal.open({
        animation: true,
        templateUrl: 'search-config-dialog',
        controller: 'searchConfigDialog',
        resolve: {
          searchConfigDialogData: function () {
            return {
              fieldType: fieldType,
              name: name,
              id: id
            };
          }
        }
      });

      searchConfigDialog.result.then(function () {
        init();
      });
    };

    init();
  }
})();
(function () {
  angular
    .module('app')
    .controller('searchConfigDialog', searchConfigDialog);

  function searchConfigDialog($scope, Resource, $uibModalInstance, searchConfigDialogData) {
    var vm = $scope;
    var SearchIndexItem = Resource.SearchConfig.SearchIndexConfigItem;
    var SearchConfigItem = Resource.SearchConfig.Item;

    var id = searchConfigDialogData.id;
    var name = searchConfigDialogData.name;
    var type = searchConfigDialogData.fieldType;
    vm.field = {};
    vm.legend = '新建field';
    if (id && name) {
      vm.keyObj = {
        id: id,
        name: name
      };
      vm.legend = '编辑field';
      SearchIndexItem.get(vm.keyObj, function (data) {
        vm.field = data;
      });
    } else {
      vm.field.appid = id;
    }

    vm.save = function () {
      if (id && name) {
        SearchIndexItem.update(
          vm.keyObj,
          vm.field,
          function (data) {
            successTip(data.message);
            vm.back()
          }, function (data) {
            errorTip(data.message);
          })
      } else if (type) {
        vm.field.type = type;
        SearchConfigItem.save(
          {primaryKey: id},
          vm.field,
          function (data) {
            successTip(data.message);
            vm.back();
          }, function (data) {
            errorTip(data.message);
          }
        )
      }
    };

    vm.back = function () {
      $uibModalInstance.close();
    };

    vm.cancel = vm.back;
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .controller('reviewdictDialog', reviewdictDialog);

  function reviewdictDialog($scope, Resource, $uibModalInstance, reviewdictDialogData) {
    var vm = $scope;
    var ReviewDictListRes = Resource.ReviewDict.ReviewDictList;
    
    vm.legend = '新增';

    vm.reviewdict = {
      appid: undefined,
      type: undefined,
      word: undefined,
      level: undefined,
      pinyin: undefined
    }

    vm.typeList = reviewdictDialogData.typeList;
    vm.levelList = reviewdictDialogData.levelList;
    vm.pinyinList = reviewdictDialogData.pinyinList;

    vm.save = function() {
      ReviewDictListRes.save(Object.assign({}, vm.reviewdict), function() {
        $uibModalInstance.close();
        successTip('新建成功');
      });
    }

    vm.cancel = function() {
      $uibModalInstance.close();
    }
    
    vm.validation = function() {
      var valid = true;
      for(var attr in vm.reviewdict) {
        if(!vm.reviewdict[attr] && vm.reviewdict[attr] != 0) {
          valid = false;
        }
      }
      return !valid;
    }
  }
})();
(function () {
    angular
        .module('app')
        .controller('recDebug.review', recResultReviewCtrl);
    recResultReviewCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService', '$filter'];

    function recResultReviewCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService, $filter) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var AnswerReviewRes = Resource.RecDebug.AnswerReview;

        vm.start_time = new Date();
        vm.end_time = new Date();

        vm.appReflect = [];
        vm.tableInited = false;

        vm.results = {
            params: [{
                name: 'requestid',
                key: 'requestid'
            }, {
                name: 'pvid',
                key: 'pvid'
            }, {
                name: 'scene_type',
                key: 'scene_type'
            }, {
                name: 'userid',
                key: 'userid'
            }, {
                name: 'imei',
                key: 'imei'
            }, {
                name: 'cid',
                key: 'cid'
            }, {
                name: '推荐时间',
                key: 'rec_time'
            }, {
                name: '调用限制',
                key: 'rec_limit'
            }]
        }

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });

        vm.removeItem = function (idx) {
            if (vm.params.itemid_list.length < 3) {
                vm.params.itemid_list[idx] = undefined
            } else {
                vm.params.itemid_list.splice(idx, 1);
            }
        }

        vm.addItem = function () {
            vm.params.itemid_list.push(undefined);
        }

        vm.search = function () {
            if (!vm.params.appInfo) {
                errorTip("appname不能为空");
                return;
            }

            if (!ifHasItem()) {
                errorTip('产品信息名称不允许为空');
                return;
            }
            var formatStartTime = vm.params.date + " " + formatTime(vm.start_time) + ":00";
            var formatEndTime = vm.params.date + " " + formatTime(vm.end_time) + ":00";
            if (new Date(formatStartTime).getTime() > new Date(formatEndTime)) {
                errorTip('开始时间要小于结束时间！');
                return;
            }

            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 100000
            }, {
                    getData: function ($defer, params) {
                        AnswerReviewRes.save(processRequestData(), function (data) {
                            vm.data = processData(data);
                            params.total(100000);
                            $defer.resolve(vm.data.rec_list);
                        });
                    }
                });
        }

        function processData(data) {
            var tempData = {};
            var tag_list = ['pvid','scene_type', 'userid', 'imei', 'cid', 'rec_time', 'rec_limit']
            tempData.requestid = data.requestid;
            angular.forEach(tag_list, function (tag) {
                if (tag == 'rec_time') {
                    tempData[tag] = getDateStr(new Date(parseInt(data.rec_data[tag]) * 1000), true)
                } else {
                    tempData[tag] = data.rec_data[tag];
                }
            });
            tempData.rec_list = data.rec_data.rec_list;
            return tempData;
        }

        vm.reset = function () {
            vm.params = {
                date: calcDateService.basedToday(-1),
                appInfo: undefined,
                itemid_list: [undefined, undefined]
            }
        }

        function processRequestData() {
            var params = angular.copy(vm.params);
            params.appid = params.appInfo.appid;
            params.appname = params.appInfo.appname;

            params.start_time = params.date + " " + formatTime(vm.start_time) + ":00";
            params.end_time = params.date + " " + formatTime(vm.end_time) + ":00";

            delete (params.appInfo);
            delete (params.date);

            return params;
        }

        function ifHasItem() {
            var hasItem = true;
            angular.forEach(vm.params.itemid_list, function (itemid) {
                if (!itemid) {
                    hasItem = false;
                }
            });

            return hasItem;
        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return undefined;
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        function formatTime(date) {

            return $filter("date")(date, " HH:mm")
        }

        vm.changed = function () {

            // console.log($filter("date")(vm.start_time, " HH:mm"));
            // console.log(new Date('2018-04-17 16:00').getTime()) ;
        }

        vm.reset();
    }
})();
(function () {
  angular
    .module('app')
    .controller('recDebug.related', recDebugRelatedCtrl);
  recDebugRelatedCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams'];

  function recDebugRelatedCtrl($scope, Resource, $stateParams, $window, ngTableParams) {
    var vm = $scope;
    var RelatedRes = Resource.RecDebug.Related;
    var Config = Resource.Common.Reflect;
    var tableInited = false;

    Config.get({}, function (data) {
      vm.appArray = [];
      for (var key in data.appid) {
        vm.appArray.push({
          id: key,
          value: {
            app_name: data.appid[key].app_name
          }
        });
      }

      if ($stateParams['app_name']) {
        angular.forEach(vm.appArray, function (app) {
          if (app.value.app_name == $stateParams['app_name']) {
            vm.selectedItem = app;
          }
        });
      }

      init();
    });

    vm.$watch('selectedItem', function (newValue, oldValue) {
      if (newValue && newValue.value.app_name.length > 0) {
        vm.queryParams.app_name = newValue.value.app_name;
      }
    });

    vm.$watch('queryParams.app_name', function (newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        vm.appArray.map(function (value) {
          if (value.value.app_name == newValue) {
            vm.selectedItem = value;
          }
        });
      }
    });

    var defaultParams = {
      app_name: undefined,
      scene_type: 'test',
      userid: undefined,
      cid: undefined,
      imei: undefined,
      itemid: undefined,
      cateid: undefined,
      cnt: 10,
      start: 0
    }

    vm.noData = true;
    vm.tableData = {
      item_info: {},
      rec_result: [],
      user_show: [],
      user_click: []
    }
    vm.queryParams = {};

    vm.resetParams = function () {
      vm.queryParams = angular.copy(defaultParams);
    }

    vm.comfirm = function (notReloadRecResult) {
      RelatedRes.get(vm.queryParams, function (data) {
        vm.noData = false;
        angular.forEach(vm.tableData, function (value, key, allData) {
          if (key !== 'rec_result' || !notReloadRecResult) {
            allData[key] = data[key];
          }
        });

        if (!tableInited) {
          tableInit();
          tableInited = true;
        } else {
          vm.userShowTableParams.page(1);
          vm.userShowTableParams.reload();
          vm.userClickTableParams.page(1);
          vm.userClickTableParams.reload();
        }
      });
    }

    vm.replaceRecResult = function () {
      vm.comfirm();
    }

    vm.searchRelateAndOpenRelated = function (item) {
      var newQueryParams = angular.copy(vm.queryParams);
      newQueryParams.itemid = item.itemid;
      // vm.comfirm();
      $window.open('#/recDebug/related?' + generateUrlParams(newQueryParams));
    }

    function init() {
      if ($stateParams.isExist) {
        angular.forEach(defaultParams, function (value, key) {
          vm.queryParams[key] = $stateParams[key];
        });
        vm.comfirm();
      } else {
        vm.resetParams();
      }

    }

    function generateUrlParams(item) {
      var resultStr = '';

      angular.forEach(defaultParams, function (value, key) {
        if (!!item[key]) {
          resultStr += (key + '=' + item[key] + '&');
        }
      });

      resultStr += 'isExist=true';
      return resultStr;
    }

    function tableInit() {
      vm.userShowTableParams = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer, params) {
          var req = {
            start: (params.page() - 1) * params.count(),
            number: params.count()
          };
          data = getListData(req, 'user_show');
          params.total(data.total);
          $defer.resolve(data.items);
        }
      });

      vm.userClickTableParams = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer, params) {
          var req = {
            start: (params.page() - 1) * params.count(),
            number: params.count()
          };
          data = getListData(req, 'user_click');
          params.total(data.total);
          $defer.resolve(data.items);
        }
      });

      function getListData(req, table_name) {
        data = vm.tableData[table_name];

        return {
          total: data.length,
          items: data.slice(req.start, req.start + req.number)
        }
      }
    }
  }
})();
(function () {
  angular
    .module('app')
    .controller('recDebug.personal', recDebugPersonalCtrl);
  recDebugPersonalCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams'];

  function recDebugPersonalCtrl($scope, Resource, $stateParams, $window, ngTableParams) {
    var vm = $scope;
    var tableInited = false;
    var PersonalRes = Resource.RecDebug.Personal;
    var Config = Resource.Common.Reflect;

    Config.get({}, function (data) {
      vm.appArray = [];
      for (var key in data.appid) {
        vm.appArray.push({
          id: key,
          value: {
            app_name: data.appid[key].app_name
          }
        });
      }

      if ($stateParams['app_name']) {
        angular.forEach(vm.appArray, function (app) {
          if (app.value.app_name == $stateParams['app_name']) {
            vm.selectedItem = app;
          }
        });
      }
    });

    vm.$watch('selectedItem', function (newValue, oldValue) {
      if (newValue) {
        vm.queryParams.app_name = newValue.value.app_name;
      }
    });

    var defaultParams = {
      app_name: null,
      scene_type: 'test',
      userid: undefined,
      cid: undefined,
      imei: undefined,
      cateid: undefined,
      cnt: 10,
      start: 0
    }

    vm.noData = true;
    vm.queryParams = {};

    vm.tableData = {
      user_model_info: {
        cate_info: [],
        tag_info: [],
        sim_user_info: [],
        item_info: []
      },
      rec_result: [],
      user_show: [],
      user_click: []
    }

    vm.resetParams = function () {
      vm.queryParams = angular.copy(defaultParams);
    }

    vm.comfirm = function (notReloadRecResult) {
      PersonalRes.get(vm.queryParams, function (data) {
        vm.noData = false;
        angular.forEach(vm.tableData, function (value, key, tableData) {
          if (key === 'user_model_info') {
            tableData[key] = data['user_model'];
          } else if (!notReloadRecResult || key !== 'rec_result') {
            tableData[key] = data[key];
          }
        });

        if (!tableInited) {
          tableInit();
          tableInited = true;
        } else {
          vm.userShowTableParams.page(1);
          vm.userShowTableParams.reload();
          vm.userClickTableParams.page(1);
          vm.userClickTableParams.reload();
        }
      });
    }

    vm.replaceRecResult = function () {
      vm.comfirm();
    }

    vm.searchPersonalAndOpenRelated = function (item) {
      var newQueryParams = angular.copy(vm.queryParams);
      newQueryParams.itemid = item.itemid;
      // vm.comfirm(true);
      $window.open('#/recDebug/related?' + generateUrlParams(newQueryParams));
    }

    init();

    function init() {
      if ($stateParams.isExist) {
        angular.forEach(defaultParams, function (value, key) {
          vm.queryParams[key] = $stateParams[key];
        });
        vm.comfirm();
      } else {
        vm.resetParams();
      }
    }

    function generateUrlParams(item) {
      var resultStr = '';

      angular.forEach(defaultParams, function (value, key) {
        if (!!item[key]) {
          resultStr += (key + '=' + item[key] + '&');
        }
      });

      resultStr += ('itemid=' + item['itemid'] + '&isExist=true');
      return resultStr;
    }

    function tableInit() {
      vm.userShowTableParams = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer, params) {
          var req = {
            start: (params.page() - 1) * params.count(),
            number: params.count()
          };
          data = getListData(req, 'user_show');
          params.total(data.total);
          $defer.resolve(data.items);
        }
      });

      vm.userClickTableParams = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer, params) {
          var req = {
            start: (params.page() - 1) * params.count(),
            number: params.count()
          };
          data = getListData(req, 'user_click');
          params.total(data.total);
          $defer.resolve(data.items);
        }
      });

      function getListData(req, table_name) {
        data = vm.tableData[table_name];

        return {
          total: data.length,
          items: data.slice(req.start, req.start + req.number)
        }
      }
    }
  }
})();
(function () {
  angular
    .module('app')
    .controller('recDebug.hot', recDebugHotCtrl);
  recDebugHotCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window'];

  function recDebugHotCtrl($scope, Resource, $stateParams, $window) {
    var vm = $scope;
    var PersonalRes = Resource.RecDebug.Hot;
    var Config = Resource.Common.Reflect;

    Config.get({}, function (data) {
      vm.appList = {};
      vm.appArray = [];
      for (var key in data.appid) {
        vm.appList[data.appid[key].app_name] = key
        vm.appArray.push({
          id: key,
          value: {
            app_name: data.appid[key].app_name
          }
        });
      }

      if ($stateParams['app_name']) {
        angular.forEach(vm.appArray, function (app) {
          if (app.value.app_name == $stateParams['app_name']) {
            vm.selectedItem = app;
          }
        });
      }
    });

    var defaultParams = {
      app_name: null,
      userid: null,
      imei: null,
      cid: null,
      scene_type: 'test',
      cateid: '',
      start: 0,
      cnt: 10,
      hot_key: null
    }

    vm.noData = true;
    vm.queryParams = {};

    vm.tableData = {
      user_model_info: {
        cate_info: [],
        tag_info: [],
        sim_user_info: [],
        item_info: []
      },
      rec_result: [],
      user_show: [],
      user_click: []
    }

    vm.resetParams = function () {
      vm.queryParams = angular.copy(defaultParams);
    };

    vm.hot = {
      typeList: ['HOT:', 'HOT_HOUR:', 'NEW_REC_'],
      type: '',
      appid: ''
    };

    vm.$watch('selectedItem', function (newValue, oldValue) {
      if (newValue) {
        vm.queryParams.app_name = newValue.value.app_name;
        vm.hot.appid = vm.queryParams.app_name ? vm.appList[vm.queryParams.app_name] : ''
      }
    });

    vm.comfirm = function (notReloadRecResult) {
      switch (vm.hot.type) {
        case 'HOT:':
          vm.queryParams.hot_key = vm.hot.type + vm.hot.appid + ':' + vm.queryParams.cateid;
          break;
        case 'HOT_HOUR:':
          vm.queryParams.hot_key = vm.hot.type + vm.hot.appid + ':' + vm.queryParams.cateid;
          break;
        case 'NEW_REC_':
          vm.queryParams.hot_key = vm.hot.type + vm.hot.appid;
          break;
        case '':
          vm.queryParams.hot_key = null
      }
      PersonalRes.get(
        vm.queryParams,
        function (data) {
          vm.noData = false;
          angular.forEach(vm.tableData, function (value, key, tableData) {
            if (key === 'user_model_info') {
              tableData[key] = data['user_model'];
            } else if (!notReloadRecResult || key !== 'rec_result') {
              tableData[key] = data[key];
            }
          });
        });
    }

    vm.replaceRecResult = function () {
      vm.comfirm();
    }

    vm.searchRelateAndOpenRelated = function (item) {
      var newQueryParams = angular.copy(vm.queryParams);
      newQueryParams.itemid = item.itemid;

      $window.open('#/recDebug/related?' + generateUrlParams(newQueryParams));
    }

    vm.relatedParam = function (item) {
      var newQueryParams = angular.copy(vm.queryParams);
      newQueryParams.itemid = item.itemid;
      return newQueryParams;
    }

    init();

    function init() {
      if ($stateParams.isExist) {
        angular.forEach(defaultParams, function (value, key) {
          vm.queryParams[key] = $stateParams[key];
        });
        vm.comfirm();
      } else {
        vm.resetParams();
      }
    }

    function generateUrlParams(item) {
      var resultStr = '';

      angular.forEach(defaultParams, function (value, key) {
        if (!!item[key]) {
          resultStr += (key + '=' + item[key] + '&');
        }
      });

      resultStr += ('itemid=' + item.itemid + '&isExist=true');
      return resultStr;
    }
  }
})();
(function () {
    angular
        .module('app')
        .controller('recConfig.mergeConfig', recConfigActionConfigCtrl);
    recConfigActionConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];

    function recConfigActionConfigCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        var MergeConfigListRes = Resource.RecConfig.MergeConfigList;
        var MergeConfigItemRes = Resource.RecConfig.MergeConfigItem;
        var AppnameReflectRes = Resource.Order.AppnameReflect; //appname
        vm.appReflect = [];
        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });
        vm.params = {
            query: undefined
        }

        var allFilter = {
            name: '全部',
            value: null
        };

        vm.filterMapping = {
            mode: '报警状态',
            status: '功能'
        };
        vm.alarmFilter = {
            mode: {
                name: 'mode',
                list: [
                    allFilter, {
                        name: '1',
                        value: 1
                    }, {
                        name: '2',
                        value: 2
                    }, {
                        name: '3',
                        value: 3
                    }
                ]
            },
            status: {
                name: 'status',
                list: [
                    allFilter, {
                        name: '启用中',
                        value: '1'
                    },
                    {
                        name: '已禁用',
                        value: '0'
                    }
                ]
            }

        };
        vm.searchValue = {};
        ['mode', 'status'].map(function (t) {
            vm.searchValue[t] = null;
        });


        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
                getData: function ($defer, params) {
                    var requestParams = angular.copy(vm.searchValue);  //赋值操作
                    requestParams.start = (params.page() - 1) * params.count();
                    requestParams.number = params.count();
                    requestParams.query = vm.params.query; //搜索关键词
                    MergeConfigListRes.get(
                        requestParams
                        , function (data) {
                            params.total(data.ret_number);
                            $defer.resolve(data.ret_list);
                        });

                }
            });

        vm.create = function () {
            vm.modify();
        }





        vm.remove = function (item) {
            warningTip('确定要删除该条数据吗？', function () {
                MergeConfigItemRes.delete({
                    primaryKey: item.id
                }, function (data) {
                    successTip(data.message);
                    vm.tableParams.reload();
                });
            });
        }

        vm.modify = function (id) {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'merge-rec-config-dialog',
                controller: 'mergeRecConfigDialog',
                resolve: {
                    data: function () {
                        return {
                            id: id
                        }
                    }
                }
            });

            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }


        vm.search = function () {
            vm.tableParams.reload()
            vm.tableParams.page(1)
        }

        vm.reload = function () {
            vm.search();
        }

        WarpState.activeCurrentState('recConfig.mergeConfig', vm.reload);
    }
})();
(function () {
    angular
        .module('app')
        .controller('recConfig.hotRecConfig', hotRecConfigCtrl);
    hotRecConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];

    function hotRecConfigCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        var HotRecConfigListRes = Resource.RecConfig.HotRecConfigList;
        var HotRecConfigItemRes = Resource.RecConfig.HotRecConfigItem;

        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
            getData: function ($defer, params) {
                var req = {
                    start: (params.page() - 1) * params.count(),
                    number: params.count()
                };

                HotRecConfigListRes.get({
                    start: req.start,
                    number: req.number,
                    query: vm.searchStr
                }, function (data) {
                    params.total(data.ret_number);
                    $defer.resolve(data.ret_list);
                });
            }
        });

        vm.search = function () {
            vm.tableParams.page(1);
            vm.tableParams.reload();
        }

        vm.create = function () {
            vm.modify();
        }

        vm.remove = function (item) {
            baseCallbackTip("是否删除该item?", function() {
                HotRecConfigItemRes.delete({
                    primaryKey: item.id
                }, function (data) {
                    successTip(data.message);
                    vm.search();
                });
            });
        }

        vm.modify = function (id) {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'hot-rec-config-dialog',
                controller: 'hotRecConfigDialog',
                resolve: {
                    data: function () {
                        return {
                            id: id
                        }
                    }
                }
            });

            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }
    }
})();
(function () {
    angular
        .module('app')
        .controller('recConfig.actionConfig', recConfigActionConfigCtrl);
    recConfigActionConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'WarpState'];

    function recConfigActionConfigCtrl($scope, Resource, $stateParams, $window, ngTableParams, WarpState) {
        var vm = $scope;
        var ActionConfigListRes = Resource.RecConfig.ActionConfigList;
        var ActionConfigItemRes = Resource.RecConfig.ActionConfigItem;
        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
            getData: function ($defer, params) {
                var req = {
                    start: (params.page() - 1) * params.count(),
                    number: params.count()
                };

                ActionConfigListRes.get({
                    start: req.start,
                    number: req.number,
                    appid: vm.searchStr
                }, function (data) {
                    params.total(data.ret_number);
                    $defer.resolve(data.ret_list);
                });
            }
        });

        vm.remove = function (item) {
            warningTip('确定要删除该条数据吗？', function () {
                ActionConfigItemRes.delete({
                    primaryKey: item.app_action_push_configid
                }, function (data) {
                    successTip(data.message);
                    vm.tableParams.reload();
                });
            });
        }

        vm.search = function () {
            vm.tableParams.reload()
            vm.tableParams.page(1)
        }

        vm.reload = function() {
            vm.search();
        }

        WarpState.activeCurrentState('recConfig.actionConfig', vm.reload);
    }
})();
(function () {
    angular
        .module('app')
        .controller('recConfig.aboutRecConfig', hotRecConfigCtrl);
    hotRecConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];

    function hotRecConfigCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        var HotRecConfigListRes = Resource.RecConfig.HotRecConfigList;
        var HotRecConfigItemRes = Resource.RecConfig.HotRecConfigItem;

        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
                getData: function ($defer, params) {
                    var req = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };

                    HotRecConfigListRes.get({
                        start: req.start,
                        number: req.number,
                        query: vm.searchStr
                    }, function (data) {
                        params.total(data.ret_number);
                        $defer.resolve(data.ret_list);
                    });
                }
            });

        vm.search = function () {
            vm.tableParams.page(1);
            vm.tableParams.reload();
        }

        vm.create = function () {
            vm.modify();
        }

        vm.remove = function (item) {
            baseCallbackTip("是否删除该item?", function () {
                HotRecConfigItemRes.delete({
                    primaryKey: item.id
                }, function (data) {
                    successTip(data.message);
                    vm.search();
                });
            });
        }

        vm.modify = function (id) {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'about-rec-config-dialog',
                controller: 'aboutRecConfigDialog',
                resolve: {
                    data: function () {
                        return {
                            id: id
                        }
                    }
                }
            });

            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }
    }
})();
(function () {



  angular
    .module('app')
    .controller('public.feedback', publicFeedback);
  publicFeedback.inject = ['$scope', '$location', 'ngTableParams', 'Resource'];

  function publicFeedback($scope, $location, ngTableParams, Resource) {
    $scope.status = "-1";

    var Feedback = Resource.Statistics.Feedback;

    $scope.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      /*counts: [10, 20, 50, 100],*/
      getData: function ($defer, params) {
        /*var start = (page-1)*$scope.page_params.self.number;
        var number = $scope.page_params.self.number;*/
        var req = {
          start: (params.page() - 1) * params.count(),
          number: params.count()
        };
        Feedback.get(req, function (data) {
          params.total(data.ret_number);
          $defer.resolve(data.ret_list);
        });
      }
    });

    $scope.back = function () {
      $location.path('/');
    };

    $scope.$on('$destroy', function () {
      FeedbackResc = null;
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('public.binding', publicBinding);
  publicBinding.inject = ['$scope', '$location', 'Resource', 'ngTableParams'];

  function publicBinding($scope, $location, Resource, ngTableParams) {

    var BindData = Resource.Statistics.BindData;
    
    $scope.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        var req = {
          start: (params.page() - 1) * params.count(),
          number: params.count()
        };
        BindData.get(req, function (data) {
          params.total(data.ret_number);
          $defer.resolve(data.ret_list);
        });
      }
    });

    $scope.back = function () {
      $location.path('/');
    };

  }

})();
(function () {
  angular
    .module('app')
    .controller('public.action', publicAction);
  publicAction.inject = ['$scope', '$location', '$modal', 'Resource', 'ngTableParams'];

  function publicAction($scope, $location, $modal, Resource, ngTableParams) {
    $scope.action_list = ['首页', '消息详情', '用户列表', '美文推荐ALL', '文章推荐', '修改图文', '新建图文', '素材列表', '消息统计', '图文统计', '用户统计']
    $scope.terminal_type = "-1";
    $scope.action_name = "";


    var Action = Resource.Statistics.Action;

    $scope.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      /*counts: [10, 20, 50, 100],*/
      getData: function ($defer, params) {
        /*var start = (page-1)*$scope.page_params.self.number;
        var number = $scope.page_params.self.number;*/
        var req = {
          start: (params.page() - 1) * params.count(),
          number: params.count()
        };
        if ($scope.terminal_type != "-1") {
          req.terminal_type = $scope.terminal_type;
        };
        if ($scope.action_name != null && $scope.action_name != "") {
          req.action_name = $scope.action_name;
        };
        Action.get(req, function (data) {
          params.total(data.ret_number);
          $defer.resolve(data.ret_list);
        });
      }
    });

    $scope.terminalTypeChange = function () {
      $scope.tableParams.$params.page = 1;
      $scope.tableParams.$params.count = 10;
      $scope.tableParams.reload();
    };

    $scope.actionNameChange = function () {
      $scope.tableParams.$params.page = 1;
      $scope.tableParams.$params.count = 10;
      $scope.tableParams.reload();
    };

    $scope.back = function () {
      $location.path('/');
      //window.history.back();
    };

    $scope.$on('$destroy', function () {
      BehaviorResc = null;
    });

  };
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('project.testApplication', projectTestApplication);


  function projectTestApplication($scope, Resource, ngTableParams, $uibModal, $stateParams, dataService, $cookies, HOST, csvSaver) {
    var vm = $scope;
    var Config = Resource.Common.Reflect;
    var List = Resource.Project.TestApplication.List;
    var GetSaler = Resource.Management.GetSaler;
    var Role = Resource.Common.Role;
    var CurrentUserRoles = Resource.Common.CurrentUserRoles
    vm.currentRoleList = []
    vm.download = function(){
      List.get({
        start: 0,
        number: 10000,
        is_exported: 1
      }, function(data){
        csvSaver(data.data, data.file_name)
      })
    }
    CurrentUserRoles.query({}, function (data) {
      vm.currentRoleList = data;
      if (vm.isProjectManager()) {
        Role.query({
          group_name: '销售部'
        }, function (data) {
          vm.managers = data;
          vm.search.manager_id = 0;
        });
      }
    })

    vm.isProjectManager = function () {
      return vm.currentRoleList.indexOf('项目部leader') > -1 || vm.currentRoleList.indexOf('Administrator') > -1;
    };

    vm.search = {
      manager_id: 0,
      q: ''
    };
    vm.downLoadLink = HOST + 'applyfortestlistdownload';

    Config.get({}, function (data) {
      vm.Config = data;
    });

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
        getData: function ($defer, params) {
          var req = {
            start: (params.page() - 1) * params.count(),
            number: params.count(),
            q: vm.search.q,
            manager_id: vm.search.manager_id == 0 ? null : vm.search.manager_id
          };
          List.get(req, function (data) {
            $defer.resolve(data.ret_list);
            params.total(data.ret_number);
          });
        }
      });

    vm.search = function () {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    };

    vm.edit = function (item) {
      var applicationDialog = $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'application-dialog',
        controller: 'applicationDialog',
        controllerAs: 'application',
        resolve: {
          applicationDialogData: function () {
            return item ? item.id : null;
          }
        }
      });

      applicationDialog.result.then(function (data) {
        if (data) {
          vm.search();
        }
      });
    };

    vm.application = function (item) {
      var accountApplicationDialog = $uibModal.open({
        animation: true,
        templateUrl: 'account-application-dialog',
        controller: 'accountApplicationDialog',
        controllerAs: 'application',
        resolve: {
          accountApplicationDialogData: function () {
            return item ? item.id : null;
          }
        }
      });

      accountApplicationDialog.result.then(function (data) {
        if (data) {
          vm.search();
        }
      });
    };

    if ($stateParams.create) {
      vm.edit();
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('order.update', orderUpdateCtrl);

  function orderUpdateCtrl($scope, $stateParams, Resource, $http, $timeout, $state, HOST) {
    var vm = $scope;
    var OrderDetailRes = Resource.Order.Detail;
    var AppnameReflect = Resource.Order.AppnameReflect;
    var ServiceRes = Resource.Order.Service;
    var Saler = Resource.Management.GetSaler;
    var Image = Resource.Order.Image;
    vm.imageScreenShow = false;
    vm.tmpDel = 0;
    vm.isNew = true;
    vm.serviceList = [];
    var MULTIPLE = 10000;
    var reload = $state.reload;
    vm.reflectData = {
      appReflect: null
    }

    vm.orderInfo = {
      orderId: undefined,
      appInfo: undefined,
      manager: undefined,
      filePath: undefined,
      orderDel: 0,
      serviceList: []
    }

    if ($stateParams.id) {
      vm.isNew = false;
    }

    vm.adjustServiceFeacture = function (service) {
      service.features_id = service.feature.typeStr;
    }

    vm.changeDelState = function (item, state) {
      if (typeof item.child_del != 'undefined') {
        item.child_del = state;
      } else if (typeof item.orderDel != 'undefined') {
        item.orderDel = state;
      }
    }


    vm.showImage = function () {
      vm.imageScreenShow = !vm.imageScreenShow;
    }

    vm.orderimgUpload = function () {
      var formData = new FormData();
      var file = angular.element("input.order-imginput")[0].files[0];
      if (file) {
        formData.append('file', file);
        $http({
          url: HOST + "contractupload",
          method: "POST",
          data: formData,
          transformRequest: angular.identity,
          headers: {
            "Content-Type": function () {
              return undefined;
            }
          }
        }).success(function (result) {
          vm.orderInfo.filePath = result.path;
        }).error(function (res) {
          errorTip(res.data.message);
        });
      }
    }

    vm.addService = function () {
      vm.orderInfo.serviceList.push({
        isNew: true,
        child_del: 0,
        child_number: 0,
        child_day_limit_num: 0,
        child_remind_day: 0,
        child_remind_month: 0,
        child_remind_season: 0,
        child_remind_semester: 0,
        child_remind_year: 0,
        date: {
          start: undefined,
          end: undefined
        },
        child_remark: {
          ad: 0,
          porn: 0,
          politic: 0,
          reaction: 0,
          lowQuality: 0
        }
      })
    }

    vm.saveService = function (service) {
      var serviceData = pickServiceData(service);
      serviceData.number *= MULTIPLE;
      serviceData.day_limit_num *= MULTIPLE;
      if (service.isNew) {
        ServiceRes.create(serviceData, function (data) {
          successTip("服务创建成功！");
          delete(service.isNew);
          service.child_id = data.id;
        }, function (res) {
          errorTip(res.data.message);
        });
      } else {
        ServiceRes.update(serviceData, function (data) {
          successTip("修改服务成功！");
        });
      }
    }

    vm.cancelService = function (service, idx) {
      if (service.isNew) {
        vm.orderInfo.serviceList.splice(idx, 1);
      } else {
        //TODO
        //设置重置
      }
    }

    vm.saveOrder = function () {
      if (!vm.orderInfo.appInfo) {
        errorTip('请选择账号名称');
        return false;
      }
      if (!vm.orderInfo.manager) {
        errorTip('请选择负责人');
        return false;
      }
      var orderData = {
        id: vm.orderInfo.orderId,
        appid: parseInt(vm.orderInfo.appInfo.id),
        manager_id: parseInt(vm.orderInfo.manager),
        contract_path: vm.orderInfo.filePath,
        del: vm.orderInfo.orderDel
      };
      if (vm.isNew) {
        OrderDetailRes.create({
          primaryKey: $stateParams.id
        }, orderData, function (data) {
          successTip('创建成功！');
          vm.orderInfo.orderId = data.id;
          vm.orderInfo.filePath = data.contract_path;
          vm.isNew = false;
          updateImage()
        }, function (res) {
          errorTip(res.data.message);
        });
      } else {
        OrderDetailRes.update({
          primaryKey: vm.orderInfo.orderId
        }, orderData, function (data) {
          successTip('修改成功！');
          updateImage()
        });
      }
    }

    init();

    function updateImage() {
      Image.get({id: vm.orderInfo.orderId}, function(data){
        vm.image = 'data:image/png;base64,' + data.data;
      })
    }

    function pickServiceData(service) {
      var resultData = {
        orders_id: vm.orderInfo.orderId,
        type_id: service.child_type_id,
        number: service.child_number,
        features_id: service.child_features_id,
        del: service.child_del,
        day_limit_num: service.child_day_limit_num,
        effective_time: service.date.start,
        deadline_time: service.date.end,
        remind_day: service.child_remind_day,
        remind_month: service.child_remind_month,
        remind_season: service.child_remind_season,
        remind_semester: service.child_remind_semester,
        remind_year: service.child_remind_year,
        remark: ''
      };
      if (!service.isNew) {
        resultData.id = service.child_id;
      }

      //预充值类型时改为限额，日限额改为无穷大
      if (service.child_type_id == 1 || service.child_features_id == 3) {
        resultData.day_limit_num = 0;
        resultData.remind_day = 0;
        resultData.remind_month = 0;
        resultData.remind_season = 0;
        resultData.remind_semester = 0;
        resultData.remind_year = 0;
      } else {
        resultData.number = 0;
      }

      if (service.child_features_id == 3) {
        resultData.number = 0;
      }

      if (service.child_features_id == 14) {
        resultData.remark = JSON.stringify(service.child_remark);
      }

      return resultData;
    }

    function init() {
      Saler.query({}, function (data) {
        vm.Saler = data;
      });
      AppnameReflect.get({}, function (data) {
        vm.reflectData.appReflect = _preProcessReflect.appReflect(data.appid);
      });

      if (!vm.isNew) {
        Image.get({id: $stateParams.id}, function(data){
          vm.image = 'data:image/png;base64,' + data.data;
        })
        OrderDetailRes.get({
          primaryKey: $stateParams.id
        }, {}, function (data) {
          dataCollect(data);
        })
      }
    }

    function dataCollect(orderData) {
      if (!vm.reflectData.appReflect) {
        $timeout(function () {
          dataCollect(orderData);
        }, 50);
        return;
      }
      //获取list信息
      vm.orderInfo.serviceList = orderData.child;
      angular.forEach(vm.orderInfo.serviceList, function (item) {
        item.child_features_id = item.child_features_id.toString();
        item.child_type_id = item.child_type_id.toString();
        if (!item.date) {
          item.date = {};
        }
        item.child_day_limit_num /= MULTIPLE;
        item.child_number /= MULTIPLE;
        item.date.start = item.child_effective_time;
        item.date.end = item.child_deadline_time;
        if (!!item.child_remark) {
          item.child_remark = JSON.parse(item.child_remark);
        } else {
          item.child_remark = {
            ad: 0,
            porn: 0,
            politic: 0,
            reaction: 0,
            lowQuality: 0
          }
        }
      });

      //appInfo映射（app_name和company_name）
      angular.forEach(vm.reflectData.appReflect, function (reflect) {
        if (orderData.order_appid == reflect.id) {
          vm.orderInfo.appInfo = reflect;
        }
      });

      //manager映射
      vm.orderInfo.manager = orderData.order_manager_id;

      vm.orderInfo.filePath = orderData.order_contract_path;
      vm.orderInfo.orderId = orderData.order_id;
      vm.orderInfo.orderDel = orderData.order_del;
    }

    var _preProcessReflect = {
      appReflect: function (data) {
        var appReflect = [];
        angular.forEach(data, function (value, key) {
          appReflect.push({
            id: key,
            value: value
          });
        });
        return appReflect;
      }
    }
  }
})();
(function () {
  angular
    .module('app')
    .controller('order.list', orderListCtrl);

  orderListCtrl.inject = ['$scope', 'Resource', 'ngTableParams', '$window', '$timeout'];

  function orderListCtrl($scope, Resource, ngTableParams, $window, $timeout) {
    var vm = $scope;
    var ListRes = Resource.Order.List;
    var ReflectRes = Resource.Common.Reflect;

    vm.resultData = {
      appReflect: [],
      managerReflect: []
    }

    vm.info = {
      'title': '订单列表',
      'subtitle': '列表',
      'breadcrumb': [{
        "name": "订单列表",
        "iconclass": "fa-child"
      }, {
        "name": "列表",
        "link": "#/order/list"
      }, {
        "name": "列表",
        "active": 1
      }]
    };

    vm.showItem = function (item) {
      function showDel() {
        return vm.filter.del == '' || item.del == vm.filter.del
      }
      return showDel();
    }

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 1000000
    }, {
      getData: function ($defer, params) {
        if(vm.resultData.appReflect.length < 1) {
          return;
        }

        ListRes.query({}, function (data) {
          data = vm.processData(data);
          data = vm.filter(data);
          params.total(1000000);
          $defer.resolve(data);
        });
      }
    });

    vm.processData = function (data) {
      angular.forEach(data, function (item) {
        if (vm.resultData.appReflect[item.appid.toString()]) {
          item.company_name = vm.resultData.appReflect[item.appid.toString()].company_name;
          item.app_name = vm.resultData.appReflect[item.appid.toString()].app_name;
        }
        item.manager = vm.resultData.managerReflect[item.manager_id.toString()];
      });

      return data;
    }

    vm.filter = function (data) {
      var resultList = [];
      if (vm.app_name) {
        data = angular.forEach(data, function (item) {
          if ((!!item.company_name && item.company_name.search(vm.app_name) > -1) ||
            (!!item.app_name && item.app_name.search(vm.app_name) > -1)) {
            resultList.push(item);
          }
        });
      } else {
        return data;
      }
      return resultList;
    }

    vm.enter = function (ev) {
      var keycode = window.event ? ev.keyCode : ev.which;
      if (keycode == 13) {
        vm.search();
      }
    };

    vm.search = function () {
      vm.tableParams.page(1);
      vm.tableParams.count(1000000);
      vm.tableParams.reload();
    }

    init();

    function init() {
      ReflectRes.get({}, function (data) {
        vm.resultData.appReflect = data.appid;
        vm.resultData.managerReflect = data.manager_id;
        vm.search()
      });
    }
  }
})();
(function () {
    angular
        .module('app')
        .controller('offline.rec', offlineRecCtrl);
    offlineRecCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];

    function offlineRecCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        // var OfflineRecListRes = Resource.RecConfig.MergeConfigList;
        var OfflineRecListRes = Resource.OfflineModule.RecList;
        var AppnameReflectRes = Resource.Order.AppnameReflect; //appname
        vm.appReflect = [];
        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });
        vm.params = {
            appInfo: undefined
        }
        vm.alarmFilter = {
            time_mode: {
                name: 'time_mode',
                list: [
                    {
                        name: 'day',
                        value: 'day'
                    }, {
                        name: 'hour',
                        value: 'hour'
                    }
                ]
            },
            status: {
                name: 'status',
                list: [{
                    name: '待运行',
                    value: null
                }, {
                    name: '正在运行',
                    value: '正在运行'
                },
                {
                    name: '已完成',
                    value: '已完成'
                }
                ]
            }

        };
        vm.searchValue = {};
        ['time_mode', 'status'].map(function (t) {
            vm.searchValue[t] = null;
        });


        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
                getData: function ($defer, params) {
                    var requestParams = angular.copy(vm.searchValue);  //赋值操作
                    requestParams.status = vm.searchValue.status == null ? '待运行' : vm.searchValue.status;
                    requestParams.start = (params.page() - 1) * params.count();
                    requestParams.number = params.count();
                    if (vm.params.appInfo) {
                        requestParams.appid = vm.params.appInfo.appid;
                    }
                    requestParams.requestid = vm.requestid;
                    OfflineRecListRes.get(
                        requestParams
                        , function (data) {
                            params.total(data.ret_number);
                            $defer.resolve(data.ret_list);
                        });

                }
            });
        vm.start = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'offline-rec-config-dialog',
                controller: 'recResultDialog',
                resolve: {
                    data: function () {
                        return {
                            id: null
                        }
                    }
                }
            });

            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }


        vm.search = function () {
            vm.tableParams.reload()
            vm.tableParams.page(1)
        }

        vm.reload = function () {
            vm.search();
        }

        WarpState.activeCurrentState('offline.rec', vm.reload);
    }
})();
(function () {
    angular
        .module('app')
        .controller('offline.hot', offlineHotCtrl);
    offlineHotCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];

    function offlineHotCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        var OfflineHotListRes = Resource.OfflineModule.HotList;
        var AppnameReflectRes = Resource.Order.AppnameReflect; //appname
        vm.appReflect = [];
        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });
        vm.params = {
            appInfo: undefined
        }

        vm.alarmFilter = {
            time_mode: {
                name: 'time_mode',
                list: [
                    {
                        name: 'day',
                        value: 'day'
                    }, {
                        name: 'hour',
                        value: 'hour'
                    }
                ]
            },
            status: {
                name: 'status',
                list: [{
                    name: '待运行',
                    value: null
                }, {
                    name: '正在运行',
                    value: '正在运行'
                },
                {
                    name: '已完成',
                    value: '已完成'
                }
                ]
            }

        };
        vm.searchValue = {};
        ['time_mode', 'status'].map(function (t) {
            vm.searchValue[t] = null;
        });


        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
                getData: function ($defer, params) {
                    var requestParams = angular.copy(vm.searchValue);  //赋值操作
                    requestParams.status = vm.searchValue.status == null ? '待运行' : vm.searchValue.status;
                    requestParams.start = (params.page() - 1) * params.count();
                    requestParams.number = params.count();
                    if (vm.params.appInfo) {
                        requestParams.appid = vm.params.appInfo.appid;
                    }
                    requestParams.requestid=vm.requestid;
                    OfflineHotListRes.get(
                        requestParams
                        , function (data) {
                            params.total(data.ret_number);
                            $defer.resolve(data.ret_list);
                        });

                }
            });

        vm.start = function (id) {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'offline-hot-result-dialog',
                controller: 'hotResultDialog',
                resolve: {
                    data: function () {
                        return {
                            id: null
                        }
                    }
                }
            });

            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }


        vm.search = function () {
            vm.tableParams.reload()
            vm.tableParams.page(1)
        }

        vm.reload = function () {
            vm.search();
        }

        WarpState.activeCurrentState('offline.hot', vm.reload);
    }
})();
(function () {
    angular
        .module('app')
        .controller('offline.data', recConfigActionConfigCtrl);
    recConfigActionConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState', 'calcDateService'];

    function recConfigActionConfigCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState, calcDateService) {
        var vm = $scope;
        var OfflineDataListRes = Resource.OfflineModule.DataList;
        var AppnameReflectRes = Resource.Order.AppnameReflect; //appname

        //时间初始值
        vm.filterDate = {
            start: calcDateService.basedToday(0) + ' 00:00:00',
            end: calcDateService.basedToday(0) + ' 23:59:59'
        };

        vm.appReflect = [];
        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });
        vm.params = {
            appInfo: undefined
        }
        vm.alarmFilter = {

            status: {
                name: 'status',
                list: [{
                    name: '待运行',
                    value: null
                }, {
                    name: '正在运行',
                    value: '正在运行'
                },
                {
                    name: '已完成',
                    value: '已完成'
                }
                ]
            }

        };
        vm.searchValue = {};
        ['status'].map(function (t) {
            vm.searchValue[t] = null;
        });


        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
                getData: function ($defer, params) {
                    var requestParams = angular.copy(vm.searchValue);  //赋值操作
                    requestParams.status = vm.searchValue.status == null ? '待运行' : vm.searchValue.status;
                    requestParams.start = (params.page() - 1) * params.count();
                    requestParams.number = params.count();
                    requestParams.start_time = vm.filterDate.start;
                    requestParams.end_time = vm.filterDate.end;
                    if (vm.params.appInfo) {
                        requestParams.appid = vm.params.appInfo.appid;
                    }
                    requestParams.requestid = vm.requestid;
                    OfflineDataListRes.get(
                        requestParams
                        , function (data) {
                            params.total(data.ret_number);
                            $defer.resolve(data.ret_list);
                        });

                }
            });


        vm.start = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'offline-data-dialog',
                controller: 'dataDialog',
                resolve: {
                    data: function () {
                        return {
                            id: null
                        }
                    }
                }
            });

            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }


        vm.search = function () {
            vm.tableParams.reload()
            vm.tableParams.page(1)
        }

        vm.reload = function () {
            vm.search();
        }

        WarpState.activeCurrentState('offline.data', vm.reload);
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('nlpDialog', nlpDialog);


  function nlpDialog($scope, $uibModalInstance, nlpEditDialogData, Resource) {
    var vm = $scope;
    vm.item = nlpEditDialogData;
    vm.isCreate = nlpEditDialogData ? false : true;
    vm.machineOriginPOSList = [];
    var SepPreview = Resource.NLP.Sep.SepPreview;

    if (!vm.isCreate) {
      vm.title = vm.item.type === 'pos' ? '人工审核：词性' : '人工审核：分词';
      vm.manualReview = {
        origin: vm.item.content_sep_person !== null && vm.item.content_sep_person.length > 0 ?
          stringToArray(vm.item.content_sep_person).join(' ') : stringToArray(vm.item.content_sep_machine).join(' '),
        eachWordList: []
      };

      vm.machineReview = vm.item.content_sep_person !== null && vm.item.content_sep_person.length > 0 ?
        vm.item.content_sep_person : vm.item.content_sep_machine;

      // 记录原有分词中每个字的词性
      vm.machineReview.map(function (value) {
        for (var i = 0; i < value.word.length; i++) {
          vm.machineOriginPOSList.push(value.pos);
        }
      });

      vm.$watch('manualReview.origin', function (newValue) {
        vm.manualReview.eachWordList = [];
        for (var i = 0; i < newValue.length; i++) {
          var word = newValue.substr(i, 1);
          vm.manualReview.eachWordList[i] = {
            word: word,
            pos: null
          }
        }
        var reviewPOSWordList = newValue.split(' ');
        vm.updatePOS = [];
        var wordLength = 0;
        reviewPOSWordList.map(function (value, index) {
          wordLength += value.length;
          vm.updatePOS.push({
            word: value,
            pos: vm.machineOriginPOSList[wordLength - 1]
          });
        });
      }, true);
    } else {
      vm.title = '提交 badcase';
      vm.nlpCreateFrom = {};
    }

    vm.isSpace = function (word) {
      if (word === ' ') {
        return 'isSpace';
      }
    };

    vm.handleEachWord = function (index) {
      if (vm.manualReview.eachWordList[index] === ' ') {
        return false;
      }
      var beforeSpaceLength = 0;
      for (var i = 0; i < index; i++) {
        if (vm.manualReview.eachWordList[i].word === ' ') {
          beforeSpaceLength++;
        }
      }
      return vm.machineOriginPOSList[index - beforeSpaceLength];
    };

    function stringToArray(string) {
      if (string) {
        var array = [];
        string.map(function (value) {
          array.push(value.word);
        });
        return array;
      }
    }

    vm.POSPreview = function () {
      if (!vm.nlpCreateFrom.content) {
        alert('请输入文本');
        return;
      }
      vm.title = '分词结果';
      vm.showPOS = true;

      SepPreview.query({
        content: vm.nlpCreateFrom.content
      }, function (data) {
        vm.wordPOSPreview = data;
      });
    };

    vm.confirm = function () {
      if (vm.isCreate) {
        vm.create();
      } else {
        vm.update();
      }
    };

    vm.update = function () {
      $uibModalInstance.close(vm.updatePOS);
    };

    vm.create = function () {
      $uibModalInstance.close({
        content: vm.nlpCreateFrom.content,
        content_sep_machine: vm.wordPOSPreview
      });
    };

    vm.close = function () {
      $uibModalInstance.close();
    };

  }
})();
(function() {
'use strict';

  angular
    .module('app')
    .controller('management.user', managementUser);

  managementUser.inject = ['$scope', 'Resource', 'ngTableParams', 'WarpState', '$state'];
  function managementUser($scope, Resource, ngTableParams, WarpState, $state) {
    var vm = $scope;
    var List = Resource.Management.UserList;

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        List.query({}, function (data) {
          $defer.resolve(data);
        });
      }
    });

    vm.create = function () {
      $state.go('management.user').then(function () {
        $state.go('management.user.item')
      });
    };

    vm.reload = function () {
      vm.tableParams.reload();
    };

    WarpState.activeCurrentState('management.user', vm.reload);
  }
})();
(function() {
'use strict';

  angular
    .module('app')
    .controller('management.role', managementRole);

  managementRole.inject = ['$scope', 'Resource', 'ngTableParams', 'WarpState', '$state'];
  function managementRole($scope, Resource, ngTableParams, WarpState, $state) {
    var vm = $scope;
    var List = Resource.Management.RoleList;

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        List.query({}, function (data) {
          $defer.resolve(data);
        });
      }
    });

    vm.create = function () {
      $state.go('management.user').then(function () {
        $state.go('management.role.item')
      });
    };

    vm.reload = function () {
      vm.tableParams.reload();
    };

    WarpState.activeCurrentState('management.role', vm.reload);
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.resource', managementResource);

  managementResource.inject = ['WarpState'];

  function managementResource(WarpState) {
    WarpState.goChild('management.resource', 'management.resource.resource');
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.menu', managementMenu);


  function managementMenu($scope, Resource, $uibModal, routerList, $state) {
    var vm = $scope;

    // API Resource
    // var Menu = Resource.Menu;
    vm.routerList = routerList();
    vm.allOpen = false;
    vm.menu = [];
    var Menu = Resource.Common.Menu;

    vm.recovery = function (key) {
      vm.dragList[key].list = angular.copy(vm.origin[key]);
    };

    Menu.query({
      show_all: 1
    }, function (data) {
      vm.menu = data;
      vm.toggleAllOpen();
    });


    vm.edit = function (params) {
      var menuDialog = $uibModal.open({
        animateion: true,
        templateUrl: 'menu-dialog',
        controller: 'menuDialog',
        resolve: {
          menuDailogData: params.item
        }
      });

      menuDialog.result.then(function (data) {
        if (params.type == 'create' && data) {
          params.list.unshift(angular.copy(data));
        } else if (params.type == 'edit' && data) {
          params.list[params.index] = data;
        }
      })
    };

    vm.toggleAllOpen = function () {
      vm.allOpen = !vm.allOpen;
      vm.menu.map(function (item) {
        item.open = vm.allOpen;
      })
    };

    vm.level = 0;

    vm.create = function (item) {
      vm.edit({
        list: item.menu_list,
        type: 'create'
      });
    };

    vm.update = function (item, index, list) {
      vm.edit({
        item: item,
        index: index,
        list: list,
        type: 'edit'
      });
    };

    vm.remove = function (item, index, list) {
      list.splice(index, 1);
    };

    vm.moveUp = function (item, index, list) {
      if (index == 0) {
        return false;
      }
      var prevItem = angular.copy(list[index - 1]);
      list[index - 1] = item;
      list[index] = prevItem;
    };

    vm.moveDown = function (item, index, list) {
      if (index == list.length - 1) {
        return false;
      }
      var nextItem = angular.copy(list[index + 1]);
      list[index + 1] = item;
      list[index] = nextItem;
    };

    vm.treeConfig = {
      callbacks: [{
        name: '新建子菜单',
        icon: 'glyphicon glyphicon-plus',
        callback: vm.create
      }, {
        name: '修改',
        icon: 'glyphicon glyphicon-pencil',
        callback: vm.update
      }, {
        icon: 'glyphicon glyphicon-remove',
        name: '删除',
        callback: vm.remove
      }, {
        icon: 'glyphicon glyphicon-arrow-up',
        name: '上移',
        callback: vm.moveUp
      }, {
        icon: 'glyphicon glyphicon-arrow-down',
        name: '下移',
        callback: vm.moveDown
      }]
    };

    vm.save = function () {
      Menu.save({
        menu_list: vm.menu
      }, function () {
        successTip('提交成功');
        $state.reload();
      }, function (data) {
        errorTip(data.data.message);
      })
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.mailTemplate', managementMailTemplate);


  function managementMailTemplate($scope, Resource, ngTableParams, $uibModal) {
    var vm = $scope;
    var List = Resource.Mail.List;

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        List.get({}, function (data) {
          $defer.resolve(data.ret_list);
        });
      }
    });


    vm.reload = function () {
      vm.tableParams.reload();
    };

    vm.edit = function (id) {
      var mailTemplateDialog = $uibModal.open({
        animation: true,
        templateUrl: 'mail-template-dialog',
        controller: 'mailTemplateDialog',
        resolve: {
          mailTemplateDialogData: angular.isNumber(id) ? id : null
        }
      });

      mailTemplateDialog.result.then(function (data) {
        if (data) {
          vm.reload();
        }
      });
    };

    vm.cancel = function (item) {
      item.newName = item.name;
      vm.toggleItemShow(item);
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.industry', managementChannel);

  function managementChannel($scope, Resource, ngTableParams, WarpState, $uibModal) {
    var vm = $scope;
    var List = Resource.Industry.List;
    var Item = Resource.Industry.Item;

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer) {
        List.get({}, function (data) {
          $defer.resolve(data.ret_list);
        });
      }
    });

    vm.reload = function () {
      vm.tableParams.reload();
    };

    vm.toggleItemShow = function (item) {
      item.show = !item.show;
    };
    
    vm.disableItem = function (item, disabled) {
      var data = angular.copy(item);
      data.status = disabled;
      var text = disabled === 1 ? '启用' : '禁用';
      vm.update(data, text + '成功')
    };

    vm.update = function (item, successMessage) {
      var data = angular.copy(item);
      data.name = data.newName;
      if (data.name.trim().length === 0) {
        errorTip('行业名不能为空');
        return false;
      }
      Item.update(data, function () {
        successTip(successMessage);
        vm.toggleItemShow(item);
        vm.reload();
      }, function (data) {
        errorTip(data.data.message);
      })
    };

    vm.create = function () {
      var channelModal = $uibModal.open({
        animation: true,
        templateUrl: 'industry-dialog',
        controller: 'industryDialog'
      });

      channelModal.result.then(function (data) {
        if (data) {
          vm.reload();
        }
      });
    };

    vm.cancel = function (item) {
      item.newName = item.name;
      vm.toggleItemShow(item);
    };

    WarpState.activeCurrentState('management.industry', vm.reload);
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.channel', managementChannel);

  managementChannel.inject = ['$scope', 'Resource', 'ngTableParams', 'WarpState', '$state', '$uibModal'];

  function managementChannel($scope, Resource, ngTableParams, WarpState, $state, $uibModal) {
    var vm = $scope;
    var List = Resource.Channel.List;
    var Item = Resource.Channel.Item;
    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        List.get({}, function (data) {
          $defer.resolve(data.ret_list);
        });
      }
    });

    vm.reload = function () {
      vm.tableParams.reload();
    };

    vm.toggleItemShow = function (item) {
      item.show = !item.show;
    };
    vm.disableItem = function (item, disabled) {
      var data = angular.copy(item);
      data.is_del = disabled;
      var text = null;
      if (disabled == 0) {
        text = '启用';
      } else {
        text = '禁用';
      }
      vm.update(data, text + '成功')
    }
    vm.update = function (item, successMessage) {
      var data = angular.copy(item);
      data.name = data.newName;
      if (data.name.trim().length == 0) {
        errorTip('渠道名不能为空');
        return false;
      }
      Item.update(data, function (data) {
        successTip(successMessage);
        vm.toggleItemShow(item);
        vm.reload();
      }, function (data) {
        errorTip(data.data.message);
      })
    };

    vm.create = function () {
      var channelModal = $uibModal.open({
        animation: true,
        templateUrl: 'channel-dialog',
        controller: 'channelDialog'
      });

      channelModal.result.then(function (data) {
        if (data) {
          vm.reload();
        }
      });
    };

    vm.cancel = function (item) {
      item.newName = item.name;
      vm.toggleItemShow(item);
    }

    WarpState.activeCurrentState('management.channel', vm.reload);
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('management.advanced', managementAdvanced);

  managementAdvanced.inject = ['$scope', 'Resource', 'ngTableParams', 'WarpState', '$state', '$filter'];

  function managementAdvanced($scope, Resource, ngTableParams, WarpState, $state) {
    var vm = $scope;
    // var List = Resource.Management.UserList;
    var List = Resource.Management.User.List;
    vm.search = {
      isOnline: 1,
      nickname: ''
    }
    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        List.get({
          start: (params.page() - 1) * params.count(),
          number: params.count(),
          is_online: vm.search.isOnline == 2 ? null : vm.search.isOnline,
          nickname: vm.search.nickname
        }, function (data) {
          $defer.resolve(data.ret_list);
          params.total(data.ret_number);
          vm.number=data.ret_number; //赋值前端展示 
        });
      }
    });

    // vm.showItem = function (item) {
    //   function showStatus() {
    //     return vm.search.isOnline == 2 || item.is_online == vm.search.isOnline;
    //   }

    //   function showNickname() {
    //     return vm.search.nickname == '' || item.nickname.indexOf(vm.search.nickname) > -1;
    //   }
    //   return showStatus() && showNickname();
    // }

    vm.create = function () {
      $state.go('management.advanced').then(function () {
        $state.go('management.advanced.item')
      });
    };

    vm.reload = function () {
      vm.tableParams.reload();
    };

    WarpState.activeCurrentState('management.advanced', vm.reload);
  }
})();
(function () {
    angular
      .module('app')
      .controller('dataUpReport.totalProductUpReport', totalProductUpReportCtrl);
      totalProductUpReportCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
  
    function totalProductUpReportCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var TotalProductRes = Resource.DataUpReport.TotalProduct;

        vm.tableInited = false; //初始化
        
        vm.query = {
            start_time: undefined,
            end_time: undefined
        }
        vm.params = {
            numState: 'report_num'
        }

        vm.filterDate = {
            start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
            end: calcDateService.basedDate(new Date(), 0)
        };

        vm.update = function () {
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        vm.getDynamicTitle = function() {
            return vm.params.numState;
        }

        function tableInit() {
        vm.ngTableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
            getData: function ($defer, params) {
                var pageParams = {
                    start: (params.page() - 1) * params.count(),
                    number: params.count()
                };
                //日期
                vm.query.start_time = vm.filterDate.start;
                vm.query.end_time = vm.filterDate.end;
                vm.query.type = vm.params.numState;
                var req = angular.extend({}, pageParams, vm.query);
                TotalProductRes.get(req, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.items);
                });
            }
            });
        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }
        //init data
        tableInit();
        vm.tableInited = true;
  
    }
  })();
  
  
(function () {
    angular
        .module('app')
        .controller('dataUpReport.totalActionUpReport', totalActionUpReportCtrl);
        totalActionUpReportCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];

    function totalActionUpReportCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var TotalActionRes = Resource.DataUpReport.TotalAction;
        vm.appReflect = [];
        vm.tableInited = false; //初始化
        
        vm.query = {
            hour: undefined,
            start_time: undefined,
            end_time: undefined,
            sort: undefined,
            reverse: undefined
        }
        vm.params = {
            hour_ori: undefined,
            statisticCaliber: 'day'
        }

        vm.newColumns = [];

        vm.getDynamicTitle = function(title) {
            return title;
        }

        vm.filterDate = {
            start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
            end: calcDateService.basedDate(new Date(), 0)
        };

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });

        vm.search = function () {

            vm.newColumns = vm.params.statisticCaliber != 'day' ? [{
                title: 'hour'
            }] : [];

            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                if (vm.params.hour_ori) {
                    if (vm.params.hour_ori.length == 1) {
                        vm.query.hour = '0' + vm.params.hour_ori;
                    } else {
                        vm.query.hour = vm.params.hour_ori;
                    }
                }
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                    var key = Object.values(params.sorting())[0];
                    if (key) {
                        vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                    }
                    //日期
                    vm.query.start_time = vm.filterDate.start;
                    vm.query.end_time = vm.filterDate.end;
                    vm.query.type = vm.params.statisticCaliber;
                    if(vm.params.statisticCaliber == 'day') {
                        vm.query.sort = undefined;
                        vm.query.hour = undefined;
                    }
                    var req = angular.extend({}, pageParams, vm.query);
                    TotalActionRes.get(req, function (data) { //需要更改
                        params.total(data.total);
                        $defer.resolve(data.items.map(function(item) {
                            return item;
                        }));
                    });
                }
            });
        }

        vm.reset = function () {
            vm.query = {
                hour: undefined,
                start_time: undefined,
                end_time: undefined,
                sort: undefined,
                reverse: undefined
            }

            vm.params.hour_ori = undefined;
            
            //刷新数据
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }

        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }


        //初始化数据
        tableInit();
        vm.tableInited = true;

    }
})();
(function () {
    angular
        .module('app')
        .controller('dataUpReport.hourlyActionUpReport', hourlyActionUpReportCtrl);
        hourlyActionUpReportCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];

    function hourlyActionUpReportCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var HourlyActionRes = Resource.DataUpReport.HourlyAction;
        vm.appReflect = [];
        vm.tableInited = false; //初始化
        
        vm.query = {
            appid: undefined,
            hour: undefined,
            start_time: undefined,
            end_time: undefined,
            sort: undefined,
            reverse: undefined
        }
        vm.params = {
            appInfo: undefined,
            hour_ori: undefined,
            actionType: 'total'
        }

        vm.filterDate = {
            start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
            end: calcDateService.basedDate(new Date(), 0)
        };

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });

        vm.search = function () {

            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                if (vm.params.hour_ori) {
                    if (vm.params.hour_ori.length == 1) {
                        vm.query.hour = '0' + vm.params.hour_ori;
                    } else {
                        vm.query.hour = vm.params.hour_ori;
                    }
                }
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                    var key = Object.values(params.sorting())[0];
                    if (key) {
                        vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                    }
                    //日期
                    vm.query.start_time = vm.filterDate.start;
                    vm.query.end_time = vm.filterDate.end;
                    vm.query.type = vm.params.actionType;
                    vm.query.appid = undefined;
                    if (vm.params.appInfo) {
                        vm.query.appid = vm.params.appInfo.appid;
                    }
                    var req = angular.extend({}, pageParams, vm.query);
                    HourlyActionRes.get(req, function (data) { //需要更改
                        params.total(data.total);
                        $defer.resolve(data.items.map(function(item) {
                            if(vm.params.actionType == 'total'){
                                item.action_type = 'total';
                            }
                            return item;
                        }));
                    });
                }
            });
        }

        vm.reset = function () {
            vm.query = {
                appid: undefined,
                hour: undefined,
                start_time: undefined,
                end_time: undefined,
                sort: undefined,
                reverse: undefined
            }

            vm.params.appInfo = undefined;
            vm.params.hour_ori = undefined;
            
            //刷新数据
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }


        //初始化数据
        tableInit();
        vm.tableInited = true;

    }
})();
(function () {
    angular
      .module('app')
      .controller('dataUpReport.dayActionUpReport', dayActionUpReportCtrl);
      dayActionUpReportCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
  
    function dayActionUpReportCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var DayActionRes = Resource.DataUpReport.DayAction;
    
        vm.appReflect = [];
        vm.tableInited = false; //初始化
        
        vm.query = {
            appid: undefined,
            start_time: undefined,
            end_time: undefined,
            sort: undefined,
            reverse: undefined
        }
        vm.params = {
            appInfo: undefined,
            actionType: 'total'
        }

        vm.filterDate = {
            start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
            end: calcDateService.basedDate(new Date(), 0)
        };

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });

        vm.search = function () {
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                    var key = Object.values(params.sorting())[0];
                    if (key) {
                        vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                    }
                    //日期
                    vm.query.start_time = vm.filterDate.start;
                    vm.query.end_time = vm.filterDate.end;
                    vm.query.type = vm.params.actionType;
                    vm.query.appid = undefined;
                    if (vm.params.appInfo) {
                        vm.query.appid = vm.params.appInfo.appid;
                    }
                    var req = angular.extend({}, pageParams, vm.query);
                    DayActionRes.get(req, function (data) { //需要更改
                        params.total(data.total);
                        $defer.resolve(data.items.map(function(item) {
                            if(vm.params.actionType == 'total'){
                                    item.action_type = 'total';
                            }
                            return item;
                        }));
                    });
                }
            });
        }
        vm.reset = function () {
            vm.query = {
                appid: undefined,
                start_time: undefined,
                end_time: undefined,
                sort: undefined,
                reverse: undefined
            }

            vm.params.appInfo = undefined;
            
            //刷新数据
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }

        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }
        //init data
        tableInit();
        vm.tableInited = true;
    
    }
  })();
  
  
(function () {
    angular
      .module('app')
      .controller('dataUpReport.appProductUpReport', appProductUpReportCtrl);
      appProductUpReportCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', 'ngTableParams', 'calcDateService'];
  
    function appProductUpReportCtrl($scope, Resource, $stateParams, $window, ngTableParams, calcDateService) {
        var vm = $scope;
        var AppnameReflectRes = Resource.Order.AppnameReflect;
        var AppProductRes = Resource.DataUpReport.AppProduct;
  
        vm.appReflect = [];
        vm.tableInited = false; //初始化
        
        vm.query = {
            appid: undefined,
            start_time: undefined,
            end_time: undefined,
            sort: undefined,
            reverse: undefined
        }
        vm.params = {
            appInfo: undefined,
            numState: 'report_num'
        }

        vm.filterDate = {
        start: calcDateService.basedDate(new Date().getTime() - 7 * 24 * 3600000, 0),
        end: calcDateService.basedDate(new Date(), 0)
        };

        AppnameReflectRes.get({}, function (data) {
            angular.forEach(data.appid, function (val, key) {
                vm.appReflect.push({
                    appid: key,
                    appname: val.app_name
                });
            });
        });

        vm.search = function () {
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }
        }
      
        vm.getDynamicTitle = function() {
        return vm.params.numState;
        }

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    vm.query.sort = Object.keys(params.sorting())[0]; //字段名字
                    var key = Object.values(params.sorting())[0];
                    if (key) {
                        vm.query.reverse = key === 'desc' ? 1 : 0; //1 降序 0升序
                    }
                    //日期
                    vm.query.start_time = vm.filterDate.start;
                    vm.query.end_time = vm.filterDate.end;
                    vm.query.type = vm.params.numState;
                    vm.query.appid = undefined;
                    if (vm.params.appInfo) {
                        vm.query.appid = vm.params.appInfo.appid;
                    }
                    if(vm.query.sort && vm.query.sort != vm.query.type) {
                        vm.query.sort = undefined;
                        vm.query.reverse = undefined;
                    }
                    var req = angular.extend({}, pageParams, vm.query);
                    AppProductRes.get(req, function (data) { //需要更改
                        params.total(data.total);
                        $defer.resolve(data.items.map(function(item) {
                            return item;
                        }));
                    });
                }
            });
        }

        vm.reset = function () {
            vm.query = {
                appid: undefined,
                start_time: undefined,
                end_time: undefined,
                sort: undefined,
                reverse: undefined
            }

            vm.params.appInfo = undefined;
            
            //刷新数据
            if (!vm.tableInited) {
                tableInit();
                vm.tableInited = true;
            } else {
                vm.ngTableParams.page(1);
                vm.ngTableParams.reload();
            }

        }

        function getDateStr(date, isFull) {
            var dateStr, year = date.getFullYear(),
                month = date.getMonth() + 1,
                days = date.getDate(),
                hours = date.getHours(),
                minutes = date.getMinutes(),
                seconds = date.getSeconds();
            if (!date) {
                return "";
            }

            dateStr = year + "-" + formatDateNum(month) + "-" + formatDateNum(days);
            if (isFull) {
                dateStr = dateStr + " " + formatDateNum(hours) + ":" + formatDateNum(minutes) + ":" + formatDateNum(seconds);
            }
            return dateStr;
        }

        function formatDateNum(num) {
            if (num / 10 < 1) {
                return '0' + num;
            } else {
                return num.toString()
            }
        }

        vm.changeDateWord = function (date) {
            if (date) {
                return date.substring(0, 10);
            }
        }
        //init data
        tableInit();
        vm.tableInited = true;
  
    }
  })();
  
  
(function () {
  'use strict';

  angular.module('app')
    .controller('crawl.statistics', statisticsCtrl);

  statisticsCtrl.$inject = ['$scope', 'calcDateService', 'ngTableParams', 'Resource'];

  function statisticsCtrl($scope, calcDateService, ngTableParams, Resource) {
    var vm = $scope;
    var ListRes = Resource.Crawl.List;

    vm.record = {
      num_pub: -1,
      num_article: -1
    };

    vm.date = calcDateService.basedToday(-1);

    //how to do到时候借鉴API.controller.js
    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10000
    }, {
      getData: function ($defer, params) {
        var sort = undefined;
        var reverse = undefined;
        if (params.sorting()) {
          var sorting = params.sorting();
          for (var i in sorting) // 形如 {read_num: 'desc'}
            if (i) {
              sort = i;
              reverse = (sorting[i] == 'desc' ? 1 : 0);
              break;
            }
        }
        var req = {
          start: 0,
          number: 10000,
          data_time: vm.date,
          sort: sort,
          reverse: reverse,
          app_name: vm.app_name
        }

        ListRes.get(req, function (data) {
          vm.record = data.record;
          params.total(data.total);
          $defer.resolve(data.ret_list);
        })
      }
    });

    vm.search = function() {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('corpusAnnotationDialogCtrl', corpusAnnotationDialogCtrl);


  function corpusAnnotationDialogCtrl($scope, $uibModalInstance, corpusAnnotationEditDialogData, Resource, posConvert) {
    var vm = $scope;
    var Item = Resource.NLP.CorpusAnnotation.Item;

    vm.item = corpusAnnotationEditDialogData;

    vm.manualReview = {
      origin: vm.item.content_sep_person,
      eachWordList: [],
      person: handleOrigin('person'),
      personEachWordList: [],
      location: handleOrigin('location'),
      locationEachWordList: [],
      organization: handleOrigin('organization'),
      organizationEachWordList: [],
      other: handleOrigin('other'),
      otherEachWordList: []
    }
    // todo: use posEditor
    vm.$watch('manualReview.person', function (newValue) {
      vm.manualReview.personEachWordList = handleEachWordList(vm.manualReview.personEachWordList, newValue);
    });
    vm.$watch('manualReview.location', function (newValue) {
      vm.manualReview.locationEachWordList = handleEachWordList(vm.manualReview.locationEachWordList, newValue);
    });
    vm.$watch('manualReview.organization', function (newValue) {
      vm.manualReview.organizationEachWordList = handleEachWordList(vm.manualReview.organizationEachWordList, newValue);
    });
    vm.$watch('manualReview.other', function (newValue) {
      vm.manualReview.otherEachWordList = handleEachWordList(vm.manualReview.otherEachWordList, newValue);
    });

    function handleEachWordList(array, newValue) {
      array = [];
      for (var i = 0; i < newValue.length; i++) {
        var word = newValue.substr(i, 1);
        array[i] = {
          word: word,
          pos: null
        }
      }
      return array;
    }

    function handleOrigin(key) {
      return vm.item.content_ner_person[key].length == 0 ? '' : vm.item.content_ner_person[key].join(' ');
    }

    vm.isSpace = function (word) {
      if (word == ' ') {
        return 'isSpace';
      }
    }

    vm.confirm = function () {
      vm.update();
    }

    vm.update = function () {
      // 判断中括号闭合
      if (vm.manualReview.origin.strLength('[') != vm.manualReview.origin.strLength(']')) {
        errorTip('中括号没有正确闭合');
        return false;
      }
      if (vm.manualReview.origin.replace(/g/, ''))
        var data = {
          id: vm.item.id,
          content_sep_person: posConvert.domToText(vm.manualReview.origin),
          content_ner_person: {
            person: vm.manualReview.person,
            location: vm.manualReview.location,
            organization: vm.manualReview.organization,
            other: vm.manualReview.other
          }
        }
      Item.update(data, function (data) {
        successTip('修改成功');
        $uibModalInstance.close(true);
      }, function (data) {
        errorTip(data.data.message);
      });
    };

    vm.isBracket = function (string) {
      if (string == '[') {
        return 'isBracket isLeftBracket';
      } else if (string == ']') {
        return 'isBracket isRightBracket';
      }
      ;
    }

    vm.close = function () {
      $uibModalInstance.close();
    };
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .controller('contact.ucloud', recommendationUcloud);
  recommendationUcloud.inject = ['$scope', 'Resource', 'ngTableParams'];


  function recommendationUcloud($scope, Resource, ngTableParams) {

    var Ucloud = Resource.Customer.Ucloud;

    $scope.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      /*counts: [10, 20, 50, 100],*/
      getData: function ($defer, params) {
        /*var start = (page-1)*$scope.page_params.self.number;
         var number = $scope.page_params.self.number;*/
        var req = {
          start: (params.page() - 1) * params.count(),
          number: params.count(),
          user_type: 'ucloud'
        };
        Ucloud.get(req, function (data) {
          params.total(data.ret_number);
          $defer.resolve(data.ret_list);
        });
      }
    });

    $scope.back = function () {
    };

    $scope.$on('$destroy', function () {
      // AccountResc = null;
    });
  };
})();
(function () {
  'use strict';


  angular
    .module('app')
    .controller('contact.contactUsMsg', contactUsMsg);

  function contactUsMsg($scope, Resource, ngTableParams, csvSaver, calcDateService, handleReqObj, COMMON_TABLE_FILTER) {
    var vm = $scope;
    var channelList = Resource.Channel.List;
    var Config = Resource.Common.Reflect;
    var List = Resource.Customer.ContactUsMsg.List;
    var Item = Resource.Customer.ContactUsMsg.Item;
    var GetSaler = Resource.Management.GetSaler;
    vm.filterDate = {
      start: calcDateService.basedToday(-6) + ' 00:00:00',
      end: calcDateService.basedToday(0) + ' 23:59:59'
    };

    vm.download = function () {
      List.get({
        number: 10000,
        start: 0,
        is_exported: 1,
        start_date: vm.filterDate.start,
        end_date: vm.filterDate.end,
        manager_id: vm.searchValue.manager_id,
        keyword: vm.searchValue.keyword,
      }, function (data) {
        csvSaver(data.data, data.file_name);
      })
    };

    vm.contactUsMsgFilter = {
      func: COMMON_TABLE_FILTER.CONTACT.FUNC
    };

    vm.searchValue = {};
    ['func', 'keyword', 'manager_id', 'channel_id'].map(function (item) {
      if (item.indexOf('_id') > -1) {
        vm.searchValue[item] = 0
      } else {
        vm.searchValue[item] = null;
      }
    });

    channelList.get({}, function (data) {
      vm.channels = data.ret_list;
    });

    GetSaler.query({}, function (data) {
      vm.managers = data.filter(function (manager) {
        return ['徐红', '张祖浩', '兰飞', '刘超', '张志坚'].indexOf(manager.user_nickname) > -1;
      });
    });

    Config.get({}, function (data) {
      vm.Config = data;
      vm.channelList = data.channel_id;
    });

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        vm.searchValue.start_date = vm.filterDate.start;
        vm.searchValue.end_date = vm.filterDate.end;
        var req = handleReqObj.handleTableParams(vm.searchValue, params);
        List.get(req, function (data) {
          $defer.resolve(data.ret_list);
          params.total(data.ret_number);
        });
      }
    });

    vm.update = function (item) {
      var req = handleReqObj.removeEmptyValue(item.tmp);
      req.id = item.contact_us_msgid;
      Item.update(
        req,
        function () {
          item.manager_id = item.tmp.manager_id;
          item.isEditing = false;
          successTip('修改成功');
        },
        function () {
          errorTip('修改失败');
        })
    };

    vm.search = function () {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    };
  }

})();
(function () {
  'use strict';


  angular
    .module('app')
    .controller('contact.contact', recommendationContact);

  function recommendationContact($scope, Resource, ngTableParams, csvSaver) {
    var vm = $scope;
    var Config = Resource.Common.Reflect;
    var Contact = Resource.Customer.Contact;
    var ContactItem = Resource.Customer.ContactItem;
    var GetSaler = Resource.Management.GetSaler;
    vm.download = function () {
      Contact.get({
        number: 10000,
        start: 0,
        is_exported: 1
      }, function (data) {
        csvSaver(data.data, data.file_name)
      })
    };
    GetSaler.query({}, function (data) {
      vm.managers = data;
      vm.managers.unshift({
        user_id: 0,
        user_nickname: '全部'
      });
    });
    vm.manager = 0;

    Config.get({}, function (data) {
      vm.Config = data;
      vm.channelList = data.channel_id;
      vm.channel = 0;
    });

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
        getData: function ($defer, params) {
          var req = {
            start: (params.page() - 1) * params.count(),
            number: params.count(),
            keyword: vm.companyName,
            manager_id: vm.manager == 0 ? null : vm.manager,
            channel_id: vm.channel == 0 ? null : vm.channel
          };
          Contact.get(req, function (data) {
            $defer.resolve(data.ret_list);
            params.total(data.ret_number);
          });
        }
      });

    vm.search = function () {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    };

    vm.modifyRemark = function (item) {
      item.tempRemark = item.manager_id;
      item.isEditing = true;
    };

    vm.cancelRemark = function (item) {
      item.tempRemark = undefined;
      item.isEditing = false;
    };

    vm.confirmRemark = function (item) {
      item.manager_id = item.tempRemark;
      // UpdateContactItemManagerId.modify({
      //   id: item.contact_us_msgid
      // }, {
      //   id: item.contact_us_msgid,
      //   manager_id: item.manager_id,
      //   remark: ' '
      // }, function () {
      //   successTip('修改成功');
      //   item.isEditing = false;
      //   vm.tableParams.reload();
      // });
      ContactItem.update({
        primaryKey: item.contact_us_msgid
      }, {
          // id: item.contact_us_msgid,
          manager_id: item.manager_id
          // remark: ' '
        }, function () {
          successTip('修改成功');
          item.isEditing = false;
          vm.tableParams.reload();
        });

    };
  }

})();
(function () {
  'use strict';


  angular
    .module('app')
    .controller('contact.applyForTrialData', applyForTrialData);

  function applyForTrialData($scope, Resource, ngTableParams, csvSaver, handleReqObj, COMMON_TABLE_FILTER) {
    var vm = $scope;
    var Config = Resource.Common.Reflect;
    var Contact = Resource.Customer.ApplyFroTrialData.List;
    var ContactItem = Resource.Customer.ContactItem;
    var GetSaler = Resource.Management.GetSaler;
    var ReferKeywordTypeListRes = Resource.Customer.ReferKeywordType.List;
    vm.keywordReflect = {};
    vm.download = function () {
      Contact.get({
        number: 10000,
        start: 0,
        is_exported: 1
      }, function (data) {
        csvSaver(data.data, data.file_name);
      })
    };

    ReferKeywordTypeListRes.get({
      start:0,
      number: 10000
    }, function(data) {
      angular.forEach(data.ret_list, function(item) {
        vm.keywordReflect[item.refer_keyword_type] = item.description;
      });
    });

    vm.contactUsMsgFilter = {
      func: COMMON_TABLE_FILTER.CONTACT.FUNC
    };

    vm.searchValue = {};
    ['func', 'keyword', 'manager_id', 'channel_id'].map(function (item) {
      if (item.indexOf('_id') > -1) {
        vm.searchValue[item] = 0
      } else {
        vm.searchValue[item] = null;
      }
    });

    GetSaler.query({}, function (data) {
      vm.managers = data;
    });

    Config.get({}, function (data) {
      vm.Config = data;
      vm.channelList = data.channel_id;
    });

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        var req = handleReqObj.handleTableParams(vm.searchValue, params);
        Contact.get(req, function (data) {
          $defer.resolve(data.ret_list);
          params.total(data.ret_number);
        });
      }
    });

    vm.search = function () {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    };
  }

})();
(function () {
    angular
        .module('app')
        .controller('configManage.timeConfig', timeConfigCtrl);
        timeConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];
  
    function timeConfigCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        var timeConfigListRes = Resource.configManage.timeConfigList;
        var timeConfigItemRes = Resource.configManage.timeConfigItem;
  
        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
                getData: function ($defer, params) {
                    var req = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
  
                    timeConfigListRes.get({
                        start: req.start,
                        number: req.number,
                        appid: vm.searchStr
                    }, function (data) {
                        for(var item in data.data_list){
                            if (data.data_list[item].timeliness_strategy === 1) {
                                data.data_list[item].timeliness_strategy = '只推荐n天之内';
                            } else if(data.data_list[item].timeliness_strategy === 2) {
                                data.data_list[item].timeliness_strategy = '时间越近越优先';
                            };
                            if (data.data_list[item].specify_cate === ''){
                                data.data_list[item].specify_cate = '不限制';
                            }
                        };
                        params.total(data.data_count);
                        $defer.resolve(data.data_list);
                    });
                }
            });
  
        vm.search = function () {
            vm.tableParams.page(1);
            vm.tableParams.reload();
        }
  
        vm.create = function () {
            vm.modify();
        }
  
        vm.remove = function (item) {
            baseCallbackTip("是否删除该item?", function () {
                timeConfigItemRes.delete({
                    primaryKey: item.id
                }, function (data) {
                    successTip(data.message);
                    vm.search();
                });
            });
        }
  
        vm.modify = function (id) {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'time-config-dialog',
                controller: 'timeConfigDialog',
                resolve: {
                    data: function () {
                        return {
                            id: id
                        }
                    }
                }
            });
  
            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }
    }
  })();
(function () {
    angular
        .module('app')
        .controller('configManage.relatedSuggestConfig', relatedSuggestConfigCtrl);
        relatedSuggestConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];
  
    function relatedSuggestConfigCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        var relateConfigListRes = Resource.configManage.relateConfigList;
        var relateConfigItemRes = Resource.configManage.relateConfigItem;
  
        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
                getData: function ($defer, params) {
                    var req = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
  
                    relateConfigListRes.get({
                        start: req.start,
                        number: req.number,
                        appid: vm.searchStr
                    }, function (data) {
                        params.total(data.data_count);
                        $defer.resolve(data.data_list);
                    });
                }
            });
  
        vm.search = function () {
            vm.tableParams.page(1);
            vm.tableParams.reload();
        }
  
        vm.create = function () {
            vm.modify();
        }
  
        vm.remove = function (item) {
            baseCallbackTip("是否删除该item?", function () {
                relateConfigItemRes.delete({
                    primaryKey: item.id
                }, function (data) {
                    successTip(data.message);
                    vm.search();
                });
            });
        }
  
        vm.modify = function (id) {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'related-suggest-config-dialog',
                controller: 'relatedSuggestConfigDialog',
                resolve: {
                    data: function () {
                        return {
                            id: id
                        }
                    }
                }
            });
  
            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }
    }
  })();
(function () {
    angular
        .module('app')
        .controller('configManage.diversityConfig', diversityConfigCtrl);
        diversityConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];
  
    function diversityConfigCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        var diversityConfigListRes = Resource.configManage.diversityConfigList;
        var diversityConfigItemRes = Resource.configManage.diversityConfigItem;
  
        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
                getData: function ($defer, params) {
                    var req = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
  
                    diversityConfigListRes.get({
                        start: req.start,
                        number: req.number,
                        appid: vm.searchStr
                    }, function (data) {
                        for(var item in data.data_list){
                            if(data.data_list[item].attribute === 1){
                                data.data_list[item].attribute = '类目';
                            } else if(data.data_list[item].attribute === 2){
                                data.data_list[item].attribute = '作者';
                            } else {
                                data.data_list[item].attribute = '标签';
                            };
                            if(data.data_list[item].diversity_type === 1){
                                data.data_list[item].diversity_type = '个数';
                            } else {
                                data.data_list[item].diversity_type = '占比';
                            };
                        };
                        params.total(data.data_count);
                        $defer.resolve(data.data_list);
                    });
                }
            });
  
        vm.search = function () {
            vm.tableParams.page(1);
            vm.tableParams.reload();
        }
  
        vm.create = function () {
            vm.modify();
        }
  
        vm.remove = function (item) {
            baseCallbackTip("是否删除该item?", function () {
                diversityConfigItemRes.delete({
                    primaryKey: item.id
                }, function (data) {
                    successTip(data.message);
                    vm.search();
                });
            });
        }
  
        vm.modify = function (id) {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'diversity-config-dialog',
                controller: 'diversityConfigDialog',
                resolve: {
                    data: function () {
                        return {
                            id: id
                        }
                    }
                }
            });
  
            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }
    }
  })();
(function () {
    angular
        .module('app')
        .controller('configManage.basicConfig', basicConfigCtrl);
    basicConfigCtrl.$inject = ['$scope', 'Resource', '$stateParams', '$window', '$uibModal', 'ngTableParams', 'WarpState'];

    function basicConfigCtrl($scope, Resource, $stateParams, $window, $uibModal, ngTableParams, WarpState) {
        var vm = $scope;
        var basicConfigListRes = Resource.configManage.basicConfigList;
        var basicConfigItemRes = Resource.configManage.basicConfigItem;
        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
            getData: function ($defer, params) {
                var req = {
                    start: (params.page() - 1) * params.count(),
                    number: params.count()
                };

                basicConfigListRes.get({
                    start: req.start,
                    number: req.number,
                    appid: vm.searchStr
                }, function (data) {
                    for(var item in data.data_list){
                        if (data.data_list[item].is_filter_click === 1) {
                            data.data_list[item].is_filter_click = '是';
                        } else {
                            data.data_list[item].is_filter_click = '否';
                        };
                        if (data.data_list[item].is_filter_show === 1) {
                            data.data_list[item].is_filter_show = '是';
                        } else {
                            data.data_list[item].is_filter_show = '否';
                        };
                        if (data.data_list[item].is_open_page === 1) {
                            data.data_list[item].is_open_page  = '是';
                        } else {
                            data.data_list[item].is_open_page = '否';
                        }
                    };
                    params.total(data.data_count);
                    $defer.resolve(data.data_list);
                });
            }
        });

        vm.search = function () {
            vm.tableParams.page(1);
            vm.tableParams.reload();
        }

        vm.create = function () {
            vm.modify();
        }

        vm.remove = function (item) {
            baseCallbackTip("是否删除该item?", function () {
                basicConfigItemRes.delete({
                    primaryKey: item.id
                }, function (data) {
                    successTip(data.message);
                    vm.search();
                });
            });
        }

        vm.modify = function (id) {
            var modalInstance = $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'basic-config-dialog',
                controller: 'basicConfigDialog',
                resolve: {
                    data: function () {
                        return {
                            id: id
                        }
                    }
                }
            });

            modalInstance.result.then(function (info) {
                if (info == 'reload') {
                    vm.search();
                }
            })
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('client.review', reviewCtrl);

    reviewCtrl.inject = ['$scope', 'Resource', 'ngTableParams', 'goDashboard', '$q', '$uibModal', 'reviewFilterGroup'];

    function reviewCtrl($scope, Resource, ngTableParams, goDashboard, $q, $uibModal, reviewFilterGroup) {
        var vm = $scope;
        var GetSalerRes = Resource.Management.GetSaler;
        var AppApplyListRes = Resource.Apply.AppApplyList;
        var CurrentUserRoles = Resource.Common.CurrentUserRoles;

        vm.isOnlySeller = false;
        vm.isManager = false;
        vm.seller = [];
        vm.filterGroup = reviewFilterGroup;
        vm.searchValue = {
            status: 0,
            function_type: 0,
            apply_type: 0,
            keyword: undefined,
            seller: undefined
        };

        vm.hideFuncType = function () {
            var hideStatus = [1, 2, 3].indexOf(vm.searchValue.apply_type) > -1;
            if (hideStatus) {
                vm.searchValue.function_type = 0;
            }

            return hideStatus;
        }

        vm.search = function () {
            vm.tableParams.page(1);
            vm.tableParams.reload();
        }

        vm.reflect = function (type, data) {
            var manager = undefined;
            if (!type) {
                return '—';
            }

            return data[type].name
        }

        vm.edit = function (item, type) {
            if (type === 'detail') {
                initDialog(item)
            }
        }

        vm.doDashboard = function (id) {
            goDashboard(id);
        };

        function getRequestParams(start, number) {
            var params = angular.copy(vm.searchValue);
            params.start = !!start ? start : 0;
            params.number = !!number ? number : 10;
            params.manager_id = !!params.seller ? params.seller.user_id : undefined;
            delete(params.seller);

            return params;
        }

        function initDialog(item) {
            return $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'func-review-dialog',
                controller: 'funcReviewDialog',
                resolve: {
                    data: item
                }
            });
        }

        function managerFilter(list) {
            var sellerReflect = {}

            angular.forEach(vm.seller, function (item) {
                sellerReflect[item.user_id] = item.user_nickname
            });

            angular.forEach(list, function (item) {
                item.manager = sellerReflect[item.manager_id]
            });

            return list;
        }

        $q.all([
            GetSalerRes.query({}).$promise,
            CurrentUserRoles.query({}).$promise
        ]).then(function (data) {
            vm.seller = data[0];
            vm.roleList = data[1];

            vm.seller.unshift({
                user_id: undefined,
                user_nickname: '全部'
            });
            vm.searchValue.seller = vm.seller[0];

            if (vm.roleList.indexOf('销售部leader') > -1 || vm.roleList.indexOf('Administrator') > -1) {
                vm.isManager = true;
            } else if (vm.roleList.indexOf('销售部') > -1) {
                vm.isOnlySeller = true;
            }
        });

        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
        }, {
            getData: function ($defer, params) {
                var start = (params.page() - 1) * params.count();
                var number = params.count();
                AppApplyListRes.get(getRequestParams(start, number), function (data) {
                    data.ret_list = managerFilter(data.ret_list);
                    $defer.resolve(data.ret_list);
                    params.total(data.ret_number);
                });
            }
        });
    }

    angular.module('app').constant('reviewFilterGroup', {
        statusList: [{
            'name': '全部',
            'value': 0
        }, {
            'name': '待审核',
            'value': 1
        }, {
            'name': '未通过',
            'value': 2
        }, {
            'name': '已通过',
            'value': 3
        }],
        functionTypeList: [{
            'name': '全部',
            'value': 0
        }, {
            'name': '文本自动审核',
            'value': 1
        }, {
            'name': '文本自动分类',
            'value': 2
        }, {
            'name': '文本标签提取',
            'value': 3
        }, {
            'name': '文本情感分析',
            'value': 4
        }, {
            'name': '推荐引擎',
            'value': 5
        }, {
            'name': '搜索引擎',
            'value': 6
        }, {
            'name': '微信抓取',
            'value': 7
        }],
        applyTypeList: [{
            'name': '全部',
            'value': 0
        }, {
            'name': '新建账号',
            'value': 1
        }, {
            'name': '功能编辑',
            'value': 2
        }, {
            'name': '功能开通',
            'value': 3
        }, {
            'name': '功能关闭',
            'value': 4
        }, {
            'name': '功能上线',
            'value': 5
        }, {
            'name': '功能续签',
            'value': 6
        }, {
            'name': '重启账号',
            'value': 7
        }]
    });
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('client.apply', applyCtrl);

    applyCtrl.inject = ['$scope', 'Resource', 'ngTableParams', '$uibModal', '$state', 'reviewFilterGroup', 'staticService', 'calcDateService'];

    function applyCtrl($scope, Resource, ngTableParams, $uibModal, $state, reviewFilterGroup, staticService, calcDateService) {
        var vm = $scope;
        var AppApplyListRes = Resource.Apply.AppApplyList;
        vm.status = 1;
        vm.salerList = staticService.getSaler();
        vm.channelList = staticService.getChannel();
        vm.tempEmail = '';
        vm.wizardData = [{
            'title': '填写客户信息',
        }, {
            'title': '填写测试信息',
        }, {
            'title': '填写项目人员信息',
        }, {
            'title': '提交',
        }];

        vm.params = {
            function_type: 0,
            apply_type: 1,
            emails: []
        }

        vm.functionList = [{
            title: '文本自动审核',
            function_type: 1
        }, {
            title: '文本自动分类',
            function_type: 2
        }, {
            title: '文本标签提取',
            function_type: 3
        }, {
            title: '文本情感分析',
            function_type: 4
        }, {
            title: '推荐引擎',
            function_type: 5,
        }, {
            title: '搜索引擎',
            function_type: 6
        }, {
            title: '微信抓取',
            function_type: 7
        }]

        angular.forEach(vm.functionList, function (item) {
            item.checked = false;
            item.date = {
                start: calcDateService.basedToday(0),
                end: calcDateService.basedToday(0)
            };
        });

        vm.next = function () {
            vm.status++;
        }

        vm.prev = function () {
            vm.status--;
        }

        vm.addEmail = function () {
            vm.params.emails.push(angular.copy(vm.tempEmail));
            vm.tempEmail = '';
        }

        vm.deleteEmail = function (idx) {
            vm.params.emails.splice(idx, 1);
        }

        vm.save = function () {
            AppApplyListRes.save(vm.params, function (data) {
                swal('创建成功', '', 'success');
                $state.go('client.review');
            });
        }

        vm.$watch('status', function (newVal, oldVal) {
            if (newVal == 4) {
                vm.params.detail_list = generateDetailList(vm.functionList);
                generateEmails();
            }
        })

        vm.$watch('tempEmail', function (newVal, oldVal) {
            if (!newVal) {
                vm.hasEmail = false;
                vm.isEmail = true;
            } else {
                if (!!newVal.match(/^[^@]+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/)) {
                    vm.hasEmail = true;
                    vm.isEmail = true;
                } else {
                    vm.hasEmail = true;
                    vm.isEmail = false;
                }
            }
        });

        function generateDetailList(functionList) {
            var result = [];
            angular.forEach(functionList, function (item) {
                if (item.checked) {
                    result.push({
                        start_date: item.date.start,
                        end_date: item.date.end,
                        limit_num: item.limit_num,
                        function_type: item.function_type,
                        test_position: JSON.stringify(item.test_position)
                    })
                }
            });

            return result;
        }

        function generateEmails() {
            if (vm.params.emails.length > 0) {
                vm.params.other_email = angular.copy(vm.params.emails);
                vm.params.custom_email = vm.params.other_email.shift();
                vm.params.other_email = generateOtherEmail(vm.params.other_email);
            }
        }

        function generateOtherEmail(emailList) {
            var resultStr = '[';
            angular.forEach(emailList, function (email) {
                resultStr = resultStr + '"' + email + '",';
            });

            if (emailList.length > 0) {
                resultStr = resultStr.substring(0, resultStr.length - 1);
            }

            resultStr += ']';
            return resultStr;
        }
    }
})();
(function () {
  angular
    .module('app')
    .controller('client.account', accountListCtrl);


  function accountListCtrl($scope, Resource, ngTableParams, dataService, calcDateService, $state, goDashboard, $uibModal, csvSaver) {
    var vm = $scope;
    vm.Config = null;
    var Common = Resource.Common.Reflect;
    var List = Resource.Customer.List;
    vm.status = 'all';
    vm.isSeller = null;
    vm.channel = '';
    vm.seller = 'all';
    var GetSaler = Resource.Management.GetSaler;

    function init() {
      GetSaler.query({}, function (data) {
        vm.isSeller = data;
      });
      Common.get({}, function (data) {
        vm.Config = data;
        vm.Config.channel_id[0] = '空渠道';
        vm.channelList = data.channel_id;
        getAccountList();
      });
    }

    vm.searchTypeList = [{
      text: '全部',
      type: 'all'
    }, {
      text: '搜索',
      type: 'search_config'
    }, {
      text: '推荐',
      type: 'rec_config'
    }, {
      text: '爬虫',
      type: 'spider_config'
    }, {
      text: '广告',
      type: 'ad'
    }, {
      text: '涉黄',
      type: 'porn'
    }, {
      text: '涉政',
      type: 'politic'
    }, {
      text: '反动',
      type: 'reaction'
    }, {
      text: '低质量',
      type: 'nonsense'
    }, {
      text: '分类',
      type: 'classify'
    }, {
      text: '标签',
      type: 'tagging'
    }, {
      text: '感情',
      type: 'sentiment'
    }, {
      text: '统计',
      type: 'static_config'
    }];

    // Default search value
    vm.managers = dataService.managers;
    vm.statuses = dataService.statuses;
    vm.manager = dataService.nickname;
    vm.master = dataService.master;
    vm.source = 'all';
    vm.status = 'all';
    vm.isOnline = '1';
    vm.searchType = 'all';
    vm.app_name = '';

    vm.period = {
      start: calcDateService.basedToday(-730),
      end: calcDateService.basedToday(0)
    }
    vm.download = function(){
      List.get({
        start_date: vm.period.start,
        end_date: vm.period.end,
        is_exported: 1,
        number: 100000,
        start: 0
      }, function(data){
        csvSaver(data.data, data.file_name)
      })
    }
    vm.filterList = function (item) {
      function showName() {
        return vm.app_name == '' || vm.Config.appid[item.appid].company_name.indexOf(vm.app_name) > -1 || vm.Config.appid[item.appid].app_name.indexOf(vm.app_name) > -1 || item.appid.toString().indexOf(vm.app_name) > -1;
      }

      function showSeller() {
        return vm.seller == 'all' || item.manager_id == vm.seller;
      }

      function showStatus() {
        return item.status == vm.status || vm.status == 'all';
      }

      function showChannel() {
        return vm.channel == '' || item.channel_name == vm.channel;
        // return vm.channel == 0 || item.channel_id == vm.channel;
      }

      // function showIsOnline() {
      //   return item.is_online == vm.isOnline || vm.isOnline == 'all';
      // }

      function showSearchType() {
        if (vm.searchType != 'all' && vm.searchType.indexOf('_') == -1) {
          if (item.nlpdetail == null) {
            return false
          } else {
            item = item.nlpdetail;
          }
        }
        return vm.searchType == 'all' || item[vm.searchType] == 1;
      }

      return showStatus() &&
        showChannel() &&
        showSeller() &&
        // showIsOnline() &&
        showSearchType() &&
        showName();
    };

    vm.doDashboard = function (id) {
      goDashboard(id);
    }
    vm.create = function () {
      $state.go('client.account').then(function () {
        $state.go('client.account.item');
      });
    };

    function table() {
      vm.tableParams = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer, params) {
          var req = {
            start: (params.page() - 1) * params.count(),
            number: params.count()
          };
          vm.handleListData(req);
          params.total(vm.data.total);
          $defer.resolve(vm.data.list);
        }
      });
    }

    function getAccountList() {
      List.get({
        start: 0,
        number: 10e5
      }, function (data) {
        vm.list = data.ret_list;
        vm.tmpTotal = vm.list.length;
        table();
      });
    }


    vm.handleListData = function (req) {
      vm.data = {
        list: null,
        total: null
      };
      var list = [];
      vm.list.map(function (value) {
        value.channel_name = vm.Config.channel_id[value.channel_id];
        if (['销售', '其他', '市场', '空渠道'].indexOf(value.channel_name) === -1) {
          value.channel_name = '市场';
        }
        if (vm.filterList(value)) {
          list.push(value);
        }
      });
      vm.data.list = list.slice(req.start, req.start + req.number);
      vm.data.total = list.length;
    };

    vm.search = function () {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    };

    init();

    vm.edit = function (item) {
      var object = item;
      var accountDialog = $uibModal.open({
        animation: true,
        templateUrl: 'account-dialog',
        controller: 'accountDialog',
        resolve: {
          accountDialogData: function () {
            return item ? item.appid : null;
          }
        }
      });

      accountDialog.result.then(function (data) {
        if (!data) {
          return false;
        }
        switch (data.type) {
          case 'update':
            Common.get({}, function (data) {
              vm.Config = data;
              vm.channelList = data.channel_id;
            });
            for (key in object) {
              object[key] = data.data[key];
            }
            break;
          case 'post':
            $state.reload();
            break;
        }
      });
    }
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .controller('client.API', recommendationAPI);

  recommendationAPI.inject = ['$scope', 'Resource', 'ngTableParams', '$filter', 'dataService', '$window', '$httpParamSerializer', 'calcDateService', 'goDashboard'];

  function recommendationAPI($scope, Resource, ngTableParams, $filter, dataService, $window, $httpParamSerializer, calcDateService, goDashboard) {
    var vm = $scope;
    var API = Resource.Customer.API;
    var Config = Resource.Common.Reflect;
    
    vm.data_date = calcDateService.basedToday(-1);
    vm.status = 'all';
    vm.searchOnlyByDate = true
    vm.name = ''

    vm.showItem = function (manager) {
      return (manager === dataService.nickname || dataService.master);
    }

    vm.doDashboard = function (id) {
      goDashboard(id);
    }

    Config.get({}, function (data) {
      vm.Config = data;
    });

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10000
    }, {
      getData: function ($defer, params) {
        if (params.settings().vm == null) {
          params.settings().vm = vm
        }
        var req = {
          start: 0,
          number: 10000,
          data_date: vm.data_date,
          q: vm.name ? vm.name : null
        }
        API.get(req, function (data) {
          params.total(data.total)
          $defer.resolve($filter('orderBy')(data.items, params.orderBy()))
        })
      }
    })


    vm.search = function () {
      vm.tableParams.reload()
    }
  }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('account.open', openCtrl);


    function openCtrl($scope, Resource, ngTableParams, $uibModal, reviewFilterGroup, goDashboard, $q) {
        var vm = $scope;
        var GetSalerRes = Resource.Management.GetSaler;
        var CurrentUserRoles = Resource.Common.CurrentUserRoles;

        vm.params = {
            status: 0,
            manager: undefined
        };

        vm.query = {
            keyword: undefined
        };

        vm.filterNavbarBtnSwitch = {
            status: {
                title: '状态',
                list: [
                    {name: '待审核'},
                    {name: '已开通'}
                ]
            }
        };

        $q.all([
            GetSalerRes.query({}).$promise,
            CurrentUserRoles.query({}).$promise
        ]).then(function (data) {
            console.log(data);
            vm.seller = data[0];
            vm.roleList = data[1];

            vm.seller.unshift({
                user_id: undefined,
                user_nickname: '全部'
            });
            // vm.searchValue.seller = vm.seller[0];

            if (vm.roleList.indexOf('销售部leader') > -1 || vm.roleList.indexOf('Administrator') > -1) {
                vm.isManager = true;
            } else if (vm.roleList.indexOf('销售部') > -1) {
                vm.isOnlySeller = true;
            }
        });

        vm.update = function(key, index) {
            vm.params[key] = index;
            vm.search();
        }

        vm.search = function() {
            vm.tableParams.reload();
        }

        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
          }, {
            getData: function ($defer, params) {
                var req = {
                    status: vm.params.status,
                    manager: vm.params.manager
                };
                
            //   AccountList.get(req, function (data) {
            //     params.total(data.total)
            //     $defer.resolve($filter('orderBy')(data.items, params.orderBy()))
            //   })
            }
        });

        vm.edit = function(id) {
            $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'client-account-dialog',
                controller: 'clientAccountCtrl',
                resolve: {}
            });
        };

        vm.examine = function() {
            $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: 'examine-account-dialog',
                controller: 'examineCtrl',
                resolve: {}
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .controller('account.management', managementCtrl);

    // managementCtrl.inject = ['$scope', 'Resource', 'ngTableParams', '$uibModal',  'reviewFilterGroup', 'goDashboard', '$q'];

    function managementCtrl($scope, Resource, ngTableParams, $uibModal, reviewFilterGroup, goDashboard, $q) {
        var vm = $scope;
        var GetSalerRes = Resource.Management.GetSaler;
        var CurrentUserRoles = Resource.Common.CurrentUserRoles;
        var AccountList = Resource.Customer.List;

        vm.params = {
            accountType: 0,
            functionActivated: 0,
            status: 0,
            manager: undefined
        };

        vm.filterNavbarBtnSwitch = {
            accountType: {
                title: '账号类型',
                list: [
                    {name: '客户账号'},
                    {name: '内部测试'},
                    {name: '合作账号'}
                ]
            },
            functionActivated: {
                title: '开通功能',
                list: [
                    {name: '全部'},
                    {name: '文本审核'},
                    {name: '文本分类'},
                    {name: '标签提取'},
                    {name: '情感分析'},
                    {name: '推荐引擎'},
                    {name: '搜索引擎'},
                    {name: '数据抓取'}
                ]
            },
            status: {
                title: '状态',
                list: [
                    {name: '全部'},
                    {name: '测试'},
                    {name: '上线'},
                    {name: '关闭'}
                ]
            }
        };

        vm.query = {
            keyword: undefined
        };

        $q.all([
            GetSalerRes.query({}).$promise,
            CurrentUserRoles.query({}).$promise
        ]).then(function (data) {
            console.log(data);
            vm.seller = data[0];
            vm.roleList = data[1];

            vm.seller.unshift({
                user_id: undefined,
                user_nickname: '全部'
            });
            // vm.searchValue.seller = vm.seller[0];

            if (vm.roleList.indexOf('销售部leader') > -1 || vm.roleList.indexOf('Administrator') > -1) {
                vm.isManager = true;
            } else if (vm.roleList.indexOf('销售部') > -1) {
                vm.isOnlySeller = true;
            }
        });

        vm.update = function(key, index) {
            vm.params[key] = index;
            vm.search();
        }

        vm.search = function() {
            vm.tableParams.reload();
        }

        vm.tableParams = new ngTableParams({
            page: 1,
            count: 10
          }, {
            getData: function ($defer, params) {
                var req = {
                    accountType: vm.params.accountType,
                    functionActivated: vm.params.functionActivated,
                    status: vm.params.status,
                    manager: vm.params.manager
                };
                
            //   AccountList.get(req, function (data) {
            //     params.total(data.total)
            //     $defer.resolve($filter('orderBy')(data.items, params.orderBy()))
            //   })
            }
        });

        vm.create = function(id, type) {
            var templateUrl = '';
            var controller = '';
            var resolve = {};
            if(type == 0) {//客户账号
                templateUrl = 'client-account-dialog';
                controller = 'clientAccountCtrl';
            } else {//非客户账号
                templateUrl = 'other-account-dialog';
                controller = 'otherAccountCtrl';
            }
            $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: templateUrl,
                controller: controller,
                resolve: resolve
            });
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('warp', warp);

  warp.inject = ['$timeout'];

  function warp($timeout) {
    var directive = {
      restrict: 'E',
      template: template,
      transclude: true,
      replace: true,
      link: link
    };

    function link() {
      function addToggleButton() {
        var toggleButton = $('#toggleSide');
        toggleButton.click(function () {
          if ($('.main-sidebar').css('display') == 'none') {
            $(this)
              .css('left', '230px')
              .children('span')
              .removeClass('glyphicon-chevron-right')
              .addClass('glyphicon-chevron-left');
            $('.main-sidebar').css('display', 'block');
            $('.content-wrapper')
              .css('margin-left', '230px')
              .removeClass('wide');
          } else {
            $(this)
              .css('left', '0')
              .children('span')
              .removeClass('glyphicon-chevron-left')
              .addClass('glyphicon-chevron-right');
            $('.main-sidebar').css('display', 'none');
            $('.content-wrapper')
              .css('margin-left', '0')
              .addClass('wide');
          }
        })
      };

      $timeout(addToggleButton, 1000)
    }

    function template() {
      var sideTplUrl = "'src/common/sidebar/sidebar.html'";
      var headerTplUrl = "'src/common/header/header.html'";
      return '<div class="wrapper">' +
        '<ng-include src="' + headerTplUrl + '"></ng-include>' +
        '<ng-include src="' + sideTplUrl + '"></ng-include>' +
        '<div class="content-wrapper clearfix"><div ng-transclude></div></div>' +
        '<div id="toggleSide"><span class="glyphicon glyphicon-chevron-left"></span></div>' +
        '</div>'
    }

    return directive;

  }
})();
(function () {
  angular
    .module('app')
    .directive('fixedContent', fixedContent);

  function fixedContent() {
    return {
      replace: true,
      restrict: 'E',
      template: template,
      transclude: true,
      link: link,
      scope: {
        title: '=',
        goState: '=',
        wide: '=',
        itemClass: '='
      }
    };

    function link(scope, element) {
      if (scope.wide) {
        element.css('left', 180);
      }
      if (scope.itemClass) {
        element.addClass(scope.itemClass)
      }
    }

    function template(element, attr) {
      return '<div class="fixed-content" id="fixed-content">' +
        '<div class="fixed-content-box widget">' +
        '<header>' +
        '<h3 ng-bind="title"></h3>' +
        '<div class="widget-controls">' +
        '<a ui-sref="{{goState}}" class="close" data-widgster="close"><i class="glyphicon glyphicon-remove"></i></a></div>' +
        '</header><div class="body" ng-transclude></div></div>' +
        '</div>';
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('userPublic', userPublic);

  function userPublic($scope, Resource, $state, $uibModal) {
    var vm = $scope;
    var Personal = Resource.Common.Personal;

    vm.password = {
      login_passwd: '',
      login_passwd_old: ''
    };
    vm.tmp = {
      repeatPasswd: ''
    };
    vm.tel = {
      tel: ''
    };

    vm.clean = function (key) {
      for (var i in vm[key]) {
        vm[key][i] = '';
      }
      if (key == 'password') {
        vm.tmp.repeatPasswd = '';
      }
      vm[key + 'Form'].$setPristine();
    };

    Personal.get({}, function(data){
      if (data.tel) {
        vm.tel.tel = data.tel;
      }
    });

    vm.confirm = function () {
      var changeTelDialog = $uibModal.open({
        animateion: true,
        templateUrl: 'change-tel-dialog',
        controller: 'changeTelDialog',
        resolve: {
          changeTelDialogData: vm.tel
        }
      });

      changeTelDialog.result.then(function (data) {
      })
    };

    vm.submit = function (key) {
      Personal.update(vm[key], function () {
        successTip('修改成功');
      }, function (data) {
        errorTip(data.data.message);
      })
    }
  }
})();
(function () {
  angular.module('app').controller('textReview', textReview);

  textReview.inject = ['$scope', 'WarpState'];

  function textReview($scope, WarpState) {
    var vm = $scope;
    var menuList = {
      'manualReview': '人工审核',
      'feedback': '反馈数据'
    };

    function change(name) {
      vm.title = menuList[name.replace('textReview.', '')]
    }

    change(WarpState.currentName.replace('textReview.', ''));

    WarpState.stateChange(change);

    WarpState.goChild('textReview', 'textReview.feedback');
  }
})();
(function () {
    'use strict';
  
    angular.module('app').controller('strategyPerformanceStatisticsCtrl', strategyPerformanceStatisticsCtrl);
    strategyPerformanceStatisticsCtrl.$inject = ['$scope', 'WarpState'];
  
    function strategyPerformanceStatisticsCtrl($scope, WarpState) {
      var vm = $scope;
      var childList = ['小时级APP调用', '小时级总体调用', '天级APP调用', '天级总体调用', 'APP处理时间分布' ,'总体处理时间分布'];
      vm.childStr = '';
  
      function change(name) {
        switch (name) {
          case 'strategyPerformanceStatistics.hourlyApp':
            vm.childStr = childList[0];
            break;
          case 'strategyPerformanceStatistics.hourlyWhole':
            vm.childStr = childList[1];
            break;
          case 'strategyPerformanceStatistics.dayApp':
            vm.childStr = childList[2];
            break;
          case 'strategyPerformanceStatistics.dayWhole':
            vm.childStr = childList[3];
            break;
          case 'strategyPerformanceStatistics.appTimeProcess':
              vm.childStr = childList[4];
              break;
          case 'strategyPerformanceStatistics.wholeTimeProcess':
              vm.childStr = childList[5];
              break;
          default:
            vm.childStr = '';
        }
      }
  
      change(WarpState.currentName);
      WarpState.stateChange(change);
    }
  })();
(function () {
  'use strict';

  angular.module('app').controller('strategyEffectStatisticsCtrl', strategyEffectStatisticsCtrl);
  strategyEffectStatisticsCtrl.$inject = ['$scope', 'WarpState'];

  function strategyEffectStatisticsCtrl($scope, WarpState) {
    var vm = $scope;
    var childList = ['小时级策略效果', '小时级总体效果', '天级策略效果', '天级总体效果','统计白名单'];
    vm.childStr = '';

    function change(name) {
      switch (name) {
        case 'strategyEffectStatistics.hourly':
          vm.childStr = childList[0];
          break;
        case 'strategyEffectStatistics.hourlyOverall':
          vm.childStr = childList[1];
          break;
        case 'strategyEffectStatistics.day':
          vm.childStr = childList[2];
          break;
        case 'strategyEffectStatistics.dayOverall':
          vm.childStr = childList[3];
          break;
        case 'strategyEffectStatistics.whiteList':
            vm.childStr = childList[4];
            break;
        default:
          vm.childStr = '';
      }
    }

    change(WarpState.currentName);
    WarpState.stateChange(change);
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('serviceAlarmCtrl', serviceAlarmCtrl);


  function serviceAlarmCtrl($scope, Resource, ngTableParams, $uibModal, goDashboard, dataService, calcDateService) {
    var vm = $scope;
    var List = Resource.ServiceAlarm.List;
    var GetSaler = Resource.Management.GetSaler;
    var CurrentUserRoles = Resource.Common.CurrentUserRoles;
    var Config = Resource.Common.Reflect;

    Config.get(function (data) {
      vm.tableSellerList = data.manager_id;
      vm.tableSellerList[0] = '无';
    });
    vm.isManager = false;
    vm.isSeller = false;
    vm.currentUserRoles = [];
    vm.canFollow = false;
    vm.canReview = false;
    var canFollowList = ['销售部', '技术部-推荐组', '技术部-搜索组', '技术部-文本组', '项目部'];
    CurrentUserRoles.query(function (data) {
      vm.currentUserRoles = data;
      if (vm.currentUserRoles.indexOf('项目部leader') > -1 || vm.currentUserRoles.indexOf('Administrator') > -1) {
        vm.isManager = true;
        vm.canReview = true;
      }
      if (vm.currentUserRoles.indexOf('销售部') > -1) {
        vm.isSeller = true;
      }
      if (vm.currentUserRoles.some(function (t) {
          return canFollowList.indexOf(t) > -1
        })) {
        vm.canFollow = true;
      }
    });

    vm.filterDate = {
      start: calcDateService.basedToday(-6) + ' 00:00:00',
      end: calcDateService.basedToday(0) + ' 23:59:59'
    };

    function handleServiceAlarmDialog(id, type) {
      return $uibModal.open({
        animation: true,
        size: 'md',
        templateUrl: 'service-alarm-dialog',
        controller: 'serviceAlarmDialog',
        resolve: {
          serviceAlarmDialogData: function () {
            return {
              id: id,
              isManager: vm.isManager,
              type: type
            };
          }
        }
      });
    }


    vm.salerList = [];
    GetSaler.query({
      url: 'service_alarm'
    }, function (data) {
      vm.sellerList = data;
      vm.sellerList.unshift({
        user_id: null,
        user_nickname: '全部'
      });
    });

    var allFilter = {
      name: '全部',
      value: null
    };

    vm.filterMapping = {
      status: '报警状态',
      alarm_api: '功能',
      alarm_type: '报警类型'
    };

    vm.ALARM_STATUS_MAPPING = dataService.alarm_mapping.alarm_status;
    vm.ALARM_TYPE_MAPPING = dataService.alarm_mapping.alarm_type;
    vm.ALARM_API_MAPPING = dataService.alarm_mapping.alarm_api;
    vm.alarmFilter = {
      status: {
        name: '报警状态',
        list: [
          allFilter, {
            name: '未处理',
            value: 0
          }, {
            name: '跟进中',
            value: 1
          }, {
            name: '已解决',
            value: 3
          }, {
            name: '待审核',
            value: 2
          }
        ]
      },
      alarm_api: {
        name: '功能',
        list: [
          allFilter, {
            name: '文本自动审核',
            value: 'check_config'
          },
          {
            name: '文本自动分类',
            value: 'classify'
          }, {
            name: '文本标签提取',
            value: 'tagging'
          }, {
            name: '文本情感分析',
            value: 'sentiment'
          }, {
            name: '推荐引擎',
            value: 'rec'
          }, {
            name: '搜索引擎',
            value: 'search'
          }, {
            name: '数据上报',
            value: 'static'
          }
        ],
        show: function () {
          return vm.currentUserRoles.some(function (t) {
            return ['技术部-搜索组', '技术部-推荐组', '技术部-文本组'].indexOf(t) == -1;
          });
        }
      },
      alarm_type: {
        name: '报警类型',
        list: [
          allFilter,
          {
            name: '开始调用',
            value: 'start'
          }, {
            name: '停止调用',
            value: 'stop'
          }, {
            name: '调用量上升30%',
            value: 'increase'
          }, {
            name: '调用量下降30%',
            value: 'decrease'
          }
        ]
      }
    };

    vm.searchValue = {};
    ['status', 'alarm_api', 'alarm_type', 'manager_id', 'keyword'].map(function (t) {
      vm.searchValue[t] = null;
    });


    vm.doDashboard = function (id) {
      goDashboard(id);
    };

    vm.handleHighLightString = function (string) {
      var highLightString = string.substring(string.indexOf('调用') + 2);
      var spanString = '<span class="ui-select-highlight">' + highLightString.substr(1) + '</span>';
      return string.replace(highLightString, '量' + spanString);
    };

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        var requestParams = angular.copy(vm.searchValue);
        requestParams.start = (params.page() - 1) * params.count();
        requestParams.number = params.count();
        requestParams.manager_id = requestParams.manager_id === '' ? null : requestParams.manager_id;
        requestParams.start_date = vm.filterDate.start;
        requestParams.end_date = vm.filterDate.end;
        List.get(requestParams, function (data) {
          $defer.resolve(data.ret_list);
          params.total(data.ret_number);
        });
      }
    });

    vm.search = function () {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    };

    vm.edit = function (id, type) {
      var serviceAlarmDialog = handleServiceAlarmDialog(id, type);
      serviceAlarmDialog.result.then(function (data) {
        if (data) {
          vm.search();
        }
      });
    }

  }

})();
(function () {
  angular.module('app').controller('searchConfigCtrl', searchConfigCtrl);

  function searchConfigCtrl($scope, Resource, ngTableParams, handleReqObj,WarpState, $state) {
    var vm = $scope;
    var List = Resource.SearchConfig.List;
    vm.searchValue = {
      app_id: null
    };

    vm.search = function () {
      vm.tableParams.page(1);
      vm.reload();
    };

    WarpState.activeCurrentState('searchConfig', function () {
      vm.reload();
    });

    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        var req = handleReqObj.handleTableParams(vm.searchValue, params);
        List.get(req, function (data) {
          $defer.resolve(data.ret_list);
          params.total(data.ret_number);
        });
      }
    });

    vm.reload = vm.tableParams.reload;
  }
})();
(function () {
    angular.module('app').controller('reviewDict', reviewDict);

    reviewDict.$inject = ['$scope', 'Resource', 'ngTableParams', '$uibModal'];


    function reviewDict($scope, Resource, ngTableParams, $uibModal) {
        var vm = $scope;
        var ReviewDictListRes = Resource.ReviewDict.ReviewDictList;
        var DeleteReviewDictItemRes = Resource.ReviewDict.DeleteReviewDictItem;

        vm.filter = {
            appid: undefined,
            type: undefined,
            level: undefined,
            pinyin: undefined
        };

        vm.query = {
            word: undefined
        };

        function tableInit() {
            vm.ngTableParams = new ngTableParams({
                page: 1,
                count: 10
            }, {
                getData: function ($defer, params) {
                    var pageParams = {
                        start: (params.page() - 1) * params.count(),
                        number: params.count()
                    };
                    var req = angular.extend({}, pageParams, vm.filter, vm.query);
                    ReviewDictListRes.get(req, function (data) {
                        params.total(data.total);
                        $defer.resolve(data.items.map(function (item) {
                            return item;
                        }));
                        vm.typeList = data.typeList;
                        vm.levelList = data.levelList;
                        vm.pinyinList = data.pinyinList;
                        vm.appidList = data.appidList;
                    });
                }
            });
        }

        vm.reload = function () {
            vm.ngTableParams.reload();
        }

        vm.delete = function (word_infoid) {
            DeleteReviewDictItemRes.update({
                primaryKey: word_infoid
            }, {}, function (res) {
                vm.reload();
            });
        }

        vm.add = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'reviewdict-dialog',
                controller: 'reviewdictDialog',
                resolve: {
                    reviewdictDialogData: function() {
                        return {
                            typeList: vm.typeList,
                            levelList: vm.levelList,
                            pinyinList: vm.pinyinList
                        }
                    }
                }
            }).result.then(function() {
                vm.reload();
            });
        }
        //init data
        tableInit();
    }
})();
(function () {
  'use strict';

  angular.module('app').controller('recDebugCtrl', recDebugCtrl);
  recDebugCtrl.$inject = ['$scope', 'WarpState'];

  function recDebugCtrl($scope, WarpState) {
    var vm = $scope;
    var childList = ['个性化推荐', '相关推荐', '热门推荐', '推荐结果检查'];
    vm.childStr = '';

    function change(name) {
      switch (name) {
        case 'recDebug.personal':
          vm.childStr = childList[0];
          break;
        case 'recDebug.related':
          vm.childStr = childList[1];
          break;
        case 'recDebug.hot':
          vm.childStr = childList[2];
          break;
          case 'recDebug.review':
            vm.childStr = childList[3];
            break;
        default:
          vm.childStr = '';
      }
    }

    change(WarpState.currentName);
    WarpState.stateChange(change);
  }
})();
(function () {
  'use strict';

  angular.module('app').controller('recConfigCtrl', recConfigCtrl);
  recConfigCtrl.$inject = ['$scope', 'WarpState'];

  function recConfigCtrl($scope, WarpState) {
    var vm = $scope;

    function change(name) {
      switch (name) {
        case 'recConfig.actionConfig':
          vm.subTitle = '行为配置';
          break;
        case 'recConfig.hotRecConfig':
          vm.subTitle = '热门推荐配置';
          break;
        case 'recConfig.mergeConfig':
          vm.subTitle = 'merge条件配置';
          break;
        case 'configManage.basicConfig':
          vm.subTitle = '基础配置';
          break;
        case 'configManage.timeConfig':
          vm.subTitle = '时效性配置';
          break;
        case 'configManage.relatedSuggestConfig':
          vm.subTitle = '相关推荐配置';
          break;
        case 'configManage.diversityConfig':
          vm.subTitle = '多样性配置';
          break;
      }
    }
    change(WarpState.currentName);
    WarpState.stateChange(change);
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('public', statisticsPublic);

  function statisticsPublic() {

  }

})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('projectCtrl', projectCtrl);
  projectCtrl.$inject = ['$scope', 'WarpState'];
  function projectCtrl($scope, WarpState) {
    var vm = $scope;

    vm.childList = {
      testApplication: '测试申请'
    };

    vm.title = '';

    function change(name) {
      vm.title = vm.childList[name.replace('project.', '')];
    }

    change(WarpState.currentName);

    WarpState.stateChange(change);
  }
})();
(function () {
  'use strict';

  angular.module('app').controller('orderCtrl', orderCtrl);
  orderCtrl.inject = ['$scope', 'WarpState'];

  function orderCtrl($scope, WarpState) {
    var childList = ['订单列表', '订单录入'];
    $scope.childStr = '';
    function change(name) {
      switch (name) {
        case 'order.list':
          $scope.childStr = childList[0];
          break;
        case 'order.update':
          $scope.childStr = childList[1];
          break;
        default:
          $scope.childStr = '';
      }
    }

    change(WarpState.currentName);
    WarpState.stateChange(change);
  }
})();
(function () {
    'use strict';
  
    angular.module('app').controller('offlineCtrl', offlineCtrl);
    offlineCtrl.$inject = ['$scope', 'WarpState'];
  
    function offlineCtrl($scope, WarpState) {
      var vm = $scope;
      var childList = ['离线数据', '离线热门结果', '离线相关推荐结果'];
      vm.childStr = '';
  
      function change(name) {
        switch (name) {
          case 'offline.data':
            vm.childStr = childList[0];
            break;
          case 'offline.hot':
            vm.childStr = childList[1];
            break;
          case 'offline.rec':
            vm.childStr = childList[2];
            break;
         
          default:
            vm.childStr = '';
        }
      }
  
      change(WarpState.currentName);
      WarpState.stateChange(change);
    }
  })();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('nlp', nlp);

  nlp.inject = ['$scope', 'Resource', 'ngTableParams', '$uibModal'];

  function nlp($scope, Resource, ngTableParams, $uibModal) {
    var vm = $scope;
    var Config = Resource.Common.Reflect;
    var List = Resource.NLP.Sep.List;
    var Item = Resource.NLP.Sep.Item;

    vm.POS = {
      n: '名词',
      nr: '人名',
      ns: '地名',
      nt: '机构团体名',
      t: '时间',
      v: '动词',
      a: '形容词',
      m: '数词',
      o: '其他， 默认'
    };

    vm.tooltip = function (pos) {
      if (vm.POS[pos]) {
        return vm.POS[pos];
      } else {
        return vm.POS.o;
      }
    };

    vm.query = {
      keyword: null,
      is_pos: 3
    };
    Config.get({}, function (data) {
      vm.masters = data.manager_id;
    });

    vm.stringToArray = function (string) {
      if (string) {
        return JSON.parse(string)
      } else {}
    };

    vm.search = function () {
      vm.nlpList.page(1);
      vm.reload();
    };

    vm.reload = function () {
      vm.nlpList.reload();
    };

    vm.edit = function (item, type) {
      if (type) {
        item.type = type;
      }
      var nlpEditDialog = $uibModal.open({
        animation: true,
        templateUrl: 'nlp-dialog',
        controller: 'nlpDialog',
        resolve: {
          nlpEditDialogData: function () {
            return item;
          }
        }
      });

      nlpEditDialog.result.then(function (data) {
        if (!data) {
          return false;
        }
        if (item) {
          Item.update({
            id: item.id,
            content_sep_person: data,
            is_pos: type == 'pos' ? 1 : 0
          }, function () {
            vm.reload();
          })
        } else {
          List.save(data, function () {
            vm.reload();
          })
        }
      });
    };
    vm.nlpList = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        List.get({
          is_pos: Number(vm.query.is_pos) === 3 ? null : vm.query.is_pos,
          start: (params.page() - 1) * params.count(),
          number: params.count(),
          keyword: vm.query.q
        }, function (data) {
          params.total(data.ret_number);
          $defer.resolve(data.ret_list);
        })
      }
    })

  }
})();
(function () {
  angular.module('app').controller('management', management);
  management.inject = ['WarpState'];
  function management(WarpState) {
    WarpState.goChild('management', 'management.user');
  }
})();
(function() {
  "use strict";
  angular.module("app").controller("LoginCtrl", LoginCtrl);

  function LoginCtrl($scope, Resource, $window, $cookies, $state, jwtHelper) {
    var vm = $scope;
    var Login = Resource.Login.Login;
    vm.loginform = {};
    vm.loginform.rememberMe = true;
    vm.verify = false;
    vm.disable = false;
    vm.login = function() {
      if (!vm.loginForm.$valid) return false;
      vm.postdata = {
        login_name: vm.loginform.username,
        login_passwd: vm.loginform.passwd
        // rememberMe: vm.loginform.rememberMe || ''
      };
      vm.disable = true;
      Login.save(
        vm.postdata,
        function(res) {
          vm.disable = false;
          $cookies.put("nickname", res.nickname);
          // $cookies.putObject('roleList', res.role_name_list);
          // save token in local storage
          localStorage.setItem("token", res.access_token);
          localStorage.setItem("refreshToken", res.refresh_token);
          var tokenPayload = jwtHelper.decodeToken(res.access_token);
          console.log(tokenPayload);
          $state.go("home");
        },
        function(err) {
          vm.message = err.data.message;
          vm.disable = false;
        }
      );
    };
  }
})();

(function () {
    'use strict';
  
    angular.module('app').controller('dataUpReportCtrl', dataUpReportCtrl);
    dataUpReportCtrl.$inject = ['$scope', 'WarpState'];
  
    function dataUpReportCtrl($scope, WarpState) {
      var vm = $scope;
      var childList = ['总体产品信息上报', 'app产品信息上报', '天级APP行为数据上报', '小时级APP行为数据上报', '总体行为数据上报'];
      vm.childStr = '';
  
      function change(name) {
        switch (name) {
          case 'dataUpReport.totalProductUpReport':
            vm.childStr = childList[0];
            break;
          case 'dataUpReport.appProductUpReport':
            vm.childStr = childList[1];
            break;
          case 'dataUpReport.dayActionUpReport':
            vm.childStr = childList[2];
            break;
          case 'dataUpReport.hourlyActionUpReport':
            vm.childStr = childList[3];
            break;
          case 'dataUpReport.totalActionUpReport':
              vm.childStr = childList[4];
              break;
          default:
            vm.childStr = '';
        }
      }
  
      change(WarpState.currentName);
      WarpState.stateChange(change);
    }
  })();
(function () {
  angular
    .module('app')
    .controller('HomeCtrl', HomeCtrl);


  function HomeCtrl($scope) {
    var vm = $scope;
    vm.tableData = [];
    vm.tableDataLength = -1;
    vm.isString = function (test) {
      return angular.isString(test);
    };
    vm.showTable = true;

    vm.className = {
      new: 'fa-plus bg-aqua',
      fixed: 'fa-wrench bg-yellow',
      better: 'fa-smile-o bg-purple',
    };

    vm.author = {
      gaoxiang: {
        name: '高翔',
        mail: 'gaoxiang@datagrand.com'
      },
      yehui: {
        name: '赵业辉',
        mail: 'zhaoyehui@datagrand.com'
      },
      pengzhong: {
        name: '张鹏中',
        mail: 'zhangpengzhong@datagrand.com'
      },
      lieyu: {
        name: '施列宇',
        mail: 'shilieyu@datagrand.com'
      },
      gongjie: {
        name: '龚洁',
        mail: 'gongjie@datagrand.com'
      }
    };

    vm.mail = function (author) {
      if (!author) {
        return false;
      }
      var copyMailList = '';
      author.map(function (value, index) {
        if (author.length - 1 === index) {
          copyMailList += value.mail
        } else {
          copyMailList += (value.mail + ';')
        }
      });
      return copyMailList;
    };

    vm.events = [
      '2017/09/29',
      {title: '推荐debug',	desc: 'user_click增加推荐时间字段', author: [vm.author.gongjie, vm.author.lieyu]},
      {title: '推荐debug',	desc: '解决点击item相关推荐后页面内容不刷新问题', author: [vm.author.gongjie, vm.author.lieyu]},
      {title: '联系我们',	desc: '解决按销售筛选功能，选择筛选条件后，申请列表出现Bug', author: [vm.author.gongjie, vm.author.lieyu]},
      {title: '离线任务',	desc: '筛选客户账号和内部账号数据', author: [vm.author.gongjie, vm.author.yehui]},
      {title: '联系我们',	desc: '优化筛选项，优化申请试用列表', author: [vm.author.gongjie, vm.author.yehui]},
      {title: '申请试用数据',	desc: '新增申请试用数据模块，主要给市场运营部门试用，统计申请试用数据', author: [vm.author.gongjie, vm.author.yehui]},
      '2017/09/15',
      {title:'接口调用', desc:'修复列表页选择时间较早时，出现报错',	author: [vm.author.lieyu, vm.author.gongjie]},
      {title:'接口调用', desc:'修复查看数据详情选择时间区段起始时间较早时，折线图无法显示的问题',	author: [vm.author.lieyu, vm.author.gongjie]},
      {title:'推荐debug', desc:'修复热门推荐跳转相关推荐失败的bug',	author: [vm.author.lieyu, vm.author.gongjie]},
      '2017/09/13',
      {title: '订单管理	', desc: '订单录入保存时出现错误提示，但订单保存成功的问题', author:	[vm.author.lieyu, vm.author.gongjie]},
      {title: '服务报警	', desc: '报警邮件文案优化，与admin服务报警模块保持一致', author:	[vm.author.yehui, vm.author.gongjie]},
      {title: '微信抓取	', desc: '修复了微信号抓取模块因数据问题导致的报错', author:	[vm.author.yehui, vm.author.gongjie]},
      '2017/09/08',
      {title: '服务报警	', desc: '服务报警-报警内容线上数据未同步更新问题修复', author:[vm.author.yehui, vm.author.gongjie]},
      {title: '服务报警	', desc: '服务报警-流量波动报警邮件提醒指定收件人发送失败问题修复', author:[vm.author.yehui, vm.author.gongjie]},
      '2017/09/07',
      {title: '服务报警	', desc: '指定项目管理人员发送指定销售所负责的 app 流量波动报警邮件', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '服务报警	', desc: 'mytest1账号线上不存在，但却有调用数据。未排查出原因，已禁用账号', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '服务报警	', desc: '爬虫数据误报bug修复', author: [vm.author.yehui, vm.author.gongjie]},
      '2017/09/06',
      {title: '推荐debug	', desc: '个性化推荐参数设置优化', author: [vm.author.lieyu, vm.author.gongjie]},
      {title: '订单列表	', desc: '图片无法获取问题修复', author: [vm.author.lieyu, vm.author.gongjie]},
      {title: '接口调用	', desc: '接口调用数据导出接口调用数据定期导出并发送到指定邮件', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '接口调用	', desc: '接口调用数据详情，选择“当日”后图表中可查看当日数据', author: [vm.author.lieyu, vm.author.gongjie]},
      {title: '服务报警	', desc: '项目部角色权限修改，及部分细节优化', author: [vm.author.yehui, vm.author.gongjie]},
      '2017/08/29',
      {title: '申请测试', desc: '修复测试提醒邮件未发送的问题', author: [vm.author.yehui, vm.author.gongjie]},
      '2017/08/28',
      {title: '分词badcase', desc: '完成python前后端开发，整个模块上线', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '语料库标注', desc: '完成python前后端开发，整个模块上线', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '推荐配置', desc: '根据账号推荐功能状态自动进行推荐配置', author: [vm.author.lieyu, vm.author.gongjie]},
      {title: '申请测试', desc: '账号重复错误提示文案优化', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '菜单管理', desc: '无法添加新菜单bug修复', author: [vm.author.lieyu, vm.author.gongjie]},
      {title: '版本记录', desc: '优化版本记录', author: [vm.author.yehui, vm.author.gongjie]},
      '2017/08/22',
      {title: '服务报警', desc: '邮件发送时间调整', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '服务报警', desc: '线上数据同步更新bug修复', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '服务报警', desc: '文案优化', author: [vm.author.yehui, vm.author.gongjie]},
      '2017/08/21',
      {title: '服务报警', desc: '服务报警邮件内容优化', author: [vm.author.yehui, vm.author.gongjie]},
      '2017/08/16',
      {title: '服务报警', desc: '修复已禁用用户负责账号显示的问题', author: [vm.author.yehui, vm.author.gongjie]},
      '2017/08/08',
      {title: '账号管理', desc: '本模块查看权限问题修复', author: [vm.author.yehui, vm.author.gongjie]},
      {title: '接口调用', desc: '调用详情数据无法显示问题修复', author: [vm.author.lieyu, vm.author.gongjie]},
      {title: '推荐debug', desc: 'rec_result排序问题修复', author: [vm.author.lieyu, vm.author.gongjie]},
      {title: '推荐debug', desc: 'ec_result纵向滚动轴出现Bug', author: [vm.author.lieyu, vm.author.gongjie]},
      {title: '推荐debug', desc: 'item_modify_time数据不一致问题修复', author: [vm.author.lieyu, vm.author.gongjie]},
      '2017/08/03',
      {
        title: 'admin',
        desc: 'new admin上线',
        author: [vm.author.gaoxiang, vm.author.yehui, vm.author.lieyu, vm.author.gongjie]
      }
    ];
    // [
    //   '2017/05/22', {
    //     title: '测试申请',
    //     desc: '测试账号申请功能，提交申请、开通账号、发送邮件',
    //     author: [vm.author.yehui, vm.author.pengzhong, vm.author.gongjie]
    //   }, {
    //     title: '其他',
    //     desc: 'admin账号跳转到大数据平台问题修复',
    //     author: [vm.author.yehui, vm.author.pengzhong, vm.author.gongjie]
    //   },
    //   '2017/05/10',
    //   {
    //     title: '用户中心',
    //     desc: '原修改密码模块改为用户中心，新增修改电话号码功能',
    //     author: [vm.author.yehui, vm.author.pengzhong, vm.author.gongjie]
    //   },
    //   {
    //     title: '联系我们',
    //     desc: '下载表格数据异常问题修复',
    //     author: [vm.author.pengzhong, vm.author.gongjie]
    //   },
    //   {
    //     title: '用户管理',
    //     desc: '用户列表新增手机号信息',
    //     author: [vm.author.pengzhong, vm.author.yehui, vm.author.gongjie]
    //   },
    //   {
    //     title: '权限管理',
    //     desc: '权限修改立即生效，不需要手动退出再登录',
    //     author: [vm.author.pengzhong, vm.author.gongjie]
    //   },
    //   {
    //     title: '菜单管理',
    //     desc: '管理admin左侧菜单',
    //     author: [vm.author.pengzhong, vm.author.yehui, vm.author.gongjie]
    //   },
    //   {
    //     title: '邮件管理',
    //     desc: '管理邮件模板',
    //     author: [vm.author.pengzhong, vm.author.yehui, vm.author.gongjie]
    //   },
    //   {
    //     title: '其他',
    //     desc: '权限最小粒度',
    //     author: [vm.author.pengzhong, vm.author.gongjie]
    //   },
    //   '2017/04/21',
    //   {
    //     title: '联系我们',
    //     desc: '修复拒绝调用错误提示Bug',
    //     author: [vm.author.yehui, vm.author.gongjie],
    //   },
    //   {
    //     title: '推荐debug',
    //     desc: '修复推荐 debug 列表有的字段没有正确绑定问题	',
    //     author: [vm.author.yehui, vm.author.gongjie],
    //   },
    //   '2017/04/07',
    //   {
    //     title: '账号管理',
    //     desc: '下线账号可通过admin跳转到大数据平台',
    //     author: [vm.author.yehui, vm.author.pengzhong, vm.author.gongjie],
    //   },
    //   {
    //     title: '账号管理',
    //     desc: '修复账号状态编辑时自动恢复默认状态的问题',
    //     author: [vm.author.yehui, vm.author.gongjie],
    //   },
    //   {
    //     title: '版本记录',
    //     desc: '修复版本记录更新时间错误的问题',
    //     author: [vm.author.yehui, vm.author.gongjie],
    //   },
    //   {
    //     title: '权限管理',
    //     desc: '部门管理中不显示已被禁用的权限和用户',
    //     author: [vm.author.yehui, vm.author.gongjie],
    //   },
    //   '2017/04/06',
    //   {
    //     title: '修复渠道问题',
    //     desc: '原有APP申请试用中，只提交channel字段，没有channel id，因此联系我们中移动端来源的试用申请渠道为空',
    //     author: [vm.author.lieyu, vm.author.gongjie],
    //     icon: vm.className.new,
    //   }, {
    //     title: '增加热门推荐debug功能',
    //     desc: '之前只有个性化推荐和相关推荐的debug功能，新增热门推荐debug',
    //     author: [vm.author.pengzhong, vm.author.yehui, vm.author.gongjie],
    //     icon: vm.className.new,
    //   }, {
    //     title: '优化推荐debug界面',
    //     desc: 'alg_type一栏宽度缩小，信息展示更好',
    //     author: [vm.author.yehui, vm.author.gongjie],
    //     icon: vm.className.new,
    //   }, {
    //     title: '增加版本记录模块',
    //     desc: '登录页增加版本记录功能，记录admin版本迭代',
    //     author: [vm.author.yehui, vm.author.gongjie],
    //     icon: vm.className.new,
    //   }, {
    //     title: '修复邮件提醒问题',
    //     desc: 'eature_id =14时名称映射问题——套餐类型为unknown',
    //     author: [vm.author.pengzhong, vm.author.gongjie],
    //     icon: vm.className.new,
    //   }, {
    //     title: '优化邮件提醒功能',
    //     desc: '续费提醒邮件中增加“套餐余量占比”一项',
    //     author: [vm.author.pengzhong, vm.author.gongjie],
    //     icon: vm.className.new,
    //     action: [{
    //       link: 'management.advanced',
    //       text: '查看'
    //     }]
    //   }
    // ]

    // events to table
    vm.events.map(function (value) {
      if (vm.isString(value)) {
        vm.tableDataLength++;
        vm.tableData[vm.tableDataLength] = {
          date: value,
          events: []
        }
      } else {
        vm.tableData[vm.tableDataLength].events.push(value);
      }
    })
  }
})();
(function () {
  angular.module('app').controller('crawlCtrl', crawlCtrl);

  function crawlCtrl() {}
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('corpusAnnotationCtrl', corpusAnnotationCtrl);

  corpusAnnotationCtrl.inject = ['$scope', 'Resource', 'ngTableParams', '$uibModal', 'posConvert'];

  function corpusAnnotationCtrl($scope, Resource, ngTableParams, $uibModal, posConvert) {
    var vm = $scope;
    var Config = Resource.Common.Reflect;
    var List = Resource.NLP.CorpusAnnotation.List;
    var Item = Resource.NLP.CorpusAnnotation.Item;
    vm.posTest = '<span>我</span><span>是</span><span>中</span><span>国</span><span>人</span><span>民</span><span>警</span><span>察</span>';
    vm.POS = {
      n: '名词',
      nr: '人名',
      ns: '地名',
      nt: '机构团体名',
      t: '时间',
      v: '动词',
      a: '形容词',
      m: '数词',
      o: '其他， 默认'
    };

    vm.nerPOS = {
      'person': 'nr',
      'other': 'o',
      'location': 'ns',
      'organization': 'nt'
    }


    vm.tooltip = function (pos) {
      if (vm.POS[pos]) {
        return vm.POS[pos];
      } else {
        return vm.POS.o;
      }
    }

    vm.query = {
      q: '',
      is_pos: ''
    };
    Config.get({}, function (data) {
      vm.masters = data.manager_id;
    })

    vm.stringToArray = function (string) {
      if (string) {
        return JSON.parse(string)
      } else {}
    }

    vm.search = function () {
      vm.nlpList.page(1);
      vm.reload();
    }

    vm.reload = function () {
      vm.nlpList.reload();
    }

    vm.edit = function (item) {
      var nlpEditDialog = $uibModal.open({
        animation: true,
        templateUrl: 'corpusAnnotationdialog',
        controller: 'corpusAnnotationDialogCtrl',
        resolve: {
          corpusAnnotationEditDialogData: function () {
            return item;
          }
        }
      });

      nlpEditDialog.result.then(function (data) {
        if (!data) {
          return false;
        }
        if (item) {
          vm.reload();
        } else {
          // Item.save(data, function () {
          //   vm.reload();
          // })
        }
      });
    }

    function handleEmptyString(string) {
      return string ? string.split(' ') : [];
    }

    vm.nlpList = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        List.get({
          status: isNaN(vm.query.status) ? null : vm.query.status,
          start: (params.page() - 1) * params.count(),
          number: params.count(),
          q: vm.query.q
        }, function (data) {
          data.ret_list.map(function (value) {
            value.content_sep_person = posConvert.textToDom(value.content_sep_person);
            for (var i in value.content_ner_person) {
              value.content_ner_person[i] = handleEmptyString(value.content_ner_person[i]);
            }
          });
          // vm.edit(data.ret_list[2]); // test
          params.total(data.ret_number);
          $defer.resolve(data.ret_list);
        })
      }
    })

  }
})();
(function () {
  angular.module('app').controller('contact', recommendationCtrl);

  recommendationCtrl.inject = ['$scope', 'WarpState'];

  function recommendationCtrl($scope, WarpState) {
    var vm = $scope;
    var menuList = {
      // 'ucloud': 'ucloud',
      // 'contact': '联系我们',
      'contactUsMsg': '联系我们',
      'applyForTrialData': '申请试用数据'
    };

    function change(name) {
      vm.title = menuList[name.replace('contact.', '')]
    }

    change(WarpState.currentName);
    WarpState.stateChange(change);
  }
})();
(function () {
    'use strict';
  
    angular.module('app').controller('configManageCtrl', configManageCtrl);
    configManageCtrl.$inject = ['$scope', 'WarpState'];
    function configManageCtrl($scope, WarpState) {
      var vm = $scope;
  
      function change(name) {
        switch (name) {
          case 'recConfig.actionConfig':
            vm.subTitle = '行为配置';
            break;
          case 'recConfig.hotRecConfig':
            vm.subTitle = '热门推荐配置';
            break;
          case 'recConfig.mergeConfig':
            vm.subTitle = 'merge条件配置';
            break;
          case 'configManage.basicConfig':
            vm.subTitle = '基础配置';
            break;
          case 'configManage.timeConfig':
            vm.subTitle = '时效性配置';
            break;
          case 'configManage.relatedSuggestConfig':
            vm.subTitle = '相关推荐配置';
            break;
          case 'configManage.diversityConfig':
            vm.subTitle = '多样性配置';
            break;
        }
      }
      change(WarpState.currentName);
      WarpState.stateChange(change);
    }
  })();
(function () {
  angular.module('app').controller('client', recommendationCtrl);

  recommendationCtrl.inject = ['$scope', 'WarpState'];

  function recommendationCtrl($scope, WarpState) {
  }
})();
(function () {
  angular.module('app').controller('activityStatisticsCtrl', activityStatisticsCtrl);

  function activityStatisticsCtrl($scope, Resource, ngTableParams, handleReqObj, csvSaver) {
    var MagazineDownloadList = Resource.ActivityStatistics.MagazineDownload.List;
    var vm = $scope;
    vm.tableParams = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        var req = handleReqObj.handleTableParams({}, params);
        MagazineDownloadList.get(req, function (data) {
          $defer.resolve(data.ret_list);
          params.total(data.ret_number);
        });
      }
    });

    vm.download = function () {
      MagazineDownloadList.get({
        number: 10000,
        start: 0,
        is_exported: 1
      }, function (data) {
        csvSaver(data.data, data.file_name);
      })
    };
  }
})();
(function () {
    'use strict';
  
    angular.module('app').controller('accountCtrl', accountCtrl);
    accountCtrl.$inject = ['$scope', 'WarpState'];
  
    function accountCtrl($scope, WarpState) {
      var vm = $scope;
      var childList = ['开通申请', '账号管理','账号详情'];
      vm.childStr = '';
  
      function change(name) {
        switch (name) {
          case 'account.open':
            vm.childStr = childList[0];
            break;
          case 'account.management':
            vm.childStr = childList[1];
            break;
          default:
            vm.childStr = '';
        }
      }
  
      change(WarpState.currentName);
      WarpState.stateChange(change);
    }
  })();
(function () {
  angular
    .module('app')
    .directive('treeItem', treeItem);

  treeItem.$inject = ['$compile', '$timeout'];

  function treeItem($compile, $timeout) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        list: '=',
        level: '=',
        index: '=',
        name: '=',
        nameObject: '=',
        callbacks: '=',
        childName: '='
      },
      transclusion: true,
      link: link,
      replace: true,
      templateUrl: 'src/directive/tree/treeItem.html'
    };

    function link(scope, element) {
      var vm = scope;
      vm.child = vm.item[vm.childName];
      // 修复指令内点击事件触发两次
      var can = true;
      function activeList() {
        $timeout(iterationAccordionItem, 100);
      }

      function toggleCan() {
        can = false;
        $timeout(function () {
          can = true
        }, 200);
      }

      function afterClick(cb) {
        if (can) {
          cb();
          toggleCan();
          activeList();
        }
      }

      vm.create = function () {
        function create() {
          vm.callbacks.create(vm.item);
        }
        afterClick(create);
      };

      vm.toggleEditing = function () {
        function toggleEditing() {
          vm.item.editing = !vm.item.editing;
        }
        afterClick(toggleEditing);
      };

      vm.update = function () {
        function update() {
          vm.callbacks.update(vm.item);
        }
        afterClick(update);
      };

      function remove() {
        vm.callbacks.remove(vm.item);
      }

      vm.remove = function () {
        afterClick(remove);
      };

      vm.toggleOpen = function () {
        if (can && vm.child && vm.child.length > 0) {
          vm.item.open = !vm.item.open;
          toggleCan();
        }
      };

      if (angular.isArray(vm.child)) {
        vm.level++;
        element.find('.panel-collapse').append(
          '<div class="box-body">' +
          '<tree list="child" level="level" callbacks="callbacks" name="name" name-object="nameObject" child-name="childName"></tree>' +
          '</div>');
        $compile(element.contents())(vm);
      }
    }
  }
})();
(function () {
  angular
    .module('app')
    .directive('tree', tree);

  function tree() {
    return {
      restrict: 'E',
      scope: {
        list: '=',
        level: '=',
        callbacks: '=',
        name: '=',
        nameObject: '=',
        childName: '='
      },
      transclusion: true,
      replace: true,
      link: link,
      template: template()
    };

    function template() {
      return '<div class="box-group iteration-accordion" level="level">'+
        '<tree-item ' +
        'ng-click="active(item)" ' +
        'ng-repeat="item in list track by $index" ' +
        'item="item" ' +
        'list="list" ' +
        'callbacks="callbacks" ' +
        'index="$index"' +
        'option="option" ' +
        'item-click="itemClick()" ' +
        'name="name"' +
        'child-name="childName"' +
        'level="level"' +
        'name-object="nameObject"' +
        '></tree-item>'+
        '</div>'
    }
    function link(scope, element) {
      var vm = scope;
      var $this = $(element);
      $this.attr('accordion-level', vm.level);
    }
  }
})();
(function() {
    angular
        .module('app')
        .directive('tooltips', tooltips);

    function tooltips() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'src/directive/tooltips/tooltips.html',    
            link: link
        };
        function link(scope, tEle, tAttrs) {
            scope.params = {
                showTips: false,
                tipsMsg: tAttrs.tipsMsg,
                iconCls: tAttrs.myClass
            }
            var target = tEle.find('.tooltips');
            tEle.find('#targetIcon').bind('mouseenter', function(event) {
                var boxW = target.outerWidth();
                var boxH = target.outerHeight();
                target.css({'left': event.clientX - boxW/2 + 10, 'top': event.clientY - boxH - 15});
                target.show();
            });
            tEle.find('#targetIcon').bind('mouseleave', function(event) {
                target.hide();
            });
        }
    }
    
})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:tableBottomScrollBar
   * @description
   * 强制在表格底部使用横向纵向滚动条。
   * @restrict A
   * @element table
   * @requires $timeout
   */

  'use strict';

  angular
    .module('app')
    .directive('tableBottomScrollBar', tableBottomScrollBar);

  tableBottomScrollBar.inject = ['$timeout'];

  function tableBottomScrollBar($timeout) {

    var directive = {
      link: link,
      restrict: 'A'
    };

    return directive;

    function link(scope, element, attrs) {
      var table = $(element);
      var initHeight = null;
      var delayTime = 50;
      function setInitHeight() {
        table.css('position', 'static');
        initHeight = table.offset().top;
      }

      $timeout(setInitHeight, delayTime);

      function handleBottomScrollBar(type) {
        var offsetTop = table.offset().top;
        var offsetLeft = table.offset().left;
        var fixedRight = $(window).width() - table.width() - offsetLeft - 20;
        if (type === 'scroll') {
          var scrollTop = $(window).scrollTop();
          offsetTop = scrollTop >= initHeight ? 0 : initHeight - scrollTop;
        }

        if (attrs.tableBottomScrollBarHeight == 'screen') {
          table.css({
            position: 'fixed',
            top: offsetTop,
            bottom: 20
          });
        }
      }

      function bindScroll() {
        $(window).scroll(function () {
          handleBottomScrollBar('scroll');
        });
      }
      
      $timeout(bindScroll, delayTime)
      $timeout(handleBottomScrollBar, delayTime);
    }
  }
})();
(function () {

    /**
     * @ngdoc directive
     * @name app.directive:reviewLabelGroup
     * @description
     * 
     * @restrict E
     */


    angular
        .module('app')
        .filter('invokeLimitFilter', invokeLimitFilter)
        .directive('reviewLabelGroup', reviewLabelGroup);

    reviewLabelGroup.$inject = ['reviewFilterGroup', 'Resource', 'staticService'];

    function reviewLabelGroup(reviewFilterGroup, Resource, staticService) {
        return {
            restrict: 'E',
            template: template,
            scope: {
                title: '@',
                type: '@',
                data: '='
            },
            link: link
        };

        function link($scope, attrs) {
            var vm = $scope;

            vm.result = [];
            vm.channel = generateReflect(staticService.getChannel(), true);
            vm.functionTypeReflect = generateReflect(reviewFilterGroup.functionTypeList);
            vm.statusReflect = generateReflect(reviewFilterGroup.statusList);

            var config = {
                'client': [{
                    key: 'company_name',
                    value: '公司名称'
                }, {
                    key: 'project_name',
                    value: '项目名称'
                }, {
                    key: 'app_name',
                    value: 'app name'
                }, {
                    key: 'channel',
                    value: '客户来源'
                }],
                'base': [{
                    key: 'company_name',
                    value: '公司名称'
                }, {
                    key: 'project_name',
                    value: '项目名称'
                }, {
                    key: 'app_name',
                    value: 'app name'
                }, {
                    key: 'manager',
                    value: '负责人'
                }],
                'func': [{
                    key: 'function',
                    value: '功能'
                }, {
                    key: 'limit_num',
                    type: 'limit',
                    value: '调用限量'
                }, {
                    key: 'start_date',
                    type: 'dateStr',
                    value: '开始测试时间'
                }, {
                    key: 'end_date',
                    type: 'dateStr',
                    value: '结束测试时间'
                }],
                'editFunc': [{
                    key: 'aim_limit_num',
                    type: 'limit',
                    value: '调用限量'
                }, {
                    key: 'aim_start_date',
                    type: 'dateStr',
                    value: '开始测试时间'
                }, {
                    key: 'aim_end_date',
                    type: 'dateStr',
                    value: '结束测试时间'
                }],
                'status': [{
                    key: 'status_info',
                    value: '申请状态'
                }, {
                    key: 'create_time',
                    value: '申请时间'
                }, {
                    key: 'review_time',
                    value: '审核时间'
                }, {
                    key: 'review_time',
                    value: '审核时间'
                }],
                'personnel': [{
                    key: 'custom_manager',
                    value: '姓名'
                }, {
                    key: 'idontknow',
                    value: '职位'
                }, {
                    key: 'custom_tel',
                    value: '电话'
                }, {
                    key: 'custom_email',
                    value: '邮箱'
                }, {
                    key: 'other_email',
                    value: '其他邮箱',
                    type: 'multi'
                }, {
                    key: 'manager',
                    value: '负责人'
                }]
            }

            $scope.$watch('data', function (newData, oldData) {
                vm.result = [];
                resetData(newData);
            }, true);

            function resetData(newData) {
                var data = newData;

                if (!data) {
                    return;
                }

                if (vm.type == 'client') {
                    data.channel = !!data.channel_id ? vm.channel[data.channel_id.toString()] : undefined;
                }

                if (vm.type == 'func' || vm.type == 'editFunc') {
                    if (data instanceof Array) {
                        data = data[0];
                    }
                    vm.function_type = data.function_type;
                    if (!!data.function_type) {
                        data.function = vm.functionTypeReflect[data.function_type];
                    }
                }

                if (vm.type == 'status') {
                    if (!!data.status) {
                        data.status_info = vm.statusReflect[data.status];
                    }
                }

                if (vm.type == 'create') {
                    if (data instanceof Array) {
                        angular.forEach(data, function (item) {
                            item.function = vm.functionTypeReflect[item.function_type];
                            if (!!item.test_position) {
                                item.test_position_info = generateTestPositionInfo(item.test_position, item.function_type);
                            }
                        });

                        vm.result = data;
                    }
                    return;
                }

                angular.forEach(config[vm.type], function (item) {
                    var name = item.value;
                    var value = data[item.key];

                    if (!!value && item.type == 'dateStr') {
                        value = value.substring(0, 10);
                    }

                    if (!!value && item.type == 'multi') {
                        if (!(value instanceof Array)) {
                            value = generateArray(value);
                        }
                    }
                    vm.result.push({
                        'name': name,
                        'value': value,
                        'type': item.type
                    })
                });
            }

            vm.isNull = function (val) {
                if (!val && !(typeof (val) === 'number' && val === 0)) {
                    return true;
                }

                return false;
            }

            function generateReflect(list, isChannel) {
                var reflect = {}

                if (isChannel) {
                    angular.forEach(list, function (item, index) {
                        reflect[item.id] = item.name;
                    });
                } else {
                    angular.forEach(list, function (item) {
                        reflect[item.value] = item.name;
                    });
                }

                return reflect;
            }

            function generateArray(arrStr) {
                /**
                 * 解析数组类型的json
                 * "[]"
                 * "["123@123.com","321@321.com"]"
                 */
                var tempKey = 'temp' + new Date().getTime();
                var arrayJsonStr = '{"' + tempKey + '":' + arrStr + '}';
                var arrayJson;
                if (JSON && JSON.parse) {
                    arrayJson = JSON.parse(arrayJsonStr);
                } else {
                    arrayJson = eval('(' + arrayJsonStr + ')');
                }
                return arrayJson[tempKey];
            }

            function generateTestPositionInfo(testPosition, functionType) {
                var result = [];
                if (!functionType || !testPosition) {
                    return;
                }

                var positionList = generateArray(testPosition);


                if (functionType == 5) {
                    angular.forEach(positionList, function (position) {
                        result.push(get(position, 'app') + '-' + get(position, 'platform') + '-' + get(position, 'page') + '-' +
                            get(position, 'module') + '-' + get(position, 'rec'));
                    });
                } else if (functionType == 6) {
                    angular.forEach(positionList, function (position) {
                        result.push(get(position, 'app') + '-' + get(position, 'platform') + '-' + get(position, 'remark'));
                    });
                }

                return result;
            }

            function get(position, tag) {
                return !!position[tag] ? position[tag] : '';
            }

        }


        function template() {
            function getCreateInfoLabel() {
                /**
                 * create类型数据，特殊处理
                 */
                return '<div ng-if="type == \'create\'">' +
                    '<div class="form-group" ng-repeat="item in result">' +
                    '<div class="row">' +
                    '<label class="col-sm-3 control-label" ng-bind="item.function + \':\'"></label>' +
                    '<div class="col-sm-6">' +
                    '<p class="form-control-static" ng-bind="item.start_date.substring(0, 10) + \'--\' + item.end_date.substring(0, 10)"></p>' +
                    '</div>' +
                    '<div class="col-sm-3">' +
                    '<p class="form-control-static" ng-bind="item.limit_num | invokeLimitFilter"></p>' +
                    '</div>' +
                    '<div class="col-sm-9 col-sm-push-3">' +
                    '<p class="form-control-static" ng-if="!!item.test_position_info" ng-repeat="info in item.test_position_info" ng-bind="info">' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
            }
            return '<div class="review-label-group-holder">' +
                '<legend class="section" ng-bind="title"></legend>' +
                getCreateInfoLabel() +
                '<div ng-if="type != \'create\'">' +
                '<div class="form-group" ng-repeat="item in result" ng-if="!isNull(item.value)">' +
                '<div class="row">' +
                '<label class="col-sm-3 control-label" ng-bind="item.name + \':\'" ng-if="item.type !== \'multi\'"></label>' +
                '<div class="col-sm-9" ng-if="item.type !== \'multi\'">' +
                '<p class="form-control-static" ng-bind="item.value | invokeLimitFilter : function_type" ng-if="item.type==\'limit\'"></p>' +
                '<p class="form-control-static" ng-bind="item.value" ng-if="item.type!==\'limit\'"></p>' +
                '</div>' +
                '<div class="col-sm-9 col-sm-push-3" ng-if="item.type === \'multi\'" ng-repeat="val in item.value track by $index">' +
                '<p class="form-control-static" ng-bind="val"></p>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';
        }

    }

    function invokeLimitFilter() {
        return function (val, type) {
            var value = parseInt(val);
            var result = ''

            // 微信抓取的limit字段做特殊处理
            if (type == 7) {
                return '限量' + value + '个公众号';
            }

            if (typeof (value) != 'number') {
                return val;
            }

            if (value > 10000) {
                result = value / 10000 + '万次';
            } else if (value > 1000) {
                result = value / 1000 + '千次';
            } else {
                result = value + '次';
            }

            result += '/天';

            return '限量' + result;
        }
    }
})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:posEditor
   * @description
   * 搜索框，包含输入框和搜索按钮。
   * @restrict E
   * @scope
   * @param {string} ngModel 绑定的 ngModel
   * @param {string} placeholder input 的 placeholder
   * @param {number} width input 的 width
   * @param {function} search input 中回车和搜索按钮点击时触发的函数
   */

  'use strict';

  angular
    .module('app')
    .directive('contenteditable', contenteditable);

  contenteditable.$inject = ['$timeout', 'posConvert']

  function contenteditable($timeout, posConvert) {
    var directive = {
      restrict: 'A',
      require: '?ngModel',
      link: link
    };

    function link(scope, element, attrs, ngModel) {
      var initText = null;
      var initTextLength = null;
      var oldText = null;

      function setInitText() {
        oldText = element[0].innerText;
        initText = removeMark(element[0].innerText);
        initTextLength = initText.length;
      }
      $timeout(setInitText);
      if (!ngModel) {
        return
      }
      var oldRender = ngModel.$render
      ngModel.$render = function () {
        var el, el2, range, sel
        if (!!oldRender) {
          oldRender()
        }
        element.html(ngModel.$viewValue || '')
      }
      var getCaretCharacterOffsetWithin = function (element) {
        var caretOffset = 0;
        var doc = element.ownerDocument || element.document;
        var win = doc.defaultView || doc.parentWindow;
        var sel;
        if (typeof win.getSelection != "undefined") {
          sel = win.getSelection();
          if (sel.rangeCount > 0) {
            var range = win.getSelection().getRangeAt(0);
            var preCaretRange = range.cloneRange();
            preCaretRange.selectNodeContents(element);
            preCaretRange.setEnd(range.endContainer, range.endOffset);
            caretOffset = preCaretRange.toString().length;
          }
        } else if ((sel = doc.selection) && sel.type != "Control") {
          var textRange = sel.createRange();
          var preCaretTextRange = doc.body.createTextRange();
          preCaretTextRange.moveToElementText(element);
          preCaretTextRange.setEndPoint("EndToEnd", textRange);
          caretOffset = preCaretTextRange.text.length;
        }
        return caretOffset;
      };

      var textToHtml = function (text) {
        text = text.replace(/\s+/g, ' ');
        var html = '';
        for (var i = 0; i < text.length; i++) {
          var char = text[i];
          if (char == ' ') {
            html += '<span class="space"> </span>';
          } else if (char == '[' || char == ']') {
            html += '<span class="bracket">' + char + '</span>';
          } else {
            html += '<span>' + char + '</span>';
          }
        }
        return html;
      };

      var getSubLenghtOfSpace = function (text) {
        return text.length - text.replace(/\s+/g, ' ').length;
      };

      function domBindData(text) {
        oldText = text;
        scope.$apply(function () {
          var rawText = text;
          var oldCaretPos = getCaretCharacterOffsetWithin(element[0]);
          ngModel.$setViewValue(textToHtml(rawText));
          ngModel.$render();
          var range, sel, target;
          range = document.createRange();
          sel = window.getSelection();
          target = element[0].childNodes[oldCaretPos];
          range.setStart(element[0], oldCaretPos - getSubLenghtOfSpace(rawText));
          sel.removeAllRanges();
          sel.addRange(range);
          element[0].focus();
        })
      }

      function removeMark (string)  {
        var text = string;
        text = text.replace(/\s/g, '');
        text = text.replace(/\[/g, '');
        text = text.replace(/\]/g, '');
        return text;
      }
      
      // view -> model
      element.bind('input', function () {
        var text = element[0].innerText;
        var newTextLength = removeMark(text);
        if (newTextLength.length !== initTextLength) {
          text = oldText;
        }
        domBindData(text);
      });

      element.bind('click', function (e) {
        var range, sel, target
        target = e.toElement
        if (target !== this && angular.element(target).attr('contenteditable') === 'false') {
          range = document.createRange()
          sel = window.getSelection()
          range.setStartBefore(target)
          range.setEndAfter(target)
          sel.removeAllRanges()
          sel.addRange(range)
        }
      });
    }

    return directive;
  }
})();
(function () {
    angular
        .module('app')
        .directive('functionForm', functionForm);

    function functionForm() {
        return {
            restrict: 'E',
            scope: {
                title: '@',
                model: '='
            },
            templateUrl: 'src/directive/functionForm/functionForm.template.html',
            link: link
        };

        function link(scope, element, attrs) {
            var vm = scope;
            vm.platformList = ['Android端', 'PC端', 'IOS端', 'M站', '其他'];
            vm.recTypeList = ['个性化推荐功能', '相关推荐功能', '热门推荐功能'];
            var defaultRecTestPosition = {
                app: undefined,
                platform: vm.platformList[0],
                page: undefined,
                module: undefined,
                rec: vm.recTypeList[0]
            }
            var defaultSearchTestPosition = {
                app: undefined,
                platform: vm.platformList[0],
                remark: undefined
            }

            initTempTestPosition();


            if ((vm.model.function_type === 5 || vm.model.function_type === 6) && !vm.model.test_position) {
                vm.model.test_position = [];
            }

            vm.add = function () {
                vm.model.test_position.push(angular.copy(vm.tempTestPosition));
                initTempTestPosition();
            }

            vm.delete = function(idx) {
                vm.model.test_position.splice(idx, 1);
            }

            vm.$watch('model.limit_num_tmp', function(newVal, oldVal) {
                var val = parseInt(newVal);
                if(typeof(val) == 'number') {
                    if(vm.model.function_type !== 7) {
                        vm.model.limit_num = val * 10000;
                    } else {
                        vm.model.limit_num = val;
                    }
                }
            });

            function initTempTestPosition() {
                if (vm.model.function_type === 5) {
                    vm.tempTestPosition = angular.copy(defaultRecTestPosition);
                }

                if (vm.model.function_type === 6) {
                    vm.tempTestPosition = angular.copy(defaultSearchTestPosition);
                }
            }
        }
    }
})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:dialogConfirmButton
   * @description
   * 弹出框确定按钮
   * @restrict E
   * @param {function} confirm 点击时触发的函数
   * @param {string} text 按钮文本，默认为'提交'
   */

  'use strict';

  angular
    .module('app')
    .directive('filterGroup', filterGroup);

  function filterGroup() {
    return {
      restrict: 'EA',
      templateUrl: 'src/directive/filterGroup/filterGroup.html',
      scope: {
        filterList: '=',
        searchValue: '=',
        searchFunc: '&'
      },
      link: link
    };
    function link(scope) {
      var vm = scope;
      vm.handleFilterShow = function(show){
        if (!show){
          return true;
        } else {
          return show()
        }
      }
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('fieldList', fieldList);

  function fieldList() {
    return {
      restrict: 'EA',
      templateUrl: 'src/directive/fieldList/fieldList.html',
      scope: {
        list: '='
      }
    };
  }
})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:dialogConfirmButton
   * @description
   * 弹出框确定按钮
   * @restrict E
   * @param {function} confirm 点击时触发的函数
   * @param {string} text 按钮文本，默认为'提交'
   */

  'use strict';

  angular
    .module('app')
    .directive('dialogConfirmButton', dialogConfirmButton);


  function dialogConfirmButton() {
    return {
      restrict: 'EA',
      template: template,
      scope: {
        confirm: '&',
        ngDisabled: '='
      }
    };

    function template(element, attr) {
      var text = attr.text || '提交';
      return '<button ng-click="confirm()" type="submit" class="btn btn-primary confirm" ng-disabled="ngDisabled">' + text + '</button>'
    }

  }
})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:dialogClose
   * @description
   * 弹出框 X 形关闭按钮
   * @restrict E
   * @param {function} close 点击时触发的函数
   */


  angular
    .module('app')
    .directive('dialogClose', dialogClose);


  function dialogClose() {
    return {
      restrict: 'E',
      template: template,
      scope: {
        close: '&'
      }
    };

    function template() {
      return '<button class="close" ng-click="close()">&times;</button>'
    }

  }
})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:dialogCancelButton
   * @description
   * 弹出框底部的取消按钮
   * @restrict E
   * @param {function} cancel 点击时按钮时执行的函数
   * * @param {string} text 按钮文本，默认为'取消'
   */

  'use strict';

  angular
    .module('app')
    .directive('dialogCancelButton', dialogCancelButton);


  function dialogCancelButton() {
    return {
      restrict: 'EA',
      template: template,
      scope: {
        cancel: '&'
      }
    };

    function template(element, attr) {
      var text = attr.text || '取消';
      return '<button ng-click="cancel()" class="btn btn-default cancel">' + text + '</button>'
    }

  }
})();
(function () {

    /**
     * @ngdoc directive
     * @name app.directive:datePicker
     * @description
     * 日期弹出选择器
     * @restrict E
     * @scope
     * @param {string} ngModel 绑定的 ngModel
     * @param {string} maxDate 最大日期，格式为"yyyy-MM-dd"
     * @param {string} minDate 最小日期，格式为"yyyy-MM-dd"
     * @param {string} disableClear 空字符串，禁用清除按钮
     * @param {string} beyondToday 空字符串，允许选取超过今天的日期
     * @param {string} disableToday 空字符串，禁用今天按钮
     * @param {function} ngChange ngModel change时触发的函数
     * @requires app.calcDateService
     * @requires $timeout
     * @requires $filter
     */
    'use strict';

    angular
        .module('app')
        .directive('dgWizard', dgWizard);


    function dgWizard() {
        var inputModel = 'dateModel';
        return {
            restrict: 'E',
            scope: {
                list: '=',
                status: '='
            },
            replace: true,
            template: template,
            link: link
        };

        function template(element, attrs, aa, bb) {
            return '<div id="smartwizard" class="sw-main sw-theme-arrows custom-sw">' +
                '<ul class="nav nav-tabs step-anchor">' +
                '<li ng-repeat="item in list track by $index" ng-class="{\'active\': item.active, \'done\': !item.active && item.selected}">' +
                '<a href="javascript:;" ng-click="select(item)">' +
                '<span ng-bind="item.title"></span>' +
                '<br  ng-if="!!item.description" /><small ng-if="!!item.description" ng-bind="item.description"></small>' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '<div style="display:none;">' +
                '<div ng-repeat="item in list track by $index" id="step-{{$index}}"></div>' +
                '</div>' +
                '</div>'
        }

        function link(scope, element, attr) {
            scope.list[0].active = true;
            scope.list[0].selected = true;

            scope.select = function (item, ifForce) {
                if (!item.selected && !ifForce) {
                    return;
                }

                angular.forEach(scope.list, function (item) {
                    item.active = false;
                });

                item.active = true;
                item.selected = true;
                scope.status = scope.list.indexOf(item) + 1;
            }

            scope.$watch('status', function (newVal, oldVal) {
                if (newVal == oldVal) {
                    return;
                }

                if (Math.abs(newVal - oldVal) !== 1) {
                    return;
                }

                scope.select(scope.list[newVal - 1], true);
            });
        }
    }

})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:dgSearchInput
   * @description
   * 搜索框，包含输入框和搜索按钮。
   * @restrict E
   * @scope
   * @param {string} ngModel 绑定的 ngModel
   * @param {string} placeholder input 的 placeholder
   * @param {number} width input 的 width
   * @param {function} search input 中回车和搜索按钮点击时触发的函数
   */

  'use strict';

  angular
    .module('app')
    .directive('dgSearchInput', dgSearchInput);

  function dgSearchInput() {
    var directive = {
      restrict: 'E',
      replace: true,
      scope: {
        ngModel: '=',
        search: '&search'
      },
      template: template
    }

    function template(element, attr) {
      var inputAttrs = 'placeholder="' + attr.placeholder + '" ng-model="ngModel" keydown="search()" ng-change="ngChange"';
      return '<div class="input-group dg-search-input" style="width: ' + attr.width + '">' +
        '<input type="text" class="form-control" keydown-code="13" ' + inputAttrs + '>' +
        '<span class="input-group-btn" ng-click="search()">' +
        '<button class="btn btn-default" type="button"><i class="glyphicon glyphicon-search"></i></button>' +
        '</span></div>';
    }

    return directive;
  }
})();
(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name app.directive:dgComboBox
   * @description
   * # dgComboBox
   */
  angular
    .module('app')
    .directive('dgComboBox', dgComboBox);

  function dgComboBox() {
    var directive = {
      restrict: 'E',
      scope: {
        selectedItem: '=',
        itemList: '=',
        itemName: '=',
        itemChange: '&',
        itemType: '='
      },
      template: template,
      link: link
    }

    function template() {
      var template = ['<div class="dg-combobox">',
        '<div class="input-group">',
        '<input class="form-control dg-combobox-input" type="text" ng-model="selectedStr" ng-change="updateList()" ng-blur="toggleDrop(false)" ng-keydown="process($event)" ng-focus="toggleDrop(true)" />',
        '<span class="input-group-btn" ng-click="focusSelect()" dg-keydown="focusSelect()" dg-keydown-code="13">',
        '<button class="btn btn-default" ng-keydown="process($event)" type="button"><i class="glyphicon glyphicon-chevron-down"></i></button>',
        '</span>',
        '</div>',
        '<div class="dropdown-list" ng-hide="shownList.length < 1">',
        '<div class="dropdown-item" ng-repeat="item in shownList track by $index" ng-bind="getItemName(item)" ng-mousedown="select($index, $event)" ng-class="$index == selectedIndex? \'active\': \'\'"></div>',
        '</div>',
        '</div>'
      ].join('')
      return template;
    }

    function link(scope, element, attrs) {
      var itemName = '';
      var defaultItemName = 'name';
      var keyCode = {
        UP: 38,
        DOWN: 40,
        LEFT: 37,
        RIGHT: 39,
        ENTER: 13,
        BACKSPACE: 8
      };

      scope.toggleDrop = function (ifShowList) {
        if (typeof ifShowList != 'undefined') {
          ifShowList ? showDrop() : hideDrop();
          return;
        }

        if (scope.shownList.length > 0) {
          hideDrop();
        } else {
          showDrop();
        }
      }

      function hideDrop() {
        scope.shownList.length = 0;
      }

      function showDrop() {
        scope.ifHideDrop = false;
        scope.shownList = angular.copy(scope.itemList);
      }

      scope.focusSelect = function () {
        var selectInput = element.children('div').children('div').children('input');
        if (scope.shownList.length > 0) {
          hideDrop();
        } else {
          selectInput.focus();
        }
      }

      scope.updateList = function () {
        var tempList = [],
          findSelectedItem = false,
          selectedItem = null,
          tempSearchList = [],
          ifAllHit = true;

        scope.selectedStr.split(/{|}|\s|\(|\)|（|）/).forEach(function (item) {
          if (!!item) {
            tempSearchList.push(item);
          }
        });

        angular.forEach(scope.itemList, function (item) {
          if (scope.getItemName(item) === scope.selectedStr) {
            findSelectedItem = true;
            selectedItem = item;
          } else {
            ifAllHit = true;
            angular.forEach(tempSearchList, function (searchItemStr) {
              if (scope.getItemName(item).search(searchItemStr) < 0) {
                ifAllHit = false;
              }
            });

            if (ifAllHit) {
              tempList.push(item);
            }
          }
        });
        if (findSelectedItem) {
          scope.selectedItem = selectedItem;
          scope.shownList = [];
        } else {
          scope.shownList = tempList;
          scope.selectedItem = undefined;
        }
      }

      scope.select = function (idx, e) {
        scope.selectedIndex = idx;
        scope.selectedItem = scope.shownList[scope.selectedIndex];
        scope.selectedStr = scope.getItemName(scope.selectedItem);
        scope.toggleDrop();
        e.stopPropagation();
      }

      scope.process = function (e) {
        if (e.keyCode == keyCode.UP) {
          scope.selectedIndex = adjustSelectedIndex(scope.selectedIndex, scope.shownList.length, true);
          adjustSelectedItemPosition();
        } else if (e.keyCode == keyCode.DOWN) {
          scope.selectedIndex = adjustSelectedIndex(scope.selectedIndex, scope.shownList.length, false);
          adjustSelectedItemPosition();
        } else if ((e.keyCode == keyCode.RIGHT || e.keyCode == keyCode.ENTER)) {
          if (scope.selectedIndex != -1 && scope.shownList.length > 0) {
            scope.selectedItem = scope.shownList[scope.selectedIndex];
            scope.selectedStr = scope.getItemName(scope.selectedItem);
          }
          if (scope.shownList.length > 0) {
            scope.toggleDrop();
          }
        } else if (e.keyCode == keyCode.BACKSPACE) {
          scope.selectedIndex = -1;
        }
      }

      scope.$watch('itemList', function (newList) {
        if (!checkIfInList(scope.selectedItem, newList)) {
          scope.selectedItem = undefined;
          scope.selectedIndex = -1;
          scope.selectedStr = '';
          scope.itemChange();
        } else {
          scope.selectedStr = scope.getItemName(scope.selectedItem);
        }
      });

      scope.$watch('selectedItem', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (!scope.selectedItem) {
            scope.selectedStr = '';
          } else {
            scope.selectedStr = scope.getItemName(scope.selectedItem);
          }
          scope.itemChange();
        }
      });

      scope.getItemName = function (item) {
        var treeList = [], returnItem;
        if (!item) {
          return '';
        }

        if (attrs.itemType == 'string') {
          return item;
        }

        treeList = itemName.split('.');
        if(treeList.length === 1) {
          return item[itemName];
        } else {
          returnItem = item;
          angular.forEach(treeList, function(eachItemName) {
            returnItem = returnItem[eachItemName];
          });

          return returnItem;
        }

      }

      function adjustSelectedIndex(initIdx, listLength, isUp) {
        var idx = initIdx;

        if(initIdx > listLength - 1 || initIdx < -1) {
          initIdx = -1;
        }

        if(isUp) {
          idx = initIdx === -1 ? listLength : initIdx;
          idx--;
        } else {
          idx = initIdx === listLength -1 ? -1 : initIdx;
          idx++;
        }

        return idx;
      }

      function adjustSelectedItemPosition() {
        var $selectedItem, $List, itemOffsetTop, listHeight, listScrollTop, itemHeight;
        setTimeout(function () {
          $selectedItem = element.find('div.dropdown-item.active');
          $List = element.find('div.dropdown-list');

          if($selectedItem.length < 1) {
            $List.scrollTop();
            return;
          }

          itemOffsetTop = $selectedItem.position().top;
          itemHeight = $selectedItem.outerHeight();
          listScrollTop = $List.scrollTop();
          listHeight = $List.outerHeight();
          if(itemOffsetTop < 0) {
            $List.scrollTop(listScrollTop + itemOffsetTop);
          } else if(itemOffsetTop > listHeight - itemHeight) {
            $List.scrollTop(listScrollTop + itemOffsetTop - listHeight + itemHeight);
          }
        }, 50);
      }

      function checkIfInList(item, list) {
        //没有item也算存在
        if (!item) {
          return true;
        }

        if (list.indexOf(item) < 0) {
          return false;
        } else {
          return true;
        }
      }

      function init() {
        scope.selectedIndex = -1;
        scope.shownList = [];

        itemName = (attrs.itemName === undefined ? defaultItemName : attrs.itemName);

        if (scope.selectedItem) {
          scope.selectedStr = scope.getItemName(scope.selectedItem);
        }
      }

      init();
    }

    return directive;
  }

})();

(function() {
/**
 * ngdoc directive
 * app.directive:citySelect
 * @description
 * 中国城市级连选择
 * @default 没有 accurateToArea属性 精确到市
 * @attribute accurateToArea 精确到区
 */

 'use strict';

 angular
 .module('app')
 .directive('cityDispatcher', cityDispatcher);

 cityDispatcher.$inject = ['cityDataService'];

 function cityDispatcher(cityDataService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            ngModel: '='
        },
        templateUrl: 'src/directive/cityDispatcher/cityDispatcher.html',
        link: link
    };
    
    function link(scope, tEle, tAttrs) {
        var vm = scope;
        vm.cityList = cityDataService.cityList;
        vm.range = {
            accurateToArea: tAttrs.hasOwnProperty('accuratetoarea')
        }
        vm.params = {
            cities: vm.cityList[0].city,
            area: undefined,
            provinceLevelShow: false,
            cityLevelShow: false,
            areaLevelShow: false
        }

        vm.query = {
            provinceName: undefined,
            cityName: undefined,
            areaName: undefined
        }

        vm.ngModel = vm.query;

        vm.setCities = function(index) {
            var province = vm.cityList[index];
            vm.params.cities = province.city;
            vm.updateQuery({
                provinceName: province.name,
                cityName: undefined
            });
            vm.setStates({
                provinceLevelShow: false,
                cityLevelShow: true
            });
        }

        vm.setAreas = function(index) {
            var city = vm.params.cities[index];
            vm.params.area = city.area;
            vm.updateQuery({
                cityName: city.name,
                areaName: undefined
            });
            vm.setStates({
                cityLevelShow: false,
                areaLevelShow: true
            });
        }

        vm.setStates = function(states) {
            for(var k in states) {
                var type = states[k];
                vm.params[k] = states[k];
            }
        }

        vm.updateQuery = function(query) {
            for(var name in query) {
                var val = query[name];
                vm.query[name] = query[name];
            }
        }

        vm.update = function(type) {
            switch(type) {
                case 1:
                vm.setStates({
                    provinceLevelShow: true,
                    cityLevelShow: false,
                    areaLevelShow: false
                });
                break;
                case 2:
                vm.setStates({
                    provinceLevelShow: false,
                    cityLevelShow: !!vm.query.provinceName,
                    areaLevelShow: false
                });
                break;
                case 3:
                vm.setStates({
                    provinceLevelShow: false,
                    cityLevelShow: false,
                    areaLevelShow: !!vm.query.cityName
                });
                break;
            }
        }

        vm.nameLike = function(name, type) {
            var isLike = true;
            var qName = vm.query[type];
            if(!qName) { return isLike;}
            if(angular.isString(name)) {
                if(name.trim().indexOf(qName) != -1) {
                    isLike = true;
                } else {
                    isLike = false;
                }
            }
            return isLike;
        }

        $(document).bind('click', function(event) {
            event.stopPropagation();
            if (tEle.find(event.target).length == 0) {
                vm.$apply(function(){
                    vm.params.provinceLevelShow = false;
                    vm.params.cityLevelShow = false;
                    vm.params.areaLevelShow = false;
                });
            }
        })
    }
 }

})();
(function () {
  'use strict';
  angular.module('app').controller('sidebarCtrl', sidebarCtrl);
  sidebarCtrl.inject = ['$scope', '$http', '$anchorScroll', 'Resource', '$timeout'];

  function sidebarCtrl($scope, $http, $anchorScroll, Resource, $timeout) {
    var vm = $scope;
    var Menu = Resource.Common.Menu;
    Menu.query({}, function (data) {   
      vm.menus = data;
      $timeout(setHeight, 50);
      function setHeight() {
        var height = $('.main-sidebar').height();
        $('.content-wrapper').css('min-height', height + 'px')
      }
    });
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .controller('headerCtrl', headerCtrl);

  headerCtrl.inject = ['$scope', 'Resource', '$http', '$state', '$cookies'];

  function headerCtrl($scope, Resource, $http, $state, $cookies) {
    var vm = $scope;
    var Logout = Resource.Login.Logout;
    vm.nickName = $cookies.get('nickname');
    // if (!vm.nickName) {
    //   $state.go('login');
    // }
    vm.logout = function () {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      $state.go('login');
    };
  }
})();
(function () {
  /**
   * @ngdoc service
   * @name app.WarpState
   * @description
   * 封装 State 相关方法
   * @requires $state
   * @requires $rootScope
   */

  'use strict';

  angular
    .module('app')
    .service('WarpState', WarpState);

  WarpState.inject = ['$state', '$rootScope'];

  function WarpState($state, $rootScope) {

    /**
     * @ngdoc method
     * @name app.WarpState#currentName
     * @methodOf app.WarpState
     * @description
     * 获取当前路由 state 的 name
     * @returns {string} 当前路由 state 的 name
     * @example
     * <pre>
        WarpState.currentName();
     * </pre>
     */

    this.currentName = $state.$current.name;


    /**
     * @ngdoc method
     * @name app.WarpState#goParent
     * @methodOf app.WarpState
     * @description
     * 跳转到当前路由的父级路由
     * @example
     * <pre>
        WarpState.goParent();
     * </pre>
     */

    this.goParent = function () {
      $state.go(this.parentName);
    };

    /**
     * @ngdoc method
     * @name app.WarpState#currentName
     * @methodOf app.WarpState
     * @description
     * 获取当前路由 state 的父级 state 的 name
     * @returns {string} 获取当前路由 state 的父级 state 的 name
     * @example
     * <pre>
        WarpState.parentName();
     * </pre>
     */

    this.parentName = $state.$current.parent.toString();

    /**
     * @ngdoc method
     * @name app.WarpState#goChild
     * @methodOf app.WarpState
     * @description
     * 判断当前路由是否为传入的 state name，是的话跳转到传入的 child 路由中
     * @param {string} name 需要判断是否为当前路由的 state name
     * @param {string} child name 为当前路由后跳转的路由
     * @example
     * <pre>
        WarpState. goChild('state1', 'state2');
     * </pre>
     */

    this.goChild = function (name, child) {
      $rootScope.$on('$stateChangeSuccess',
        function (event, toState) {
          if (toState.name.replace(name, '').length == 0) {
            $state.go(child)
          }
        });
    };

    /**
     * @ngdoc method
     * @name app.WarpState#activeCurrentState
     * @methodOf app.WarpState
     * @description
     * 判断当前路由是否为传入的 state name，是的话执行回调函数
     * @returns {string} 当前路由 state 的 name
     * @example
     * <pre>
        WarpState.currentName();
     * </pre>
     */
    this.activeCurrentState = function (name, callback) {
      $rootScope.$on('$stateChangeSuccess',
        function (event, toState) {
          if (toState.name === name) {
            callback();
          }
        });
    };

    this.stateChange = function (callback) {
      $rootScope.$on('$stateChangeSuccess', function (event, toState) {
        callback(toState.name);
      });
    };

    return this;
  }
})();
(function () {
    angular.module('app')
        .service('staticService', staticService);

    function staticService(Resource, $http) {
        var self = this;
        var channelRes = Resource.Static.Channel;
        var getSalerRes = Resource.Management.GetSaler;
        var channelKey = 'CHANNELS';
        var salerKey = 'SALERLIST';

        self.getChannel = function () {
            channelsStr = sessionStorage.getItem(channelKey);

            if (!!channelsStr) {
                return JSON.parse(channelsStr);
            }
        }

        self.getSaler = function() {
            salerStr = sessionStorage.getItem(salerKey);
            
            if(!!salerStr) {
                return JSON.parse(salerStr);
            }
        }

        self.setChannel = function () {
            channelRes.query({}, function (data) {
                sessionStorage.setItem(channelKey, JSON.stringify(data));
            });
        }

        self.setSaler = function () {
            getSalerRes.query({}, function (data) {
                sessionStorage.setItem(salerKey, JSON.stringify(data.map(function (item) {
                    return {
                        id: item.user_id,
                        name: item.user_nickname
                    }
                })));
            })
        }
    }
})();
(function () {
  angular
    .module('app')
    .value('routerList', routerList);

  function routerList() {
    return [{
        name: '首页',
        link: 'home',
        parent: null
      }, {
        name: '登录',
        link: 'login',
        parent: null
      }, {
        name: '订单列表',
        link: 'order.list',
        parent: '订单管理'
      }, {
        name: '订单录入',
        link: 'order.update',
        parent: '订单管理'
      }, {
        name: '联系我们',
        link: 'contact.contactUsMsg',
        parent: '联系我们'
      }, {
        name: '申请试用数据',
        link: 'contact.applyForTrialData',
        parent: '联系我们'
      }, {
        name: 'UCloud',
        link: 'contact.ucloud',
        parent: '联系我们'
      }, {
        name: '账号管理',
        link: 'client.account',
        parent: '客户管理'
      }, {
        name: '接口调用',
        link: 'client.API',
        parent: '客户管理'
      }, {
        name: '绑定数据',
        link: 'public.binding',
        parent: '公众号统计'
      }, {
        name: '用户行为',
        link: 'public.action',
        parent: '公众号统计'
      }, {
        name: '数据反馈',
        link: 'public.feedback',
        parent: '公众号统计'
      }, {
        name: '分词Badcase',
        link: 'nlp',
        parent: 'NLP'
      }, {
        name: '语料库标注',
        link: 'corpusAnnotation',
        parent: 'NLP'
      }, {
        name: '个性化推荐',
        link: 'recDebug.personal',
        parent: '推荐Debug'
      }, {
        name: '相关推荐',
        link: 'recDebug.related',
        parent: '推荐Debug'
      }, {
        name: '热门推荐',
        link: 'recDebug.hot',
        parent: '推荐Debug'
      }, {
        name: '小时级策略效果',
        link: 'strategyEffectStatistics.hourly',
        parent: '推荐Debug'
      }, {
        name: '小时级APP调用',
        link: 'strategyPerformanceStatistics.hourlyApp',
        parent: '推荐Debug'
      }, {
        name: '总体产品信息上报',
        link: 'dataUpReport.totalProductUpReport',
        parent: '推荐Debug'
      }, {
        name: '离线数据',
        link: 'offline.data',
        parent: '推荐Debug'
      },
      {
        name: '行为配置',
        link: 'recConfig.actionConfig',
        parent: '推荐Debug'
      }, {
        name: '人工审核',
        link: 'textReview.manualReview',
        parent: '文本审核'
      }, {
        name: '审核词典',
        link: 'reviewDict',
        parent: '文本审核'
      }, {
        name: '反馈数据',
        link: 'textReview.feedback',
        parent: '文本审核'
      }, {
        name: '申请测试',
        link: 'project.testApplication',
        parent: '项目管理'
      }, {
        name: '用户管理',
        link: 'management.advanced',
        parent: '基本权限'
      }, {
        name: '部门管理',
        link: 'management.role',
        parent: '基本权限'
      }, {
        name: '资源管理',
        link: 'management.resource.resource',
        parent: '基本权限'
      }, {
        name: '资源组管理',
        link: 'management.resource.group',
        parent: '基本权限'
      }, {
        name: '渠道管理',
        link: 'management.channel',
        parent: '基本权限'
      }, {
        name: '菜单管理',
        link: 'management.menu',
        parent: '基本权限'
      }, {
        name: '邮件模板管理',
        link: 'management.mailTemplate',
        parent: '基本权限'
      }, {
        name: '服务报警',
        link: 'serviceAlarm',
        parent: '客户管理'
      }, {
        name: '微信抓取',
        link: 'crawl.statistics',
        parent: null
      }, {
        name: '活动统计',
        link: 'activityStatistics',
        parent: null
      }, {
        name: '搜索配置',
        link: 'searchConfig',
        parent: null
      }, {
        name: '配置管理',
        link: 'configManage',
        parent: null
      }, {
        name: '基础配置',
        link: 'configManage.basicConfig',
        parent: '配置管理',
      }, {
        name: '时效性配置',
        link: 'configManage.timeConfig',
        parent: '配置管理',
      }, {
        name: '多样性配置',
        link: 'configManage.diversityConfig',
        parent: '配置管理',
      }, {
        name: '相关推荐配置',
        link: 'configManage.relatedSuggestConfig',
        parent: '配置管理',
      }
    ]
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .service('Resource', Resource);

  function Resource($resource, HOST) {
    function resource(path, isItem) {
      var fullPath = HOST + path;
      if (isItem) {
        return $resource(fullPath + ':primaryKey', {
          primaryKey: '@id'
        })
      } else {
        return $resource(fullPath);
      }
    }

    function mock(path) {
      return $resource('/mock/' + path);
    }
    return {
      Channel: {
        List: resource('channellist/'),
        Item: resource('channellist/', true)
      },
      Industry: {
        List: resource('industry_list/'),
        Item: resource('industry_list/', true)
      },
      Login: {
        Login: resource('login'),
        Logout: resource('logout'),
        Token: resource('logintoken')
      },
      Menu: resource('menulist'),
      Customer: {
        ApplyFroTrialData: {
          List: resource('apply_for_trial_data_list/'),
        },
        ReferKeywordType: {
          List: resource('referkeywordtypelist')
        },
        ContactUsMsg: {
          List: resource('contact_us_msg_list/'),
          Item: resource('contact_us_msg_list/', true)
        },
        API: resource('appidtransferquery'),
        APIItem: resource('appidtransferdetail'),
        List: resource('accountlist'),
        Ucloud: resource('siterecuserlist'),
        Saler: resource('customergetsaler')
      },
      Statistics: {
        BindData: resource('adminstaticuserlist'),
        Action: resource('adminstaticactionlist'),
        Feedback: resource('appfeedbacklist')
      },
      Management: {
        User: {
          List: resource('userlist/'),
          Item: resource('userlist/', true)
        },
        GetSaler: resource('getsaler'),
        // User: resource('user'),
        // UserList: resource('userlist'),
        Role: resource('rolelist/', true),
        RoleList: resource('rolelist'),
        RoleUserList: resource('roleuser/', true),
        RoleAddUser: resource('roleadduser/', true),
        Resource: resource('resourcelist/', true),
        ResourceList: resource('resourcelist/'),
        RoleResourceList: resource('roleresourcelist/', true),
        ResourceGroupItem: resource('resourcegroup'),
        ResourceGroupList: resource('resourcegrouplist'),
        GroupAddResource: resource('groupaddresource'),
        UserRole: resource('userrole/', true),
        UserAddRole: resource('useraddrole'),
        GroupResource: resource('groupresource'),
        PermissionsList: resource('roleresourcegroup'),
        AddPermissions: resource('roleaddresourcegroup')
      },
      Recommendation: {
        AppInfoItem: resource('accountlist/', true),
        AppRegistration: resource('siterecregistration')
      },
      Order: {
        Detail: resource('orderlist/', true),
        List: resource('orderlist/'),
        Service: resource('orderchild'),
        AppnameReflect: resource('order/appname_reflect'),
        Image: resource('getcontractfile')
      },
      Common: {
        MenuUpdate: resource('menu'),
        Reflect: resource('common/reflect'),
        Personal: resource('person'),
        Menu: resource('common/menu'),
        Role: resource('userlistbyrolename'),
        CurrentUserRoles: resource('currentuserroles')
      },
      NLP: {
        Sep: {
          List: resource('nlp_bad_case_list'),
          Item: resource('nlp_bad_case_list/', true),
          SepPreview: resource('nlp_seg_preview')
        },
        CorpusAnnotation: {
          List: resource('corpus_annotation_list'),
          Item: resource('corpus_annotation_list/', true)
        }
      },
      RecDebug: {
        Personal: resource('recpersonal'),
        Related: resource('recrelate'),
        Hot: resource('rechot'),
        AnswerReview: resource('recanswerreview')
      },
      RecConfig: {
        ActionTypeList: resource('recactiontypelist'),
        ActionConfigList: resource('recactinconfiglist'),
        ActionConfigItem: resource('recactinconfiglist/', true),
        HotRecConfigList: resource('hotrecconfiglist'),
        HotRecConfigItem: resource('hotrecconfiglist/', true),
        MergeConfigList: resource('mergerecconfiglist'),
        MergeConfigItem: resource('mergerecconfiglist/', true)
      },
      configManage:{
        basicConfigList: resource('houyi_basic_config'),
        basicConfigItem: resource('houyi_basic_config/',true),
        diversityConfigList: resource('houyi_diversity_config'),
        diversityConfigItem: resource('houyi_diversity_config/',true),
        relateConfigList: resource('houyi_relate_config'),
        relateConfigItem: resource('houyi_relate_config/',true),
        timeConfigList: resource('houyi_timeliness_config'),
        timeConfigItem: resource('houyi_timeliness_config/',true)
      },
      RecStrategy: {
        HourlyList: resource('recalghour'),
        HourlyOverallList: resource('rectotalhour'),
        DayList: resource('recalgday'),
        DayOverallList: resource('rectotalday'),
        WhiteList: resource('recalgwhitelist'),
        AddWhite: resource('recalgwhitelist'),
        Delwhitelist: resource('recalgwhitelist/', true)
      },
      OfflineModule: {
        DataList: resource('startupimporterlist'),
        HotList: resource('startuphotreclist'),
        RecList: resource('startupitemreclist')
      },
      PerformanceStrategy: {
        HourlyList: resource('performance/hourappinvoke'),
        HourlyWholeList: resource('performance/hourtotalinvoke'),
        DayList: resource('performance/dayappinvoke'),
        DayWholeList: resource('performance/daytotalinvoke'),
        TimeProcess: resource('performance/appprocesstime'),
        TimeWholeProcess: resource('performance/totalprocesstime'),
      },
      DataUpReport: {
        TotalProduct: resource('dataupreport/totalproduct'),
        AppProduct: resource('dataupreport/appproduct'),
        DayAction: resource('dataupreport/dayaction'),
        HourlyAction: resource('dataupreport/hourlyaction'),
        TotalAction: resource('dataupreport/totalaction')
      },
      TextReview: {
        AdminAuditList: resource('manualreviewlist'),
        // AdminFeedback: resource('adminnlpfeedbacks'),
        AdminFeedbackList: resource('feedbackdatalist'),
        AdminFeedbackItem: resource('feedbackdatalist/', true)
      },
      ReviewDict: {
        ReviewDictList: resource('reviewdictlist'),
        DeleteReviewDictItem: resource('deletereviewdictitem/', true)
      },
      // 邮件管理
      Mail: {
        List: resource('emailtemplatelist/'),
        Item: resource('emailtemplatelist/', true)
      },
      Crawl: {
        List: resource('wechatcrawllist')
      },
      // 项目管理
      Project: {
        TestApplication: {
          List: resource('applicationtestinglist/'),
          Item: resource('applicationtestinglist/', true),
          ItemUpdate: resource('applyfortestupdate'),
          ItemCreate: resource('applyfortestcreate'),
          Application: resource('accountlist')
        }
      },
      Apply: {
        AppApplyList: resource('appapplylist/'),
        AppApplyItem: resource('appapplylist/', true),
        AppApplyModifyDetail: resource('appapplymodifydetail/', true),
      },
      // 服务调用次数报警
      ServiceAlarm: {
        List: resource('servicealarmlist/'),
        Item: resource('servicealarmlist/', true)
      },
      Static: {
        Channel: resource('channel/')
      },
      SearchConfig: {
        List: resource('search_config_list/'),
        Item: resource('search_config_list/', true),
        SearchIndexConfigItem: resource('search_config_list/:id/:name', { id: '@id', name: '@name' })
      },
      ActivityStatistics: {
        MagazineDownload: {
          List: resource('magazine_download_list/')
        }
      }
    }
  }
})();





(function () {

  /**
   * @ngdoc service
   * @name app.calcDateService
   * @description
   * 日期相关计算
   */

  'use strict';
  angular
    .module('app')
    .service('posConvert', posConvert);

  function posConvert() {

    /**
     * @ngdoc method
     * @name app.calcDateService#basedDate
     * @methodOf app.calcDateService
     * @description
     * 基于所给日期计算所给天数后的日期
     * @param {string} "yyyy-MM-dd" 格式的日期字符串
     * @param {number} num 距离所给日期的天数，所给日期后为整数，所给日期前为负数，所给日期为0
     * @returns {string} "yyyy-MM-dd" 格式的日期字符串
     * @example
     * <pre>
     * calcDateService.basedDate('2012-11-12', 2);
     * </pre>
     */
    function handleTextClassName(text) {
      switch (text) {
        case '[':
          return 'class="bracket right-bracket"';
        case ']':
          return 'class="bracket left-bracket"';
        case ' ':
          return 'class="space"';
        default:
          return '';
      }
    }

    this.textToDom = function (text) {
      var dom = ''
      var length = text.length;
      for (var i = 0; i < length; i++) {
        var word = text.substr(i, 1);
        dom += '<span ' + handleTextClassName(word) + '>' + word + '</span>'
      }
      return dom;
    };

    this.domToText = function (dom) {
      return dom.replace(/<\/?[^>]+(>|$)/g, '');
    }

    return this
  }
})();
(function () {

  /**
   * @ngdoc service
   * @name app.isSeller
   * @description
   * 判断当前用户是否为销售人员
   * @example
   * <pre>
      isSeller.then(function(data){
        $scope.isSeller = data;
      }) 
     </pre>
   * @requires Resource
   * @requires $cookies
   * @requires $q
   */

  'use strict';

  angular
    .module('app')
    .service('isSeller', isSeller);

  isSeller.inject = ['Resource', '$cookies', '$q'];

  function isSeller(Resource, $cookies, $q) {
    return function () {
      var defer = $q.defer()
      var GetSaler = Resource.Management.GetSaler;
      var currentUser = $cookies.get('nickname');
      var salerList = [];
      var isSeller = null;
      GetSaler.query({}, function (data) {
        data.map(function (value) {
          salerList.push(value.user_nickname);
        });
        isSeller = salerList.indexOf(currentUser) > -1 ? true : false;
        defer.resolve(isSeller);
      })
      return defer.promise;
    }
  }
})();
angular.module("app").value("HOST", "api/");
(function () {

  /**
   * @ngdoc service
   * @name app.handleReqObj
   * @description
   * 处理请求参数，将空值转换为null
   */

  'use strict';
  angular
    .module('app')
    .service('handleReqObj', handleReqObj);

  function handleReqObj() {
    this.tablePagination = function (reqObj, tableParams) {
      var obj = angular.copy(reqObj);
      if (!tableParams.page) {
        tableParams = tableParams.tableParams;
      }
      obj.start = (tableParams.page() - 1) * tableParams.count();
      obj.number = tableParams.count();
      return obj
    };

    this.handleTableParams = function (reqObj, tableParams) {
      return this.removeEmptyValue(
        this.tablePagination(reqObj, tableParams)
      );
    };

    this.removeEmptyValue = function (reqObj) {
      var obj = angular.copy(reqObj);
      Object.keys(obj).forEach(function (t) {
        if (t.search('_id') > -1) {
          if ([0, '0', '', undefined, null].indexOf(obj[t]) > -1) {
            obj[t] = null;
          }
        } else {
          if (['', undefined, null].indexOf(obj[t]) > -1) {
            obj[t] = null;
          }
        }

      });
      return obj
    };

    return this
  }
})();
(function () {

  /**
   * @ngdoc service
   * @name app.goDashboard
   * @description
   * 在新窗口跳转到 DASHBOARD
   * @param {number} appID 需要跳转的 AppId
   * @requires Resource
   * @requires $window
   */

  'use strict';

  angular
    .module('app')
    .service('goDashboard', goDashboard);

  goDashboard.inject = ['Resource', '$window'];

  function goDashboard(Resource, $window) {
    var Token = Resource.Login.Token;
    var DashBoardUrl = 'http://data.datagrand.com/signup/#/login?token=';

    function goDashboard(appId) {
      Token.get({
        appid: appId
      }, function (data) {
        $window.open(DashBoardUrl + data.token);
      })
    }
    return goDashboard;
  }
})();
(function () {

  /**
   * @ngdoc service
   * @name app.service:aaaa
   * @description
   * 元素居中，设置 margin-top、margin-left 属性，使用此指令前请为元素设置 position 为 absolute 或 fixed。
   * @restrict A
   * @scope
   * @param {string} fixedCenteredShow ng-if 或 ng-show 里的值，指令会监视这个值，当这个值为 true 时延时 10ms 计算元素的尺寸。
   * @requires $timeout
   */

  'use strict';

  angular
    .module('app')
    .service('formService', formService);

  function formService() {

    this.error = function (key, form) {
      if (angular.isUndefined(form)) {
        return false;
      }
      return {
        error: form[key].$error,
        dirty: form[key].$dirty,
        show: form[key].$error && form[key].$dirty
      }
    };

    return this;
  }
})();
(function () {

  /**
   * @ngdoc service
   * @name app.dataService
   * @description
   * 常用常量
   * - statuses: 账户状态
   * - sources: 账号来源渠道
   * - nickname: 账号来源渠道
   * - master: 当前账号是否为管理员（已弃用）
   * @requires $cookie
   */

  'use strict';

  angular
    .module('app')
    .service('dataService', dataService);

  function dataService($cookies) {
    return {
      statuses: ['上线', '测试', '暂停', '开通', '停止'],
      sources: ['百度', '七牛', 'Ucloud', '销售', '360', '移动端'],
      nickname: $cookies.get('nickname'),
      master: $cookies.get('nickname') === '测试哈哈哈',
      currentRoleList: $cookies.getObject('roleList'),
      mailType: {
        customer_create_user: '测试申请表——内部人员接受邮件',
        customer_create: '账号创建邮件',
        customer_test_end: '测试到期邮件'
      },
      alarm_mapping: {
        alarm_api: {
          check_config: '文本自动审核',
          classify: '文本自动分类',
          tagging: '文本标签提取',
          sentiment: '文本情感分析',
          rec: '推荐引擎',
          search: '搜索引擎',
          static: '数据上报'
        },
        alarm_type: {
          start: '开始调用',
          stop: '停止调用',
          increase: '调用量上升30%',
          decrease: '调用量下降30%'
        },
        alarm_status: {
          0: '未处理',
          1: '处理中',
          2: '待审核',
          3: '已解决'
        }
      }
    }
  }
})();
(function () {

  'use strict';
  angular
    .module('app')
    .service('csvSaver', csvSaver);

  function csvSaver(Blob, FileSaver) {
    function downloadFile(csvString, fileName) {
      console.log(csvString);
      var file_string = new Blob(["\ufeff" + csvString], {
        type: "application/vnd.ms-excel;charset=charset=utf-8"
      });
      FileSaver.saveAs(file_string, fileName + '.xls')
    }
    return downloadFile
  }
})();
(function () {

  'use strict';
  
  var CONTACT = {
    FUNC: {
      name: '需要功能',
      list: [{
        name: '全部',
        value: null
      }, {
        name: '个性化推荐引擎',
        value: 'rec_config'
      }, {
        name: '垂直搜索引擎',
        value: 'search_config'
      }, {
        name: '文本语义理解',
        value: 'text_understanding_config'
      }, {
        name: '数据采集挖掘',
        value: 'data_mining_config'
      }, {
        name: '用户画像',
        value: 'user_portrait_config'
      }, {
        name: '其他',
        value: 'other_config'
      }]
    }
  };
  var COMMON_TABLE_FILTER = {};
  COMMON_TABLE_FILTER.CONTACT = CONTACT;

  angular
    .module('app')
    .value('COMMON_TABLE_FILTER', COMMON_TABLE_FILTER);

})();
(function () {

    /**
     * @ngdoc service
     * @name app.cityDataService
     * @description
     * 常用常量
     * @requires $cookie
     */
  
    'use strict';
  
    angular
      .module('app')
      .service('cityDataService', cityDataService);
  
    function cityDataService($cookies) {
      return {
        cityList: 
        [
            {
            "name": "北京市",
            "city": [
                {
                "name": "北京市",
                "area": [
                    "东城区",
                    "西城区",
                    "崇文区",
                    "宣武区",
                    "朝阳区",
                    "丰台区",
                    "石景山区",
                    "海淀区",
                    "门头沟区",
                    "房山区",
                    "通州区",
                    "顺义区",
                    "昌平区",
                    "大兴区",
                    "平谷区",
                    "怀柔区",
                    "密云县",
                    "延庆县"
                ]
                }
            ]
            },
            {
            "name": "天津市",
            "city": [
                {
                "name": "天津市",
                "area": [
                    "和平区",
                    "河东区",
                    "河西区",
                    "南开区",
                    "河北区",
                    "红桥区",
                    "塘沽区",
                    "汉沽区",
                    "大港区",
                    "东丽区",
                    "西青区",
                    "津南区",
                    "北辰区",
                    "武清区",
                    "宝坻区",
                    "宁河县",
                    "静海县",
                    "蓟  县"
                ]
                }
            ]
            },
            {
            "name": "河北省",
            "city": [
                {
                "name": "石家庄市",
                "area": [
                    "长安区",
                    "桥东区",
                    "桥西区",
                    "新华区",
                    "郊  区",
                    "井陉矿区",
                    "井陉县",
                    "正定县",
                    "栾城县",
                    "行唐县",
                    "灵寿县",
                    "高邑县",
                    "深泽县",
                    "赞皇县",
                    "无极县",
                    "平山县",
                    "元氏县",
                    "赵  县",
                    "辛集市",
                    "藁",
                    "晋州市",
                    "新乐市",
                    "鹿泉市"
                ]
                },
                {
                "name": "唐山市",
                "area": [
                    "路南区",
                    "路北区",
                    "古冶区",
                    "开平区",
                    "新  区",
                    "丰润县",
                    "滦  县",
                    "滦南县",
                    "乐亭县",
                    "迁西县",
                    "玉田县",
                    "唐海县",
                    "遵化市",
                    "丰南市",
                    "迁安市"
                ]
                },
                {
                "name": "秦皇岛市",
                "area": [
                    "海港区",
                    "山海关区",
                    "北戴河区",
                    "青龙满族自治县",
                    "昌黎县",
                    "抚宁县",
                    "卢龙县"
                ]
                },
                {
                "name": "邯郸市",
                "area": [
                    "邯山区",
                    "丛台区",
                    "复兴区",
                    "峰峰矿区",
                    "邯郸县",
                    "临漳县",
                    "成安县",
                    "大名县",
                    "涉  县",
                    "磁  县",
                    "肥乡县",
                    "永年县",
                    "邱  县",
                    "鸡泽县",
                    "广平县",
                    "馆陶县",
                    "魏  县",
                    "曲周县",
                    "武安市"
                ]
                },
                {
                "name": "邢台市",
                "area": [
                    "桥东区",
                    "桥西区",
                    "邢台县",
                    "临城县",
                    "内丘县",
                    "柏乡县",
                    "隆尧县",
                    "任  县",
                    "南和县",
                    "宁晋县",
                    "巨鹿县",
                    "新河县",
                    "广宗县",
                    "平乡县",
                    "威  县",
                    "清河县",
                    "临西县",
                    "南宫市",
                    "沙河市"
                ]
                },
                {
                "name": "保定市",
                "area": [
                    "新市区",
                    "北市区",
                    "南市区",
                    "满城县",
                    "清苑县",
                    "涞水县",
                    "阜平县",
                    "徐水县",
                    "定兴县",
                    "唐  县",
                    "高阳县",
                    "容城县",
                    "涞源县",
                    "望都县",
                    "安新县",
                    "易  县",
                    "曲阳县",
                    "蠡  县",
                    "顺平县",
                    "博野",
                    "雄县",
                    "涿州市",
                    "定州市",
                    "安国市",
                    "高碑店市"
                ]
                },
                {
                "name": "张家口",
                "area": [
                    "桥东区",
                    "桥西区",
                    "宣化区",
                    "下花园区",
                    "宣化县",
                    "张北县",
                    "康保县",
                    "沽源县",
                    "尚义县",
                    "蔚  县",
                    "阳原县",
                    "怀安县",
                    "万全县",
                    "怀来县",
                    "涿鹿县",
                    "赤城县",
                    "崇礼县"
                ]
                },
                {
                "name": "承德市",
                "area": [
                    "双桥区",
                    "双滦区",
                    "鹰手营子矿区",
                    "承德县",
                    "兴隆县",
                    "平泉县",
                    "滦平县",
                    "隆化县",
                    "丰宁满族自治县",
                    "宽城满族自治县",
                    "围场满族蒙古族自治县"
                ]
                },
                {
                "name": "沧州市",
                "area": [
                    "新华区",
                    "运河区",
                    "沧  县",
                    "青  县",
                    "东光县",
                    "海兴县",
                    "盐山县",
                    "肃宁县",
                    "南皮县",
                    "吴桥县",
                    "献  县",
                    "孟村回族自治县",
                    "泊头市",
                    "任丘市",
                    "黄骅市",
                    "河间市"
                ]
                },
                {
                "name": "廊坊市",
                "area": [
                    "安次区",
                    "固安县",
                    "永清县",
                    "香河县",
                    "大城县",
                    "文安县",
                    "大厂回族自治县",
                    "霸州市",
                    "三河市"
                ]
                },
                {
                "name": "衡水市",
                "area": [
                    "桃城区",
                    "枣强县",
                    "武邑县",
                    "武强县",
                    "饶阳县",
                    "安平县",
                    "故城县",
                    "景  县",
                    "阜城县",
                    "冀州市",
                    "深州市"
                ]
                }
            ]
            },
            {
            "name": "山西省",
            "city": [
                {
                "name": "太原市",
                "area": [
                    "小店区",
                    "迎泽区",
                    "杏花岭区",
                    "尖草坪区",
                    "万柏林区",
                    "晋源区",
                    "清徐县",
                    "阳曲县",
                    "娄烦县",
                    "古交市"
                ]
                },
                {
                "name": "大同市",
                "area": [
                    "城  区",
                    "矿  区",
                    "南郊区",
                    "新荣区",
                    "阳高县",
                    "天镇县",
                    "广灵县",
                    "灵丘县",
                    "浑源县",
                    "左云县",
                    "大同县"
                ]
                },
                {
                "name": "阳泉市",
                "area": [
                    "城  区",
                    "矿  区",
                    "郊  区",
                    "平定县",
                    "盂  县"
                ]
                },
                {
                "name": "长治市",
                "area": [
                    "城  区",
                    "郊  区",
                    "长治县",
                    "襄垣县",
                    "屯留县",
                    "平顺县",
                    "黎城县",
                    "壶关县",
                    "长子县",
                    "武乡县",
                    "沁  县",
                    "沁源县",
                    "潞城市"
                ]
                },
                {
                "name": "晋城市",
                "area": [
                    "城  区",
                    "沁水县",
                    "阳城县",
                    "陵川县",
                    "泽州县",
                    "高平市"
                ]
                },
                {
                "name": "朔州市",
                "area": [
                    "朔城区",
                    "平鲁区",
                    "山阴县",
                    "应  县",
                    "右玉县",
                    "怀仁县"
                ]
                },
                {
                "name": "忻州市",
                "area": [
                    "忻府区",
                    "原平市",
                    "定襄县",
                    "五台县",
                    "代  县",
                    "繁峙县",
                    "宁武县",
                    "静乐县",
                    "神池县",
                    "五寨县",
                    "岢岚县",
                    "河曲县",
                    "保德县",
                    "偏关县"
                ]
                },
                {
                "name": "吕梁市",
                "area": [
                    "离石区",
                    "孝义市",
                    "汾阳市",
                    "文水县",
                    "交城县",
                    "兴  县",
                    "临  县",
                    "柳林县",
                    "石楼县",
                    "岚  县",
                    "方山县",
                    "中阳县",
                    "交口县"
                ]
                },
                {
                "name": "晋中市",
                "area": [
                    "榆次市",
                    "介休市",
                    "榆社县",
                    "左权县",
                    "和顺县",
                    "昔阳县",
                    "寿阳县",
                    "太谷县",
                    "祁  县",
                    "平遥县",
                    "灵石县"
                ]
                },
                {
                "name": "临汾市",
                "area": [
                    "临汾市",
                    "侯马市",
                    "霍州市",
                    "曲沃县",
                    "翼城县",
                    "襄汾县",
                    "洪洞县",
                    "古  县",
                    "安泽县",
                    "浮山县",
                    "吉  县",
                    "乡宁县",
                    "蒲  县",
                    "大宁县",
                    "永和县",
                    "隰  县",
                    "汾西县"
                ]
                },
                {
                "name": "运城市",
                "area": [
                    "运城市",
                    "永济市",
                    "河津市",
                    "芮城县",
                    "临猗县",
                    "万荣县",
                    "新绛县",
                    "稷山县",
                    "闻喜县",
                    "夏  县",
                    "绛  县",
                    "平陆县",
                    "垣曲县"
                ]
                }
            ]
            },
            {
            "name": "内蒙古",
            "city": [
                {
                "name": "呼和浩特市",
                "area": [
                    "新城区",
                    "回民区",
                    "玉泉区",
                    "郊  区",
                    "土默特左旗",
                    "托克托县",
                    "和林格尔县",
                    "清水河县",
                    "武川县"
                ]
                },
                {
                "name": "包头市",
                "area": [
                    "东河区",
                    "昆都伦区",
                    "青山区",
                    "石拐矿区",
                    "白云矿区",
                    "郊  区",
                    "土默特右旗",
                    "固阳县",
                    "达尔罕茂明安联合旗"
                ]
                },
                {
                "name": "乌海市",
                "area": [
                    "海勃湾区",
                    "海南区",
                    "乌达区"
                ]
                },
                {
                "name": "赤峰市",
                "area": [
                    "红山区",
                    "元宝山区",
                    "松山区",
                    "阿鲁科尔沁旗",
                    "巴林左旗",
                    "巴林右旗",
                    "林西县",
                    "克什克腾旗",
                    "翁牛特旗",
                    "喀喇沁旗",
                    "宁城县",
                    "敖汉旗"
                ]
                },
                {
                "name": "呼伦贝尔市",
                "area": [
                    "海拉尔市",
                    "满洲里市",
                    "扎兰屯市",
                    "牙克石市",
                    "根河市",
                    "额尔古纳市",
                    "阿荣旗",
                    "莫力达瓦达斡尔族自治旗",
                    "鄂伦春自治旗",
                    "鄂温克族自治旗",
                    "新巴尔虎右旗",
                    "新巴尔虎左旗",
                    "陈巴尔虎旗"
                ]
                },
                {
                "name": "兴安盟",
                "area": [
                    "乌兰浩特市",
                    "阿尔山市",
                    "科尔沁右翼前旗",
                    "科尔沁右翼中旗",
                    "扎赉特旗",
                    "突泉县"
                ]
                },
                {
                "name": "通辽市",
                "area": [
                    "科尔沁区",
                    "霍林郭勒市",
                    "科尔沁左翼中旗",
                    "科尔沁左翼后旗",
                    "开鲁县",
                    "库伦旗",
                    "奈曼旗",
                    "扎鲁特旗"
                ]
                },
                {
                "name": "锡林郭勒盟",
                "area": [
                    "二连浩特市",
                    "锡林浩特市",
                    "阿巴嘎旗",
                    "苏尼特左旗",
                    "苏尼特右旗",
                    "东乌珠穆沁旗",
                    "西乌珠穆沁旗",
                    "太仆寺旗",
                    "镶黄旗",
                    "正镶白旗",
                    "正蓝旗",
                    "多伦县"
                ]
                },
                {
                "name": "乌兰察布盟",
                "area": [
                    "集宁市",
                    "丰镇市",
                    "卓资县",
                    "化德县",
                    "商都县",
                    "兴和县",
                    "凉城县",
                    "察哈尔右翼前旗",
                    "察哈尔右翼中旗",
                    "察哈尔右翼后旗",
                    "四子王旗"
                ]
                },
                {
                "name": "伊克昭盟",
                "area": [
                    "东胜市",
                    "达拉特旗",
                    "准格尔旗",
                    "鄂托克前旗",
                    "鄂托克旗",
                    "杭锦旗",
                    "乌审旗",
                    "伊金霍洛旗"
                ]
                },
                {
                "name": "巴彦淖尔盟",
                "area": [
                    "临河市",
                    "五原县",
                    "磴口县",
                    "乌拉特前旗",
                    "乌拉特中旗",
                    "乌拉特后旗",
                    "杭锦后旗"
                ]
                },
                {
                "name": "阿拉善盟",
                "area": [
                    "阿拉善左旗",
                    "阿拉善右旗",
                    "额济纳旗"
                ]
                }
            ]
            },
            {
            "name": "辽宁省",
            "city": [
                {
                "name": "沈阳市",
                "area": [
                    "沈河区",
                    "皇姑区",
                    "和平区",
                    "大东区",
                    "铁西区",
                    "苏家屯区",
                    "东陵区",
                    "于洪区",
                    "新民市",
                    "法库县",
                    "辽中县",
                    "康平县",
                    "新城子区",
                    "其他"
                ]
                },
                {
                "name": "大连市",
                "area": [
                    "西岗区",
                    "中山区",
                    "沙河口区",
                    "甘井子区",
                    "旅顺口区",
                    "金州区",
                    "瓦房店市",
                    "普兰店市",
                    "庄河市",
                    "长海县",
                    "其他"
                ]
                },
                {
                "name": "鞍山市",
                "area": [
                    "铁东区",
                    "铁西区",
                    "立山区",
                    "千山区",
                    "海城市",
                    "台安县",
                    "岫岩满族自治县",
                    "其他"
                ]
                },
                {
                "name": "抚顺市",
                "area": [
                    "顺城区",
                    "新抚区",
                    "东洲区",
                    "望花区",
                    "抚顺县",
                    "清原满族自治县",
                    "新宾满族自治县",
                    "其他"
                ]
                },
                {
                "name": "本溪市",
                "area": [
                    "平山区",
                    "明山区",
                    "溪湖区",
                    "南芬区",
                    "本溪满族自治县",
                    "桓仁满族自治县",
                    "其他"
                ]
                },
                {
                "name": "丹东市",
                "area": [
                    "振兴区",
                    "元宝区",
                    "振安区",
                    "东港市",
                    "凤城市",
                    "宽甸满族自治县",
                    "其他"
                ]
                },
                {
                "name": "锦州市",
                "area": [
                    "太和区",
                    "古塔区",
                    "凌河区",
                    "凌海市",
                    "黑山县",
                    "义县",
                    "北宁市",
                    "其他"
                ]
                },
                {
                "name": "营口市",
                "area": [
                    "站前区",
                    "西市区",
                    "鲅鱼圈区",
                    "老边区",
                    "大石桥市",
                    "盖州市",
                    "其他"
                ]
                },
                {
                "name": "阜新市",
                "area": [
                    "海州区",
                    "新邱区",
                    "太平区",
                    "清河门区",
                    "细河区",
                    "彰武县",
                    "阜新蒙古族自治县",
                    "其他"
                ]
                },
                {
                "name": "辽阳市",
                "area": [
                    "白塔区",
                    "文圣区",
                    "宏伟区",
                    "太子河区",
                    "弓长岭区",
                    "灯塔市",
                    "辽阳县",
                    "其他"
                ]
                },
                {
                "name": "盘锦",
                "area": [
                    "双台子区",
                    "兴隆台区",
                    "盘山县",
                    "大洼县",
                    "其他"
                ]
                },
                {
                "name": "铁岭市",
                "area": [
                    "银州区",
                    "清河区",
                    "调兵山市",
                    "开原市",
                    "铁岭县",
                    "昌图县",
                    "西丰县",
                    "其他"
                ]
                },
                {
                "name": "朝阳市",
                "area": [
                    "双塔区",
                    "龙城区",
                    "凌源市",
                    "北票市",
                    "朝阳县",
                    "建平县",
                    "喀喇沁左翼蒙古族自治县",
                    "其他"
                ]
                },
                {
                "name": "葫芦岛市",
                "area": [
                    "龙港区",
                    "南票区",
                    "连山区",
                    "兴城市",
                    "绥中县",
                    "建昌县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "吉林省",
            "city": [
                {
                "name": "长春市",
                "area": [
                    "朝阳区",
                    "宽城区",
                    "二道区",
                    "南关区",
                    "绿园区",
                    "双阳区",
                    "九台市",
                    "榆树市",
                    "德惠市",
                    "农安县",
                    "其他"
                ]
                },
                {
                "name": "吉林市",
                "area": [
                    "船营区",
                    "昌邑区",
                    "龙潭区",
                    "丰满区",
                    "舒兰市",
                    "桦甸市",
                    "蛟河市",
                    "磐石市",
                    "永吉县",
                    "其他"
                ]
                },
                {
                "name": "四平",
                "area": [
                    "铁西区",
                    "铁东区",
                    "公主岭市",
                    "双辽市",
                    "梨树县",
                    "伊通满族自治县",
                    "其他"
                ]
                },
                {
                "name": "辽源市",
                "area": [
                    "龙山区",
                    "西安区",
                    "东辽县",
                    "东丰县",
                    "其他"
                ]
                },
                {
                "name": "通化市",
                "area": [
                    "东昌区",
                    "二道江区",
                    "梅河口市",
                    "集安市",
                    "通化县",
                    "辉南县",
                    "柳河县",
                    "其他"
                ]
                },
                {
                "name": "白山市",
                "area": [
                    "八道江区",
                    "江源区",
                    "临江市",
                    "靖宇县",
                    "抚松县",
                    "长白朝鲜族自治县",
                    "其他"
                ]
                },
                {
                "name": "松原市",
                "area": [
                    "宁江区",
                    "乾安县",
                    "长岭县",
                    "扶余县",
                    "前郭尔罗斯蒙古族自治县",
                    "其他"
                ]
                },
                {
                "name": "白城市",
                "area": [
                    "洮北区",
                    "大安市",
                    "洮南市",
                    "镇赉县",
                    "通榆县",
                    "其他"
                ]
                },
                {
                "name": "延边朝鲜族自治州",
                "area": [
                    "延吉市",
                    "图们市",
                    "敦化市",
                    "龙井市",
                    "珲春市",
                    "和龙市",
                    "安图县",
                    "汪清县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "黑龙江省",
            "city": [
                {
                "name": "哈尔滨市",
                "area": [
                    "松北区",
                    "道里区",
                    "南岗区",
                    "平房区",
                    "香坊区",
                    "道外区",
                    "呼兰区",
                    "阿城区",
                    "双城市",
                    "尚志市",
                    "五常市",
                    "宾县",
                    "方正县",
                    "通河县",
                    "巴彦县",
                    "延寿县",
                    "木兰县",
                    "依兰县",
                    "其他"
                ]
                },
                {
                "name": "齐齐哈尔市",
                "area": [
                    "龙沙区",
                    "昂昂溪区",
                    "铁锋区",
                    "建华区",
                    "富拉尔基区",
                    "碾子山区",
                    "梅里斯达斡尔族区",
                    "讷河市",
                    "富裕县",
                    "拜泉县",
                    "甘南县",
                    "依安县",
                    "克山县",
                    "泰来县",
                    "克东县",
                    "龙江县",
                    "其他"
                ]
                },
                {
                "name": "鹤岗市",
                "area": [
                    "兴山区",
                    "工农区",
                    "南山区",
                    "兴安区",
                    "向阳区",
                    "东山区",
                    "萝北县",
                    "绥滨县",
                    "其他"
                ]
                },
                {
                "name": "双鸭山",
                "area": [
                    "尖山区",
                    "岭东区",
                    "四方台区",
                    "宝山区",
                    "集贤县",
                    "宝清县",
                    "友谊县",
                    "饶河县",
                    "其他"
                ]
                },
                {
                "name": "鸡西市",
                "area": [
                    "鸡冠区",
                    "恒山区",
                    "城子河区",
                    "滴道区",
                    "梨树区",
                    "麻山区",
                    "密山市",
                    "虎林市",
                    "鸡东县",
                    "其他"
                ]
                },
                {
                "name": "大庆市",
                "area": [
                    "萨尔图区",
                    "红岗区",
                    "龙凤区",
                    "让胡路区",
                    "大同区",
                    "林甸县",
                    "肇州县",
                    "肇源县",
                    "杜尔伯特蒙古族自治县",
                    "其他"
                ]
                },
                {
                "name": "伊春市",
                "area": [
                    "伊春区",
                    "带岭区",
                    "南岔区",
                    "金山屯区",
                    "西林区",
                    "美溪区",
                    "乌马河区",
                    "翠峦区",
                    "友好区",
                    "上甘岭区",
                    "五营区",
                    "红星区",
                    "新青区",
                    "汤旺河区",
                    "乌伊岭区",
                    "铁力市",
                    "嘉荫县",
                    "其他"
                ]
                },
                {
                "name": "牡丹江市",
                "area": [
                    "爱民区",
                    "东安区",
                    "阳明区",
                    "西安区",
                    "绥芬河市",
                    "宁安市",
                    "海林市",
                    "穆棱市",
                    "林口县",
                    "东宁县",
                    "其他"
                ]
                },
                {
                "name": "佳木斯市",
                "area": [
                    "向阳区",
                    "前进区",
                    "东风区",
                    "郊区",
                    "同江市",
                    "富锦市",
                    "桦川县",
                    "抚远县",
                    "桦南县",
                    "汤原县",
                    "其他"
                ]
                },
                {
                "name": "七台河市",
                "area": [
                    "桃山区",
                    "新兴区",
                    "茄子河区",
                    "勃利县",
                    "其他"
                ]
                },
                {
                "name": "黑河市",
                "area": [
                    "爱辉区",
                    "北安市",
                    "五大连池市",
                    "逊克县",
                    "嫩江县",
                    "孙吴县",
                    "其他"
                ]
                },
                {
                "name": "绥化市",
                "area": [
                    "北林区",
                    "安达市",
                    "肇东市",
                    "海伦市",
                    "绥棱县",
                    "兰西县",
                    "明水县",
                    "青冈县",
                    "庆安县",
                    "望奎县",
                    "其他"
                ]
                },
                {
                "name": "大兴安岭地区",
                "area": [
                    "呼玛县",
                    "塔河县",
                    "漠河县",
                    "大兴安岭辖区",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "上海市",
            "city": [
                {
                "name": "上海市",
                "area": [
                    "黄浦区",
                    "卢湾区",
                    "徐汇区",
                    "长宁区",
                    "静安区",
                    "普陀区",
                    "闸北区",
                    "虹口区",
                    "杨浦区",
                    "宝山区",
                    "闵行区",
                    "嘉定区",
                    "松江区",
                    "金山区",
                    "青浦区",
                    "南汇区",
                    "奉贤区",
                    "浦东新区",
                    "崇明县",
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "江苏省",
            "city": [
                {
                "name": "南京市",
                "area": [
                    "玄武区",
                    "白下区",
                    "秦淮区",
                    "建邺区",
                    "鼓楼区",
                    "下关区",
                    "栖霞区",
                    "雨花台区",
                    "浦口区",
                    "江宁区",
                    "六合区",
                    "溧水县",
                    "高淳县",
                    "其他"
                ]
                },
                {
                "name": "苏州市",
                "area": [
                    "金阊区",
                    "平江区",
                    "沧浪区",
                    "虎丘区",
                    "吴中区",
                    "相城区",
                    "常熟市",
                    "张家港市",
                    "昆山市",
                    "吴江市",
                    "太仓市",
                    "其他"
                ]
                },
                {
                "name": "无锡市",
                "area": [
                    "崇安区",
                    "南长区",
                    "北塘区",
                    "滨湖区",
                    "锡山区",
                    "惠山区",
                    "江阴市",
                    "宜兴市",
                    "其他"
                ]
                },
                {
                "name": "常州市",
                "area": [
                    "钟楼区",
                    "天宁区",
                    "戚墅堰区",
                    "新北区",
                    "武进区",
                    "金坛市",
                    "溧阳市",
                    "其他"
                ]
                },
                {
                "name": "镇江市",
                "area": [
                    "京口区",
                    "润州区",
                    "丹徒区",
                    "丹阳市",
                    "扬中市",
                    "句容市",
                    "其他"
                ]
                },
                {
                "name": "南通市",
                "area": [
                    "崇川区",
                    "港闸区",
                    "通州市",
                    "如皋市",
                    "海门市",
                    "启东市",
                    "海安县",
                    "如东县",
                    "其他"
                ]
                },
                {
                "name": "泰州市",
                "area": [
                    "海陵区",
                    "高港区",
                    "姜堰市",
                    "泰兴市",
                    "靖江市",
                    "兴化市",
                    "其他"
                ]
                },
                {
                "name": "扬州市",
                "area": [
                    "广陵区",
                    "维扬区",
                    "邗江区",
                    "江都市",
                    "仪征市",
                    "高邮市",
                    "宝应县",
                    "其他"
                ]
                },
                {
                "name": "盐城市",
                "area": [
                    "亭湖区",
                    "盐都区",
                    "大丰市",
                    "东台市",
                    "建湖县",
                    "射阳县",
                    "阜宁县",
                    "滨海县",
                    "响水县",
                    "其他"
                ]
                },
                {
                "name": "连云港市",
                "area": [
                    "新浦区",
                    "海州区",
                    "连云区",
                    "东海县",
                    "灌云县",
                    "赣榆县",
                    "灌南县",
                    "其他"
                ]
                },
                {
                "name": "徐州市",
                "area": [
                    "云龙区",
                    "鼓楼区",
                    "九里区",
                    "泉山区",
                    "贾汪区",
                    "邳州市",
                    "新沂市",
                    "铜山县",
                    "睢宁县",
                    "沛县",
                    "丰县",
                    "其他"
                ]
                },
                {
                "name": "淮安市",
                "area": [
                    "清河区",
                    "清浦区",
                    "楚州区",
                    "淮阴区",
                    "涟水县",
                    "洪泽县",
                    "金湖县",
                    "盱眙县",
                    "其他"
                ]
                },
                {
                "name": "宿迁市",
                "area": [
                    "宿城区",
                    "宿豫区",
                    "沭阳县",
                    "泗阳县",
                    "泗洪县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "浙江省",
            "city": [
                {
                "name": "杭州市",
                "area": [
                    "拱墅区",
                    "西湖区",
                    "上城区",
                    "下城区",
                    "江干区",
                    "滨江区",
                    "余杭区",
                    "萧山区",
                    "建德市",
                    "富阳市",
                    "临安市",
                    "桐庐县",
                    "淳安县",
                    "其他"
                ]
                },
                {
                "name": "宁波市",
                "area": [
                    "海曙区",
                    "江东区",
                    "江北区",
                    "镇海区",
                    "北仑区",
                    "鄞州区",
                    "余姚市",
                    "慈溪市",
                    "奉化市",
                    "宁海县",
                    "象山县",
                    "其他"
                ]
                },
                {
                "name": "温州市",
                "area": [
                    "鹿城区",
                    "龙湾区",
                    "瓯海区",
                    "瑞安市",
                    "乐清市",
                    "永嘉县",
                    "洞头县",
                    "平阳县",
                    "苍南县",
                    "文成县",
                    "泰顺县",
                    "其他"
                ]
                },
                {
                "name": "嘉兴市",
                "area": [
                    "秀城区",
                    "秀洲区",
                    "海宁市",
                    "平湖市",
                    "桐乡市",
                    "嘉善县",
                    "海盐县",
                    "其他"
                ]
                },
                {
                "name": "湖州市",
                "area": [
                    "吴兴区",
                    "南浔区",
                    "长兴县",
                    "德清县",
                    "安吉县",
                    "其他"
                ]
                },
                {
                "name": "绍兴市",
                "area": [
                    "越城区",
                    "诸暨市",
                    "上虞市",
                    "嵊州市",
                    "绍兴县",
                    "新昌县",
                    "其他"
                ]
                },
                {
                "name": "金华市",
                "area": [
                    "婺城区",
                    "金东区",
                    "兰溪市",
                    "义乌市",
                    "东阳市",
                    "永康市",
                    "武义县",
                    "浦江县",
                    "磐安县",
                    "其他"
                ]
                },
                {
                "name": "衢州市",
                "area": [
                    "柯城区",
                    "衢江区",
                    "江山市",
                    "龙游县",
                    "常山县",
                    "开化县",
                    "其他"
                ]
                },
                {
                "name": "舟山市",
                "area": [
                    "定海区",
                    "普陀区",
                    "岱山县",
                    "嵊泗县",
                    "其他"
                ]
                },
                {
                "name": "台州市",
                "area": [
                    "椒江区",
                    "黄岩区",
                    "路桥区",
                    "临海市",
                    "温岭市",
                    "玉环县",
                    "天台县",
                    "仙居县",
                    "三门县",
                    "其他"
                ]
                },
                {
                "name": "丽水市",
                "area": [
                    "莲都区",
                    "龙泉市",
                    "缙云县",
                    "青田县",
                    "云和县",
                    "遂昌县",
                    "松阳县",
                    "庆元县",
                    "景宁畲族自治县",
                    "其他"
                ]
                },
                {
                "name": "其他市",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "安徽省",
            "city": [
                {
                "name": "合肥市",
                "area": [
                    "庐阳区",
                    "瑶海区",
                    "蜀山区",
                    "包河区",
                    "长丰县",
                    "肥东县",
                    "肥西县",
                    "其他"
                ]
                },
                {
                "name": "芜湖市",
                "area": [
                    "镜湖区",
                    "弋江区",
                    "鸠江区",
                    "三山区",
                    "芜湖县",
                    "南陵县",
                    "繁昌县",
                    "其他"
                ]
                },
                {
                "name": "蚌埠市",
                "area": [
                    "蚌山区",
                    "龙子湖区",
                    "禹会区",
                    "淮上区",
                    "怀远县",
                    "固镇县",
                    "五河县",
                    "其他"
                ]
                },
                {
                "name": "淮南市",
                "area": [
                    "田家庵区",
                    "大通区",
                    "谢家集区",
                    "八公山区",
                    "潘集区",
                    "凤台县",
                    "其他"
                ]
                },
                {
                "name": "马鞍山市",
                "area": [
                    "雨山区",
                    "花山区",
                    "金家庄区",
                    "当涂县",
                    "其他"
                ]
                },
                {
                "name": "淮北市",
                "area": [
                    "相山区",
                    "杜集区",
                    "烈山区",
                    "濉溪县",
                    "其他"
                ]
                },
                {
                "name": "铜陵市",
                "area": [
                    "铜官山区",
                    "狮子山区",
                    "郊区",
                    "铜陵县",
                    "其他"
                ]
                },
                {
                "name": "安庆市",
                "area": [
                    "迎江区",
                    "大观区",
                    "宜秀区",
                    "桐城市",
                    "宿松县",
                    "枞阳县",
                    "太湖县",
                    "怀宁县",
                    "岳西县",
                    "望江县",
                    "潜山县",
                    "其他"
                ]
                },
                {
                "name": "黄山市",
                "area": [
                    "屯溪区",
                    "黄山区",
                    "徽州区",
                    "休宁县",
                    "歙县",
                    "祁门县",
                    "黟县",
                    "其他"
                ]
                },
                {
                "name": "滁州市",
                "area": [
                    "琅琊区",
                    "南谯区",
                    "天长市",
                    "明光市",
                    "全椒县",
                    "来安县",
                    "定远县",
                    "凤阳县",
                    "其他"
                ]
                },
                {
                "name": "阜阳市",
                "area": [
                    "颍州区",
                    "颍东区",
                    "颍泉区",
                    "界首市",
                    "临泉县",
                    "颍上县",
                    "阜南县",
                    "太和县",
                    "其他"
                ]
                },
                {
                "name": "宿州市",
                "area": [
                    "埇桥区",
                    "萧县",
                    "泗县",
                    "砀山县",
                    "灵璧县",
                    "其他"
                ]
                },
                {
                "name": "巢湖市",
                "area": [
                    "居巢区",
                    "含山县",
                    "无为县",
                    "庐江县",
                    "和县",
                    "其他"
                ]
                },
                {
                "name": "六安市",
                "area": [
                    "金安区",
                    "裕安区",
                    "寿县",
                    "霍山县",
                    "霍邱县",
                    "舒城县",
                    "金寨县",
                    "其他"
                ]
                },
                {
                "name": "亳州市",
                "area": [
                    "谯城区",
                    "利辛县",
                    "涡阳县",
                    "蒙城县",
                    "其他"
                ]
                },
                {
                "name": "池州市",
                "area": [
                    "贵池区",
                    "东至县",
                    "石台县",
                    "青阳县",
                    "其他"
                ]
                },
                {
                "name": "宣城市",
                "area": [
                    "宣州区",
                    "宁国市",
                    "广德县",
                    "郎溪县",
                    "泾县",
                    "旌德县",
                    "绩溪县",
                    "其他"
                ]
                },
                {
                "name": "其他市",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "福建省",
            "city": [
                {
                "name": "福州市",
                "area": [
                    "鼓楼区",
                    "台江区",
                    "仓山区",
                    "马尾区",
                    "晋安区",
                    "福清市",
                    "长乐市",
                    "闽侯县",
                    "闽清县",
                    "永泰县",
                    "连江县",
                    "罗源县",
                    "平潭县",
                    "其他"
                ]
                },
                {
                "name": "厦门市",
                "area": [
                    "思明区",
                    "海沧区",
                    "湖里区",
                    "集美区",
                    "同安区",
                    "翔安区",
                    "其他"
                ]
                },
                {
                "name": "莆田市",
                "area": [
                    "城厢区",
                    "涵江区",
                    "荔城区",
                    "秀屿区",
                    "仙游县",
                    "其他"
                ]
                },
                {
                "name": "三明市",
                "area": [
                    "梅列区",
                    "三元区",
                    "永安市",
                    "明溪县",
                    "将乐县",
                    "大田县",
                    "宁化县",
                    "建宁县",
                    "沙县",
                    "尤溪县",
                    "清流县",
                    "泰宁县",
                    "其他"
                ]
                },
                {
                "name": "泉州市",
                "area": [
                    "鲤城区",
                    "丰泽区",
                    "洛江区",
                    "泉港区",
                    "石狮市",
                    "晋江市",
                    "南安市",
                    "惠安县",
                    "永春县",
                    "安溪县",
                    "德化县",
                    "金门县",
                    "其他"
                ]
                },
                {
                "name": "漳州市",
                "area": [
                    "芗城区",
                    "龙文区",
                    "龙海市",
                    "平和县",
                    "南靖县",
                    "诏安县",
                    "漳浦县",
                    "华安县",
                    "东山县",
                    "长泰县",
                    "云霄县",
                    "其他"
                ]
                },
                {
                "name": "南平市",
                "area": [
                    "延平区",
                    "建瓯市",
                    "邵武市",
                    "武夷山市",
                    "建阳市",
                    "松溪县",
                    "光泽县",
                    "顺昌县",
                    "浦城县",
                    "政和县",
                    "其他"
                ]
                },
                {
                "name": "龙岩市",
                "area": [
                    "新罗区",
                    "漳平市",
                    "长汀县",
                    "武平县",
                    "上杭县",
                    "永定县",
                    "连城县",
                    "其他"
                ]
                },
                {
                "name": "宁德市",
                "area": [
                    "蕉城区",
                    "福安市",
                    "福鼎市",
                    "寿宁县",
                    "霞浦县",
                    "柘荣县",
                    "屏南县",
                    "古田县",
                    "周宁县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "江西省",
            "city": [
                {
                "name": "南昌市",
                "area": [
                    "东湖区",
                    "西湖区",
                    "青云谱区",
                    "湾里区",
                    "青山湖区",
                    "新建县",
                    "南昌县",
                    "进贤县",
                    "安义县",
                    "其他"
                ]
                },
                {
                "name": "景德镇市",
                "area": [
                    "珠山区",
                    "昌江区",
                    "乐平市",
                    "浮梁县",
                    "其他"
                ]
                },
                {
                "name": "萍乡市",
                "area": [
                    "安源区",
                    "湘东区",
                    "莲花县",
                    "上栗县",
                    "芦溪县",
                    "其他"
                ]
                },
                {
                "name": "九江市",
                "area": [
                    "浔阳区",
                    "庐山区",
                    "瑞昌市",
                    "九江县",
                    "星子县",
                    "武宁县",
                    "彭泽县",
                    "永修县",
                    "修水县",
                    "湖口县",
                    "德安县",
                    "都昌县",
                    "其他"
                ]
                },
                {
                "name": "新余市",
                "area": [
                    "渝水区",
                    "分宜县",
                    "其他"
                ]
                },
                {
                "name": "鹰潭市",
                "area": [
                    "月湖区",
                    "贵溪市",
                    "余江县",
                    "其他"
                ]
                },
                {
                "name": "赣州市",
                "area": [
                    "章贡区",
                    "瑞金市",
                    "南康市",
                    "石城县",
                    "安远县",
                    "赣县",
                    "宁都县",
                    "寻乌县",
                    "兴国县",
                    "定南县",
                    "上犹县",
                    "于都县",
                    "龙南县",
                    "崇义县",
                    "信丰县",
                    "全南县",
                    "大余县",
                    "会昌县",
                    "其他"
                ]
                },
                {
                "name": "吉安市",
                "area": [
                    "吉州区",
                    "青原区",
                    "井冈山市",
                    "吉安县",
                    "永丰县",
                    "永新县",
                    "新干县",
                    "泰和县",
                    "峡江县",
                    "遂川县",
                    "安福县",
                    "吉水县",
                    "万安县",
                    "其他"
                ]
                },
                {
                "name": "宜春市",
                "area": [
                    "袁州区",
                    "丰城市",
                    "樟树市",
                    "高安市",
                    "铜鼓县",
                    "靖安县",
                    "宜丰县",
                    "奉新县",
                    "万载县",
                    "上高县",
                    "其他"
                ]
                },
                {
                "name": "抚州市",
                "area": [
                    "临川区",
                    "南丰县",
                    "乐安县",
                    "金溪县",
                    "南城县",
                    "东乡县",
                    "资溪县",
                    "宜黄县",
                    "广昌县",
                    "黎川县",
                    "崇仁县",
                    "其他"
                ]
                },
                {
                "name": "上饶市",
                "area": [
                    "信州区",
                    "德兴市",
                    "上饶县",
                    "广丰县",
                    "鄱阳县",
                    "婺源县",
                    "铅山县",
                    "余干县",
                    "横峰县",
                    "弋阳县",
                    "玉山县",
                    "万年县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "山东省",
            "city": [
                {
                "name": "济南市",
                "area": [
                    "市中区",
                    "历下区",
                    "天桥区",
                    "槐荫区",
                    "历城区",
                    "长清区",
                    "章丘市",
                    "平阴县",
                    "济阳县",
                    "商河县",
                    "其他"
                ]
                },
                {
                "name": "青岛市",
                "area": [
                    "市南区",
                    "市北区",
                    "城阳区",
                    "四方区",
                    "李沧区",
                    "黄岛区",
                    "崂山区",
                    "胶南市",
                    "胶州市",
                    "平度市",
                    "莱西市",
                    "即墨市",
                    "其他"
                ]
                },
                {
                "name": "淄博市",
                "area": [
                    "张店区",
                    "临淄区",
                    "淄川区",
                    "博山区",
                    "周村区",
                    "桓台县",
                    "高青县",
                    "沂源县",
                    "其他"
                ]
                },
                {
                "name": "枣庄市",
                "area": [
                    "市中区",
                    "山亭区",
                    "峄城区",
                    "台儿庄区",
                    "薛城区",
                    "滕州市",
                    "其他"
                ]
                },
                {
                "name": "东营市",
                "area": [
                    "东营区",
                    "河口区",
                    "垦利县",
                    "广饶县",
                    "利津县",
                    "其他"
                ]
                },
                {
                "name": "烟台市",
                "area": [
                    "芝罘区",
                    "福山区",
                    "牟平区",
                    "莱山区",
                    "龙口市",
                    "莱阳市",
                    "莱州市",
                    "招远市",
                    "蓬莱市",
                    "栖霞市",
                    "海阳市",
                    "长岛县",
                    "其他"
                ]
                },
                {
                "name": "潍坊市",
                "area": [
                    "潍城区",
                    "寒亭区",
                    "坊子区",
                    "奎文区",
                    "青州市",
                    "诸城市",
                    "寿光市",
                    "安丘市",
                    "高密市",
                    "昌邑市",
                    "昌乐县",
                    "临朐县",
                    "其他"
                ]
                },
                {
                "name": "济宁市",
                "area": [
                    "市中区",
                    "任城区",
                    "曲阜市",
                    "兖州市",
                    "邹城市",
                    "鱼台县",
                    "金乡县",
                    "嘉祥县",
                    "微山县",
                    "汶上县",
                    "泗水县",
                    "梁山县",
                    "其他"
                ]
                },
                {
                "name": "泰安市",
                "area": [
                    "泰山区",
                    "岱岳区",
                    "新泰市",
                    "肥城市",
                    "宁阳县",
                    "东平县",
                    "其他"
                ]
                },
                {
                "name": "威海市",
                "area": [
                    "环翠区",
                    "乳山市",
                    "文登市",
                    "荣成市",
                    "其他"
                ]
                },
                {
                "name": "日照市",
                "area": [
                    "东港区",
                    "岚山区",
                    "五莲县",
                    "莒县",
                    "其他"
                ]
                },
                {
                "name": "莱芜市",
                "area": [
                    "莱城区",
                    "钢城区",
                    "其他"
                ]
                },
                {
                "name": "临沂市",
                "area": [
                    "兰山区",
                    "罗庄区",
                    "河东区",
                    "沂南县",
                    "郯城县",
                    "沂水县",
                    "苍山县",
                    "费县",
                    "平邑县",
                    "莒南县",
                    "蒙阴县",
                    "临沭县",
                    "其他"
                ]
                },
                {
                "name": "德州市",
                "area": [
                    "德城区",
                    "乐陵市",
                    "禹城市",
                    "陵县",
                    "宁津县",
                    "齐河县",
                    "武城县",
                    "庆云县",
                    "平原县",
                    "夏津县",
                    "临邑县",
                    "其他"
                ]
                },
                {
                "name": "聊城市",
                "area": [
                    "东昌府区",
                    "临清市",
                    "高唐县",
                    "阳谷县",
                    "茌平县",
                    "莘县",
                    "东阿县",
                    "冠县",
                    "其他"
                ]
                },
                {
                "name": "滨州市",
                "area": [
                    "滨城区",
                    "邹平县",
                    "沾化县",
                    "惠民县",
                    "博兴县",
                    "阳信县",
                    "无棣县",
                    "其他"
                ]
                },
                {
                "name": "菏泽市",
                "area": [
                    "牡丹区",
                    "鄄城县",
                    "单县",
                    "郓城县",
                    "曹县",
                    "定陶县",
                    "巨野县",
                    "东明县",
                    "成武县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "河南省",
            "city": [
                {
                "name": "郑州市",
                "area": [
                    "中原区",
                    "金水区",
                    "二七区",
                    "管城回族区",
                    "上街区",
                    "惠济区",
                    "巩义市",
                    "新郑市",
                    "新密市",
                    "登封市",
                    "荥阳市",
                    "中牟县",
                    "其他"
                ]
                },
                {
                "name": "开封市",
                "area": [
                    "鼓楼区",
                    "龙亭区",
                    "顺河回族区",
                    "禹王台区",
                    "金明区",
                    "开封县",
                    "尉氏县",
                    "兰考县",
                    "杞县",
                    "通许县",
                    "其他"
                ]
                },
                {
                "name": "洛阳市",
                "area": [
                    "西工区",
                    "老城区",
                    "涧西区",
                    "瀍河回族区",
                    "洛龙区",
                    "吉利区",
                    "偃师市",
                    "孟津县",
                    "汝阳县",
                    "伊川县",
                    "洛宁县",
                    "嵩县",
                    "宜阳县",
                    "新安县",
                    "栾川县",
                    "其他"
                ]
                },
                {
                "name": "平顶山市",
                "area": [
                    "新华区",
                    "卫东区",
                    "湛河区",
                    "石龙区",
                    "汝州市",
                    "舞钢市",
                    "宝丰县",
                    "叶县",
                    "郏县",
                    "鲁山县",
                    "其他"
                ]
                },
                {
                "name": "安阳市",
                "area": [
                    "北关区",
                    "文峰区",
                    "殷都区",
                    "龙安区",
                    "林州市",
                    "安阳县",
                    "滑县",
                    "内黄县",
                    "汤阴县",
                    "其他"
                ]
                },
                {
                "name": "鹤壁市",
                "area": [
                    "淇滨区",
                    "山城区",
                    "鹤山区",
                    "浚县",
                    "淇县",
                    "其他"
                ]
                },
                {
                "name": "新乡市",
                "area": [
                    "卫滨区",
                    "红旗区",
                    "凤泉区",
                    "牧野区",
                    "卫辉市",
                    "辉县市",
                    "新乡县",
                    "获嘉县",
                    "原阳县",
                    "长垣县",
                    "封丘县",
                    "延津县",
                    "其他"
                ]
                },
                {
                "name": "焦作市",
                "area": [
                    "解放区",
                    "中站区",
                    "马村区",
                    "山阳区",
                    "沁阳市",
                    "孟州市",
                    "修武县",
                    "温县",
                    "武陟县",
                    "博爱县",
                    "其他"
                ]
                },
                {
                "name": "濮阳市",
                "area": [
                    "华龙区",
                    "濮阳县",
                    "南乐县",
                    "台前县",
                    "清丰县",
                    "范县",
                    "其他"
                ]
                },
                {
                "name": "许昌市",
                "area": [
                    "魏都区",
                    "禹州市",
                    "长葛市",
                    "许昌县",
                    "鄢陵县",
                    "襄城县",
                    "其他"
                ]
                },
                {
                "name": "漯河市",
                "area": [
                    "源汇区",
                    "郾城区",
                    "召陵区",
                    "临颍县",
                    "舞阳县",
                    "其他"
                ]
                },
                {
                "name": "三门峡市",
                "area": [
                    "湖滨区",
                    "义马市",
                    "灵宝市",
                    "渑池县",
                    "卢氏县",
                    "陕县",
                    "其他"
                ]
                },
                {
                "name": "南阳市",
                "area": [
                    "卧龙区",
                    "宛城区",
                    "邓州市",
                    "桐柏县",
                    "方城县",
                    "淅川县",
                    "镇平县",
                    "唐河县",
                    "南召县",
                    "内乡县",
                    "新野县",
                    "社旗县",
                    "西峡县",
                    "其他"
                ]
                },
                {
                "name": "商丘市",
                "area": [
                    "梁园区",
                    "睢阳区",
                    "永城市",
                    "宁陵县",
                    "虞城县",
                    "民权县",
                    "夏邑县",
                    "柘城县",
                    "睢县",
                    "其他"
                ]
                },
                {
                "name": "信阳市",
                "area": [
                    "浉河区",
                    "平桥区",
                    "潢川县",
                    "淮滨县",
                    "息县",
                    "新县",
                    "商城县",
                    "固始县",
                    "罗山县",
                    "光山县",
                    "其他"
                ]
                },
                {
                "name": "周口市",
                "area": [
                    "川汇区",
                    "项城市",
                    "商水县",
                    "淮阳县",
                    "太康县",
                    "鹿邑县",
                    "西华县",
                    "扶沟县",
                    "沈丘县",
                    "郸城县",
                    "其他"
                ]
                },
                {
                "name": "驻马店市",
                "area": [
                    "驿城区",
                    "确山县",
                    "新蔡县",
                    "上蔡县",
                    "西平县",
                    "泌阳县",
                    "平舆县",
                    "汝南县",
                    "遂平县",
                    "正阳县",
                    "其他"
                ]
                },
                {
                "name": "焦作市",
                "area": [
                    "济源市",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "湖北省",
            "city": [
                {
                "name": "武汉市",
                "area": [
                    "江岸区",
                    "武昌区",
                    "江汉区",
                    "硚口区",
                    "汉阳区",
                    "青山区",
                    "洪山区",
                    "东西湖区",
                    "汉南区",
                    "蔡甸区",
                    "江夏区",
                    "黄陂区",
                    "新洲区",
                    "其他"
                ]
                },
                {
                "name": "黄石市",
                "area": [
                    "黄石港区",
                    "西塞山区",
                    "下陆区",
                    "铁山区",
                    "大冶市",
                    "阳新县",
                    "其他"
                ]
                },
                {
                "name": "十堰市",
                "area": [
                    "张湾区",
                    "茅箭区",
                    "丹江口市",
                    "郧县",
                    "竹山县",
                    "房县",
                    "郧西县",
                    "竹溪县",
                    "其他"
                ]
                },
                {
                "name": "荆州市",
                "area": [
                    "沙市区",
                    "荆州区",
                    "洪湖市",
                    "石首市",
                    "松滋市",
                    "监利县",
                    "公安县",
                    "江陵县",
                    "其他"
                ]
                },
                {
                "name": "宜昌市",
                "area": [
                    "西陵区",
                    "伍家岗区",
                    "点军区",
                    "猇亭区",
                    "夷陵区",
                    "宜都市",
                    "当阳市",
                    "枝江市",
                    "秭归县",
                    "远安县",
                    "兴山县",
                    "五峰土家族自治县",
                    "长阳土家族自治县",
                    "其他"
                ]
                },
                {
                "name": "襄樊市",
                "area": [
                    "襄城区",
                    "樊城区",
                    "襄阳区",
                    "老河口市",
                    "枣阳市",
                    "宜城市",
                    "南漳县",
                    "谷城县",
                    "保康县",
                    "其他"
                ]
                },
                {
                "name": "鄂州市",
                "area": [
                    "鄂城区",
                    "华容区",
                    "梁子湖区",
                    "其他"
                ]
                },
                {
                "name": "荆门市",
                "area": [
                    "东宝区",
                    "掇刀区",
                    "钟祥市",
                    "京山县",
                    "沙洋县",
                    "其他"
                ]
                },
                {
                "name": "孝感市",
                "area": [
                    "孝南区",
                    "应城市",
                    "安陆市",
                    "汉川市",
                    "云梦县",
                    "大悟县",
                    "孝昌县",
                    "其他"
                ]
                },
                {
                "name": "黄冈市",
                "area": [
                    "黄州区",
                    "麻城市",
                    "武穴市",
                    "红安县",
                    "罗田县",
                    "浠水县",
                    "蕲春县",
                    "黄梅县",
                    "英山县",
                    "团风县",
                    "其他"
                ]
                },
                {
                "name": "咸宁市",
                "area": [
                    "咸安区",
                    "赤壁市",
                    "嘉鱼县",
                    "通山县",
                    "崇阳县",
                    "通城县",
                    "其他"
                ]
                },
                {
                "name": "随州市",
                "area": [
                    "曾都区",
                    "广水市",
                    "其他"
                ]
                },
                {
                "name": "恩施土家族苗族自治州",
                "area": [
                    "恩施市",
                    "利川市",
                    "建始县",
                    "来凤县",
                    "巴东县",
                    "鹤峰县",
                    "宣恩县",
                    "咸丰县",
                    "其他"
                ]
                },
                {
                "name": "仙桃市",
                "area": [
                    "仙桃"
                ]
                },
                {
                "name": "天门市",
                "area": [
                    "天门"
                ]
                },
                {
                "name": "潜江市",
                "area": [
                    "潜江"
                ]
                },
                {
                "name": "神农架林区",
                "area": [
                    "神农架林区"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "湖南省",
            "city": [
                {
                "name": "长沙市",
                "area": [
                    "岳麓区",
                    "芙蓉区",
                    "天心区",
                    "开福区",
                    "雨花区",
                    "浏阳市",
                    "长沙县",
                    "望城县",
                    "宁乡县",
                    "其他"
                ]
                },
                {
                "name": "株洲市",
                "area": [
                    "天元区",
                    "荷塘区",
                    "芦淞区",
                    "石峰区",
                    "醴陵市",
                    "株洲县",
                    "炎陵县",
                    "茶陵县",
                    "攸县",
                    "其他"
                ]
                },
                {
                "name": "湘潭市",
                "area": [
                    "岳塘区",
                    "雨湖区",
                    "湘乡市",
                    "韶山市",
                    "湘潭县",
                    "其他"
                ]
                },
                {
                "name": "衡阳市",
                "area": [
                    "雁峰区",
                    "珠晖区",
                    "石鼓区",
                    "蒸湘区",
                    "南岳区",
                    "耒阳市",
                    "常宁市",
                    "衡阳县",
                    "衡东县",
                    "衡山县",
                    "衡南县",
                    "祁东县",
                    "其他"
                ]
                },
                {
                "name": "邵阳市",
                "area": [
                    "双清区",
                    "大祥区",
                    "北塔区",
                    "武冈市",
                    "邵东县",
                    "洞口县",
                    "新邵县",
                    "绥宁县",
                    "新宁县",
                    "邵阳县",
                    "隆回县",
                    "城步苗族自治县",
                    "其他"
                ]
                },
                {
                "name": "岳阳市",
                "area": [
                    "岳阳楼区",
                    "云溪区",
                    "君山区",
                    "临湘市",
                    "汨罗市",
                    "岳阳县",
                    "湘阴县",
                    "平江县",
                    "华容县",
                    "其他"
                ]
                },
                {
                "name": "常德市",
                "area": [
                    "武陵区",
                    "鼎城区",
                    "津市市",
                    "澧县",
                    "临澧县",
                    "桃源县",
                    "汉寿县",
                    "安乡县",
                    "石门县",
                    "其他"
                ]
                },
                {
                "name": "张家界市",
                "area": [
                    "永定区",
                    "武陵源区",
                    "慈利县",
                    "桑植县",
                    "其他"
                ]
                },
                {
                "name": "益阳市",
                "area": [
                    "赫山区",
                    "资阳区",
                    "沅江市",
                    "桃江县",
                    "南县",
                    "安化县",
                    "其他"
                ]
                },
                {
                "name": "郴州市",
                "area": [
                    "北湖区",
                    "苏仙区",
                    "资兴市",
                    "宜章县",
                    "汝城县",
                    "安仁县",
                    "嘉禾县",
                    "临武县",
                    "桂东县",
                    "永兴县",
                    "桂阳县",
                    "其他"
                ]
                },
                {
                "name": "永州市",
                "area": [
                    "冷水滩区",
                    "零陵区",
                    "祁阳县",
                    "蓝山县",
                    "宁远县",
                    "新田县",
                    "东安县",
                    "江永县",
                    "道县",
                    "双牌县",
                    "江华瑶族自治县",
                    "其他"
                ]
                },
                {
                "name": "怀化市",
                "area": [
                    "鹤城区",
                    "洪江市",
                    "会同县",
                    "沅陵县",
                    "辰溪县",
                    "溆浦县",
                    "中方县",
                    "新晃侗族自治县",
                    "芷江侗族自治县",
                    "通道侗族自治县",
                    "靖州苗族侗族自治县",
                    "麻阳苗族自治县",
                    "其他"
                ]
                },
                {
                "name": "娄底市",
                "area": [
                    "娄星区",
                    "冷水江市",
                    "涟源市",
                    "新化县",
                    "双峰县",
                    "其他"
                ]
                },
                {
                "name": "湘西土家族苗族自治州",
                "area": [
                    "吉首市",
                    "古丈县",
                    "龙山县",
                    "永顺县",
                    "凤凰县",
                    "泸溪县",
                    "保靖县",
                    "花垣县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "广东省",
            "city": [
                {
                "name": "广州市",
                "area": [
                    "越秀区",
                    "荔湾区",
                    "海珠区",
                    "天河区",
                    "白云区",
                    "黄埔区",
                    "番禺区",
                    "花都区",
                    "南沙区",
                    "萝岗区",
                    "增城市",
                    "从化市",
                    "其他"
                ]
                },
                {
                "name": "深圳市",
                "area": [
                    "福田区",
                    "罗湖区",
                    "南山区",
                    "宝安区",
                    "龙岗区",
                    "盐田区",
                    "其他"
                ]
                },
                {
                "name": "东莞市",
                "area": [
                    "莞城",
                    "常平",
                    "塘厦",
                    "塘厦",
                    "塘厦",
                    "其他"
                ]
                },
                {
                "name": "中山市",
                "area": [
                    "中山"
                ]
                },
                {
                "name": "潮州市",
                "area": [
                    "湘桥区",
                    "潮安县",
                    "饶平县",
                    "其他"
                ]
                },
                {
                "name": "揭阳市",
                "area": [
                    "榕城区",
                    "揭东县",
                    "揭西县",
                    "惠来县",
                    "普宁市",
                    "其他"
                ]
                },
                {
                "name": "云浮市",
                "area": [
                    "云城区",
                    "新兴县",
                    "郁南县",
                    "云安县",
                    "罗定市",
                    "其他"
                ]
                },
                {
                "name": "珠海市",
                "area": [
                    "香洲区",
                    "斗门区",
                    "金湾区",
                    "其他"
                ]
                },
                {
                "name": "汕头市",
                "area": [
                    "金平区",
                    "濠江区",
                    "龙湖区",
                    "潮阳区",
                    "潮南区",
                    "澄海区",
                    "南澳县",
                    "其他"
                ]
                },
                {
                "name": "韶关市",
                "area": [
                    "浈江区",
                    "武江区",
                    "曲江区",
                    "乐昌市",
                    "南雄市",
                    "始兴县",
                    "仁化县",
                    "翁源县",
                    "新丰县",
                    "乳源瑶族自治县",
                    "其他"
                ]
                },
                {
                "name": "佛山市",
                "area": [
                    "禅城区",
                    "南海区",
                    "顺德区",
                    "三水区",
                    "高明区",
                    "其他"
                ]
                },
                {
                "name": "江门市",
                "area": [
                    "蓬江区",
                    "江海区",
                    "新会区",
                    "恩平市",
                    "台山市",
                    "开平市",
                    "鹤山市",
                    "其他"
                ]
                },
                {
                "name": "湛江市",
                "area": [
                    "赤坎区",
                    "霞山区",
                    "坡头区",
                    "麻章区",
                    "吴川市",
                    "廉江市",
                    "雷州市",
                    "遂溪县",
                    "徐闻县",
                    "其他"
                ]
                },
                {
                "name": "茂名市",
                "area": [
                    "茂南区",
                    "茂港区",
                    "化州市",
                    "信宜市",
                    "高州市",
                    "电白县",
                    "其他"
                ]
                },
                {
                "name": "肇庆市",
                "area": [
                    "端州区",
                    "鼎湖区",
                    "高要市",
                    "四会市",
                    "广宁县",
                    "怀集县",
                    "封开县",
                    "德庆县",
                    "其他"
                ]
                },
                {
                "name": "惠州市",
                "area": [
                    "惠城区",
                    "惠阳区",
                    "博罗县",
                    "惠东县",
                    "龙门县",
                    "其他"
                ]
                },
                {
                "name": "梅州市",
                "area": [
                    "梅江区",
                    "兴宁市",
                    "梅县",
                    "大埔县",
                    "丰顺县",
                    "五华县",
                    "平远县",
                    "蕉岭县",
                    "其他"
                ]
                },
                {
                "name": "汕尾市",
                "area": [
                    "城区",
                    "陆丰市",
                    "海丰县",
                    "陆河县",
                    "其他"
                ]
                },
                {
                "name": "河源市",
                "area": [
                    "源城区",
                    "紫金县",
                    "龙川县",
                    "连平县",
                    "和平县",
                    "东源县",
                    "其他"
                ]
                },
                {
                "name": "阳江市",
                "area": [
                    "江城区",
                    "阳春市",
                    "阳西县",
                    "阳东县",
                    "其他"
                ]
                },
                {
                "name": "清远市",
                "area": [
                    "清城区",
                    "英德市",
                    "连州市",
                    "佛冈县",
                    "阳山县",
                    "清新县",
                    "连山壮族瑶族自治县",
                    "连南瑶族自治县",
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "广西",
            "city": [
                {
                "name": "南宁市",
                "area": [
                    "青秀区",
                    "兴宁区",
                    "西乡塘区",
                    "良庆区",
                    "江南区",
                    "邕宁区",
                    "武鸣县",
                    "隆安县",
                    "马山县",
                    "上林县",
                    "宾阳县",
                    "横县",
                    "其他"
                ]
                },
                {
                "name": "柳州市",
                "area": [
                    "城中区",
                    "鱼峰区",
                    "柳北区",
                    "柳南区",
                    "柳江县",
                    "柳城县",
                    "鹿寨县",
                    "融安县",
                    "融水苗族自治县",
                    "三江侗族自治县",
                    "其他"
                ]
                },
                {
                "name": "桂林市",
                "area": [
                    "象山区",
                    "秀峰区",
                    "叠彩区",
                    "七星区",
                    "雁山区",
                    "阳朔县",
                    "临桂县",
                    "灵川县",
                    "全州县",
                    "平乐县",
                    "兴安县",
                    "灌阳县",
                    "荔浦县",
                    "资源县",
                    "永福县",
                    "龙胜各族自治县",
                    "恭城瑶族自治县",
                    "其他"
                ]
                },
                {
                "name": "梧州市",
                "area": [
                    "万秀区",
                    "蝶山区",
                    "长洲区",
                    "岑溪市",
                    "苍梧县",
                    "藤县",
                    "蒙山县",
                    "其他"
                ]
                },
                {
                "name": "北海市",
                "area": [
                    "海城区",
                    "银海区",
                    "铁山港区",
                    "合浦县",
                    "其他"
                ]
                },
                {
                "name": "防城港市",
                "area": [
                    "港口区",
                    "防城区",
                    "东兴市",
                    "上思县",
                    "其他"
                ]
                },
                {
                "name": "钦州市",
                "area": [
                    "钦南区",
                    "钦北区",
                    "灵山县",
                    "浦北县",
                    "其他"
                ]
                },
                {
                "name": "贵港市",
                "area": [
                    "港北区",
                    "港南区",
                    "覃塘区",
                    "桂平市",
                    "平南县",
                    "其他"
                ]
                },
                {
                "name": "玉林市",
                "area": [
                    "玉州区",
                    "北流市",
                    "容县",
                    "陆川县",
                    "博白县",
                    "兴业县",
                    "其他"
                ]
                },
                {
                "name": "百色市",
                "area": [
                    "右江区",
                    "凌云县",
                    "平果县",
                    "西林县",
                    "乐业县",
                    "德保县",
                    "田林县",
                    "田阳县",
                    "靖西县",
                    "田东县",
                    "那坡县",
                    "隆林各族自治县",
                    "其他"
                ]
                },
                {
                "name": "贺州市",
                "area": [
                    "八步区",
                    "钟山县",
                    "昭平县",
                    "富川瑶族自治县",
                    "其他"
                ]
                },
                {
                "name": "河池市",
                "area": [
                    "金城江区",
                    "宜州市",
                    "天峨县",
                    "凤山县",
                    "南丹县",
                    "东兰县",
                    "都安瑶族自治县",
                    "罗城仫佬族自治县",
                    "巴马瑶族自治县",
                    "环江毛南族自治县",
                    "大化瑶族自治县",
                    "其他"
                ]
                },
                {
                "name": "来宾市",
                "area": [
                    "兴宾区",
                    "合山市",
                    "象州县",
                    "武宣县",
                    "忻城县",
                    "金秀瑶族自治县",
                    "其他"
                ]
                },
                {
                "name": "崇左市",
                "area": [
                    "江州区",
                    "凭祥市",
                    "宁明县",
                    "扶绥县",
                    "龙州县",
                    "大新县",
                    "天等县",
                    "其他"
                ]
                },
                {
                "name": "其他市",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "海南省",
            "city": [
                {
                "name": "海口市",
                "area": [
                    "龙华区",
                    "秀英区",
                    "琼山区",
                    "美兰区",
                    "其他"
                ]
                },
                {
                "name": "三亚市",
                "area": [
                    "三亚市",
                    "其他"
                ]
                },
                {
                "name": "五指山市",
                "area": [
                    "五指山"
                ]
                },
                {
                "name": "琼海市",
                "area": [
                    "琼海"
                ]
                },
                {
                "name": "儋州市",
                "area": [
                    "儋州"
                ]
                },
                {
                "name": "文昌市",
                "area": [
                    "文昌"
                ]
                },
                {
                "name": "万宁市",
                "area": [
                    "万宁"
                ]
                },
                {
                "name": "东方市",
                "area": [
                    "东方"
                ]
                },
                {
                "name": "澄迈县",
                "area": [
                    "澄迈县"
                ]
                },
                {
                "name": "定安县",
                "area": [
                    "定安县"
                ]
                },
                {
                "name": "屯昌县",
                "area": [
                    "屯昌县"
                ]
                },
                {
                "name": "临高县",
                "area": [
                    "临高县"
                ]
                },
                {
                "name": "白沙黎族自治县",
                "area": [
                    "白沙黎族自治县"
                ]
                },
                {
                "name": "昌江黎族自治县",
                "area": [
                    "昌江黎族自治县"
                ]
                },
                {
                "name": "乐东黎族自治县",
                "area": [
                    "乐东黎族自治县"
                ]
                },
                {
                "name": "陵水黎族自治县",
                "area": [
                    "陵水黎族自治县"
                ]
                },
                {
                "name": "保亭黎族苗族自治县",
                "area": [
                    "保亭黎族苗族自治县"
                ]
                },
                {
                "name": "琼中黎族苗族自治县",
                "area": [
                    "琼中黎族苗族自治县"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "重庆市",
            "city": [
                {
                "name": "重庆市",
                "area": [
                    "渝中区",
                    "大渡口区",
                    "江北区",
                    "南岸区",
                    "北碚区",
                    "渝北区",
                    "巴南区",
                    "长寿区",
                    "双桥区",
                    "沙坪坝区",
                    "万盛区",
                    "万州区",
                    "涪陵区",
                    "黔江区",
                    "永川区",
                    "合川区",
                    "江津区",
                    "九龙坡区",
                    "南川区",
                    "綦江县",
                    "潼南县",
                    "荣昌县",
                    "璧山县",
                    "大足县",
                    "铜梁县",
                    "梁平县",
                    "开县",
                    "忠县",
                    "城口县",
                    "垫江县",
                    "武隆县",
                    "丰都县",
                    "奉节县",
                    "云阳县",
                    "巫溪县",
                    "巫山县",
                    "石柱土家族自治县",
                    "秀山土家族苗族自治县",
                    "酉阳土家族苗族自治县",
                    "彭水苗族土家族自治县",
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "四川省",
            "city": [
                {
                "name": "成都市",
                "area": [
                    "青羊区",
                    "锦江区",
                    "金牛区",
                    "武侯区",
                    "成华区",
                    "龙泉驿区",
                    "青白江区",
                    "新都区",
                    "温江区",
                    "都江堰市",
                    "彭州市",
                    "邛崃市",
                    "崇州市",
                    "金堂县",
                    "郫县",
                    "新津县",
                    "双流县",
                    "蒲江县",
                    "大邑县",
                    "其他"
                ]
                },
                {
                "name": "自贡市",
                "area": [
                    "大安区",
                    "自流井区",
                    "贡井区",
                    "沿滩区",
                    "荣县",
                    "富顺县",
                    "其他"
                ]
                },
                {
                "name": "攀枝花市",
                "area": [
                    "仁和区",
                    "米易县",
                    "盐边县",
                    "东区",
                    "西区",
                    "其他"
                ]
                },
                {
                "name": "泸州市",
                "area": [
                    "江阳区",
                    "纳溪区",
                    "龙马潭区",
                    "泸县",
                    "合江县",
                    "叙永县",
                    "古蔺县",
                    "其他"
                ]
                },
                {
                "name": "德阳市",
                "area": [
                    "旌阳区",
                    "广汉市",
                    "什邡市",
                    "绵竹市",
                    "罗江县",
                    "中江县",
                    "其他"
                ]
                },
                {
                "name": "绵阳市",
                "area": [
                    "涪城区",
                    "游仙区",
                    "江油市",
                    "盐亭县",
                    "三台县",
                    "平武县",
                    "安县",
                    "梓潼县",
                    "北川羌族自治县",
                    "其他"
                ]
                },
                {
                "name": "广元市",
                "area": [
                    "元坝区",
                    "朝天区",
                    "青川县",
                    "旺苍县",
                    "剑阁县",
                    "苍溪县",
                    "市中区",
                    "其他"
                ]
                },
                {
                "name": "遂宁市",
                "area": [
                    "船山区",
                    "安居区",
                    "射洪县",
                    "蓬溪县",
                    "大英县",
                    "其他"
                ]
                },
                {
                "name": "内江市",
                "area": [
                    "市中区",
                    "东兴区",
                    "资中县",
                    "隆昌县",
                    "威远县",
                    "其他"
                ]
                },
                {
                "name": "乐山市",
                "area": [
                    "市中区",
                    "五通桥区",
                    "沙湾区",
                    "金口河区",
                    "峨眉山市",
                    "夹江县",
                    "井研县",
                    "犍为县",
                    "沐川县",
                    "马边彝族自治县",
                    "峨边彝族自治县",
                    "其他"
                ]
                },
                {
                "name": "南充",
                "area": [
                    "顺庆区",
                    "高坪区",
                    "嘉陵区",
                    "阆中市",
                    "营山县",
                    "蓬安县",
                    "仪陇县",
                    "南部县",
                    "西充县",
                    "其他"
                ]
                },
                {
                "name": "眉山市",
                "area": [
                    "东坡区",
                    "仁寿县",
                    "彭山县",
                    "洪雅县",
                    "丹棱县",
                    "青神县",
                    "其他"
                ]
                },
                {
                "name": "宜宾市",
                "area": [
                    "翠屏区",
                    "宜宾县",
                    "兴文县",
                    "南溪县",
                    "珙县",
                    "长宁县",
                    "高县",
                    "江安县",
                    "筠连县",
                    "屏山县",
                    "其他"
                ]
                },
                {
                "name": "广安市",
                "area": [
                    "广安区",
                    "华蓥市",
                    "岳池县",
                    "邻水县",
                    "武胜县",
                    "其他"
                ]
                },
                {
                "name": "达州市",
                "area": [
                    "通川区",
                    "万源市",
                    "达县",
                    "渠县",
                    "宣汉县",
                    "开江县",
                    "大竹县",
                    "其他"
                ]
                },
                {
                "name": "雅安市",
                "area": [
                    "雨城区",
                    "芦山县",
                    "石棉县",
                    "名山县",
                    "天全县",
                    "荥经县",
                    "宝兴县",
                    "汉源县",
                    "其他"
                ]
                },
                {
                "name": "巴中市",
                "area": [
                    "巴州区",
                    "南江县",
                    "平昌县",
                    "通江县",
                    "其他"
                ]
                },
                {
                "name": "资阳市",
                "area": [
                    "雁江区",
                    "简阳市",
                    "安岳县",
                    "乐至县",
                    "其他"
                ]
                },
                {
                "name": "阿坝藏族羌族自治州",
                "area": [
                    "马尔康县",
                    "九寨沟县",
                    "红原县",
                    "汶川县",
                    "阿坝县",
                    "理县",
                    "若尔盖县",
                    "小金县",
                    "黑水县",
                    "金川县",
                    "松潘县",
                    "壤塘县",
                    "茂县",
                    "其他"
                ]
                },
                {
                "name": "甘孜藏族自治州",
                "area": [
                    "康定县",
                    "丹巴县",
                    "炉霍县",
                    "九龙县",
                    "甘孜县",
                    "雅江县",
                    "新龙县",
                    "道孚县",
                    "白玉县",
                    "理塘县",
                    "德格县",
                    "乡城县",
                    "石渠县",
                    "稻城县",
                    "色达县",
                    "巴塘县",
                    "泸定县",
                    "得荣县",
                    "其他"
                ]
                },
                {
                "name": "凉山彝族自治州",
                "area": [
                    "西昌市",
                    "美姑县",
                    "昭觉县",
                    "金阳县",
                    "甘洛县",
                    "布拖县",
                    "雷波县",
                    "普格县",
                    "宁南县",
                    "喜德县",
                    "会东县",
                    "越西县",
                    "会理县",
                    "盐源县",
                    "德昌县",
                    "冕宁县",
                    "木里藏族自治县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "贵州省",
            "city": [
                {
                "name": "贵阳市",
                "area": [
                    "南明区",
                    "云岩区",
                    "花溪区",
                    "乌当区",
                    "白云区",
                    "小河区",
                    "清镇市",
                    "开阳县",
                    "修文县",
                    "息烽县",
                    "其他"
                ]
                },
                {
                "name": "六盘水市",
                "area": [
                    "钟山区",
                    "水城县",
                    "盘县",
                    "六枝特区",
                    "其他"
                ]
                },
                {
                "name": "遵义市",
                "area": [
                    "红花岗区",
                    "汇川区",
                    "赤水市",
                    "仁怀市",
                    "遵义县",
                    "绥阳县",
                    "桐梓县",
                    "习水县",
                    "凤冈县",
                    "正安县",
                    "余庆县",
                    "湄潭县",
                    "道真仡佬族苗族自治县",
                    "务川仡佬族苗族自治县",
                    "其他"
                ]
                },
                {
                "name": "安顺市",
                "area": [
                    "西秀区",
                    "普定县",
                    "平坝县",
                    "镇宁布依族苗族自治县",
                    "紫云苗族布依族自治县",
                    "关岭布依族苗族自治县",
                    "其他"
                ]
                },
                {
                "name": "铜仁地区",
                "area": [
                    "铜仁市",
                    "德江县",
                    "江口县",
                    "思南县",
                    "石阡县",
                    "玉屏侗族自治县",
                    "松桃苗族自治县",
                    "印江土家族苗族自治县",
                    "沿河土家族自治县",
                    "万山特区",
                    "其他"
                ]
                },
                {
                "name": "毕节地区",
                "area": [
                    "毕节市",
                    "黔西县",
                    "大方县",
                    "织金县",
                    "金沙县",
                    "赫章县",
                    "纳雍县",
                    "威宁彝族回族苗族自治县",
                    "其他"
                ]
                },
                {
                "name": "黔西南布依族苗族自治州",
                "area": [
                    "兴义市",
                    "望谟县",
                    "兴仁县",
                    "普安县",
                    "册亨县",
                    "晴隆县",
                    "贞丰县",
                    "安龙县",
                    "其他"
                ]
                },
                {
                "name": "黔东南苗族侗族自治州",
                "area": [
                    "凯里市",
                    "施秉县",
                    "从江县",
                    "锦屏县",
                    "镇远县",
                    "麻江县",
                    "台江县",
                    "天柱县",
                    "黄平县",
                    "榕江县",
                    "剑河县",
                    "三穗县",
                    "雷山县",
                    "黎平县",
                    "岑巩县",
                    "丹寨县",
                    "其他"
                ]
                },
                {
                "name": "黔南布依族苗族自治州",
                "area": [
                    "都匀市",
                    "福泉市",
                    "贵定县",
                    "惠水县",
                    "罗甸县",
                    "瓮安县",
                    "荔波县",
                    "龙里县",
                    "平塘县",
                    "长顺县",
                    "独山县",
                    "三都水族自治县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "云南省",
            "city": [
                {
                "name": "昆明市",
                "area": [
                    "盘龙区",
                    "五华区",
                    "官渡区",
                    "西山区",
                    "东川区",
                    "安宁市",
                    "呈贡县",
                    "晋宁县",
                    "富民县",
                    "宜良县",
                    "嵩明县",
                    "石林彝族自治县",
                    "禄劝彝族苗族自治县",
                    "寻甸回族彝族自治县",
                    "其他"
                ]
                },
                {
                "name": "曲靖市",
                "area": [
                    "麒麟区",
                    "宣威市",
                    "马龙县",
                    "沾益县",
                    "富源县",
                    "罗平县",
                    "师宗县",
                    "陆良县",
                    "会泽县",
                    "其他"
                ]
                },
                {
                "name": "玉溪市",
                "area": [
                    "红塔区",
                    "江川县",
                    "澄江县",
                    "通海县",
                    "华宁县",
                    "易门县",
                    "峨山彝族自治县",
                    "新平彝族傣族自治县",
                    "元江哈尼族彝族傣族自治县",
                    "其他"
                ]
                },
                {
                "name": "保山市",
                "area": [
                    "隆阳区",
                    "施甸县",
                    "腾冲县",
                    "龙陵县",
                    "昌宁县",
                    "其他"
                ]
                },
                {
                "name": "昭通市",
                "area": [
                    "昭阳区",
                    "鲁甸县",
                    "巧家县",
                    "盐津县",
                    "大关县",
                    "永善县",
                    "绥江县",
                    "镇雄县",
                    "彝良县",
                    "威信县",
                    "水富县",
                    "其他"
                ]
                },
                {
                "name": "丽江市",
                "area": [
                    "古城区",
                    "永胜县",
                    "华坪县",
                    "玉龙纳西族自治县",
                    "宁蒗彝族自治县",
                    "其他"
                ]
                },
                {
                "name": "普洱市",
                "area": [
                    "思茅区",
                    "普洱哈尼族彝族自治县",
                    "墨江哈尼族自治县",
                    "景东彝族自治县",
                    "景谷傣族彝族自治县",
                    "镇沅彝族哈尼族拉祜族自治县",
                    "江城哈尼族彝族自治县",
                    "孟连傣族拉祜族佤族自治县",
                    "澜沧拉祜族自治县",
                    "西盟佤族自治县",
                    "其他"
                ]
                },
                {
                "name": "临沧市",
                "area": [
                    "临翔区",
                    "凤庆县",
                    "云县",
                    "永德县",
                    "镇康县",
                    "双江拉祜族佤族布朗族傣族自治县",
                    "耿马傣族佤族自治县",
                    "沧源佤族自治县",
                    "其他"
                ]
                },
                {
                "name": "德宏傣族景颇族自治州",
                "area": [
                    "潞西市",
                    "瑞丽市",
                    "梁河县",
                    "盈江县",
                    "陇川县",
                    "其他"
                ]
                },
                {
                "name": "怒江傈僳族自治州",
                "area": [
                    "泸水县",
                    "福贡县",
                    "贡山独龙族怒族自治县",
                    "兰坪白族普米族自治县",
                    "其他"
                ]
                },
                {
                "name": "迪庆藏族自治州",
                "area": [
                    "香格里拉县",
                    "德钦县",
                    "维西傈僳族自治县",
                    "其他"
                ]
                },
                {
                "name": "大理白族自治州",
                "area": [
                    "大理市",
                    "祥云县",
                    "宾川县",
                    "弥渡县",
                    "永平县",
                    "云龙县",
                    "洱源县",
                    "剑川县",
                    "鹤庆县",
                    "漾濞彝族自治县",
                    "南涧彝族自治县",
                    "巍山彝族回族自治县",
                    "其他"
                ]
                },
                {
                "name": "楚雄彝族自治州",
                "area": [
                    "楚雄市",
                    "双柏县",
                    "牟定县",
                    "南华县",
                    "姚安县",
                    "大姚县",
                    "永仁县",
                    "元谋县",
                    "武定县",
                    "禄丰县",
                    "其他"
                ]
                },
                {
                "name": "红河哈尼族彝族自治州",
                "area": [
                    "蒙自县",
                    "个旧市",
                    "开远市",
                    "绿春县",
                    "建水县",
                    "石屏县",
                    "弥勒县",
                    "泸西县",
                    "元阳县",
                    "红河县",
                    "金平苗族瑶族傣族自治县",
                    "河口瑶族自治县",
                    "屏边苗族自治县",
                    "其他"
                ]
                },
                {
                "name": "文山壮族苗族自治州",
                "area": [
                    "文山县",
                    "砚山县",
                    "西畴县",
                    "麻栗坡县",
                    "马关县",
                    "丘北县",
                    "广南县",
                    "富宁县",
                    "其他"
                ]
                },
                {
                "name": "西双版纳傣族自治州",
                "area": [
                    "景洪市",
                    "勐海县",
                    "勐腊县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "西藏",
            "city": [
                {
                "name": "拉萨市",
                "area": [
                    "城关区",
                    "林周县",
                    "当雄县",
                    "尼木县",
                    "曲水县",
                    "堆龙德庆县",
                    "达孜县",
                    "墨竹工卡县",
                    "其他"
                ]
                },
                {
                "name": "那曲地区",
                "area": [
                    "那曲县",
                    "嘉黎县",
                    "比如县",
                    "聂荣县",
                    "安多县",
                    "申扎县",
                    "索县",
                    "班戈县",
                    "巴青县",
                    "尼玛县",
                    "其他"
                ]
                },
                {
                "name": "昌都地区",
                "area": [
                    "昌都县",
                    "江达县",
                    "贡觉县",
                    "类乌齐县",
                    "丁青县",
                    "察雅县",
                    "八宿县",
                    "左贡县",
                    "芒康县",
                    "洛隆县",
                    "边坝县",
                    "其他"
                ]
                },
                {
                "name": "林芝地区",
                "area": [
                    "林芝县",
                    "工布江达县",
                    "米林县",
                    "墨脱县",
                    "波密县",
                    "察隅县",
                    "朗县",
                    "其他"
                ]
                },
                {
                "name": "山南地区",
                "area": [
                    "乃东县",
                    "扎囊县",
                    "贡嘎县",
                    "桑日县",
                    "琼结县",
                    "曲松县",
                    "措美县",
                    "洛扎县",
                    "加查县",
                    "隆子县",
                    "错那县",
                    "浪卡子县",
                    "其他"
                ]
                },
                {
                "name": "日喀则地区",
                "area": [
                    "日喀则市",
                    "南木林县",
                    "江孜县",
                    "定日县",
                    "萨迦县",
                    "拉孜县",
                    "昂仁县",
                    "谢通门县",
                    "白朗县",
                    "仁布县",
                    "康马县",
                    "定结县",
                    "仲巴县",
                    "亚东县",
                    "吉隆县",
                    "聂拉木县",
                    "萨嘎县",
                    "岗巴县",
                    "其他"
                ]
                },
                {
                "name": "阿里地区",
                "area": [
                    "噶尔县",
                    "普兰县",
                    "札达县",
                    "日土县",
                    "革吉县",
                    "改则县",
                    "措勤县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "陕西省",
            "city": [
                {
                "name": "西安市",
                "area": [
                    "莲湖区",
                    "新城区",
                    "碑林区",
                    "雁塔区",
                    "灞桥区",
                    "未央区",
                    "阎良区",
                    "临潼区",
                    "长安区",
                    "高陵县",
                    "蓝田县",
                    "户县",
                    "周至县",
                    "其他"
                ]
                },
                {
                "name": "铜川市",
                "area": [
                    "耀州区",
                    "王益区",
                    "印台区",
                    "宜君县",
                    "其他"
                ]
                },
                {
                "name": "宝鸡市",
                "area": [
                    "渭滨区",
                    "金台区",
                    "陈仓区",
                    "岐山县",
                    "凤翔县",
                    "陇县",
                    "太白县",
                    "麟游县",
                    "扶风县",
                    "千阳县",
                    "眉县",
                    "凤县",
                    "其他"
                ]
                },
                {
                "name": "咸阳市",
                "area": [
                    "秦都区",
                    "渭城区",
                    "杨陵区",
                    "兴平市",
                    "礼泉县",
                    "泾阳县",
                    "永寿县",
                    "三原县",
                    "彬县",
                    "旬邑县",
                    "长武县",
                    "乾县",
                    "武功县",
                    "淳化县",
                    "其他"
                ]
                },
                {
                "name": "渭南市",
                "area": [
                    "临渭区",
                    "韩城市",
                    "华阴市",
                    "蒲城县",
                    "潼关县",
                    "白水县",
                    "澄城县",
                    "华县",
                    "合阳县",
                    "富平县",
                    "大荔县",
                    "其他"
                ]
                },
                {
                "name": "延安市",
                "area": [
                    "宝塔区",
                    "安塞县",
                    "洛川县",
                    "子长县",
                    "黄陵县",
                    "延川县",
                    "富县",
                    "延长县",
                    "甘泉县",
                    "宜川县",
                    "志丹县",
                    "黄龙县",
                    "吴起县",
                    "其他"
                ]
                },
                {
                "name": "汉中市",
                "area": [
                    "汉台区",
                    "留坝县",
                    "镇巴县",
                    "城固县",
                    "南郑县",
                    "洋县",
                    "宁强县",
                    "佛坪县",
                    "勉县",
                    "西乡县",
                    "略阳县",
                    "其他"
                ]
                },
                {
                "name": "榆林市",
                "area": [
                    "榆阳区",
                    "清涧县",
                    "绥德县",
                    "神木县",
                    "佳县",
                    "府谷县",
                    "子洲县",
                    "靖边县",
                    "横山县",
                    "米脂县",
                    "吴堡县",
                    "定边县",
                    "其他"
                ]
                },
                {
                "name": "安康市",
                "area": [
                    "汉滨区",
                    "紫阳县",
                    "岚皋县",
                    "旬阳县",
                    "镇坪县",
                    "平利县",
                    "石泉县",
                    "宁陕县",
                    "白河县",
                    "汉阴县",
                    "其他"
                ]
                },
                {
                "name": "商洛市",
                "area": [
                    "商州区",
                    "镇安县",
                    "山阳县",
                    "洛南县",
                    "商南县",
                    "丹凤县",
                    "柞水县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "甘肃省",
            "city": [
                {
                "name": "兰州市",
                "area": [
                    "城关区",
                    "七里河区",
                    "西固区",
                    "安宁区",
                    "红古区",
                    "永登县",
                    "皋兰县",
                    "榆中县",
                    "其他"
                ]
                },
                {
                "name": "嘉峪关市",
                "area": [
                    "嘉峪关市",
                    "其他"
                ]
                },
                {
                "name": "金昌市",
                "area": [
                    "金川区",
                    "永昌县",
                    "其他"
                ]
                },
                {
                "name": "白银市",
                "area": [
                    "白银区",
                    "平川区",
                    "靖远县",
                    "会宁县",
                    "景泰县",
                    "其他"
                ]
                },
                {
                "name": "天水市",
                "area": [
                    "清水县",
                    "秦安县",
                    "甘谷县",
                    "武山县",
                    "张家川回族自治县",
                    "北道区",
                    "秦城区",
                    "其他"
                ]
                },
                {
                "name": "武威市",
                "area": [
                    "凉州区",
                    "民勤县",
                    "古浪县",
                    "天祝藏族自治县",
                    "其他"
                ]
                },
                {
                "name": "酒泉市",
                "area": [
                    "肃州区",
                    "玉门市",
                    "敦煌市",
                    "金塔县",
                    "肃北蒙古族自治县",
                    "阿克塞哈萨克族自治县",
                    "安西县",
                    "其他"
                ]
                },
                {
                "name": "张掖市",
                "area": [
                    "甘州区",
                    "民乐县",
                    "临泽县",
                    "高台县",
                    "山丹县",
                    "肃南裕固族自治县",
                    "其他"
                ]
                },
                {
                "name": "庆阳市",
                "area": [
                    "西峰区",
                    "庆城县",
                    "环县",
                    "华池县",
                    "合水县",
                    "正宁县",
                    "宁县",
                    "镇原县",
                    "其他"
                ]
                },
                {
                "name": "平凉市",
                "area": [
                    "崆峒区",
                    "泾川县",
                    "灵台县",
                    "崇信县",
                    "华亭县",
                    "庄浪县",
                    "静宁县",
                    "其他"
                ]
                },
                {
                "name": "定西市",
                "area": [
                    "安定区",
                    "通渭县",
                    "临洮县",
                    "漳县",
                    "岷县",
                    "渭源县",
                    "陇西县",
                    "其他"
                ]
                },
                {
                "name": "陇南市",
                "area": [
                    "武都区",
                    "成县",
                    "宕昌县",
                    "康县",
                    "文县",
                    "西和县",
                    "礼县",
                    "两当县",
                    "徽县",
                    "其他"
                ]
                },
                {
                "name": "临夏回族自治州",
                "area": [
                    "临夏市",
                    "临夏县",
                    "康乐县",
                    "永靖县",
                    "广河县",
                    "和政县",
                    "东乡族自治县",
                    "积石山保安族东乡族撒拉族自治县",
                    "其他"
                ]
                },
                {
                "name": "甘南藏族自治州",
                "area": [
                    "合作市",
                    "临潭县",
                    "卓尼县",
                    "舟曲县",
                    "迭部县",
                    "玛曲县",
                    "碌曲县",
                    "夏河县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "青海省",
            "city": [
                {
                "name": "西宁市",
                "area": [
                    "城中区",
                    "城东区",
                    "城西区",
                    "城北区",
                    "湟源县",
                    "湟中县",
                    "大通回族土族自治县",
                    "其他"
                ]
                },
                {
                "name": "海东地区",
                "area": [
                    "平安县",
                    "乐都县",
                    "民和回族土族自治县",
                    "互助土族自治县",
                    "化隆回族自治县",
                    "循化撒拉族自治县",
                    "其他"
                ]
                },
                {
                "name": "海北藏族自治州",
                "area": [
                    "海晏县",
                    "祁连县",
                    "刚察县",
                    "门源回族自治县",
                    "其他"
                ]
                },
                {
                "name": "海南藏族自治州",
                "area": [
                    "共和县",
                    "同德县",
                    "贵德县",
                    "兴海县",
                    "贵南县",
                    "其他"
                ]
                },
                {
                "name": "黄南藏族自治州",
                "area": [
                    "同仁县",
                    "尖扎县",
                    "泽库县",
                    "河南蒙古族自治县",
                    "其他"
                ]
                },
                {
                "name": "果洛藏族自治州",
                "area": [
                    "玛沁县",
                    "班玛县",
                    "甘德县",
                    "达日县",
                    "久治县",
                    "玛多县",
                    "其他"
                ]
                },
                {
                "name": "玉树藏族自治州",
                "area": [
                    "玉树县",
                    "杂多县",
                    "称多县",
                    "治多县",
                    "囊谦县",
                    "曲麻莱县",
                    "其他"
                ]
                },
                {
                "name": "海西蒙古族藏族自治州",
                "area": [
                    "德令哈市",
                    "格尔木市",
                    "乌兰县",
                    "都兰县",
                    "天峻县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "宁夏",
            "city": [
                {
                "name": "银川市",
                "area": [
                    "兴庆区",
                    "西夏区",
                    "金凤区",
                    "灵武市",
                    "永宁县",
                    "贺兰县",
                    "其他"
                ]
                },
                {
                "name": "石嘴山市",
                "area": [
                    "大武口区",
                    "惠农区",
                    "平罗县",
                    "其他"
                ]
                },
                {
                "name": "吴忠市",
                "area": [
                    "利通区",
                    "青铜峡市",
                    "盐池县",
                    "同心县",
                    "其他"
                ]
                },
                {
                "name": "固原市",
                "area": [
                    "原州区",
                    "西吉县",
                    "隆德县",
                    "泾源县",
                    "彭阳县",
                    "其他"
                ]
                },
                {
                "name": "中卫市",
                "area": [
                    "沙坡头区",
                    "中宁县",
                    "海原县",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "新疆",
            "city": [
                {
                "name": "乌鲁木齐市",
                "area": [
                    "天山区",
                    "沙依巴克区",
                    "新市区",
                    "水磨沟区",
                    "头屯河区",
                    "达坂城区",
                    "东山区",
                    "乌鲁木齐县",
                    "其他"
                ]
                },
                {
                "name": "克拉玛依市",
                "area": [
                    "克拉玛依区",
                    "独山子区",
                    "白碱滩区",
                    "乌尔禾区",
                    "其他"
                ]
                },
                {
                "name": "吐鲁番地区",
                "area": [
                    "吐鲁番市",
                    "托克逊县",
                    "鄯善县",
                    "其他"
                ]
                },
                {
                "name": "哈密地区",
                "area": [
                    "哈密市",
                    "伊吾县",
                    "巴里坤哈萨克自治县",
                    "其他"
                ]
                },
                {
                "name": "和田地区",
                "area": [
                    "和田市",
                    "和田县",
                    "洛浦县",
                    "民丰县",
                    "皮山县",
                    "策勒县",
                    "于田县",
                    "墨玉县",
                    "其他"
                ]
                },
                {
                "name": "阿克苏地区",
                "area": [
                    "阿克苏市",
                    "温宿县",
                    "沙雅县",
                    "拜城县",
                    "阿瓦提县",
                    "库车县",
                    "柯坪县",
                    "新和县",
                    "乌什县",
                    "其他"
                ]
                },
                {
                "name": "喀什地区",
                "area": [
                    "喀什市",
                    "巴楚县",
                    "泽普县",
                    "伽师县",
                    "叶城县",
                    "岳普湖县",
                    "疏勒县",
                    "麦盖提县",
                    "英吉沙县",
                    "莎车县",
                    "疏附县",
                    "塔什库尔干塔吉克自治县",
                    "其他"
                ]
                },
                {
                "name": "克孜勒苏柯尔克孜自治州",
                "area": [
                    "阿图什市",
                    "阿合奇县",
                    "乌恰县",
                    "阿克陶县",
                    "其他"
                ]
                },
                {
                "name": "巴音郭楞蒙古自治州",
                "area": [
                    "库尔勒市",
                    "和静县",
                    "尉犁县",
                    "和硕县",
                    "且末县",
                    "博湖县",
                    "轮台县",
                    "若羌县",
                    "焉耆回族自治县",
                    "其他"
                ]
                },
                {
                "name": "昌吉回族自治州",
                "area": [
                    "昌吉市",
                    "阜康市",
                    "奇台县",
                    "玛纳斯县",
                    "吉木萨尔县",
                    "呼图壁县",
                    "木垒哈萨克自治县",
                    "米泉市",
                    "其他"
                ]
                },
                {
                "name": "博尔塔拉蒙古自治州",
                "area": [
                    "博乐市",
                    "精河县",
                    "温泉县",
                    "其他"
                ]
                },
                {
                "name": "石河子",
                "area": [
                    "石河子"
                ]
                },
                {
                "name": "阿拉尔",
                "area": [
                    "阿拉尔"
                ]
                },
                {
                "name": "图木舒克",
                "area": [
                    "图木舒克"
                ]
                },
                {
                "name": "五家渠",
                "area": [
                    "五家渠"
                ]
                },
                {
                "name": "伊犁哈萨克自治州",
                "area": [
                    "伊宁市",
                    "奎屯市",
                    "伊宁县",
                    "特克斯县",
                    "尼勒克县",
                    "昭苏县",
                    "新源县",
                    "霍城县",
                    "巩留县",
                    "察布查尔锡伯自治县",
                    "塔城地区",
                    "阿勒泰地区",
                    "其他"
                ]
                },
                {
                "name": "其他",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "台湾省",
            "city": [
                {
                "name": "台北市",
                "area": [
                    "内湖区",
                    "南港区",
                    "中正区",
                    "万华区",
                    "大同区",
                    "中山区",
                    "松山区",
                    "大安区",
                    "信义区",
                    "文山区",
                    "士林区",
                    "北投区"
                ]
                },
                {
                "name": "新北市",
                "area": [
                    "板桥区",
                    "汐止区",
                    "新店区",
                    "其他"
                ]
                },
                {
                "name": "桃园市",
                "area": [
                    "其他"
                ]
                },
                {
                "name": "台中市",
                "area": [
                    "其他"
                ]
                },
                {
                "name": "台南市",
                "area": [
                    "其他"
                ]
                },
                {
                "name": "高雄市",
                "area": [
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "澳门",
            "city": [
                {
                "name": "澳门",
                "area": [
                    "花地玛堂区",
                    "圣安多尼堂区",
                    "大堂区",
                    "望德堂区",
                    "风顺堂区",
                    "嘉模堂区",
                    "圣方济各堂区",
                    "路凼",
                    "其他"
                ]
                }
            ]
            },
            {
            "name": "香港",
            "city": [
                {
                "name": "香港",
                "area": [
                    "深水埗区",
                    "油尖旺区",
                    "九龙城区",
                    "黄大仙区",
                    "观塘区",
                    "北区",
                    "大埔区",
                    "沙田区",
                    "西贡区",
                    "元朗区",
                    "屯门区",
                    "荃湾区",
                    "葵青区",
                    "离岛区",
                    "中西区",
                    "湾仔区",
                    "东区",
                    "南区",
                    "其他"
                ]
                }
            ]
            }
        ]
      }
    }
  })();
(function () {

  /**
   * @ngdoc service
   * @name app.calcDateService
   * @description
   * 日期相关计算
   */

  'use strict';
  angular
    .module('app')
    .service('calcDateService', calcDateService);

  function calcDateService() {

    /**
     * @ngdoc method
     * @name app.calcDateService#basedDate
     * @methodOf app.calcDateService
     * @description
     * 基于所给日期计算所给天数后的日期
     * @param {string} "yyyy-MM-dd" 格式的日期字符串
     * @param {number} num 距离所给日期的天数，所给日期后为整数，所给日期前为负数，所给日期为0
     * @returns {string} "yyyy-MM-dd" 格式的日期字符串
     * @example
     * <pre>
     * calcDateService.basedDate('2012-11-12', 2);
     * </pre>
     */

    this.basedDate = function (date, num) {
      var newDate = new Date(date);
      newDate.setDate(newDate.getDate() + num);
      var day = newDate.getDate() < 10 ? '0' + newDate.getDate().toString() : newDate.getDate();
      var month = newDate.getMonth() + 1 < 10 ? '0' + (newDate.getMonth() + 1).toString() : newDate.getMonth() + 1;
      var year = newDate.getFullYear();
      return year + '-' + month + '-' + day;
    };

    /**
     * @ngdoc method
     * @name app.calcDateService#basedToday
     * @methodOf app.calcDateService
     * @description
     * 计算今天后所给天数后的日期
     * @param {number} num 距离今天的天数，今天后为整数，今天前为负数，今天为0
     * @returns {string} "yyyy-MM-dd" 格式的日期字符串
     * @example
     * <pre>
     * calcDateService.basedToday(1);
     * </pre>
     */

    this.basedToday = function (num) {
      var date = new Date();
      date.setDate(date.getDate() + num);
      var year = date.getUTCFullYear();
      var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      if (num == 0) {
        return year + '-' + month + '-' + day;
      } else {
        return year + '-' + month + '-' + day;
      }
    };

    /**
     * @ngdoc method
     * @name app.calcDateService#dateDiff
     * @methodOf app.calcDateService
     * @description
     * 计算两个日期之差
     * @param {string} beginDate 开始日期，字符串格式为“yyyy-MM-dd”
     * @param {string} endDate 开始日期，字符串格式为“yyyy-MM-dd”
     * @returns {number} 开始日期与结束日期天数之差，开始日期大于结束日期返回负数，反之返回正数。
     * @example
     * <pre>
     * calcDateService.dateDiff('2010-12-12', '2011-12-12');
     * </pre>
     */

    this.dateDiff = function (beginDate, endDate) {
      var beginDate = beginDate.substr(0, 10).split("-");
      var Date1 = new Date(beginDate[1] + '-' + beginDate[2] + '-' + beginDate[0]);
      var endDate = endDate.substr(0, 10).split("-");
      var Date2 = new Date(endDate[1] + '-' + endDate[2] + '-' + endDate[0]);
      return parseInt(Math.abs(Date1 - Date2) / 1000 / 60 / 60 / 24);
    };

    return this
  }
})();
(function () {
  angular
    .module('app')
    .value('APP_CONFIG', APP_CONFIG);

  APP_CONFIG.inject = ['HOST'];

  function APP_CONFIG(HOST) {
    return {
      host: HOST
    }
  }
})();
angular.module('app').factory('DgUiTemplateEngine', function(){
    var base_module = {
        name: '',
        type: -1,
        value: '',
        title: '',
        desc: '',
        editable: false
    };

    
    var text_input_module = angular.copy(base_module);   //type 1
    var number_input_module = angular.copy(base_module); //type 2
    var time_input_module = angular.copy(base_module);   //type 3 
    var radios_module = angular.copy(base_module);       //type 4
    radios_module.options = [];
    var checkboxes_module = angular.copy(base_module);   //type 5
    checkboxes_module.options = [];
    var image_module = angular.copy(base_module);        //type 6
    var textarea_module = angular.copy(base_module);     //type 7
    var text_module = angular.copy(base_module);         //type 8
    var select_module = angular.copy(base_module);       //type 9
    select_module.options = [];
    select_module.placeholder = '请点击选择';
    var media_module = angular.copy(base_module);        //type 10
    var switch_module = angular.copy(base_module);       //type 11
    var link_module = angular.copy(base_module);         //type 12
    var button_module = angular.copy(base_module);       //type 13
    var qrcode_module = angular.copy(base_module);       //type 14
    qrcode_module.width = 150;
    qrcode_module.visible = true;
    var phone_module = angular.copy(base_module);        //type 15

    var template = {
        name: '',
        title: '',
        desc:'',
        size: 0,
        modules: [],
        name_map: {},
        style: 1,
        theme: 1
    };

    var module_list_base = [
    template,
    text_input_module,
    number_input_module,
    time_input_module,
    radios_module,
    checkboxes_module,
    image_module,
    textarea_module,
    text_module,
    select_module,
    media_module,
    switch_module,
    link_module,
    button_module,
    qrcode_module,
    phone_module
    ];



    return{
        createTemplate: function(name){
            var new_template = angular.copy(template);
            new_template.name = name;
            return new_template;
        },
        //desc: create empty module
        //use: createModule(type, name)
        createModule: function(){
            if(arguments.length == 0){
                return null;
            }
            var module_type = arguments[0];
            if(module_type > module_list_base.length || module_type < 0){
                return null;
            }
            var new_module = angular.copy(module_list_base[module_type]);
            new_module.type = module_type;
            if(arguments.length > 1){
                new_module.name = arguments[1];
            }
            if(arguments.length > 2){
                new_module.title = arguments[2];
            }
            if(arguments.length > 3){
                new_module.editable = arguments[3];
            }
            return new_module;
        },
        addModule: function(template, module){
            if(module.name){
                // module.name = template.modules.length + '-' + module.type;
                template.name_map[module.name] = template.modules.length;
            }
            template.modules.push(module);
            template.size = template.modules.length;
        },
        deleteModuleByIndex: function(template, index){
            if(index < template.modules.length && index > -1){
                template.modules.splice(index, 1);
                template.size = template.modules.length;
            }
            else{
                console.error('template: ' + template.name + ' delete module by index failed, index: ' + index);
            }
        },
        getModuleByIndex: function(template, index){
            if(index < template.modules.length && index > -1){
                return template.modules[index];
            }
            else{
                console.error('template: ' + template.name + ' get module by index failed, index: ' + index);
                return null;
            }
        },
        getModuleByName: function(template, name){
            if(name in template.name_map){
                var index = template.name_map[name];
                return template.modules[index];
            }
            return null;
        },
        updateTemplateNameMap: function(template){
            for(var i = 0; i<template.modules.length; i++){
                var module = template.modules[i];
                template.name_map[module.name] = i;
            }
            template.size = template.modules.length;
        },
        createOption: function(title_str, value_int){
            return {
                title: title_str,
                value: value_int
            };
        },
        addOption: function(module, option){
            if(module.options){
                module.options.push(option);
            }
            else{
                console.error('module: ' + module.name + ' has no options, add failed!');
            }
        },
        deleteOption: function(module, index){
            if(module.options && index < module.options.length && index > -1){
                module.options.splice(index, 1);
            }
            else{
                console.error('module: ' + module.name + ' delete option failed!');
            }
        },
        getValues: function(template){
            var values = {};
            for(var key in template.name_map){
                values[key] = template.modules[template.name_map[key]].value;
            }
            return values;
        },
        setValues: function(template, key_value_map){
            for(var key in key_value_map){
                template.modules[template.name_map[key]].value = key_value_map[key];
            }
        },
        bindModel: function(scope, template_str, model_str){
            scope.$watch(
                function(){
                    return scope[template_str];
                },
                function(newVaule, oldValue){
                    if(newVaule == oldValue){
                        return;
                    }
                    var template = scope[template_str];
                    var model = scope[model_str];
                    for(var key in model){
                        if(key in template.name_map){
                            var index = template.name_map[key];
                            var module = template.modules[index];
                            model[key] = module.value;
                        }
                    }
                },
                true);
            scope.$watch(
                function(){
                    return scope[model_str];
                },
                function(newVaule, oldValue){
                    if(newVaule == oldValue){
                        return;
                    }
                    var template = scope[template_str];
                    var model = scope[model_str];
                    for(var key in model){
                        if(key in template.name_map){
                            var index = template.name_map[key];
                            var module = template.modules[index];
                            module.value = model[key];
                        }
                    }
                },
                true);
        },
        getMobilePreviewScope: function(preview_dom_id){
            var preview_iframe = document.getElementById(preview_dom_id);
            return preview_iframe.contentWindow.angular.element(preview_iframe.contentDocument.getElementById('user_template_root_dom')).scope();                
        }
    };
});
angular.module('app').factory('agentService', function ($resource, APP_CONFIG) {
  return {
    agentInfoRes: function () {
      return $resource(APP_CONFIG.host + 'agentinfo', {agent_infoid: '@id'}, {
        all: {method: 'GET', isArray: false},
        update: {method: 'PUT'}
      })
    }
  };
});
(function () {
    'use strict';
    angular
      .module('app')
      .config(routerConfig);
  
    function routerConfig($stateProvider) {
          var strategyPerformanceStatisticsChild = [{
            name: 'hourlyApp',
            url: 'hourlyApp',
            controller: 'hourlyApp',
            templateUrl: 'hourlyApp/hourlyApp',
            controllerUrl: 'hourlyApp/hourlyAppday'
          }, {
            name: 'hourlyWhole',
            url: 'hourlyWhole',
            controller: 'hourlyWhole',
            templateUrl: 'hourlyWhole/hourlyWhole',
            controllerUrl: 'hourlyWhole/hourlyWhole'
          }, {
            name: 'dayApp',
            url: 'dayApp',
            controller: 'dayApp',
            templateUrl: 'dayApp/dayApp',
            controllerUrl: 'dayApp/dayApp'
          }, {
            name: 'dayWhole',
            url: 'dayWhole',
            controller: 'dayWhole',
            templateUrl: 'dayWhole/dayWhole',
            controllerUrl: 'dayWhole/dayWhole'
          }, {
            name: 'appTimeProcess',
            url: 'appTimeProcess',
            controller: 'appTimeProcess',
            templateUrl: 'appTimeProcess/appTimeProcess',
            controllerUrl: 'appTimeProcess/appTimeProcess'
          }, {
            name: 'wholeTimeProcess',
            url: 'wholeTimeProcess',
            controller: 'wholeTimeProcess',
            templateUrl: 'wholeTimeProcess/wholeTimeProcess',
            controllerUrl: 'wholeTimeProcess/wholeTimeProcess'
          }];
          $stateProvider.childRegisteredState(strategyPerformanceStatisticsChild, 'strategyPerformanceStatistics');
    }
  })();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var strategyEffectStatisticsChild = [{
      name: 'day',
      url: 'day?isExist&app_name&scene_type&userid&cid&imei&itemid&cateid&cnt&start',
      controller: 'day',
      templateUrl: 'day/day',
      controllerUrl: 'day/day'
    }, {
      name: 'hourlyOverall',
      url: 'hourlyOverall',
      controller: 'hourlyOverall',
      templateUrl: 'hourlyOverall/hourlyOverall',
      controllerUrl: 'hourlyOverall/hourlyOverall'
    }, {
      name: 'hourly',
      url: 'hourly?isExist&app_name&scene_type&userid&cid&imei&itemid&cateid&cnt&start',
      controller: 'hourly',
      templateUrl: 'hourly/hourly',
      controllerUrl: 'hourly/hourly'
    }, {
      name: 'dayOverall',
      url: 'dayOverall',
      controller: 'dayOverall',
      templateUrl: 'dayOverall/dayOverall',
      controllerUrl: 'dayOverall/dayOverall'
    }, {
      name: 'whiteList',
      url: 'whiteList',
      controller: 'whiteList',
      templateUrl: 'whiteList/whiteList',
      controllerUrl: 'whiteList/whiteList'
    }];
    $stateProvider.childRegisteredState(strategyEffectStatisticsChild, 'strategyEffectStatistics');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var recommendationChild = [{
      name: 'account',
      url: 'account',
      controller: 'account',
      templateUrl: 'account/account',
      controllerUrl: 'account/account'
    }, {
      name: 'account.item',
      url: ':id',
      controller: 'account.item',
      templateUrl: 'account/item/item',
      controllerUrl: 'account/item/item'
    }, {
      name: 'API',
      url: 'API',
      controller: 'API',
      templateUrl: 'API/API',
      controllerUrl: 'API/API'
    }, {
      name: 'API.item',
      url: ':id',
      controller: 'API.item',
      templateUrl: 'API/item/item',
      controllerUrl: 'API/item/item'
    },{
      name: 'contact',
      url: 'contact',
      controller: 'contact',
      templateUrl: 'contact/contact',
      controllerUrl: 'contact/contact'
    }, {
      name: 'ucloud',
      url: 'ucloud',
      controller: 'ucloud',
      templateUrl: 'ucloud/ucloud',
      controllerUrl: 'ucloud/ucloud'
    }];

    $stateProvider.childRegisteredState(recommendationChild, 'recommendation');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var recDebugChild = [{
      name: 'personal',
      url: 'personal?isExist&app_name&scene_type&userid&cid&imei&itemid&cateid&cnt&start',
      controller: 'personal',
      templateUrl: 'personal/personal',
      controllerUrl: 'personal/personal'
    }, {
      name: 'related',
      url: 'related?isExist&app_name&scene_type&userid&cid&imei&itemid&cateid&cnt&start',
      controller: 'related',
      templateUrl: 'related/related',
      controllerUrl: 'related/related'
    }, {
      name: 'hot',
      url: 'hot?isExist&app_name&scene_type&userid&cid&imei&itemid&cateid&cnt&start',
      controller: 'hot',
      templateUrl: 'hot/hot',
      controllerUrl: 'hot/hot'
    }, {
      name: 'review',
      url: 'review',
      controller: 'review',
      templateUrl: 'review/review',
      controllerUrl: 'review/review'
    }];
    $stateProvider.childRegisteredState(recDebugChild, 'recDebug');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var recConfigChild = [{
      name: 'actionConfig',
      url: 'actionConfig',
      controller: 'actionConfig',
      templateUrl: 'actionConfig/actionConfig',
      controllerUrl: 'actionConfig/actionConfig'
    }, {
      name: 'actionConfig.item',
      url: ':id',
      controller: 'actionConfig.item',
      templateUrl: 'actionConfig/item/item',
      controllerUrl: 'actionConfig/item/item'
    }, {
      name: 'hotRecConfig',
      url: 'hotRecConfig',
      controller: 'hotRecConfig',
      templateUrl: 'hotRecConfig/hotRecConfig',
      controllerUrl: 'hotRecConfig/hotRecConfig'
    }, {
      name: 'hotRecConfig.item',
      url: ':id',
      controller: 'hotRecConfig.item',
      templateUrl: 'hotRecConfig/item/item',
      controllerUrl: 'hotRecConfig/item/item'
    }, {
      name: 'aboutRecConfig',
      url: 'aboutRecConfig',
      controller: 'aboutRecConfig',
      templateUrl: 'aboutRecConfig/aboutRecConfig',
      controllerUrl: 'aboutRecConfig/aboutRecConfig'
    }, {
      name: 'mergeConfig',
      url: 'mergeConfig',
      controller: 'mergeConfig',
      templateUrl: 'mergeConfig/mergeConfig',
      controllerUrl: 'mergeConfig/mergeConfig'
    }, {
      name: 'basicConfig',
      url: 'basicConfig',
      controller: 'basicConfig',
      templateUrl: 'basicConfig/basicConfig',
      controllerUrl: 'basicConfig/basicConfig'
    }, {
      name: 'basicConfig.item',
      url: ':id',
      controller: 'basicConfig.item',
      templateUrl: 'basicConfig/item/item',
      controllerUrl: 'basicConfig/item/item'
    }, {
      name: 'timeConfig',
      url: 'timeConfig',
      controller: 'timeConfig',
      templateUrl: 'timeConfig/timeConfig',
      controllerUrl: 'timeConfig/timeConfig'
    }, {
      name: 'timeConfig.item',
      url: ':id',
      controller: 'timeConfig.item',
      templateUrl: 'timeConfig/item/item',
      controllerUrl: 'timeConfig/item/item'
    }, {
      name: 'diversityConfig',
      url: 'diversityConfig',
      controller: 'diversityConfig',
      templateUrl: 'diversityConfig/diversityConfig',
      controllerUrl: 'diversityConfig/diversityConfig'
    }, {
      name: 'diversityConfig.item',
      url: ':id',
      controller: 'diversityConfig.item',
      templateUrl: 'diversityConfig/item/item',
      controllerUrl: 'diversityConfig/item/item'
    }, {
      name: 'relatedSuggestConfig',
      url: 'relatedSuggestConfig',
      controller: 'relatedSuggestConfig',
      templateUrl: 'relatedSuggestConfig/relatedSuggestConfig',
      controllerUrl: 'relatedSuggestConfig/relatedSuggestConfig'
    }, {
      name: 'relatedSuggestConfig.item',
      url: ':id',
      controller: 'relatedSuggestConfig.item',
      templateUrl: 'relatedSuggestConfig/item/item',
      controllerUrl: 'relatedSuggestConfig/item/item'
    }];
    $stateProvider.childRegisteredState(recConfigChild, 'recConfig');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var publicChild = [{
      name: 'action',
      url: 'action',
      controller: 'action',
      templateUrl: 'action/action',
      controllerUrl: 'action/action'
    }, {
      name: 'feedback',
      url: 'feedback',
      controller: 'feedback',
      templateUrl: 'feedback/feedback',
      controllerUrl: 'feedback/feedback'
    }, {
      name: 'binding',
      url: 'binding',
      controller: 'binding',
      templateUrl: 'binding/binding',
      controllerUrl: 'binding/binding'
    }];

    $stateProvider.childRegisteredState(publicChild, 'public');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var projectChild = [{
      name: 'testApplication',
      url: 'testApplication',
      controller: 'testApplication',
      templateUrl: 'testApplication/testApplication',
      controllerUrl: 'testApplication/testApplication',
      params: {
        create: null
      }
    }];

    $stateProvider.childRegisteredState(projectChild, 'project');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var orderChild = [{
      name: 'list',
      url: 'list',
      controller: 'list',
      templateUrl: 'list/list',
      controllerUrl: 'list/list'
    }, {
      name: 'update',
      url: 'update/:id',
      controller: 'update',
      templateUrl: 'update/update',
      controllerUrl: 'update/update'
    }];
    $stateProvider.childRegisteredState(orderChild, 'order');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var offlineChild = [{
      name: 'data',
      url: 'data',
      controller: 'data',
      templateUrl: 'data/data',
      controllerUrl: 'data/data'
    }, {
      name: 'hot',
      url: 'hot',
      controller: 'hot',
      templateUrl: 'hot/hot',
      controllerUrl: 'hot/hot'
    }, {
      name: 'rec',
      url: 'rec',
      controller: 'rec',
      templateUrl: 'rec/rec',
      controllerUrl: 'rec/rec'
    }];
    $stateProvider.childRegisteredState(offlineChild, 'offline');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var textReviewChild = [{
      name: 'manualReview',
      url: 'manual-review',
      controller: 'manualReview',
      templateUrl: 'manualReview/manualReview',
      controllerUrl: 'manualReview/manualReview'
    }, {
      name: 'feedback',
      url: 'feedback',
      controller: 'feedback',
      templateUrl: 'feedback/feedback',
      controllerUrl: 'feedback/feedback'
    }];

    $stateProvider.childRegisteredState(textReviewChild, 'textReview');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var managementChild = [{
      cache: false,
      name: 'user',
      url: 'user',
      controller: 'user',
      templateUrl: 'user/user',
      controllerUrl: 'user/user'
    }, {
      name: 'user.item',
      url: ':id',
      controller: 'user.item',
      templateUrl: 'user/item/item',
      controllerUrl: 'user/item/item'
    }, {
      name: 'role',
      url: 'role',
      controller: 'role',
      templateUrl: 'role/role',
      controllerUrl: 'role/role'
    }, {
      name: 'role.item',
      url: ':id',
      controller: 'role.item',
      templateUrl: 'role/item/item',
      controllerUrl: 'role/item/item'
    }, {
      name: 'resource',
      url: 'resource',
      controller: 'resource',
      templateUrl: 'resource/resource',
      controllerUrl: 'resource/resource'
    }, {
      name: 'resource.resource',
      url: 'resource',
      controller: 'resource.resource',
      templateUrl: 'resource/resource/resource',
      controllerUrl: 'resource/resource/resource'
    }, {
      name: 'resource.resource.item',
      url: ':resource_id',
      controller: 'resource.resource.item',
      templateUrl: 'resource/resource/item/item',
      controllerUrl: 'resource/resource/item/item'
    },
    //  {
    //   name: 'resource.group',
    //   url: 'group',
    //   controller: 'resource.group',
    //   templateUrl: 'resource/group/group',
    //   controllerUrl: 'resource/group/group'
    // }, 
    {
      name: 'resource.group.item',
      url: ':id',
      controller: 'resource.group.item',
      templateUrl: 'resource/group/item/item',
      controllerUrl: 'resource/group/item/item'
    }, {
      name: 'advanced',
      url: 'advanced',
      controller: 'advanced',
      templateUrl: 'advanced/advanced',
      controllerUrl: 'advanced/advanced'
    }, {
      name: 'advanced.item',
      url: ':id',
      controller: 'advanced.item',
      templateUrl: 'advanced/item/item',
      controllerUrl: 'advanced/item/item'
    }, {
    }, {
      name: 'menu',
      url: 'menu',
      controller: 'menu',
      templateUrl: 'menu/menu',
      controllerUrl: 'menu/menu'
    }, {
      name: 'channel',
      url: 'channel',
      controller: 'channel',
      templateUrl: 'channel/channel',
      controllerUrl: 'channel/channel'
    }, {
      name: 'mailTemplate',
      url: 'mail-template',
      controller: 'mailTemplate',
      templateUrl: 'mailTemplate/mailTemplate',
      controllerUrl: 'mailTemplate/mailTemplate'
    }, {
        name: 'industry',
        url: 'industry',
        controller: 'industry',
        templateUrl: 'industry/industry',
        controllerUrl: 'industry/industry'
      }, {
        name: 'configManage',
        url: 'configManage',
        controller: 'configManage',
        templateUrl: 'configManage/configManage',
        controllerUrl: 'configManage/configManage'
      }
    ];

    $stateProvider.childRegisteredState(managementChild, 'management');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var crawlChild = [{
      name: 'statistics',
      url: 'statistics',
      controller: 'statistics',
      templateUrl: 'statistics/statistics',
      controllerUrl: 'statistics/statistics'
    }];

    $stateProvider.childRegisteredState(crawlChild, 'crawl');
  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var contactChild = [{
      name: 'contact',
      url: 'contact',
      controller: 'contact',
      templateUrl: 'contact/contact',
      controllerUrl: 'contact/contact'
    }, {
      name: 'ucloud',
      url: 'ucloud',
      controller: 'ucloud',
      templateUrl: 'ucloud/ucloud',
      controllerUrl: 'ucloud/ucloud'
    }, 
    // 新联系我们
    {
      name: 'contactUsMsg',
      url: 'contactUsMsg',
      controller: 'contactUsMsg',
      templateUrl: 'contactUsMsg/contactUsMsg',
      controllerUrl: 'contactUsMsg/contactUsMsg'
    }, 
    // 申请试用数据
    {
      name: 'applyForTrialData',
      url: 'applyForTrialData',
      controller: 'applyForTrialData',
      templateUrl: 'applyForTrialData/applyForTrialData',
      controllerUrl: 'applyForTrialData/applyForTrialData'
    }];

    $stateProvider.childRegisteredState(contactChild, 'contact');
  }
})();
(function () {
    'use strict';
    angular
        .module('app')
        .config(routerConfig);

    function routerConfig($stateProvider) {
        var configManageChild = [{
                name: 'basicConfig',
                url: 'basicConfig',
                controller: 'basicConfig',
                templateUrl: 'basicConfig/basicConfig',
                controllerUrl: 'basicConfig/basicConfig'
            }, {
                name: 'basicConfig.item',
                url: ':id',
                controller: 'basicConfig.item',
                templateUrl: 'basicConfig/item/item',
                controllerUrl: 'basicConfig/item/item'
            }, {
                name: 'timeConfig',
                url: 'timeConfig',
                controller: 'timeConfig',
                templateUrl: 'timeConfig/timeConfig',
                controllerUrl: 'timeConfig/timeConfig'
            }, {
                name: 'timeConfig.item',
                url: ':id',
                controller: 'timeConfig.item',
                templateUrl: 'timeConfig/item/item',
                controllerUrl: 'timeConfig/item/item'
            }, {
                name: 'diversityConfig',
                url: 'diversityConfig',
                controller: 'diversityConfig',
                templateUrl: 'diversityConfig/diversityConfig',
                controllerUrl: 'diversityConfig/diversityConfig'
            }, {
                name: 'diversityConfig.item',
                url: ':id',
                controller: 'diversityConfig.item',
                templateUrl: 'diversityConfig/item/item',
                controllerUrl: 'diversityConfig/item/item'
            }, {
                name: 'relatedSuggestConfig',
                url: 'relatedSuggestConfig',
                controller: 'relatedSuggestConfig',
                templateUrl: 'relatedSuggestConfig/relatedSuggestConfig',
                controllerUrl: 'relatedSuggestConfig/relatedSuggestConfig'
            }, {
                name: 'relatedSuggestConfig.item',
                url: ':id',
                controller: 'relatedSuggestConfig.item',
                templateUrl: 'relatedSuggestConfig/item/item',
                controllerUrl: 'relatedSuggestConfig/item/item'
            }
        ];

        $stateProvider.childRegisteredState(configManageChild, 'configManage');
    }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    var clientChild = [{
      name: 'account',
      url: 'account',
      controller: 'account',
      templateUrl: 'account/account',
      controllerUrl: 'account/account'
    }, {
      name: 'API',
      url: 'API',
      controller: 'API',
      templateUrl: 'API/API',
      controllerUrl: 'API/API'
    }, {
      name: 'API.item',
      url: ':id',
      controller: 'API.item',
      templateUrl: 'API/item/item',
      controllerUrl: 'API/item/item'
    }, {
      name: 'review',
      url: 'review',
      controller: 'review',
      templateUrl: 'review/review',
      controllerUrl: 'review/review'
    }, {
      name: 'apply',
      url: 'apply',
      controller: 'apply',
      templateUrl: 'apply/apply',
      controllerUrl: 'apply/apply',
    }];

    $stateProvider.childRegisteredState(clientChild, 'client');
  }
})();
(function () {
    'use strict';
    angular
      .module('app')
      .config(routerConfig);
  
    function routerConfig($stateProvider) {
      var accountChild = [
        {
          name: 'unonlineDetail',
          url: 'unonlineDetail?id&pre&name',
          controller: 'unonlineDetail',
          templateUrl: 'management/unonlineDetail/unonlineDetail',
          controllerUrl: 'management/unonlineDetail/unonlineDetail'
        },
         {
            name: 'open',
            url: 'open',
            controller: 'open',
            templateUrl: 'open/open',
            controllerUrl: 'open/open'
          }, {
            name: 'management',
            url: ':management',
            controller: 'management',
            templateUrl: 'management/management',
            controllerUrl: 'management/management'
          },    
          {
            name: 'onlineDetail',
            url: 'onlineDetail?id&pre&name',
            controller: 'onlineDetail',
            templateUrl: 'management/onlineDetail/onlineDetail',
            controllerUrl: 'management/onlineDetail/onlineDetail'
          }];
  
      $stateProvider.childRegisteredState(accountChild, 'account');
    }
  })();
(function () {
    'use strict';
    /**
     * @ngdoc filter
     * @name app.filter:tableData
     * @description
     * table中元素过滤器
     */
    angular
      .module('app')
      .filter('tableArrayFilter', tableArrayFilter)
      .filter('tableTimeFilter', tableTimeFilter);
  
    function tableArrayFilter() {
    /**
     * 没想好怎么总结
     */
      return function(index, json) {
        var result;
        if(!index) {
            return '—';
        }

        if(!name) {
            return json.data[index];
        }

        if(!json.data[index] && (result = json.data[index][json.name])) {
            return result;
        }

        return index;
      }
    }

    function tableTimeFilter() {
        return function(data) {
            if (!data) {
                return '—';
            }

            return data.substring(0, 10);
        }
    }
  })();
(function () {
  'use strict';
  /**
   * @ngdoc filter
   * @name app.filter:status
   * @description
   * 显示禁用或启用
   */
  angular
    .module('app')
    .filter('status', status);

  function status() {
    return statusFilter;

    function statusFilter(status) {
      return !status ? '禁用' : '启用';
    }
  }
})();
(function () {
  'use strict';
  /**
   * @ngdoc filter
   * @name app.filter:lenFilter
   * @description
   * 长度显示，超出长度的部分用'...'替换
   * @param {number} maxLength 显示的长度
   */
  angular
    .module('app')
    .filter('lenFilter', lenFilter);

  function lenFilter() {
    return function (str, maxLength) {
      if (!str) {
        return;
      }

      if (typeof str !== 'string') {
        str = str.toString();
      }

      if (!maxLength) {
        maxLength = 5;
      }
      return str.length > maxLength ? (str.substring(0, maxLength) + '...') : str;
    };
  }
})();
(function () {
  'use strict';
  /**
   * @ngdoc filter
   * @name app.filter:disabled
   * @description
   * 显示禁用或启用
   */
  angular
    .module('app')
    .filter('disabled', disabled);

  function disabled() {
    return disabledFilter;

    function disabledFilter(disabled) {
      return disabled ? '禁用' : '启用';
    }
  }
})();
(function () {
  'use strict';
  /**
   * @ngdoc filter
   * @name app.filter:NLPPOS
   * @description
   * NLP 按照分词的类型返回对应的 class 名，不在已知列表中的返回默认 class 名
   */
  angular
    .module('app')
    .filter('NLPPOS', NLPPOS);

  function NLPPOS() {
    var POS = ['n', 'nr', 'ns', 'nt', 't', 'v', 'a', 'm', 'o'];
    return function (pos) {
      if (POS.indexOf(pos) > -1) {
        return 'pos-' + pos;
      } else {
        return 'pos-o';
      }
    };
  }
})();
(function () {
  angular
    .module('app')
    .directive('tablePagination', tablePagination);
  function tablePagination() {
    return {
      restrict: 'A',
      compile: compile
    };
    function compile(element) {
      element.attr('template-pagination', 'src/common/pagination.html');
    }
  }
})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:selectConvertToNumber
   * @description
   * select 的值转化为 number 类型
   * @restrict A
   * @element select
   */


  angular
    .module('app')
    .directive('selectConvertToNumber', selectConvertToNumber);


  function selectConvertToNumber() {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function (val) {
          return val != null ? parseInt(val, 10) : null;
        });
        ngModel.$formatters.push(function (val) {
          return val != null ? '' + val : null;
        });
      }
    };
  }

})();
angular
  .module('app')
  .directive('customPopover', ['$compile', 'APP_CONFIG', function ($compile, APP_CONFIG) {
    return {
      restrict: 'A',
      //template: '<span>{{label}}</span>',
      link: function (scope, el, attrs) {
        //scope.label = attrs.popoverLabel;
        if (attrs.popoverTarget) attrs.popoverHtml = $compile($(attrs.popoverTarget).html())(scope);
        if (attrs.popoverTemplate) attrs.popoverHtml = $compile(APP_CONFIG['jsTemplate'][attrs.popoverTemplate])(scope);
        $(el).popover({
          trigger: attrs.popoverTrigger || 'focus',
          title: attrs.popoverTitle,
          html: true,
          content: attrs.popoverHtml,
          placement: attrs.popoverPlacement
        });

        $(el).on('shown.bs.popover', function () {
          $(el).next().find('.btn-ok').click(function () {
            $(el).popover('hide');
          });
          if (attrs.popoverCopy) {
            var client = new ZeroClipboard($('.clip-btn'), {
              moviePath: "/js/lib/zeroclipboard/dist/ZeroClipboard.swf"
            });
            client.on("aftercopy", function (event) {
              $('.warning-msg').html('');
              global.message('复制成功', 'success');
            });
          }
        });
      }
    };
  }]);
(function () {
  /**
   * @ngdoc directive
   * @name app.directive:periodDatePicker
   * @description
   * 日期弹出选择器
   * @restrict E
   * @scope
   * @param {string} ngModel 绑定的 ngModel，格式为`{start: 'yyyy-MM-dd', end: 'yyyy-MM-dd'}`
   * @param {string} maxDate 最大日期，格式为"yyyy-MM-dd"
   * @param {string} minDate 最小日期，格式为"yyyy-MM-dd"
   * @param {string} disableClear 空字符串，禁用清除按钮
   * @param {string} beyondToday 空字符串，允许选取超过今天的日期
   * @param {string} disableToday 空字符串，禁用今天按钮
   * @param {number} maxPeriod 开始日期到结束日期的最多天数
   * @param {function} ngChange ngModel change时触发的函数
   * @requires app.calcDateService
   * @requires $timeout
   * @requires $filter
   */

  'use strict';
  
  angular
    .module('app')
    .directive('periodDatePicker', periodDatePicker);

  periodDatePicker.inject = ['calcDateService', '$timeout', '$filter'];

  function periodDatePicker(calcDateService, $timeout, $filter) {
    var directive = {
      restrict: 'E',
      scope: {
        ngModel: '=',
        maxDate: '=?',
        minDate: '=?',
        config: '=?',
        maxPeriod: '=?',
        ngChange: '&ngChange'
      },
      replace: true,
      transclude: true,
      template: template,
      link: link
    };

    var startModelName = 'startModelName';
    var endModelName = 'endModelName';

    function template() {

      var inputAttr = function (ngModelName, key) {
        var limit = key === 'start' ? 'min-date="minDate" max-date="limitStart"' : 'min-date="limitEnd" max-date="maxDate"';
        return [
          'type="text"',
          'class="form-control"',
          'is-open="' + key + 'Opened"',
          'uib-datepicker-popup=""',
          'ng-model="' + ngModelName + '"',
          'ng-required="ngRequired"',
          'show-weeks="false"',
          limit,
          'ng-click="open' + key.substr(0, 1).toUpperCase() + key.substr(1) + 'Pop($event)"'
        ].join(' ');
      };

      var datepicker = function (ngModelName, key) {
        return [
          '<div class="datepicker-box">',
          '<span class="input-group-btn" ng-click="open' + key.substr(0, 1).toUpperCase() + key.substr(1) + 'Pop($event)">',
          '<button type="button" class="btn" ng-click="openPop($event)">',
          '<i class="glyphicon glyphicon-calendar"></i>',
          '</button></span>',
          '<input ' + inputAttr(ngModelName, key) + '/>',
          '</div>'
        ].join('');
      };

      return [
        '<div class="double-datepicker">',
        datepicker(startModelName, 'start'),
        datepicker(endModelName, 'end'),
        '</div>'
      ].join('');
    }

    function link(scope, element, attr) {
      // timeout ngChange
      $timeout(function () {
        scope.canSearch = true;
      }, 500);

      function setCompletionTime(date, key) {
        var time = {
          start: ' 00:00:00',
          end: ' 23:59:59'
        };
        if (date == null) {
          return null;
        }
        if (attr.completionTime === '') {
          return date + time[key]
        } else {
          return date
        }
      }

      function isMaxToday() {
        return attr.beyondToday != '';
      }
      var today = calcDateService.basedToday(0);

      if (isMaxToday()) {
        scope.maxDate = today;
      }

      function setPeriodLimit(date, key) {
        if (scope.maxPeriod) {
          var days = key === 'start' ?
            scope.maxPeriod - calcDateService.dateDiff(date, scope.ngModel.end) - 1 :
            scope.maxPeriod - calcDateService.dateDiff(date, scope.ngModel.start) - 1;
          switch (key) {
            case 'start':
              var endDate = calcDateService.basedDate(scope.ngModel.end, days);
              if (isMaxToday() && calcDateService.dateDiff(today, endDate) > 0) {
                scope.limitStart = scope.maxDate = today;
              } else {
                scope.limitStart = scope.maxDate = endDate;
              }
              break;
            case 'end':
              var startDate = calcDateService.basedDate(scope.ngModel.start, -days);
              scope.limitEnd = scope.minDate = startDate;
              break;
          }
        } else {
          switch (key) {
            case 'start':
              scope.limitEnd = date;
              break;
            case 'end':
              scope.limitStart = date;
              break;
          }
        }
      }

      // date filter
      function getDateString(date, type) {
        if (angular.isNumber(type)) {
          return $filter('date')(date, 'yyyyMMdd');
        } else if (angular.isString(type)) {
          return date.replace(/-/g, '');
        } else {
          return $filter('date')(date, 'yyyy-MM-dd');
        }
      }

      function newValueToModel(newValue) {
        if (angular.isObject(newValue) && newValue !== null) {
          return attr.completionTime === '' ?
            new Date(Date.parse(newValue.toLocaleDateString().substr(0, 10).replace(/\-/g, '/'))) :
            new Date(Date.parse(newValue.toLocaleDateString().replace(/\-/g, '/')));
        } else if (newValue == null) {
          return null;
        } else {
          return attr.completionTime === '' ?
            new Date(Date.parse(newValue.substr(0, 10).replace(/\-/g, '/'))) :
            new Date(Date.parse(newValue.replace(/\-/g, '/')));
        }
      }

      function doChange() {
        if (angular.isFunction(scope.ngChange) && scope.canSearch) {
          scope.ngChange();
        }
      }
      // watch ngModel
      scope.$watch('ngModel', function (newValue) {
        if (!newValue) return;
        scope[startModelName] = newValueToModel(newValue.start);
        scope[endModelName] = newValueToModel(newValue.end);
      }, true);

      // watch start date
      scope.$watch(startModelName, function (newValue) {
        if (!newValue) return;
        var date = getDateString(newValue);
        setPeriodLimit(date, 'start');
        scope.ngModel.start = setCompletionTime(date, 'start');
        doChange();
      }, true);

      // watch end date
      scope.$watch(endModelName, function (newValue) {
        if (!newValue) return;
        var date = getDateString(newValue);
        setPeriodLimit(date, 'end');
        scope.ngModel.end = setCompletionTime(date, 'end');
        doChange();
      }, true);

      function removeButton() {
        var clearDom = element.find('.btn.btn-sm.btn-danger');
        var todayDom = element.find('.btn-group > .btn.btn-sm.btn-info');
        if (attr.disableClear === '') {
          clearDom.remove();
        }
        if (attr.disableToday === '') {
          todayDom.remove();
        }
      }

      // open dropdown menu
      function openOop($event, key) {
        $timeout(function () {
          removeButton();
        }, 5);
        $event.preventDefault();
        $event.stopPropagation();
        scope[key + 'Opened'] = true;
      }

      scope.openStartPop = function ($event) {
        openOop($event, 'start');
      };
      scope.openEndPop = function ($event) {
        openOop($event, 'end');
      };
    }

    return directive;
  }

})();
angular
  .module('app')
  .directive('mymultiselect',['APP_CONFIG','$timeout',function(APP_CONFIG,$timeout){

    	return {
    		restrict: 'A',
    		link:function(scope, el, attrs){
    			$(el).multiselect({
    				disableIfEmpty:false,
    				maxHeight:attrs.maxHeight || 200,
    				buttonClass:attrs.buttonClass ,
    				buttonWidth:attrs.buttonWidth ,
    				buttonText:attrs.buttonText,
    				numberDisplayed:attrs.numberDisplayed||4,
    				enableFiltering:attrs.enableFiltering||true,
    				buttonContainer:'<div ></div>'
    			});
				// scope.$watch(function(){
				// 	var data = eval('scope.'+attrs.provider);
				// 	return data.length;
				// },function(){
				// 	$(el).multiselect('dataprovider', eval('scope.'+attrs.provider));	
				// });
    			var t ;
    			t = scope.$on('multi-rebuild',function(){
    				$timeout(function(){
    					$(el).multiselect('rebuild');
    				},1000);

    			});

    			el.on('$destroy',function(){
    				$(el).multiselect('destroy');
    				$timeout.cancel(t);
    			});
    		}
    	};
    }]);
angular
  .module('app')
  .directive('loadingContainer', function () {
    //表格loading效果
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, element, attrs) {
        var loadingLayer = angular.element('<div class="loading"></div>');
        element.append(loadingLayer);
        element.addClass('loading-container');
        scope.$watch(attrs.loadingContainer, function (value) {
          loadingLayer.toggleClass('ng-hide', !value);
        });
        var destroyDirective = function () {
          //loadingLayer.destroy();
          loadingLayer = null;
        }
        scope.$on('$destroy', destroyDirective);
        element.on('$destroy', destroyDirective);
      }
    };
  });
angular
  .module('app')
  .directive('linkTemplate',['$compile','APP_CONFIG',function($compile,APP_CONFIG){
    	return {
            restrict: 'A',
            scope:false,
            link: function (scope, el, attrs) {
                var regx = /^http:|^\/\//;
                var url = null;
                $(el).click(function($event){
                	$event.preventDefault();
                	return false;
                }).popover({
                    trigger: 'click',
                    title:attrs.popoverTitle,
                    html: true,
                    content: $compile(APP_CONFIG['jsTemplate']['linkTemplateEdit'])(scope),
                    placement: 'top'
                });
                $(el).on('shown.bs.popover',function(){
                	$(el).next().find('input.link-template-url').val(decodeURIComponent($(el).attr('href').substr((APP_CONFIG.redirect_url+"gameid="+scope.creative.selectedGame.GameId+'&redirect=').length)));
                	$(el).next().find('input.link-template-text').val($(el).text());
                    $(el).next().find('.btn-ok').click(function(){
                        url = $(el).next().find('input.link-template-url').val();
                        if(!regx.test(url)) url = "//"+url;
						url = APP_CONFIG.redirect_url+"gameid="+scope.creative.selectedGame.GameId+'&redirect='+encodeURIComponent(url);
                        $(el).attr('href',url);
                        $(el).text($(el).next().find('input.link-template-text').val())
                        $(el).popover('hide');
                    });
                });
                var destroyDirective = function(){
                    regx = null;
                    url = null;
                }
                scope.$on('$destroy', destroyDirective);
                el.on('$destroy', destroyDirective);
            }
        };
    }]);
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:keydown
   * @description
   * 绑定按键事件
   * @restrict A
   * @scope
   * @param {function} keydown dg-keydown-code 中指定的按键码被按到后触发的方法
   * @param {number} keydownCode 指定的按键码
   */

  'use strict';

  angular
    .module('app')
    .directive('keydown', keydown)

  function keydown() {
    return {
      restrict: 'A',
      scope: {
        keydown: '&keydown',
        keydownCode: '='
      },
      link: function (scope, element) {
        element.keydown(function (event) {
          if (event.keyCode === scope.keydownCode) {
            scope.keydown();
          }
        });
      }
    }
  }
})();
/**
 * 图库组件
 * @param  {[type]} FileUploader         [description]
 * @param  {[type]} $timeout             [description]
 * @param  {[type]} $http                [description]
 * @param  {[type]} Config               [description]
 * @param  {[type]} PictureInstanceRes   [description]
 * @param  {[type]} PictureRes){	return {		restrict: 'AEC',		transclude: true, 		scope: {              imageInfo: ' [description]
 * @param  {String} template:'<button    class         [description]
 * @return {[type]}                      [description]
 *
 * usage:
 *
 * <image-browser bindmodel="ima" btn-class="btn btn-primary flat">浏览图库</image-browser>
 * btn-class 设置按钮样式
 * bindmodel 绑定ngModel对象
 *
 */

angular
  .module('app')
  .run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/imagebrowser/modal.html",
      '      <div class="modal-header">' +
      '        <div class="btn btn-success btn-flat pull-right" ngf-select ng-model="files"><i class="fa fa-upload"></i>上传</div>' +
      '        <label class="pull-right" style="margin-right: 10px;display: inline-block;cursor:pointer;">&nbsp;<input type="checkbox" ng-model="watermark">水印</label>' +
      '        <h4 class="modal-title">图库浏览</h4>' +
      '      </div>' +
      '      <div class="modal-body">' +
      '		<div class="row gallery">' +
      '		<div class="col-xs-6 col-md-3" ng-repeat="image in images">' +
      '			<a href="" class="thumbnail" ng-class="{active:imageInfo.picture_id==image.picture_id}" ng-click="selectImage(image)">' +
      '			  <img src="{{image.url}}" alt="...">' +
      '			<button class="btn btn-danger btn-block flat delete-hidden" ng-click="delete(image)" type="button"><i class="fa fa-trash-o"></i></button>' +
      '			</a>' +

      '		</div>' +
      '		</div>' +
      '      </div>' +
      '      <div class="modal-footer">' +
      '			<button class="btn btn-default btn-flat" ng-click="close()">取消</button>' +
      '			<button class="btn btn-primary btn-flat" type="button" ng-click="Ok()">确定</button>' +
      '      </div>'
    );
  }])
  .controller('imagebrowser.gallery', ['$scope', 'Upload', '$timeout', '$resource', 'APP_CONFIG', '$modalInstance', function ($scope, Upload, $timeout, $resource, APP_CONFIG, $modalInstance) {
    $scope.$watch('files', function () {
      $scope.upload($scope.files);
    });
    $scope.images = [];
    var queryPictures = function () {
      $resource(APP_CONFIG.upload_url + '?action=listimage').get({
        query: $scope.searchTitle,
        start: $scope.images.length,
        size: 10
      }, function (data) {
        $scope.images = data.list;
      });
    }
    queryPictures();
    $scope.watermark = 0;
    $scope.upload = function (files) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          Upload.upload({
            url: APP_CONFIG.upload_url + "?action=uploadimage&watermark=" + $scope.watermark,
            file: file,
            fileFormDataName: 'upfile'
          }).progress(function (evt) {

          }).success(function (data, status, headers, config) {
            swal('上传成功', '', 'success');
            $scope.images.ushift({
              'picture_id': data.picture_id,
              'url': data.url
            })
          }).error(function () {
            swal('上传失败', '', 'error');
          });
        }
      }
    };
    $scope.selectImage = function (image) {
      $scope.imageInfo = image;
    }

    $scope.Ok = function () {
      if ($scope.imageInfo == null) {
        swal('请选择一张图片', '', 'warning');
        return false;
      }
      $modalInstance.close($scope.imageInfo);
    };

    $scope.close = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.delete = function (image) {
      swal({
        title: '确认删除',
        text: '是否确认删除图片？',
        showConfirmButton: true,
        showCancelButton: true,
        type: 'warning'
      }, function () {
        $resource(APP_CONFIG.upload_res, {id: '@id'}).remove({id: image.picture_id}, function (data) {
          scope.images.splice(scope.images.indexOf(image), 1);
          scope.imageInfo = null;
        }, function (err) {
          swal('删除失败', '', 'error');
        });
      });

    };
    $scope.$on('$destroy', function () {
      queryPictures = null;
    });


  }]).directive('imageBrowser', ['Upload', '$timeout', '$http', 'APP_CONFIG', '$modal', function (Upload, $timeout, $http, APP_CONFIG, $modal) {
    return {
      restrict: 'AEC',
      transclude: true,
      scope: {
        imageInfo: '=bindmodel'
      },
      template: '<button class="{{btnClass}}" ng-click="browse()" type="button" ><div ng-transclude></div></button>'
      ,
      link: function (scope, iElement, iAttrs) {
        scope.imageInfo = null;


        scope.btnClass = iAttrs.btnClass || "btn btn-success btn-flat";

        /*scope.uploader.onSuccessItem = function(fileItem, response, status, headers) {

         fileItem.remove();
         PictureInstanceRes.save({
         picture_name: response[0].auto_name,
         picture_url: response[0].url,
         media_id:response[0].media_id
         }, function(data){
         //alert('上传成功');
         scope.images.unshift(data);
         scope.imageInfo = data;
         }, function(err){
         alert('上传失败');
         });
         };*/

        scope.browse = function () {
          var modalInstance = $modal.open({
            animation: true,
            templateUrl: 'template/imagebrowser/modal.html',
            controller: 'imagebrowser.gallery',
            size: 'lg'
          });
          modalInstance.result.then(function (selectedItem) {
            scope.imageInfo = selectedItem;
          }, function () {
            //dismissed
          });
          // for(var i=0;i<50;i++){
          // 	scope.images.push({
          // 		url:'https://www.baidu.com/img/bd_logo1.png'
          // 	})
          // }


        }


        scope.save = function (index) {

          scope.images[index].picture_name = scope.images[index].newName;
          /*PictureInstanceRes.update({picture_id: scope.images[index].picture_id},
           scope.items[index], function(data){
           scope.editIndex = -1;
           }, function(err){
           alert('更新失败');
           });*/
        };

        scope.selectImage = function (image) {
          scope.imageInfo = image;
        }


      }

    };
  }]);

angular
  .module('app')
  .directive('icheck',['$timeout',function($timeout){
       
    	return {
            //require: 'ngModel',
    		restrict: 'A',
    		link:function($scope, element, $attrs, ngModel) {
                return $timeout(function() {
                    var value = $attrs['value'];

                    $scope.$watch($attrs['ngModel'], function(newValue){
                        $(element).iCheck('update');
                    });


                    return $(element).iCheck({
                        checkboxClass: 'icheckbox_flat-blue',
                        radioClass: 'iradio_flat-blue',
                        increaseArea: '20%'
                    }).on('ifChanged', function(event) {
                        
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
                });
            }
    	};
    }]);
(function () {
  angular
    .module('app')
    .directive('formMessage', formMessage);

  function formMessage(formService) {
    return {
      restrict: 'E',
      compile: compile,
    };

    function compile(element, attrs) {
      var filedName = element.closest('form').attr('name') + '.' + attrs.name;
      var error = filedName + '.$error';
      var show = filedName + '.$error && ' + filedName + '.$dirty';

      var dom = '<label class="control-label error" ng-messages="' + error + '" ng-show="'+ show +'">' +
        '<i class="fa fa-times-circle-o"></i>' +
        '<span>' + attrs.label + '</span>' +
        '<span ng-message="required">是必填的</span>' +
        '<span ng-message="pattern">格式错误</span>' +
        '<span ng-message="maxlength">长度超出限制</span>' +
        '<span ng-message="minlength">长度不符合要求</span>' +
        '</label>';

      $(element).append(dom);
    }
  }
})();
(function() {
/**
*  @ngdoc directive
* @name app.directive:formErrorMessage
* @description
* 错误信息提示
* @restrict E
*/

'use strict';

angular
.module('app')
.directive('formErrorMessage', formErrorMessage);

function formErrorMessage(formService) {
    return {
      restrict: 'E',
      compile: function(tEle, tAttrs) {
        var errorMsg = {
            required: tAttrs.errrequired || (tAttrs.label || '') + '是必填的',
            pattern: tAttrs.errpattern || (tAttrs.label || '') + '格式错误',
            maxlength: tAttrs.errmaxlength || (tAttrs.label || '') + '长度超出限制',
            minlength: tAttrs.errminlength || (tAttrs.label || '') + '长度不符合要求'
        }
        var filedName = tEle.closest('form').attr('name') + '.' + tAttrs.name;
        var error = filedName + '.$error';
        var show = filedName + '.$error && ' + filedName + '.$dirty';
        
        var html = '<label class="control-label error" ng-messages="' + error + '" ng-show="'+ show +'">' +
          '<i class="fa fa-times-circle-o"></i>' +
          '<span ng-message="required">' + errorMsg.required + '</span>' +
          '<span ng-message="pattern">' + errorMsg.pattern + '</span>' +
          '<span ng-message="maxlength">' + errorMsg.maxlength + '</span>' +
          '<span ng-message="minlength">' + errorMsg.minlength + '</span>' +
          '<span>' + (tAttrs.errduplicated || '') + '</span>' +
          '</label>';

        $(tEle).append(html);

      }
    };

  }
})();

(function () {
  /**
   * @ngdoc directive
   * @name app.directive:fixedCentered
   * @description
   * 元素居中，设置 margin-top、margin-left 属性，使用此指令前请为元素设置 position 为 absolute 或 fixed。
   * @restrict A
   * @scope
   * @param {string} fixedCenteredShow ng-if 或 ng-show 里的值，指令会监视这个值，当这个值为 true 时延时 10ms 计算元素的尺寸。
   * @requires $timeout
   */


  'use strict';

  angular
    .module('app')
    .directive('fixedCentered', fixedCentered);

  fixedCentered.$inject = ['$timeout']

  function fixedCentered($timeout) {
    return {
      restrict: 'A',
      link: link,
      scope: {
        fixedCenteredShow: '='
      }
    };

    function link(scope, element, attrs) {

      if (attrs.fixedCenteredShow !== '') {
        scope.$watch('fixedCenteredShow', function (newValue, oldValue) {
          if (newValue) {
            $timeout(handleCentered, 10);
          }
        }, false)
      } else {
        handleCentered();
      }

      function handleCentered() {
        var width = $(element).width();
        var height = $(element).height();
        $(element).css({
          marginTop: -height / 2,
          marginLeft: -width / 2,
          left: '50%',
          top: '50%'
        })
      }
    }
  }
})();
(function() {
    angular
        .module("app")
        .directive("filesInput", filesInput);

    function filesInput() {
        return {
          require: "ngModel",
          link: function postLink(scope, elem, attrs, ngModel) {
            elem.on("change", function(e) {
              var files = elem[0].files;
              ngModel.$setViewValue(files);
            });
          }
        }
      }
})()

angular
  .module('app')
  .directive('editor',[function(){
    	return {
            restrict: 'A',
            scope:{
                content:'=ngModel'
            },
            link: function (scope, el, attrs) {
                var saveSuccessHandler = function(event){
                        scope.content = event.detail.content;
                        document.removeEventListener('saveSuccess',saveSuccessHandler,false);
                        showPreviewBtn();
                    };
                var previewBtn = null;
                var showPreviewBtn = function(){
                    if(typeof scope.content!='undefined'&&scope.content!=''&&previewBtn==null){
                        previewBtn = $('<button class="btn btn-flat btn-success " style="margin-left:10px;"><i class="fa fa-eye"></i>预览</button>');
                        $(el).after(previewBtn)
                        previewBtn.click(function(){
                            var p = window.open('about:blank','_blank', 'location=no,height='+window.screen.height+',width='+window.screen.width);
                            p.document.write(scope.content);
                        });
                    }
                }

                showPreviewBtn();
                
                $(el).click(function($event){
                	$event.preventDefault();
                    var ref = window.open('/editor','_blank', 'location=no,height='+window.screen.height+',width='+window.screen.width);
                	document.presetContent = scope.content;
                    document.addEventListener('saveSuccess',saveSuccessHandler);
                    return false;
                });

                var destroyDirective = function(){
                    saveSuccessHandler = null;
                    document.presetContent = null;
                    previewBtn = null;
                    showPreviewBtn = null;
                }
                scope.$on('$destroy', destroyDirective);
                el.on('$destroy', destroyDirective);
            }
        };
    }]);
(function () {
  angular
    .module('app')
    .directive('disabledCheckBox', disabledCheckBox)

  function disabledCheckBox() {
    return {
      template: '<input type="checkbox" ng-checked="ngChecked === 1" disabled>',
      restrict: 'EA',
      scope: {
        ngChecked: '='
      }
    };
  }
})();
(function () {

  /**
   * @ngdoc directive
   * @name app.directive:datePicker
   * @description
   * 日期弹出选择器
   * @restrict E
   * @scope
   * @param {string} ngModel 绑定的 ngModel
   * @param {string} maxDate 最大日期，格式为"yyyy-MM-dd"
   * @param {string} minDate 最小日期，格式为"yyyy-MM-dd"
   * @param {string} disableClear 空字符串，禁用清除按钮
   * @param {string} beyondToday 空字符串，允许选取超过今天的日期
   * @param {string} disableToday 空字符串，禁用今天按钮
   * @param {function} ngChange ngModel change时触发的函数
   * @requires app.calcDateService
   * @requires $timeout
   * @requires $filter
   */
  'use strict';

  angular
    .module('app')
    .directive('datePicker', datePicker);

  datePicker.inject = ['calcDateService', '$timeout', '$filter'];

  function datePicker(calcDateService, $timeout, $filter) {
    var inputModel = 'dateModel';
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngShow: '=?',
        ngClass: '=?',
        disableClear: '=?',
        disableToday: '=?',
        ngRequired: '=?',
        minDate: '=?',
        maxDate: '=?',
        ngInit: '=?',
        isOpen: '=?',
        ngDisabled: '=?',
        ngChange: '&?ngChange'
      },
      replace: true,
      template: template,
      link: link
    };

    function template() {
      var inputAttr = [
        'is-open="opened"',
        'uib-datepicker-popup=""',
        'ng-model="' + inputModel + '"',
        'ng-required="ngRequired"',
        'ng-disabled="ngDisabled"',
        'show-weeks="false"',
        'min-date="minDate"',
        'max-date="maxDate"',
        'ng-click="openPop($event)"'
      ].join(' ');

      return [
        '<div class="datepicker-box">',
        '<span class="input-group-btn">',
        '<button type="button" class="btn" ng-click="openPop($event)" ng-disabled="ngDisabled">',
        '<i class="glyphicon glyphicon-calendar"></i>',
        '</button></span>',
        '<input type="text" class="form-control"' + inputAttr + '/>',
        '</div>'
      ].join('');
    }

    function link(scope, element, attr) {

      $timeout(function () {
        scope.canSearch = true;
      }, 500);

      function isMaxToday() {
        return attr.beyondToday != '';
      }

      var today = calcDateService.basedToday(0);

      // date filter
      function getDateString(date, type) {
        if (angular.isNumber(type)) {
          return $filter('date')(date, 'yyyyMMdd');
        } else if (angular.isString(type)) {
          return date.replace(/-/g, '');
        } else {
          return $filter('date')(date, 'yyyy-MM-dd');
        }
      }

      function setCompletionTime(date) {
        var time = ' 00:00:00';
        if (date == null) {
          return null;
        }
        if (attr.completionTime === '') {
          return date + time
        } else {
          return date
        }
      }

      function newValueToModel(newValue) {
        if (angular.isObject(newValue) && newValue !== null) {
          return attr.completionTime === '' ?
            new Date(Date.parse(newValue.toLocaleDateString().substr(0, 10).replace(/\-/g, '/'))) :
            new Date(Date.parse(newValue.toLocaleDateString().replace(/\-/g, '/')));
        } else if (newValue == null) {
          return null;
        } else {
          return attr.completionTime === '' ?
            new Date(Date.parse(newValue.substr(0, 10).replace(/\-/g, '/'))) :
            new Date(Date.parse(newValue.replace(/\-/g, '/')));
        }
      }

      // 监视 ngModel
      scope.$watch('ngModel', function (newValue) {
        scope[inputModel] = newValueToModel(newValue);
        if (isMaxToday() && !scope.maxDate) {
          scope.maxDate = today;
        }
        if (isMaxToday() && scope.maxDate && calcDateService.dateDiff(scope.maxDate, today) > 0) {
          scope.maxDate = today;
        }
        if (angular.isFunction(scope.ngChange) && scope.canSearch) {
          scope.ngChange();
        }
      }, true);

      // 监视 inputModel
      scope.$watch(inputModel, function (newValue) {
        var date = getDateString(newValue);
        scope.ngModel = setCompletionTime(date);
      }, true);

      function removeButton() {
        var clearDom = element.find('.btn.btn-sm.btn-danger');
        var todayDom = element.find('.btn-group > .btn.btn-sm.btn-info');
        if (attr.disableClear === '') {
          clearDom.remove();
        }
        if (attr.disableToday === '') {
          todayDom.remove();
        }
      }

      // open dropdown menu
      scope.openPop = function ($event) {
        $event.preventDefault();
        $timeout(function () {
          removeButton()
        }, 5);
        $event.stopPropagation();
        scope.opened = true;
      }
    }
  }

})();
angular
  .module('app')
  .directive('dgUiRadios', function () {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        value: '=',
        type: '@'
      },
      templateUrl: ' js/app/templates/datagrand_ui/dg_ui_radios.html',
      controller: function ($scope) {
        this.checked = function (index) {
          if ($scope.type == 'show') {
            return;
          }
          angular.forEach($scope.options, function (radio) {
            radio.value = false;
          });
          $scope.options[index].value = true;
          $scope.value = index;
        };

        this.deleteOption = function (index) {
          $scope.options.splice(index, 1);
        };

        this.addOption = function () {
          $scope.options.push({title: '', value: false});
        };

      },
      controllerAs: 'dgUiRadiosCtrl'
    };
  })
  .directive('dgUiCheckboxes', function () {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        type: '@'
      },
      templateUrl: ' js/app/templates/datagrand_ui/dg_ui_checkboxes.html',
      controller: function ($scope) {
        this.checked = function (option) {
          if ($scope.type == 'show') {
            return;
          }
          option.value = !option.value;

        };

        this.deleteOption = function (index) {
          $scope.options.splice(index, 1);
        };

        this.addOption = function () {
          $scope.options.push({title: '', value: false});
        };
      },
      controllerAs: 'dgUiCheckboxesCtrl'
    };
  })
  .directive('dgUiTime', function () {
    return {
      restrict: 'E',
      scope: {
        precision: '=',
        value: '=',
        type: '@'
      },
      templateUrl: ' js/app/templates/datagrand_ui/dg_ui_time.html',
      controller: function ($scope) {


        this.zeroPad = function (num, size) {
          var s = num.toString();
          while (s.length < size) {
            s = "0" + s;
          }
          return s;
        };

        this.getTimeUnit = function (start, count, zeroPadSize) {
          var array = [];
          for (var i = start; i < count + start; i++) {
            array.push(this.zeroPad(i, zeroPadSize));
          }
          return array;
        };

        this.getYears = function () {
          var years = [];
          var currentYear = this.currentDate.getFullYear();
          for (var i = 0; i < 10; i++) {
            years.push((i + currentYear).toString());
          }
          return years;
        };

        this.getMonths = function () {
          return this.getTimeUnit(1, 12, 2);
        };

        this.getDays = function () {
          if (!this.year) {
            return [];
          }
          var day_count = 31;
          switch (this.month) {
            case '04':
            case '06':
            case '09':
            case '11':
              day_count = 30;
              break;
            case '02':
              if ((this.year % 4 == 0 && this.year % 100 != 0) || this.year % 400 == 0) {
                day_count = 29;
              }
              else {
                if (this.days.length == 29 && this.day == 29) {
                  this.day = '01';
                }
                day_count = 28;
              }
              break;
            default:
              break;
          }
          var days = [];
          for (var i = 1; i <= day_count; i++) {
            days.push(this.zeroPad(i, 2));
          }
          return days;
        };

        this.getHours = function () {
          return this.getTimeUnit(0, 24, 2);
        };

        this.getMinutes = function () {
          return this.getTimeUnit(0, 60, 2);
        };

        this.getSeconds = function () {
          return this.getTimeUnit(0, 60, 2);
        };

        this.getTimestamp = function () {
          $scope.value = (new Date(this.year, this.month - 1, this.day, this.hour, this.minute, this.second).getTime()) / 1000;
        };

        this.yearChange = function () {
          this.days = this.getDays();
          this.getTimestamp();
        };

        this.monthChange = function () {
          this.days = this.getDays();
          this.getTimestamp();
        };

        this.currentDate = new Date();
        this.year = this.zeroPad(this.currentDate.getFullYear(), 4);
        this.month = this.zeroPad(this.currentDate.getMonth() + 1, 2);
        this.day = this.zeroPad(this.currentDate.getDate(), 2);
        this.hour = '00';
        if ($scope.precision == 2 || $scope.precision == 3) {
          this.hour = this.zeroPad(this.currentDate.getHours(), 2);
        }
        this.minute = '00';
        if ($scope.precision == 3) {
          this.minute = this.zeroPad(this.currentDate.getMinutes(), 2);
        }
        this.second = '00';
        this.getTimestamp();
        this.years = this.getYears();
        this.months = this.getMonths();
        this.days = this.getDays();
        this.hours = this.getHours();
        this.minutes = this.getMinutes();
        this.seconds = this.getSeconds();
      },
      controllerAs: 'dgUiTimeCtrl'
    };
  })
  .directive('dgUiTimeTest', function () {
    return {
      restrict: 'E',
      scope: {
        precision: '=',
        value: '=',
        type: '@'
      },
      templateUrl: ' js/app/templates/datagrand_ui/dg_ui_time_test.html',
      controller: function ($scope) {
        this.getTimeValue = function (event) {
          var time_str = event.target.value;
          var year = '1970';
          var month = '01';
          var day = '01';
          var hour = '00';
          var minute = '00';
          var second = '00';
          if (time_str) {
            if ($scope.precision == 1) {
              var strs = time_str.split('-');
              year = strs[0];
              month = strs[1];
              day = strs[2];
            }
            else {
              var strs = time_str.split('T');
              var str1s = strs[0].split('-');
              var str2s = strs[1].split(':');
              year = str1s[0];
              month = str1s[1];
              day = str1s[2];
              hour = str2s[0];
              minute = str2s[1];
            }
            $scope.value = (new Date(year, month - 1, day, hour, minute, second).getTime()) / 1000;
          }
        };

        $scope.value = 0;
      },
      controllerAs: 'dgUiTimeTestCtrl'
    };
  })
  .directive('dgUiQrcode', function (md5, $timeout) {
    return {
      restrict: 'E',
      scope: {
        name: '=',
        value: '=',
        title: '=',
        width: '=',
        visible: '='
      },
      templateUrl: ' js/app/templates/datagrand_ui/dg_ui_qrcode.html',
      controller: function ($scope) {
        this.qrdiv_id = '';
        this.createDivId = function () {
          return md5.createHash($scope.name + $scope.value + $scope.title);
        };

        this.createQrcode = function () {
          $(this.qrdiv_id).empty();
          $(this.qrdiv_id).qrcode({width: $scope.width, height: $scope.width, text: $scope.value});
        };
        this.qrdiv_id = this.createDivId();
        this.createQrcode();
      },
      controllerAs: 'dgUiQrcodeCtrl'
    };
  })
  .directive('dgUiTemplate', function () {
    return {
      restrict: 'E',
      scope: {
        template: '=',
        type: '@'
      },
      templateUrl: ' js/app/templates/datagrand_ui/dg_ui_template.html',
      controller: function ($scope) {
        this.getTemplateModulesUrl = function (type) {
          return ' js/app/templates/datagrand_ui/dg_ui_template_modules_' + type + '_' + $scope.template.style + '.html';
        };
      },
      controllerAs: 'templateCtrl'
    };
  })
  .directive('dgUiTemplateEdit', ['DgUiTemplateEngine', function (DgUiTemplateEngine) {
    return {
      restrict: 'E',
      scope: {
        template: '=',
        type: '@'
      },
      templateUrl: ' js/app/templates/datagrand_ui/dg_ui_template_edit.html',
      controller: function ($scope) {
        this.selected = null;

        this.editing_index = -1;

        this.hover_index = -1;

        this.getTemplateModulesUrl = function (type) {
          return ' js/app/templates/datagrand_ui/dg_ui_template_modules_' + type + '_' + $scope.template.style + '.html';
        };

        this.moduleClick = function (module, $index) {
          this.selected = module;
          if (this.editing_index != $index) {
            this.editing_index = -1;
          }
        };

        this.deleteModule = function ($index) {
          $scope.template.modules.splice($index, 1);
        };

        this.setModule = function ($index) {
          if ($index == this.editing_index) {
            this.editing_index = -1;
          }
          else {
            this.editing_index = $index;
          }
        };

        this.doneSetting = function () {
          this.editing_index = -1;
          this.selected = null;
        };

        this.moveModule = function (index) {
          $scope.template.modules.splice(index, 1);
        };

        this.dropModule = function (event, index, item, external) {
          return item;
        };

        this.freshView = function () {
          this.selected = null;
          this.editing_index = -1;
        };

        this.hoverIn = function (index) {
          this.hover_index = index;
        };

        this.hoverOut = function (index) {
          this.hover_index = -1;
        };
      },
      controllerAs: 'templateEditCtrl'
    };
  }]).directive('dgUiModuleSetting', ['DgUiTemplateEngine', function (DgUiTemplateEngine) {
  return {
    restrict: 'E',
    scope: {
      module: '='
    },
    templateUrl: ' js/app/templates/datagrand_ui/dg_ui_module_setting.html',
    controller: function ($scope) {
      this.addOption = function () {
        var option = DgUiTemplateEngine.createOption('', false);
        DgUiTemplateEngine.addOption($scope.module, option);
      };

      this.deleteOption = function ($index) {
        DgUiTemplateEngine.deleteOption($scope.module, $index);
      };
    },
    controllerAs: 'moduleSettingCtrl'
  };
}]);
'use strict';
angular
  .module('app')
  .directive('charts', ['$http', function ($http) {
    //表格loading效果
    return {
      restrict: 'A',
      link: function (scope, el, attrs) {

        //var remoteUrl = eval('scope.'+attrs.chartRemote);
        var chart = null;
        var _default = {
          element: el,
          xkey: attrs.chartXKey || 'x',
          ykeys: eval(attrs.chartYKeys) || [],
          labels: eval(attrs.chartLabels),
          smooth: true,
          pointSize: 0,
          data: []
        };
        var option = {};
        var legend = null;
        var legendItem = null;
        scope.$watch(function () {
          return eval('scope.' + attrs.chartRemote);
        }, function (u) {
          //remoteUrl = eval('scope.'+attrs.chartRemote);
          if (u == '') return false;
          $http.get(u).success(function (data, status, headers, config) {
            //console.log(remoteUrl);

            option = angular.extend(_default, data);
            el.html('');
            angular.element('.chart-legend').remove();
            chart = new Morris.Line(option);
            legend = $('<div class="chart-legend"></div>');
            chart.options.labels.forEach(function (label, i) {
              legendItem = $('<span class="chart-legend-text"></span>').text(label).css('color', chart.options.lineColors[i]);

              legend.append(legendItem);

            });
            el.after(legend);
          });
        });
        var destroyDirective = function () {
          chart = null;
          //remoteUrl = null;
          option = null;
          _default = null;
          legendItem = null;
          legend = null;
        }
        scope.$on('$destroy', destroyDirective);
        el.on('$destroy', destroyDirective);
      }
    };
  }]);

(function () {
  angular
    .module('app')
    .directive('breadcrumb', breadcrumb)
  function breadcrumb() {
    return {
      template: template,
      restrict: 'EA',
      scope: {
        info: '&='
      }
    };

    function template() {
      var ngClass = "'active': item.active";
      var voidLink = "'javascirpt:;'";
      return '<h1>{{info.title}}<small>{{info.subtitle}}</small></h1>' +
        '<ol class="breadcrumb">' +
        '<li ng-repeat="item in info.breadcrumb" ng-class="{ ' + ngClass + '}" >' +
        '<a href="{{item.link||' + voidLink + '}}" ng-if="!item.active"><i class="fa {{item.iconclass}}" ng-if="item.iconclass"></i> {{item.name}}</a>' +
        '<span ng-if="item.active">{{item.name}}</span>' +
        '</li></ol>'
    }
  }
})();
(function () {
  angular
    .module('app')
    .directive('activeLink', activeLink);

  activeLink.inject = ['$location', 'dataService'];

  function activeLink($location, dataService) {
    return {
      restrict: 'A',
      link: link
    };

    function link(scope, element, attrs) {
      if (attrs.linkMaster === '' && !dataService.master) {
        if (attrs.parentActive === '') {
          element.parent().css('display', 'none');
        }
        element.css('display', 'none');
      }
      var className = attrs.activeLink
      var path = attrs.href
      path = path.substring(1);
      scope.location = $location;
      scope.$watch('location.path()', function (newPath) {
        var activeElement = attrs.parentActive === '' ? element.parent() : element;
        if (attrs.childLink) {
          if (path === newPath || newPath.indexOf(attrs.childLink.substring(1)) > -1) {
            activeElement.addClass(className)
          } else {
            activeElement.removeClass(className)
          }
        } else {
          if (path === newPath) {
            activeElement.addClass(className)
          } else {
            activeElement.removeClass(className)
          }
        }
      })
    }
  }
})();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("src/index.html","<!doctype html>\n<html ng-app=\"app\">\n\n<head>\n  <meta charset=\"utf-8\">\n  <title>ADMIN</title>\n  <meta name=\"description\" content=\"\">\n  <meta name=\"viewport\" content=\"width=device-width\">\n  <!--设置不缓存-->\n  <meta http-equiv=\"pragma\" content=\"no-cache\">\n  <meta http-equiv=\"Cache-Control\" content=\"no-cache, must-revalidate\">\n  <meta http-equiv=\"expires\" content=\"0\">\n  <!-- Place favicon.ico and apple-touch-icon.png in the root directory -->\n\n  <!-- build:css({tmp/serve,src}) styles/vendor.css -->\n  <!-- bower:css -->\n  <!-- run `gulp inject` to automatically populate bower styles dependencies -->\n  <!-- endbower -->\n  <!-- endbuild -->\n\n  <!-- build:css({tmp/serve,src}) styles/app.css -->\n  <!-- inject:css -->\n  <!-- css files will be automatically insert here -->\n  <!-- endinject -->\n  <!-- endbuild -->\n</head>\n\n<body class=\"skin-blue sidebar-mini\">\n  <!--[if lt IE 10]>\n<![endif]-->\n  <ui-view></ui-view>\n\n  <!-- build:js(src) scripts/vendor.js -->\n  <!-- bower:js -->\n  <!-- run `gulp inject` to automatically populate bower script dependencies -->\n  <!-- endbower -->\n  <!-- endbuild -->\n\n  <!-- build:js({tmp/serve,tmp/partials,src}) scripts/app.js -->\n  <!-- inject:js -->\n  <!-- js files will be automatically insert here -->\n  <!-- endinject -->\n\n  <!-- inject:partials -->\n  <!-- angular templates will be automatically converted in js and inserted here -->\n  <!-- endinject -->\n  <!-- endbuild -->\n  <!--<link rel=\"stylesheet\" href=\"bower_components/release/wangEditor.css\">-->\n  <!--<script src=\"bower_components/release/wangEditor.js\"></script>-->\n</body>\n\n</html>");
$templateCache.put("src/common/pagination.html","<div class=\"ng-cloak dataTables_paginate paging_bootstrap pull-right\">\n  <ul class=\"pagination\">\n    <li ng-class=\"{\'disabled\': !page.active&&(page.type==\'prev\'||page.type==\'next\'),\'active\':!page.active&&(page.type!=\'prev\'&&page.type!=\'next\'&&page.type!=\'more\')}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n      <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">←  上一页</a>\n      <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n        <span ng-bind=\"page.number\"></span>\n      </a>\n      <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n        <span ng-bind=\"page.number\"></span>\n      </a>\n      <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n      <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n        <span ng-bind=\"page.number\"></span>\n      </a>\n      <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">下一页  →</a>\n    </li>\n  </ul>\n</div>");
$templateCache.put("src/common/wordPOSExample.html","<div>\n  <span class=\"pos-n\">名词</span>\n  <span class=\"pos-nr\">人名</span>\n  <span class=\"pos-ns\">地名</span>\n  <span class=\"pos-nt\">机构团体名</span>\n  <span class=\"pos-t\">时间词</span>\n  <span class=\"pos-v\">动词</span>\n  <span class=\"pos-a\">形容词</span>\n  <span class=\"pos-m\">数词</span>\n  <span class=\"pos-o\">其他/默认</span>\n</div>");
$templateCache.put("src/common/header/header.html","<header ng-controller=\"headerCtrl\" class=\"main-header\">\n  <a ui-sref=\"home\" class=\"logo\">\n    <span class=\"logo-lg\"> <b></b></span>\n  </a>\n  <nav class=\"navbar navbar-static-top\" role=\"navigation\">\n    <div class=\"navbar-custom-menu\">\n      <ul class=\"nav navbar-nav\">\n        <li class=\"user user-menu\">\n          <a ui-sref=\"userPublic\" tooltip=\"用户中心\" tooltip-placement=\"bottom\" tooltip-trigger=\"mouseenter\">\n            <span ng-bind=\"nickName\"></span>\n          </a>\n        </li>\n        <!--lagout-->\n        <li>\n          <a ng-click=\"logout()\" tooltip=\"注销\" tooltip-placement=\"bottom\" tooltip-trigger=\"mouseenter\"><i class=\"fa fa-sign-out\"></i></a>\n        </li>\n      </ul>\n    </div>\n  </nav>\n</header>");
$templateCache.put("src/common/sidebar/sidebar.html","<aside class=\"main-sidebar\" ng-controller=\"sidebarCtrl\">\n  <section class=\"sidebar\">\n    <ul class=\"sidebar-menu\" ng-repeat=\"menu in menus\">\n      <li class=\"header\" ng-bind=\"menu.name\"></li>\n      <li ng-repeat=\"childMenu in menu.menu_list\" ui-sref-active=\"active\">\n        <a ui-sref=\"{{childMenu.link}}\" ng-if=\"childMenu.link\">\n          <span class=\"name\" ng-bind=\"childMenu.name\"></span>\n        </a>\n        <a ng-if=\"!childMenu.link\">\n          <span class=\"name\" ng-bind=\"childMenu.name\"></span>\n        </a>\n      </li>\n    </ul>\n  </section>\n</aside>");
$templateCache.put("src/directive/cityDispatcher/cityDispatcher.html","<div class=\"city-select-box\">\n    <div class=\"city-search\" ng-class=\"{\'column-2\':!range.accurateToArea}\">\n        <input type=\"text\" ng-model=\"query.provinceName\" ng-click=\"update(1)\" placeholder=\"省/直辖市\">\n        <input type=\"text\" ng-model=\"query.cityName\" ng-click=\"update(2)\" placeholder=\"市\">\n        <input type=\"text\" ng-model=\"query.areaName\" ng-click=\"update(3)\" placeholder=\"区/县\" ng-if=\"range.accurateToArea\">\n    </div>\n    <div class=\"city-list\">\n        <ul class=\"level-province-list\" ng-show=\"params.provinceLevelShow\">\n            <li ng-repeat=\"province in cityList\" ng-bind=\"province.name\" ng-show=\"nameLike(province.name, \'provinceName\')\" ng-click=\"setCities($index)\"></li>\n        </ul>\n        <ul class=\"level-city-list\" ng-show=\"params.cityLevelShow\">\n            <li ng-repeat=\"city in params.cities\" ng-bind=\"city.name\" ng-show=\"nameLike(city.name, \'cityName\')\" ng-click=\"setAreas($index)\"></li>\n        </ul>\n        <ul class=\"level-area-list\" ng-if=\"range.accurateToArea && params.areaLevelShow\">\n            <li ng-repeat=\"area in params.area\" ng-bind=\"area\" ng-show=\"nameLike(area, \'areaName\')\" ng-click=\"query.areaName = area; params.areaLevelShow = false;\"></li>\n        </ul>\n    </div>\n</div>");
$templateCache.put("src/directive/fieldList/fieldList.html","<div class=\"fields-box\" ng-if=\"list.length > 0\">\n  <p>\n    <span ng-bind=\"list[0]\"></span>\n    <span class=\"small\">[<span ng-bind=\"list.length\"></span>个]</span>\n  </p>\n  <div class=\"fields-list-tool small\">\n    <div class=\"input-group\">\n      <input type=\"text\" class=\"form-control\" placeholder=\"搜索field名称\" ng-model=\"keyword\">\n      <span class=\"input-group-btn\">\n        <button class=\"btn btn-default\" type=\"button\">\n          <span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span>\n        </button>\n      </span>\n    </div>\n    <ol>\n      <!--uib-tooltip=\"点击前往配置\"-->\n      <li ng-repeat=\"field in list track by $index\" ng-bind=\"field\" ng-show=\"field.search(keyword) > -1\"></li>\n    </ol>\n  </div>\n</div>");
$templateCache.put("src/directive/filterGroup/filterGroup.html","<div ng-repeat=\"(type, obj) in filterList\" ng-show=\"handleFilterShow(obj.show)\" class=\"filter-list\">\n  <span>{{obj.hide}}</span>\n  <span class=\"filter-list-label\" ng-bind=\"obj.name\"></span>\n  <div class=\"filter-list-button-group\">\n    <button type=\"button\" class=\"btn btn-flat btn-default\" ng-repeat=\"filter in obj.list\" ng-class=\"{\'bg-olive\': searchValue[type] == filter.value, \'btn-default\': searchValue[type] != filter.value}\" ng-click=\"searchValue[type] = filter.value; searchFunc()\" ng-bind=\"filter.name\"></button>\n  </div>\n</div>");
$templateCache.put("src/directive/functionForm/functionForm.template.html","<div class=\"function-form\">\n    <div class=\"col-xs-12\">\n        <div class=\"checkbox\">\n            <label>\n                <input type=\"checkbox\" ng-model=\"model.checked\">\n                <span ng-bind=\"model.title\"></span>\n            </label>\n        </div>\n    </div>\n    <div class=\"col-xs-12\" ng-show=\"model.checked\">\n        <div class=\"function-form-holder form-horizontal\">\n            <div class=\"form-group\">\n                <div class=\"col-xs-2 control-label\">测试周期</div>\n                <div class=\"col-xs-10\">\n                    <period-date-picker ng-model=\"model.date\" disable-clear disable-today completion-time></period-date-picker>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <div class=\"col-xs-2 control-label\">调用限量</div>\n                <div class=\"col-xs-10\">\n                    <input type=\"text\" ng-model=\"model.limit_num_tmp\" class=\"form-control function-form-input\">\n                    <span class=\"tip\" ng-if=\"model.function_type !== 7\" ng-bind=\"\'万次/天\'\"></span>\n                    <span class=\"tip\" ng-if=\"model.function_type === 7\" ng-bind=\"\'个公众号\'\"></span>\n                </div>\n            </div>\n            <div class=\"form-group\" ng-if=\"model.function_type === 5 || model.function_type === 6\">\n                <div class=\"col-xs-2 control-label\">测试位置</div>\n                <div class=\"col-xs-10\">\n                    <input type=\"text\" class=\"form-control function-form-input-fixed-width\" ng-model=\"tempTestPosition.app\" placeholder=\"应用名/网站名\">\n                    <select class=\"form-control function-form-input-fixed-width\" ng-model=\"tempTestPosition.platform\" ng-options=\"platform for platform in platformList\"></select>\n                    <input ng-if=\"model.function_type === 5\" type=\"text\" class=\"form-control function-form-input-fixed-width\" ng-model=\"tempTestPosition.page\" placeholder=\"页面名称\">\n                    <input ng-if=\"model.function_type === 5\" type=\"text\" class=\"form-control function-form-input-fixed-width\" ng-model=\"tempTestPosition.module\" placeholder=\"功能模块名称\">\n                    <select ng-if=\"model.function_type === 5\" class=\"form-control function-form-input-fixed-width\" ng-model=\"tempTestPosition.rec\" ng-options=\"rectype for rectype in recTypeList\"></select>\n\n                    <input ng-if=\"model.function_type === 6\" type=\"text\" class=\"form-control function-form-input-fixed-width\" ng-model=\"tempTestPosition.remark\" placeholder=\"备注\">\n\n                    <button class=\"btn btn-default btn-flat\" ng-click=\"add()\">+测试位置</button>\n                </div>\n            </div>\n            <div class=\"form-group\" ng-repeat=\"position in model.test_position\">\n                <div class=\"col-xs-10 col-xs-push-2\">\n                    <input type=\"text\" class=\"form-control function-form-input-fixed-width\" ng-model=\"position.app\" placeholder=\"应用名/网站名\">\n                    <select class=\"form-control function-form-input-fixed-width\" ng-model=\"position.platform\" ng-options=\"platform for platform in platformList\"></select>\n                    <input type=\"text\" ng-if=\"model.function_type === 5\" class=\"form-control function-form-input-fixed-width\" ng-model=\"position.page\" placeholder=\"页面名称\">\n                    <input type=\"text\" ng-if=\"model.function_type === 5\" class=\"form-control function-form-input-fixed-width\" ng-model=\"position.module\" placeholder=\"功能模块名称\">\n                    <select ng-if=\"model.function_type === 5\" class=\"form-control function-form-input-fixed-width\" ng-model=\"position.rec\" ng-options=\"rectype for rectype in recTypeList\"></select>\n\n                    <input type=\"text\" ng-if=\"model.function_type === 6\" class=\"form-control function-form-input-fixed-width\" ng-model=\"position.remark\" placeholder=\"备注\">\n\n                    <button class=\"btn btn-default btn-flat\" ng-click=\"delete($index)\"><i class=\"glyphicon glyphicon-trash\"></i>删除</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("src/directive/tooltips/tooltips.html","<div class=\"tooltips-box\">\n    <i ng-class=\"params.iconCls\" id=\"targetIcon\" ng-mouseenter=\"showTipsBox(\'enter\')\" ng-mouseleave=\"showTipsBox(\'leave\')\"></i>\n    <div class=\"tooltips\">\n        <p ng-bind=\"params.tipsMsg\"></p>\n        <i></i>\n    </div>\n</div>");
$templateCache.put("src/directive/tree/treeItem.html","<div class=\"panel box\" ng-class=\"{\'active\': item.active}\">\n  <div class=\"box-header with-border\">\n    <div class=\"toggle-open-button\" ng-click=\"toggleOpen()\">\n      <i class=\"glyphicon glyphicon-chevron-right\" ng-class=\"{\n        \'glyphicon-chevron-down\': item.open && child.length > 0,\n        \'glyphicon-chevron-right\': child.length == 0 || !item.open ,\n        \'disabled\': !child ||  child.length == 0}\"></i>\n    </div>\n    <h4 class=\"box-title\" ng-bind=\"nameObject ? item[nameObject][name] : item[name]\" ng-hide=\"item.editing\"></h4>\n    <div class=\"iteration-accordion-item-option pull-right\">\n      <a ng-repeat=\"option in callbacks track by $index\" ng-click=\"option.callback(item, index, list)\">\n        <i class=\"{{option.icon}}\"></i>\n        <span ng-bind=\"option.name\"></span>\n      </a>\n      <span class=\"glyphicon glyphicon-option-horizontal\"></span>\n    </div>\n  </div>\n  <div class=\"panel-collapse\" ng-show=\"item.open\">\n  </div>\n</div>");
$templateCache.put("src/module/activityStatistics/activityStatistics.html","<warp>\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      活动统计\n    </h2>\n  </section>\n  <section class=\"content\">\n    <div class=\"nav-tabs-custom\">\n      <uib-tabset>\n        <uib-tab heading=\"电子刊下载统计\">\n          <span class=\"filter-list-label\" style=\"margin-left:10px\">\n            <a ng-click=\"download()\" class=\"btn btn-primary btn-flat btn-sm\">\n              <i class=\"glyphicon glyphicon-arrow-down\"></i>下载表格\n            </a>\n          </span>\n          <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n            <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n              <tr ng-repeat=\"item in $data track by $index\">\n                <td data-title=\"\'序号\'\" ng-bind=\"item.id\"></td>\n                <td data-title=\"\'姓名\'\" ng-bind=\"item.name\"></td>\n                <td data-title=\"\'手机\'\" ng-bind=\"item.tel\"></td>\n                <td data-title=\"\'邮箱\'\" ng-bind=\"item.email\"></td>\n                <td data-title=\"\'公司名称\'\" ng-bind=\"item.company_name\"></td>\n                <td data-title=\"\'职业\'\" ng-bind=\"item.job\"></td>\n                <td data-title=\"\'申请时间\'\" ng-bind=\"item.create_time\"></td>\n              </tr>\n            </table>\n          </div>\n        </uib-tab>\n      </uib-tabset>\n    </div>\n  </section>\n</warp>");
$templateCache.put("src/module/account/account.html","<warp class=\"rec-debug\">\n    <section class=\"content-header\">\n      <h2 class=\"page-title\">\n        账号管理\n        <small ng-bind=\"childStr\"></small>\n      </h2>\n    </section>\n    <div class=\"col-md-12\">\n      <div class=\"nav-tabs-custom\">\n        <ul class=\"nav nav-tabs\">\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"account.open\">开通申请</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"account.management\">账号管理</a>\n          </li>\n        </ul>\n        <div class=\"tab-content\">\n          <div class=\"tab-pane active clearfix\" ui-view>\n          </div>\n        </div>\n      </div>\n  </div></warp>");
$templateCache.put("src/module/client/client.html","<warp>\n  <ui-view></ui-view>\n</warp>");
$templateCache.put("src/module/configManage/configManage.html","<warp class=\"rec-debug\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      配置管理\n      <small ng-bind=\"childStr\"></small>\n    </h2>\n  </section>\n  <div class=\"col-md-12\">\n    <div class=\"nav-tabs-custom\">\n      <ul class=\"nav nav-tabs\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recConfig.actionConfig\">行为配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recConfig.hotRecConfig\">热门推荐配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recConfig.mergeConfig\">merge条件配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"configManage.basicConfig\">基础配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"configManage.timeConfig\">时效性配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"configManage.diversityConfig\">多样性配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"configManage.relatedSuggestConfig\">相关推荐配置</a>\n        </li>\n      </ul>\n      <div class=\"tab-content\">\n        <div class=\"tab-pane active clearfix\" ui-view>\n        </div>\n      </div>\n    </div>\n</div></warp>");
$templateCache.put("src/module/contact/contact.html","<warp class=\"contact-module\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      申请试用\n      <small ng-bind=\"title\"></small>\n    </h2>\n  </section>\n  <section class=\"content\">\n    <div class=\"box\" ui-view></div>\n  </section>\n</warp>");
$templateCache.put("src/module/corpusAnnotation/corpusAnnotation.html","<warp class=\"nlp\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      语料库标注\n    </h2>\n  </section>\n  <section class=\"content corpus-annotation\">\n    <div class=\"box\">\n      <div class=\"box-header\">\n        <form class=\"form-inline\">\n          <div class=\"form-group\">\n            <label>状态：</label>\n            <select ng-model=\"query.status\" class=\"form-control\" select-convert-to-number ng-change=\"search()\">\n              <option value=\"\">全部</option>\n              <option value=\"0\">未标注</option>\n              <option value=\"1\">已标注</option>\n            </select>\n          </div>\n        </form>\n      </div>\n      <div loading-container=\"nlpList.settings().$loading\" class=\"box-body\">\n        <table class=\"table table-bordered table-hover\" ng-table=\"nlpList\" template-pagination=\"src/common/pagination.html\">\n          <tr ng-repeat=\"item in $data track by $index\">\n            <td data-title=\"\'标注日期\'\" ng-bind=\"item.last_update_time.substr(0,10)\" class=\"date\"></td>\n            <td data-title=\"\'文本\'\" ng-bind=\"item.content\"></td>\n            <td data-title=\"\'人工分词结果\'\" class=\"min-width-200\">\n              <p class=\"pos-editor\" ng-model=\"item.content_sep_person\" contenteditable=\"false\" ng-show=\"item.status == 1\"></p>\n            </td>\n            <td data-title=\"\'专有名词提取\'\" class=\"min-width-200\">\n              <span ng-repeat=\"(key,ner) in item.content_ner_person\" ng-show=\"item.status == 1\">\n                <span class=\"word-segmentation nowrap {{nerPOS[key] | NLPPOS}}\" ng-bind=\"i\" tooltip-placement=\"top\" tooltip=\"{{tooltip(nerPOS[key])}}\" ng-repeat=\"i in ner track by $index\"></span>\n              </span>\n            </td>\n            <td data-title=\"\'操作\'\" class=\"option text-center\">\n              <div class=\"nlp-button-box\">\n                <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"edit(item, \'seg\')\">\n                  <i class=\"fa fa-thumb-tack pointerable\"></i> 标注\n                </button>\n              </div>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </section>\n\n  <!--nlp dialog ng-template-->\n  <script id=\"corpusAnnotationdialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog nlp-dialog corpus-annotation-dialog\">\n      <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/corpusAnnotation/dialog/dialog.html\'\"></div>\n    </div>\n  </script>\n</warp>");
$templateCache.put("src/module/crawl/crawl.html","<warp class=\"crawl\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      微信抓取\n      <small>数据统计</small>\n    </h2>\n  </section>\n  <div class=\"col-md-12\">\n    <div class=\"nav-tabs-custom\">\n      <ul class=\"nav nav-tabs\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"crawl.statistics\">数据统计</a>\n        </li>\n      </ul>\n      <div class=\"tab-content\">\n        <div class=\"tab-pane active clearfix\" ui-view>\n        </div>\n      </div>\n    </div>\n  </div>\n</warp>");
$templateCache.put("src/module/dataUpReport/dataUpReport.html","<warp class=\"rec-debug\">\n    <section class=\"content-header\">\n      <h2 class=\"page-title\">\n        数据上报统计\n        <small ng-bind=\"childStr\"></small>\n      </h2>\n    </section>\n    <div class=\"col-md-12\">\n      <div class=\"nav-tabs-custom\">\n        <ul class=\"nav nav-tabs\">\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"dataUpReport.totalProductUpReport\">总体产品信息上报</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"dataUpReport.appProductUpReport\">app产品信息上报</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"dataUpReport.dayActionUpReport\">天级APP行为数据上报</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"dataUpReport.hourlyActionUpReport\">小时级APP行为数据上报</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"dataUpReport.totalActionUpReport\">总体行为数据上报</a>\n          </li>\n        </ul>\n        <div class=\"tab-content\">\n          <div class=\"tab-pane active clearfix\" ui-view>\n          </div>\n        </div>\n      </div>\n  </div></warp>");
$templateCache.put("src/module/home/home.html","<warp>\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      版本记录\n      <!--<span class=\"glyphicon glyphicon-th change-show-type\" ng-click=\"showTable = true\" ng-class=\"{\'active\': showTable}\"></span>-->\n      <!--<span class=\"glyphicon glyphicon-th-list change-show-type\" ng-click=\"showTable = false\" ng-class=\"{\'active\': !showTable}\"></span>-->\n    </h2>\n  </section>\n  <section class=\"content\">\n    <!--timeline-->\n    <ul class=\"timeline\" ng-show=\"!showTable\">\n      <li ng-repeat=\"event in events track by $index\" ng-class=\"{\'time-label\': isString(event)}\">\n        <span class=\"bg-green\" ng-bind=\"event\" ng-if=\"isString(event)\"></span>\n        <i class=\"fa {{event.icon}}\" ng-if=\"!isString(event)\"></i>\n        <div class=\"timeline-item\" ng-if=\"!isString(event)\">\n          <div class=\"time\">\n            <a ng-repeat=\"author in event.author track by $index\" ng-bind=\"author.name\" href=\"mailto:{{author.mail}}\" tooltip-placement=\"left\" tooltip=\"发送邮件给{{author.name}}\"></a>\n          </div>\n          <h3 class=\"timeline-header\" ng-bind=\"event.title\">\n          </h3>\n          <div class=\"timeline-body\" ng-bind=\"event.desc\"></div>\n          <div class=\"timeline-footer\">\n            <a class=\"btn btn-primary btn-flat btn-xs\" ng-repeat=\"item in event.action\" ng-bind=\"item.text\" ui-sref=\"{{item.link}}\" ng-if=\"event.action\"></a>\n            <a class=\"btn btn-primary btn-flat btn-xs\" href=\"mailto:{{mail(event.author)}}?subject={{event.title}}建议\" ng-if=\"event.author\">建议</a>\n            <a class=\"btn btn-warning btn-flat btn-xs\" href=\"mailto:{{mail(event.author)}}?subject={{event.title}}问题反馈\" ng-if=\"event.author\">问题反馈</a>\n          </div>\n        </div>\n      </li>\n      <li>\n        <i class=\"fa fa-clock-o bg-gray\"></i>\n      </li>\n    </ul>\n    <!--table-->\n    <div class=\"box\" ng-repeat=\"item in tableData track by $index\" ng-show=\"showTable\">\n      <div class=\"box-header with-border\">\n        <h3 class=\"box-title\" ng-bind=\"item.date\"></h3>\n      </div>\n      <!-- /.box-header -->\n      <div class=\"box-body\">\n        <table class=\"table table-bordered table-hover\">\n          <tbody>\n            <thead>\n              <tr>\n                <th class=\"nowrap\">序号</th>\n                <th class=\"nowrap\">事项</th>\n                <th>描述</th>\n                <th class=\"nowrap\">人员</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"event in item.events\">\n                <td ng-bind=\"$index + 1\" class=\"nowrap\"></td>\n                <td ng-bind=\"event.title\" class=\"nowrap\"></td>\n                <td ng-bind=\"event.desc\"></td>\n                <td class=\"nowrap\">\n                  <div class=\"time\">\n                    <span ng-repeat=\"author in event.author track by $index\" ng-bind=\"author.name\">\n                </span></div>\n              </td>\n              <!--<td>\n                <a class=\"btn btn-primary btn-flat btn-xs\" ng-repeat=\"item in event.action\" ng-bind=\"item.text\" ui-sref=\"{{item.link}}\" ng-if=\"event.action\"></a>\n                <a class=\"btn btn-primary btn-flat btn-xs\" href=\"mailto:{{mail(event.author)}}?subject={{event.title}}建议\" ng-if=\"event.author\">建议</a>\n                <a class=\"btn btn-warning btn-flat btn-xs\" href=\"mailto:{{mail(event.author)}}?subject={{event.title}}问题反馈\" ng-if=\"event.author\">问题反馈</a>\n              </td>-->\n            </tr>\n            </tbody>\n          </tbody>\n        </table>\n      </div>\n      <!-- /.box-body -->\n    </div>\n  </section>\n</warp>");
$templateCache.put("src/module/login/login.html","<div class=\"login-page\">\n  <div class=\"login-box\">\n    <div class=\"login-logo\">\n      <a ui-serf=\"home\"><b></b></a>\n    </div>\n    <!-- /.login-logo -->\n    <div class=\"login-box-body\">\n      <p class=\"login-box-msg\">登录</p>\n      <form name=\"loginForm\" ng-submit=\"login()\">\n        <div class=\"form-group\" ng-class=\"{\'has-error\': message}\">\n          <input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"邮箱\" ng-model=\"loginform.username\" name=\"username\">\n          <span class=\"glyphicon glyphicon-envelope form-control-feedback\"></span>\n        </div>\n        <div class=\"form-group\" ng-class=\"{\'has-error\': message}\">\n          <input id=\"password\" type=\"password\" class=\"form-control\" placeholder=\"密码\" ng-model=\"loginform.passwd\" name=\"passwd\">\n          <span class=\"glyphicon glyphicon-lock form-control-feedback\"></span>\n        </div>\n        <div class=\"row\" ng-class=\"{\'has-error\': message}\">\n          <div class=\"col-xs-8\">\n            <label class=\"control-label\" ng-show=\"message\"><i class=\"fa fa-times-circle-o\"></i>{{message}}</label>\n          </div>\n          <!-- /.col -->\n          <div class=\"col-xs-4\">\n            <button type=\"submit\" class=\"btn btn-primary btn-block btn-flat\">登录</button>\n          </div>\n          <!-- /.col -->\n        </div>\n      </form>\n    </div>\n    <!-- /.login-box-body -->\n  </div>\n  <!-- /.login-box -->\n</div>");
$templateCache.put("src/module/management/management.html","<warp>\n  <ui-view></ui-view>\n</warp>");
$templateCache.put("src/module/nlp/nlp.html","<warp class=\"nlp\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      分词badcase\n    </h2>\n  </section>\n  <section class=\"content\">\n    <div class=\"box\">\n      <div class=\"box-header\">\n        <form class=\"form-inline\">\n          <a class=\"btn btn-primary btn-sm\" ng-click=\"edit()\">\n            <span class=\"glyphicon glyphicon-plus\"></span> 新增\n          </a>\n          <div class=\"form-group\">\n            <label>状态：</label>\n            <select ng-model=\"query.is_pos\" class=\"form-control\" select-convert-to-number ng-change=\"search()\">\n              <option value=\"{{3}}\">全部</option>\n              <option value=\"{{0}}\">未标注词性</option>\n              <option value=\"{{1}}\">已标注词性</option>\n            </select>\n          </div>\n          <dg-search-input ng-model=\"query.q\" search=\"search()\" placeholder=\"请输入文本内容关键字\"></dg-search-input>\n        </form>\n      </div>\n      <div loading-container=\"nlpList.settings().$loading\" class=\"box-body\">\n        <table class=\"table table-bordered table-hover\" ng-table=\"nlpList\" template-pagination=\"src/common/pagination.html\">\n          <tr ng-repeat=\"item in $data track by $index\">\n            <td data-title=\"\'提交日期\'\" ng-bind=\"item.last_update_time.substr(0,10)\" class=\"date\"></td>\n            <td data-title=\"\'文本\'\" ng-bind=\"item.content\"></td>\n            <td data-title=\"\'机器分词\'\" class=\"min-width-200\">\n              <span ng-repeat=\"i in item.content_sep_machine\">\n                <span class=\"word-segmentation nowrap {{i.pos | NLPPOS}}\" ng-bind=\"i.word\" tooltip-placement=\"top\" tooltip=\"{{tooltip(i.pos)}}\"></span>\n              </span>\n            </td>\n            <td data-title=\"\'提交人员\'\" ng-bind=\"masters[item.create_manager_id]\" class=\"manager nowrap\"></td>\n            <td data-title=\"\'人工审核\'\" class=\"min-width-200\">\n              <span ng-repeat=\"i in item.content_sep_person\">\n                <span class=\"word-segmentation nowrap {{i.pos | NLPPOS}}\" ng-bind=\"i.word\" tooltip-placement=\"top\" tooltip=\"{{tooltip(i.pos)}}\"></span>\n              </span>\n            </td>\n            <td data-title=\"\'审核人员\'\" ng-bind=\"masters[item.check_manager_id]\" class=\"manager nowrap\"></td>\n            <td data-title=\"\'操作\'\" class=\"option text-center\">\n              <div class=\"nlp-button-box\">\n                <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"edit(item, \'seg\')\">\n                  <i class=\"fa fa-scissors pointerable\"></i> 分词\n                </button>\n                <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"edit(item, \'pos\')\">\n                  <i class=\"fa fa-file-word-o pointerable\"></i> 词性\n                </button>\n              </div>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </section>\n\n  <!--nlp dialog ng-template-->\n  <script id=\"nlp-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog nlp-dialog\">\n      <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/nlp/dialog/dialog.html\'\"></div>\n    </div>\n  </script>\n</warp>");
$templateCache.put("src/module/offline/offline.html","<warp class=\"rec-debug\">\n    <section class=\"content-header\">\n      <h2 class=\"page-title\">\n        离线模块\n        <small ng-bind=\"childStr\"></small>\n      </h2>\n    </section>\n    <div class=\"col-md-12\">\n      <div class=\"nav-tabs-custom\">\n        <ul class=\"nav nav-tabs\">\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"offline.data\">离线数据</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"offline.hot\">离线热门结果</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"offline.rec\">离线相关推荐结果</a>\n          </li> \n        </ul>\n        <div class=\"tab-content\">\n          <div class=\"tab-pane active clearfix\" ui-view>\n          </div>\n        </div>\n      </div>\n  </div></warp>");
$templateCache.put("src/module/order/order.html","<warp>\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      订单管理\n      <small ng-bind=\"childStr\"></small>\n    </h2>\n  </section>\n  <div class=\"col-md-12\">\n    <div class=\"nav-tabs-custom\">\n      <ul class=\"nav nav-tabs\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"order.list\">订单列表</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"order.update\">订单录入</a>\n        </li>\n      </ul>\n      <div class=\"tab-content\">\n        <div class=\"tab-pane active clearfix\" ui-view>\n        </div>\n      </div>\n    </div>\n  </div>\n</warp>");
$templateCache.put("src/module/project/project.html","<warp class=\"rec-debug\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      项目管理\n      <small ng-bind=\"title\"></small>\n    </h2>\n  </section>\n  <div class=\"col-md-12\">\n    <div class=\"nav-tabs-custom\">\n      <ul class=\"nav nav-tabs\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"project.testApplication\">测试申请</a>\n        </li>\n      </ul>\n      <div class=\"tab-content\">\n        <div class=\"tab-pane active clearfix\" ui-view>\n        </div>\n      </div>\n    </div>\n  </div>\n</warp>");
$templateCache.put("src/module/public/public.html","<warp>\n  <ui-view></ui-view>\n</warp>");
$templateCache.put("src/module/recConfig/recConfig.html","<warp class=\"rec-config\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      推荐配置\n      <small ng-bind=\"subTitle\"></small>\n    </h2>\n  </section>\n  <div class=\"col-md-12\">\n    <div class=\"nav-tabs-custom\">\n      <ul class=\"nav nav-tabs\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recConfig.actionConfig\">行为配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recConfig.hotRecConfig\">热门推荐配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recConfig.mergeConfig\">merge条件配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"configManage.basicConfig\">基础配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"configManage.timeConfig\">时效性配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"configManage.diversityConfig\">多样性配置</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"configManage.relatedSuggestConfig\">相关推荐配置</a>\n        </li>\n      </ul>\n      <div class=\"tab-content\">\n        <div class=\"tab-pane active clearfix\" ui-view>\n        </div>\n      </div>\n    </div>\n</div></warp>");
$templateCache.put("src/module/recDebug/recDebug.html","<warp class=\"rec-debug\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      推荐Debug平台\n      <small ng-bind=\"childStr\"></small>\n    </h2>\n  </section>\n  <div class=\"col-md-12\">\n    <div class=\"nav-tabs-custom\">\n      <ul class=\"nav nav-tabs\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recDebug.personal\">个性化推荐</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recDebug.related\">相关推荐</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recDebug.hot\">热门推荐</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"recDebug.review\">推荐结果检查</a>\n        </li>\n      </ul>\n      <div class=\"tab-content\">\n        <div class=\"tab-pane active clearfix\" ui-view>\n        </div>\n      </div>\n    </div>\n</div></warp>");
$templateCache.put("src/module/reviewDict/reviewDict.html","<warp>\n  <div class=\"box-body\">\n    <div class=\"box-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"row\">\n          <div class=\"col-xs-8 col-sm-3\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-3 control-label\">type：</label>\n              <div class=\"col-xs-9\">\n                <select class=\"form-control function-form-input-fixed-width\" ng-model=\"filter.type\" ng-options=\"type for type in typeList\" ng-change=\"reload()\"></select>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-8 col-sm-3\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-3 control-label\">level：</label>\n              <div class=\"col-xs-9\">\n                <select class=\"form-control function-form-input-fixed-width\" ng-model=\"filter.level\" ng-options=\"level for level in levelList\" ng-change=\"reload()\"></select>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-8 col-sm-3\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-3 control-label\">pinyin：</label>\n              <div class=\"col-xs-9\">\n                <select class=\"form-control function-form-input-fixed-width\" ng-model=\"filter.pinyin\" ng-options=\"pinyin for pinyin in pinyinList\" ng-change=\"reload()\"></select>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-8 col-sm-3\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-3 control-label\">appid：</label>\n              <div class=\"col-xs-9\">\n                <select class=\"form-control function-form-input-fixed-width\" ng-model=\"filter.appid\" ng-options=\"appid for appid in appidList\" ng-change=\"reload()\"></select>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-8 col-sm-3\">\n            <dg-search-input ng-model=\"query.word\" placeholder=\"请输word\" search=\"reload()\" width=\"260px\"></dg-search-input>\n          </div>\n          <div class=\"col-xs-8 col-sm-5\">\n            <button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"add()\" ng-disabled=\"!pinyinList\">新增</button>\n          </div>\n        </div>\n        <fieldset class=\"mt-sm\">\n          <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body reviewdict-tbl\">\n            <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n              <tr ng-repeat=\"item in $data\">\n                <td data-title=\"\'appid\'\" ng-bind=\"item.appid\" class=\"text-align-center\"></td>\n                <td data-title=\"\'type\'\" ng-bind=\"item.type\" class=\"text-align-center\"></td>\n                <td data-title=\"\'word\'\" ng-bind=\"item.word\" class=\"text-align-center\"></td>\n                <td data-title=\"\'level\'\" ng-bind=\"item.level\" class=\"text-align-center\"></td>\n                <td data-title=\"\'pinyin\'\" ng-bind=\"item.pinyin\" class=\"text-align-center\"></td>\n                <td data-title=\"\'操作\'\" class=\"text-align-center\">\n                  <button type=\"button\" class=\"btn btn-primary\" ng-click=\"delete(item.word_infoid)\">删除</button>\n                </td>\n              </tr>\n            </table>\n          </div>\n        </fieldset>\n      </form>\n    </div>\n  </div>\n  <!--reviewdict dialog ng-template-->\n  <script id=\"reviewdict-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog reviewdict-dialog\">\n      <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/reviewDict/dialog/dialog.html\'\"></div>\n    </div>\n  </script>\n</warp>");
$templateCache.put("src/module/searchConfig/searchConfig.html","<warp class=\"contact-module\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      搜索配置\n      <small ng-bind=\"title\"></small>\n    </h2>\n  </section>\n  <section class=\"content\">\n    <div class=\"box\">\n      <div class=\"box-header\">\n        <form class=\"form-inline\">\n          <button class=\"btn btn-primary btn-sm btn-flat\" ui-sref=\"searchConfig.item()\">\n            <span class=\"glyphicon glyphicon-plus\"></span>添加配置\n          </button>\n          <dg-search-input ng-model=\"searchValue.app_id\" placeholder=\"请输app_id\" search=\"search()\" width=\"200px\"></dg-search-input>\n        </form>\n      </div>\n      <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n        <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n          <tr ng-repeat=\"item in $data\">\n            <td data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n            <td data-title=\"\'ready\'\" ng-bind=\"item.is_search_ready\"></td>\n            <td data-title=\"\'count\'\" ng-bind=\"item.app_item_count\"></td>\n            <td data-title=\"\'category\'\" ng-bind=\"item.app_category\"></td>\n            <td data-title=\"\'is_multi_value\'\" ng-bind=\"item.is_multi_value\"></td>\n            <td data-title=\"\'index_fields\'\">\n              <field-list list=\"item.index_fields\"></field-list>\n            </td>\n            <td data-title=\"\'return_fields\'\">\n              <field-list list=\"item.return_fields\"></field-list>\n            </td>\n            <td data-title=\"\'suggest_fields\'\">\n              <field-list list=\"item.suggest_fields\"></field-list>\n            </td>\n            <!--<td data-title=\"\'create_time\'\" ng-bind=\"item.create_time\"></td>-->\n            <!--<td data-title=\"\'last_update_time\'\" ng-bind=\"item.last_update_time\"></td>-->\n            <td data-title=\"\'edit\'\">\n              <button class=\"btn btn-default btn-sm btn-flat\" ui-sref=\"searchConfig.item({id: item.appid})\">\n                <span class=\"glyphicon glyphicon-pencil\"></span>\n              </button>\n              <!--<button class=\"btn btn-sm btn-danger btn-flat\">-->\n                <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n              <!--</button>-->\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </section>\n  <!--nlp dialog ng-template-->\n  <script id=\"search-config-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog account-dialog\">\n      <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/searchConfig/dialog/dialog.html\'\"></div>\n    </div>\n  </script>\n  <ui-view></ui-view>\n</warp>");
$templateCache.put("src/module/serviceAlarm/serviceAlarm.html","<warp>\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      项目管理\n      <small>服务报警</small>\n    </h2>\n  </section>\n  <section class=\"content service-alarm\">\n    <div class=\"box\">\n      <div class=\"box-header\">\n        <dg-search-input ng-model=\"searchValue.keyword\" uib-tooltip=\"按照项目名称、app name搜索\" tooltip-class=\"text-right\" placeholder=\"请输关键词\" search=\"search()\" width=\"200px\">\n        </dg-search-input>\n        <filter-group filter-list=\"alarmFilter\" search-value=\"searchValue\" search-func=\"search()\">\n        </filter-group>\n        <p ng-if=\"!isSeller\">\n          <span class=\"alarm-label\">负责人:</span>\n          <select class=\"form-control\" ng-model=\"searchValue.manager_id\" ng-change=\"search()\">\n            <option ng-repeat=\"seller in sellerList\" value=\"{{seller.user_id}}\" ng-bind=\"seller.user_nickname\"></option>\n          </select>\n        </p>\n        <p>\n          <span class=\"alarm-label\">报警时间:</span>\n          <period-date-picker ng-model=\"filterDate\" disable-clear ng-change=\"search()\" disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n        </p>\n      </div>\n      <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n        <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n          <tr ng-repeat=\"item in $data\" ng-show=\"$data.length > 0\">\n            <td data-title=\"\'序号\'\" ng-bind=\"$index + 1\"></td>\n            <td data-title=\"\'项目名称\'\" ng-bind=\"item.project_name\"></td>\n            <td data-title=\"\'app name\'\">\n              <a ng-bind=\"item.app_name\" ng-click=\"doDashboard(item.app_id)\"></a>\n            </td>\n            <td data-title=\"\'功能\'\" ng-bind=\"ALARM_API_MAPPING[item.alarm_api]\" class=\"nowrap\"></td>\n            <td data-title=\"\'报警类型\'\" ng-bind=\"ALARM_TYPE_MAPPING[item.alarm_type]\" class=\"nowrap\"></td>\n            <td data-title=\"\'报警详情\'\">\n              <div ng-if=\"item.detail.indexOf(\'\\n\') == -1\">\n                <span ng-repeat=\"string in item.detail.split(\'，\')\" ng-bind-html=\"handleHighLightString(string)\"></span>\n              </div>\n              <div ng-if=\"item.detail.indexOf(\'\\n\') > -1\">\n                <span ng-repeat=\"string in item.detail.split(\'\\n\')[0].split(\'，\')\" ng-bind-html=\"handleHighLightString(string)\"></span>；\n                <span ng-repeat=\"string in item.detail.split(\'\\n\')[1].split(\'，\')\" ng-bind-html=\"handleHighLightString(string)\"></span>\n              </div>\n            </td>\n            <td data-title=\"\'报警时间\'\" ng-bind=\"item.alarm_time.substring(0,10)\" class=\"nowrap\"></td>\n            <td data-title=\"\'报警状态\'\" ng-bind=\"ALARM_STATUS_MAPPING[item.status]\" class=\"nowrap\"></td>\n            <td data-title=\"\'负责人\'\" ng-bind=\"tableSellerList[item.manager_id]\" class=\"nowrap\"></td>\n            <td data-title=\"\'最新跟进时间\'\" class=\"nowrap\" ng-bind=\"item.last_follow_time\"></td>\n            <td data-title=\"\'操作\'\" class=\"nowrap\">\n              <div class=\"btn-group\" uib-dropdown uib-dropdown-toggle style=\"width: 80px\" ng-mouseover=\"item.isopen = true\" is-open=\"item.isopen\">\n                <button id=\"split-button\" type=\"button\" class=\"btn btn-default btn-sm\">操作</button>\n                <button type=\"button\" class=\"btn btn-default btn-sm\">\n                  <span class=\"caret\"></span>\n                </button>\n                <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-button\">\n                  <li role=\"menuitem\">\n                    <a ng-click=\"edit(item.id, \'detail\')\">跟进详情</a></li>\n                  <li role=\"menuitem\" ng-if=\"canReview && item.status ==2  && isManager\">\n                    <a ng-click=\"edit(item.id, \'review\')\">审核</a></li>\n                  <li role=\"menuitem\" ng-if=\"canFollow && item.status != 3\">\n                    <a ng-click=\"edit(item.id, \'follow\')\">跟进</a></li>\n                </ul>\n              </div>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </section>\n  <script id=\"service-alarm-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog application-dialog\">\n      <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/serviceAlarm/dialog/dialog.html\'\"></div>\n    </div>\n  </script>\n</warp>");
$templateCache.put("src/module/strategyEffectStatistics/strategyEffectStatistics.html","<warp class=\"rec-debug\">\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      策略效果统计\n      <small ng-bind=\"childStr\"></small>\n    </h2>\n  </section>\n  <div class=\"col-md-12\">\n    <div class=\"nav-tabs-custom\">\n      <ul class=\"nav nav-tabs\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"strategyEffectStatistics.hourly\">小时级策略效果</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"strategyEffectStatistics.hourlyOverall\">小时级总体效果</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"strategyEffectStatistics.day\">天级策略效果</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"strategyEffectStatistics.dayOverall\">天级总体效果</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"strategyEffectStatistics.whiteList\">统计白名单</a>\n        </li>\n      </ul>\n      <div class=\"tab-content\">\n        <div class=\"tab-pane active clearfix\" ui-view>\n        </div>\n      </div>\n    </div>\n</div></warp>");
$templateCache.put("src/module/strategyPerformanceStatistics/strategyPerformanceStatistics.html","<warp class=\"rec-debug\">\n    <section class=\"content-header\">\n      <h2 class=\"page-title\">\n        性能监控统计\n        <small ng-bind=\"childStr\"></small>\n      </h2>\n    </section>\n    <div class=\"col-md-12\">\n      <div class=\"nav-tabs-custom\">\n        <ul class=\"nav nav-tabs\">\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"strategyPerformanceStatistics.hourlyApp\">小时级APP调用</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"strategyPerformanceStatistics.hourlyWhole\">小时级总体调用</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"strategyPerformanceStatistics.dayApp\">天级APP调用</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"strategyPerformanceStatistics.dayWhole\">天级总体调用</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"strategyPerformanceStatistics.appTimeProcess\">APP处理时间分布</a>\n          </li>\n          <li ui-sref-active=\"active\">\n            <a ui-sref=\"strategyPerformanceStatistics.wholeTimeProcess\">总体处理时间分布</a>\n          </li>\n        </ul>\n        <div class=\"tab-content\">\n          <div class=\"tab-pane active clearfix\" ui-view>\n          </div>\n        </div>\n      </div>\n  </div></warp>");
$templateCache.put("src/module/textReview/textReview.html","<warp>\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      文本审核\n      <small ng-bind=\"title\"></small>\n    </h2>\n  </section>\n  <div class=\"col-md-12\">\n    <div class=\"nav-tabs-custom\">\n      <ul class=\"nav nav-tabs\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"textReview.manualReview\">人工审核</a>\n        </li>\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"textReview.feedback\">反馈数据</a>\n        </li>\n    </ul></div>\n    <div class=\"body tab-content\">\n      <div class=\"tab-pane active clearfix\">\n        <div class=\"box\" ui-view></div>\n      </div>\n    </div>\n    \n  </div>\n</warp>");
$templateCache.put("src/module/userPublic/changePassword.html","<warp>\n  <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      用户中心\n    </h2>\n  </section>\n  <section class=\"content\">\n    <div class=\"nav-tabs-custom\">\n      <uib-tabset>\n        <uib-tab heading=\"修改密码\">\n          <div class=\"row\">\n            <form role=\"form\" class=\"center-block col-md-6\" name=\"passwordForm\" novalidate>\n              <div class=\"box-body\" ng-init=\"setForm(passwordForm, \'passwordForm\')\">\n                <div class=\"form-group\">\n                  <label class=\"control-label\">原密码</label>\n                  <input type=\"text\" class=\"form-control\" placeholder=\"原密码\" ng-model=\"password.login_passwd_old\" name=\"login_passwd_old\" required>\n                  <form-message name=\"login_passwd_old\" label=\"原密码\"></form-message>\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"control-label\">新密码</label>\n                  <input type=\"password\" class=\"form-control\" placeholder=\"新密码\" ng-model=\"password.login_passwd\" name=\"login_passwd\" required>\n                  <form-message name=\"login_passwd\" label=\"新密码\"></form-message>\n                  <label class=\"control-label error\" ng-if=\"password.login_passwd != tmp.repeatPasswd\">\n                    <i class=\"fa fa-times-circle-o\"></i><span>新密码与重复密码不一致</span>\n                  </label>\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"control-label\">确认新密码</label>\n                  <input type=\"password\" class=\"form-control\" placeholder=\"确认新密码\" ng-model=\"tmp.repeatPasswd\" name=\"repeatPasswd\" required>\n                  <form-message name=\"repeatPasswd\" label=\"确认新密码\"></form-message>\n                  <label class=\"control-label error\" ng-if=\"password.login_passwd != tmp.repeatPasswd\">\n                    <i class=\"fa fa-times-circle-o\"></i><span>新密码与重复密码不一致</span>\n                  </label>\n                </div>\n              </div>\n              <div class=\"box-footer\">\n                <button class=\"btn btn-default btn-flat\" ng-click=\"clean(\'password\')\" ng-disabled=\"!passwordForm.$dirty\">\n                  清空\n                </button>\n                <button class=\"btn btn-primary pull-right btn-flat\" ng-click=\"submit(\'password\')\" ng-disabled=\"passwordForm.$invalid || password.login_passwd != tmp.repeatPasswd\">确定\n                </button>\n              </div>\n            </form>\n          </div>\n        </uib-tab>\n        <uib-tab heading=\"修改手机号\">\n          <form role=\"form\" class=\"center-block col-md-6\" name=\"telForm\" novalidate>\n            <div class=\"box-body\" ng-init=\"setForm(telForm, \'telForm\')\">\n              <div class=\"form-group\">\n                <label class=\"control-label\">手机号</label>\n                <input type=\"text\" class=\"form-control\" placeholder=\"手机号\" ng-model=\"tel.tel\" required name=\"tel\" ng-pattern=\"/^1(3|4|5|7|8)\\d{9}$/\">\n                <form-message name=\"tel\" label=\"手机号\"></form-message>\n              </div>\n            </div>\n            <div class=\"box-footer\">\n              <button class=\"btn btn-primary pull-right btn-flat\" ng-click=\"confirm()\" ng-disabled=\"telForm.$invalid\">确定\n              </button>\n            </div>\n          </form>\n        </uib-tab>\n      </uib-tabset>\n    </div>\n  </section>\n\n  <!--menu dialog ng-template-->\n  <script id=\"change-tel-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/userPublic/dialog/dialog.html\'\"></div>\n    </div>\n  </script>\n</warp>");
$templateCache.put("src/module/account/management/management.html","<!-- <section class=\"content-header\">\n    <h2 class=\"page-title\">\n      <a class=\"btn btn-info btn-flat\" ui-sref=\"account.onlineDetail({id: 8})\">查看开通</a>\n      <a class=\"btn btn-info btn-flat\" ui-sref=\"account.unonlineDetail({id: 8})\">查看未开通</a>\n    </h2>\n  </section> -->\n<!-- <section class=\"content-header\">\n  <form class=\"form-horizontal\">\n    <div class=\"row\">\n      <div class=\"form-group\">\n        <label class=\"control-label col-xs-1\">账号类型：</label>\n        <div class=\"btn-group col-xs-8\">\n          <span class=\"btn\">客户账号</span>\n          <span class=\"btn\">内部测试</span>\n          <span class=\"btn\">合作账号</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-group\">\n        <label>开通功能：</label>\n      </div>\n    </div>\n  </form>\n</section> -->\n<div class=\"box\">\n  <div class=\"box-header box-radius\">\n    <dg-search-input ng-model=\"query.keyword\" uib-tooltip=\"按照项目（产品）名称,appname,appid搜索\" tooltip-class=\"text-right\" placeholder=\"项目（产品）名称/appname/appid\" search=\"search()\" width=\"300px\">\n    </dg-search-input>\n    <dl class=\"navbar-btn-switch clearfix\" ng-repeat=\"(key, obj) in filterNavbarBtnSwitch\">\n      <dt ng-bind=\"obj.title\"></dt>\n      <dd ng-repeat=\"l in obj.list\" ng-bind=\"l.name\" ng-class=\"{\'active\' : $index == params[key]}\" ng-click=\"update(key, $index)\"></dd>\n    </dl>\n    <dl ng-if=\"!isOnlySeller\" class=\"navbar-btn-switch clearfix dropdown\">\n        <dt ng-bind=\"\'负责人\'\">\n        <dd>\n          <select ng-model=\"params.manager\" ng-change=\"search()\">\n            <option ng-repeat=\"item in seller\" ng-bind=\"item.user_nickname\" ng-bind=\"params.manger: item.user_nickname == \'全部\'\"></option>\n          </select>\n        </dd>\n    </dt></dl>\n  </div>\n\n  <div class=\"btn-custom\">\n    <button class=\"btn\" ng-click=\"create(id, 0)\">+新建账号</button>\n    <button class=\"btn\" ng-click=\"create(id, 1)\">+非客户账号</button>\n    <button class=\"btn\" ng-click=\"\">下载账号信息</button>\n  </div>\n\n  <div class=\"box-radius inset-tbl\">\n      <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\">\n            <td data-title=\"\'项目（产品）名称\'\" ng-bind=\"item.project_name\"></td>\n            <td data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n            <td data-title=\"\'appid\'\" ng-bind=\"\" class=\"nowrap\"></td>\n            <td data-title=\"\'审核\'\" ng-bind=\"\" class=\"nowrap\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n            <td data-title=\"\'分类\'\" ng-bind=\"\" class=\"nowrap\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n            <td data-title=\"\'标签\'\" ng-bind=\"item.review_time | tableTimeFilter\" class=\"nowrap\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n            <td data-title=\"\'情感\'\" ng-bind=\"reflect(item.status, filterGroup.statusList)\" class=\"nowrap\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n            <td data-title=\"\'推荐\'\" class=\"nowrap\" ng-bind=\"\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n            <td data-title=\"\'搜索\'\" class=\"nowrap\" ng-bind=\"\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n            <td data-title=\"\'抓取\'\" class=\"nowrap\" ng-bind=\"\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n            <td data-title=\"\'负责人\'\" class=\"nowrap\" ng-bind=\"\"></td>\n            <td data-title=\"\'状态\'\" class=\"nowrap\" ng-bind=\"\"></td>\n            <td data-title=\"\'开通时间\'\" class=\"nowrap\" ng-bind=\"\"></td>\n            <td data-title=\"\'操作\'\" class=\"nowrap\">\n              <button id=\"split-button\" type=\"button\" class=\"btn btn-default btn-sm\">查看</button>\n            </td>\n        </tr>\n    </table>\n  </div>\n\n  <script id=\"client-account-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog application-dialog\">\n      <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/account/management/client/client.html\'\"></div>\n    </div>\n  </script>\n\n  <script id=\"other-account-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog application-dialog\">\n      <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/account/management/other/other.html\'\"></div>\n    </div>\n  </script>\n\n</div>\n\n\n");
$templateCache.put("src/module/account/open/open.html","<div class=\"box\">\n    <div class=\"box-header box-radius\">\n      <dg-search-input ng-model=\"query.keyword\" uib-tooltip=\"按照项目（产品）名称,appname,appid搜索\" tooltip-class=\"text-right\" placeholder=\"项目（产品）名称/appname/appid\" search=\"search()\" width=\"300px\">\n      </dg-search-input>\n      <dl class=\"navbar-btn-switch clearfix\" ng-repeat=\"(key, obj) in filterNavbarBtnSwitch\">\n        <dt ng-bind=\"obj.title\"></dt>\n        <dd ng-repeat=\"l in obj.list\" ng-bind=\"l.name\" ng-class=\"{\'active\' : $index == params[key]}\" ng-click=\"update(key, $index)\"></dd>\n      </dl>\n      <dl ng-if=\"!isOnlySeller\" class=\"navbar-btn-switch clearfix dropdown\">\n          <dt ng-bind=\"\'负责人\'\">\n          <dd>\n            <select ng-model=\"params.manager\" ng-change=\"search()\">\n              <option ng-repeat=\"item in seller\" ng-bind=\"item.user_nickname\" ng-bind=\"params.manger: item.user_nickname == \'全部\'\"></option>\n            </select>\n          </dd>\n      </dt></dl>\n    </div>\n    <button id=\"edit\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"edit(id)\">编辑</button>\n    <button id=\"examine\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"examine()\">审核</button>\n    <div class=\"box-radius inset-tbl\">\n        <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n          <tr ng-repeat=\"item in $data\">\n              <td data-title=\"\'项目（产品）名称\'\" ng-bind=\"item.project_name\"></td>\n              <td data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n              <td data-title=\"\'appid\'\" ng-bind=\"\" class=\"nowrap\"></td>\n              <td data-title=\"\'审核\'\" ng-bind=\"\" class=\"nowrap\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n              <td data-title=\"\'分类\'\" ng-bind=\"\" class=\"nowrap\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n              <td data-title=\"\'标签\'\" ng-bind=\"item.review_time | tableTimeFilter\" class=\"nowrap\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n              <td data-title=\"\'情感\'\" ng-bind=\"reflect(item.status, filterGroup.statusList)\" class=\"nowrap\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n              <td data-title=\"\'推荐\'\" class=\"nowrap\" ng-bind=\"\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n              <td data-title=\"\'搜索\'\" class=\"nowrap\" ng-bind=\"\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n              <td data-title=\"\'抓取\'\" class=\"nowrap\" ng-bind=\"\"><input type=\"checkbox\" disabled=\"disabled\"></td>\n              <td data-title=\"\'负责人\'\" class=\"nowrap\" ng-bind=\"\"></td>\n              <td data-title=\"\'申请时间\'\" class=\"nowrap\" ng-bind=\"\"></td>\n              <td data-title=\"\'操作\'\" class=\"nowrap\">\n                <button id=\"edit\" type=\"button\" class=\"btn btn-default btn-sm\">编辑</button>\n                <button id=\"examine\" type=\"button\" class=\"btn btn-default btn-sm\">审核</button>\n              </td>\n          </tr>\n      </table>\n    </div>\n  \n    <script id=\"client-account-dialog\" type=\"text/ng-template\">\n      <div class=\"modal-dialog application-dialog\">\n        <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/account/management/client/client.html\'\"></div>\n      </div>\n    </script>\n  \n    <script id=\"examine-account-dialog\" type=\"text/ng-template\">\n      <div class=\"modal-dialog application-dialog\">\n        <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/account/open/examine/examine.html\'\"></div>\n      </div>\n    </script>\n  \n  </div>");
$templateCache.put("src/module/client/API/API.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    客户管理\n    <small>接口调用</small>\n  </h2>\n</section>\n<section class=\"content\">\n  <div class=\"box\">\n    <div class=\"box-header\">\n      <form class=\"form-inline\">\n        <div class=\"form-group\">\n          <label>日期：</label>\n          <date-picker ng-model=\"data_date\" ng-change=\"search()\" disable-clear></date-picker>\n        </div>\n        <div class=\"form-group\">\n          <label>状态：</label>\n          <select ng-model=\"status\" class=\"form-control\">\n            <option value=\"all\">全部</option>\n            <option value=\"测试\">测试</option>\n            <option value=\"上线\">上线</option>\n            <option value=\"暂停\">暂停</option>\n            <option value=\"停止\">停止</option>\n          </select>\n        </div>\n        <dg-search-input ng-model=\"name\" placeholder=\"用户名称/公司名称\" search=\"search()\"></dg-search-input>\n      </form>\n    </div>\n    <div class=\"box-body table-responsive\" ng-show=\"searchOnlyByDate\" class=\"box-body\" scroll-box=\"$(this)\" table-bottom-scroll-bar-height=\"screen\" table-bottom-scroll-bar>\n      <table class=\"table table-bordered table-hover dataTable\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data track by $index\" ng-show=\"item.status == status || status == \'all\'\">\n          <td data-title=\"\'序号\'\" ng-bind=\"$index + 1\"></td>\n          <td data-title=\"\'公司名称\'\" ng-bind=\"item.company_name\"></td>\n          <td data-title=\"\'用户名称\'\">\n            <a ng-bind=\"item.username\" ng-click=\"doDashboard(item.appid)\"></a>\n          </td>\n          <td data-title=\"\'APP ID\'\" ng-bind=\"item.appid\"></td>\n          <td data-title=\"\'状态\'\" ng-bind=\"item.status\"></td>\n          <td data-title=\"\'数据上报\'\" sortable=\"\'static\'\" class=\"number\" ng-bind=\"item.static\"></td>\n          <td data-title=\"\'搜索\'\" sortable=\"\'search\'\" class=\"number\" ng-bind=\"item.search\"></td>\n          <td data-title=\"\'推荐\'\" sortable=\"\'rec\'\" class=\"number\" ng-bind=\"item.rec\"></td>\n          <td data-title=\"\'爬虫\'\" sortable=\"\'spider\'\" class=\"number\" ng-bind=\"item.spider\"></td>\n          <td data-title=\"\'广告\'\" ng-bind=\"item.ad\" class=\"number\" sortable=\"\'ad\'\"></td>\n          <td data-title=\"\'涉黄\'\" ng-bind=\"item.porn\" class=\"number\" sortable=\"\'porn\'\"></td>\n          <td data-title=\"\'涉政\'\" ng-bind=\"item.politic\" class=\"number\" sortable=\"\'politic\'\"></td>\n          <td data-title=\"\'反动\'\" ng-bind=\"item.reaction\" class=\"number\" sortable=\"\'reaction\'\"></td>\n          <td data-title=\"\'低质量\'\" ng-bind=\"item.nonsense\" class=\"number\" sortable=\"\'nonsense\'\"></td>\n          <td data-title=\"\'分类\'\" ng-bind=\"item.classify\" sortable=\"\'classify\'\" class=\"number\"></td>\n          <td data-title=\"\'标签\'\" ng-bind=\"item.tagging\" sortable=\"\'tagging\'\" class=\"number\"></td>\n          <td data-title=\"\'情感\'\" ng-bind=\"item.sentiment\" sortable=\"\'sentiment\'\" class=\"number\"></td>\n          <td data-title=\"\'负责人\'\" ng-bind=\"Config.manager_id[item.manager_id]\"></td>\n          <td data-title=\"\'操作\'\">\n            <button ui-sref=\"client.API.item({id: item.appid})\" type=\"button\" class=\"btn btn-primary btn-sm\">\n              <span class=\"glyphicon glyphicon-info\"></span>查看\n            </button>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>\n<ui-view></ui-view>");
$templateCache.put("src/module/client/account/account.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    客户管理\n    <small>账号管理</small>\n  </h2>\n</section>\n<section class=\"content\">\n  <div class=\"box\">\n    <div class=\"box-header\">\n      <form class=\"form-inline\">\n        <div class=\"input-group search-box\">\n          <a ng-click=\"download()\" class=\"btn btn-primary\">\n            <i class=\"glyphicon glyphicon-arrow-down\"></i> 下载表格\n          </a>\n          &nbsp;\n          <a class=\"btn btn-primary\" type=\"button\" ui-sref=\"project.testApplication({create: true})\">\n            <i class=\"fa fa-plus\"></i> 新建账户\n          </a>\n          <!--<a class=\"btn btn-primary\" type=\"button\" ng-click=\"edit()\">\n            <i class=\"fa fa-plus\"></i> 新建账户\n          </a>-->\n        </div>\n        <div class=\"form-group\">\n          <label for=\"searchType\">功能</label>\n          <select class=\"form-control\" ng-model=\"searchType\" ng-change=\"search()\">\n            <option ng-repeat=\"item in searchTypeList track by $index\" value=\"{{item.type}}\" ng-bind=\"item.text\"></option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"source\">渠道</label>\n          <select class=\"form-control\" ng-model=\"channel\" ng-change=\"search()\">\n            <!-- <option ng-repeat=\"(key, channel) in channelList\" value=\"{{key}}\" ng-bind=\"channel\"></option> -->\n            <option value=\"\">全部</option>\n            <option value=\"空渠道\">空渠道</option>\n            <option value=\"销售\">销售</option>\n            <option value=\"市场\">市场</option>\n            <option value=\"其他\">其他</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label>状态</label>\n          <select class=\"form-control\" ng-model=\"status\" ng-change=\"search()\">\n            <option value=\"all\">全部</option>\n            <option value=\"测试\">测试</option>\n            <option value=\"上线\">上线</option>\n            <option value=\"暂停\">暂停</option>\n            <option value=\"停止\">停止</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label>负责人</label>\n          <select class=\"form-control\" ng-model=\"seller\" ng-change=\"search()\">\n            <option value=\"all\">全部</option>\n            <option value=\"{{seller.user_id}}\" ng-repeat=\"seller in isSeller track by $index\" ng-bind=\"seller.user_nickname\"></option>\n          </select>\n        </div>\n        <dg-search-input ng-model=\"app_name\" search=\"search()\" placeholder=\"用户名称/公司名称\"></dg-search-input>\n      </form>\n    </div>\n    <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n      <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-header=\"table_header\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in data.list track by $index\">\n          <td data-title=\"\'序号\'\" ng-bind=\"$index + 1\"></td>\n          <td data-title=\"\'公司名称\'\" ng-bind=\"Config.appid[item.appid].company_name\"></td>\n          <td data-title=\"\'用户名称\'\">\n            <a ng-bind=\"Config.appid[item.appid].app_name\" ng-click=\"doDashboard(item.appid)\"></a>\n          </td>\n          <td ng-bind=\"item.appid\"></td>\n          <td data-title=\"\'广告\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.nlpdetail.ad == 1 ? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'低质量文本\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.nlpdetail.nonsense == 1 ? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'涉黄\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.nlpdetail.porn == 1 ? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'涉政\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.nlpdetail.politic == 1 ? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'反动\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.nlpdetail.reaction == 1 ? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'分类\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.nlpdetail.classify == 1 ? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'标签\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.nlpdetail.tagging == 1 ? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'感情\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.nlpdetail.sentiment == 1 ? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'搜索\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.search_config== \'1\'? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'推荐\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.rec_config== \'1\'? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'爬虫\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.spider_config== \'1\'? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'统计\'\">\n            <div class=\"checkbox\">\n              <label>\n                <input type=\"checkbox\" ng-checked=\"item.static_config== \'1\'? true : false\" disabled=\"true\">\n              </label>\n            </div>\n          </td>\n          <td data-title=\"\'渠道\'\" ng-bind=\"item.channel_name\" class=\"nowrap\"></td>\n          <td data-title=\"\'开通时间\'\" ng-bind=\"item.register_time\"></td>\n          <td data-title=\"\'状态\'\" ng-bind=\"item.status\" class=\"nowrap\"></td>\n          <td data-title=\"\'负责人\'\" ng-bind=\"Config.manager_id[item.manager_id]\" class=\"nowrap\"></td>\n          <td data-title=\"\'操作\'\" class=\"nowrap\">\n            <a ui-sref=\"client.API.item({id: item.appid})\" target=\"_blank\" class=\"btn btn-primary btn-sm\">\n              <span class=\"glyphicon glyphicon-edit\"></span>查看\n            </a>\n            <a class=\"btn btn-primary btn-sm\" ng-click=\"edit(item, $index)\">\n              <span class=\"glyphicon glyphicon-edit\"></span>编辑\n            </a>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>\n<!-- /.box-header -->\n<script id=\"table_header\" type=\"text/ng-template\">\n  <tr>\n    <th>序号</th>\n    <th>公司名称</th>\n    <th>用户名称</th>\n    <th>APP ID</th>\n    <th>广告</th>\n    <th>低质量</th>\n    <th>涉黄</th>\n    <th>涉政</th>\n    <th>反动</th>\n    <th>分类</th>\n    <th>标签</th>\n    <th>感情</th>\n    <th>搜索</th>\n    <th>推荐</th>\n    <th>爬虫</th>\n    <th>统计</th>\n    <th>渠道</th>\n    <th>开通时间</th>\n    <th>状态</th>\n    <th>负责人</th>\n    <th>操作</th>\n  </tr>\n</script>\n<!--nlp dialog ng-template-->\n<script id=\"account-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog account-dialog\">\n    <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/client/account/dialog/dialog.html\'\"></div>\n  </div>\n</script>");
$templateCache.put("src/module/client/apply/apply.html","<section class=\"content-header\">\n    <h2 class=\"page-title\">\n        项目管理\n        <small>新建账号</small>\n    </h2>\n</section>\n<section class=\"content client-apply\">\n    <div class=\"box\">\n        <div class=\"box-header\">\n            <dg-wizard list=\"wizardData\" status=\"status\"></dg-wizard>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-10 col-xs-push-1\">\n                <div ng-show=\"status == 1\">\n                    <form class=\"form-horizontal\" name=\"accountInfoForm\" novalidate>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">公司名称</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"company_name\" ng-model=\"params.company_name\" required>\n                                <form-message label=\"公司名称\" name=\"company_name\"></form-message>\n                            </div>\n                            <div class=\"col-xs-5\">\n                                例：达而观信息科技（上海）有限公司\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">项目名称</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"project_name\" ng-model=\"params.project_name\" required ng-maxlength=\"24\">\n                                <form-message label=\"项目名称\" name=\"project_name\"></form-message>\n                            </div>\n                            <div class=\"col-xs-5\">\n                                例：达观数据大师\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">所属行业</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"industry\" ng-model=\"params.industry\" required>\n                                <form-message label=\"所属行业\" name=\"industry\"></form-message>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">app name</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"app_name\" ng-pattern=\"/^\\w+$/\" ng-model=\"params.app_name\" required ng-maxlength=\"20\">\n                                <form-message label=\"app name\" name=\"app_name\"></form-message>\n                            </div>\n                            <div class=\"col-xs-5\">\n                                *由字母和数字组成，一般使用项目名称的拼音<br>app name唯一且不可更改\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">客户来源</label>\n                            <div class=\"col-xs-5\">\n                                <select class=\"form-control\" ng-model=\"params.channel_id\" ng-options=\"channel.id as channel.name for channel in channelList\" required></select>\n                                <form-message label=\"客户来源\" name=\"channel_id\"></form-message>\n                            </div>\n                        </div>\n                    </form>\n                    <div class=\"control-holder\">\n                        <button class=\"btn btn-primary btn-flat\" ng-click=\"next()\" ng-disabled=\"accountInfoForm.$invalid\">下一步</button>\n                        <!-- <button class=\"btn btn-primary btn-flat\" ng-click=\"next()\">下一步</button> -->\n                    </div>\n                </div>\n                <div ng-show=\"status == 2\">\n                    <function-form model=\"function\" ng-repeat=\"function in functionList\"></function-form>\n                    <div class=\"control-holder\">\n                        <button class=\"btn btn-primary btn-flat\" ng-click=\"prev()\">上一步</button> &nbsp;&nbsp;&nbsp;&nbsp;\n                        <button class=\"btn btn-primary btn-flat\" ng-click=\"next()\">下一步</button>\n                    </div>\n                </div>\n                <div ng-show=\"status == 3\">\n                    <form class=\"form-horizontal\" name=\"contactInfoForm\" novalidate>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">姓名</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"custom_manager\" ng-model=\"params.custom_manager\" placeholder=\"填写客户项目负责人姓名\" required>\n                                <form-message label=\"客户项目负责人姓名\" name=\"custom_manager\"></form-message>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">职位</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"custom_position\" ng-model=\"params.custom_position\" placeholder=\"填写客户项目负责人职位\" required ng-maxlength=\"24\">\n                                <form-message label=\"客户项目负责人职位\" name=\"custom_position\"></form-message>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">电话</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"custom_tel\" ng-pattern=\"/^1(3|4|5|7|8)\\d{9}$/\" ng-model=\"params.custom_tel\" placeholder=\"填写客户项目负责人电话\" required>\n                                <form-message label=\"客户项目负责人电话\" name=\"custom_tel\"></form-message>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-2 control-label\">邮箱</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"tempEmail\" ng-model=\"tempEmail\" placeholder=\"填写客户项目负责人邮箱\">\n                                <label class=\"control-label error\" ng-show=\"hasEmail && !isEmail\">\n                            <i class=\"fa fa-times-circle-o\"></i>\n                            <span>邮箱名格式不正确</span>\n                        </label>\n                            </div>\n                            <div class=\"col-xs-5\">\n                                <button class=\"btn btn-default btn-flat\" ng-click=\"addEmail()\" ng-disabled=\"!(hasEmail && isEmail)\"><i class=\"fa fa-plus\"></i>&nbsp;邮箱</button>&nbsp;&nbsp;\n                                <i class=\"fa fa-question-circle\" style=\"font-size: 20px\" tooltip=\"客户通知邮件将发送至该邮箱，请务必准确填写。最多可添加5个客户通知邮箱。\" tooltip-placement=\"top\" tooltip-trigger=\"mouseenter\"></i>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-repeat=\"email in params.emails\">\n                            <label class=\"col-xs-2 control-label\">新增邮箱{{$index + 1}}</label>\n                            <div class=\"col-xs-5\">\n                                <input type=\"text\" class=\"form-control\" name=\"email\" ng-model=\"email\">\n                            </div>\n                            <div class=\"col-xs-5\">\n                                <button class=\"btn btn-danger btn-flat\" ng-click=\"deleteEmail($index)\"><i class=\"fa fa-trash-o\"></i> 删除</button>\n                            </div>\n                        </div>\n                    </form>\n                    <div class=\"control-holder\">\n                        <button class=\"btn btn-primary btn-flat\" ng-click=\"prev()\">上一步</button> &nbsp;&nbsp;&nbsp;&nbsp;\n                        <button class=\"btn btn-primary btn-flat\" ng-click=\"next()\" ng-disabled=\"contactInfoForm.$invalid || params.emails.length < 1\">下一步</button>\n                    </div>\n                </div>\n                <div ng-show=\"status == 4\">\n                    <form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n                        <fieldset>\n                            <review-label-group title=\"客户信息\" type=\"client\" data=\"params\"></review-label-group>\n                            <review-label-group title=\"测试信息\" type=\"create\" data=\"params.detail_list\"></review-label-group>\n                            <review-label-group title=\"项目人员信息\" type=\"personnel\" data=\"params\"></review-label-group>\n                        </fieldset>\n                    </form>\n                    <div class=\"control-holder\">\n                        <button class=\"btn btn-primary btn-flat\" ng-click=\"prev()\">上一步</button> &nbsp;&nbsp;&nbsp;&nbsp;\n                        <button class=\"btn btn-primary btn-flat\" ng-click=\"save()\">完成</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>");
$templateCache.put("src/module/client/review/review.html","<section class=\"content-header\">\n    <h2 class=\"page-title\">\n        项目管理\n        <small>账号管理审核</small>\n    </h2>\n</section>\n<section class=\"content\">\n    <div class=\"box\">\n        <div class=\"box-header filter-group\">\n            <dg-search-input ng-model=\"searchValue.keyword\" uib-tooltip=\"支持项目名称、app name、appid搜索\" tooltip-class=\"text-right\" placeholder=\"项目名称、appname或appid\" search=\"search()\" width=\"250px\"></dg-search-input>\n            <p>\n                <span class=\"filter-label\" ng-bind=\"\'申请状态:\'\"></span>\n                <button type=\"button\" class=\"btn btn-flat\" ng-repeat=\"filter in filterGroup.statusList\" ng-bind=\"filter.name\" ng-click=\"searchValue.status = filter.value;search();\" ng-class=\"{\'bg-olive\': filter.value === searchValue.status, \'btn-default\': filter.value !== searchValue.status}\"></button>\n            </p>\n            <p ng-hide=\"hideFuncType()\">\n                <span class=\"filter-label\" ng-bind=\"\'功能:\'\"></span>\n                <button type=\"button\" class=\"btn btn-flat\" ng-repeat=\"filter in filterGroup.functionTypeList\" ng-bind=\"filter.name\" ng-click=\"searchValue.function_type = filter.value;search();\" ng-class=\"{\'bg-olive\': filter.value === searchValue.function_type, \'btn-default\': filter.value !== searchValue.function_type}\"></button>\n            </p>\n            <p>\n                <span class=\"filter-label\" ng-bind=\"\'申请类型:\'\"></span>\n                <button type=\"button\" class=\"btn btn-flat\" ng-repeat=\"filter in filterGroup.applyTypeList\" ng-bind=\"filter.name\" ng-click=\"searchValue.apply_type = filter.value;search();\" ng-class=\"{\'bg-olive\': filter.value === searchValue.apply_type, \'btn-default\': filter.value !== searchValue.apply_type}\"></button>\n            </p>\n            <p ng-if=\"!isOnlySeller\">\n                <span class=\"filter-label\" ng-bind=\"\'负责人:\'\"></span>\n                <select class=\"form-control\" ng-model=\"searchValue.seller\" ng-change=\"search()\" ng-options=\"item.user_nickname for item in seller\"></select>\n            </p>\n            <!-- <p>\n                <span class=\"filter-label\" ng-bind=\"\'报警时间:\'\"></span>\n                <period-date-picker ng-model=\"filterDate\" disable-clear ng-change=\"search()\" disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n            </p> -->\n        </div>\n        <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n            <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n                <tr ng-repeat=\"item in $data\">\n                    <td data-title=\"\'序号\'\" ng-bind=\"$index + 1\"></td>\n                    <td data-title=\"\'项目名称\'\" ng-bind=\"item.project_name\"></td>\n                    <td data-title=\"\'app name\'\">\n                        <a ng-bind=\"item.app_name\" ng-click=\"doDashboard(item.appid)\"></a>\n                    </td>\n                    <td data-title=\"\'功能\'\" ng-bind=\"reflect(item.function_type, filterGroup.functionTypeList)\" class=\"nowrap\"></td>\n                    <td data-title=\"\'申请类型\'\" ng-bind=\"reflect(item.apply_type, filterGroup.applyTypeList)\" class=\"nowrap\"></td>\n                    <td data-title=\"\'申请时间\'\" ng-bind=\"item.create_time | tableTimeFilter\" class=\"nowrap\"></td>\n                    <td data-title=\"\'审核时间\'\" ng-bind=\"item.review_time | tableTimeFilter\" class=\"nowrap\"></td>\n                    <td data-title=\"\'申请状态\'\" ng-bind=\"reflect(item.status, filterGroup.statusList)\" class=\"nowrap\"></td>\n                    <td data-title=\"\'负责人\'\" class=\"nowrap\" ng-bind=\"item.manager\"></td>\n                    <td data-title=\"\'操作\'\" class=\"nowrap\">\n                        <div class=\"btn-group\" uib-dropdown uib-dropdown-toggle style=\"width: 80px\" ng-mouseover=\"item.isopen = true\" is-open=\"item.isopen\">\n                            <button id=\"split-button\" type=\"button\" class=\"btn btn-default btn-sm\">操作</button>\n                            <button type=\"button\" class=\"btn btn-default btn-sm\"><span class=\"caret\"></span></button>\n                            <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-button\">\n                                <li role=\"menuitem\" ng-click=\"edit(item, \'detail\')\">\n                                    <a>申请详情</a>\n                                </li>\n                                <li role=\"menuitem\" ng-click=\"edit(item, \'edit\')\" ng-if=\"item.status == 2 || item.status == 3\">\n                                    <a>编辑申请</a>\n                                </li>\n                                <li role=\"menuitem\" ng-click=\"edit(item, \'review\')\" ng-if=\"item.status == 1 && isManager\">\n                                    <a>审核</a>\n                                </li>\n                            </ul>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n    </div>\n</section>\n<script id=\"func-review-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog application-dialog\">\n    <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/client/review/dialog/dialog.html\'\"></div>\n  </div>\n</script>\n<ui-view></ui-view>");
$templateCache.put("src/module/configManage/basicConfig/basicConfig.html","<div class=\"box-header\">\n    <form class=\"form-inline\">\n      <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"create()\">\n        <i class=\"glyphicon glyphicon-plus\"></i> 新建配置\n      </button>\n      <dg-search-input ng-model=\"searchStr\" search=\"search()\" placeholder=\"请输入指定的appid\"></dg-search-input>\n    </form>\n  </div>\n  <div class=\"box-body\">\n    <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n      <tr ng-repeat=\"item in $data\">\n        <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.appname\"></td>\n        <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n        <td align=\"center\" data-title=\"\'推荐类型\'\" ng-bind=\"item.rec_type\"></td>\n        <td align=\"center\" data-title=\"\'scene type\'\" ng-bind=\"item.scene_type\"></td>\n        <td align=\"center\" data-title=\"\'最新编辑时间\'\" ng-bind=\"item.last_update_time\"></td>\n        <!-- <td align=\"center\" data-title=\"\'允许推荐历史推荐过的item\'\" ng-bind=\"item.is_filter_show\"></td>\n        <td align=\"center\" data-title=\"\'允许推荐历史点击过的item\'\" ng-bind=\"item.is_filter_click\"></td>\n        <td align=\"center\" data-title=\"\'标题滤重\'\" ng-bind=\"item.title_similarity+\'%\'\"></td> -->\n  \n        <td align=\"center\" data-title=\"\'操作\'\">\n          <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"modify(item.id)\">\n            <i class=\"glyphicon glyphicon-pencil\"></i> 编辑</button>&nbsp;\n          <button type=\"button\" class=\"btn btn-danger btn-flat\" ng-click=\"remove(item)\">\n            <i class=\"glyphicon glyphicon-trash\"></i> 删除</button>\n        </td>\n      </tr>\n    </table>\n  </div>\n  \n  <script id=\"basic-config-dialog\" type=\"text/ng-template\">\n      <div class=\"modal-dialog\">\n          <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/configManage/basicConfig/item/item.html\'\"></div>\n      </div>\n  </script>\n  <ui-view></ui-view>");
$templateCache.put("src/module/configManage/diversityConfig/diversityConfig.html","<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"create()\">\n      <i class=\"glyphicon glyphicon-plus\"></i> 新建配置\n    </button>\n    <dg-search-input ng-model=\"searchStr\" search=\"search()\" placeholder=\"请输入指定的appid\"></dg-search-input>\n  </form>\n</div>\n<div class=\"box-body\">\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.appname\"></td>\n        <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n        <td align=\"center\" data-title=\"\'推荐类型\'\" ng-bind=\"item.rec_type\"></td>\n        <td align=\"center\" data-title=\"\'scene type\'\" ng-bind=\"item.scene_type\"></td>\n        <td align=\"center\" data-title=\"\'最新编辑时间\'\" ng-bind=\"item.last_update_time\"></td>\n        <!-- <td align=\"center\" data-title=\"\'属性\'\" ng-bind=\"item.attribute\"></td>\n        <td align=\"center\" data-title=\"\'多样性控制方式（个数/占比）\'\" ng-bind=\"item.diversity_type\"></td>\n        <td align=\"center\" data-title=\"\'类别个数/占比上限\'\" ng-bind=\"item.upper_limit\"></td> -->\n\n      <td align=\"center\" data-title=\"\'操作\'\">\n        <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"modify(item.id)\">\n          <i class=\"glyphicon glyphicon-pencil\"></i> 编辑</button>&nbsp;\n        <button type=\"button\" class=\"btn btn-danger btn-flat\" ng-click=\"remove(item)\">\n          <i class=\"glyphicon glyphicon-trash\"></i> 删除</button>\n      </td>\n    </tr>\n  </table>\n</div>\n\n<script id=\"diversity-config-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/configManage/diversityConfig/item/item.html\'\"></div>\n    </div>\n</script>\n<ui-view></ui-view>");
$templateCache.put("src/module/configManage/relatedSuggestConfig/relatedSuggestConfig.html","<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"create()\">\n      <i class=\"glyphicon glyphicon-plus\"></i> 新建配置\n    </button>\n    <dg-search-input ng-model=\"searchStr\" search=\"search()\" placeholder=\"请输入指定的appid\"></dg-search-input>\n  </form>\n</div>\n<div class=\"box-body\">\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.appname\"></td>\n      <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n      <td align=\"center\" data-title=\"\'训练数据天数\'\" ng-bind=\"item.day_cnt\"></td>\n      <td align=\"center\" data-title=\"\'结果保存个数\'\" ng-bind=\"item.result_len\"></td>\n      <td align=\"center\" data-title=\"\'最新编辑时间\'\" ng-bind=\"item.last_update_time\"></td>\n      <!-- <td align=\"center\" data-title=\"\'weight\'\" ng-bind=\"item.weight\"></td>\n      <td align=\"center\" data-title=\"\'algmark\'\" ng-bind=\"item.alg_mark\"></td>\n      <td align=\"center\" data-title=\"\'user_max_op\'\" ng-bind=\"item.user_max_op\"></td>\n      <td align=\"center\" data-title=\"\'item_min_show\'\" ng-bind=\"item.item_min_show\"></td>\n      <td align=\"center\" data-title=\"\'min_item_pair_freq\'\" ng-bind=\"item.min_item_pair_freq\"></td>\n      <td align=\"center\" data-title=\"\'min_total_item_pair_cnt\'\" ng-bind=\"item.min_total_item_pair_cnt\"></td> -->\n      <!-- <td align=\"center\" data-title=\"\'day_cnt\'\" ng-bind=\"item.day_cnt\"></td>\n      <td align=\"center\" data-title=\"\'result_len\'\" ng-bind=\"item.result_len\"></td>\n      <td align=\"center\" data-title=\"\'expire_time\'\" ng-bind=\"item.expire_time\"></td> -->\n\n      <td align=\"center\" data-title=\"\'操作\'\">\n        <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"modify(item.id)\">\n          <i class=\"glyphicon glyphicon-pencil\"></i> 编辑</button>&nbsp;\n        <button type=\"button\" class=\"btn btn-danger btn-flat\" ng-click=\"remove(item)\">\n          <i class=\"glyphicon glyphicon-trash\"></i> 删除</button>\n      </td>\n    </tr>\n  </table>\n</div>\n\n<script id=\"related-suggest-config-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog relate-dialog\">\n        <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/configManage/relatedSuggestConfig/item/item.html\'\"></div>\n    </div>\n</script>\n<ui-view></ui-view>");
$templateCache.put("src/module/configManage/timeConfig/timeConfig.html","<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"create()\">\n      <i class=\"glyphicon glyphicon-plus\"></i> 新建配置\n    </button>\n    <dg-search-input ng-model=\"searchStr\" search=\"search()\" placeholder=\"请输入指定的appid\"></dg-search-input>\n  </form>\n</div>\n<div class=\"box-body\">\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.appname\"></td>\n        <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n        <td align=\"center\" data-title=\"\'推荐类型\'\" ng-bind=\"item.rec_type\"></td>\n        <td align=\"center\" data-title=\"\'scene type\'\" ng-bind=\"item.scene_type\"></td>\n        <td align=\"center\" data-title=\"\'最新编辑时间\'\" ng-bind=\"item.last_update_time\"></td>\n        <!-- <td align=\"center\" data-title=\"\'分类频道\'\" ng-bind=\"item.specify_cate\"></td>\n        <td align=\"center\" data-title=\"\'时效性策略\'\" ng-bind=\"item.timeliness_strategy\"></td> -->\n\n      <td align=\"center\" data-title=\"\'操作\'\">\n        <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"modify(item.id)\">\n          <i class=\"glyphicon glyphicon-pencil\"></i> 编辑</button>&nbsp;\n        <button type=\"button\" class=\"btn btn-danger btn-flat\" ng-click=\"remove(item)\">\n          <i class=\"glyphicon glyphicon-trash\"></i> 删除</button>\n      </td>\n    </tr>\n  </table>\n</div>\n\n<script id=\"time-config-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/configManage/timeConfig/item/item.html\'\"></div>\n    </div>\n</script>\n<ui-view></ui-view>");
$templateCache.put("src/module/contact/applyForTrialData/applyForTrialData.html","<div class=\"box\">\n  <div class=\"box-header\">\n    <form class=\"form-inline\">\n      <div style=\"margin-bottom: 10px\">\n        <span class=\"filter-list-label\">\n          <a ng-click=\"download()\" class=\"btn btn-primary btn-flat btn-sm\">\n            <i class=\"glyphicon glyphicon-arrow-down\"></i>下载表格\n          </a>\n        </span>\n        <div class=\"filter-list filter-list-inline-block\" ng-show=\"!isSeller()\">\n          <span class=\"filter-list-label\">渠道</span>\n          <div class=\"filter-list-button-group\">\n            <select class=\"form-control\" ng-model=\"searchValue.channel_id\" ng-change=\"search()\" select-convert-to-number>\n              <option value=\"0\">全部</option>\n              <option ng-value=\"key\" ng-bind=\"channel\" ng-repeat=\"(key, channel) in channelList\"></option>\n            </select>\n          </div>\n        </div>\n        <div class=\"filter-list filter-list-inline-block\">\n          <span class=\"filter-list-label\">负责人</span>\n          <div class=\"filter-list-button-group\">\n            <select ng-model=\"searchValue.manager_id\" class=\"form-control\" select-convert-to-number ng-change=\"search()\">\n              <option value=\"0\">全部</option>\n              <option ng-value=\"saler.user_id\" ng-repeat=\"saler in managers\" ng-bind=\"saler.user_nickname\"></option>\n            </select>\n          </div>\n        </div>\n        <dg-search-input ng-model=\"searchValue.keyword\" placeholder=\"请输关键词\" search=\"search()\" width=\"200px\"></dg-search-input>\n      </div>\n      <!-- <filter-group filter-list=\"contactUsMsgFilter\" search-value=\"searchValue\" search-func=\"search()\"></filter-group> -->\n    </form>\n  </div>\n  <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n    <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n      <tr ng-repeat=\"item in $data track by item.contact_us_msgid\">\n        <td data-title=\"\'序号\'\" ng-bind=\"item.contact_us_msgid\"></td>\n        <td data-title=\"\'创建时间\'\" ng-bind=\"item.create_time.substring(0,13) + \'时\'\"></td>\n        <td data-title=\"\'公司名称\'\" ng-bind=\"item.company_name\" class=\"must-wrap\"></td>\n        <!-- <td data-title=\"\'需要功能\'\">\n          <p\n            style=\"width: 150px\"\n            class=\"small\"\n            ng-repeat=\"config in contactUsMsgFilter.func.list track by $index\"\n            ng-if=\"config.name && item[config.value]\" ng-bind=\"config.name\">\n          </p>\n        </td> -->\n        <td data-title=\"\'渠道\'\">\n          <span ng-bind=\"Config.channel_id[item.channel_id]\"></span>\n          <span ng-show=\"item.remark\" ng-bind=\"item.remark.replace(\'其他\', \'\')\"></span>\n        </td>\n        <td data-title=\"\'渠道来源详情\'\" ng-bind=\"keywordReflect[item.keyword]\"></td>\n        <td data-title=\"\'ip\'\" ng-bind=\"item.ip\" class=\"must-wrap\"></td>\n        <td data-title=\"\'负责人\'\" ng-bind=\"Config.manager_id[item.manager_id]\"></td>\n      </tr>\n    </table>\n  </div>\n</div>");
$templateCache.put("src/module/contact/contact/contact.html","<div class=\"box\">\n  <div class=\"box-header\">\n    <form class=\"form-inline\">\n       <!-- <a href=\"{{download_url}}\" class=\"btn btn-primary\" target=\"_blank\">  -->\n      <a ng-click=\"download()\" class=\"btn btn-primary\">  \n        <i class=\"glyphicon glyphicon-arrow-down\"></i>下载表格\n      </a>\n      <div class=\"form-group\">\n        <label for=\"\">渠道</label>\n        <select class=\"form-control\" ng-model=\"channel\" ng-change=\"search()\" select-convert-to-number>\n          <option value=\"0\">全部</option>\n          <option ng-value=\"key\" ng-bind=\"channel\" ng-repeat=\"(key, channel) in channelList\"></option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"\">负责人</label>\n        <select class=\"form-control\" ng-model=\"manager\" ng-change=\"search()\" select-convert-to-number>\n          <option value=\"{{manager.user_id}}\" ng-bind=\"manager.user_nickname\" ng-repeat=\"manager in managers\"></option>  \n        </select>\n      </div>\n      <dg-search-input ng-model=\"companyName\" placeholder=\"请输关键词\" search=\"search()\" width=\"200px\"></dg-search-input>\n    </form>\n  </div>\n  <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n    <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n      <tr ng-repeat=\"item in $data track by item.contact_us_msgid\">\n        <td data-title=\"\'序号\'\" ng-bind=\"item.contact_us_msgid\" header-class=\"\'nowrap\'\"></td>\n        <td data-title=\"\'创建时间\'\" ng-bind=\"item.create_time.substring(0,13) + \'时\'\" class=\"nowrap\"></td>\n        <td data-title=\"\'电话\'\" ng-bind=\"item.tel\" class=\"nowrap\"></td>\n        <td data-title=\"\'公司名称\'\" class=\"special-width\" ng-bind=\"item.company_name\" class=\"nowrap\"></td>\n        <td data-title=\"\'渠道\'\" class=\"special-width\" class=\"nowrap\">\n          <span ng-bind=\"Config.channel_id[item.channel_id]\"></span><span ng-show=\"item.remark\" ng-bind=\"item.remark.replace(\'其他\', \'\')\"></span>\n        </td>\n        <td data-title=\"\'渠道来源详情\'\" class=\"special-width\" ng-bind=\"item.keyword\" class=\"nowrap\"></td>\n        <td data-title=\"\'ip\'\" ng-bind=\"item.ip\" class=\"nowrap\"></td>\n        <td data-title=\"\'留言\'\" class=\"special-width\" ng-bind=\"item.msg\">\n        </td>\n        <td data-title=\"\'职务\'\" ng-bind=\"item.job\">\n        </td>\n        <td data-title=\"\'负责人\'\" class=\"special-width\" class=\"nowrap\">\n          <span ng-show=\"!item.isEditing\" ng-bind=\"Config.manager_id[item.manager_id]\"></span>\n          <select ng-model=\"item.tempRemark\" ng-show=\"item.isEditing\" class=\"form-control\" select-convert-to-number>\n            <option value=\"0\">空</option>\n            <option ng-repeat=\"manager in managers\" value=\"{{manager.user_id}}\" ng-bind=\"manager.user_nickname\" ng-if=\"manager.user_id !== 0\"></option>\n          </select>\n        </td>\n        <td data-title=\"\'操作\'\" class=\"nowrap\">\n          <div style=\"width: 80px\">\n            <button class=\"btn btn-default btn-sm\" ng-if=\"!item.isEditing\" ng-click=\"modifyRemark(item); item.tmp.managerId = item.manager_id\">\n              <span class=\"glyphicon glyphicon-pencil\"></span>\n            </button>\n            <button class=\"btn btn-default btn-sm\" ng-if=\"item.isEditing\" ng-click=\"confirmRemark(item)\">\n              <span class=\"glyphicon glyphicon-ok\"></span>\n            </button>\n            <button class=\"btn btn-default btn-sm\" ng-if=\"item.isEditing\" ng-click=\"cancelRemark(item)\">\n              <span class=\"glyphicon glyphicon-remove\"></span>\n            </button>\n          </div>\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>");
$templateCache.put("src/module/contact/contactUsMsg/contactUsMsg.html","<div class=\"box\">\n  <div class=\"box-header\">\n    <form class=\"form-inline\">\n      <div style=\"margin-bottom: 10px\">\n        <div class=\"form-group\">\n          <label>负责人：</label>\n          <select ng-model=\"searchValue.manager_id\" class=\"form-control\" select-convert-to-number ng-change=\"search()\">\n            <option value=\"0\">全部</option>\n            <option ng-value=\"saler.user_id\" ng-repeat=\"saler in managers\" ng-bind=\"saler.user_nickname\"></option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label>渠道：</label>\n          <select ng-model=\"searchValue.channel_id\" class=\"form-control\" select-convert-to-number ng-change=\"search()\">\n            <option value=\"0\">全部</option>\n            <option ng-value=\"channel.id\" ng-repeat=\"channel in channels\" ng-bind=\"channel.name\"></option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"\">时间：</label>\n          <period-date-picker ng-model=\"filterDate\" disable-clear ng-change=\"search()\" disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n        </div>\n        <div class=\"form-group\">\n          <a ng-click=\"download()\" class=\"btn btn-primary btn-flat btn-sm\">\n            <i class=\"glyphicon glyphicon-arrow-down\"></i>下载表格\n          </a>\n        </div>\n        <dg-search-input ng-model=\"searchValue.keyword\" placeholder=\"请输关键词\" search=\"search()\" width=\"200px\"></dg-search-input>\n      </div>\n    </form>\n  </div>\n  <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n    <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n      <tr ng-repeat=\"item in $data track by item.contact_us_msgid\">\n        <td data-title=\"\'序号\'\" ng-bind=\"item.contact_us_msgid\"></td>\n        <td data-title=\"\'创建时间\'\" ng-bind=\"item.create_time.substring(0,13) + \'时\'\"></td>\n        <td data-title=\"\'公司名称\'\" ng-bind=\"item.company_name\" class=\"must-wrap\"></td>\n        <!-- <td data-title=\"\'姓名\'\" ng-bind=\"item.name\" class=\"must-wrap\"></td> -->\n        <td data-title=\"\'职务\'\" ng-bind=\"item.job\" class=\"must-wrap\"></td>\n        <td data-title=\"\'电话\'\" ng-bind=\"item.tel\" class=\"must-wrap\"></td>\n        <td data-title=\"\'邮箱\'\" ng-bind=\"item.email\" class=\"must-wrap\"></td>\n        <!-- <td data-title=\"\'需要功能\'\">\n          <p\n            style=\"width: 150px\"\n            class=\"small\"\n            ng-repeat=\"config in contactUsMsgFilter.func.list track by $index\"\n            ng-if=\"config.name && item[config.value]\" ng-bind=\"config.name\">\n          </p>\n        </td> -->\n        <!-- <td data-title=\"\'渠道\'\">\n          <span ng-bind=\"Config.channel_id[item.channel_id]\"></span>\n          <span\n            ng-show=\"item.remark\"\n            ng-bind=\"item.remark.replace(\'其他\', \'\')\"\n          ></span>\n        </td> -->\n        <td data-title=\"\'需求说明\'\" ng-bind=\"item.msg\" class=\"must-wrap\"></td>\n        <td data-title=\"\'地区\'\" ng-bind=\"item.area\"></td>\n        <td data-title=\"\'负责人\'\" class=\"nowrap\">\n          <span ng-show=\"!item.isEditing\" ng-bind=\"Config.manager_id[item.manager_id]\"></span>\n          <select ng-model=\"item.tmp.manager_id\" ng-show=\"item.isEditing\" class=\"form-control\" select-convert-to-number>\n            <option value=\"0\">空</option>\n            <option ng-repeat=\"manager in managers\" value=\"{{manager.user_id}}\" ng-bind=\"manager.user_nickname\" ng-if=\"manager.user_id !== 0\"></option>\n          </select>\n        </td>\n        <td data-title=\"\'操作\'\">\n          <button class=\"btn btn-default btn-sm\" ng-if=\"!item.isEditing\" ng-click=\"item.isEditing = true; item.tmp.manager_id = item.manager_id\">\n            <span class=\"glyphicon glyphicon-pencil\"></span>\n          </button>\n          <button class=\"btn btn-default btn-sm\" ng-if=\"item.isEditing\" ng-click=\"update(item)\">\n            <span class=\"glyphicon glyphicon-ok\"></span>\n          </button>\n          <button class=\"btn btn-default btn-sm\" ng-if=\"item.isEditing\" ng-click=\"item.isEditing = false; item.tmp.manager_id = item.manager_id\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n          </button>\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("src/module/contact/ucloud/ucloud.html","<div loading-container=\"tableParams.settings().$loading\" class=\"box-body\" table-bottom-scroll-bar scroll-box=\"$(this)\" table-bottom-scroll-bar-height=\"screen\">\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data track by item.id\">\n      <td data-title=\"\'注册时间\'\">{{item.register_time}}</td>\n      <td data-title=\"\'用户名称\'\">{{item.username}}</td>\n      <td data-title=\"\'密码\'\">{{item.pwd_tmp}}</td>\n      <td data-title=\"\'ucloudid\'\">{{item.description.UserId}}</td>\n      <td data-title=\"\'邮箱\'\">{{item.description.UserEmail}}</td>\n      <td data-title=\"\'手机号\'\">{{item.description.UserPhone}}</td>\n      <td data-title=\"\'昵称\'\">{{item.description.UserName}}</td>\n      <td data-title=\"\'公司名\'\">{{item.description.CompanyName}}</td>\n      <td data-title=\"\'用户地址\'\">{{item.description.UserAddress}}</td>\n    </tr>\n  </table>\n</div>");
$templateCache.put("src/module/corpusAnnotation/dialog/dialog.html","<div class=\"disable-modal-blur\"></div>\n<div class=\"modal-header\">\n  <dialog-close close=\"close()\"></dialog-close>\n  <h3 class=\"modal-title\">标注</h3>\n</div>\n<div class=\"modal-body\">\n  <!--edit from-->\n  <form role=\"form\" name=\"nlpEditForm\">\n    <div class=\"form-group\">\n      <label>文本</label>\n      <div class=\"form-control autoheight\">\n        <p ng-bind=\"item.content\"></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"nlp-edit-text\">人工审核：分词</label>\n      <div class=\"manual-review\">\n        <p class=\"pos-editor\" ng-model=\"manualReview.origin\" contenteditable=\"true\"></p>\n      </div>\n      <p class=\"help-block\">使用空格分割分词，使用<span class=\"text-red\">英文输入法输入</span>中括号标注大粒度分词，例：[中华 人民 共和国]</p>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"nlp-edit-text\">专有名词提取：人名</label>\n      <div class=\"manual-review\">\n        <div class=\"manual-review-box\">\n          <span class=\"word-segmentation pos-nr {{isSpace(i.word)}}\" ng-repeat=\"i in manualReview.personEachWordList track by $index\" ng-bind=\"i.word\"></span>\n        </div>\n        <textarea class=\"form-control height-auto\" placeholder=\"输入文本中的人名，使用空格分割不同人名\" ng-model=\"manualReview.person\"></textarea>\n\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"nlp-edit-text\">专有名词提取：地名</label>\n      <div class=\"manual-review\">\n        <div class=\"manual-review-box\">\n          <span class=\"word-segmentation pos-ns {{isSpace(i.word)}}\" ng-repeat=\"i in manualReview.locationEachWordList track by $index\" ng-bind=\"i.word\"></span>\n        </div>\n        <textarea class=\"form-control height-auto\" placeholder=\"输入文本中的地名，使用空格分割不同地名\" ng-model=\"manualReview.location\"></textarea>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"nlp-edit-text\">专有名词提取：机构团体名</label>\n      <div class=\"manual-review\">\n        <div class=\"manual-review-box\">\n          <span class=\"word-segmentation pos-nt {{isSpace(i.word)}}\" ng-repeat=\"i in manualReview.organizationEachWordList track by $index\" ng-bind=\"i.word\"></span>\n        </div>\n        <textarea class=\"form-control height-auto\" placeholder=\"输入文本中的机构团体名，使用空格分割不同机构团体名\" ng-model=\"manualReview.organization\"></textarea>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"nlp-edit-text\">专有名词提取：其他专有名词</label>\n      <div class=\"manual-review\">\n        <div class=\"manual-review-box\">\n          <span class=\"word-segmentation pos-other {{isSpace(i.word)}}\" ng-repeat=\"i in manualReview.otherEachWordList track by $index\" ng-bind=\"i.word\"></span>\n        </div>\n        <textarea class=\"form-control height-auto\" placeholder=\"输入文本中的其他专有名词，使用空格分割不同专有名词\" ng-model=\"manualReview.other\"></textarea>\n      </div>\n    </div>\n    <div class=\"text-center\">\n      <dialog-cancel-button cancel=\"close()\"></dialog-cancel-button>\n      <dialog-confirm-button confirm=\"update()\"></dialog-confirm-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("src/module/crawl/statistics/statistics.html","<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <date-picker ng-model=\"date\" ng-change=\"search()\" disable-clear></date-picker>\n    <dg-search-input ng-model=\"app_name\" search=\"search()\" placeholder=\"appname\"></dg-search-input>\n  </form>\n</div>\n<div class=\"box-body\">\n  <div class=\"text\" ng-show=\"record.num_pub > -1 && record.num_article > -1\">共抓取公众号<span ng-bind=\"record.num_pub\"></span>个，抓取文章<span ng-bind=\"record.num_article\"></span>篇</div>\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td align=\"center\" data-title=\"\'序号\'\" ng-bind=\"$index + 1\" class=\"number\"></td>\n      <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\" class=\"number\"></td>\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.app_name\" class=\"number\"></td>\n      <td align=\"center\" data-title=\"\'订阅公众号数量\'\" ng-bind=\"item.num_sub\" sortable=\"\'num_sub\'\" class=\"number\"></td>\n      <td align=\"center\" data-title=\"\'抓取公众号数量\'\" ng-bind=\"item.num_catch\" sortable=\"\'num_catch\'\" class=\"number\"></td>\n      <td align=\"center\" data-title=\"\'抓取文章数量\'\" ng-bind=\"item.num_item\" sortable=\"\'num_item\'\" class=\"number\"></td>\n      <td align=\"center\" data-title=\"\'平均每个公众号抓取文章数量\'\" ng-bind=\"item.num_average\" class=\"number\"></td>\n    </tr>\n  </table>\n</div>");
$templateCache.put("src/module/dataUpReport/appProductUpReport/appProductUpReport.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n      <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n        <fieldset class=\"mt-sm\">\n          <div class=\"row state-switch-button-groups\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-5 control-label\">report_num/item_num：</label>\n                <div class=\"col-xs-7\">\n                  <span class=\"btn\" ng-class=\"params.numState == \'report_num\' ? \'active\' : \'\' \" ng-click=\"params.numState = \'report_num\'; search()\">report_num</span>\n                  <sapn class=\"btn\" ng-class=\"params.numState == \'item_num\' ? \'active\' : \'\' \" ng-click=\"params.numState = \'item_num\'; search()\">item_num：\n                </sapn></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-5 control-label\">data_time：</label>\n                <div class=\"col-xs-7\">\n                  <period-date-picker ng-model=\"filterDate\" disable-clear disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n                </div>\n              </div>\n            </div>\n          </div>\n  \n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-5 control-label\">appname：</label>\n                <div class=\"col-xs-7\">\n                  <div class=\"per63\">\n                    <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                  </div>\n                </div>\n              </div>\n            </div>\n  \n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-3 control-label\">appid：</label>\n                <div class=\"col-xs-8 per58\">\n                  <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row text-center\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n          </div>\n        </fieldset>\n  \n        <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n          <legend class=\"section\"></legend>\n          <div class=\"col-xs-12 box-body\" loading-container=\"ngTableParams.settings().$loading\">\n            <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n              <tr ng-repeat=\"item in $data track by $index\">\n                <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\" width=\"18%\"></td>\n                <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\" width=\"18%\"></td>\n                <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\" width=\"18%\"></td>\n                <td data-title=\"getDynamicTitle()\" sortable=\"getDynamicTitle()\" align=\"center\" ng-bind=\"item[getDynamicTitle()]\" width=\"16%\"></td>\n                <td data-title=\"\'online\'\" sortable=\"\'online\'\" align=\"center\" ng-bind=\"item.online\" width=\"15%\"></td>\n                <td data-title=\"\'offline\'\" sortable=\"\'offline\'\" align=\"center\" ng-bind=\"item.offline\" width=\"15%\"></td>\n              </tr>\n            </table>\n          </div>\n        </fieldset>\n      </form>\n    </div>\n  </div>");
$templateCache.put("src/module/dataUpReport/dayActionUpReport/dayActionUpReport.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n      <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n        <fieldset class=\"mt-sm\">\n          <div class=\"row state-switch-button-groups\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">action_type：</label>\n                <div class=\"col-xs-6\">\n                  <span class=\"btn\" ng-class=\"params.actionType == \'total\' ? \'active\' : \'\' \" ng-click=\"params.actionType = \'total\'; search()\">total</span>\n                  <sapn class=\"btn\" ng-class=\"params.actionType == \'specific\' ? \'active\' : \'\' \" ng-click=\"params.actionType = \'specific\'; search()\">具体行为类型\n                </sapn></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">data_time：</label>\n                <div class=\"col-xs-8\">\n                  <period-date-picker ng-model=\"filterDate\" disable-clear disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n                </div>\n              </div>\n            </div>\n          </div>\n  \n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">appname：</label>\n                <div class=\"col-xs-7\">\n                  <div class=\"per63\">\n                    <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                  </div>\n                </div>\n              </div>\n            </div>\n  \n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-3 control-label\">appid：</label>\n                <div class=\"col-xs-8 per58\">\n                  <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row text-center\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n          </div>\n        </fieldset>\n  \n        <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n          <legend class=\"section\"></legend>\n          <div class=\"col-xs-12\">\n            <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n              <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                <tr ng-repeat=\"item in $data track by $index\">\n                  <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                  <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                  <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                  <td data-title=\"\'action_type\'\" align=\"center\" ng-bind=\"item.action_type\"></td>\n                  <td data-title=\"\'report_num\'\" sortable=\"\'report_num\'\" align=\"center\" ng-bind=\"item.report_num\"></td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </fieldset>\n      </form>\n    </div>\n  </div>");
$templateCache.put("src/module/dataUpReport/hourlyActionUpReport/hourlyActionUpReport.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n      <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n        <fieldset class=\"mt-sm\">\n          <div class=\"row state-switch-button-groups\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">action_type：</label>\n                <div class=\"col-xs-6\">\n                  <span class=\"btn\" ng-class=\"params.actionType == \'total\' ? \'active\' : \'\' \" ng-click=\"params.actionType = \'total\'; search()\">total</span>\n                  <sapn class=\"btn\" ng-class=\"params.actionType == \'specific\' ? \'active\' : \'\' \" ng-click=\"params.actionType = \'specific\'; search()\">具体行为类型\n                </sapn></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">data_time：</label>\n                <div class=\"col-xs-8\">\n                  <period-date-picker ng-model=\"filterDate\" disable-clear disable-today completion-time></period-date-picker>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-xs-12 col-sm-5\">\n                <div class=\"form-group\">\n                  <label class=\"col-xs-3 control-label\">hour：</label>\n                  <div class=\"col-xs-7\">\n                    <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.hour_ori\">\n                  </div>\n                </div>\n              </div>\n          </div>\n  \n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">appname：</label>\n                <div class=\"col-xs-8\">\n                  <div class=\"per63\">\n                    <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                  </div>\n                </div>\n              </div>\n            </div>\n  \n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-3 control-label\">appid：</label>\n                <div class=\"col-xs-8 per58\">\n                  <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                </div>\n              </div>\n            </div>\n          </div>\n  \n          <div class=\"row text-center\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n          </div>\n        </fieldset>\n  \n        <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n          <legend class=\"section\"></legend>\n          <div class=\"col-xs-12\">\n            <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n              <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                <tr ng-repeat=\"item in $data track by $index\">\n                  <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                  <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                  <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                  <td data-title=\"\'hour\'\" sortable=\"\'hour\'\" align=\"center\" ng-bind=\"item.hour\"></td>\n                  <td data-title=\"\'action_type\'\" align=\"center\" ng-bind=\"item.action_type\"></td>\n                  <td data-title=\"\'report_num\'\" sortable=\"\'report_num\'\" align=\"center\" ng-bind=\"item.report_num\"></td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </fieldset>\n      </form>\n    </div>\n  </div>");
$templateCache.put("src/module/dataUpReport/totalActionUpReport/totalActionUpReport.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n      <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n        <fieldset class=\"mt-sm\">\n          <div class=\"row state-switch-button-groups\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">统计口径：</label>\n                <div class=\"col-xs-6\">\n                  <span class=\"btn\" ng-class=\"params.statisticCaliber == \'day\' ? \'active\' : \'\' \" ng-click=\"params.statisticCaliber = \'day\'; search()\">天级</span>\n                  <sapn class=\"btn\" ng-class=\"params.statisticCaliber == \'hourly\' ? \'active\' : \'\' \" ng-click=\"params.statisticCaliber = \'hourly\'; search()\">小时级\n                </sapn></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">data_time：</label>\n                <div class=\"col-xs-8\">\n                  <period-date-picker ng-model=\"filterDate\" disable-clear disable-today completion-time></period-date-picker>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-3 control-label\">hour：</label>\n                <div class=\"col-xs-7 per62\">\n                  <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.hour_ori\">\n                </div>\n              </div>\n            </div>\n          </div>\n          \n  \n          <div class=\"row text-center\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n          </div>\n        </fieldset>\n  \n        <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n          <legend class=\"section\"></legend>\n          <div class=\"col-xs-12\">\n            <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n              <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                <tr ng-repeat=\"item in $data track by $index\">\n                  <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                  <td data-title=\"\'hour\'\" align=\"center\" ng-if=\"newColumns.length\" sortable=\"\'hour\'\" ng-repeat=\"newColumn in newColumns\" ng-bind=\"item.hour\"></td>\n                  <td data-title=\"\'report_num\'\" align=\"center\" ng-bind=\"item.report_num\"></td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </fieldset>\n      </form>\n    </div>\n  </div>");
$templateCache.put("src/module/dataUpReport/totalProductUpReport/totalProductUpReport.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n      <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n        <fieldset class=\"mt-sm\">\n          <div class=\"row state-switch-button-groups\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-5 control-label\">report_num/item_num：</label>\n                <div class=\"col-xs-7\">\n                  <span class=\"btn\" ng-class=\"params.numState == \'report_num\' ? \'active\' : \'\' \" ng-click=\"params.numState = \'report_num\'; update()\">report_num</span>\n                  <sapn class=\"btn\" ng-class=\"params.numState == \'item_num\' ? \'active\' : \'\' \" ng-click=\"params.numState = \'item_num\'; update()\">item_num\n                </sapn></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-5 control-label\">data_time：</label>\n                <div class=\"col-xs-7\">\n                  <period-date-picker ng-model=\"filterDate\" disable-clear disable-today ng-change=\"update()\" completion-time></period-date-picker>\n                </div>\n              </div>\n            </div>\n          </div>\n        </fieldset>\n  \n        <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n          <legend class=\"section\"></legend>\n          <div class=\"col-xs-12\" loading-container=\"ngTableParams.settings().$loading\">\n            <div class=\"box-body\">\n              <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                <tr ng-repeat=\"item in $data track by $index\">\n                  <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\" width=\"25%\"></td>\n                  <td data-title=\"getDynamicTitle()\" align=\"center\" ng-bind=\"item[getDynamicTitle()]\" width=\"25%\"></td>\n                  <td data-title=\"\'online\'\" align=\"center\" ng-bind=\"item.online\" width=\"25%\"></td>\n                  <td data-title=\"\'offline\'\" align=\"center\" ng-bind=\"item.offline\" width=\"25%\"></td>\n                </tr>\n              </table>\n            </div>\n            \n          </div>\n        </fieldset>\n      </form>\n    </div>\n  </div>");
$templateCache.put("src/module/management/advanced/advanced.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    基础权限\n    <small>用户管理</small>\n  </h2>\n</section>\n<section class=\"content\">\n  <div class=\"box\">\n    <div class=\"box-header\">\n      <form class=\"form-inline\">\n        <a class=\"btn btn-primary btn-sm\" ng-click=\"create()\">\n          <span class=\"glyphicon glyphicon-plus\"></span> 新建用户\n        </a>\n        <div class=\"form-group\">\n          <label>状态：</label>\n          <select ng-model=\"search.isOnline\" class=\"form-control\" select-convert-to-number ng-change=\"reload()\">\n            <option value=\"1\">启用</option>\n            <option value=\"0\">禁用</option>\n            <option value=\"2\">全部</option>\n          </select>\n        </div>\n        <dg-search-input ng-model=\"search.nickname\" placeholder=\"请输入用户关键字\" search=\"reload()\"></dg-search-input>\n      </form>\n    </div>\n    <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\" fixed-table-header>\n      共{{number}}个用户\n      <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <!--<tr ng-repeat=\"item in $data | orderBy: \'-create_time\'\" ui-sref=\"management.advanced.item({id: item.admin_staffid})\" ng-show=\"showItem(item)\">-->\n        <tr ng-repeat=\"item in $data\" ui-sref=\"management.advanced.item({id: item.admin_staffid})\">\n          <td data-title=\"\'序号\'\" ng-bind=\"item.admin_staffid\" class=\"text-align-left\"></td>\n          <td data-title=\"\'用户\'\" ng-bind=\"item.nickname\" class=\"text-align-left\"></td>\n          <td data-title=\"\'登录账号\'\" ng-bind=\"item.login_name\" class=\"text-align-left\"></td>\n          <td data-title=\"\'状态\'\" ng-bind=\"!item.is_online | disabled\" class=\"text-align-center\"></td>\n          <td data-title=\"\'手机号\'\" ng-bind=\"item.tel\" class=\"text-align-center\"></td>\n          <td data-title=\"\'创建时间\'\" ng-bind=\"item.create_time | limitTo: 10\" class=\"text-align-center\"></td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>\n<ui-view></ui-view>");
$templateCache.put("src/module/management/channel/channel.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    基础权限\n    <small>渠道管理</small>\n  </h2>\n</section>\n<section class=\"content channel\">\n  <div class=\"box\">\n    <div class=\"box-header\">\n      <a class=\"btn btn-primary btn-sm\" ng-click=\"create()\">\n        <span class=\"glyphicon glyphicon-plus\"></span> 新建渠道\n      </a>\n    </div>\n    <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\" fixed-table-header>\n      <table class=\"table table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\">\n          <td data-title=\"\'序号\'\" ng-bind=\"item.id\" class=\"text-align-center id\"></td>\n          <td data-title=\"\'渠道\'\" class=\"text-align-left\" header-class=\"\'text-algin-left\'\">\n            <span ng-bind=\"item.name\" ng-hide=\"item.show\"></span>\n            <input class=\"form-control\" type=\"text\" ng-show=\"item.show\" ng-model=\"item.newName\" ng-init=\"item.newName = item.name\">\n          </td>\n          <td data-title=\"\'状态\'\" ng-bind=\"item.is_del | disabled\" class=\"text-align-center\"></td>\n          <td data-title=\"\'操作\'\" class=\"text-center\">\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"toggleItemShow(item)\" ng-hide=\"item.show\">\n              <i class=\"fa fa-pencil-square-o\"></i> 编辑\n            </button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"disableItem(item, 0)\" ng-show=\"!item.show && item.is_del == 1\">\n              <i class=\"glyphicon glyphicon-ok\"></i> 启用\n            </button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"disableItem(item, 1)\" ng-show=\"!item.show && item.is_del == 0\">\n              <i class=\"glyphicon glyphicon-remove\"></i> 禁用\n            </button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-show=\"item.show\" ng-click=\"update(item, \'修改成功\')\">\n              <i class=\"fa fa-floppy-o\"></i> 保存\n            </button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-show=\"item.show\" ng-click=\"cancel(item)\">\n              <i class=\"fa fa-ban\"></i> 取消\n            </button>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>\n<!--nlp dialog ng-template-->\n<script id=\"channel-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\" ng-include=\"\'src/module/management/channel/dialog/dialog.html\'\"></div>\n  </div>\n</script>");
$templateCache.put("src/module/management/industry/industry.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    基础权限\n    <small>行业管理</small>\n  </h2>\n</section>\n<section class=\"content channel\">\n  <div class=\"box\">\n    <div class=\"box-header\">\n      <a class=\"btn btn-primary btn-sm\" ng-click=\"create()\">\n        <span class=\"glyphicon glyphicon-plus\"></span> 新建行业\n      </a>\n    </div>\n    <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\" fixed-table-header>\n      <table class=\"table table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\">\n          <td data-title=\"\'序号\'\" ng-bind=\"item.id\" class=\"text-align-center id\"></td>\n          <td data-title=\"\'行业\'\" class=\"text-align-left\" header-class=\"\'text-algin-left\'\">\n            <span ng-bind=\"item.name\" ng-hide=\"item.show\"></span>\n            <input class=\"form-control\" type=\"text\" ng-show=\"item.show\" ng-model=\"item.newName\" ng-init=\"item.newName = item.name\">\n          </td>\n          <td data-title=\"\'状态\'\" ng-bind=\"!item.status | disabled\" class=\"text-align-center\"></td>\n          <td data-title=\"\'操作\'\" class=\"text-center\">\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"toggleItemShow(item)\" ng-hide=\"item.show\">\n              <i class=\"fa fa-pencil-square-o\"></i> 编辑\n            </button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"disableItem(item, 1)\" ng-show=\"!item.show && item.status === 0\">\n              <i class=\"glyphicon glyphicon-ok\"></i> 启用\n            </button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"disableItem(item, 0)\" ng-show=\"!item.show && item.status === 1\">\n              <i class=\"glyphicon glyphicon-remove\"></i> 禁用\n            </button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-show=\"item.show\" ng-click=\"update(item, \'修改成功\')\">\n              <i class=\"fa fa-floppy-o\"></i> 保存\n            </button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-show=\"item.show\" ng-click=\"cancel(item)\">\n              <i class=\"fa fa-ban\"></i> 取消\n            </button>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>\n<!--nlp dialog ng-template-->\n<script id=\"industry-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\" ng-include=\"\'src/module/management/industry/dialog/dialog.html\'\"></div>\n  </div>\n</script>");
$templateCache.put("src/module/management/mailTemplate/mailTemplate.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    基础权限\n    <small>邮件模板管理</small>\n  </h2>\n</section>\n<section class=\"content channel\">\n  <div class=\"box\">\n    <div class=\"box-header\">\n      <a class=\"btn btn-primary btn-sm btn-flat\" ng-click=\"edit()\">\n        <span class=\"glyphicon glyphicon-plus\"></span> 新建模板\n      </a>\n    </div>\n    <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\" fixed-table-header>\n      <table class=\"table table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\">\n          <td data-title=\"\'序号\'\" ng-bind=\"item.id\" class=\"text-align-center id\"></td>\n          <td data-title=\"\'名称\'\" class=\"text-align-left\" header-class=\"\'text-algin-left\'\" ng-bind=\"item.name\"></td>\n          <td data-title=\"\'操作\'\" class=\"text-center\" width=\"40\">\n            <button type=\"button\" class=\"btn btn-primary btn-sm btn-flat\" ng-click=\"edit(item.id)\">\n              <i class=\"fa fa-pencil-square-o\"></i> 编辑\n            </button>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>\n\n<!--nlp dialog ng-template-->\n<script id=\"mail-template-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/management/mailTemplate/dialog/dialog.html\'\"></div>\n  </div>\n</script>");
$templateCache.put("src/module/management/menu/menu.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    基础权限\n    <small>菜单管理</small>\n  </h2>\n</section>\n<section class=\"content\">\n  <div class=\"box\">\n    <div class=\"box-header clearfix\">\n      <h3 class=\"box-title\"></h3>\n      <div class=\"box-tools pull-right\">\n        <button type=\"button\" class=\"btn btn-box-tool\" role=\"button\" ng-click=\"edit({type: \'create\', list: menu})\" ng-disabled=\"!menu\">\n          <i class=\"fa fa-plus\"></i>\n          <span>新建菜单</span>\n        </button>\n        <button type=\"button\" class=\"btn btn-box-tool\" role=\"button\" ng-click=\"toggleAllOpen()\" ng-disabled=\"!menu\">\n          <i class=\"fa\" ng-class=\"{\'fa-angle-double-down\': !allOpen, \'fa-angle-double-up\': allOpen}\"></i>\n          <span ng-bind=\"!allOpen ? \'全部展开\' : \'全部折叠\'\">全部展开</span>\n        </button>\n        <button type=\"button\" class=\"btn btn-box-tool\" role=\"button\" ng-click=\"recovery(list.type)\">\n          <i class=\"fa fa-undo\"></i>\n          <span>复原</span>\n        </button>\n      </div>\n    </div>\n    <div class=\"box-body\">\n      <tree list=\"menu\" name=\"\'name\'\" level=\"level\" callbacks=\"treeConfig.callbacks\" child-name=\"\'menu_list\'\"></tree>\n    </div>\n    <div class=\"box-footer\">\n      <a class=\"btn btn-primary btn-flat\" ng-click=\"save()\">保存</a>\n    </div>\n  </div>\n</section>\n\n<!--menu dialog ng-template-->\n<script id=\"menu-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/management/menu/dialog/dialog.html\'\"></div>\n  </div>\n</script>");
$templateCache.put("src/module/management/resource/resource.html","<section class=\"content-header\">\n<h2 class=\"page-title\">\n  基础权限\n  <small>资源管理</small>\n</h2>\n</section>\n<div class=\"col-md-12\">\n  <div class=\"tab-content\">\n    <div class=\"tab-pane active clearfix\">\n      <div class=\"box\" ui-view></div>\n    </div>\n  </div>\n</div>");
$templateCache.put("src/module/management/role/role.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    基础权限\n    <small>角色管理</small>\n  </h2>\n</section>\n<section class=\"content\">\n  <div class=\"box\">\n    <div class=\"box-header\">\n      <a class=\"btn btn-primary btn-sm\" ng-click=\"create()\">\n        <span class=\"glyphicon glyphicon-plus\"></span> 新建角色\n      </a>\n    </div>\n    <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\" fixed-table-header>\n      <table class=\"table table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\" ui-sref=\"management.role.item({id: item.role_id})\">\n          <td data-title=\"\'序号\'\" ng-bind=\"item.role_id\" class=\"text-align-center\"></td>\n          <td data-title=\"\'角色\'\" ng-bind=\"item.role_name\" class=\"text-align-left\" header-class=\"\'text-algin-left\'\"></td>\n          <td data-title=\"\'状态\'\" ng-bind=\"item.status | status\" class=\"text-align-center\"></td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>\n<ui-view></ui-view>");
$templateCache.put("src/module/management/user/user.html","<h2 class=\"page-title\">\n  基础权限\n  <small>用户管理</small>\n</h2>\n<section class=\"widget\">\n  <header>\n    <div class=\"well\">\n      <a class=\"btn btn-primary btn-sm\" ng-click=\"create()\">\n        <span class=\"glyphicon glyphicon-plus\"></span> 新建账号\n      </a>\n    </div>\n  </header>\n  <div loading-container=\"tableParams.settings().$loading\" class=\"body\">\n    <table class=\"table table-hover\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n      <tr ng-repeat=\"item in $data\" ui-sref=\"management.user.item({id: item.admin_staffid})\">\n        <td data-title=\"\'创建时间\'\" ng-bind=\"item.create_time | limitTo: 10\" class=\"text-align-center\"></td>\n        <td data-title=\"\'登录名\'\" ng-bind=\"item.login_name\" class=\"text-align-left\"></td>\n        <td data-title=\"\'昵称\'\" ng-bind=\"item.nickname\" class=\"text-align-left\"></td>\n        <td data-title=\"\'状态\'\" ng-bind=\"!item.is_online | disabled\" class=\"text-align-center\"></td>\n      </tr>\n    </table>\n  </div>\n</section>\n<ui-view></ui-view>");
$templateCache.put("src/module/nlp/dialog/dialog.html","<div class=\"modal-header\">\n  <dialog-close close=\"close()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"title\"></h3>\n</div>\n<div class=\"modal-body\">\n  <!--create form-->\n  <div ng-show=\"isCreate\">\n    <form role=\"form\" ng-hide=\"showPOS\" name=\"nlpCreateForm\">\n      <div class=\"form-group\">\n        <label for=\"nlp-create-text\">文本</label>\n        <textarea class=\"form-control\" placeholder=\"输入文本\" id=\"nlp-create-text\" ng-model=\"nlpCreateFrom.content\"></textarea>\n      </div>\n      <div class=\"text-center\">\n        <dialog-cancel-button cancel=\"close()\"></dialog-cancel-button>\n        <dialog-confirm-button text=\"分词结果\" confirm=\"POSPreview()\"></dialog-confirm-button>\n      </div>\n    </form>\n    <!--POS Preview-->\n    <form role=\"form\" ng-show=\"showPOS\">\n      <div class=\"form-group\">\n        <label for=\"nlp-create-text\">文本</label>\n        <div class=\"form-control autoheight\">\n          <p ng-bind=\"nlpCreateFrom.content\"></p>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"nlp-create-text\">机器分词</label>\n        <div class=\"form-control autoheight\">\n          <span class=\"word-segmentation\" ng-repeat=\"word in wordPOSPreview track by $index\" ng-class=\"word.pos | NLPPOS\" ng-bind=\"word.word\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <ng-include src=\"\'src/common/wordPOSExample.html\'\"></ng-include>\n      </div>\n      <div class=\"text-center\">\n        <dialog-cancel-button cancel=\"close()\"></dialog-cancel-button>\n        <dialog-confirm-button confirm=\"create()\"></dialog-confirm-button>\n      </div>\n    </form>\n  </div>\n  <!--edit from-->\n  <form role=\"form\" ng-hide=\"isCreate\" name=\"nlpEditForm\" ng-submit=\"update()\">\n    <div class=\"form-group\">\n      <label>文本</label>\n      <div class=\"form-control autoheight\">\n        <p ng-bind=\"item.content\"></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label>机器分词</label>\n      <div class=\"form-control machine-box clearfix autoheight\" ng-show=\"item.type == \'pos\'\">\n        <span class=\"word-segmentation {{i.pos | NLPPOS}}\" ng-repeat=\"i in machineReview track by $index\" ng-bind=\"i.word\" ng-class=\"{\'isSpace\': i.word == \' \'}\"></span>\n      </div>\n      <div class=\"form-control machine-box clearfix autoheight\" ng-show=\"item.type == \'seg\'\">\n        <span class=\"word-segmentation\" ng-repeat=\"i in machineReview track by $index\" ng-bind=\"i.word\" ng-class=\"{\'isSpace\': i.word == \' \'}\"></span>\n      </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"item.type == \'seg\'\">\n      <label for=\"nlp-edit-text\">人工审核：分词</label>\n      <div class=\"manual-review\">\n        <div class=\"manual-review-box\">\n          <span class=\"word-segmentation {{isSpace(i.word)}}\" ng-repeat=\"i in manualReview.eachWordList track by $index\" ng-bind=\"i.word\" ng-class=\"{\'not-break\': manualReview.origin.split(\' \').length < 2}\"></span>\n        </div>\n        <textarea class=\"form-control\" placeholder=\"请输入文本\" id=\"nlp-edit-text\" ng-model=\"manualReview.origin\"></textarea>\n      </div>\n      <p class=\"help-block\">使用空格分割分词</p>\n    </div>\n    <div class=\"form-group\" ng-show=\"item.type == \'pos\'\">\n      <label for=\"nlp-edit-text\">人工审核：词性</label>\n      <div class=\"machine-box form-control autoheight\">\n        <span uib-dropdown ng-repeat=\"word in updatePOS track by $index\">\n          <a uib-dropdown-toggle class=\"word-segmentation {{word.pos | NLPPOS}}\" ng-bind=\"word.word\" ng-click=\"word.show = !word.show\" ng-class=\"{\'top-zindex\': word.show}\"></a>\n          <div class=\"full-screen-mask\" ng-show=\"word.show\" ng-click=\"word.show = !word.show\"></div>\n          <ul class=\"uib-dropdown-menu choose-pos\" ng-click=\"word.show = !word.show\">\n            <a ng-click=\"word.pos = \'n\'\" class=\"pos-n nowrap\">名词</a>\n            <a ng-click=\"word.pos = \'nr\'\" class=\"pos-nr nowrap\">人名</a>\n            <a ng-click=\"word.pos = \'ns\'\" class=\"pos-ns nowrap\">地名</a>\n            <a ng-click=\"word.pos = \'nt\'\" class=\"pos-nt nowrap\">机构团体名</a>\n            <a ng-click=\"word.pos = \'t\'\" class=\"pos-t nowrap\">时间词</a>\n            <a ng-click=\"word.pos = \'v\'\" class=\"pos-v nowrap\">动词</a>\n            <a ng-click=\"word.pos = \'a\'\" class=\"pos-a nowrap\">形容词</a>\n            <a ng-click=\"word.pos = \'m\'\" class=\"pos-m nowrap\">数词</a>\n            <a ng-click=\"word.pos = \'o\'\" class=\"pos-o nowrap\">其他/默认</a>\n          </ul>\n        </span>\n      </div>\n      <div class=\"form-group\">\n        <ng-include src=\"\'src/common/wordPOSExample.html\'\"></ng-include>\n      </div>\n    </div>\n    <div class=\"text-center\">\n      <dialog-cancel-button cancel=\"close()\"></dialog-cancel-button>\n      <dialog-confirm-button></dialog-confirm-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("src/module/offline/data/data.html","<div class=\"box-header\">\n    <div class=\"row\">\n        <div class=\"col-xs-12 col-sm-3\">\n            <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">requestid：</label>\n                <div class=\"col-xs-8\">\n                    <dg-search-input class=\"custom-search-input\" ng-model=\"requestid\" search=\"search()\" placeholder=\"requestid\"></dg-search-input>\n\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12 col-sm-3\">\n            <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">appname：</label>\n                <div class=\"col-xs-8\">\n                    <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-xs-12 col-sm-3\">\n            <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">appid：</label>\n                <div class=\"col-xs-8\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12 col-sm-3\">\n            <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">date：</label>\n                <div class=\"col-xs-8\">\n                    <period-date-picker ng-model=\"filterDate\" disable-clear disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n                </div>\n            </div>\n        </div>\n    </div>\n    <filter-group filter-list=\"alarmFilter\" search-value=\"searchValue\" search-func=\"search()\">\n    </filter-group>\n</div>\n\n\n<div class=\"box-body\">\n    <div class=\"box-header\">\n        <button class=\"btn btn-primary btn-flat\" ng-click=\"start()\">\n            启动importer\n        </button>\n    </div>\n\n    <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\">\n            <td align=\"center\" data-title=\"\'requestid\'\" ng-bind=\"item.requestid\"></td>\n            <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n            <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n            <td align=\"center\" data-title=\"\'mode\'\" ng-bind=\"item.date\"></td>\n            <td align=\"center\" data-title=\"\'item_info\'\" ng-bind=\"item.item_info\"></td>\n            <td align=\"center\" data-title=\"\'user_item\'\" ng-bind=\"item.user_item\"></td>\n            <td align=\"center\" data-title=\"\'create_time\'\" ng-bind=\"item.create_time\"></td>\n            <td align=\"center\" data-title=\"\'last_update_time\'\" ng-bind=\"item.last_update_time\"></td>\n            <td align=\"center\" data-title=\"\'status\'\" ng-bind=\"item.status\"></td>\n        </tr>\n    </table>\n</div>\n<script id=\"offline-data-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/offline/data/item/item.html\'\"></div>\n    </div>\n  </script>\n<ui-view></ui-view>");
$templateCache.put("src/module/offline/hot/hot.html","<div class=\"box-header\">\n\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-3\">\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">requestid：</label>\n        <div class=\"col-xs-8\">\n            <dg-search-input class=\"custom-search-input\" ng-model=\"requestid\" search=\"search()\" placeholder=\"requestid\"></dg-search-input>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-3\">\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">appname：</label>\n        <div class=\"col-xs-8\">\n          <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-sm-3\">\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">appid：</label>\n        <div class=\"col-xs-8\">\n          <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n        </div>\n      </div>\n    </div>\n  </div>\n  <filter-group filter-list=\"alarmFilter\" search-value=\"searchValue\" search-func=\"search()\">\n  </filter-group>\n\n\n</div>\n<div class=\"box-body\">\n  <div class=\"box-header\">\n    <button class=\"btn btn-primary btn-flat\" ng-click=\"start()\">\n      启动热门推荐\n    </button>\n  </div>\n\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td align=\"center\" data-title=\"\'requestid\'\" ng-bind=\"item.requestid\"></td>\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n      <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n      <td align=\"center\" data-title=\"\'time_mode\'\" ng-bind=\"item.time_mode\"></td>\n      <td align=\"center\" data-title=\"\'create_time\'\" ng-bind=\"item.create_time\"></td>\n      <td align=\"center\" data-title=\"\'last_update_time\'\" ng-bind=\"item.last_update_time\"></td>\n      <td align=\"center\" data-title=\"\'status\'\" ng-bind=\"item.status\"></td>\n    </tr>\n  </table>\n</div>\n\n<script id=\"offline-hot-result-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/offline/hot/item/item.html\'\"></div>\n    </div>\n  </script>\n<ui-view></ui-view>");
$templateCache.put("src/module/offline/rec/rec.html","<div class=\"box-header\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-3\">\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">requestid：</label>\n        <div class=\"col-xs-8\">\n          <dg-search-input class=\"custom-search-input\" ng-model=\"requestid\" search=\"search()\" placeholder=\"requestid\"></dg-search-input>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-3\">\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">appname：</label>\n        <div class=\"col-xs-8\">\n          <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-sm-3\">\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label mer-lable-fixed text-right\">appid：</label>\n        <div class=\"col-xs-8\">\n          <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n        </div>\n      </div>\n    </div>\n  </div>\n  <filter-group filter-list=\"alarmFilter\" search-value=\"searchValue\" search-func=\"search()\">\n  </filter-group>\n</div>\n<div class=\"box-body\">\n  <div class=\"box-header\">\n    <button class=\"btn btn-primary btn-flat\" ng-click=\"start()\">\n      启动相关推荐\n    </button>\n  </div>\n\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td align=\"center\" data-title=\"\'requestid\'\" ng-bind=\"item.requestid\"></td>\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n      <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n      <td align=\"center\" data-title=\"\'time_mode\'\" ng-bind=\"item.time_mode\"></td>\n      <td align=\"center\" data-title=\"\'is_cf\'\" ng-bind=\"item.is_cf\"></td>\n      <td align=\"center\" data-title=\"\'is_rec\'\" ng-bind=\"item.is_rec\"></td>\n      <td align=\"center\" data-title=\"\'create_time\'\" ng-bind=\"item.create_time\"></td>\n      <td align=\"center\" data-title=\"\'last_update_time\'\" ng-bind=\"item.last_update_time\"></td>\n      <td align=\"center\" data-title=\"\'status\'\" ng-bind=\"item.status\"></td>\n    </tr>\n  </table>\n</div>\n<script id=\"offline-rec-config-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/offline/rec/item/item.html\'\"></div>\n    </div>\n  </script>\n<ui-view></ui-view>");
$templateCache.put("src/module/order/list/list.html","<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <a class=\"btn btn-primary\" href=\"#/order/update/\">新增订单</a>\n    <div class=\"form-group\">\n      <label>状态</label>\n      <select ng-model=\"filter.del\" class=\"form-control\" ng-init=\"filter.del = \'0\'\">\n        <option value=\"\">全部</option>\n        <option value=\"0\">启用</option>\n        <option value=\"1\">禁用</option>\n      </select>\n    </div>\n    <dg-search-input search=\"search()\" placeholder=\"用户名称/公司名称\" ng-model=\"app_name\"></dg-search-input>\n  </form>\n</div>\n<div loading-container=\"tableParams.settings().$loading\" scroll-box=\"$(this)\" table-bottom-scroll-bar-height=\"screen\" table-bottom-scroll-bar>\n  <table class=\"table table-bordered table-hover\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data  | orderBy: \'-create_time\' track by $index\" ng-show=\"showItem(item)\">\n      <td align=\"center\" data-title=\"\'序号\'\" ng-bind=\"$index + 1\"></td>\n      <td align=\"center\" data-title=\"\'公司名称\'\" ng-bind=\"item.company_name\"></td>\n      <td align=\"center\" data-title=\"\'app名称\'\" ng-bind=\"item.app_name\"></td>\n      <!--<td align=\"center\" data-title=\"\'审核\'\">\n          <input type=\"checkbox\" ng-checked=\"item.features_name == \'examine\' ? true : false\" disabled=\"true\">\n        </td>\n        <td align=\"center\" data-title=\"\'分类\'\">\n          <input type=\"checkbox\" ng-checked=\"item.features_name == \'classify\' ? true : false\" disabled=\"true\">\n        </td>\n        <td align=\"center\" data-title=\"\'标签\'\">\n          <input type=\"checkbox\" ng-checked=\"item.features_name == \'tagging\' ? true : false\" disabled=\"true\">\n        </td>\n        <td align=\"center\" data-title=\"\'情感\'\">\n          <input type=\"checkbox\" ng-checked=\"item.features_name == \'sentiment\' ? true : false\" disabled=\"true\">\n        </td>\n        <td align=\"center\" data-title=\"\'推荐\'\">\n          <input type=\"checkbox\" ng-checked=\"item.features_name == \'rec\' ? true : false\" disabled=\"true\">\n        </td>\n        <td align=\"center\" data-title=\"\'搜索\'\">\n          <input type=\"checkbox\" ng-checked=\"item.features_name == \'search\' ? true : false\" disabled=\"true\">\n        </td>\n        <td align=\"center\" data-title=\"\'抓取\'\">\n          <input type=\"checkbox\" ng-checked=\"item.features_name == \'spider\' ? true : false\" disabled=\"true\">\n        </td>-->\n      <!--<td align=\"center\" data-title=\"\'订单状态\'\" ng-bind=\"item.del == 1 ? \'禁用\' : \'启用\'\"></td>-->\n      <td align=\"center\" data-title=\"\'负责人\'\" ng-bind=\"item.manager\"></td>\n      <td align=\"center\" data-title=\"\'创建时间\'\" ng-bind=\"item.create_time.substring(0, 10)\"></td>\n      <td align=\"center\" data-title=\"\'操作\'\">\n        <a href=\"#/order/update/{{item.id}}\" class=\"btn btn-primary btn-sm\">\n          <span class=\"glyphicon glyphicon-info-sign\"></span>&nbsp;&nbsp;编辑\n        </a>\n      </td>\n    </tr>\n  </table>\n</div>");
$templateCache.put("src/module/order/update/update.html","<style>\n  .order-img {\n    margin: 20px auto 0;\n    max-width: 300px;\n    max-height: 300px;\n  }\n</style>\n<form class=\"form-horizontal\" ng-submit=\"save()\">\n  <div class=\"box-body\">\n    <fieldset class=\"mt-sm\">\n      <legend class=\"section\">订单总体信息</legend>\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label\">\n          <span class=\"required\"></span>&nbsp;账号名称\n        </label>\n        <div class=\"col-xs-4\">\n          <dg-combo-box selected-item=\"orderInfo.appInfo\" item-list=\"reflectData.appReflect\" item-name=\"value.app_name\"></dg-combo-box>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label\">\n          <span class=\"required\"></span>&nbsp;公司名称\n        </label>\n        <div class=\"col-xs-4\">\n          <input type=\"text\" class=\"form-control input-transparent\" disabled=\"disabled\" ng-model=\"orderInfo.appInfo.value.company_name\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label\">负责人</label>\n        <div class=\"col-xs-4\">\n          <select class=\"form-control input-transparent\" ng-options=\"manager.user_id as manager.user_nickname for manager in Saler\" ng-model=\"orderInfo.manager\"></select>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label\">状态</label>\n        <div class=\"col-xs-4\">\n          <div class=\"radio\">\n            <label>\n              <input type=\"radio\" value=\"0\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 0)\">\n              启用\n            </label>\n            <label>\n              <input type=\"radio\" value=\"1\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 1)\">\n              禁用\n            </label>\n          </div>\n          <!--<div class=\"btn-group\">-->\n          <!--<label class=\"btn btn-default\" ng-class=\"{\'btn-primary\': orderInfo.orderDel == 1}\" ng-click=\"changeDelState(orderInfo, 1)\">启用</label>\n            <label class=\"btn btn-default\" ng-class=\"{\'btn-primary\': orderInfo.orderDel == 0}\" ng-click=\"changeDelState(orderInfo, 0)\">禁用</label>-->\n          <!--</div>-->\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label\">文件</label>\n        <div class=\"col-xs-4\" ng-init=\"imageScreenShow = false\">\n          <input type=\"file\" class=\"form-control input-transparent order-imginput\" onchange=\"angular.element(this).scope().orderimgUpload()\">\n          <img class=\"order-img\" ng-click=\"showImage()\" ng-src=\"{{image}}\" ng-if=\"!!orderInfo.orderId\">\n          <div class=\"full-screen-image-box\" ng-show=\"imageScreenShow\" ng-click=\"showImage()\"></div>\n          <img class=\"full-screen-image\" ng-src=\"{{image}}\" ng-show=\"imageScreenShow\" fixed-centered fixed-centered-show=\"imageScreenShow\" ng-if=\"!!orderInfo.orderId\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label\">操作</label>\n        <div class=\"col-xs-4\">\n          <button class=\"btn btn-primary\" type=\"button\" ng-click=\"saveOrder()\" ng-bind=\"isNew ? \'创建\' : \'保存\'\"></button>\n          <a href=\"#/order/list\" class=\"btn btn-danger\">取消</a>\n        </div>\n      </div>\n    </fieldset>\n    <fieldset class=\"mt-sm\" ng-repeat=\"service in orderInfo.serviceList\">\n      <legend class=\"section\">服务{{$index + 1}}</legend>\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label\">服务类型</label>\n        <div class=\"col-xs-4\">\n          <select class=\"form-control input-transparent\" ng-model=\"service.child_features_id\">\n            <option value=\"2\">推荐引擎</option>\n            <option value=\"1\">搜索引擎</option>\n            <option value=\"14\">文本审核</option>\n            <option value=\"3\">数据抓取</option>\n            <option value=\"11\">文本分类</option>\n            <option value=\"12\">文本打标签</option>\n            <option value=\"13\">文本情感分析</option>\n          </select>\n        </div>\n      </div>\n      <div class=\"detail-container\" ng-show=\"!!service.child_features_id\">\n        <div class=\"form-group\" ng-if=\"service.child_features_id == 14\">\n          <label class=\"col-xs-4 control-label\">服务内容</label>\n          <div class=\"col-xs-4\" style=\"padding-top:6px\">\n            <label><input type=\"checkbox\" ng-model=\"service.child_remark.ad\" ng-true-value=\"1\" ng-false-value=\"0\">广告</label>\n            <label><input type=\"checkbox\" ng-model=\"service.child_remark.porn\" ng-true-value=\"1\" ng-false-value=\"0\">涉黄</label>\n            <label><input type=\"checkbox\" ng-model=\"service.child_remark.politic\" ng-true-value=\"1\" ng-false-value=\"0\">涉政</label>\n            <label><input type=\"checkbox\" ng-model=\"service.child_remark.reaction\" ng-true-value=\"1\" ng-false-value=\"0\">反动</label>\n            <label><input type=\"checkbox\" ng-model=\"service.child_remark.lowQuality\" ng-true-value=\"1\" ng-false-value=\"0\">低质量</label>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-xs-4 control-label\">套餐类型</label>\n          <div class=\"col-xs-4\">\n            <select class=\"form-control input-transparent\" ng-model=\"service.child_type_id\">\n              <option value=\"1\" ng-if=\"service.child_features_id != 1 && service.child_features_id != 2 && service.child_features_id != 3\">预充值</option>\n              <option value=\"2\">月付</option>\n              <option value=\"3\">季付</option>\n              <option value=\"5\">半年付</option>\n              <option value=\"4\">年付</option>\n            </select>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-hide=\"service.child_features_id == 3\">\n          <label class=\"col-xs-4 control-label\" ng-bind=\"service.child_type_id == 1 ? \'限额\' : \'日限额\'\"></label>\n          <div class=\"col-xs-3\">\n            <input type=\"text\" class=\"form-control input-transparent\" ng-show=\"service.child_type_id == 1\" ng-model=\"service.child_number\">\n            <input type=\"text\" class=\"form-control input-transparent\" ng-hide=\"service.child_type_id == 1\" ng-model=\"service.child_day_limit_num\">\n          </div>\n          <div class=\"col-xs-1 control-label\" style=\"margin-left: -30px\">万次</div>\n        </div>\n        <div class=\"form-group\" ng-show=\"service.child_type_id != 1 && service.child_features_id != 3\">\n          <label class=\"col-xs-4 control-label\">超限提醒</label>\n          <div class=\"col-xs-4\" style=\"padding-top:6px\">\n            <label><input type=\"checkbox\" ng-model=\"service.child_remind_day\" ng-true-value=\"1\" ng-false-value=\"0\">日提醒</label>\n            <label><input type=\"checkbox\" ng-model=\"service.child_remind_month\" ng-true-value=\"1\" ng-false-value=\"0\">月提醒</label>\n            <label><input type=\"checkbox\" ng-model=\"service.child_remind_season\" ng-true-value=\"1\" ng-false-value=\"0\">季度提醒</label>\n            <label><input type=\"checkbox\" ng-model=\"service.child_remind_semester\" ng-true-value=\"1\" ng-false-value=\"0\">半年提醒</label>\n            <label><input type=\"checkbox\" ng-model=\"service.child_remind_year\" ng-true-value=\"1\" ng-false-value=\"0\">年提醒</label>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-xs-4 control-label\">服务时限</label>\n          <div class=\"col-xs-4\">\n            <period-date-picker ng-model=\"service.date\" beyond-today disable-clear></period-date-picker>\n          </div>\n        </div>\n        <!--<div class=\"form-group\">\n          <label class=\"col-xs-4 control-label\">状态</label>\n          <div class=\"col-xs-4\">\n            <div class=\"btn-group\">\n              <label class=\"btn btn-default\" ng-class=\"{\'btn-primary\': service.child_del == \'1\'}\" ng-click=\"changeDelState(service, \'1\')\">启用</label>\n              <label class=\"btn btn-default\" ng-class=\"{\'btn-primary\': service.child_del == \'0\'}\" ng-click=\"changeDelState(service, \'0\')\">禁用</label>\n            </div>\n          </div>\n        </div>-->\n        <div class=\"form-group\">\n          <div class=\"col-xs-4 col-xs-offset-4\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveService(service)\" ng-bind=\"service.isNew ? \'创建\' : \'保存\'\"></button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cancelService(service, $index)\">取消</button>\n          </div>\n        </div>\n      </div>\n    </fieldset>\n    <fieldset class=\"mt-sm\" ng-if=\"!isNew\">\n      <legend class=\"section\">新增服务</legend>\n      <div class=\"form-group\">\n        <div class=\"col-xs-4 col-xs-offset-4\">\n          <button type=\"button\" class=\"btn btn-primary\" ng-click=\"addService()\">添加服务</button>\n        </div>\n      </div>\n    </fieldset>\n  </div>\n</form>");
$templateCache.put("src/module/project/testApplication/testApplication.html","<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <a class=\"btn btn-primary btn-flat\" ng-click=\"edit()\">\n      <i class=\"glyphicon glyphicon-plus\"></i> 新建申请\n    </a>\n    <a class=\"btn btn-primary btn-flat\" ng-click=\"download()\" ng-show=\"isProjectManager()\">\n      <i class=\"fa fa-download\"></i> 下载数据\n    </a>\n    <div class=\"form-group\" ng-show=\"isProjectManager()\">\n      <label>销售</label>\n      <select class=\"form-control\" ng-model=\"search.manager_id\" ng-change=\"search()\" select-convert-to-number>\n        <option value=\"{{ 0 }}\">全部</option>\n        <option value=\"{{ manager.user_id }}\" ng-bind=\"manager.user_nickname\" ng-repeat=\"manager in managers\"></option>\n      </select>\n    </div>\n    <dg-search-input ng-model=\"search.q\" placeholder=\"企业名称/项目(产品)名称\" search=\"search()\" style=\"width: 230px\"></dg-search-input>\n  </form>\n</div>\n<div loading-container=\"tableParams.settings().$loading\" class=\"box-body\">\n  <table class=\"table table-bordered table-hover table-layout-fixed\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td class=\"break-word\" data-title=\"\'序号\'\" ng-bind=\"item.id\"></td>\n      <td class=\"break-word\" data-title=\"\'企业名称\'\" ng-bind=\"item.company_name\"></td>\n      <td class=\"break-word\" data-title=\"\'项目（产品）名称\'\" ng-bind=\"item.project_name\"></td>\n      <td class=\"break-word\" data-title=\"\'销售负责人\'\" ng-bind=\"Config.manager_id[item.manager_id]\"></td>\n      <td class=\"break-word\" data-title=\"\'app name\'\" ng-bind=\"item.app_name\"></td>\n      <td class=\"break-word\" data-title=\"\'app id\'\" ng-bind=\"item.appid == 0 ? \'\' : item.appid\"></td>\n      <td class=\"break-word\" data-title=\"\'申请时间\'\" ng-bind=\"item.create_time.substr(0,10)\"></td>\n      <td class=\"break-word\" data-title=\"\'账号开通时间\'\">\n        <span ng-show=\"item.status\" ng-bind=\"item.start_time.substr(0,10)\"></span>\n      </td>\n      <td class=\"break-word\" data-title=\"\'操作\'\">\n        <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"edit(item)\" ng-disabled=\"item.status\">\n          <span class=\"glyphicon glyphicon-pencil\"></span>\n          编辑\n        </button>\n        <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"application(item)\" ng-disabled=\"item.status\" ng-show=\"isProjectManager()\">\n          <span class=\"glyphicon glyphicon-ok\"></span> 开通\n        </button>\n      </td>\n    </tr>\n  </table>\n</div>\n<!--nlp dialog ng-template-->\n<script id=\"application-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog application-dialog\">\n    <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/project/testApplication/applicationDialog/dialog.html\'\"></div>\n  </div>\n</script>\n\n<script id=\"account-application-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog account-application-dialog\">\n    <div class=\"modal-content dialog-form\" ng-include=\"\'src/module/project/testApplication/accountApplicationDialog/dialog.html\'\"></div>\n  </div>\n</script>");
$templateCache.put("src/module/public/action/action.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    公众号统计\n    <small>用户行为</small>\n  </h2>\n</section>\n<section class=\"content\">\n  <div class=\"box\">\n    <div class=\"box-header\">\n      <form class=\"form-inline text-center\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon bg-teal color-palette\">来源</span>\n          <select class=\"form-control\" ng-model=\"terminal_type\" ng-change=\"terminalTypeChange()\">\n            <option value=\"-1\"> 全部 </option>\n            <option value=\"0\"> PC </option>\n            <option value=\"1\"> APP </option>\n            </select>\n          <span class=\"input-group-addon bg-teal color-palette\">类型</span>\n          <select class=\"form-control\" ng-model=\"action_name\" ng-options=\"action_name for action_name in action_list\" ng-change=\"actionNameChange()\">\n            <option value=\"\">全部</option>\n          </select>\n        </div>\n      </form>\n    </div>\n    <div loading-container=\"tableParams.settings().$loading\" class=\"body\">\n      <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data track by item.admin_static_actionid\">\n          <td data-title=\"\'日期\'\">{{item.ref_date | limitTo: 10}}</td>\n          <td data-title=\"\'来源\'\">{{item.terminal_type==0?\'PC\':\'APP\'}}</td>\n          <td data-title=\"\'类型\'\">{{item.action_name}}</td>\n          <td data-title=\"\'uv\'\">{{item.uv}}</td>\n          <td data-title=\"\'pv\'\">{{item.pv}}</td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>");
$templateCache.put("src/module/public/binding/binding.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    公众号统计\n    <small>绑定数据</small>\n  </h2>\n</section>\n<section class=\"content\">\n  <div class=\"box\">\n    <div loading-container=\"tableParams.settings().$loading\" class=\"box-content\">\n      <table class=\"table table-bordered table-hover\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data track by item.admin_static_userid\">\n          <td data-title=\"\'日期\'\">{{item.ref_date | limitTo: 10}}</td>\n          <td data-title=\"\'注册数\'\">{{item.reg_num}}</td>\n          <td data-title=\"\'绑定数\'\">{{item.bind_num}}</td>\n          <td data-title=\"\'解绑数\'\">{{item.unbind_num}}</td>\n          <td data-title=\"\'当前总绑定数\'\">{{item.all_bind_num}}</td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</section>");
$templateCache.put("src/module/public/feedback/feedback.html","<section class=\"content-header\">\n  <h2 class=\"page-title\">\n    公众号统计\n    <small>数据反馈</small>\n  </h2>\n</section>\n<section class=\"content\">\n  <div class=\"box\">\n    <div loading-container=\"tableParams.settings().$loading\">\n      <table class=\"table table-hover\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\">\n          <td data-title=\"\'日期\'\" class=\"nowrap\">{{item.last_update_time}}</td>\n          <td data-title=\"\'用户名称\'\">{{item.nick_name}}</td>\n          <td data-title=\"\'手机号\'\">{{item.tel}}</td>\n          <td data-title=\"\'内容\'\">{{item.content}}</td>\n          \n        </tr>\n      </table>\n    </div>\n  </div>\n</section>");
$templateCache.put("src/module/recConfig/aboutRecConfig/aboutRecConfig.html","<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"create()\">\n      <i class=\"glyphicon glyphicon-plus\"></i> 新建配置\n    </button>\n    <dg-search-input ng-model=\"searchStr\" search=\"search()\" placeholder=\"appname/appid\"></dg-search-input>\n  </form>\n</div>\n<div class=\"box-body\">\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n      <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n      <td align=\"center\" data-title=\"\'is_odps\'\" ng-bind=\"item.is_odps\"></td>\n      <td align=\"center\" data-title=\"\'cf_type\'\" ng-bind=\"item.cf_type\"></td>\n      <td align=\"center\" data-title=\"\'cf_day_cnt\'\" ng-bind=\"item.cf_day_cnt\"></td>\n      <td align=\"center\" data-title=\"\'table_name\'\" ng-bind=\"item.table_name\"></td>\n      <td align=\"center\" data-title=\"\'result_cnt\'\" ng-bind=\"item.result_cnt\"></td>\n      <td align=\"center\" data-title=\"\'last_update_time\'\" ng-bind=\"item.last_update_time\"></td>\n\n      <td align=\"center\" data-title=\"\'操作\'\">\n        <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"modify(item.id)\">\n          <i class=\"glyphicon glyphicon-pencil\"></i> 编辑</button>&nbsp;\n        <button type=\"button\" class=\"btn btn-danger btn-flat\" ng-click=\"remove(item)\">\n          <i class=\"glyphicon glyphicon-trash\"></i> 删除</button>\n      </td>\n\n    </tr>\n  </table>\n</div>\n\n<script id=\"about-rec-config-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/recConfig/aboutRecConfig/item/item.html\'\"></div>\n    </div>\n</script>\n<ui-view></ui-view>");
$templateCache.put("src/module/recConfig/actionConfig/actionConfig.html","<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <button class=\"btn btn-primary btn-flat\" ui-sref=\"recConfig.actionConfig.item\">\n        <i class=\"glyphicon glyphicon-plus\"></i> 创建\n    </button>\n    <dg-search-input ng-model=\"searchStr\" search=\"search()\" placeholder=\"请输入指定的appid\"></dg-search-input>\n  </form>\n</div>\n<div class=\"box-body\">\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n      <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n      <td align=\"center\" data-title=\"\'data_type\'\" ng-bind=\"item.data_type\"></td>\n      <td align=\"center\" data-title=\"\'action_list\'\" ng-bind=\"item.action_list\"></td>\n      <td align=\"center\" data-title=\"\'操作\'\">\n          <button class=\"btn btn-primary btn-flat\" ui-sref=\"recConfig.actionConfig.item({id: item.app_action_push_configid})\"><i class=\"glyphicon glyphicon-pencil\"></i> 修改</button>&nbsp;\n          <button class=\"btn btn-danger btn-flat\" ng-click=\"remove(item)\"><i class=\"glyphicon glyphicon-trash\"></i> 删除</button>\n      </td>\n    </tr>\n  </table>\n</div>\n<ui-view></ui-view>");
$templateCache.put("src/module/recConfig/hotRecConfig/hotRecConfig.html","<div class=\"box-header\">\n    <form class=\"form-inline\">\n        <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"create()\">\n              <i class=\"glyphicon glyphicon-plus\"></i> 新建配置\n          </button>\n        <dg-search-input ng-model=\"searchStr\" search=\"search()\" placeholder=\"appname/appid\"></dg-search-input>\n    </form>\n</div>\n<div class=\"box-body\">\n    <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\">\n            <td align=\"center\" data-title=\"\'序号\'\" ng-bind=\"$index + 1\"></td>\n            <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n            <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n            <td align=\"center\" data-title=\"\'最新编辑时间\'\" ng-bind=\"item.last_update_time\"></td>\n            <td align=\"center\" data-title=\"\'操作\'\">\n                <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"modify(item.id)\"><i class=\"glyphicon glyphicon-pencil\"></i> 编辑</button>&nbsp;\n                <button type=\"button\" class=\"btn btn-danger btn-flat\" ng-click=\"remove(item)\"><i class=\"glyphicon glyphicon-trash\"></i> 删除</button>\n            </td>\n        </tr>\n    </table>\n</div>\n\n<script id=\"hot-rec-config-dialog\" type=\"text/ng-template\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/recConfig/hotRecConfig/item/item.html\'\"></div>\n    </div>\n</script>\n<ui-view></ui-view>");
$templateCache.put("src/module/recConfig/mergeConfig/mergeConfig.html","<div class=\"box-header\">\n\n  <!-- <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-3\">\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label mer-lable-fixed\">appname：</label>\n        <div class=\"col-xs-8\">\n          <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-sm-3\">\n      <div class=\"form-group\">\n        <label class=\"col-xs-4 control-label mer-lable-fixed\">appid：</label>\n        <div class=\"col-xs-8\">\n          <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n        </div>\n      </div>\n    </div>\n  </div> -->\n\n  <filter-group filter-list=\"alarmFilter\" search-value=\"searchValue\" search-func=\"search()\">\n  </filter-group>\n\n  <form class=\"form-inline\">\n    <button type=\"button\" class=\"btn btn-primary btn-flat\" ng-click=\"create()\">\n      <i class=\"glyphicon glyphicon-plus\"></i> 新建配置\n    </button>\n    <dg-search-input ng-model=\"params.query\" search=\"search()\" placeholder=\"appname/appid\"></dg-search-input>\n  </form>\n\n</div>\n<div class=\"box-body\">\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\">\n\n      <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.app_name\"></td>\n      <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n      <td align=\"center\" header=\"\'mode-note\'\">\n        <span ng-bind=\"item.mode\"></span>\n      </td>\n\n      <td align=\"center\" data-title=\"\'last_update_time\'\" ng-bind=\"item.last_update_time\"></td>\n      <td align=\"center\" data-title=\"\'action_type_list\'\" ng-bind=\"item.action_type_list\"></td>\n      <td align=\"center\" data-title=\"\'time_min\'\" ng-bind=\"item.time_threshold_min\"></td>\n      <td align=\"center\" data-title=\"\'time_max\'\" ng-bind=\"item.time_threshold_max\"></td>\n      <td align=\"center\" header=\"\'status-note\'\">\n        <span ng-bind=\"item.status===1 ? \'启用中\': \'已禁用\'\"></span>\n      </td>\n      <td align=\"center\" data-title=\"\'操作\'\">\n        <button class=\"btn btn-primary btn-flat\" ng-click=\"modify(item.id)\">\n          编辑</button>\n        <button class=\"btn btn-danger btn-flat\" type=\"button\" ng-click=\"remove(item)\">删除</button>\n      </td>\n    </tr>\n  </table>\n</div>\n\n<script id=\"status-note\" type=\"text/ng-template\">\n  status\n  <i class=\"glyphicon glyphicon-question-sign\" tooltip-placement=\"top\" uib-tooltip=\"启用中：app在线且开通推荐功能 已禁用：app下线或已关闭推荐功能\"></i>\n</script>\n\n\n<script id=\"mode-note\" type=\"text/ng-template\">\n  mode\n  <i class=\"glyphicon glyphicon-question-sign\" tooltip-placement=\"top\" uib-tooltip=\"mode=1 从rec_log加载历史点击，通过对比时间范围计算是否点击；\n             mode=2 从/dx_data/user_item_action中限定action_type加载历史点击，通过对比时间范围计算是否点击；        \n             mode=3 从/dx_data/user_item_action中限定action_type取rec_requestid加载历史点击，通过rec_requestid对比确定每次推荐是否点击；\"></i>\n</script>\n\n<script id=\"merge-rec-config-dialog\" type=\"text/ng-template\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content dialog-form fix-dialog-form\" ng-include=\"\'src/module/recConfig/mergeConfig/item/item.html\'\"></div>\n  </div>\n</script>\n<ui-view></ui-view>");
$templateCache.put("src/module/recDebug/hot/hot.html","<div class=\"box-body table-responsive scroll-table\">\n  <div class=\"box-body\">\n    <form class=\"form-horizontal\">\n      <fieldset class=\"mt-sm\">\n        <legend class=\"section\">参数设置</legend>\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">app_name</label>\n              <div class=\"col-xs-8\">\n                <dg-combo-box selected-item=\"selectedItem\" item-list=\"appArray\" item-name=\"value.app_name\"></dg-combo-box>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-4\" ng-repeat=\"(key, value) in queryParams\" ng-show=\"key != \'hot_key\' && key != \'app_name\'\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\" ng-bind=\"key\"></label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" ng-model=\"queryParams[key]\" class=\"form-control\">\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">hot_key</label>\n              <div class=\"col-xs-8\">\n                <select id=\"hotType\" class=\"form-control\" ng-model=\"hot.type\">\n                  <option value=\"\">无</option>\n                  <option value=\"HOT:\">HOT</option> \n                  <option value=\"HOT_HOUR:\">HOT_HOUR</option>\n                  <option value=\"NEW_REC_\">NEW_REC</option>\n                </select>\n              </div>\n            </div>\n          </div>\n        </div>\n      </fieldset>\n      <div class=\"row text-center\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"resetParams()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"comfirm()\">&nbsp;&nbsp;提交&nbsp;&nbsp;</button>\n      </div>\n      <fieldset class=\"mt-sm\" ng-if=\"!noData\">\n        <legend class=\"section\">数据反馈</legend>\n        <div class=\"form-group\">\n          <div class=\"col-xs-12 col-mlg-6\" style=\"position:relative\">\n            <legend class=\"section\">rec_result</legend>\n            <div class=\"fixed-section-height-2\">\n              <div class=\"fixed-replace\">\n                <button class=\"btn btn-primary\" ng-click=\"replaceRecResult()\">换一换</button>\n              </div>\n              <table class=\"table table-hover table-bordered custom-table\">\n                <thead>\n                  <tr>\n                    <th class=\"rec-table-index\">序号</th>\n                    <th>itemid</th>\n                    <th>产品名称</th>\n                    <th>cateid</th>\n                    <th>tag</th>\n                    <th>modify_time</th>\n                    <th class=\"width100\">alg_type</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"item in tableData.rec_result\">\n                    <td ng-bind=\"$index + 1\" class=\"rec-table-index\"></td>\n                    <td ng-bind=\"item.itemid\"></td>\n                    <td ng-click=\"searchRelateAndOpenRelated(item)\" class=\"can_click\" ng-bind=\"item.title\">\n                      <!--<a ui-sref=\"recDebug.related(relatedParam(relatedParam(item)))\" class=\"can_click\" ng-bind=\"item.title\" target=\"_blank\"></a>-->\n                    </td>\n                    <td ng-bind=\"item.cateid\"></td>\n                    <td ng-bind=\"item.item_tags\"></td>\n                    <td ng-bind=\"item.item_modify_time\"></td>\n                    <td class=\"width100\" ng-bind=\"item.alg_type\"></td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-mlg-6\">\n            <legend class=\"section\">user_model_info</legend>\n            <div class=\"fixed-section-height-2\">\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">类别</label>\n                <div class=\"col-xs-8 tag-align-left\">\n                  <span class=\"tag\" ng-repeat=\"item in tableData.user_model_info.cate_info\" ng-bind=\"item\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">标签</label>\n                <div class=\"col-xs-8 tag-align-left\">\n                  <span class=\"tag\" ng-repeat=\"item in tableData.user_model_info.tag_info\" ng-bind=\"item\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">相似用户</label>\n                <div class=\"col-xs-8 tag-align-left\">\n                  <span class=\"tag\" ng-repeat=\"item in tableData.user_model_info.sim_user_info\" ng-if=\"$index < 3\" ng-bind=\"item\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">偏好产品</label>\n              </div>\n              <table class=\"table table-hover table-bordered custom-table\">\n                <thead>\n                  <tr>\n                    <th>itemid</th>\n                    <th>产品名称</th>\n                    <th>cateid</th>\n                    <th>tag</th>\n                    <th>modify_time</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"item in tableData.user_model_info.item_info\">\n                    <td ng-bind=\"item.itemid\"></td>\n                    <td>\n                      <span class=\"span-test\" ng-bind=\"item.title\"></span>\n                    </td>\n                    <td ng-bind=\"item.cateid\"></td>\n                    <td ng-bind=\"item.item_tags\"></td>\n                    <td ng-bind=\"!!item.item_modify_time ? item.item_modify_time : \'\'\"></td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </fieldset>\n    </form>\n  </div>\n</div>");
$templateCache.put("src/module/recDebug/personal/personal.html","<div class=\"box-body table-responsive scroll-table\">\n  <div class=\"box-body\">\n    <form class=\"form-horizontal\">\n      <fieldset class=\"mt-sm\">\n        <legend class=\"section\">参数设置</legend>\n        <div class=\"col-xs-12 col-sm-4\">\n          <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">app_name</label>\n            <div class=\"col-xs-8\">\n              <dg-combo-box selected-item=\"selectedItem\" item-list=\"appArray\" item-name=\"value.app_name\"></dg-combo-box>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-12 col-sm-4\" ng-repeat=\"(key, value) in queryParams\" ng-show=\"key != \'hot_key\' && key != \'app_name\'\">\n          <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\" ng-bind=\"key\"></label>\n            <div class=\"col-xs-8\">\n              <input type=\"text\" ng-model=\"queryParams[key]\" class=\"form-control\">\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-12\">\n          <div class=\"form-group text-center\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"resetParams()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"comfirm()\">&nbsp;&nbsp;提交&nbsp;&nbsp;</button>\n          </div>\n        </div>\n      </fieldset>\n      <fieldset class=\"mt-sm\" ng-if=\"!noData\">\n        <legend class=\"section\">数据反馈</legend>\n        <div class=\"form-group\">\n          <div class=\"col-xs-12 col-mlg-6\" style=\"position:relative\">\n            <legend class=\"section\">rec_result</legend>\n            <div class=\"fixed-section-height-2\">\n              <div class=\"fixed-replace\">\n                <button class=\"btn btn-primary\" ng-click=\"replaceRecResult()\">换一换</button>\n              </div>\n              <table class=\"table table-hover table-bordered custom-table\">\n                <thead>\n                  <tr>\n                    <th class=\"rec-table-index\">序号</th>\n                    <th>itemid</th>\n                    <th>产品名称</th>\n                    <th>cateid</th>\n                    <th>tag</th>\n                    <th>modify_time</th>\n                    <th class=\"width100\">alg_type</th>\n                    <!-- <th class=\"width100\">alg_type</th> -->\n                    <th class=\"width100\">co_cnt</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"item in tableData.rec_result\">\n                    <td class=\"rec-table-index\" ng-bind=\"$index + 1\"></td>\n                    <td ng-bind=\"item.itemid\"></td>\n                    <td ng-click=\"searchPersonalAndOpenRelated(item)\" class=\"can_click\" ng-bind=\"item.title\"></td>\n                    <td ng-bind=\"item.cateid\"></td>\n                    <td ng-bind=\"item.item_tags\"></td>\n                    <td ng-bind=\"item.item_modify_time\"></td>\n                    <td class=\"width100\" ng-bind=\"item.alg_type\"></td>\n                    <td class=\"width100\" ng-bind=\"item.co_cnt\"></td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-mlg-6\">\n            <legend class=\"section\">user_model_info</legend>\n            <div class=\"fixed-section-height-2\">\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">类别</label>\n                <div class=\"col-xs-10 tag-align-left\">\n                  <span class=\"tag\" ng-repeat=\"item in tableData.user_model_info.cate_info\" ng-bind=\"item\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">标签</label>\n                <div class=\"col-xs-10 tag-align-left\">\n                  <span class=\"tag\" ng-repeat=\"item in tableData.user_model_info.tag_info\" ng-bind=\"item\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">相似用户</label>\n                <div class=\"col-xs-10 tag-align-left\">\n                  <span class=\"tag\" ng-repeat=\"item in tableData.user_model_info.sim_user_info\" ng-if=\"$index < 3\" ng-bind=\"item\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">偏好产品</label>\n              </div>\n              <table class=\"table table-hover table-bordered\">\n                <thead>\n                  <tr>\n                    <th>itemid</th>\n                    <th>产品名称</th>\n                    <th>cateid</th>\n                    <th>tag</th>\n                    <th>modify_time</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"item in tableData.user_model_info.item_info\">\n                    <td ng-bind=\"item.itemid\"></td>\n                    <td>\n                      <span class=\"span-test\" ng-bind=\"item.title\"></span>\n                    </td>\n                    <td ng-bind=\"item.cateid\"></td>\n                    <td ng-bind=\"item.item_tags\"></td>\n                    <td ng-bind=\"!!item.item_modify_time ? item.item_modify_time : \'\'\"></td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <div class=\"col-xs-12 col-mlg-6\">\n            <legend class=\"section\">user_show</legend>\n            <div class=\"fixed-section-height\">\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-12 control-label text-left\">user_show列表总计为 <span class=\"total\" ng-bind=\"tableData.user_show.length\"></span></label>\n              </div>\n              <div loading-container=\"userShowTableParams.settings().$loading\" class=\"box-body\">\n                <table class=\"table table-hover table-bordered\" ng-table=\"userShowTableParams\" template-pagination=\"src/common/pagination.html\">\n                  <tr ng-repeat=\"item in $data track by $index\">\n                    <td data-title=\"\'itemid\'\" ng-bind=\"item.itemid\"></td>\n                    <td data-title=\"\'产品名称\'\" ng-bind=\"item.title\"></td>\n                    <td data-title=\"\'cateid\'\" ng-bind=\"item.cateid\"></td>\n                    <td data-title=\"\'tag\'\" ng-bind=\"item.item_tags\"></td>\n                    <td data-title=\"\'推荐时间\'\" ng-bind=\"item.rtime * 1000 | date: \'yyyy-MM-dd HH:mm:ss\'\"></td>\n                    <td data-title=\"\'modify_time\'\" ng-bind=\"item.item_modify_time\"></td>\n                  </tr>\n                </table>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-mlg-6\">\n            <legend class=\"section\">user_click</legend>\n            <div class=\"fixed-section-height\">\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-12 control-label text-left\">user_click列表总计为 <span class=\"total\" ng-bind=\"tableData.user_click.length\"></span></label>\n              </div>\n              <div loading-container=\"userClickTableParams.settings().$loading\" class=\"box-body\">\n                <table class=\"table table-hover table-bordered\" ng-table=\"userClickTableParams\" template-pagination=\"src/common/pagination.html\">\n                  <tr ng-repeat=\"item in $data track by $index\">\n                    <td data-title=\"\'itemid\'\" ng-bind=\"item.itemid\"></td>\n                    <td data-title=\"\'产品名称\'\" ng-bind=\"item.title\"></td>\n                    <td data-title=\"\'cateid\'\" ng-bind=\"item.cateid\"></td>\n                    <td data-title=\"\'tag\'\" ng-bind=\"item.item_tags\"></td>\n                    <td data-title=\"\'modify_time\'\" ng-bind=\"item.item_modify_time\"></td>\n                    <td data-title=\"\'推荐时间\'\" ng-bind=\"item.rtime * 1000 | date: \'yyyy-MM-dd HH:mm:ss\'\"></td>\n                    <td data-title=\"\'页面类型\'\" ng-bind=\"item.pt\"></td>\n                    <td data-title=\"\'行为类型\'\" ng-bind=\"item.at\"></td>\n                  </tr>\n                </table>\n              </div>\n            </div>\n          </div>\n        </div>\n      </fieldset>\n    </form>\n  </div>\n</div>");
$templateCache.put("src/module/recDebug/related/related.html","<div class=\"box-body table-responsive scroll-table\">\n  <div class=\"box-body\">\n    <form class=\"form-horizontal\">\n      <fieldset class=\"mt-sm\">\n        <legend class=\"section\">参数设置</legend>\n        <div class=\"col-xs-12 col-sm-4\">\n          <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">app_name</label>\n            <div class=\"col-xs-8\">\n              <dg-combo-box selected-item=\"selectedItem\" item-list=\"appArray\" item-name=\"value.app_name\"></dg-combo-box>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-12 col-sm-4\" ng-repeat=\"(key, value) in queryParams\" ng-show=\"key != \'hot_key\' && key != \'app_name\'\">\n          <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\" ng-bind=\"key\"></label>\n            <div class=\"col-xs-8\">\n              <input type=\"text\" ng-model=\"queryParams[key]\" class=\"form-control\">\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group text-center\">\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"resetParams()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n          <button type=\"button\" class=\"btn btn-primary\" ng-click=\"comfirm()\">&nbsp;&nbsp;提交&nbsp;&nbsp;</button>\n        </div>\n      </fieldset>\n      <fieldset class=\"mt-sm\" ng-if=\"!noData\">\n        <legend class=\"section\">数据反馈</legend>\n        <div class=\"form-group\">\n          <div class=\"col-xs-12 col-mlg-6\" style=\"position:relative\">\n            <legend class=\"section\">rec_result</legend>\n            <div class=\"fixed-section-height-2\">\n              <div class=\"fixed-replace\">\n                <button class=\"btn btn-primary\" ng-click=\"replaceRecResult()\">换一换</button>\n              </div>\n              <table class=\"table table-hover table-bordered custom-table\">\n                <thead>\n                  <tr>\n                    <th class=\"rec-table-index\">序号</th>\n                    <th>itemid</th>\n                    <th>产品名称</th>\n                    <th>cateid</th>\n                    <th>tag</th>\n                    <th>modify_time</th>\n                    <th class=\"width100\">alg_type</th>\n                    <th class=\"width100\">co_cnt</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"item in tableData.rec_result\">\n                    <td class=\"rec-table-index\" ng-bind=\"$index + 1\"></td>\n                    <td ng-bind=\"item.itemid\"></td>\n                    <td ng-click=\"searchRelateAndOpenRelated(item)\" class=\"can_click\" ng-bind=\"item.title\"></td>\n                    <td ng-bind=\"item.cateid\"></td>\n                    <td ng-bind=\"item.item_tags\"></td>\n                    <td ng-bind=\"item.item_modify_time\"></td>\n                    <td class=\"width100\" ng-bind=\"item.alg_type\"></td>\n                    <td class=\"width100\" ng-bind=\"item.co_cnt\"></td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-mlg-6\">\n            <legend class=\"section\">item_info</legend>\n            <div class=\"fixed-section-height-2\">\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">itemid</label>\n                <div class=\"col-xs-10 tag-align-left\">\n                  <span ng-bind=\"tableData.item_info.itemid\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">产品名称</label>\n                <div class=\"col-xs-10 tag-align-left\">\n                  <span ng-bind=\"tableData.item_info.title\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">类别</label>\n                <div class=\"col-xs-10 tag-align-left\">\n                  <span ng-bind=\"tableData.item_info.cateid\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">标签</label>\n                <div class=\"col-xs-10 tag-align-left\">\n                  <span ng-bind=\"tableData.item_info.item_tags\"></span>\n                </div>\n              </div>\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-2 control-label text-left\">修改时间</label>\n                <div class=\"col-xs-10 tag-align-left\">\n                  <span ng-bind=\"tableData.item_info.item_modify_time\"></span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <div class=\"col-xs-12 col-mlg-6\">\n            <legend class=\"section\">user_show</legend>\n            <div class=\"fixed-section-height\">\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-12 control-label text-left\">user_show列表总计为 <span class=\"total\" ng-bind=\"tableData.user_show.length\"></span></label>\n              </div>\n              <div loading-container=\"userShowTableParams.settings().$loading\" class=\"box-body\">\n                <table class=\"table table-hover table-bordered\" ng-table=\"userShowTableParams\" template-pagination=\"src/common/pagination.html\">\n                  <tr ng-repeat=\"item in $data track by $index\">\n                    <td data-title=\"\'itemid\'\" ng-bind=\"item.itemid\"></td>\n                    <td data-title=\"\'产品名称\'\" ng-bind=\"item.title\"></td>\n                    <td data-title=\"\'cateid\'\" ng-bind=\"item.cateid\"></td>\n                    <td data-title=\"\'tag\'\" ng-bind=\"item.item_tags\"></td>\n                    <td data-title=\"\'推荐时间\'\" ng-bind=\"item.rtime * 1000 | date: \'yyyy-MM-dd HH:mm:ss\'\"></td>\n                    <td data-title=\"\'modify_time\'\" ng-bind=\"item.item_modify_time\"></td>\n                  </tr>\n                </table>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-mlg-6\">\n            <legend class=\"section\">user_click</legend>\n            <div class=\"fixed-section-height\">\n              <div class=\"item-info-holder\">\n                <label class=\"col-xs-12 control-label text-left\">user_click列表总计为 <span class=\"total\" ng-bind=\"tableData.user_click.length\"></span></label>\n              </div>\n              <div loading-container=\"userClickTableParams.settings().$loading\" class=\"box-body\">\n                <table class=\"table table-hover table-bordered\" ng-table=\"userClickTableParams\" template-pagination=\"src/common/pagination.html\">\n                  <tr ng-repeat=\"item in $data track by $index\">\n                    <td data-title=\"\'itemid\'\" ng-bind=\"item.itemid\"></td>\n                    <td data-title=\"\'产品名称\'\" ng-bind=\"item.title\"></td>\n                    <td data-title=\"\'cateid\'\" ng-bind=\"item.cateid\"></td>\n                    <td data-title=\"\'tag\'\" ng-bind=\"item.item_tags\"></td>\n                    <td data-title=\"\'modify_time\'\" ng-bind=\"item.item_modify_time\"></td>\n                    <td data-title=\"\'推荐时间\'\" ng-bind=\"item.rtime * 1000 | date: \'yyyy-MM-dd HH:mm:ss\'\"></td>\n                    <td data-title=\"\'页面类型\'\" ng-bind=\"item.pt\"></td>\n                    <td data-title=\"\'行为类型\'\" ng-bind=\"item.at\"></td>\n                  </tr>\n                </table>\n              </div>\n            </div>\n          </div>\n        </div>\n      </fieldset>\n    </form>\n  </div>\n</div>");
$templateCache.put("src/module/recDebug/review/review.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n        <form class=\"form-horizontal recdebug-review\">\n            <fieldset class=\"mt-sm\">\n                <legend class=\"section\">推荐信息</legend>\n                <div class=\"col-xs-12 form-group\">\n                    <label class=\"control-label\">appname：</label>\n                    <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                    <label class=\"control-label\">appid：</label>\n                    <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                    <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"search()\">搜索</button>\n                    &nbsp;&nbsp;\n                    <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"reset()\">重置</button>\n                </div>\n                <div class=\"col-xs-12 form-group\">\n                    <label class=\"control-label\">推荐日期：</label>\n                    <date-picker ng-model=\"params.date\" class=\"input-fixed\" disable-clear></date-picker>\n                </div>\n                <div>\n                    <div class=\"start-time\">\n                        <label class=\"control-label\">开始时间:</label>\n                        <uib-timepicker ng-model=\"start_time\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"false\"></uib-timepicker>\n                    </div>\n                    <div class=\"end-time\">\n                        <label class=\"control-label\">结束时间:</label>\n                        <uib-timepicker ng-model=\"end_time\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"false\"></uib-timepicker>\n                    </div>\n                </div>\n\n                <div class=\"form-group\"></div>\n                <div class=\"col-xs-12 form-group\" ng-repeat=\"item in params.itemid_list track by $index\">\n                    <label class=\"control-label\" ng-class=\"{\'visible-none\': $index !== 0}\">item信息：</label>\n                    <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.itemid_list[$index]\" placeholder=\"请输入itemid\"> &nbsp;&nbsp;\n                    <span class=\"add-style\" ng-click=\"removeItem($index)\">\n                        <i class=\"fa fa-trash-o\"></i> 删除</span>\n                    &nbsp;&nbsp;&nbsp;\n                    <span class=\"add-style\" ng-click=\"addItem()\" ng-show=\"$index == params.itemid_list.length - 1\">\n                        <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n                </div>\n            </fieldset>\n            <fieldset class=\"mt-sm\">\n                <legend class=\"section\">推荐结果</legend>\n                <div class=\"col-xs-12 review-panel\">\n                    <div class=\"col-xs-12 form-group\" ng-repeat=\"item in results.params\">\n                        <label class=\"label-fixed-width control-label\" ng-bind=\"item.name + \'：\'\"></label>\n                        <label class=\"col-xs-8 label-align-left\" ng-bind=\"data[item.key]\"></label>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\">\n                    <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n                        <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                            <tr ng-repeat=\"item in $data track by $index\">\n                                <td data-title=\"\'序号\'\" ng-bind=\"$index\"></td>\n                                <td data-title=\"\'itemid\'\" ng-bind=\"item.itemid\"></td>\n                                <td data-title=\"\'产品名称\'\" ng-bind=\"item.title\"></td>\n                                <td data-title=\"\'cateid\'\" ng-bind=\"item.cateid\"></td>\n                                <td data-title=\"\'tag\'\" ng-bind=\"item.item_tags\"></td>\n                                <td data-title=\"\'modify_time\'\" ng-bind=\"item.item_modify_time\"></td>\n                                <td data-title=\"\'alg_type\'\" ng-bind=\"item.alg_type\"></td>\n                            </tr>\n                        </table>\n                    </div>\n                </div>\n            </fieldset>\n        </form>\n    </div>\n</div>");
$templateCache.put("src/module/reviewDict/dialog/dialog.html","<div class=\"modal-header\">\n  <dialog-close close=\"cancel()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"legend\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"reviewdictForm\" novalidate>\n  <fieldset>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\">\n        <span class=\"required\"></span>appid</label>\n      <div class=\"col-sm-7\">\n        <input type=\"text\" name=\"appid\" ng-model=\"reviewdict.appid\" class=\"form-control\" required>\n        <p ng-show=\"reviewdictForm.appid.$dirty && reviewdictForm.appid.$error.required\" class=\"text-danger\">\n          <span>appid是必填的</span>\n        </p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\">\n        <span class=\"required\"></span>type</label>\n      <div class=\"col-sm-7\">\n        <select class=\"form-control\" ng-model=\"reviewdict.type\" ng-options=\"type for type in typeList\">\n        </select>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\">\n        <span class=\"required\"></span>word</label>\n      <div class=\"col-sm-7\">\n        <input type=\"text\" name=\"word\" ng-model=\"reviewdict.word\" class=\"form-control\" required>\n        <p ng-show=\"reviewdictForm.word.$dirty && reviewdictForm.word.$error.required\" class=\"text-danger\">\n          <span>word是必填的</span>\n        </p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\">\n        <span class=\"required\"></span>level</label>\n      <div class=\"col-sm-7\">\n        <select class=\"form-control\" ng-model=\"reviewdict.level\" ng-options=\"level for level in levelList\">\n        </select>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\">\n        <span class=\"required\"></span>pinyin</label>\n      <div class=\"col-sm-7\">\n        <select class=\"form-control\" ng-model=\"reviewdict.pinyin\" ng-options=\"pinyin for pinyin in pinyinList\">\n        </select>\n      </div>\n    </div>\n  </fieldset>\n  <div class=\"form-action\">\n    <div class=\"text-center\">\n      <button type=\"button\" class=\"btn btn-primary\" ng-click=\"save()\" ng-disabled=\"validation()\">保存</button>\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"cancel()\">取消</button>\n    </div>\n  </div>\n</form>");
$templateCache.put("src/module/searchConfig/dialog/dialog.html","<div class=\"disable-modal-blur\"></div>\n<div class=\"modal-header\">\n  <dialog-close close=\"back()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"legend\"></h3>\n</div>\n<form name=\"fieldConfig\" class=\"form-horizontal small-form\" novalidate>\n  <fieldset>\n    <div class=\"form-group\">\n      <label for=\"appid\" class=\"col-xs-3 control-label\">appid</label>\n      <div class=\"col-xs-9\">\n        <input ng-model=\"field.appid\" type=\"text\" class=\"form-control\" name=\"appid\" required id=\"appid\" disabled=\"disabled\">\n        <form-message label=\"field_name\" name=\"field_name\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"field_name\" class=\"col-xs-3 control-label\">field_name</label>\n      <div class=\"col-xs-9\">\n        <input ng-model=\"field.field_name\" type=\"text\" class=\"form-control\" name=\"field_name\" required id=\"field_name\">\n        <form-message label=\"field_name\" name=\"field_name\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"index_type\" class=\"col-xs-3 control-label\">index_type</label>\n      <div class=\"col-xs-9\">\n        <input ng-model=\"field.index_type\" type=\"text\" class=\"form-control\" name=\"index_type\" required id=\"index_type\">\n        <form-message label=\"index_type\" name=\"index_type\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"field_weight\" class=\"col-xs-3 control-label\">field_weight</label>\n      <div class=\"col-xs-9\">\n        <input ng-model=\"field.field_weight\" type=\"text\" class=\"form-control\" name=\"field_weight\" required id=\"field_weight\">\n        <form-message label=\"field_weight\" name=\"field_weight\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"field_type\" class=\"col-xs-3 control-label\">field_type</label>\n      <div class=\"col-xs-9\">\n        <input ng-model=\"field.field_type\" type=\"text\" class=\"form-control\" name=\"field_type\" required id=\"field_type\">\n        <form-message label=\"field_type\" name=\"field_type\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"is_multi_value\" class=\"col-xs-3 control-label\">is_multi_value</label>\n      <div class=\"col-xs-9\">\n        <input ng-model=\"field.is_multi_value\" type=\"text\" class=\"form-control\" required name=\"is_multi_value\" id=\"is_multi_value\">\n        <form-message label=\"is_multi_value\" name=\"is_multi_value\"></form-message>\n      </div>\n    </div>\n  </fieldset>\n  <div class=\"form-action\">\n    <div class=\"text-center\">\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\" ng-disabled=\"fieldConfig.$invalid\">保存</button>\n      <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel()\">取消</button>\n    </div>\n  </div>\n</form>");
$templateCache.put("src/module/searchConfig/item/item.html","<fixed-content title=\"title\" go-state=\"\'searchConfig\'\">\n  <fieldset>\n    <legend class=\"section\">search config</legend>\n    <form class=\"form-horizontal\" role=\"form\" name=\"searchConfigForm\" novalidate>\n      <div class=\"form-group\">\n        <label for=\"id\" class=\"col-xs-3 control-label\">appid</label>\n        <div class=\"col-xs-9\">\n          <input ng-model=\"item.appid\" ng-disabled=\"!isCreate\" type=\"text\" class=\"form-control\" name=\"id\" id=\"id\" required>\n          <form-message label=\"id\" name=\"id\"></form-message>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"is_search_ready\" class=\"col-xs-3 control-label\">is_search_ready</label>\n        <div class=\"col-xs-9\">\n          <input ng-model=\"item.is_search_ready\" type=\"text\" class=\"form-control\" required name=\"is_search_ready\" id=\"is_search_ready\">\n          <form-message label=\"is_search_ready\" name=\"is_search_ready\"></form-message>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"app_category\" class=\"col-xs-3 control-label\">app_category</label>\n        <div class=\"col-xs-9\">\n          <input ng-model=\"item.app_category\" type=\"text\" class=\"form-control\" name=\"app_category\" required id=\"app_category\">\n          <form-message label=\"app_category\" name=\"app_category\"></form-message>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"app_item_count\" class=\"col-xs-3 control-label\">app_item_count</label>\n        <div class=\"col-xs-9\">\n          <input ng-model=\"item.app_item_count\" type=\"text\" class=\"form-control\" name=\"app_item_count\" required id=\"app_item_count\">\n          <form-message label=\"app_item_count\" name=\"app_item_count\"></form-message>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"is_auto_create\" class=\"col-xs-3 control-label\">is_auto_create</label>\n        <div class=\"col-xs-9\">\n          <input ng-model=\"item.is_auto_create\" type=\"text\" class=\"form-control\" name=\"is_auto_create\" required id=\"is_auto_create\">\n          <form-message label=\"is_auto_create\" name=\"is_auto_create\"></form-message>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-xs-3\"></label>\n        <div class=\"col-xs-9\">\n          <button class=\"btn btn-primary\" ng-click=\"save()\" ng-disabled=\"searchConfigForm.$invalid\">保存</button> &nbsp;\n          <button class=\"btn btn-default\" ng-click=\"backParent()\">取消</button>\n        </div>\n      </div>\n    </form>\n    <legend ng-if=\"!isCreate\">fields config</legend>\n    <!-- fileds list box -->\n    <div class=\"box box-default box-solid\" ng-repeat=\"keyword in FIELDS_LIST track by $index\" ng-init=\"tmp[keyword + \'Keyword\'] = \'\'\" ng-if=\"!isCreate\">\n      <div class=\"box-header with-border\" ng-click=\"tmp[keyword + \'Show\'] = !tmp[keyword + \'Show\']\">\n        <p ng-bind=\"keyword\"></p>\n        <div class=\"box-tools pull-right\">\n          <span class=\"badge bg-light-blue\" ng-bind=\"item[keyword].length\"></span>\n          <button class=\"btn btn-box-tool\">\n            <i class=\"fa\" ng-class=\"{\'fa-minus\': !tmp[keyword + \'Show\'], \'fa-plus\': tmp[keyword + \'Show\']}\"></i>\n          </button>\n        </div>\n      </div>\n      <!-- /.box-header -->\n      <div uib-collapse=\"tmp[keyword + \'Show\']\" class=\"box-body\">\n        <table class=\"table table-bordered table-hover table-layout-fixed\">\n          <colgroup>\n            <col>\n            <col width=\"140px\">\n          </colgroup>\n          <thead>\n          <tr>\n            <th ng-bind=\"keyword + \' name\'\"></th>\n            <th>操作</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr>\n            <td>\n              <input type=\"text\" ng-model=\"tmp[keyword + \'Keyword\']\" placeholder=\"搜索field name\" class=\"form-control\">\n            </td>\n            <td>\n              <button class=\"btn btn-primary btn-sm btn-flat\" ng-click=\"editField(null, item.appid, keyword)\">\n                <i class=\"fa fa-plus\"></i>添加 field\n              </button>\n            </td>\n          </tr>\n          <tr ng-repeat=\"actionType in item[keyword] track by $index\" ng-show=\"item[keyword][$index].search(tmp[keyword + \'Keyword\']) > -1\" ng-init=\"tmp[keyword + \'ItemShow\'] = []\">\n            <td>\n              <p ng-bind=\"item[keyword][$index]\" class=\"\"></p>\n            </td>\n            <td>\n              <div ng-show=\"tmp[keyword + \'ItemShow\'][$index]\">\n                <button class=\"btn btn-danger btn-sm btn-flat\" ng-click=\"removeItem(item[keyword][$index])\">\n                  删除\n                </button>\n                <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"tmp[keyword + \'ItemShow\'][$index] = false\">\n                  取消\n                </button>\n              </div>\n              <div ng-show=\"!tmp[keyword + \'ItemShow\'][$index]\">\n                <button class=\"btn btn-danger btn-sm btn-flat\" ng-click=\"tmp[keyword + \'ItemShow\'][$index] = true\">\n                  删除\n                </button>\n                <button class=\"btn btn-primary btn-sm btn-flat\" ng-click=\"editField(item[keyword][$index], item.appid)\">\n                  修改\n                </button>\n              </div>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n      <!-- /.box-body -->\n    </div>\n    <!-- /.fileds list box  -->\n  </fieldset>\n</fixed-content>");
$templateCache.put("src/module/serviceAlarm/dialog/dialog.html","<div class=\"modal-header\">\n  <dialog-close close=\"back()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"legend\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"serviceAlarmForm\" novalidate>\n  <fieldset>\n    <legend class=\"section\">报警信息</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">项目名称:</label>\n      <div class=\"col-sm-10\">\n        <p class=\"form-control-static\" ng-bind=\"serviceAlarmItem.project_name\"></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">app name:</label>\n      <div class=\"col-sm-10\">\n        <p class=\"form-control-static\" ng-bind=\"serviceAlarmItem.app_name\"></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">功能:</label>\n      <div class=\"col-sm-10\">\n        <p class=\"form-control-static\" ng-bind=\"ALARM_API_MAPPING[serviceAlarmItem.alarm_api]\"></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">报警类型:</label>\n      <div class=\"col-sm-10\">\n        <p class=\"form-control-static\" ng-bind=\"ALARM_TYPE_MAPPING[serviceAlarmItem.alarm_type]\"></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">报警详情:</label>\n      <div class=\"col-sm-10\">\n        <p ng-if=\"serviceAlarmItem.detail.indexOf(\'\\n\') == -1\" class=\"form-control-static\">\n                <span ng-repeat=\"string in serviceAlarmItem.detail.split(\'，\')\" ng-bind-html=\"handleHighLightString(string)\"></span>\n        </p>\n        <p ng-if=\"serviceAlarmItem.detail.indexOf(\'\\n\') > -1\" class=\"form-control-static\">\n                <span ng-repeat=\"string in serviceAlarmItem.detail.split(\'\\n\')[0].split(\'，\')\" ng-bind-html=\"handleHighLightString(string)\"></span>；\n          <span ng-repeat=\"string in serviceAlarmItem.detail.split(\'\\n\')[1].split(\'，\')\" ng-bind-html=\"handleHighLightString(string)\"></span>\n        </p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">报警时间:</label>\n      <div class=\"col-sm-10\">\n        <p class=\"form-control-static\" ng-bind=\"serviceAlarmItem.alarm_time.substring(0,10)\"></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">负责人:</label>\n      <div class=\"col-sm-10\">\n        <p class=\"form-control-static\" ng-bind=\"manager[serviceAlarmItem.manager_id]\"></p>\n      </div>\n    </div>\n    <legend class=\"section\">跟进信息</legend>\n    <div class=\"form-group\" ng-if=\"type === \'detail\'\">\n      <label class=\"col-sm-2 control-label\">报警状态:</label>\n      <div class=\"col-sm-10\">\n        <p class=\"form-control-static\" ng-bind=\"ALARM_STATUS_MAPPING[serviceAlarmItem.status]\"></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">问题原因:</label>\n      <div class=\"col-sm-8\">\n        <p class=\"form-control-static\" ng-bind=\"serviceAlarmItem.reason\" ng-if=\"type !== \'follow\' || !canEditReason\"></p>\n        <textarea class=\"form-control\" ng-model=\"serviceAlarmItem.reason\" required ng-if=\"type === \'follow\' && canEditReason\" placeholder=\"问题原因\"></textarea>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\" ng-bind=\"type === \'follow\' ? \'最新跟进:\' : \'问题跟进:\'\"></label>\n      <div class=\"col-sm-8\">\n        <ul class=\"list-unstyled\">\n          <li ng-repeat=\"item in serviceAlarmItem.follow_detail\">\n            <p class=\"form-control-static small\">\n              <span ng-bind=\"item.date_time\"></span>\n              <span ng-bind=\"manager[item.manager_id]\"></span>\n            </p>\n            <p class=\"form-control-static\" ng-bind=\"item.reason\"></p>\n          </li>\n        </ul>\n        <textarea class=\"form-control\" ng-model=\"serviceAlarmItem.detailReason\" required ng-if=\"type == \'follow\'\" placeholder=\"填写报警问题最新更近\"></textarea>\n      </div>\n    </div>\n    <div class=\"form-group\" ng-if=\"type == \'follow\'\">\n      <label class=\"col-sm-2 control-label\">报警状态:</label>\n      <div class=\"col-sm-8\">\n        <select ng-model=\"serviceAlarmItem.status\" class=\"form-control\">\n          <option value=\"{{item.status}}\" ng-bind=\"item.text\" ng-repeat=\"item in statusList\" ng-selected=\"item.status == serviceAlarmItem.status\"></option>\n        </select>\n        <p class=\"help-block small\">*如选择“已解决”，提交后状态为“待审核”，审核通过后状态为“已解决”，不通过则还是“跟进中”</p>\n      </div>\n    </div>\n    <legend class=\"section\" ng-if=\"type === \'review\'\">待审核信息</legend>\n    <div class=\"form-group\" ng-if=\"type === \'review\'\">\n      <label class=\"col-sm-2 control-label\">报警状态:</label>\n      <div class=\"col-sm-10\">\n        <p class=\"form-control-static\" ng-bind=\"ALARM_STATUS_MAPPING[serviceAlarmItem.status]\"></p>\n      </div>\n    </div>\n  </fieldset>\n  <div class=\"form-action\" ng-if=\"type == \'review\'\">\n    <div class=\"text-center\">\n      <button class=\"btn btn-primary\" ng-click=\"updateStatus(3)\">已解决</button>\n      <button class=\"btn btn-default\" ng-click=\"updateStatus(1)\">未解决</button>\n    </div>\n  </div>\n  <div class=\"form-action\" ng-if=\"type == \'follow\'\">\n    <div class=\"text-center\">\n      <button class=\"btn btn-primary\" ng-click=\"save()\" ng-disabled=\"serviceAlarmForm.$invalid\">保存</button>\n      <button class=\"btn btn-default\" ng-click=\"cancel()\">取消</button>\n    </div>\n  </div>\n</form>");
$templateCache.put("src/module/strategyEffectStatistics/day/day.html","<div class=\"box-body table-responsive scroll-table\">\n  <div class=\"box-body\">\n    <form class=\"form-horizontal recdebug-review\">\n      <fieldset class=\"mt-sm\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">推荐日期：</label>\n              <div class=\"col-xs-8\">\n                <period-date-picker ng-model=\"filterDate\" disable-clear disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">appname：</label>\n              <div class=\"col-xs-8\">\n                <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">appid：</label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-xs-12 col-sm-3\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">scene_type：</label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"query.scene_type\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">rec_type：</label>\n              <div class=\"col-xs-8\">\n                <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.rec_type\" item-list=\"rec_type\" item-name=\"key\"></dg-combo-box>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">alg_type：</label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"query.alg_type\">\n              </div>\n            </div>\n          </div>\n        </div>\n\n\n        <div class=\"row text-center\">\n          <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n        </div>\n      </fieldset>\n\n      <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n        <legend class=\"section\"></legend>\n        <div class=\"col-xs-12\">\n          <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n            <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n              <tr ng-repeat=\"item in $data track by $index\">\n                <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                <td data-title=\"\'rec_type\'\" align=\"center\" ng-bind=\"item.rec_type\"></td>\n                <td data-title=\"\'scene_type\'\" align=\"center\" ng-bind=\"item.scene_type\"></td>\n                <td data-title=\"\'alg_type\'\" align=\"center\" ng-bind=\"item.alg_type\"></td>\n                <td data-title=\"\'pv\'\" sortable=\"\'pv\'\" align=\"center\" ng-bind=\"item.pv\"></td>\n                <td data-title=\"\'pv_ratio\'\" sortable=\"\'pv_ratio\'\" align=\"center\" ng-bind=\"item.pv_ratio+ \'%\'\"></td>\n                <td data-title=\"\'click\'\" sortable=\"\'click\'\" align=\"center\" ng-bind=\"item.click\"></td>\n                <td data-title=\"\'ctr\'\" sortable=\"\'ctr\'\" align=\"center\" ng-bind=\"item.ctr+ \'%\'\"></td>\n              </tr>\n            </table>\n          </div>\n        </div>\n      </fieldset>\n    </form>\n  </div>\n</div>");
$templateCache.put("src/module/strategyEffectStatistics/dayOverall/dayOverall.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n        <form class=\"form-horizontal recdebug-review\">\n            <fieldset class=\"mt-sm\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12 col-sm-4\">\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-4 control-label\">推荐日期：</label>\n                            <div class=\"col-xs-8\">\n                                <period-date-picker ng-model=\"filterDate\" disable-clear disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"col-xs-12 col-sm-4\">\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-4 control-label\">appname：</label>\n                            <div class=\"col-xs-8\">\n                                <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"col-xs-12 col-sm-4\">\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-4 control-label\">appid：</label>\n                            <div class=\"col-xs-8\">\n                                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"col-xs-12 col-sm-3\">\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-4 control-label\">scene_type：</label>\n                            <div class=\"col-xs-8\">\n                                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"query.scene_type\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-xs-12 col-sm-4\">\n                        <div class=\"form-group\">\n                            <label class=\"col-xs-4 control-label\">rec_type：</label>\n                            <div class=\"col-xs-8\">\n                                <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.rec_type\" item-list=\"rec_type\" item-name=\"key\"></dg-combo-box>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n                <div class=\"row text-center\">\n                    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n                </div>\n            </fieldset>\n\n            <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n                <legend class=\"section\"></legend>\n                <div class=\"col-xs-12\">\n                    <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n                        <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                            <tr ng-repeat=\"item in $data track by $index\">\n                                <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                                <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                                <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                                <td data-title=\"\'rec_type\'\" align=\"center\" ng-bind=\"item.rec_type\"></td>\n                                <td data-title=\"\'scene_type\'\" align=\"center\" ng-bind=\"item.scene_type\"></td>\n                                <td data-title=\"\'pv\'\" align=\"center\" sortable=\"\'pv\'\" ng-bind=\"item.pv\"></td>\n                                <td data-title=\"\'diff_pv\'\" align=\"center\" ng-bind=\"item.diff_pv\"></td>\n                                <td data-title=\"\'click\'\" align=\"center\" sortable=\"\'click\'\" ng-bind=\"item.click\"></td>\n                                <td data-title=\"\'diff_click\'\" align=\"center\" ng-bind=\"item.diff_click\"></td>\n                                <td data-title=\"\'ctr\'\" align=\"center\" sortable=\"\'ctr\'\" ng-bind=\"item.ctr+ \'%\'\"></td>\n                                <td data-title=\"\'diff_ctr\'\" align=\"center\" ng-bind=\"item.diff_ctr\"></td>\n                            </tr>\n                        </table>\n                    </div>\n                </div>\n            </fieldset>\n        </form>\n    </div>\n</div>");
$templateCache.put("src/module/strategyEffectStatistics/hourly/hourly.html","<div class=\"box-body table-responsive scroll-table\">\n  <div class=\"box-body\">\n    <form class=\"form-horizontal recdebug-review\">\n      <fieldset class=\"mt-sm\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">推荐日期：</label>\n              <div class=\"col-xs-8\">\n                <period-date-picker ng-model=\"filterDate\" disable-clear disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">appname：</label>\n              <div class=\"col-xs-8\">\n                <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">appid：</label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-xs-12 col-sm-3\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 control-label\">scene_type：</label>\n              <div class=\"col-xs-7\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"query.scene_type\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">rec_type：</label>\n              <div class=\"col-xs-8\">\n                <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.rec_type\" item-list=\"rec_type\" item-name=\"key\"></dg-combo-box>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">alg_type：</label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"query.alg_type\">\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-3\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 control-label\">hour：</label>\n              <div class=\"col-xs-7\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.hour_ori\">\n              </div>\n            </div>\n          </div>\n        </div>\n\n\n\n\n        <div class=\"row text-center\">\n          <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n        </div>\n      </fieldset>\n\n      <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n        <legend class=\"section\"></legend>\n        <div class=\"col-xs-12\">\n          <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n            <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n              <tr ng-repeat=\"item in $data track by $index\">\n                <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                <td data-title=\"\'hour\'\" sortable=\"\'hour\'\" align=\"center\" ng-bind=\"item.hour\"></td>\n                <td data-title=\"\'rec_type\'\" align=\"center\" ng-bind=\"item.rec_type\"></td>\n                <td data-title=\"\'scene_type\'\" align=\"center\" ng-bind=\"item.scene_type\"></td>\n                <td data-title=\"\'alg_type\'\" align=\"center\" ng-bind=\"item.alg_type\"></td>\n                <td data-title=\"\'pv\'\" sortable=\"\'pv\'\" align=\"center\" ng-bind=\"item.pv\"></td>\n                <td data-title=\"\'pv_ratio\'\" sortable=\"\'pv_ratio\'\" align=\"center\" ng-bind=\"item.pv_ratio+ \'%\'\"></td>\n                <td data-title=\"\'click\'\" sortable=\"\'click\'\" align=\"center\" ng-bind=\"item.click\"></td>\n                <td data-title=\"\'ctr\'\" sortable=\"\'ctr\'\" align=\"center\" ng-bind=\"item.ctr+ \'%\'\"></td>\n              </tr>\n            </table>\n          </div>\n        </div>\n      </fieldset>\n    </form>\n  </div>\n</div>");
$templateCache.put("src/module/strategyEffectStatistics/hourlyOverall/hourlyOverall.html","<div class=\"box-body table-responsive scroll-table\">\n  <div class=\"box-body\">\n    <form class=\"form-horizontal recdebug-review\">\n      <fieldset class=\"mt-sm\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">推荐日期：</label>\n              <div class=\"col-xs-8\">\n                <period-date-picker ng-model=\"filterDate\" disable-clear disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">appname：</label>\n              <div class=\"col-xs-8\">\n                <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">appid：</label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-xs-12 col-sm-3\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">scene_type：</label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"query.scene_type\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">rec_type：</label>\n              <div class=\"col-xs-8\">\n                <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.rec_type\" item-list=\"rec_type\" item-name=\"key\"></dg-combo-box>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-4\">\n            <div class=\"form-group\">\n              <label class=\"col-xs-4 control-label\">hour：</label>\n              <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.hour_ori\">\n              </div>\n            </div>\n          </div>\n        </div>\n\n\n\n\n\n        <div class=\"row text-center\">\n          <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n        </div>\n      </fieldset>\n\n      <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n        <legend class=\"section\"></legend>\n        <div class=\"col-xs-12\">\n          <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n            <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n              <tr ng-repeat=\"item in $data track by $index\">\n                <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                <td data-title=\"\'hour\'\" align=\"center\" sortable=\"\'hour\'\" ng-bind=\"item.hour\"></td>\n                <td data-title=\"\'rec_type\'\" align=\"center\" ng-bind=\"item.rec_type\"></td>\n                <td data-title=\"\'scene_type\'\" align=\"center\" ng-bind=\"item.scene_type\"></td>\n                <td data-title=\"\'pv_ratio\'\" align=\"center\" sortable=\"\'pv_ratio\'\" ng-bind=\"item.pv_ratio+ \'%\'\"></td>\n                <td data-title=\"\'diff_pv_ratio\'\" align=\"center\" ng-bind=\"item.diff_pv_ratio\"></td>\n                <td data-title=\"\'pv\'\" sortable=\"\'pv\'\" align=\"center\" ng-bind=\"item.pv\"></td>\n                <td data-title=\"\'diff_pv\'\" align=\"center\" ng-bind=\"item.diff_pv\"></td>\n                <td data-title=\"\'click\'\" sortable=\"\'click\'\" align=\"center\" ng-bind=\"item.click\"></td>\n                <td data-title=\"\'diff_click\'\" align=\"center\" ng-bind=\"item.diff_click\"></td>\n                <td data-title=\"\'ctr\'\" sortable=\"\'ctr\'\" align=\"center\" ng-bind=\"item.ctr+ \'%\'\"></td>\n                <td data-title=\"\'diff_ctr\'\" align=\"center\" ng-bind=\"item.diff_ctr\"></td>\n              </tr>\n            </table>\n          </div>\n        </div>\n      </fieldset>\n    </form>\n  </div>\n</div>");
$templateCache.put("src/module/strategyEffectStatistics/whiteList/whiteList.html","<div class=\"box-body table-responsive scroll-table\">\n  <div class=\"box-body\">\n    <form class=\"form-horizontal recdebug-review\">\n      <fieldset class=\"mt-sm\">\n      \n        <div class=\"col-xs-12 form-group\">\n          <label class=\"control-label\">appname：</label>\n          <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n          <label class=\"control-label\">appid：</label>\n          <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n          <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"add()\">新增白名单</button>\n          <dg-search-input ng-model=\"search.query\" search=\"searchMethod()\" placeholder=\"appname/appid\" type=\"button\"></dg-search-input>\n        </div>\n      </fieldset>\n      <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n        <legend class=\"section\"></legend>\n        <div class=\"col-xs-12\">\n          <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n            <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n              <tr ng-repeat=\"item in $data track by $index\">\n                <td align=\"center\" data-title=\"\'appname\'\" ng-bind=\"item.appname\"></td>\n                <td align=\"center\" data-title=\"\'appid\'\" ng-bind=\"item.appid\"></td>\n                <td align=\"center\" data-title=\"\'创建时间\'\" ng-bind=\"item.create_time\"></td>\n                <td align=\"center\" data-title=\"\'操作\'\">\n                  <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"del(item)\">删除</button>\n                </td>\n              </tr>\n            </table>\n          </div>\n        </div>\n      </fieldset>\n    </form>\n  </div>\n</div>");
$templateCache.put("src/module/strategyPerformanceStatistics/appTimeProcess/appTimeProcess.html","<div class=\"box-body table-responsive scroll-table\">\n        <div class=\"box-body\">\n          <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n            <fieldset class=\"mt-sm\">\n              <div class=\"row state-switch-button-groups\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">nearline/online：</label>\n                    <div class=\"col-xs-6\">\n                      <span class=\"btn\" ng-class=\"params.lineState == \'nearline\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'nearline\'; search()\">nearline</span>\n                      <sapn class=\"btn\" ng-class=\"params.lineState == \'online\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'online\'; search()\">online\n                    </sapn></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">data_time：</label>\n                    <div class=\"col-xs-8\">\n                      <period-date-picker ng-model=\"filterDate\" disable-clear disable-today completion-time></period-date-picker>\n                    </div>\n                  </div>\n                </div>\n              </div>\n      \n              <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">appname：</label>\n                    <div class=\"col-xs-8\">\n                      <div class=\"per63\">\n                        <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n      \n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-3 control-label\">appid：</label>\n                    <div class=\"col-xs-8 per58\">\n                      <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                    </div>\n                  </div>\n                </div>\n              </div>\n              \n              <div class=\"row text-center\">\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n              </div>\n\n            </fieldset>\n      \n            <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n              <legend class=\"section\"></legend>\n              <div class=\"col-xs-12\">\n                <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n                  <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                    <tr ng-repeat=\"item in $data track by $index\">\n                      <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                      <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                      <td data-title=\"\'nearline/online\'\" align=\"center\" ng-bind=\"item.line\"></td>\n                      <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                      <td data-title=\"\'time_slot\'\" sortable=\"\'time_slot\'\" align=\"center\" ng-bind=\"item.time_slot\"></td>\n                      <td data-title=\"\'avg_handle_time\'\" sortable=\"\'avg_handle_time\'\" align=\"center\" ng-bind=\"item.avg_handle_time\"></td>\n                      <td data-title=\"\'over_50\'\" sortable=\"\'over_50\'\" align=\"center\" ng-bind=\"item.over_50\"></td>\n                      <td data-title=\"\'over_200\'\" sortable=\"\'over_200\'\" align=\"center\" ng-bind=\"item.over_200\"></td>\n                      <td data-title=\"\'over_500\'\" sortable=\"\'over_500\'\" align=\"center\" ng-bind=\"item.over_500\"></td>\n                      <td data-title=\"\'over_1000\'\" sortable=\"\'over_1000\'\" align=\"center\" ng-bind=\"item.over_1000\"></td>\n                    </tr>\n                  </table>\n                </div>\n              </div>\n            </fieldset>\n          </form>\n        </div>\n      </div>");
$templateCache.put("src/module/strategyPerformanceStatistics/dayApp/dayApp.html","<div class=\"box-body table-responsive scroll-table\">\n        <div class=\"box-body\">\n          <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n            <fieldset class=\"mt-sm\">\n              <div class=\"row state-switch-button-groups\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">nearline/online：</label>\n                    <div class=\"col-xs-6\">\n                      <span class=\"btn\" ng-class=\"params.lineState == \'nearline\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'nearline\'; search()\">nearline</span>\n                      <sapn class=\"btn\" ng-class=\"params.lineState == \'online\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'online\'; search()\">online\n                    </sapn></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">data_time：</label>\n                    <div class=\"col-xs-8\">\n                      <period-date-picker ng-model=\"filterDate\" disable-clear disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n                    </div>\n                  </div>\n                </div>\n              </div>\n      \n              <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">appname：</label>\n                    <div class=\"col-xs-7\">\n                      <div class=\"per63\">\n                        <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n      \n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-3 control-label\">appid：</label>\n                    <div class=\"col-xs-8 per58\">\n                      <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"row text-center\">\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n              </div>\n            </fieldset>\n      \n            <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n              <legend class=\"section\"></legend>\n              <div class=\"col-xs-12\">\n                <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n                  <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                    <tr ng-repeat=\"item in $data track by $index\">\n                      <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                      <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                      <td data-title=\"\'nearline/online\'\" align=\"center\" ng-bind=\"item.line\"></td>\n                      <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                      <td data-title=\"\'call_num\'\" sortable=\"\'call_num\'\" align=\"center\" ng-bind=\"item.call_num\"></td>\n                    </tr>\n                  </table>\n                </div>\n              </div>\n            </fieldset>\n          </form>\n        </div>\n      </div>");
$templateCache.put("src/module/strategyPerformanceStatistics/dayWhole/dayWhole.html","<div class=\"box-body table-responsive scroll-table\">\n        <div class=\"box-body\">\n          <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n            <fieldset class=\"mt-sm\">\n              <div class=\"row state-switch-button-groups\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">nearline/online：</label>\n                    <div class=\"col-xs-6\">\n                      <span class=\"btn\" ng-class=\"params.lineState == \'nearline\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'nearline\'; update()\">nearline</span>\n                      <sapn class=\"btn\" ng-class=\"params.lineState == \'online\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'online\'; update()\">online\n                    </sapn></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">data_time：</label>\n                    <div class=\"col-xs-8\">\n                      <period-date-picker ng-model=\"filterDate\" ng-change=\"update()\" disable-clear disable-today completion-time></period-date-picker>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </fieldset>\n      \n            <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n              <legend class=\"section\"></legend>\n              <div class=\"col-xs-12\">\n                <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n                  <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                    <tr ng-repeat=\"item in $data track by $index\">\n                      <td data-title=\"\'nearline/online\'\" align=\"center\" ng-bind=\"item.line\"></td>\n                      <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                      <td data-title=\"\'call_num\'\" sortable=\"\'call_num\'\" align=\"center\" ng-bind=\"item.call_num\"></td>\n                    </tr>\n                  </table>\n                </div>\n              </div>\n            </fieldset>\n          </form>\n        </div>\n      </div>");
$templateCache.put("src/module/strategyPerformanceStatistics/hourlyApp/hourlyApp.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n      <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n        <fieldset class=\"mt-sm\">\n          <div class=\"row state-switch-button-groups\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">nearline/online：</label>\n                <div class=\"col-xs-6\">\n                  <span class=\"btn\" ng-class=\"params.lineState == \'nearline\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'nearline\'; search()\">nearline</span>\n                  <sapn class=\"btn\" ng-class=\"params.lineState == \'online\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'online\'; search()\">online\n                </sapn></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">data_time：</label>\n                <div class=\"col-xs-8\">\n                  <period-date-picker ng-model=\"filterDate\" disable-clear disable-today completion-time></period-date-picker>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-xs-12 col-sm-5\">\n                <div class=\"form-group\">\n                  <label class=\"col-xs-3 control-label\">hour：</label>\n                  <div class=\"col-xs-7\">\n                    <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.hour_ori\">\n                  </div>\n                </div>\n              </div>\n          </div>\n  \n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">appname：</label>\n                <div class=\"col-xs-8\">\n                  <div class=\"per63\">\n                    <dg-combo-box class=\"input-fixed\" style=\"vertical-align:bottom;height:37px\" selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"appname\"></dg-combo-box>\n                  </div>\n                </div>\n              </div>\n            </div>\n  \n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-3 control-label\">appid：</label>\n                <div class=\"col-xs-8 per58\">\n                  <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n                </div>\n              </div>\n            </div>\n          </div>\n  \n          <div class=\"row text-center\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n          </div>\n        </fieldset>\n  \n        <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n          <legend class=\"section\"></legend>\n          <div class=\"col-xs-12\">\n            <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n              <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                <tr ng-repeat=\"item in $data track by $index\">\n                  <td data-title=\"\'appname\'\" align=\"center\" ng-bind=\"item.appname\"></td>\n                  <td data-title=\"\'appid\'\" align=\"center\" ng-bind=\"item.appid\"></td>\n                  <td data-title=\"\'nearline/online\'\" align=\"center\" ng-bind=\"item.line\"></td>\n                  <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                  <td data-title=\"\'hour\'\" sortable=\"\'hour\'\" align=\"center\" ng-bind=\"item.hour\"></td>\n                  <td data-title=\"\'call_num\'\" sortable=\"\'call_num\'\" align=\"center\" ng-bind=\"item.call_num\"></td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </fieldset>\n      </form>\n    </div>\n  </div>");
$templateCache.put("src/module/strategyPerformanceStatistics/hourlyWhole/hourlyWhole.html","<div class=\"box-body table-responsive scroll-table\">\n    <div class=\"box-body\">\n      <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n        <fieldset class=\"mt-sm\">\n          <div class=\"row state-switch-button-groups\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">nearline/online：</label>\n                <div class=\"col-xs-6\">\n                  <span class=\"btn\" ng-class=\"params.lineState == \'nearline\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'nearline\'; search()\">nearline</span>\n                  <sapn class=\"btn\" ng-class=\"params.lineState == \'online\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'online\'; search()\">online\n                </sapn></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\">data_time：</label>\n                <div class=\"col-xs-8\">\n                  <period-date-picker ng-model=\"filterDate\" disable-clear disable-today completion-time></period-date-picker>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-xs-12 col-sm-5\">\n              <div class=\"form-group\">\n                <label class=\"col-xs-3 control-label\">hour：</label>\n                <div class=\"col-xs-7 per62\">\n                  <input type=\"text\" class=\"form-control input-fixed\" ng-model=\"params.hour_ori\">\n                </div>\n              </div>\n            </div>\n          </div>\n          \n  \n          <div class=\"row text-center\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"search()\">&nbsp;&nbsp;搜索&nbsp;&nbsp;</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"reset()\">&nbsp;&nbsp;重置&nbsp;&nbsp;</button> &nbsp;&nbsp;&nbsp;&nbsp;\n          </div>\n        </fieldset>\n  \n        <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n          <legend class=\"section\"></legend>\n          <div class=\"col-xs-12\">\n            <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n              <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                <tr ng-repeat=\"item in $data track by $index\">\n                  <td data-title=\"\'nearline/online\'\" align=\"center\" ng-bind=\"item.line\"></td>\n                  <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                  <td data-title=\"\'hour\'\" sortable=\"\'hour\'\" align=\"center\" ng-bind=\"item.hour\"></td>\n                  <td data-title=\"\'call_num\'\" sortable=\"\'call_num\'\" align=\"center\" ng-bind=\"item.call_num\"></td>\n                </tr>\n              </table>\n            </div>\n          </div>\n        </fieldset>\n      </form>\n    </div>\n  </div>");
$templateCache.put("src/module/strategyPerformanceStatistics/wholeTimeProcess/wholeTimeProcess.html","<div class=\"box-body table-responsive scroll-table\">\n        <div class=\"box-body\">\n          <form class=\"form-horizontal recdebug-review strategy-performance-monitor\">\n            <fieldset class=\"mt-sm\">\n              <div class=\"row state-switch-button-groups\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">nearline/online：</label>\n                    <div class=\"col-xs-6\">\n                      <span class=\"btn\" ng-class=\"params.lineState == \'nearline\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'nearline\'; update()\">nearline</span>\n                      <sapn class=\"btn\" ng-class=\"params.lineState == \'online\' ? \'active\' : \'\' \" ng-click=\"params.lineState = \'online\'; update()\">online\n                    </sapn></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-5\">\n                  <div class=\"form-group\">\n                    <label class=\"col-xs-4 control-label\">data_time：</label>\n                    <div class=\"col-xs-8\">\n                      <period-date-picker ng-model=\"filterDate\" disable-clear disable-today ng-change=\"update()\" completion-time></period-date-picker>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </fieldset>\n      \n            <fieldset class=\"mt-sm\" style=\"margin-top:20px\">\n              <legend class=\"section\"></legend>\n              <div class=\"col-xs-12\">\n                <div loading-container=\"ngTableParams.settings().$loading\" class=\"box-body\">\n                  <table class=\"table table-hover table-bordered\" ng-table=\"ngTableParams\" template-pagination=\"src/common/pagination.html\">\n                    <tr ng-repeat=\"item in $data track by $index\">\n                      <td data-title=\"\'nearline/online\'\" align=\"center\" ng-bind=\"item.line\"></td>\n                      <td data-title=\"\'data_time\'\" align=\"center\" ng-bind=\"changeDateWord(item.data_time)\"></td>\n                      <td data-title=\"\'time_slot\'\" sortable=\"\'time_slot\'\" align=\"center\" ng-bind=\"item.time_slot\"></td>\n                      <td data-title=\"\'avg_handle_time\'\" sortable=\"\'avg_handle_time\'\" align=\"center\" ng-bind=\"item.avg_handle_time\"></td>\n                      <td data-title=\"\'over_50\'\" sortable=\"\'over_50\'\" align=\"center\" ng-bind=\"item.over_50\"></td>\n                      <td data-title=\"\'over_200\'\" sortable=\"\'over_200\'\" align=\"center\" ng-bind=\"item.over_200\"></td>\n                      <td data-title=\"\'over_500\'\" sortable=\"\'over_500\'\" align=\"center\" ng-bind=\"item.over_500\"></td>\n                      <td data-title=\"\'over_1000\'\" sortable=\"\'over_1000\'\" align=\"center\" ng-bind=\"item.over_1000\"></td>\n                    </tr>\n                  </table>\n                </div>\n              </div>\n            </fieldset>\n          </form>\n        </div>\n      </div>");
$templateCache.put("src/module/textReview/feedback/feedback.html","<style>\n  .form-group>select.form-control {\n    margin-right: 20px;\n  }\n</style>\n<div class=\"box-header\">\n  <form class=\"form-inline\">\n    <div class=\"form-group\">\n      <period-date-picker ng-model=\"params.date\" ng-init=\"params.date\" disable-clear ng-change=\"method.query()\" disable-today max-date=\"params.maxDate\" completion-time></period-date-picker>\n      <span>反馈类型：</span>\n      <select class=\"form-control\" ng-model=\"data.feedbackTypeSelected\" ng-options=\"option.value as option.name for option in data.feedbackTypeList\" ng-change=\"method.query();\"></select>\n      <span>审核类型：</span>\n      <select class=\"form-control\" ng-model=\"data.reviewTypeSelected\" ng-options=\"option.value as option.name for option in data.reviewTypeList\" ng-change=\"method.query();\"></select>\n    </div>\n  </form>\n</div>\n<div class=\"box-body\">\n  <div class=\"total-num\" ng-bind=\"\'共查询到\' + total + \'个结果\'\"></div>\n  <div loading-container=\"tableParams.settings().$loading\" class=\"dg-table-holder\">\n    <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\" template-header=\"ng_table_header\">\n      <tbody>\n        <tr ng-repeat=\"statistic in $data track by $index\">\n          <td ng-bind=\"statistic.create_time.slice(0, 10)\" align=\"center\"></td>\n          <td ng-bind=\"statistic.app_name\" align=\"center\"></td>\n          <td align=\"left\" style=\"max-width:300px\" class=\"dg-text-overflow\">\n            <span ng-bind=\"statistic.content\" title=\"{{statistic.content}}\"></span>\n          </td>\n          <td ng-bind=\"statistic.user\" align=\"center\"></td>\n          <td ng-if=\"data.reviewTypeSelected === \'ad\'\" align=\"center\">\n            <span ng-bind=\"method.showText(statistic.origin_static_info.weight_ad)\"></span>\n            <span ng-bind=\"method.showNumber(statistic.origin_static_info.weight_ad)\"></span>\n            <!--<span ng-bind=\"method.showText(1)\"></span>-->\n            <!--<span ng-bind=\"method.showNumber(1)\"></span>-->\n          </td>\n          <td ng-if=\"data.reviewTypeSelected === \'nonsense\'\" align=\"center\">\n            <span ng-bind=\"method.showText(statistic.origin_static_info.weight_nonsense)\"></span>\n            <span ng-bind=\"method.showNumber(statistic.origin_static_info.weight_nonsense)\"></span>\n          </td>\n          <td ng-if=\"data.reviewTypeSelected === \'porn\'\" align=\"center\">\n            <span ng-bind=\"method.showText(statistic.origin_static_info.porn)\"></span>\n            <span ng-bind=\"method.showNumber(statistic.origin_static_info.porn)\"></span>\n          </td>\n          <td ng-if=\"data.reviewTypeSelected === \'politic\'\" align=\"center\">\n            <span ng-bind=\"method.showText(statistic.origin_static_info.politic)\"></span>\n            <span ng-bind=\"method.showNumber(statistic.origin_static_info.politic)\"></span>\n          </td>\n          <td ng-if=\"data.reviewTypeSelected === \'reaction\'\" align=\"center\">\n            <span ng-bind=\"method.showText(statistic.origin_static_info.reaction)\"></span>\n            <span ng-bind=\"method.showNumber(statistic.origin_static_info.reaction)\"></span>\n          </td>\n          <td align=\"center\">\n            <span style=\"margin-right:20px\" ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_ad != null && data.reviewTypeSelected == \'ad\'\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_ad == 1 ? \'广告评论\' : \'正常文本\'\"></span>\n            </span>\n            <span ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_nonsense != null && data.reviewTypeSelected == \'nonsense\'\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_nonsense == 1 ? \'低质量文本\': \'正常文本\'\" style=\"margin-right:10px\"></span>\n            </span>\n            <span style=\"margin-right:20px\" ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_politic != null && data.reviewTypeSelected == \'politic\'\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_politic == 1 ? \'涉政文本\' : \'正常文本\'\"></span>\n            </span>\n            <span ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_porn != null && data.reviewTypeSelected == \'porn\'\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_porn == 1 ? \'涉黄文本\': \'正常文本\'\" style=\"margin-right:10px\"></span>\n            </span>\n            <span ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_reaction != null && data.reviewTypeSelected == \'reaction\'\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_reaction == 1 ? \'反动文本\': \'正常文本\'\" style=\"margin-right:10px\"></span>\n            </span>\n          </td>\n          <td align=\"center\" ng-bind=\"statistic.feedback_appname\"></td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n<script id=\"ng_table_header\" type=\"text/ng-template\">\n  <tr>\n    <th>反馈时间</th>\n    <th>app name</th>\n    <th>文本内容</th>\n    <th>用户昵称</th>\n    <th ng-show=\"data.reviewTypeSelected === \'ad\'\">\n      <span class=\"sort-indicator\">广告评论（权重）</span>\n    </th>\n    <th ng-show=\"data.reviewTypeSelected === \'nonsense\'\">\n      <span class=\"sort-indicator\">低质量文本（权重）</span>\n    </th>\n    <th ng-show=\"data.reviewTypeSelected === \'porn\'\">\n      <span class=\"sort-indicator\">涉黄文本（权重）</span>\n    </th>\n    <th ng-show=\"data.reviewTypeSelected === \'politic\'\">\n      <span class=\"sort-indicator\">涉政文本（权重）</span>\n    </th>\n    <th ng-show=\"data.reviewTypeSelected === \'reaction\'\">\n      <span class=\"sort-indicator\">反动文本（权重）</span>\n    </th>\n    <th ng-show=\"data.feedbackTypeSelected == \'0\'\">用户反馈</th>\n    <th ng-show=\"data.feedbackTypeSelected == \'1\'\">内部审核反馈</th>\n    <th>审核人员</th>\n  </tr>\n</script>");
$templateCache.put("src/module/textReview/manualReview/manualReview.html","<style type=\"text/css\">\n  .result .content-2 {\n    width: 98%;\n    padding: 10px 6px 10px 15px;\n    height: 320px;\n    border: 1px solid #edf5ff;\n    background-color: #edf5ff;\n  }\n  \n  .txt.normal {\n    color: #fff;\n    background-color: #1964a6;\n  }\n  \n  .txt.selected {\n    color: #fff;\n    background-color: #a1a1a1;\n  }\n  \n  .txt {\n    display: inline-block;\n    margin: 0 5px 10px;\n    padding: 0 8px;\n    height: 29px;\n    line-height: 29px;\n    color: #000;\n  }\n  \n  .pointerable {\n    cursor: pointer;\n  }\n  \n  dg-search-input {\n    float: right;\n  }\n  \n  label {\n    font-weight: normal;\n  }\n  \n  .weight-box input[type=\"text\"],\n  .btn-default.btn.small {\n    padding: 3px 6px;\n    height: 25px;\n    font-size: 12px;\n  }\n  \n  .form-horizontal .checkbox-inline,\n  .form-horizontal .radio-inline {\n    padding: 0 0 0 30px;\n  }\n  \n  .weight-box {\n    display: inline-block;\n    padding: 6px 12px;\n    box-sizing: content-box;\n    border: 1px solid #ffffff;\n  }\n  \n  .weight-box input.form-control[type=\"text\"] {\n    width: 55px;\n  }\n  \n  .weight-box .btn-default.btn[type=\"submit\"] {\n    display: none;\n  }\n  \n  .weight-box:hover .btn-default.btn[type=\"submit\"] {\n    display: inline-block;\n  }\n  \n  .weight-box:hover {\n    border: 1px solid #1976d2;\n  }\n  \n  .form-inline {\n    height: 40px;\n    margin: 10px 0;\n  }\n</style>\n<div class=\"box-header\">\n  <div class=\"form-horizontal\">\n    <!-- start: 审核类型 -->\n    <div class=\"form-inline\">\n      审核类型：\n      <select class=\"form-control\" ng-model=\"auditTypeSelect\" ng-options=\"option.value as option.name for option in auditType\" ng-change=\"clearWeight();cleanSort();keyword = \'\';query();\"></select>\n      <dg-search-input placeholder=\"请输入文本内容关键字\" ng-model=\"keyword\" search=\"query()\"></dg-search-input>\n      <dg-search-input placeholder=\"请输入 app name\" ng-model=\"appName\" search=\"query()\"></dg-search-input>\n    </div>\n    <!-- end: 审核类型 -->\n    <!-- start: 时间区段 -->\n    <div class=\"form-inline\">\n      时间区段：\n      <period-date-picker ng-model=\"query_params.date\" ng-init=\"query_params.date\" disable-clear ng-change=\"query()\" disable-today max-date=\"maxDate\"></period-date-picker>\n    </div>\n    <!-- end: 时间区段 -->\n    <!-- start: 文本类型 -->\n    <div class=\"form-inline inline-bar\">\n      文本类型：\n      <button class=\"btn btn-primary btn-sm\" type=\"button\" ng-click=\"clearWeight();clearRadioValue(); query()\">不限</button>\n      <div class=\"weight-box\" ng-click=\"clearWeight()\">\n        <div ng-repeat=\"item in auditType track by $index\" ng-if=\"auditTypeSelect == item.value\">\n          <label class=\"radio-inline\" ng-repeat=\"radio in item.radio\">\n            <input type=\"radio\" name=\"{{\'is_\' + item.value}}\" ng-model=\"query_params[item.modelName]\" ng-change=\"query()\" ng-value=\"{{radio.value}}\">{{radio.text}}\n          </label>\n        </div>\n      </div>\n      <div class=\"weight-box\">\n        自定义：\n        <input type=\"text\" class=\"form-control\" ng-model=\"weightStart\" ng-change=\"watchWeight(\'weightStart\')\"> 至\n        <input type=\"text\" class=\"form-control\" ng-model=\"weightEnd\" ng-change=\"watchWeight(\'weightEnd\')\">\n        <button type=\"submit\" class=\"btn btn-primary btn-sm\" ng-click=\"queryByWeight()\">确定</button>\n      </div>\n    </div>\n    <!-- end: 文本类型 -->\n  </div>\n</div>\n<div class=\"box-body\">\n  <div class=\"total-num\" ng-bind=\"\'共查询到\' + total + \'个结果\'\"></div>\n  <div loading-container=\"tableParams.settings().$loading\" class=\"dg-table-holder\">\n    <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\" template-header=\"ng_table_header\">\n      <tbody>\n        <tr ng-repeat=\"statistic in $data track by $index\">\n          <td ng-bind=\"statistic.timestr\" align=\"center\"></td>\n          <td ng-bind=\"statistic.app_name\" align=\"center\"></td>\n          <td align=\"left\" style=\"max-width:300px\" class=\"dg-text-overflow\">\n            <span ng-bind=\"statistic.content\" title=\"{{statistic.content}}\"></span>\n          </td>\n          <td align=\"center\">\n            <span ng-bind=\"statistic.user | lenFilter:15\" title=\"{{statistic.user}}\"></span>\n          </td>\n          <td ng-show=\"auditTypeSelect === \'ad\'\" align=\"center\">\n            <span ng-bind=\"showText(statistic.result.weight_ad)\"></span>\n            <span ng-bind=\"showNumber(statistic.result.weight_ad)\"></span>\n          </td>\n          <td ng-show=\"auditTypeSelect === \'nonsense\'\" align=\"center\">\n            <span ng-bind=\"showText(statistic.result.weight_nonsense)\"></span>\n            <span ng-bind=\"showNumber(statistic.result.weight_nonsense)\"></span>\n          </td>\n          <td ng-show=\"auditTypeSelect === \'porn\'\" align=\"center\">\n            <span ng-bind=\"showText(statistic.result.porn)\"></span>\n            <span ng-bind=\"showNumber(statistic.result.porn)\"></span>\n          </td>\n          <td ng-show=\"auditTypeSelect === \'politic\'\" align=\"center\">\n            <span ng-bind=\"showText(statistic.result.politic)\"></span>\n            <span ng-bind=\"showNumber(statistic.result.politic)\"></span>\n          </td>\n          <td ng-show=\"auditTypeSelect === \'reaction\'\" align=\"center\">\n            <span ng-bind=\"showText(statistic.result.reaction)\"></span>\n            <span ng-bind=\"showNumber(statistic.result.reaction)\"></span>\n          </td>\n          <td align=\"center\">\n            <span style=\"margin-right:20px\" ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_ad != null\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_ad == 1 ? \'广告评论\' : \'正常文本\'\"></span>\n            </span>\n            <span ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_nonsense != null\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_nonsense == 1 ? \'低质量文本\': \'正常文本\'\" style=\"margin-right:10px\"></span>\n            </span>\n            <span style=\"margin-right:20px\" ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_politic != null\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_politic == 1 ? \'涉政文本\' : \'正常文本\'\"></span>\n            </span>\n            <span ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_porn != null\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_porn == 1 ? \'涉黄文本\': \'正常文本\'\" style=\"margin-right:10px\"></span>\n            </span>\n            <span ng-if=\"statistic.user_feedback_info != null && statistic.user_feedback_info.is_reaction != null\">\n              <i class=\"fa fa-tag\" style=\"margin-right:10px; color:#B9BECB\"></i>\n              <span ng-bind=\"statistic.user_feedback_info.is_reaction == 1 ? \'反动文本\': \'正常文本\'\" style=\"margin-right:10px\"></span>\n            </span>\n          </td>\n          <td data-title=\"\'操作\'\" align=\"center\">\n            <i class=\"fa fa-pencil pointerable\" ng-click=\"what($index, auditTypeSelect)\"></i>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n<script id=\"ng_table_header\" type=\"text/ng-template\">\n  <tr>\n    <th>检测时间</th>\n    <th>app name</th>\n    <th>文本内容</th>\n    <th>用户昵称</th>\n    <th ng-show=\"auditTypeSelect === \'ad\'\">\n      <span class=\"sort-indicator\">广告评论（权重）</span>\n    </th>\n    <th ng-show=\"auditTypeSelect === \'nonsense\'\">\n      <span class=\"sort-indicator\">低质量文本（权重）</span>\n    </th>\n    <th ng-show=\"auditTypeSelect === \'porn\'\">\n      <span class=\"sort-indicator\">涉黄文本（权重）</span>\n    </th>\n    <th ng-show=\"auditTypeSelect === \'politic\'\">\n      <span class=\"sort-indicator\">涉政文本（权重）</span>\n    </th>\n    <th ng-show=\"auditTypeSelect === \'reaction\'\">\n      <span class=\"sort-indicator\">反动文本（权重）</span>\n    </th>\n    <th>用户反馈</th>\n    <th>操作</th>\n  </tr>\n</script>\n<script type=\"text/ng-template\" id=\"change_junk_feedback_dialog\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content dialog-form\">\n      <div class=\"modal-header\">\n        <button class=\"close\" ng-click=\"method.cancel()\">&times;</button>\n        <h3 class=\"modal-title\">用户反馈</h3>\n      </div>\n      <div class=\"modal-body\">\n        <div>\n          请为该文本选择您认为合适的标签：\n        </div>\n        <div>\n          “<span ng-bind=\"params.content\"></span>”\n        </div>\n        <br/>\n        <div class=\"row\" ng-show=\"params.auditTypeSelect === \'ad\'\">\n          <div class=\"col-sm-3\">\n            广告评论：\n          </div>\n          <div class=\"col-sm-9\">\n            <span class=\"txt {{params.is_ad == 1 ? \'normal\' : \'selected\'}} pointerable\" ng-click=\"method.select_ad(1)\">广告评论</span>\n            <span class=\"txt {{params.is_ad == 0 ? \'normal\' : \'selected\'}} pointerable\" ng-click=\"method.select_ad(0)\">正常文本</span>\n          </div>\n          <br/>\n        </div>\n        <div class=\"row\" ng-show=\"params.auditTypeSelect === \'nonsense\'\">\n          <div class=\"col-sm-3\">\n            文本质量：\n          </div>\n          <div class=\"col-sm-9\">\n            <span class=\"txt {{params.is_nonsense == 1 ? \'normal\' : \'selected\'}} pointerable\" ng-click=\"method.select_nonsense(1)\">低质量文本</span>\n            <span class=\"txt {{params.is_nonsense == 0 ? \'normal\' : \'selected\'}} pointerable\" ng-click=\"method.select_nonsense(0)\">正常文本</span>\n          </div>\n        </div>\n        <div class=\"row\" ng-show=\"params.auditTypeSelect === \'porn\'\">\n          <div class=\"col-sm-3\">\n            涉黄文本：\n          </div>\n          <div class=\"col-sm-9\">\n            <span class=\"txt {{params.is_porn == 1 ? \'normal\' : \'selected\'}} pointerable\" ng-click=\"method.select_porn(1)\">涉黄文本</span>\n            <span class=\"txt {{params.is_porn == 0 ? \'normal\' : \'selected\'}} pointerable\" ng-click=\"method.select_porn(0)\">正常文本</span>\n          </div>\n        </div>\n        <div class=\"row\" ng-show=\"params.auditTypeSelect === \'politic\'\">\n          <div class=\"col-sm-3\">\n            涉政文本：\n          </div>\n          <div class=\"col-sm-9\">\n            <span class=\"txt {{params.is_politic == 1 ? \'normal\' : \'selected\'}} pointerable\"\n                  ng-click=\"method.select_politic(1)\">涉政文本</span>\n            <span class=\"txt {{params.is_politic == 0 ? \'normal\' : \'selected\'}} pointerable\"\n                  ng-click=\"method.select_politic(0)\">正常文本</span>\n          </div>\n        </div>\n        <div class=\"row\" ng-show=\"params.auditTypeSelect === \'reaction\'\">\n          <div class=\"col-sm-3\">\n            反动文本：\n          </div>\n          <div class=\"col-sm-9\">\n            <span class=\"txt {{params.is_reaction == 1 ? \'normal\' : \'selected\'}} pointerable\" ng-click=\"method.select_reaction(1)\">反动文本</span>\n            <span class=\"txt {{params.is_reaction == 0 ? \'normal\' : \'selected\'}} pointerable\" ng-click=\"method.select_reaction(0)\">正常文本</span>\n          </div>\n        </div>\n\n        <br/>\n        <div class=\"text-center\">\n          <button class=\"btn btn-default dg-button-minwidth cancel\" ng-click=\"method.cancel()\">\n            取消\n          </button>\n          <button class=\"btn btn-primary dg-button-minwidth confirm\"\n                  ng-disabled=\"(params.is_ad == null) && (params.is_nonsense == null) && (params.is_porn == nll) && (params.is_politic == nll) && (params.is_reaction == nll)\"\n                  ng-click=\"method.ok()\">\n            确认\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</script>");
$templateCache.put("src/module/userPublic/dialog/dialog.html","<div class=\"modal-header\">\n  <dialog-close close=\"close()\"></dialog-close>\n  <h3 class=\"modal-title\">确认修改</h3>\n</div>\n<form class=\"form-horizontal small-form\" name=\"confirmTelForm\" novalidate>\n  <fieldset>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>密码</label>\n      <div class=\"col-sm-10\">\n        <input type=\"password\" class=\"form-control\" placeholder=\"密码\" ng-model=\"tel.login_passwd_old\" required name=\"login_passwd_old\">\n        <small class=\"text-red\">输入账号密码确认修改</small>\n        <form-message label=\"密码\" name=\"login_passwd_old\"></form-message>\n      </div>\n    </div>\n  </fieldset>\n  <div class=\"form-action\">\n    <div class=\"text-center\">\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"update()\" ng-disabled=\"confirmTelForm.$invalid\">确定\n      </button>\n      <button type=\"submit\" class=\"btn btn-default\" ng-click=\"close()\">取消</button>\n    </div>\n  </div>\n</form>");
$templateCache.put("src/module/account/management/client/client.html","<div class=\"modal-header\">\n    <h3 class=\"modal-title\">新建账号</h3>\n</div>\n<div class=\"client-account\">\n    <section>\n        <div class=\"progressbar clearfix\">\n            <span ng-class=\"{\'on\':params.isFirst}\">1.填写账号信息<i class=\"outset\"></i></span>\n            <span ng-class=\"{\'on\':(!params.isFirst && !params.isLast)}\"><i class=\"inset\"></i> 2.开通账号功能<i class=\"outset\"></i></span>\n            <span ng-class=\"{\'on\':params.isLast}\"><i class=\"inset\"></i>3.提交<i class=\"outset\"></i></span>\n        </div>\n    </section>\n    <section>\n        <form class=\"form-horizontal\" name=\"clientForm\">\n        <div ng-include=\"\'src/module/account/management/client/\'+ dialogSubViewArr[params.currentTplIndex] + \'.html\'\"></div>\n        <!-- <div ng-include=\"\'src/module/account/management/client/fillInfo.html\'\"></div> -->\n        <!-- <div ng-include=\"\'src/module/account/management/client/funcOpenInitial.html\'\"></div> -->\n        <!-- <div ng-include=\"\'src/module/account/management/client/funcOpenDetails.html\'\"></div> -->\n        <!-- <div ng-include=\"\'src/module/account/management/client/funcOpenSubmit.html\'\"></div> -->\n        <div class=\"text-center btn-groups\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"back()\" ng-if=\"!params.isFirst\">上一步</button>\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"next()\" ng-disabled=\"formVerification()\">{{params.isLast ? \'提交\': \'下一步\'}}</button>\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"cancel()\">取消</button>\n        </div>\n        </form>\n    </section>\n</div>");
$templateCache.put("src/module/account/management/client/fillInfo.html","<fieldset>\n    <legend class=\"title-bar-border\">基础信息</legend>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">*企业名称</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <input type=\"text\" class=\"dialog-form-horizontal-text\" ng-model=\"forms.step1.companyName\" name=\"companyName\" required>\n            <form-error-message name=\"companyName\" label=\"企业名称\"></form-error-message>\n        </div>\n    </div>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">*产品（项目）名称</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <input type=\"text\" class=\"dialog-form-horizontal-text\" name=\"productName\" ng-model=\"forms.step1.productName\" ng-maxlength=\"12\" required>\n            <form-error-message name=\"productName\" label=\"产品（项目）名称\" errmaxlength=\"项目（产品）名称长度不能超过12个中文字符\"></form-error-message>\n        </div>\n    </div>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">*appname</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <input type=\"text\" class=\"dialog-form-horizontal-text\" name=\"appname\" ng-model=\"forms.step1.appname\" ng-pattern=\"/^[0-9a-zA-Z_]+$/\" ng-maxlength=\"20\" required ng-blur=\"\">\n            <form-error-message class=\"both-msg-box\" ng-class=\"{\'duplicate-msg-box\':params.duplicate}\" name=\"appname\" label=\"appname\" errpattern=\"appname只能由英文字母、数字和下划线组成\" errmaxlength=\"appname长度不能超过20个字符\" errduplicated=\"appname已存在，请重新输入\">\n            </form-error-message>\n        </div>\n    </div>\n\n    <legend class=\"title-bar-border\">客户资料</legend>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">*所在城市</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <city-dispatcher class=\"dialog-form-horizontal-text no-padding\" ng-model=\"forms.step1.address\"></city-dispatcher>\n        </div>\n    </div>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">*所属行业</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <select class=\"dialog-form-horizontal-text\" ng-model=\"forms.step1.industry\" data-ng-options=\"indu for indu in industry\"></select>\n        </div>\n    </div>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">*客户来源</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <select class=\"dialog-form-horizontal-text\" ng-model=\"forms.step1.clientSource\" data-ng-options=\"indu for indu in industry\"></select>\n        </div>\n    </div>\n\n    <legend class=\"title-bar-border\">其他</legend>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">*测试周期</label>\n        <div class=\"col-xs-8 no-padding-left\">\n                <period-date-picker class=\"dialog-form-horizontal-text\" ng-model=\"filterDate\" disable-clear disable-today completion-time></period-date-picker>\n        </div>\n    </div>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">*通知邮箱</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <label class=\"add-btn pull-right\" ng-click=\"addEmails()\"><i class=\"glyphicon glyphicon-plus\"></i>添加</label>\n            <div ng-repeat=\"ename in emailList\">\n                <input type=\"text\" ng-class=\"{\'no-margin-top\': $index == 0}\" class=\"dialog-form-horizontal-text pull-left text-email\" name=\"{{ename}}\" ng-model=\"forms.step1.emails[ename]\" ng-pattern=\"/^[^@]+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/\" required>\n                <label class=\"control-label error\" ng-messages=\"clientForm[ename].$error\" ng-show=\"clientForm[ename].$dirty\">\n                    <i class=\"fa fa-times-circle-o\"></i><span ng-message=\"pattern\">请填写正确的邮箱地址的</span>\n                </label>\n                <label class=\"add-btn remove pull-right\" ng-if=\"$index\" ng-click=\"removeEmail($index)\"><i class=\"glyphicon glyphicon-minus\"></i>删除</label>\n            </div>\n        </div>\n    </div>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-4 control-label text-center\">客户特殊要求</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <textarea class=\"dialog-form-horizontal-text\" ng-model=\"forms.step1.specifiedDemand\" rows=\"4\"></textarea>\n        </div>\n    </div>\n</fieldset>");
$templateCache.put("src/module/account/management/client/funcOpenDetails.html","<fieldset class=\"shrink-space\">\n        <legend class=\"title-bar-border\">文本</legend>\n        <div class=\"form-group\">\n            <div class=\"checkbox\">\n                <label class=\"lf-title pull-left\"><input type=\"checkbox\" ng-model=\"funcOpenEnable.textExamine\">文本审核</label>\n                <div class=\"invoke-limit\">\n                    <label><input type=\"text\" placeholder=\"调用限量\" name=\"textExamine\" ng-model=\"limitNumber.textExamine\" ng-pattern=\"/^[1-9]\\d*$/\">万次/天</label>\n                    <tooltips my-class=\"glyphicon glyphicon-question-sign\" tips-msg=\"当天掉用量超过限制后，24:00之前不可再调用，之后可以继续正常调用。调用限量为0或为空时，不限制调用限量。\">\n                    </tooltips>\n                    <div>\n                        <form-error-message name=\"textExamine\" errpattern=\"调用限量只能是正整数\"> </form-error-message>\n                    </div>\n                </div>\n            </div>\n            <div class=\"panel-box\" ng-show=\"funcOpenEnable.textExamine\">\n                <div class=\"row form-group\">\n                    <label class=\"lf-title\">*具体功能:</label>\n                    <div class=\"checkbox\">\n                        <label><input type=\"checkbox\" ng-model=\"checkBox.textSpecificFunc.identify\" ng-true-value=\"\'黄反识别\'\" ng-change=\"getCheckboxValArr(\'textSpecificFunc\')\">黄反识别</label>\n                        <label><input type=\"checkbox\" ng-model=\"checkBox.textSpecificFunc.rubbishFilter\" ng-true-value=\"\'垃圾评论过滤\'\" ng-change=\"getCheckboxValArr(\'textSpecificFunc\')\">垃圾评论过滤</label>\n                    </div>\n                </div>\n                <div class=\"row form-group\">\n                    <label class=\"lf-title\">*应用行业:</label>\n                    <div class=\"text-info\">\n                        <select class=\"dialog-form-horizontal-text\" ng-model=\"forms.step2.applyIndustry\" data-ng-options=\"indust for indust in applyIndustry\"></select>\n                    </div>\n                </div>\n                <div class=\"row form-group\">\n                    <label class=\"lf-title\">*应用场景:</label>\n                    <div class=\"text-info\">\n                        <input type=\"text\" class=\"dialog-form-horizontal-text\" ng-model=\"forms.step2.applyScene\" placeholder=\"直播弹幕/社区评论......\">\n                    </div>\n                </div>\n                <div class=\"row form-group\">\n                    <label class=\"lf-title\">*审核内容:</label>\n                    <div class=\"checkbox\">\n                        <label><input type=\"checkbox\" ng-model=\"checkBox.textExamine.longText\" ng-true-value=\"\'长文本\'\" ng-change=\"getCheckboxValArr(\'textExamine\')\">长文本</label>\n                        <label><input type=\"checkbox\" ng-model=\"checkBox.textExamine.shortText\" ng-true-value=\"\'短文本\'\" ng-change=\"getCheckboxValArr(\'textExamine\')\">短文本</label>\n                    </div>\n                </div>\n                <div class=\"row form-group\">\n                    <label class=\"lf-title\">*骂人功能:</label>\n                    <div class=\"radio\">\n                        <label><input type=\"radio\" ng-model=\"forms.step2.callBadName\" value=\"开通\">开通</label>\n                        <label><input type=\"radio\" ng-model=\"forms.step2.callBadName\" value=\"不开通\">不开通</label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"checkbox\">\n                <label class=\"lf-title pull-left\"><input type=\"checkbox\" ng-model=\"funcOpenEnable.textClassification\">文本分类</label>\n                <div class=\"invoke-limit\">\n                    <label><input type=\"text\" placeholder=\"调用限量\" name=\"textClassification\" ng-model=\"limitNumber.textClassification\" ng-pattern=\"/^[1-9]\\d*$/\">万次/天</label>\n                    <tooltips my-class=\"glyphicon glyphicon-question-sign\" tips-msg=\"当天掉用量超过限制后，24:00之前不可再调用，之后可以继续正常调用。调用限量为0或为空时，不限制调用限量。\">\n                    <div>\n                        <form-error-message name=\"textClassification\" errpattern=\"调用限量只能是正整数\"> </form-error-message>\n                    </div>\n                </tooltips></div>\n            </div>\n            <div class=\"checkbox\">\n                <label class=\"lf-title pull-left\"><input type=\"checkbox\" ng-model=\"funcOpenEnable.textLabelExtraction\">文本标签提取</label>\n                <div class=\"invoke-limit\">\n                    <label><input type=\"text\" placeholder=\"调用限量\" name=\"textLabelExtraction\" ng-model=\"limitNumber.textLabelExtraction\" ng-pattern=\"/^[1-9]\\d*$/\">万次/天</label>\n                    <tooltips my-class=\"glyphicon glyphicon-question-sign\" tips-msg=\"当天掉用量超过限制后，24:00之前不可再调用，之后可以继续正常调用。调用限量为0或为空时，不限制调用限量。\">\n                    <div>\n                        <form-error-message name=\"textLabelExtraction\" errpattern=\"调用限量只能是正整数\"> </form-error-message>\n                    </div>\n                </tooltips></div>\n            </div>\n            <div class=\"checkbox\">\n                <label class=\"lf-title pull-left\"><input type=\"checkbox\" ng-model=\"funcOpenEnable.textEmotionalAnalysis\">文本情感分析</label>\n                <div class=\"invoke-limit\">\n                    <label><input type=\"text\" placeholder=\"调用限量\" name=\"textEmotionalAnalysis\" ng-model=\"limitNumber.textEmotionalAnalysis\" ng-pattern=\"/^[1-9]\\d*$/\">万次/天</label>\n                    <tooltips my-class=\"glyphicon glyphicon-question-sign\" tips-msg=\"当天掉用量超过限制后，24:00之前不可再调用，之后可以继续正常调用。调用限量为0或为空时，不限制调用限量。\">\n                    <div>\n                        <form-error-message name=\"textEmotionalAnalysis\" errpattern=\"调用限量只能是正整数\"> </form-error-message>\n                    </div>\n                </tooltips></div>\n            </div>\n        </div>\n\n        <legend class=\"title-bar-border\">推荐</legend>\n        <div class=\"form-group\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.personalizedRecommEngine\">个性化推荐引擎</label>\n            </div>\n        </div>\n        <div class=\"panel-box\" ng-show=\"funcOpenEnable.personalizedRecommEngine\">\n            <div class=\"row form-group\">\n                <label class=\"lf-title\">*测试方案:</label>\n                <div class=\"radio\">\n                    <label><input type=\"radio\" ng-model=\"forms.step2.testStrategy\" value=\"提供\">提供</label>\n                    <label><input type=\"radio\" ng-model=\"forms.step2.testStrategy\" value=\"不提供\">不提供</label>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <label class=\"lf-title\">*测试数据:</label>\n                <div class=\"radio\">\n                    <label><input type=\"radio\" ng-model=\"forms.step2.testData\" value=\"提供\">提供</label>\n                    <label><input type=\"radio\" ng-model=\"forms.step2.testData\" value=\"不提供\">不提供</label>\n                </div>\n            </div>\n            <div class=\"details-box clearfix\">\n                <label class=\"lf-title pull-left\">测试详情:</label>\n                <div class=\"content pull-right\" ng-repeat=\"i in testDetailList\">\n                    <h3>测试详情<span ng-bind=\"i + 1\"></span><i class=\"pull-right glyphicon glyphicon-trash\" ng-click=\"removeTestDetails($index)\"></i></h3>\n                    <div class=\"details\">\n                        <div class=\"form-group\">\n                            <label class=\"lf-title\">具体功能:</label>\n                            <div class=\"text-info\">\n                                <select class=\"dialog-form-horizontal-text\" ng-model=\"engineRecomm[\'test\'+i].testSpecificFunc\" data-ng-options=\"fun for fun in testSpecificFunc\"></select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"lf-title\">测试场景:</label>\n                            <div class=\"text-info\">\n                                <select class=\"dialog-form-horizontal-text\" ng-model=\"engineRecomm[\'test\'+i].testScene\" data-ng-options=\"scene for scene in testScene\"></select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"lf-title\">测试方式:</label>\n                            <div class=\"text-info widther\">\n                                <input type=\"text\" class=\"dialog-form-horizontal-text\" ng-model=\"engineRecomm[\'test\'+i].testMethod\">\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"lf-title\">插入位置:</label>\n                            <div class=\"text-info widther\">\n                                <input type=\"text\" class=\"dialog-form-horizontal-text\" ng-model=\"engineRecomm[\'test\'+i].screenshotinsertpos\">\n                            </div>\n                            <div class=\"upload_screenshot_btn pull-right\">\n                                <input type=\"file\" files-input ng-model=\"engineRecomm[\'test\'+i].screenshotpos\">\n                                <button type=\"button\" class=\"btn\">上传截图</button>\n                            </div>\n                            <div class=\"text-center screenshotpos\" ng-show=\"engineRecomm[\'test\'+i].screenshotpos\">\n                                位置截图: <a ng-bind=\"engineRecomm[\'test\'+i].screenshotpos[0].name\"></a>\n                            </div>\n                            \n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"lf-title\">流量划分:</label>\n                            <div class=\"text-info widther\">\n                                <input type=\"text\" class=\"dialog-form-horizontal-text\" ng-model=\"engineRecomm[\'test\'+i].flowdispatch\">\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"lf-title widther\">测试指标:</label>\n                            <div class=\"text-info widther\">\n                                <input type=\"text\" class=\"dialog-form-horizontal-text\" ng-model=\"engineRecomm[\'test\'+i].testindex\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <button type=\"button btn-default\" class=\"pull-right btn\" ng-click=\"addTestDetails()\">+添加测试详情</button>\n            </div>\n        </div>\n        <legend class=\"title-bar-border\">搜索</legend>\n        <div class=\"form-group\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.verticalSearchEngine\">垂直搜索引擎</label>\n            </div>\n        </div>\n        <div class=\"panel-box\" ng-show=\"funcOpenEnable.verticalSearchEngine\">\n            <div class=\"row form-group\">\n                <label class=\"lf-title\">*具体功能:</label>\n                <div class=\"checkbox\">\n                    <label><input type=\"checkbox\" ng-model=\"checkBox.vSearchSpecificFunc.keywordSearch\" ng-true-value=\"\'关键词搜索\'\" ng-change=\"getCheckboxValArr(\'vSearchSpecificFunc\')\">关键词搜索</label>\n                    <label><input type=\"checkbox\" ng-model=\"checkBox.vSearchSpecificFunc.keywordAutoComplete\" ng-true-value=\"\'关键词自动补全\'\" ng-change=\"getCheckboxValArr(\'vSearchSpecificFunc\')\">关键词自动补全</label>\n                    <label><input type=\"checkbox\" ng-model=\"checkBox.vSearchSpecificFunc.relationSearch\" ng-true-value=\"\'相关搜索\'\" ng-change=\"getCheckboxValArr(\'vSearchSpecificFunc\')\">相关搜索</label>\n                    <label><input type=\"checkbox\" ng-model=\"checkBox.vSearchSpecificFunc.hotSearch\" ng-true-value=\"\'热门搜索\'\" ng-change=\"getCheckboxValArr(\'vSearchSpecificFunc\')\">热门搜索</label>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <label class=\"lf-title\">*测试方案:</label>\n                <div class=\"radio\">\n                    <label><input type=\"radio\" ng-model=\"forms.step2.vSearchvStrategy\" value=\"提供\">提供</label>\n                    <label><input type=\"radio\" ng-model=\"forms.step2.vSearchvStrategy\" value=\"不提供\">不提供</label>\n                </div>\n            </div>\n        </div>\n        <legend class=\"title-bar-border\">其他</legend>\n        <div class=\"form-group\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.dataCapture\">数据抓取</label>\n            </div>\n        </div>\n    </fieldset>");
$templateCache.put("src/module/account/management/client/funcOpenInitial.html","<fieldset class=\"shrink-space\">\n        <legend class=\"title-bar-border\">文本</legend>\n        <div class=\"form-group\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.textExamine\">文本审核</label>\n            </div>\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.textClassification\">文本分类</label>\n            </div>\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.textLabelExtraction\">文本标签提取</label>\n            </div>\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.textEmotionalAnalysis\">文本情感分析</label>\n            </div>\n        </div>\n\n        <legend class=\"title-bar-border\">推荐</legend>\n        <div class=\"form-group\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.personalizedRecommEngine\">个性化推荐引擎</label>\n            </div>\n        </div>\n\n        <legend class=\"title-bar-border\">搜索</legend>\n        <div class=\"form-group\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.verticalSearchEngine\">垂直搜索引擎</label>\n            </div>\n        </div>\n\n        <legend class=\"title-bar-border\">其他</legend>\n        <div class=\"form-group\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"funcOpenEnable.dataCapture\">数据抓取</label>\n            </div>\n        </div>\n    </fieldset>");
$templateCache.put("src/module/account/management/client/funcOpenSubmit.html","<fieldset class=\"shrink-legend\">\n        <legend class=\"title-bar-border\">基础信息</legend>\n        <ul class=\"common-list clearfix\">\n            <li>\n                <span class=\"name pull-left\">企业名称:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.companyName\">湖南掌赢网络科技有限公司</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">项目（产品）名称:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.productName\">豆赚</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">appname:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.appname\">douzhuan</span>\n            </li>\n        </ul>\n    \n        <legend class=\"title-bar-border\">客户资料</legend>\n        <ul class=\"common-list clearfix\">\n            <li>\n                <span class=\"name pull-left\">所在城市:</span>\n                <span class=\"desc pull-left\" ng-bind-template=\"{{forms.step1.address.provinceName}} {{forms.step1.address.cityName}}\"></span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">所属行业:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.industry\">媒体</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">客户来源:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.clientSource\">百度搜索</span>\n            </li>\n        </ul>\n\n        <legend class=\"title-bar-border\">其他</legend>\n        <ul class=\"common-list clearfix\">\n            <li>\n                <span class=\"name pull-left\">测试周期:</span>\n                <span class=\"desc pull-left\" ng-bind-template=\"{{filterDate.start}}——{{filterDate.end}}\"></span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">通知邮箱:</span>\n                <div class=\"desc pull-left email-list\">\n                    <span ng-repeat=\"ename in emailList\" ng-bind=\"forms.step1.emails[ename]\">zhangsanfeng@douzhuan.com</span>\n                </div>\n            </li>\n            <li>\n                <span class=\"name pull-left\">客户特殊要求:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.specifiedDemand\">-</span>\n            </li>\n        </ul>\n\n        <legend class=\"title-bar-border\">文本功能</legend>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.textExamine\">文本审核</label>\n            </div>\n            <div class=\"frequency\"><span ng-bind=\"limitNumber.textExamine\">20</span>万 次/天</div>\n        </div>\n        <ul class=\"common-list clearfix shrink\">\n            <li>\n                <span class=\"name pull-left\">具体功能:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.textSpecificFunc\"></span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">应用行业:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.applyIndustry\">直播行业（竞争对手识别；场控识别</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">应用场景:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.applyScene\">直播弹幕</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">审核内容:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.textExamine\">长文本；短文本</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">骂人功能:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.callBadName\">开通</span>\n            </li>\n        </ul>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.textClassification\">文本分类</label>\n            </div>\n            <div class=\"frequency\"><span ng-bind=\"limitNumber.textClassification\">20</span>万 次/天</div>\n        </div>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.textLabelExtraction\">文本标签提取</label>\n            </div>\n            <div class=\"frequency\"><span ng-bind=\"limitNumber.textLabelExtraction\">20</span>万 次/天</div>\n        </div>\n        <div class=\"form-group horizontal mb-10\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.textEmotionalAnalysis\">文本情感分析</label>\n            </div>\n            <div class=\"frequency\"><span ng-bind=\"limitNumber.textEmotionalAnalysis\">20</span>万 次/天</div>\n        </div>\n        \n        <legend class=\"title-bar-border\">推荐</legend>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.personalizedRecommEngine\">个性化推荐引擎</label>\n            </div>\n        </div>\n        <div class=\"clearfix common-list shrink\">\n            <span class=\"name pull-left\">测试方案:</span>\n            <span class=\"desc pull-left\" ng-bind=\"forms.step2.testStrategy\">提供</span>\n        </div>\n        <div class=\"clearfix common-list shrink\">\n            <span class=\"name pull-left\">测试数据:</span>\n            <span class=\"desc pull-left\" ng-bind=\"forms.step2.testData\">提供</span>\n        </div>\n        <div class=\"clearfix panel-box bg-inverse\">\n            <label class=\"lf-title pull-left\">测试详情:</label>\n            <div class=\"content pull-right\" ng-repeat=\"i in testDetailList\">\n                <h3>测试详情<span ng-bind=\"i + 1\">1</span><i class=\"pull-right glyphicon glyphicon-trash\"></i></h3>\n                <ul class=\"details common-list clearfix shrink\">\n                    <li>\n                        <span class=\"name pull-left\">具体功能:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].testSpecificFunc\">个性化推荐</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">测试场景:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].testScene\">pc</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">测试方式:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].testMethod\">AB test</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">接入位置:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].screenshotinsertpos\">网站首页，推荐模块</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">位置截图:</span>\n                        <a class=\"desc pull-left text-underline\" ng-bind=\"engineRecomm[\'test\'+i].screenshotpos[0].name\">ndsfnsefwlfnewl.jpg</a>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">流量划分:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].flowdispatch\">达观20%</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">测试指标:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].testindex\">购买率</span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <legend class=\"title-bar-border\">搜索</legend>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.verticalSearchEngine\">垂直搜索引擎</label>\n            </div>\n        </div>\n        <div class=\"clearfix common-list shrink mb-10 form-group horizontal\">\n            <span class=\"name pull-left\">具体功能:</span>\n            <div class=\"desc pull-left\">\n                <span ng-bind=\"forms.step2.vSearchSpecificFunc\">关键词搜索;</span>\n            </div>\n        </div>\n        <legend class=\"title-bar-border\">其他功能</legend>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.dataCapture\">数据抓取</label>\n            </div>\n        </div>\n</fieldset>");
$templateCache.put("src/module/account/management/detail/detail.html","<div class=\"modal-header\">\n  <span class=\"modal-title\"> 哈哈哈</span>\n  <span class=\"modal-title\" ng-bind=\"id\">12345</span>\n</div>\n<form class=\"form-horizontal\" name=\"scAccountForm\" novalidate>\n  <fieldset>\n    <legend class=\"section\">基本信息</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-1 control-label\">\n        <span class=\"required\"></span>企业名称:</label>\n      <div class=\"col-sm-2\">\n        <span class=\"form-control\" ng-bind=\"id\"></span>\n      </div>\n      <label class=\"col-sm-1 control-label\">\n        <span class=\"required\"></span>开通时间:</label>\n      <div class=\"col-sm-2\">\n        <input type=\"text\" name=\"company_name\" ng-model=\"account.company_name\" class=\"form-control\" ng-maxlength=\"32\" ng-disabled=\"isEdit\">\n      </div>\n      <label class=\"col-sm-1 control-label\">\n        <span class=\"required\"></span>开通时间:</label>\n      <div class=\"col-sm-2\">\n        <input type=\"text\" name=\"company_name\" ng-model=\"account.company_name\" class=\"form-control\" ng-maxlength=\"32\" ng-disabled=\"isEdit\">\n      </div>\n      <label class=\"col-sm-1 control-label\">\n        <span class=\"required\"></span>开通时间:</label>\n      <div class=\"col-sm-2\">\n        <input type=\"text\" name=\"company_name\" ng-model=\"account.company_name\" class=\"form-control\" ng-maxlength=\"32\" ng-disabled=\"isEdit\">\n      </div>\n\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>用户名称</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-maxlength=\"32\" ng-required=\"true\" ng-disabled=\"is_edit\" ng-disabled=\"isEdit\">\n        <p ng-show=\"scAccountForm.appName.$dirty && scAccountForm.appName.$error.required\" class=\"text-danger\">\n          <strong>用户名称是必填的</strong>\n        </p>\n        <p ng-show=\"scAccountForm.appName.$dirty && scAccountForm.appName.$error.maxlength\" class=\"text-danger\">\n          <strong>用户名称长度不能超过32</strong>\n        </p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>密码</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"pwdPassword\" ng-model=\"account.passwd\" class=\"form-control\" ng-required=\"true\">\n      </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"isCreate\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>密码</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"appPassword\" ng-model=\"account.passwd\" class=\"form-control\" ng-required=\"true\" ng-pattern=\"/^([0-9A-Za-z\\!@#\\$\\^&\\*\\(\\)+\\-]){6,18}$/\" ng-disabled=\"is_edit\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>启用\n      </label>\n      <div class=\"col-sm-10\">\n        <div class=\"checkbox\">\n          <input type=\"checkbox\" ng-model=\"account.is_online\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"is_online\" ng-change=\"changeStatus()\">\n          <label for=\"is_online\"></label>\n        </div>\n      </div>\n    </div>\n    <legend class=\"section\">功能\n      <span>0次表示不限制调用</span>\n    </legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>基础</label>\n      <div class=\"col-sm-10\">\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.rec_config == \'1\'}\">\n          <label for=\"rec_config\">\n            <input type=\"checkbox\" ng-model=\"account.rec_config\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"isEdit\" id=\"rec_config\"> 推荐\n          </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.rec\">次/天\n          </div>\n        </div>\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.search_config == \'1\'}\">\n          <label for=\"search_config\">\n            <input type=\"checkbox\" ng-model=\"account.search_config\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"isEdit\" id=\"search_config\"> 搜索\n          </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.search\">次/天\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <div class=\"row\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>机器审核</label>\n        <div class=\"col-sm-10 ad\" ng-class=\"{\'active\': account.nlpdetail.ad == \'1\' || account.nlpdetail.nonsense == \'1\'}\">\n          <div class=\"row\">\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.ad\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.ad\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.ad\"> 广告\n              </label>\n            </div>\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.nonsense\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.nonsense\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.nonsense\"> 低质量\n              </label>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"number-limited\">\n              <input type=\"number\" ng-model=\"account.func_thold.ad\">次/天\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-2\"></div>\n        <div class=\"col-sm-10 porn\" ng-class=\"{\'active\': account.nlpdetail.porn == \'1\' || account.nlpdetail.politic == \'1\' || account.nlpdetail.reaction == \'1\'}\">\n          <div class=\"row\">\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.porn\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.porn\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.porn\"> 涉黄\n              </label>\n            </div>\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.politic\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.politic\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.politic\"> 涉政\n              </label>\n            </div>\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.reaction\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.reaction\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.reaction\"> 反动\n              </label>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"number-limited\">\n              <input type=\"number\" ng-model=\"account.func_thold.porn\">次/天\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>机器阅读</label>\n      <div class=\"col-sm-10\">\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.nlpdetail.classify == \'1\'}\">\n          <label for=\"nlpdetail.classify\">\n            <input type=\"checkbox\" ng-model=\"account.nlpdetail.classify\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.classify\"> 分类\n          </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.classify\">次/天\n          </div>\n        </div>\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.nlpdetail.tagging == \'1\'}\">\n          <label for=\"nlpdetail.tagging\">\n            <input type=\"checkbox\" ng-model=\"account.nlpdetail.tagging\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.tagging\"> 打标签\n          </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.tagging\">次/天\n          </div>\n        </div>\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.nlpdetail.sentiment == \'1\'}\">\n          <label for=\"nlpdetail.sentiment\">\n            <input type=\"checkbox\" ng-model=\"account.nlpdetail.sentiment\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.sentiment\"> 感情分析\n          </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.sentiment\">次/天\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">其他</label>\n      <div class=\"col-sm-10\">\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.spider_config == \'1\'}\">\n          <label for=\"spider_config\">\n            <input type=\"checkbox\" ng-model=\"account.spider_config\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"isEdit\" id=\"spider_config\"> 爬虫\n          </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.spider\">次/天\n          </div>\n        </div>\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.static_config == \'1\'}\">\n          <label for=\"static_config\">\n            <input type=\"checkbox\" ng-model=\"account.static_config\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"isEdit\" id=\"static_config\"> 统计\n          </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.static\">次/天\n          </div>\n        </div>\n      </div>\n    </div>\n    <legend class=\"section\">来源</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>渠道</label>\n      <div class=\"col-sm-10\">\n        <select ng-model=\"account.channel_id\" class=\"form-control\" select-convert-to-number>\n          <option value=\"0\">空</option>\n          <option value=\"{{Number(key)}}\" ng-bind=\"item\" ng-repeat=\"(key, item) in channelList\" ng-if=\"[\'销售\', \'其他\', \'市场\'].indexOf(item) > -1\"></option>\n        </select>\n        <!--<div ng-click=\"cleanOtherValue()\" class=\"from-group\">\n            <div class=\"radio  col-sm-3\" ng-repeat=\"source in sources\">\n              <input type=\"radio\" ng-model=\"account.source\" ng-value=\"source\" id=\"{{source}}\" ng-disabled=\"isEdit\">\n              <label for=\"{{source}}\" ng-bind=\"source\"></label>\n            </div>\n            <div class=\"radio col-sm-3\">\n              <input type=\"radio\" ng-model=\"account.source\" ng-value=\"\'other\'\" id=\"other\" ng-disabled=\"isEdit\">\n              <label for=\"other\">其他</label>\n            </div>\n          </div>\n          <div class=\"from-group\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"account.otherSource\" ng-trim=\"true\" ng-disabled=\"account.source !== \'other\' || isEdit\">\n          </div>-->\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>负责人</label>\n      <div class=\"col-sm-10\">\n        <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n        </select>\n      </div>\n    </div>\n    <legend class=\"section\">状态</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>状态</label>\n      <div class=\"col-sm-10\">\n        <select ng-model=\"account.status\" class=\"form-control\">\n          <option value=\"{{status}}\" ng-bind=\"status\" ng-repeat=\"status in statuses\"></option>\n        </select>\n      </div>\n    </div>\n  </fieldset>\n\n</form>");
$templateCache.put("src/module/account/management/onlineDetail/onlineDetail.html","<div class=\"modal-header\">\n  <span class=\"modal-title\" ng-bind=\"app_name\"></span>\n  <span class=\"modal-title\" ng-bind=\"app_id\"></span>\n  <button class=\"btn btn-default btn-sm btn-flat btn-float\" ng-click=\"addRelationAccount()\">开通关联账号</button>\n\n</div>\n<form class=\"form-horizontal\" name=\"scAccountForm\" novalidate>\n  <fieldset>\n\n    <legend class=\"head-bg\">基本信息\n      <button class=\"btn-edit\" ng-click=\"edit(\'baseInfo\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n\n    <div ng-show=\"!isShowBaseInfo\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>企业名称：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\" ng-bind=\"company_name\"></span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>项目名称：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\" ng-bing=\"proj_name\"></span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>开通时间:</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\" ng-bing=\"open_time\" x></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>账号类型：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">上海达观</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>状态：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>服务时限：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">上海达观</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>付款方式：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>首次付款：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>销售负责人：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">上海达观</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>项目负责人：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>技术负责人-文本：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>技术负责人-推荐：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">上海达观</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>技术负责人-搜索：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>技术负责人-抓取：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n      </div>\n\n    </div>\n\n    <div ng-show=\"isShowBaseInfo\">\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>企业名称：</label>\n        <div class=\"col-sm-2\">\n          <input type=\"text\" name=\"company_name\" ng-model=\"account.company_name\" class=\"form-control\" ng-required=\"true\">\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>项目名称：</label>\n        <div class=\"col-sm-2\">\n          <input type=\"text\" name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-maxlength=\"12\" ng-required=\"true\">\n          <p ng-show=\"scAccountForm.appName.$dirty && scAccountForm.appName.$error.required\" class=\"text-danger\">\n            <strong>名称是必填的</strong>\n          </p>\n          <p ng-show=\"scAccountForm.appName.$dirty && scAccountForm.appName.$error.maxlength\" class=\"text-danger\">\n            <strong>项目（产品）名称长度不能超过12个中文字符</strong>\n          </p>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>开通时间:</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2018-02-08 14:34:23</span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>账号类型：</label>\n        <div class=\"col-sm-2\">\n          <select ng-model=\"account.type\" class=\"form-control\" ng-init=\"account.type\">\n            <option value=\"{{type.key}}\" ng-bind=\"type.name\" ng-repeat=\"type in accountTypeList\"></option>\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>状态：</label>\n        <div class=\"col-sm-2\">\n          <select ng-model=\"account.status\" class=\"form-control\" ng-init=\"account.status\">\n            <option value=\"{{status.key}}\" ng-bind=\"status.name\" ng-repeat=\"status in statuses\"></option>\n          </select>\n        </div>\n      </div>\n\n      <!-- 上线状态的数据  -->\n      <div ng-show=\"account.status==\'2\'\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-2 control-label\">\n            <span class=\"required\"></span>服务时限：</label>\n          <div class=\"col-sm-3 nowrap\">\n            <date-picker ng-model=\"period.start\" disable-clear beyond-today min-date=\"dateConfig.minDate\" max-date=\"period.end\" ng-change=\"dateConfig.change()\" max-date=\"dateConfig.maxDate\"></date-picker>\n            <date-picker ng-model=\"period.end\" disable-clear beyond-today min-date=\"period.start\"></date-picker>\n          </div>\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>付款方式：</label>\n          <div class=\"col-sm-2\">\n            <select ng-model=\"account.payment\" class=\"form-control\" ng-init=\"account.payment\">\n              <option value=\"{{payment.key}}\" ng-bind=\"payment.name\" ng-repeat=\"payment in paymentList\"></option>\n            </select>\n\n          </div>\n          <label class=\"col-sm-2 control-label\">\n            <span class=\"required\"></span>首次付款：</label>\n          <div class=\"col-sm-2\">\n            <date-picker ng-model=\"period.start\" disable-clear beyond-today min-date=\"dateConfig.minDate\" max-date=\"period.end\" ng-change=\"dateConfig.change()\" max-date=\"dateConfig.maxDate\"></date-picker>\n          </div>\n        </div>\n      </div>\n\n      <!-- 关闭状态的数据  -->\n\n      <div ng-show=\"account.status==\'3\'\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-2 control-label\">\n            <span class=\"required\"></span>关闭原因：</label>\n          <div class=\"col-sm-10\">\n            <textarea name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-required=\"true\"></textarea>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>销售负责人：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>项目负责人：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>技术负责人-文本：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>技术负责人-推荐：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>技术负责人-搜索：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>技术负责人-抓取：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n      </div>\n\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(\'baseInfo\')\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'baseInfo\')\">取消</button>\n        </div>\n      </div>\n    </div>\n\n\n    <legend class=\"head-bg\">客户资料\n      <button class=\"btn-edit\" ng-click=\"edit(\'cusInfo\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n\n    <div class=\"form-group\" ng-show=\"!isShowCusInfo\">\n      <label class=\"col-sm-2 control-label\">\n        <span></span>所在城市：</label>\n      <div class=\"col-sm-2\">\n        <span class=\"form-control border-fixed\">湖南长沙</span>\n      </div>\n      <label class=\"col-sm-2 control-label\">\n        <span></span>所属行业：</label>\n      <div class=\"col-sm-2\">\n        <span class=\"form-control border-fixed\">小说阅读</span>\n      </div>\n      <label class=\"col-sm-2 control-label\">\n        <span></span>客户来源：</label>\n      <div class=\"col-sm-2\">\n        <span class=\"form-control border-fixed\">百度搜索</span>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowCusInfo\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>所在城市：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>所属行业：</label>\n\n        <div class=\"col-sm-2\">\n          <select ng-model=\"cusInfo.industry\" class=\"form-control\" ng-init=\"\">\n            <option value=\"{{industry.key}}\" ng-bind=\"industry.name\" ng-repeat=\"industry in industryList\"></option>\n          </select>\n\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>客户来源：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n      </div>\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save(\'cusInfo\')\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'cusInfo\')\">取消</button>\n        </div>\n      </div>\n    </div>\n\n    <legend class=\"head-bg\">其他\n      <button class=\"btn-edit\" ng-click=\"edit(\'other\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n\n\n    <div ng-show=\"!isShowOther\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>测试周期：</label>\n        <div class=\"col-sm-3\">\n          <span class=\"form-control border-fixed\">2018/02/01-2018/02/14</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>联系人邮箱：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">百度搜索</span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>客户特殊要求：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">-</span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>项目备注：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">-</span>\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowOther\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>测试周期：</label>\n        <div class=\"col-sm-3\">\n          <span class=\"form-control border-fixed\">2018/02/01-2018/02/14</span>\n        </div>\n\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>通知邮箱：</label>\n        <div class=\"col-sm-3\">\n          <input type=\"text\" class=\"input-default\" value=\"gongjie@datagrand.com\" readonly=\"true\"> \n          <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"addEmail()\">添加</button>\n        </div>\n\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2\"></label>\n        <div class=\"col-sm-10 client-info\">\n          <div class=\"col-sm-6 other-email\" ng-repeat=\"email in application.other_email track by $index\">\n            <div>\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control input-sm\" ng-model=\"application.other_email[$index]\" placeholder=\"输入邮箱\" name=\"{{\'otherEmail\' + $index}}\" ng-pattern=\"/^[^@]+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/\">\n                <span class=\"input-group-btn\">\n                  <button class=\"btn\">\n                    <span class=\"glyphicon glyphicon-remove\" ng-click=\"removeEmail($index)\"></span>\n                  </button>\n                </span>\n              </div>\n              <label class=\"control-label error\" ng-messages=\"formVerification(\'otherEmail\' + $index).error\" ng-if=\"formVerification(\'otherEmail\' + $index).show\">\n                <i class=\"fa fa-times-circle-o\"></i>\n                <span ng-message=\"pattern\">邮箱格式错误</span>\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label nowrap\">\n          <span></span>客户特殊要求：</label>\n        <div class=\"col-sm-10\">\n          <textarea name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-required=\"true\"></textarea>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label nowrap\">\n          <span></span>项目备注：</label>\n        <div class=\"col-sm-10\">\n          <textarea name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-required=\"true\"></textarea>\n        </div>\n      </div>\n\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'other\')\">取消</button>\n        </div>\n      </div>\n\n    </div>\n    <legend class=\"head-bg\">文本分类\n      <button class=\"btn-edit\" ng-click=\"edit(\'text\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n    <div ng-show=\"!isShowText\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">文本审核</span>\n            </label>\n          </div>\n        </div>\n        <label class=\"col-sm-1 control-label nowrap\">\n          <span> 调用限量：</span>\n        </label>\n        <div class=\"col-sm-3\">\n          <span class=\"form-control border-fixed width-fixed\">200万次／天</span>\n\n          <button type=\"button\" class=\"btn-border\" title=\"提示\" data-trigger=\"hover\" data-container=\"body\" data-toggle=\"popover\" data-placement=\"top\" data-content=\"\n              测试账号：              \n              当天调用量超过限制后，24:00之前不可再调用，之后可以继续正常调用。调用限量为0或为空时，不限制调用量。\n              上线账号：   \n              当天调用量超过限制后，用户仍然可以继续调用。销售负责人、项目负责人将收到调用超限提醒 \">\n            <i class=\"glyphicon glyphicon-question-sign\"></i>\n          </button>\n        </div>\n      </div>\n\n      <div class=\"head-bg\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-2 control-label nowrap\">\n            <span>具体功能：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">-</span>\n          </div>\n          <label class=\"col-sm-2 control-label\">\n            <span>应用行业：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">-</span>\n          </div>\n          <label class=\"col-sm-2 control-label\">\n            <span>应用行情：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">-</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-2 control-label\">\n            <span>审核内容：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">-</span>\n          </div>\n          <label class=\"col-sm-2 control-label\">\n            <span>骂人功能：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">-</span>\n          </div>\n        </div>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本分类</span>\n              </label>\n            </div>\n          </div>\n          <label class=\"col-sm-2 control-label\">\n            <span>调用限量：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">200万次／天</span>\n          </div>\n        </div>\n      </div>\n\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本标签提取</span>\n              </label>\n            </div>\n          </div>\n          <label class=\"col-sm-2 control-label\">\n            <span>调用限量：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">200万次／天</span>\n          </div>\n        </div>\n\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本情感分析</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">\n              <span>调用限量：</span>\n            </label>\n            <div class=\"col-sm-3\">\n              <span class=\"form-control border-fixed\">200万次／天</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div ng-show=\"isShowText\">\n\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">文本审核</span>\n            </label>\n          </div>\n        </div>\n        <label class=\"col-sm-1 control-label nowrap\">\n          <span class=\"required\"></span>调用限量：\n        </label>\n        <div class=\"col-sm-3\">\n          <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control input-limit\" ng-required=\"true\">\n          <span> 万次／天</span>\n        </div>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>具体功能：\n          </label>\n\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">黄反识别</span>\n              </label>\n            </div>\n          </div>\n\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">垃圾评论过滤</span>\n              </label>\n            </div>\n          </div>\n\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>应用行业：\n          </label>\n          <div class=\"col-sm-1\">\n            <select ng-model=\"text.apply\" class=\"form-control\">\n              <option value=\"{{text.key}}\" ng-bind=\"text.name\" ng-repeat=\"text in textApplyList\"></option>\n            </select>\n          </div>\n          <!-- 选中直播后显示 -->\n          <div ng-show=\"text.apply==\'1\'\">\n            <div class=\"col-sm-1\">\n              <div class=\"checkbox\">\n                <label>\n                  <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                  <span class=\"nowrap\">黄反识别</span>\n                </label>\n              </div>\n            </div>\n\n            <div class=\"col-sm-2\">\n              <div class=\"checkbox\">\n                <label>\n                  <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                  <span class=\"nowrap\">垃圾评论过滤</span>\n                </label>\n              </div>\n            </div>\n          </div>\n          <!-- 选中其他后显示后显示 -->\n          <div ng-show=\"text.apply==\'2\'\">\n            <div class=\"col-sm-2\">\n              <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control\" placeholder=\"文本审核功能应用行业\" ng-required=\"true\">\n            </div>\n          </div>\n\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\">应用场景：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control\" placeholder=\"直播弹幕／社区评论......\" ng-required=\"true\">\n          </div>\n        </div>\n\n\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>审核内容：\n          </label>\n\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">长文本</span>\n              </label>\n            </div>\n          </div>\n\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">短文本</span>\n              </label>\n            </div>\n          </div>\n\n\n\n\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>骂人功能：\n          </label>\n          <div class=\"col-sm-2\">\n            <div class=\"radio\">\n              <label>\n                <input type=\"radio\" value=\"0\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 0)\"> 开通\n              </label>\n              <label>\n                <input type=\"radio\" value=\"1\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 1)\"> 不开通\n              </label>\n            </div>\n\n          </div>\n        </div>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本分类</span>\n              </label>\n            </div>\n          </div>\n\n          <div class=\"col-sm-3\">\n            <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control input-limit\" placeholder=\"调用限量\" ng-required=\"true\">\n            <span> 万次／天</span>\n          </div>\n\n        </div>\n      </div>\n\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本标签提取</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-3\">\n            <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control input-limit\" placeholder=\"调用限量\" ng-required=\"true\">\n            <span> 万次／天</span>\n          </div>\n\n        </div>\n\n        <div>\n          <div class=\"form-group\">\n            <div class=\"col-sm-2\">\n              <div class=\"checkbox\">\n                <label>\n                  <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                  <span class=\"nowrap\">文本情感分析</span>\n                </label>\n              </div>\n            </div>\n\n            <div class=\"col-sm-3\">\n              <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control input-limit\" placeholder=\"调用限量\" ng-required=\"true\">\n              <span> 万次／天</span>\n            </div>\n\n          </div>\n        </div>\n\n\n        <div class=\"form-action bottom-fixed\">\n          <div class=\"text-center\">\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n            <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'text\')\">取消</button>\n          </div>\n        </div>\n\n      </div>\n    </div>\n\n    <legend class=\"head-bg\">推荐\n      <button class=\"btn-edit\" ng-click=\"edit(\'recommend\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n    <div ng-show=\"!isShowRecommend\">\n\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">个性化推荐引擎</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"head-bg\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span></span>测试方案：</label>\n          <div class=\"col-sm-4\">\n            <span class=\"form-control border-fixed\">《xxxxx推荐测试方案》.pdf</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span></span>测试数据：</label>\n          <div class=\"col-sm-3\">\n            <span class=\"form-control border-fixed\">提供</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span></span>测试详情：</label>\n          <div class=\"col-sm-11\">\n\n            <div class=\"\">\n              <div class=\"col-sm-3 test-detail\">\n                <div class=\"form-group\">\n                  <label class=\"col-sm-5 control-label nowrap\">\n                    <span></span>具体功能：</label>\n                  <div class=\"col-sm-7\">\n                    <span class=\"form-control border-fixed\">提供</span>\n                  </div>\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-5 control-label nowrap\">\n                    <span></span>测试场景：</label>\n                  <div class=\"col-sm-7\">\n                    <span class=\"form-control border-fixed\">提供</span>\n                  </div>\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-5 control-label nowrap\">\n                    <span></span>测试方式：</label>\n                  <div class=\"col-sm-7\">\n                    <span class=\"form-control border-fixed\">提供</span>\n                  </div>\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-5 control-label nowrap\">\n                    <span></span>接入位置：</label>\n                  <div class=\"col-sm-7\">\n                    <span class=\"form-control border-fixed\">提供</span>\n                  </div>\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-5 control-label nowrap\">\n                    <span></span>位置截图：</label>\n                  <div class=\"col-sm-7\">\n                    <span class=\"form-control border-fixed\">提供</span>\n                  </div>\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-5 control-label nowrap\">\n                    <span></span>流量划分：</label>\n                  <div class=\"col-sm-7\">\n                    <span class=\"form-control border-fixed\">提供</span>\n                  </div>\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-5 control-label nowrap\">\n                    <span></span>测试指标：</label>\n                  <div class=\"col-sm-7\">\n                    <span class=\"form-control border-fixed\">提供</span>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n\n          </div>\n\n\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowRecommend\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">个性化推荐引擎</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>测试方案：</label>\n          <div class=\"col-sm-4\">\n            <span class=\"border-fixed\">《xxxxx推荐测试方案》.pdf</span>\n            <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"addRecommendTestProj()\">+上传测试方案</button>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>测试数据：</label>\n          <div class=\"col-sm-4\">\n            <div class=\"radio\">\n              <label>\n                <input type=\"radio\" value=\"0\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 0)\"> 提供\n              </label>\n              <label>\n                <input type=\"radio\" value=\"1\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 1)\"> 不提供\n              </label>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>测试详情：</label>\n          <div class=\"col-sm-1\">\n            <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"testDetail()\">+测试详情</button>\n          </div>\n        </div>\n\n        <div class=\"form-action bottom-fixed\">\n          <div class=\"text-center\">\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n            <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'recommend\')\">取消</button>\n          </div>\n        </div>\n\n      </div>\n    </div>\n    <legend class=\"head-bg\">搜索\n      <button class=\"btn-edit\" ng-click=\"edit(\'search\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n    <div ng-show=\"!isShowSearch\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">垂直搜索引擎</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label nowrap\">\n          具体功能：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">-</span>\n        </div>\n        <label class=\"col-sm-1 control-label nowrap\">\n          测试方案：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">-</span>\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowSearch\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">垂直搜索引擎</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label nowrap\">\n          <span class=\"required\"></span>具体功能：</label>\n        <div class=\"col-sm-10\">\n\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">关键词搜索</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">关键词自动补全</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">相关搜索</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">热门搜索</span>\n              </label>\n            </div>\n          </div>\n\n        </div>\n\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label nowrap\">\n          <span class=\"required\"></span>测试方案：</label>\n        <div class=\"col-sm-4\">\n          <span class=\"border-fixed\">《xxxxx推荐测试方案》.pdf</span>\n          <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"addSearchTestProj()\">+上传测试方案</button>\n        </div>\n      </div>\n\n\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'search\')\">取消</button>\n        </div>\n      </div>\n    </div>\n\n    <legend class=\"head-bg\">其他功能\n      <button class=\"btn-edit\" ng-click=\"edit(\'otherFun\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n    <div ng-show=\"!isShowOtherFun\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">数据抓取</span>\n            </label>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowOtherFun\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">数据抓取</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'otherFun\')\">取消</button>\n        </div>\n      </div>\n\n    </div>\n  </fieldset>\n\n</form>");
$templateCache.put("src/module/account/management/other/other.html","<div class=\"modal-header\">\n    <h3 class=\"modal-title\">快速新建账号</h3>\n</div>\n<div class=\"other-account client-account\">\n    <section>\n        <form class=\"form-horizontal\">\n            <fieldset>\n                <legend class=\"title-bar-border\">基础信息</legend>\n                <div class=\"row form-group\">\n                    <label class=\"col-xs-4 control-label text-center\">*产品（项目）名称</label>\n                    <div class=\"col-xs-8 no-padding-left\">\n                        <input type=\"text\" class=\"dialog-form-horizontal-text\" ng-model=\"forms.productName\">\n                    </div>\n                </div>\n                <div class=\"row form-group\">\n                    <label class=\"col-xs-4 control-label text-center\">*appname</label>\n                    <div class=\"col-xs-8 no-padding-left\">\n                        <input type=\"text\" class=\"dialog-form-horizontal-text\" ng-model=\"forms.appname\">\n                    </div>\n                </div>\n                <div class=\"row form-group\">\n                    <label class=\"col-xs-4 control-label text-center\">*账号类型</label>\n                    <div class=\"radio col-xs-8 no-padding-left\">\n                        <label><input type=\"radio\" ng-model=\"forms.accountType\" value=\"内部测试\">内部测试</label>\n                        <label><input type=\"radio\" ng-model=\"forms.accountType\" value=\"合作账号\">合作账号</label>\n                        <label><input type=\"radio\" ng-model=\"forms.accountType\" value=\"客户账号\">客户账号</label>\n                    </div>\n                </div>\n                <div class=\"row form-group\">\n                    <label class=\"col-xs-4 control-label text-center\">*状态</label>\n                    <div class=\"radio col-xs-8 no-padding-left\">\n                        <label><input type=\"radio\" ng-model=\"forms.state\" value=\"上线\">上线</label>\n                        <label><input type=\"radio\" ng-model=\"forms.state\" value=\"关闭\">关闭</label>\n                    </div>\n                </div>\n                \n                <legend class=\"title-bar-border\">开通功能</legend>\n                <div class=\"tbl-box\">\n                    <table class=\"table table-bordered table-hover table-layout-fixed\">\n                        <thead>\n                            <tr>\n                                <th class=\"text-center\" width=\"50%\">功能</th>\n                                <th class=\"text-center\" width=\"50%\">调用限量</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"d in tableData\">\n                                <td><label class=\"label\"><input type=\"checkbox\">{{d.checkboxName}}</label></td>\n                                <td ng-class=\"{\'text-center\': !d.inputExist}\">\n                                    {{d.inputExist ? \'\' : \'-\'}}\n                                    <div class=\"frequency\" ng-show=\"d.inputExist\">\n                                        <input type=\"text\">\n                                        <span>万次/天</span>\n                                    </div>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </fieldset>\n        <div class=\"text-center btn-groups\">\n            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"save()\" ng-disabled=\"formVerification()\">确定</button>\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"cancel()\">取消</button>\n        </div>\n        </form>\n    </section>\n</div>");
$templateCache.put("src/module/account/management/unonlineDetail/unonlineDetail.html","<div class=\"modal-header\">\n  <span class=\"modal-title\"> 哈哈哈</span>\n  <span class=\"modal-title\">12345</span>\n  <button class=\"btn btn-default btn-sm btn-flat btn-float\" ng-click=\"addRelationAccount()\">开通关联账号</button>\n\n</div>\n<form class=\"form-horizontal\" name=\"scAccountForm\" novalidate>\n  <fieldset>\n    <legend class=\"head-bg\">基本信息\n      <button class=\"btn-edit\" ng-click=\"edit(\'baseInfo\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n\n    <div ng-show=\"!isShowBaseInfo\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>企业名称：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">上海达观</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>项目名称：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>开通时间:</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>账号类型：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">上海达观</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>状态：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>关闭原因：</label>\n        <div class=\"col-sm-10\">\n          <span class=\"form-control border-fixed\">这里是很长很长，长到占据一整行的账号关闭原因</span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>销售负责人：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">上海达观</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>项目负责人：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>技术负责人-文本：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>技术负责人-推荐：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">上海达观</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>技术负责人-搜索：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>技术负责人-抓取：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2015</span>\n        </div>\n      </div>\n\n    </div>\n\n    <div ng-show=\"isShowBaseInfo\">\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>企业名称：</label>\n        <div class=\"col-sm-2\">\n          <input type=\"text\" name=\"company_name\" ng-model=\"account.company_name\" class=\"form-control\" ng-required=\"true\" ng-disabled=\"true\">\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>项目名称：</label>\n        <div class=\"col-sm-2\">\n          <input type=\"text\" name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-maxlength=\"12\" ng-required=\"true\">\n          <p ng-show=\"scAccountForm.appName.$dirty && scAccountForm.appName.$error.required\" class=\"text-danger\">\n            <strong>名称是必填的</strong>\n          </p>\n          <p ng-show=\"scAccountForm.appName.$dirty && scAccountForm.appName.$error.maxlength\" class=\"text-danger\">\n            <strong>项目（产品）名称长度不能超过12个中文字符</strong>\n          </p>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>开通时间:</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2018-02-08 14:34:23</span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>账号类型：</label>\n        <div class=\"col-sm-2\">\n          <select ng-model=\"account.status\" class=\"form-control\">\n            <option value=\"{{status}}\" ng-bind=\"status\" ng-repeat=\"status in statuses\"></option>\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>状态：</label>\n        <div class=\"col-sm-2\">\n          <select ng-model=\"account.status\" class=\"form-control\">\n            <option value=\"{{status}}\" ng-bind=\"status\" ng-repeat=\"status in statuses\"></option>\n          </select>\n        </div>\n      </div>\n\n      <!-- 上线状态的数据  -->\n      <div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-2 control-label\">\n            <span class=\"required\"></span>服务时限：</label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">上海达观</span>\n          </div>\n          <label class=\"col-sm-2 control-label\">\n            <span class=\"required\"></span>付款方式：</label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">2015</span>\n          </div>\n          <label class=\"col-sm-2 control-label\">\n            <span class=\"required\"></span>首次付款：</label>\n          <div class=\"col-sm-2\">\n            <span class=\"form-control border-fixed\">2015</span>\n          </div>\n        </div>\n      </div>\n\n      <!-- 关闭状态的数据  -->\n\n      <div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-2 control-label\">\n            <span class=\"required\"></span>关闭原因：</label>\n          <div class=\"col-sm-10\">\n            <textarea name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-required=\"true\"></textarea>\n          </div>\n        </div>\n      </div>\n\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>销售负责人：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>项目负责人：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>技术负责人-文本：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>技术负责人-推荐：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>技术负责人-搜索：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>技术负责人-抓取：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n      </div>\n\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'baseInfo\')\">取消</button>\n        </div>\n      </div>\n    </div>\n\n\n    <legend class=\"head-bg\">客户资料\n      <button class=\"btn-edit\" ng-click=\"edit(\'cusInfo\')\" ng-disabled=\"isEdit\">\n        <i class=\"glyphicon glyphicon-edit\"></i>\n      </button>\n    </legend>\n\n    <div class=\"form-group\" ng-show=\"!isShowCusInfo\">\n      <label class=\"col-sm-2 control-label\">\n        <span></span>所在城市：</label>\n      <div class=\"col-sm-2\">\n        <span class=\"form-control border-fixed\">湖南长沙</span>\n      </div>\n      <label class=\"col-sm-2 control-label\">\n        <span></span>所属行业：</label>\n      <div class=\"col-sm-2\">\n        <span class=\"form-control border-fixed\">小说阅读</span>\n      </div>\n      <label class=\"col-sm-2 control-label\">\n        <span></span>客户来源：</label>\n      <div class=\"col-sm-2\">\n        <span class=\"form-control border-fixed\">百度搜索</span>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowCusInfo\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>所在城市：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>所属行业：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>客户来源：</label>\n        <div class=\"col-sm-2\">\n          <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n        </div>\n      </div>\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'cusInfo\')\">取消</button>\n        </div>\n      </div>\n    </div>\n\n\n\n\n\n    <legend class=\"head-bg\">其他\n      <span class=\"glyphicon glyphicon-edit\" ng-click=\"edit(\'other\')\"></span>\n    </legend>\n    <div ng-show=\"!isShowOther\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>测试周期：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">小说阅读</span>\n        </div>\n        <label class=\"col-sm-2 control-label\">\n          <span></span>联系人邮箱：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">百度搜索</span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>客户特殊要求：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">-</span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>项目备注：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">-</span>\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowOther\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label\">\n          <span></span>测试周期：</label>\n        <div class=\"col-sm-2\">\n          <span class=\"form-control border-fixed\">2018/02/01-2018/02/14</span>\n        </div>\n\n        <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>通知邮箱：</label>\n        <div class=\"col-sm-2\">\n          <input type=\"text\" class=\"input-default\" value=\"gongjie@datagrand.com\" readonly=\"true\"> \n          <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"addEmail()\">添加</button>\n        </div>\n\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-2\"></label>\n        <div class=\"col-sm-10 client-info\">\n          <div class=\"col-sm-6 other-email\" ng-repeat=\"email in application.other_email track by $index\">\n            <div>\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control input-sm\" ng-model=\"application.other_email[$index]\" placeholder=\"输入邮箱\" name=\"{{\'otherEmail\' + $index}}\" ng-pattern=\"/^[^@]+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/\">\n                <span class=\"input-group-btn\">\n                  <button class=\"btn\">\n                    <span class=\"glyphicon glyphicon-remove\" ng-click=\"removeEmail($index)\"></span>\n                  </button>\n                </span>\n              </div>\n              <label class=\"control-label error\" ng-messages=\"formVerification(\'otherEmail\' + $index).error\" ng-if=\"formVerification(\'otherEmail\' + $index).show\">\n                <i class=\"fa fa-times-circle-o\"></i>\n                <span ng-message=\"pattern\">邮箱格式错误</span>\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label\">\n          <span class=\"required\"></span>客户特殊要求：</label>\n        <div class=\"col-sm-10\">\n          <textarea name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-required=\"true\"></textarea>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label\">\n          <span></span>项目备注：</label>\n        <div class=\"col-sm-10\">\n          <textarea name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-required=\"true\"></textarea>\n        </div>\n      </div>\n\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'other\')\">取消</button>\n        </div>\n      </div>\n\n    </div>\n\n\n    <legend class=\"head-bg\">文本分类\n      <span class=\"glyphicon glyphicon-edit\" ng-click=\"edit(\'text\')\"></span>\n    </legend>\n    <div ng-show=\"!isShowText\">\n\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">文本审核</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本分类</span>\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本标签提取</span>\n              </label>\n            </div>\n          </div>\n        </div>\n\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本情感分析</span>\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div ng-show=\"isShowText\">\n\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">文本审核</span>\n            </label>\n          </div>\n        </div>\n        <label class=\"col-sm-1 control-label\">\n          <span class=\"required\"></span>调用限量：\n        </label>\n        <div class=\"col-sm-2\">\n          <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control input-limit\" ng-required=\"true\">\n          <span> 万次／天</span>\n        </div>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label\">\n            <span class=\"required\"></span>具体功能：\n          </label>\n\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">黄反识别</span>\n              </label>\n            </div>\n          </div>\n\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">垃圾评论过滤</span>\n              </label>\n            </div>\n          </div>\n\n          <label class=\"col-sm-1 control-label\">\n            <span class=\"required\"></span>应用行业：\n          </label>\n          <div class=\"col-sm-1\">\n            <select ng-model=\"account.status\" class=\"form-control\">\n              <option value=\"{{status}}\" ng-bind=\"status\" ng-repeat=\"status in statuses\"></option>\n            </select>\n          </div>\n          <!-- 选中直播后显示 -->\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">黄反识别</span>\n              </label>\n            </div>\n          </div>\n\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">垃圾评论过滤</span>\n              </label>\n            </div>\n          </div>\n\n\n\n\n          <!-- 选中其他后显示后显示 -->\n          <div class=\"col-sm-1\">\n            <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control\" placeholder=\"文本审核功能应用行业\" ng-required=\"true\">\n          </div>\n\n          <label class=\"col-sm-1 control-label\">\n            <span class=\"required\">应用场景：</span>\n          </label>\n          <div class=\"col-sm-2\">\n            <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control\" placeholder=\"直播弹幕／社区评论......\" ng-required=\"true\">\n          </div>\n        </div>\n\n\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label\">\n            <span class=\"required\"></span>审核内容：\n          </label>\n\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">长文本</span>\n              </label>\n            </div>\n          </div>\n\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">短文本</span>\n              </label>\n            </div>\n          </div>\n\n\n\n\n          <label class=\"col-sm-1 control-label\">\n            <span class=\"required\"></span>骂人功能：\n          </label>\n          <div class=\"col-sm-2\">\n            <div class=\"radio\">\n              <label>\n                <input type=\"radio\" value=\"0\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 0)\"> 开通\n              </label>\n              <label>\n                <input type=\"radio\" value=\"1\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 1)\"> 不开通\n              </label>\n            </div>\n\n          </div>\n        </div>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本分类</span>\n              </label>\n            </div>\n          </div>\n\n          <div class=\"col-sm-2\">\n            <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control input-limit\" placeholder=\"调用限量\" ng-required=\"true\">\n            <span> 万次／天</span>\n          </div>\n\n        </div>\n      </div>\n\n\n      <div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-1\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">文本标签提取</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control input-limit\" placeholder=\"调用限量\" ng-required=\"true\">\n            <span> 万次／天</span>\n          </div>\n\n        </div>\n\n        <div>\n          <div class=\"form-group\">\n            <div class=\"col-sm-1\">\n              <div class=\"checkbox\">\n                <label>\n                  <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                  <span class=\"nowrap\">文本情感分析</span>\n                </label>\n              </div>\n            </div>\n\n            <div class=\"col-sm-2\">\n              <input type=\"text\" name=\"company_name\" ng-model=\"text.text_check\" class=\"form-control input-limit\" placeholder=\"调用限量\" ng-required=\"true\">\n              <span> 万次／天</span>\n            </div>\n\n          </div>\n        </div>\n\n\n        <div class=\"form-action bottom-fixed\">\n          <div class=\"text-center\">\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n            <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'text\')\">取消</button>\n          </div>\n        </div>\n\n      </div>\n    </div>\n\n    <legend class=\"head-bg\">推荐\n      <span class=\"glyphicon glyphicon-edit\" ng-click=\"edit(\'recommend\')\"></span>\n    </legend>\n    <div ng-show=\"!isShowRecommend\">\n\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">个性化推荐引擎</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n    <div ng-show=\"isShowRecommend\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">个性化推荐引擎</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>测试方案：</label>\n          <div class=\"col-sm-4\">\n            <span class=\"border-fixed\">《xxxxx推荐测试方案》.pdf</span>\n            <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"addRecommendTestProj()\">+上传测试方案</button>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>测试数据：</label>\n          <div class=\"col-sm-4\">\n            <div class=\"radio\">\n              <label>\n                <input type=\"radio\" value=\"0\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 0)\"> 提供\n              </label>\n              <label>\n                <input type=\"radio\" value=\"1\" ng-model=\"orderInfo.orderDel\" ng-change=\"changeDelState(orderInfo, 1)\"> 不提供\n              </label>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-1 control-label nowrap\">\n            <span class=\"required\"></span>测试详情：</label>\n          <div class=\"col-sm-1\">\n            <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"testDetail()\">+测试详情</button>\n          </div>\n        </div>\n\n        <div class=\"form-action bottom-fixed\">\n          <div class=\"text-center\">\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n            <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'recommend\')\">取消</button>\n          </div>\n        </div>\n\n      </div>\n    </div>\n\n\n    <legend class=\"head-bg\">搜索\n      <span class=\"glyphicon glyphicon-edit\" ng-click=\"edit(\'search\')\"></span>\n    </legend>\n    <div ng-show=\"!isShowSearch\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">垂直搜索引擎</span>\n            </label>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowSearch\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">垂直搜索引擎</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label nowrap\">\n          <span class=\"required\"></span>具体功能：</label>\n        <div class=\"col-sm-10\">\n\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">关键词搜索</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">关键词自动补全</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">相关搜索</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span class=\"nowrap\">热门搜索</span>\n              </label>\n            </div>\n          </div>\n\n        </div>\n\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-1 control-label nowrap\">\n          <span class=\"required\"></span>测试方案：</label>\n        <div class=\"col-sm-4\">\n          <span class=\"border-fixed\">《xxxxx推荐测试方案》.pdf</span>\n          <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"addSearchTestProj()\">+上传测试方案</button>\n        </div>\n      </div>\n\n\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'search\')\">取消</button>\n        </div>\n      </div>\n    </div>\n\n\n    <legend class=\"head-bg\">其他功能\n      <span class=\"glyphicon glyphicon-edit\" ng-click=\"edit(\'otherFun\')\"></span>\n    </legend>\n    <div ng-show=\"!isShowOtherFun\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">数据抓取</span>\n            </label>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"isShowOtherFun\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-1\">\n          <div class=\"checkbox\">\n            <label>\n              <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n              <span class=\"nowrap\">数据抓取</span>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-action bottom-fixed\">\n        <div class=\"text-center\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\">保存</button>\n          <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel(\'otherFun\')\">取消</button>\n        </div>\n      </div>\n\n    </div>\n  </fieldset>\n\n</form>");
$templateCache.put("src/module/account/open/examine/accountFunc.html","<fieldset class=\"shrink-legend\">\n        <legend class=\"title-bar-border\">文本功能</legend>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.textExamine\">文本审核</label>\n            </div>\n            <div class=\"frequency\"><span ng-bind=\"limitNumber.textExamine\">20</span>万 次/天</div>\n        </div>\n        <ul class=\"common-list clearfix shrink\">\n            <li>\n                <span class=\"name pull-left\">具体功能:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.textSpecificFunc\"></span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">应用行业:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.applyIndustry\">直播行业（竞争对手识别；场控识别</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">应用场景:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.applyScene\">直播弹幕</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">审核内容:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.textExamine\">长文本；短文本</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">骂人功能:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step2.callBadName\">开通</span>\n            </li>\n        </ul>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.textClassification\">文本分类</label>\n            </div>\n            <div class=\"frequency\"><span ng-bind=\"limitNumber.textClassification\">20</span>万 次/天</div>\n        </div>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.textLabelExtraction\">文本标签提取</label>\n            </div>\n            <div class=\"frequency\"><span ng-bind=\"limitNumber.textLabelExtraction\">20</span>万 次/天</div>\n        </div>\n        <div class=\"form-group horizontal mb-10\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.textEmotionalAnalysis\">文本情感分析</label>\n            </div>\n            <div class=\"frequency\"><span ng-bind=\"limitNumber.textEmotionalAnalysis\">20</span>万 次/天</div>\n        </div>\n        \n        <legend class=\"title-bar-border\">推荐</legend>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.personalizedRecommEngine\">个性化推荐引擎</label>\n            </div>\n        </div>\n        <div class=\"clearfix common-list shrink\">\n            <span class=\"name pull-left\">测试方案:</span>\n            <span class=\"desc pull-left\" ng-bind=\"forms.step2.testStrategy\">提供</span>\n        </div>\n        <div class=\"clearfix common-list shrink\">\n            <span class=\"name pull-left\">测试数据:</span>\n            <span class=\"desc pull-left\" ng-bind=\"forms.step2.testData\">提供</span>\n        </div>\n        <div class=\"clearfix panel-box bg-inverse\">\n            <label class=\"lf-title pull-left\">测试详情:</label>\n            <div class=\"content pull-right\" ng-repeat=\"i in testDetailList\">\n                <h3>测试详情<span ng-bind=\"i + 1\">1</span><i class=\"pull-right glyphicon glyphicon-trash\"></i></h3>\n                <ul class=\"details common-list clearfix shrink\">\n                    <li>\n                        <span class=\"name pull-left\">具体功能:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].testSpecificFunc\">个性化推荐</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">测试场景:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].testScene\">pc</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">测试方式:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].testMethod\">AB test</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">接入位置:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].screenshotinsertpos\">网站首页，推荐模块</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">位置截图:</span>\n                        <a class=\"desc pull-left text-underline\" ng-bind=\"engineRecomm[\'test\'+i].screenshotpos[0].name\">ndsfnsefwlfnewl.jpg</a>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">流量划分:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].flowdispatch\">达观20%</span>\n                    </li>\n                    <li>\n                        <span class=\"name pull-left\">测试指标:</span>\n                        <span class=\"desc pull-left\" ng-bind=\"engineRecomm[\'test\'+i].testindex\">购买率</span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <legend class=\"title-bar-border\">搜索</legend>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.verticalSearchEngine\">垂直搜索引擎</label>\n            </div>\n        </div>\n        <div class=\"clearfix common-list shrink mb-10 form-group horizontal\">\n            <span class=\"name pull-left\">具体功能:</span>\n            <div class=\"desc pull-left\">\n                <span ng-bind=\"forms.step2.vSearchSpecificFunc\">关键词搜索;</span>\n            </div>\n        </div>\n        <legend class=\"title-bar-border\">其他功能</legend>\n        <div class=\"form-group horizontal\">\n            <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-checked=\"funcOpenEnable.dataCapture\">数据抓取</label>\n            </div>\n        </div>\n</fieldset>");
$templateCache.put("src/module/account/open/examine/accountInfo.html","<fieldset class=\"shrink-legend\">\n        <legend class=\"title-bar-border\">基础信息</legend>\n        <ul class=\"common-list clearfix\">\n            <li>\n                <span class=\"name pull-left\">企业名称:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.companyName\">湖南掌赢网络科技有限公司</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">项目（产品）名称:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.productName\">豆赚</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">appname:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.appname\">douzhuan</span>\n            </li>\n        </ul>\n    \n        <legend class=\"title-bar-border\">客户资料</legend>\n        <ul class=\"common-list clearfix\">\n            <li>\n                <span class=\"name pull-left\">所在城市:</span>\n                <span class=\"desc pull-left\" ng-bind-template=\"{{forms.step1.address.provinceName}} {{forms.step1.address.cityName}}\"></span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">所属行业:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.industry\">媒体</span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">客户来源:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.clientSource\">百度搜索</span>\n            </li>\n        </ul>\n\n        <legend class=\"title-bar-border\">其他</legend>\n        <ul class=\"common-list clearfix\">\n            <li>\n                <span class=\"name pull-left\">测试周期:</span>\n                <span class=\"desc pull-left\" ng-bind-template=\"{{filterDate.start}}——{{filterDate.end}}\"></span>\n            </li>\n            <li>\n                <span class=\"name pull-left\">通知邮箱:</span>\n                <div class=\"desc pull-left email-list\">\n                    <span ng-repeat=\"ename in emailList\" ng-bind=\"forms.step1.emails[ename]\">zhangsanfeng@douzhuan.com</span>\n                </div>\n            </li>\n            <li>\n                <span class=\"name pull-left\">客户特殊要求:</span>\n                <span class=\"desc pull-left\" ng-bind=\"forms.step1.specifiedDemand\">-</span>\n            </li>\n        </ul>\n</fieldset>");
$templateCache.put("src/module/account/open/examine/accountOpen.html","<fieldset>\n    <legend class=\"title-bar-border\">基础信息</legend>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-3 control-label text-center\">*销售负责人</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <select class=\"dialog-form-horizontal-text\" ng-model=\"forms.managerSale\" data-ng-options=\"indu for indu in industry\"></select>\n        </div>\n    </div>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-3 control-label text-center\">*项目负责人</label>\n        <div class=\"col-xs-8 no-padding-left\">\n            <select class=\"dialog-form-horizontal-text\" ng-model=\"forms.managerProduct\" data-ng-options=\"indu for indu in industry\"></select>\n        </div>\n    </div>\n    <legend class=\"title-bar-border\">推荐</legend>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-3 control-label text-center\">测试方案：</label>\n        <div class=\"upload_screenshot_btn col-xs-2 examine text-center\">\n            <input type=\"file\" files-input ng-model=\"screenshotpos.recommand\">\n            <button type=\"button\" class=\"btn\">上传测试方案</button>\n        </div>\n        <div class=\"col-xs-6\">\n            <span ng-if=\"!screenshotpos.recommand[0].name\">*文件不能超过{{fileMaxSize}}MB</span>\n            <span ng-show=\"!fileVerification(\'recommand\').sizeError && !fileVerification(\'recommand\').formatError\">\n                <i ng-if=\"screenshotpos.recommand[0].name\" class=\"glyphicon glyphicon-file\"></i>\n                <span ng-bind=\"screenshotpos.recommand[0].name\"></span>\n            </span>\n            <span ng-show=\"fileVerification(\'recommand\').sizeError || fileVerification(\'recommand\').formatError\">\n                <span>上传文件失败</span>\n                <span ng-if=\"fileVerification(\'recommand\').formatError\">文件格式只能时Word文档或PDF</span>\n                <span ng-if=\"fileVerification(\'recommand\').sizeError\">文件大小不得超过{{fileMaxSize}}MB</span>\n            </span>\n        </div>\n    </div>  \n    <legend class=\"title-bar-border\">搜索</legend>\n    <div class=\"row form-group\">\n        <label class=\"col-xs-3 control-label text-center\">测试方案：</label>\n        <div class=\"upload_screenshot_btn col-xs-2 examine text-center\">\n            <input type=\"file\" files-input ng-model=\"screenshotpos.search\">\n            <button type=\"button\" class=\"btn\">上传测试方案</button>\n        </div>\n        <div class=\"col-xs-6\">\n            <span ng-if=\"!screenshotpos.search[0].name\">*文件不能超过{{fileMaxSize}}MB</span>\n            <span ng-show=\"!fileVerification(\'search\').sizeError && !fileVerification(\'search\').formatError\">\n                <i ng-if=\"screenshotpos.search[0].name\" class=\"glyphicon glyphicon-file\"></i>\n                <span ng-bind=\"screenshotpos.search[0].name\"></span>\n            </span>\n            <span ng-show=\"fileVerification(\'search\').sizeError || fileVerification(\'search\').formatError\">\n                <span>上传文件失败</span>\n                <span ng-if=\"fileVerification(\'search\').formatError\">文件格式只能时Word文档或PDF</span>\n                <span ng-if=\"fileVerification(\'search\').sizeError\">文件大小不得超过{{fileMaxSize}}MB</span>\n            </span>\n        </div>\n    </div> \n</fieldset>");
$templateCache.put("src/module/account/open/examine/examine.html","<div class=\"modal-header\">\n        <h3 class=\"modal-title\">审核</h3>\n    </div>\n    <div class=\"client-account\">\n        <section>\n            <div class=\"progressbar clearfix\">\n                <span ng-class=\"{\'on\':params.isFirst}\">1.账号信息<i class=\"outset\"></i></span>\n                <span ng-class=\"{\'on\':(!params.isFirst && !params.isLast)}\"><i class=\"inset\"></i> 2.账号功能<i class=\"outset\"></i></span>\n                <span ng-class=\"{\'on\':params.isLast}\"><i class=\"inset\"></i>3.开通账号<i class=\"outset\"></i></span>\n            </div>\n        </section>\n        <section>\n            <form class=\"form-horizontal\" name=\"clientForm\">\n            <div ng-include=\"\'src/module/account/open/examine/\'+ dialogSubViewArr[params.currentTplIndex] + \'.html\'\"></div>\n            <div class=\"text-center btn-groups\">\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"back()\" ng-if=\"!params.isFirst\">上一步</button>\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"next()\" ng-disabled=\"formVerification()\">{{params.isLast ? \'开通\': \'下一步\'}}</button>\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"cancel()\">取消</button>\n            </div>\n            </form>\n        </section>\n    </div>");
$templateCache.put("src/module/client/API/item/item.html","<fixed-content title=\"detail.username + \':\' + detail.company_name\" go-state=\"\'client.API\'\" wide=\"true\" item-class=\"\'api-item\'\">\n  <period-date-picker ng-model=\"period\" ng-change=\"search()\"></period-date-picker>\n  <div class=\"body\">\n    <highchart class=\"chart\" config=\"chartData\"></highchart>\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n      <a class=\"btn btn-primary download-chart\" ng-click=\"download()\">\n        <i class=\"glyphicon glyphicon-arrow-down\"></i> 下载表格\n      </a>\n      </div>\n    </div>\n  </div>\n  <div loading-container=\"tableParams.settings().$loading\" class=\"body\">\n    <table class=\"table table-bordered table-hover dataTable\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n      <tr ng-repeat=\"item in detail.items track by $index\">\n        <td data-title=\"\'时间\'\" ng-bind=\"item.data_time.slice(0,10)\"></td>\n        <td data-title=\"\'数据上报\'\" ng-bind=\"item.static\"></td>\n        <td data-title=\"\'搜索\'\" ng-bind=\"item.search\"></td>\n        <td data-title=\"\'推荐\'\" ng-bind=\"item.rec\"></td>\n        <td data-title=\"\'爬虫\'\" ng-bind=\"item.spider\"></td>\n        <td data-title=\"\'广告\'\" ng-bind=\"item.ad\"></td>\n        <td data-title=\"\'涉黄\'\" ng-bind=\"item.porn\"></td>\n        <td data-title=\"\'涉政\'\" ng-bind=\"item.politic\"></td>\n        <td data-title=\"\'反动\'\" ng-bind=\"item.reaction\"></td>\n        <td data-title=\"\'低质量\'\" ng-bind=\"item.nonsense\"></td>\n        <td data-title=\"\'分类\'\" ng-bind=\"item.classify\"></td>\n        <td data-title=\"\'标签\'\" ng-bind=\"item.tagging\"></td>\n        <td data-title=\"\'情感\'\" ng-bind=\"item.sentiment\"></td>\n      </tr>\n      <tr>\n        <td>总计</td>\n        <td data-title=\"\'数据上报\'\" ng-bind=\"sum.static\"></td>\n        <td data-title=\"\'搜索\'\" ng-bind=\"sum.search\"></td>\n        <td data-title=\"\'推荐\'\" ng-bind=\"sum.rec\"></td>\n        <td data-title=\"\'爬虫\'\" ng-bind=\"sum.spider\"></td>\n        <td data-title=\"\'广告\'\" ng-bind=\"sum.ad\"></td>\n        <td data-title=\"\'涉黄\'\" ng-bind=\"sum.porn\"></td>\n        <td data-title=\"\'涉政\'\" ng-bind=\"sum.politic\"></td>\n        <td data-title=\"\'反动\'\" ng-bind=\"sum.reaction\"></td>\n        <td data-title=\"\'低质量\'\" ng-bind=\"sum.nonsense\"></td>\n        <td data-title=\"\'分类\'\" ng-bind=\"sum.classify\"></td>\n        <td data-title=\"\'标签\'\" ng-bind=\"sum.tagging\"></td>\n        <td data-title=\"\'情感\'\" ng-bind=\"sum.sentiment\"></td>\n      </tr>\n    </table>\n  </div>\n</fixed-content>");
$templateCache.put("src/module/client/account/dialog/dialog.html","<div class=\"disable-modal-blur\"></div>\n<div class=\"modal-header\">\n  <dialog-close close=\"back()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"legend\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"scAccountForm\" novalidate>\n  <fieldset>\n    <legend class=\"section\">基本信息</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>公司名称</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"company_name\" ng-model=\"account.company_name\" class=\"form-control\" ng-maxlength=\"32\" ng-disabled=\"isEdit\">\n        <p ng-show=\"scAccountForm.company_name.$dirty && scAccountForm.company_name.$error.required\" class=\"text-danger\"><strong>公司名称是必填的</strong></p>\n        <p ng-show=\"scAccountForm.company_name.$dirty && scAccountForm.userName.$error.maxlength\" class=\"text-danger\"><strong>公司名称长度不能超过32</strong></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>用户名称</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"appName\" ng-model=\"account.app_name\" class=\"form-control\" ng-maxlength=\"32\" ng-required=\"true\" ng-disabled=\"is_edit\" ng-disabled=\"isEdit\">\n        <p ng-show=\"scAccountForm.appName.$dirty && scAccountForm.appName.$error.required\" class=\"text-danger\">\n          <strong>用户名称是必填的</strong></p>\n        <p ng-show=\"scAccountForm.appName.$dirty && scAccountForm.appName.$error.maxlength\" class=\"text-danger\">\n          <strong>用户名称长度不能超过32</strong></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>密码</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"pwdPassword\" ng-model=\"account.passwd\" class=\"form-control\" ng-required=\"true\">\n      </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"isCreate\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>密码</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"appPassword\" ng-model=\"account.passwd\" class=\"form-control\" ng-required=\"true\" ng-pattern=\"/^([0-9A-Za-z\\!@#\\$\\^&\\*\\(\\)+\\-]){6,18}$/\" ng-disabled=\"is_edit\">\n        <p ng-show=\"scAccountForm.appPassword.$dirty && scAccountForm.appPassword.$error.required\" class=\"text-danger\"><strong>密码是必填的</strong></p>\n        <p ng-show=\"scAccountForm.appPassword.$dirty && scAccountForm.appPassword.$error.pattern\" class=\"text-danger\">\n          <strong>密码必须是字母、数字或英文符号且长度6-18位</strong></p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n          <span class=\"required\"></span>启用\n        </label>\n      <div class=\"col-sm-10\">\n        <div class=\"checkbox\">\n          <input type=\"checkbox\" ng-model=\"account.is_online\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"is_online\" ng-change=\"changeStatus()\">\n          <label for=\"is_online\"></label>\n        </div>\n      </div>\n    </div>\n    <legend class=\"section\">功能\n      <span>0次表示不限制调用</span>\n    </legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>基础</label>\n      <div class=\"col-sm-10\">\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.rec_config == \'1\'}\">\n          <label for=\"rec_config\">\n              <input type=\"checkbox\" ng-model=\"account.rec_config\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"isEdit\" id=\"rec_config\">\n              推荐\n            </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.rec\">次/天\n          </div>\n        </div>\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.search_config == \'1\'}\">\n          <label for=\"search_config\">\n              <input type=\"checkbox\" ng-model=\"account.search_config\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"isEdit\" id=\"search_config\">\n              搜索\n            </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.search\">次/天\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <div class=\"row\">\n        <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>机器审核</label>\n        <div class=\"col-sm-10 ad\" ng-class=\"{\'active\': account.nlpdetail.ad == \'1\' || account.nlpdetail.nonsense == \'1\'}\">\n          <div class=\"row\">\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.ad\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.ad\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.ad\">\n                广告\n              </label>\n            </div>\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.nonsense\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.nonsense\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.nonsense\">\n                低质量\n              </label>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"number-limited\">\n              <input type=\"number\" ng-model=\"account.func_thold.ad\">次/天\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-2\"></div>\n        <div class=\"col-sm-10 porn\" ng-class=\"{\'active\': account.nlpdetail.porn == \'1\' || account.nlpdetail.politic == \'1\' || account.nlpdetail.reaction == \'1\'}\">\n          <div class=\"row\">\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.porn\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.porn\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.porn\">\n                涉黄\n              </label>\n            </div>\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.politic\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.politic\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.politic\">\n                涉政\n              </label>\n            </div>\n            <div class=\"checkbox col-sm-3\">\n              <label for=\"nlpdetail.reaction\">\n                <input type=\"checkbox\" ng-model=\"account.nlpdetail.reaction\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.reaction\">\n                反动\n              </label>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"number-limited\">\n              <input type=\"number\" ng-model=\"account.func_thold.porn\">次/天\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>机器阅读</label>\n      <div class=\"col-sm-10\">\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.nlpdetail.classify == \'1\'}\">\n          <label for=\"nlpdetail.classify\">\n              <input type=\"checkbox\" ng-model=\"account.nlpdetail.classify\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.classify\">\n              分类\n              </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.classify\">次/天\n          </div>\n        </div>\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.nlpdetail.tagging == \'1\'}\">\n          <label for=\"nlpdetail.tagging\">\n              <input type=\"checkbox\" ng-model=\"account.nlpdetail.tagging\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.tagging\">\n              打标签\n            </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.tagging\">次/天\n          </div>\n        </div>\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.nlpdetail.sentiment == \'1\'}\">\n          <label for=\"nlpdetail.sentiment\">\n              <input type=\"checkbox\" ng-model=\"account.nlpdetail.sentiment\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" id=\"nlpdetail.sentiment\">\n              感情分析\n            </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.sentiment\">次/天\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">其他</label>\n      <div class=\"col-sm-10\">\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.spider_config == \'1\'}\">\n          <label for=\"spider_config\">\n              <input type=\"checkbox\" ng-model=\"account.spider_config\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"isEdit\" id=\"spider_config\">\n              爬虫\n            </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.spider\">次/天\n          </div>\n        </div>\n        <div class=\"checkbox col-sm-3\" ng-class=\"{\'active\': account.static_config == \'1\'}\">\n          <label for=\"static_config\">\n              <input type=\"checkbox\" ng-model=\"account.static_config\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"isEdit\" id=\"static_config\">\n              统计\n            </label>\n          <div class=\"number-limited\">\n            <input type=\"number\" ng-model=\"account.func_thold.static\">次/天\n          </div>\n        </div>\n      </div>\n    </div>\n    <legend class=\"section\">来源</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>渠道</label>\n      <div class=\"col-sm-10\">\n        <select ng-model=\"account.channel_id\" class=\"form-control\" select-convert-to-number>\n            <option value=\"0\">空</option>\n            <option value=\"{{Number(key)}}\" ng-bind=\"item\" ng-repeat=\"(key, item) in channelList\" ng-if=\"[\'销售\', \'其他\', \'市场\'].indexOf(item) > -1\"></option>\n          </select>\n        <!--<div ng-click=\"cleanOtherValue()\" class=\"from-group\">\n            <div class=\"radio  col-sm-3\" ng-repeat=\"source in sources\">\n              <input type=\"radio\" ng-model=\"account.source\" ng-value=\"source\" id=\"{{source}}\" ng-disabled=\"isEdit\">\n              <label for=\"{{source}}\" ng-bind=\"source\"></label>\n            </div>\n            <div class=\"radio col-sm-3\">\n              <input type=\"radio\" ng-model=\"account.source\" ng-value=\"\'other\'\" id=\"other\" ng-disabled=\"isEdit\">\n              <label for=\"other\">其他</label>\n            </div>\n          </div>\n          <div class=\"from-group\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"account.otherSource\" ng-trim=\"true\" ng-disabled=\"account.source !== \'other\' || isEdit\">\n          </div>-->\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>负责人</label>\n      <div class=\"col-sm-10\">\n        <select class=\"form-control\" ng-model=\"account.manager_id\" ng-disabled=\"isEdit\" ng-options=\"manager.user_id as manager.user_nickname for manager in managers\">\n          </select>\n      </div>\n    </div>\n    <legend class=\"section\">状态</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>状态</label>\n      <div class=\"col-sm-10\">\n        <select ng-model=\"account.status\" class=\"form-control\">\n            <option value=\"{{status}}\" ng-bind=\"status\" ng-repeat=\"status in statuses\"></option>\n          </select>\n      </div>\n    </div>\n  </fieldset>\n  <div class=\"form-action\">\n    <div class=\"text-center\">\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"edit()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-edit\"></span>编辑\n        </button>\n      <button type=\"submit\" class=\"btn btn-default\" ng-click=\"back()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-remove\"></span>取消\n        </button>\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"save()\" ng-show=\"!isEdit\">保存</button>\n      <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel()\" ng-show=\"!isEdit\">取消</button>\n    </div>\n  </div>\n</form>");
$templateCache.put("src/module/client/review/dialog/dialog.html","<div class=\"modal-header\">\n  <dialog-close close=\"back()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"legend\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n  <fieldset ng-if=\"applyType == 1\">\n    <!-- 新建账号 -->\n    <review-label-group title=\"客户信息\" type=\"client\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"测试信息\" type=\"create\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"项目人员信息\" type=\"personnel\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"审核信息\" type=\"status\" data=\"baseData\"></review-label-group>\n  </fieldset>\n  <fieldset ng-if=\"applyType == 2\">\n    <!-- 功能编辑 -->\n    <review-label-group title=\"基本信息\" type=\"base\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"功能信息\" type=\"func\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"编辑信息\" type=\"editFunc\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"审核信息\" type=\"status\" data=\"baseData\"></review-label-group>\n  </fieldset>\n  <fieldset ng-if=\"applyType == 3\">\n    <!-- 开通申请 -->\n    <review-label-group title=\"客户信息\" type=\"client\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"测试信息\" type=\"create\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"审核信息\" type=\"status\" data=\"baseData\"></review-label-group>\n  </fieldset>\n  <fieldset ng-if=\"applyType == 4\">\n    <!-- 功能关闭 -->\n    <review-label-group title=\"基本信息\" type=\"base\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"功能信息\" type=\"func\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"审核信息\" type=\"status\" data=\"baseData\"></review-label-group>\n  </fieldset>\n  <fieldset ng-if=\"applyType == 5\">\n    <!-- 功能上线 -->\n    <review-label-group title=\"基本信息\" type=\"base\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"测试信息\" type=\"func\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"上线信息\" type=\"editFunc\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"审核信息\" type=\"status\" data=\"baseData\"></review-label-group>\n  </fieldset>\n  <fieldset ng-if=\"applyType == 6\">\n    <!-- 功能续签 -->\n    <review-label-group title=\"基本信息\" type=\"base\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"上线信息\" type=\"editFunc\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"续签信息\" type=\"status\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"审核信息\" type=\"status\" data=\"baseData\"></review-label-group>\n  </fieldset>\n  <fieldset ng-if=\"applyType == 7\">\n    <!-- 重启账号 -->\n    <review-label-group title=\"客户信息\" type=\"client\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"测试信息\" type=\"create\" data=\"funcData\"></review-label-group>\n    <review-label-group title=\"项目人员信息\" type=\"personnel\" data=\"baseData\"></review-label-group>\n    <review-label-group title=\"审核信息\" type=\"status\" data=\"baseData\"></review-label-group>\n  </fieldset>\n  \n  <div class=\"form-action\">\n    <div class=\"text-center\">\n      <button class=\"btn btn-primary\" ng-click=\"back()\">确定</button>\n    </div>\n  </div>\n</form>");
$templateCache.put("src/module/configManage/basicConfig/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号信息</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">appname:</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n            <label class=\"col-xs-2 control-label\">appid:</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n        <legend class=\"section\">基础配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">推荐类型：</label>\n            <div class=\"col-xs-4\">\n                <select class=\"form-control\" ng-model=\"params.rec_type\">\n                    <option ng-repeat=\"val in recTypes\" value=\"{{val.value}}\">{{val.name}}</option>\n                </select>\n            </div>\n\n            <label class=\"col-xs-2 control-label\">scene type：</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" min=\"0\" max=\"100\" class=\"form-control\" ng-model=\"params.scene_type\" placeholder=\"scene type\">\n            </div>\n\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">标题滤重：</label>\n            <div class=\"col-xs-4\">\n                <input type=\"number\" min=\"0\" max=\"100\" class=\"form-control\" ng-model=\"params.title_similarity\" placeholder=\"百分比\" required>\n            </div>\n            <label class=\"col-xs-2 control-label\">开启分页：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_open_page\" value=\"1\" ng-model=\"params.is_open_page\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_open_page\" value=\"0\" ng-model=\"params.is_open_page\">否</label>\n                </div>\n            </div>\n\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">允许推荐历史推荐过的item：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_filter_show\" value=\"0\" ng-model=\"params.is_filter_show\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_filter_show\" value=\"1\" ng-model=\"params.is_filter_show\">否</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">允许推荐历史点击过的item：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_filter_click\" value=\"0\" ng-model=\"params.is_filter_click\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_filter_click\" value=\"1\" ng-model=\"params.is_filter_click\">否</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"params.rec_type === \'personal\'\" ng-repeat=\"item in params.action_list track by $index\">\n            <label class=\"col-xs-4 control-label\" ng-if=\"$index==0\">触发个性化实时计算的用户行为集：</label>\n            <div class=\"col-xs-2\" ng-class=\"{\'col-xs-offset-4\': $index != 0}\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"item.name\">\n            </div>\n            <div class=\"col-xs-3 margin-fixed\">\n                <span class=\"add-style\" ng-click=\"deleteConfig($index, \'action_list\')\">\n                    <i class=\"fa fa-trash-o\"></i> 删除</span> &nbsp;&nbsp;&nbsp;\n                <span class=\"add-style\" ng-click=\"addConfig(\'action_list\')\" ng-show=\"$index == (params.action_list.length - 1)\">\n                    <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n            </div>\n        </div>\n    </fieldset>\n\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"confirm()\" ng-disabled=\"funcReviewForm.$invalid\">确定</button>\n            &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/configManage/diversityConfig/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号信息</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">appname:</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n            <label class=\"col-xs-2 control-label\">appid:</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n        <legend class=\"section\">多样性配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">推荐类型：</label>\n            <div class=\"col-xs-4\">\n                <select class=\"form-control\" ng-model=\"params.rec_type\">\n                    <option ng-repeat=\"val in recTypes\" value=\"{{val.value}}\">{{val.name}}</option>\n                </select>\n            </div>\n            <label class=\"col-xs-2 control-label\">scene type：</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.scene_type\" placeholder=\"scene type\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">属性：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"attribute\" ng-model=\"params.attribute\" value=\"category\">类目</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"attribute\" ng-model=\"params.attribute\" value=\"publisher\">作者</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"attribute\" ng-model=\"params.attribute\" value=\"tag\">标签</label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">多样性控制方式：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"diversity_type\" value=\"cnt\" ng-model=\"params.diversity_type\">个数</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"diversity_type\" value=\"percent\" ng-model=\"params.diversity_type\">占比</label>\n                </div>\n            </div>\n            <label class=\"col-xs-2 control-label\">类别个数/占比上限：</label>\n            <div class=\"col-xs-2\">\n                <input type=\"number\" min=\"0\" max=\"100\" class=\"form-control\" ng-model=\"params.upper_limit\" placeholder=\"upper_limit\" ng-pattern=\"/^([0-9]|\\.)*$/\" required>\n            </div>\n        </div>\n\n    </fieldset>\n\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"confirm()\" ng-disabled=\"funcReviewForm.$invalid\">确定</button>\n            &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/configManage/relatedSuggestConfig/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号信息</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">appname:</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n            <label class=\"col-xs-2 control-label\">appid:</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n        <legend class=\"section\">行为配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">开启天级配置：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" value=\"1\" ng-model=\"params.is_day\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                    <div class=\"radio\">\n                        <label>\n                            <input type=\"radio\" value=\"0\" ng-model=\"params.is_day\">否</label>\n                    </div>\n                </div>\n            \n        </div>\n        <div class=\"form-group\">\n            <table class=\"table table-hover table-bordered\">\n                <thead>\n                    <tr>\n                        <th>actionType</th>\n                        <th>weight</th>\n                        <th>itemMinShow</th>\n                        <th>algMark</th>\n                        <th>userMaxOp</th>\n                        <th>minItemPairFreq</th>\n                        <th>minTotalItemPairCnt</th>\n                        <th>操作</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr ng-repeat=\"item in params.day_action_detail track by $index\">\n                        <td align=\"center\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"item.action_type\">\n                        </td>\n                        <td align=\"center\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"item.weight\">\n                        </td>\n                        <td align=\"center\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"item.item_min_show\">\n                        </td>\n                        <td align=\"center\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"item.alg_mark\">\n                        </td>\n                        <td align=\"center\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"item.user_max_op\">\n                        </td>\n                        <td align=\"center\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"item.min_item_pair_freq\">\n                        </td>\n                        <td align=\"center\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"item.min_total_item_pair_cnt\">\n                        </td>\n\n                        <td align=\"center\">\n                            <div class=\"col-xs-2 margin-fixed\">\n                                <span class=\"add-style\" ng-click=\"deleteConfig($index, \'day_action_detail\')\">\n                                    <i class=\"fa fa-trash-o\"></i> 删除</span>\n                            </div>\n                        </td>\n                </tr></tbody>\n                \n            </table>\n            <div class=\"col-xs-3 margin-fixed\">\n                <span class=\"add-style\" ng-click=\"addConfig(\'day_action_detail\')\">\n                    <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n            </div>\n\n        </div>\n        <div class=\"form-group\">\n                <label class=\"col-xs-2 control-label\">开启小时级配置：</label>\n                <div class=\"col-xs-2\">\n                    <div class=\"radio\">\n                        <label>\n                            <input type=\"radio\" name=\"action_type\" value=\"1\" ng-model=\"params.is_hour\">是</label>\n                    </div>\n                </div>\n                <div class=\"col-xs-2\">\n                        <div class=\"radio\">\n                            <label>\n                                <input type=\"radio\" name=\"action_type\" value=\"0\" ng-model=\"params.is_hour\">否</label>\n                        </div>\n                    </div>\n                \n            </div>\n            <div class=\"form-group\">\n                <table class=\"table table-hover table-bordered\">\n                    <thead>\n                        <tr>\n                            <th>actionType</th>\n                            <th>weight</th>\n                            <th>itemMinShow</th>\n                            <th>algMark</th>\n                            <th>userMaxOp</th>\n                            <th>minItemPairFreq</th>\n                            <th>minTotalItemPairCnt</th>\n                            <th>操作</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"item in params.hour_action_detail track by $index\">\n                            <td align=\"center\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"item.action_type\">\n                            </td>\n                            <td align=\"center\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"item.weight\">\n                            </td>\n                            <td align=\"center\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"item.item_min_show\">\n                            </td>\n                            <td align=\"center\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"item.alg_mark\">\n                            </td>\n                            <td align=\"center\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"item.user_max_op\">\n                            </td>\n                            <td align=\"center\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"item.min_item_pair_freq\">\n                            </td>\n                            <td align=\"center\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"item.min_total_item_pair_cnt\">\n                            </td>\n    \n                            <td align=\"center\">\n                                <div class=\"col-xs-2 margin-fixed\">\n                                    <span class=\"add-style\" ng-click=\"deleteConfig($index, \'hour_action_detail\')\">\n                                        <i class=\"fa fa-trash-o\"></i> 删除</span>\n                                </div>\n                            </td>\n                    </tr></tbody>\n                    \n                </table>\n                <div class=\"col-xs-3 margin-fixed\">\n                    <span class=\"add-style\" ng-click=\"addConfig(\'hour_action_detail\')\">\n                        <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n                </div>\n    \n            </div>\n\n        <legend class=\"section\">推荐结果配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">day_cnt：</label>\n            <div class=\"col-xs-2\">\n                <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"params.day_cnt\" placeholder=\"day_cnt\" required>\n            </div>\n            <label class=\"col-xs-2 control-label\">同类别优先：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_same_cate_first\" value=\"1\" ng-model=\"params.is_same_cate_first\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_same_cate_first\" value=\"0\" ng-model=\"params.is_same_cate_first\">否</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">result_len：</label>\n            <div class=\"col-xs-2\">\n                <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"params.result_len\" placeholder=\"result_len\" required>\n            </div>\n            <label class=\"col-xs-2 control-label\">同标签优先：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_same_tag_first\" value=\"1\" ng-model=\"params.is_same_tag_first\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"is_same_tag_first\" value=\"0\" ng-model=\"params.is_same_tag_first\">否</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">expire time：</label>\n            <div class=\"col-xs-2\">\n                <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"params.expire_time\" placeholder=\"expire_time\" required>\n            </div>\n\n        </div>\n    </fieldset>\n\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"confirm()\" ng-disabled=\"funcReviewForm.$invalid\">确定</button>\n            &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/configManage/timeConfig/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号信息</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">appname:</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n            <label class=\"col-xs-2 control-label\">appid:</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n        <legend class=\"section\">时效性配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">推荐类型：</label>\n            <div class=\"col-xs-4\">\n                <select class=\"form-control\" ng-model=\"params.rec_type\">\n                    <option ng-repeat=\"val in recTypes\" value=\"{{val.value}}\">{{val.name}}</option>\n                </select>\n            </div>\n\n            <label class=\"col-xs-2 control-label\">scene type：</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.scene_type\" placeholder=\"scene type\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">分类频道：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" name=\"specify_cate\" ng-click=\"selectCate()\" value=\"\" ng-model=\"params.specify_cate\">不限制</label>\n                </div>\n            </div>\n            <div class=\"form-group\" ng-repeat=\"item in params.specify_cate track by $index\">\n                <div class=\"col-xs-2\" ng-class=\"{\'col-xs-offset-4\': $index != 0}\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"item.name\">\n                </div>\n                <div class=\"col-xs-3 margin-fixed\">\n                    <span class=\"add-style\" ng-click=\"deleteConfig($index, \'specify_cate\')\">\n                        <i class=\"fa fa-trash-o\"></i> 删除</span> &nbsp;&nbsp;&nbsp;\n                    <span class=\"add-style\" ng-click=\"addConfig(\'specify_cate\')\" ng-show=\"$index == (params.specify_cate.length - 1)\">\n                        <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">时效性策略：</label>\n            <div class=\"col-xs-8\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"timeliness_strategy\" ng-model=\"params.timeliness_strategy\" value=\"1\">只推荐n天内的item</label>\n                    <label>\n                        <input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"params.day_limit\" placeholder=\"天数\" ng-pattern=\"/^([0-9]|\\.)*$/\">\n                    </label>\n                    <label style=\"padding:0\">天内</label>\n                </div>\n\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"timeliness_strategy\" ng-model=\"params.timeliness_strategy\" value=\"2\">时间越近越优先</label>\n                </div>\n            </div>\n        </div>\n    </fieldset>\n\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"confirm()\" ng-disabled=\"funcReviewForm.$invalid\">确定</button>\n            &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/management/advanced/item/item.html","<fixed-content title=\"title\" go-state=\"\'management.advanced\'\">\n  <fieldset>\n    <legend class=\"section\" ng-bind=\"legend\"></legend>\n    <form class=\"form-horizontal\" role=\"form\" name=\"account\">\n      <!--<h1 ng-bind=\"account | json\"></h1>-->\n      <div class=\"form-group\">\n        <label for=\"nick-name\" class=\"col-sm-2 control-label\">用户</label>\n        <div class=\"col-sm-10\">\n          <!--<label class=\"control-label\"><i class=\"fa fa-times-circle-o\"></i> Input with error</label>-->\n          <input type=\"text\" class=\"form-control\" id=\"nick-name\" placeholder=\"昵称\" ng-model=\"user.nickname\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"login-name\" class=\"col-sm-2 control-label\">登录邮箱</label>\n        <div class=\"col-sm-10\">\n          <input type=\"email\" class=\"form-control\" id=\"login-name\" placeholder=\"登录邮箱\" ng-model=\"user.login_name\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"password\" class=\"col-sm-2 control-label\">密码</label>\n        <div class=\"col-sm-10\">\n          <input type=\"text\" class=\"form-control\" id=\"password\" placeholder=\"密码\" ng-model=\"user.login_passwd\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"nick-name\" class=\"col-sm-2 control-label\">状态</label>\n        <div class=\"col-sm-10\">\n          <div class=\"checkbox\">\n            <label for=\"is-online\">\n              <input type=\"checkbox\" id=\"is-online\" ng-model=\"user.is_online\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" ng-required=\"true\" ng-checked=\"user.is_online == 1 ? true : false\">\n              启用 (启用后可配置用户所属部门，禁用会将用户从其所属的所有部门删除)\n            </label>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\" ng-hide=\"isCreate || !user.is_online\">\n        <label class=\"col-sm-2 control-label\">部门</label>\n        <div class=\"col-sm-10\">\n          <div class=\"checkbox col-sm-3\" ng-repeat=\"role in RoleList track by $index\">\n            <label>\n              <input type=\"checkbox\" ng-model=\"roleCheckedList[$index]\" ng-true-value=\"{{role.role_id}}\" ng-false-value=\"null\" ng-checked=\"roleIsExisted(role.role_id)\">\n              <span ng-bind=\"role.role_name\" class=\"nowrap\"></span>\n            </label>\n          </div>\n        </div>\n      </div>\n    </form>\n    <div class=\"form-actions\">\n      <div class=\"text-center\">\n        <!--<button type=\"submit\" class=\"btn btn-danger\" ng-click=\"delete()\" ng-show=\"!isEdit\">-->\n          <!--<span class=\"glyphicon glyphicon-remove\"></span>删除-->\n        <!--</button>-->\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"update()\" ng-show=\"!isEdit\">保存</button>\n        <button type=\"submit\" class=\"btn btn-default\" ng-click=\"back()\" ng-show=\"!isEdit\">取消</button>\n      </div>\n    </div>\n  </fieldset>\n</fixed-content>");
$templateCache.put("src/module/management/channel/dialog/dialog.html","<div class=\"modal-header\">\n  <dialog-close close=\"close()\"></dialog-close>\n  <h3 class=\"modal-title\">新建渠道</h3>\n</div>\n<div class=\"modal-body\">\n  <form role=\"form\" class=\"form-horizontal\">\n    <div class=\"form-group\">\n      <label class=\"control-label col-sm-2\">渠道名</label>\n      <div class=\"input-group col-sm-9\">\n        <input type=\"text\" ng-model=\"channel.name\" placeholder=\"请输入渠道名\" class=\"form-control\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"control-label col-sm-2\">状态</label>\n      <div class=\"input-group col-sm-9\">\n        <div class=\"radio col-sm-3\">\n        <label>\n            <input type=\"radio\" ng-model=\"channel.is_del\" ng-value=\"{{0}}\">\n            启用\n          </label>\n        </div>\n        <div class=\"radio col-sm-3\">\n          <label>\n            <input type=\"radio\" ng-model=\"channel.is_del\" ng-value=\"{{1}}\">\n            禁用\n          </label>\n        </div>\n      </div>\n    </div>\n    <div class=\"text-center\">\n      <dialog-cancel-button cancel=\"close()\"></dialog-cancel-button>\n      <dialog-confirm-button confirm=\"confirm()\"></dialog-confirm-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("src/module/management/industry/dialog/dialog.html","<div class=\"modal-header\">\n  <dialog-close close=\"close()\"></dialog-close>\n  <h3 class=\"modal-title\">新建渠道</h3>\n</div>\n<div class=\"modal-body\">\n  <form role=\"form\" class=\"form-horizontal\">\n    <div class=\"form-group\">\n      <label class=\"control-label col-sm-2\">渠道名</label>\n      <div class=\"input-group col-sm-9\">\n        <input type=\"text\" ng-model=\"channel.name\" placeholder=\"请输入渠道名\" class=\"form-control\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"control-label col-sm-2\">状态</label>\n      <div class=\"input-group col-sm-9\">\n        <div class=\"radio col-sm-3\">\n        <label>\n            <input type=\"radio\" ng-model=\"channel.is_del\" ng-value=\"{{0}}\">\n            启用\n          </label>\n        </div>\n        <div class=\"radio col-sm-3\">\n          <label>\n            <input type=\"radio\" ng-model=\"channel.is_del\" ng-value=\"{{1}}\">\n            禁用\n          </label>\n        </div>\n      </div>\n    </div>\n    <div class=\"text-center\">\n      <dialog-cancel-button cancel=\"close()\"></dialog-cancel-button>\n      <dialog-confirm-button confirm=\"confirm()\"></dialog-confirm-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("src/module/management/mailTemplate/dialog/dialog.html","<div class=\"modal-header\">\n  <dialog-close close=\"close()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"title\"></h3>\n</div>\n<div class=\"modal-body\">\n  <form role=\"form\" name=\"mailTemplate\" novalidate>\n    <div class=\"form-group\">\n      <label class=\"control-label\">名称</label>\n      <select name=\"name\" class=\"form-control\" ng-model=\"mail.name\">\n        <option value=\"{{ key }}\" ng-repeat=\"(key, type) in mailType\" ng-bind=\"type\"></option>\n      </select>\n      <form-message label=\"名称\" name=\"name\"></form-message>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"control-label\">HTML模板</label>\n      <textarea ng-model=\"mail.html\" placeholder=\"HTML模板内容\" class=\"form-control\" name=\"html\" required style=\"resize: vertical\"></textarea>\n      <form-message label=\"HTML模板\" name=\"html\"></form-message>\n    </div>\n    <div class=\"text-center\">\n      <dialog-cancel-button cancel=\"close()\"></dialog-cancel-button>\n      <dialog-confirm-button confirm=\"confirm()\" ng-disabled=\"mailTemplate.$invalid\"></dialog-confirm-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("src/module/management/menu/dialog/dialog.html","<div class=\"disable-modal-blur\"></div>\n<div class=\"modal-header\">\n  <dialog-close close=\"close()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"title\"></h3>\n</div>\n<form class=\"form-horizontal small-form\" name=\"menuForm\" novalidate>\n  <fieldset>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>菜单名</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"name\" ng-model=\"menu.name\" class=\"form-control\" required>\n        <form-message label=\"菜单名\" name=\"name\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        图标名</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"project_name\" ng-model=\"menu.icon_class\" class=\"form-control\">\n        <small class=\"help-block\">\n          查找图标\n          <a target=\"_blank\" href=\"http://v3.bootcss.com/components/#glyphicons\">glyphicons系列</a>\n          ，\n          <a target=\"_blank\" href=\"http://fontawesome.io/icons/\">fontawesome系列</a>\n          。\n          找到图标后将 class 名填入此处。\n        </small>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">链接</label>\n      <div class=\"col-sm-10\">\n        <ui-select ng-model=\"tmp.link\" theme=\"select2\" style=\"width: 100%\">\n          <ui-select-match placeholder=\"选择链接\">{{$select.selected.name}}</ui-select-match>\n          <ui-select-choices group-by=\"\'parent\'\" repeat=\"route in routerList | filter: {name: $select.search}\">\n            <small ng-bind-html=\"route.name | highlight: $select.search\"></small>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">角色列表</label>\n      <div class=\"col-sm-10\">\n        <ui-select ng-model=\"tmp.role_list\" multiple=\"multiple\" class=\"role-list-selector\">\n          <ui-select-choices repeat=\"role in roleList | filter: $select.search track by role.role_id\">\n            <small ng-bind-html=\"role.role_name | highlight: $select.search\"></small>\n          </ui-select-choices>\n          <ui-select-match placeholder=\"选择角色\">{{$item.role_name}}</ui-select-match>\n        </ui-select>\n      </div>\n    </div>\n  </fieldset>\n  <div class=\"form-action\">\n    <div class=\"text-center\">\n      <button type=\"submit\" class=\"btn btn-primary btn-flat\" ng-click=\"update()\" ng-disabled=\"menuForm.$invalid\">确定</button>\n      <button type=\"submit\" class=\"btn btn-default btn-flat\" ng-click=\"close()\">取消</button>\n    </div>\n  </div>\n</form>");
$templateCache.put("src/module/management/resource/group/group.html","<div class=\"box-header\">\n  <a class=\"btn btn-primary btn-sm\" ng-click=\"create()\">\n    <span class=\"glyphicon glyphicon-plus\"></span> 新建资源组\n  </a>\n</div>\n<div loading-container=\"tableParams.settings().$loading\" class=\"box-body\" fixed-table-header>\n  <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n    <tr ng-repeat=\"item in $data\" ui-sref=\"management.resource.group.item({id: item.id})\">\n      <td data-title=\"\'名称\'\" ng-bind=\"item.name\" class=\"text-align-center\"></td>\n      <td data-title=\"\'状态\'\" ng-bind=\"item.del | disabled\" class=\"text-align-center\"></td>\n    </tr>\n  </table>\n</div>\n<ui-view></ui-view>\n");
$templateCache.put("src/module/management/resource/resource/resource.html","<section class=\"content\">\n    <div class=\"box-header\">\n        <a class=\"btn btn-primary btn-sm\" ng-click=\"create()\">\n          <span class=\"glyphicon glyphicon-plus\"></span> 新建资源\n        </a>\n    </div>\n    <div loading-container=\"tableParams.settings().$loading\" class=\"box-body\" fixed-table-header>\n      <table class=\"table table-hover table-bordered\" ng-table=\"tableParams\" template-pagination=\"src/common/pagination.html\">\n        <tr ng-repeat=\"item in $data\" ui-sref=\"management.resource.resource.item({resource_id: item.resource_id})\">\n          <td data-title=\"\'name\'\" ng-bind=\"item.resource_name\" class=\"text-align-center\"></td>\n          <td data-title=\"\'source_name\'\" ng-bind=\"item.source_name\" class=\"text-align-center\"></td>\n          <td data-title=\"\'状态\'\" ng-bind=\"item.status | status\" class=\"text-align-center\"></td>\n        </tr>\n      </table>\n    </div>\n</section>\n<ui-view></ui-view>");
$templateCache.put("src/module/management/role/item/item.html","<fixed-content title=\"title\" go-state=\"\'management.role\'\">\n  <fieldset>\n    <legend class=\"section\" ng-bind=\"legend\"></legend>\n    <form class=\"form-horizontal\" role=\"form\">\n      <div class=\"form-group\">\n        <label for=\"nick-name\" class=\"col-sm-2 control-label\">角色名称</label>\n        <div class=\"col-sm-10\">\n          <input type=\"text\" class=\"form-control\" id=\"nick-name\" placeholder=\"角色名\" ng-model=\"role.role_name\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"col-sm-offset-2 col-sm-10\">\n          <div class=\"checkbox\">\n            <input type=\"checkbox\" id=\"status\" ng-model=\"role.status\" ng-true-value=\"true\" ng-true-value=\"false\" ng-disabled=\"isEdit\" ng-required=\"true\">\n            <label for=\"status\">\n              禁用\n            </label>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\" ng-hide=\"isCreate\">\n        <label for=\"resource\" class=\"col-sm-2 control-label\">权限</label>\n        <div class=\"col-sm-10\">\n          <div class=\"col-xs-12 resource-list\">\n            <div class=\"col-xs-2\">权限名</div>\n            <div class=\"col-xs-2\">增加</div>\n            <div class=\"col-xs-2\">删除</div>\n            <div class=\"col-xs-2\">查询</div>\n            <div class=\"col-xs-2\">改动</div>\n            <div class=\"col-xs-2\">全选</div>\n          </div>\n          <div class=\"col-xs-12 resource-list\" ng-repeat=\"resource in resourceList track by $index\">\n            <div class=\"col-xs-2\"><span ng-bind=\"resource.resource_name\"></span></div>\n            <div class=\"col-xs-2\"><input type=\"checkbox\" ng-model=\"resource[\'post\']\" ng-checked=\"check(resource, \'post\')\" ng-click=\"select(resource, \'post\')\"></div>\n            <div class=\"col-xs-2\"><input type=\"checkbox\" ng-model=\"resource[\'delete\']\" ng-checked=\"check(resource, \'delete\')\" ng-click=\"select(resource, \'delete\')\"></div>\n            <div class=\"col-xs-2\"><input type=\"checkbox\" ng-model=\"resource[\'get\']\" ng-checked=\"check(resource, \'get\')\" ng-click=\"select(resource, \'get\')\"></div>\n            <div class=\"col-xs-2\"><input type=\"checkbox\" ng-model=\"resource[\'put\']\" ng-checked=\"check(resource, \'put\')\" ng-click=\"select(resource, \'put\')\"></div>\n            <div class=\"col-xs-2\"><input type=\"checkbox\" ng-model=\"resource[\'all\']\" ng-checked=\"check(resource, \'all\')\" ng-click=\"select(resource, \'all\')\"></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\" ng-hide=\"isCreate\">\n        <label for=\"resource\" class=\"col-sm-2 control-label\">用户</label>\n        <div class=\"col-sm-10\">\n          <div class=\"checkbox col-sm-4\" ng-repeat=\"user in UserList track by $index\" ng-if=\"user.is_online == 1\">\n            <div class=\"checkbox\">\n              <label for=\"{{user.login_name}}\">\n                <input type=\"checkbox\" id=\"{{user.login_name}}\" ng-model=\"userCheckedList[$index]\" ng-true-value=\"{{user.admin_staffid}}\" ng-false-value=\"null\" ng-checked=\"userIsExisted(user.admin_staffid)\">\n                <span ng-bind=\"user.nickname\"></span>\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n\n    <div class=\"form-actions\">\n      <div class=\"text-center\">\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"edit()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-edit\"></span>编辑\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\" ng-click=\"delete()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-remove\"></span>删除\n        </button>\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"update()\" ng-show=\"!isEdit\">保存</button>\n        <button type=\"submit\" class=\"btn btn-default\" ng-click=\"back()\" ng-show=\"!isEdit\">取消</button>\n      </div>\n    </div>\n  </fieldset>\n</fixed-content>");
$templateCache.put("src/module/management/user/item/item.html","<fixed-content title=\"title\" go-state=\"\'management.user\'\">\n  <fieldset>\n    <legend class=\"section\" ng-bind=\"legend\"></legend>\n    <form class=\"form-horizontal\" role=\"form\">\n      <div class=\"form-group\">\n        <label for=\"login-name\" class=\"col-sm-2 control-label\">登录邮箱</label>\n        <div class=\"col-sm-10\">\n          <input type=\"email\" class=\"form-control\" id=\"login-name\" placeholder=\"登录邮箱\" ng-model=\"user.login_name\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"nick-name\" class=\"col-sm-2 control-label\">昵称</label>\n        <div class=\"col-sm-10\">\n          <input type=\"text\" class=\"form-control\" id=\"nick-name\" placeholder=\"昵称\" ng-model=\"user.nickname\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"password\" class=\"col-sm-2 control-label\">密码</label>\n        <div class=\"col-sm-10\">\n          <input type=\"text\" class=\"form-control\" id=\"password\" placeholder=\"密码\" ng-model=\"user.login_passwd\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"col-sm-offset-2 col-sm-10\">\n          <div class=\"checkbox\">\n            <input type=\"checkbox\" id=\"is-online\" ng-model=\"user.is_online\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" ng-required=\"true\" ng-checked=\"user.is_online == 1 ? true : false\">\n            <label for=\"is-online\">\n              上线\n            </label>\n          </div>\n        </div>\n      </div>\n    </form>\n    <div class=\"form-actions\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"edit()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-edit\"></span>编辑\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\" ng-click=\"delete()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-remove\"></span>删除\n        </button>\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"update()\" ng-show=\"!isEdit\">保存</button>\n        <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel()\" ng-show=\"!isEdit\">取消</button>\n      </div>\n    </div>\n  </fieldset>\n</fixed-content>");
$templateCache.put("src/module/offline/data/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'启动importer\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">appname：</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">appid：</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">date：</label>\n            <date-picker ng-model=\"data_date\" disable-clear></date-picker>\n        </div>\n\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">data：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.item_info\">item_info</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.user_item\">user_item</label>\n                </div>\n            </div>\n\n        </div>\n\n\n    </fieldset>\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"save()\" ng-disabled=\"funcReviewForm.$invalid\">启动</button> &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/offline/hot/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">appname：</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">appid：</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">time_mode：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"time_mode\" ng-model=\"params.time_mode\" value=\"day\">day</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"time_mode\" ng-model=\"params.time_mode\" value=\"hour\">hour</label>\n                </div>\n            </div>\n        </div>\n\n    </fieldset>\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"save()\" ng-disabled=\"funcReviewForm.$invalid\">启动</button> &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/offline/rec/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">appname：</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">appid：</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">time_mode：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"time_mode\" ng-model=\"params.time_mode\" value=\"day\">day</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"time_mode\" ng-model=\"params.time_mode\" value=\"hour\">hour</label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">算法：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" 1ng-false-value=\"0\" ng-model=\"params.cf\">CF</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.rec\">REC</label>\n                </div>\n            </div>\n\n        </div>\n    </fieldset>\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"save()\" ng-disabled=\"funcReviewForm.$invalid\">启动</button> &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/project/testApplication/accountApplicationDialog/dialog.html","<!--申请-->\n<div class=\"disable-modal-blur\"></div>\n<div class=\"modal-header\">\n  <dialog-close close=\"back()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"legend\"></h3>\n</div>\n<form class=\"form-horizontal small-form\" name=\"accountApplicationForm\" novalidate>\n  <fieldset>\n    <legend class=\"section\">客户信息</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\">\n        <span class=\"required\"></span>企业名称</label>\n      <div class=\"col-sm-9\">\n        <input type=\"text\" name=\"company_name\" ng-model=\"application.company_name\" class=\"form-control\" required placeholder=\"例：达而观信息科技（上海）有限公司\">\n        <form-message label=\"企业名称\" name=\"company_name\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\">\n        <span class=\"required\"></span>项目(产品)名称</label>\n      <div class=\"col-sm-9\">\n        <input type=\"text\" name=\"project_name\" ng-model=\"application.project_name\" class=\"form-control\" required placeholder=\"例：达观数据大师APP\">\n        <form-message label=\"项目(产品)名称\" name=\"project_name\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\"><span class=\"required\"></span>应用名称</label>\n      <div class=\"col-sm-9\">\n        <input type=\"text\" name=\"username\" ng-model=\"application.app_name\" class=\"form-control\" required placeholder=\"例：datagranddemo\">\n        <form-message label=\"应用名称\" name=\"username\"></form-message>\n      </div>\n    </div>\n    <legend class=\"section\">测试信息</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\"><span class=\"required\"></span>测试功能</label>\n      <div class=\"col-sm-9\">\n        <div class=\"row\">\n          <div class=\"col-sm-3\" ng-repeat=\"fn in functionList track by $index\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[fn.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span ng-bind=\"fn.name\" class=\"nowrap\"></span>\n              </label>\n            </div>\n          </div>\n        </div>\n        <label class=\"control-label error\" ng-if=\"checkFunctionRequired()\">\n          <i class=\"fa fa-times-circle-o\"></i><span>测试功能是必填的</span>\n        </label>\n      </div>\n    </div>\n    <legend class=\"section\">项目人员</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\">\n        <span class=\"required\"></span>项目管理\n      </label>\n      <div class=\"col-sm-9\">\n        <select class=\"form-control\" ng-model=\"application.follower\" select-convert-to-number name=\"follower\" required>\n          <option value=\"{{user.user_id}}\" ng-bind=\"user.user_nickname\" ng-repeat=\"user in role\"></option>\n        </select>\n        <form-message label=\"项目管理\" name=\"follower\"></form-message>\n      </div>\n    </div>\n  </fieldset>\n  <div class=\"form-action\">\n    <div class=\"text-center\">\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"submit()\" ng-disabled=\"accountApplicationForm.$invalid\">提交</button>\n      <button type=\"submit\" class=\"btn btn-default\" ng-click=\"back()\">取消</button>\n    </div>\n  </div>\n  <div ng-init=\"setForm(accountApplicationForm)\"></div>\n</form>");
$templateCache.put("src/module/project/testApplication/applicationDialog/dialog.html","<!--申请-->\n<div class=\"disable-modal-blur\"></div>\n<div class=\"modal-header\" ng-hide=\"preview\">\n  <dialog-close close=\"back()\"></dialog-close>\n  <h3 class=\"modal-title\" ng-bind=\"legend\"></h3>\n</div>\n<form class=\"form-horizontal small-form\" name=\"applicationForm\" novalidate ng-hide=\"preview\">\n  <fieldset>\n    <legend class=\"section\">客户信息</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>企业名称</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"company_name\" ng-model=\"application.company_name\" class=\"form-control\" required placeholder=\"例：达而观信息科技（上海）有限公司\">\n        <label ng-messages=\"formVerification(\'company_name\').error\" class=\"control-label error\" ng-if=\"formVerification(\'company_name\').show\">\n          <i class=\"fa fa-times-circle-o\"></i><span ng-message=\"required\">企业名称是必填的</span>\n        </label>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>项目(产品)名称</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"project_name\" ng-model=\"application.project_name\" class=\"form-control\" required placeholder=\"例：达观数据大师APP\">\n        <form-message label=\"项目(产品)名称\" name=\"project_name\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>应用名称</label>\n      <div class=\"col-sm-10\">\n        <input type=\"text\" name=\"industry\" ng-model=\"application.username\" class=\"form-control\" required placeholder=\"例：datagrand123\" ng-pattern=\"/^[A-Za-z0-9]+$/\">\n        <form-message label=\"应用名称\" name=\"industry\"></form-message>\n        <p class=\"help-block text-red small\">*只允许填写英文和数字</p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>测试位置</label>\n      <div class=\"col-sm-10\">\n        <textarea class=\"form-control\" ng-model=\"application.test_position\" name=\"testPosition\"></textarea>\n        <p class=\"row\">\n          <small class=\"help-block text-red col-sm-5\">*请务必准确描述测试位置，否则账号无法审核开通</small>\n          <small class=\"col-sm-7\">例：测试位置1-PC端-视频详情页-大家都在看模块-使用相关推荐</small>\n        </p>\n        <form-message label=\"测试位置\" name=\"testPosition\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>渠道</label>\n      <div class=\"col-sm-10\">\n        <select class=\"form-control\" ng-model=\"application.channel_id\" select-convert-to-number required name=\"channel\">\n          <option value=\"{{key}}\" ng-bind=\"channel\" ng-repeat=\"(key, channel) in channelList\" ng-if=\"[\'销售\', \'其他\', \'市场\'].indexOf(channel) > -1\"></option>\n        </select>\n        <form-message label=\"渠道\" name=\"channel\"></form-message>\n      </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"channelList[application.channel_id] == \'其他\'\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>其他渠道</label>\n      <div class=\"col-sm-10\">\n        <input class=\"form-control\" type=\"text\" ng-model=\"application.source\" ng-required=\"channelList[application.channel_id] == \'其他\'\" name=\"source\">\n        <form-message label=\"其他渠道\" name=\"source\"></form-message>\n      </div>\n    </div>\n    <legend class=\"section\">测试信息</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>测试周期</label>\n      <div class=\"col-sm-10\">\n        <date-picker ng-model=\"period.start\" disable-clear beyond-today min-date=\"dateConfig.minDate\" max-date=\"period.end\" ng-change=\"dateConfig.change()\" max-date=\"dateConfig.maxDate\"></date-picker>\n        <date-picker ng-model=\"period.end\" disable-clear beyond-today min-date=\"period.start\"></date-picker>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\"><span class=\"required\"></span>测试功能</label>\n      <div class=\"col-sm-10\">\n        <div class=\"row\">\n          <div class=\"col-sm-3\" ng-repeat=\"function in functionList track by $index\">\n            <div class=\"checkbox\">\n              <label>\n                <input name=\"function\" type=\"checkbox\" ng-model=\"application[function.key]\" ng-blur=\"doTouched()\" ng-required=\"!functionRequire()\" ng-true-value=\"1\" ng-false-value=\"0\">\n                <span ng-bind=\"function.name\" class=\"nowrap\"></span>\n              </label>\n            </div>\n          </div>\n        </div>\n        <label class=\"control-label error\" ng-if=\"checkFunctionRequired()\">\n          <i class=\"fa fa-times-circle-o\"></i><span>测试功能是必填的</span>\n        </label>\n      </div>\n    </div>\n    <legend class=\"section\">项目人员</legend>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\">\n        <span class=\"required\"></span>客户\n      </label>\n      <div class=\"col-sm-10 client-info\">\n        <div class=\"col-sm-3\">\n          <input type=\"text\" name=\"projectInfo1\" ng-model=\"application.custom_manager\" class=\"form-control input-sm\" required placeholder=\"项目负责人\">\n          <form-message label=\"项目负责人\" name=\"projectInfo1\"></form-message>\n        </div>\n        <div class=\"col-sm-3\">\n          <input type=\"text\" name=\"projectInfo2\" class=\"form-control input-sm\" placeholder=\"负责人职位\" ng-model=\"application.custom_position\" required>\n          <form-message label=\"负责人职位\" name=\"projectInfo2\"></form-message>\n        </div>\n        <div class=\"col-sm-3\">\n          <input type=\"text\" name=\"projectInfo3\" class=\"form-control input-sm\" placeholder=\"负责人电话\" ng-model=\"application.custom_tel\" required ng-pattern=\"/^(0|86|17951)?(13[0-9]|14[579]|15[012356789]|16[0-9]|17[0135678]|18[0-9])[0-9]{8}$/\">\n          <form-message label=\"负责人电话\" name=\"projectInfo3\"></form-message>\n        </div>\n        <div class=\"col-sm-3\">\n          <input type=\"text\" name=\"projectInfo4\" class=\"form-control input-sm\" placeholder=\"负责人邮箱\" ng-model=\"application.custom_email\" required ng-pattern=\"/^[^@]+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/\">\n          <form-message label=\"负责人邮箱\" name=\"projectInfo4\"></form-message>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2\"></label>\n      <div class=\"col-sm-10 client-info\">\n        <p class=\"help-block\">其他《测试信息表》接收邮箱：\n          <button class=\"btn btn-default btn-sm btn-flat\" ng-click=\"addEmail()\">新增</button>\n        </p>\n        <div class=\"col-sm-6 other-email\" ng-repeat=\"email in application.other_email track by $index\">\n          <div>\n            <div class=\"input-group\">\n              <input type=\"text\" class=\"form-control input-sm\" ng-model=\"application.other_email[$index]\" placeholder=\"输入邮箱\" name=\"{{\'otherEmail\' + $index}}\" ng-pattern=\"/^[^@]+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/\">\n              <span class=\"input-group-btn\">\n              <button class=\"btn\">\n                <span class=\"glyphicon glyphicon-remove\" ng-click=\"removeEmail($index)\"></span>\n              </button>\n              </span>\n            </div>\n            <label class=\"control-label error\" ng-messages=\"formVerification(\'otherEmail\' + $index).error\" ng-if=\"formVerification(\'otherEmail\' + $index).show\">\n            <i class=\"fa fa-times-circle-o\"></i><span ng-message=\"pattern\">邮箱格式错误</span>\n          </label>\n          </div>\n        </div>\n      </div>\n    </div>\n  </fieldset>\n  <div class=\"form-action\">\n    <div class=\"text-center\">\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"submit()\" ng-disabled=\"applicationForm.$invalid\" ng-show=\"is_edit\">提交</button>\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"preview = true\" ng-disabled=\"applicationForm.$invalid\" ng-hide=\"is_edit\">提交</button>\n      <button type=\"submit\" class=\"btn btn-default\" ng-click=\"back()\">取消</button>\n    </div>\n  </div>\n  <div ng-init=\"setForm(applicationForm)\"></div>\n</form>\n\n<div class=\"preview\" ng-show=\"preview\">\n  <div class=\"modal-header\">\n    <dialog-close close=\"back()\"></dialog-close>\n    <h3 class=\"modal-title\">预览</h3>\n  </div>\n  <form class=\"form-horizontal small-form\" novalidate>\n    <fieldset>\n      <legend class=\"section\">客户信息</legend>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">\n          <span class=\"required\"></span>公司名称</label>\n        <div class=\"col-sm-9\">\n          <p ng-bind=\"application.company_name\">\n        </p></div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">\n          <span class=\"required\"></span>项目(产品)名称</label>\n        <div class=\"col-sm-9\">\n          <p ng-bind=\"application.project_name\"></p>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\"><span class=\"required\"></span>应用名称</label>\n        <div class=\"col-sm-9\">\n          <p ng-bind=\"application.username\"></p>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">测试位置</label>\n        <div class=\"col-sm-9\">\n          <p ng-bind=\"application.test_position\"></p>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">渠道</label>\n        <div class=\"col-sm-9\">\n          <p><span ng-bind=\"channelList[application.channel_id]\"></span><span ng-show=\"application.source\" ng-bind=\"\'->\' + application.source\"></span></p>\n        </div>\n      </div>\n      <legend class=\"section\">测试信息</legend>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\"><span class=\"required\"></span>测试周期</label>\n        <div class=\"col-sm-9\">\n          <p ng-bind=\"period.start + \'——\' + period.end\"></p>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\"><span class=\"required\"></span>测试功能</label>\n        <div class=\"col-sm-9\">\n          <p>\n            <span ng-repeat=\"function in functionList track by $index\" ng-bind=\"function.name\" ng-show=\"application[function.key] == 1\"></span>\n          </p>\n        </div>\n      </div>\n      <legend class=\"section\">项目人员</legend>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">\n          <span class=\"required\"></span>客户\n        </label>\n        <div class=\"col-sm-9 client-info\">\n          <p>\n            <span ng-bind=\"application.custom_manager\"></span>\n            <span ng-bind=\"application.custom_position\"></span>\n            <span ng-bind=\"application.custom_tel\"></span>\n            <span ng-bind=\"application.custom_email\"></span>\n          </p>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3\"></label>\n        <div class=\"col-sm-9 client-info\">\n          <p class=\"help-block\">其他《测试信息表》接收邮箱：\n            <span ng-show=\"application.other_email.length == 0\">无</span></p>\n          <div class=\"col-sm-6 other-email\" ng-repeat=\"email in application.other_email track by $index\">\n            <p ng-bind=\"email\"></p>\n          </div>\n        </div>\n      </div>\n    </fieldset>\n    <div class=\"form-action\">\n      <div class=\"text-center\">\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"submit()\">提交</button>\n        <button type=\"submit\" class=\"btn btn-default\" ng-click=\"preview = false\">编辑</button>\n      </div>\n    </div>\n  </form>\n</div>");
$templateCache.put("src/module/recConfig/aboutRecConfig/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号信息</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">appname:</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n            <label class=\"col-xs-2 control-label\">appid:</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n        <legend class=\"section\">基础配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">is_odps：</label>\n            <div class=\"col-xs-1\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"save_type\" value=\"1\" ng-model=\"params.save_type\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-1\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"save_type\" value=\"0\" ng-model=\"params.save_type\">否</label>\n                </div>\n            </div>\n            <label class=\"col-xs-2 control-label\">cf_type：</label>\n            <div class=\"col-xs-1\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"save_type\" value=\"1\" ng-model=\"params.save_type\">day</label>\n                </div>\n            </div>\n            <div class=\"col-xs-1\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"save_type\" value=\"0\" ng-model=\"params.save_type\">other</label>\n                </div>\n            </div>\n\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">table_name：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"save_type\" value=\"1\" ng-model=\"params.save_type\">user_item</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"save_type\" value=\"0\" ng-model=\"params.save_type\">page_visit_info</label>\n                </div>\n            </div>\n\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">cf_day_cnt：</label>\n            <div class=\"col-xs-2\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"item.weight\" placeholder=\"cf_day_cnt\" ng-pattern=\"/^([0-9]|\\.)*$/\" required>\n            </div>\n            <label class=\"col-xs-3 control-label\">result_cnt：</label>\n            <div class=\"col-xs-2\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"item.weight\" placeholder=\"result_cnt\" ng-pattern=\"/^([0-9]|\\.)*$/\" required>\n            </div>\n\n        </div>\n\n\n\n\n        <legend class=\"section\">推荐效果配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">冷启动用户推荐结果多样性：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"diversity\" ng-model=\"params.diversity\" value=\"1\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"diversity\" ng-model=\"params.diversity\" value=\"0\">否</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">推荐结果数量：</label>\n            <div class=\"col-xs-3\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.rec_num\" ng-pattern=\"/^([0-9]|\\.)*$/\" required>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">过期时间：</label>\n            <div class=\"col-xs-3\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.tempExpire\" ng-pattern=\"/^[0-9]+$/\" required>\n            </div>\n            <label class=\"col-xs-1 control-label\">\n                小时\n            </label>\n        </div>\n\n        <legend class=\"section\">点击率排序配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">排序方式：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.sort_all\">all</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.sort_cate\">cate</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.sort_newrec\">newrec</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\" ng-repeat=\"item in params.ctr_config track by $index\">\n            <label class=\"col-xs-2 control-label\" ng-if=\"$index==0\">权重设置：</label>\n            <div class=\"col-xs-2\" ng-class=\"{\'col-xs-offset-2\': $index != 0}\">\n                <select class=\"form-control\" name=\"time\" ng-model=\"item.time\">\n                    <option ng-hide=\"existTime(val, params.ctr_config)\" ng-repeat=\"val in [1,2,3,4,5,6,7]\" value=\"{{val}}\">{{val + \'天\'}}</option>\n                </select>\n            </div>\n            <div class=\"col-xs-2\">\n                <input type=\"text\" ng-model=\"item.weight\" placeholder=\"weight\" class=\"form-control\">\n            </div>\n            <div class=\"col-xs-3 margin-fixed\">\n                <span class=\"add-style\" ng-click=\"deleteConfig($index, \'ctr_config\')\">\n                    <i class=\"fa fa-trash-o\"></i> 删除</span> &nbsp;&nbsp;&nbsp;\n                <span class=\"add-style\" ng-click=\"addConfig(\'ctr_config\')\" ng-show=\"$index == (params.ctr_config.length - 1)\">\n                    <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n            </div>\n        </div>\n    </fieldset>\n\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"confirm()\" ng-disabled=\"funcReviewForm.$invalid\">确定</button> &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/recConfig/actionConfig/item/item.html","<fixed-content title=\"title\" go-state=\"\'recConfig.actionConfig\'\">\n    <fieldset>\n        <legend class=\"section\" ng-bind=\"legend\"></legend>\n        <form class=\"form-horizontal\" role=\"form\">\n            <div class=\"form-group\">\n                <label for=\"\" class=\"col-xs-3 control-label\">appid</label>\n                <div class=\"col-xs-9\">\n                    <!-- <select class=\"form-control\" ng-model=\"holder.appInfo\" data-ng-options=\"app.app_name for app in appReflect\"></select> -->\n                    <dg-combo-box selected-item=\"holder.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label for=\"\" class=\"col-xs-3 control-label\">data_type</label>\n                <div class=\"col-xs-9\">\n                    <!-- <select class=\"form-control\" ng-model=\"data.data_type\" ng-options=\"data_type for data_type in data_type_list\"></select> -->\n                    <select class=\"form-control\" ng-model=\"data.data_type\" disabled=\"true\">\n                        <option value=\"user_item_action\">user_item_action</option>\n                        <option value=\"page_visit_info\">page_visit_info</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-xs-3 control-label\">action_list</label>\n                <div class=\"col-xs-3\">\n                    <label class=\"control-label\">action</label>\n                </div>\n                <div class=\"col-xs-2\">\n                    <label class=\"control-label\">操作</label>\n                </div>\n            </div>\n            <div class=\"form-group\" ng-repeat=\"actionType in action_list_tmp track by $index\">\n                <label class=\"col-xs-3 control-label\">\n                </label>\n                <div class=\"col-xs-3 text-left\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"action_list_tmp[$index]\">\n                </div>\n                <label class=\"col-xs-2 control-label remove-style text-left\">\n                    <span ng-click=\"removeItem(actionType, $index)\"><i class=\"fa fa-trash-o\"></i> 删除</span>\n                </label>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-xs-3 control-label\"></label>\n                <div class=\"col-xs-3\">\n                    <input class=\"form-control\" type=\"text\" ng-model=\"params.action_temp\" ng-hide=\"showSelect\">\n                    <select class=\"form-control\" ng-model=\"params.action_temp\" ng-show=\"showSelect\" ng-options=\"action_type for action_type in action_type_list\"></select>\n                </div>\n                <label class=\"col-xs-2 add-style control-label text-left\" ng-click=\"add()\">\n                        <span><i class=\"fa fa-plus-square-o\"></i> 添加</span>\n                    </label>\n                <label class=\"col-xs-2 control-label text-left\">\n                        <span ng-click=\"toggleShowSelect()\"><i class=\"fa fa-refresh\"></i> <span ng-bind=\"showSelect ? \'手动输入\': \'下拉选择\'\"></span></span>\n                    </label>\n            </div>\n            <div class=\"form-group\">\n                <label for=\"\" class=\"col-xs-3\"></label>\n                <div class=\"col-xs-9\">\n                    <button class=\"btn btn-primary\" ng-click=\"save()\">保存</button> &nbsp;\n                    <button class=\"btn btn-danger\" ui-sref=\"recConfig.actionConfig\">取消</button>\n                </div>\n            </div>\n        </form>\n    </fieldset>\n</fixed-content>");
$templateCache.put("src/module/recConfig/hotRecConfig/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">appname:</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n            <label class=\"col-xs-2 control-label\">appid:</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n\n        <legend class=\"section\">字段权重配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">生效范围：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-model=\"params.effect_range.daily\" ng-true-value=\"1\" ng-false-value=\"0\">天级</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-model=\"params.effect_range.hourly\" ng-true-value=\"1\" ng-false-value=\"0\">小时级</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\" ng-repeat=\"item in params.data_type_config track by $index\">\n            <label class=\"col-xs-2 control-label\" ng-if=\"$index == 0\">权重设置：</label>\n            <div class=\"col-xs-3\" ng-class=\"{\'col-xs-offset-2\': $index != 0}\">\n                <select class=\"form-control\" ng-model=\"item.data_type\">\n                    <option ng-repeat=\"val in [\'user_item_action\', \'item_info\', \'ctr\', \'page_visit\']\" value=\"{{val}}\">{{val}}</option>\n                </select>\n            </div>\n            <div class=\"col-xs-2\">\n                <input type=\"text\" ng-model=\"item.field\" placeholder=\"field\" class=\"form-control\">\n            </div>\n            <div class=\"col-xs-2\">\n                <input type=\"text\" ng-model=\"item.weight\" placeholder=\"weight\" class=\"form-control\">\n            </div>\n            <div class=\"col-xs-3 margin-fixed\">\n                <span class=\"add-style\" ng-click=\"deleteConfig($index, \'data_type_config\')\">\n                    <i class=\"fa fa-trash-o\"></i> 删除\n                </span> &nbsp;&nbsp;&nbsp;\n                <span class=\"add-style\" ng-click=\"addConfig(\'data_type_config\')\" ng-show=\"$index == (params.data_type_config.length - 1)\">\n                    <i class=\"fa fa-plus-square-o\"></i> 添加\n                </span>\n            </div>\n        </div>\n        <legend class=\"section\">时间权重配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-3 control-label\">热推结果保存方式：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"save_type\" value=\"1\" ng-model=\"params.save_type\">分天</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"save_type\" value=\"0\" ng-model=\"params.save_type\">不分天</label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\" ng-repeat=\"item in params.time_config track by $index\">\n            <label class=\"col-xs-2 control-label\" ng-if=\"$index==0\">权重设置：</label>\n            <div class=\"col-xs-2\" ng-class=\"{\'col-xs-offset-2\': $index != 0}\">\n                <select class=\"form-control\" name=\"time\" ng-model=\"item.time\">\n                    <option ng-hide=\"existTime(val, params.time_config)\" ng-repeat=\"val in [1,2,3,4,5,6,7]\" value=\"{{val}}\">{{val + \'天\'}}</option>\n                </select>\n            </div>\n            <div class=\"col-xs-2\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"item.weight\" placeholder=\"weight\" ng-pattern=\"/^([0-9]|\\.)*$/\" required>\n            </div>\n            <div class=\"col-xs-3 margin-fixed\">\n                <span class=\"add-style\" ng-click=\"deleteConfig($index, \'time_config\')\">\n                    <i class=\"fa fa-trash-o\"></i> 删除</span> &nbsp;&nbsp;&nbsp;\n                <span class=\"add-style\" ng-click=\"addConfig(\'time_config\')\" ng-show=\"$index == (params.time_config.length - 1)\">\n                    <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n            </div>\n        </div>\n\n        <legend class=\"section\">推荐效果配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">冷启动用户推荐结果多样性：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"diversity\" ng-model=\"params.diversity\" value=\"1\">是</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"radio\">\n                    <label>\n                        <input type=\"radio\" name=\"diversity\" ng-model=\"params.diversity\" value=\"0\">否</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">推荐结果数量：</label>\n            <div class=\"col-xs-3\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.rec_num\" ng-pattern=\"/^([0-9]|\\.)*$/\" required>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">过期时间：</label>\n            <div class=\"col-xs-3\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.tempExpire\" ng-ng-pattern=\"/^[0-9]+$/\" required>\n            </div>\n            <label class=\"col-xs-1 control-label\">\n                小时\n            </label>\n        </div>\n\n        <legend class=\"section\">点击率排序配置</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-2 control-label\">排序方式：</label>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.sort_all\">all</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.sort_cate\">cate</label>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <div class=\"checkbox\">\n                    <label>\n                        <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"params.sort_newrec\">newrec</label>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\" ng-repeat=\"item in params.ctr_config track by $index\">\n            <label class=\"col-xs-2 control-label\" ng-if=\"$index==0\">权重设置：</label>\n            <div class=\"col-xs-2\" ng-class=\"{\'col-xs-offset-2\': $index != 0}\">\n                <select class=\"form-control\" name=\"time\" ng-model=\"item.time\">\n                    <option ng-hide=\"existTime(val, params.ctr_config)\" ng-repeat=\"val in [1,2,3,4,5,6,7]\" value=\"{{val}}\">{{val + \'天\'}}</option>\n                </select>\n            </div>\n            <div class=\"col-xs-2\">\n                <input type=\"text\" ng-model=\"item.weight\" placeholder=\"weight\" class=\"form-control\">\n            </div>\n            <div class=\"col-xs-3 margin-fixed\">\n                <span class=\"add-style\" ng-click=\"deleteConfig($index, \'ctr_config\')\">\n                    <i class=\"fa fa-trash-o\"></i> 删除</span> &nbsp;&nbsp;&nbsp;\n                <span class=\"add-style\" ng-click=\"addConfig(\'ctr_config\')\" ng-show=\"$index == (params.ctr_config.length - 1)\">\n                    <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n            </div>\n        </div>\n    </fieldset>\n\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"confirm()\" ng-disabled=\"funcReviewForm.$invalid\">确定</button> &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/recConfig/mergeConfig/item/item.html","<div class=\"modal-header\">\n    <dialog-close close=\"cancel()\"></dialog-close>\n    <h3 class=\"modal-title\" ng-bind=\"isCreate ? \'新建配置\': \'编辑配置\'\"></h3>\n</div>\n<form class=\"form-horizontal\" name=\"funcReviewForm\" novalidate>\n    <fieldset>\n        <legend class=\"section\">账号</legend>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">appname：</label>\n            <div class=\"col-xs-4\">\n                <dg-combo-box selected-item=\"params.appInfo\" item-list=\"appReflect\" item-name=\"app_name\"></dg-combo-box>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">appid：</label>\n            <div class=\"col-xs-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"params.appInfo.appid\" disabled=\"disabled\">\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label for=\"\" class=\"col-xs-4 control-label\">mode：</label>\n            <div class=\"col-xs-4\">\n                <select class=\"form-control\" name=\"time\" ng-model=\"params.mode\" ng-change=\"change(params.mode)\">\n                    <option ng-repeat=\"val in [1,2,3]\">{{val}}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"form-group form-fixed\">\n            <label class=\"col-xs-4 control-label\">time_interval_threshold：</label>\n            <div class=\"col-xs-8 text-left\">\n                <div>\n                    <input type=\"text\" class=\"control-label input-width\" ng-model=\"params.time_threshold_min\" ng-pattern=\"/^(\\-?)([0-9]|\\.)*$/\" required ng-disabled=\"params.mode==3\">\n                    <label class=\"control-label\">到</label>\n                    <input type=\"text\" class=\"control-label input-width\" ng-model=\"params.time_threshold_max\" ng-pattern=\"/^(\\-?)([0-9]|\\.)*$/\" required ng-disabled=\"params.mode==3\">\n                </div>\n                <p class=\"help-block text-red small\">*mode=3时，该项不用操作</p>\n                <p class=\"help-block text-red small\">*只允许填写数字且开始小于结束</p>\n            </div>\n\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"col-xs-4 control-label\">action_type_list：</label>\n            <div class=\"col-xs-3\">\n                <label class=\"control-label\">action</label>\n            </div>\n            <label class=\"col-xs-2 control-label remove-style text-left\">\n                <span>操作</span>\n            </label>\n\n        </div>\n\n        <div ng-show=\"params.mode==2||params.mode==3 \">\n\n            <div class=\"form-group\" ng-repeat=\"actionType in action_list_tmp track by $index\">\n                <label class=\"col-xs-4 control-label\">\n                </label>\n                <div class=\"col-xs-3 text-left\">\n                    <input type=\"text\" class=\"form-control\" ng-model=\"action_list_tmp[$index]\">\n                </div>\n                <label class=\"col-xs-2 control-label remove-style text-left\">\n                    <span ng-click=\"removeItem(actionType, $index)\">\n                        <i class=\"fa fa-trash-o\"></i> 删除</span>\n                </label>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-xs-4 control-label\"></label>\n                <div class=\"col-xs-3\">\n                    <input class=\"form-control\" type=\"text\" ng-model=\"params.action_temp\" ng-hide=\"showSelect\">\n                    <select class=\"form-control\" ng-model=\"params.action_temp\" ng-show=\"showSelect\" ng-options=\"action_type for action_type in action_type_list\"></select>\n                </div>\n                <label class=\"col-xs-2 add-style control-label text-left\" ng-click=\"add()\">\n                    <span>\n                        <i class=\"fa fa-plus-square-o\"></i> 添加</span>\n                </label>\n                <label class=\"col-xs-2 control-label text-left\">\n                    <span ng-click=\"toggleShowSelect()\">\n                        <i class=\"fa fa-refresh\"></i>\n                        <span ng-bind=\"showSelect ? \'手动输入\': \'下拉选择\'\"></span>\n                    </span>\n                </label>\n            </div>\n        </div>\n    </fieldset>\n    <div class=\"form-action\">\n        <div class=\"text-center\">\n            <button class=\"btn btn-primary btn-flat\" type=\"button\" ng-click=\"save()\" ng-disabled=\"funcReviewForm.$invalid \">确定</button> &nbsp;&nbsp;\n            <button class=\"btn btn-default btn-flat\" type=\"button\" ng-click=\"cancel()\">取消</button>\n        </div>\n    </div>\n</form>");
$templateCache.put("src/module/management/resource/group/item/item.html","<fixed-content title=\"title\" go-state=\"\'management.resource.group\'\">\n  <fieldset>\n    <legend ng-bind=\"legend\"></legend>\n    <form class=\"form-horizontal\" role=\"form\">\n      <div class=\"form-group\">\n        <label for=\"nick-name\" class=\"col-sm-2 control-label\">资源名</label>\n        <div class=\"col-sm-10\">\n          <input type=\"text\" class=\"form-control\" id=\"nick-name\" placeholder=\"资源名\" ng-model=\"resourceGroup.name\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"col-sm-offset-2 col-sm-10\">\n          <div class=\"checkbox\">\n            <input type=\"checkbox\" id=\"is-del\" ng-model=\"resourceGroup.del\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"isEdit\" ng-required=\"true\" ng-checked=\"resourceGroup.del == 1 ? true : false\">\n            <label for=\"is-del\">\n              禁用\n            </label>\n          </div>\n        </div>\n      </div>\n    </form>\n    <section class=\"widget\" ng-hide=\"isCreate\">\n      <header>\n        <h4 ng-show=\"isEdit\">资源组包含资源</h4>\n        <h4 ng-show=\"!isEdit\">添加资源到该资源组</h4>\n      </header>\n      <div class=\"body\">\n        <!--资源组组包含资源-->\n        <div loading-container=\"resourceGroupList.settings().$loading\" ng-show=\"isEdit\">\n          <table class=\"table table-hover\" ng-table=\"resourceGroupList\" template-pagination=\"src/common/pagination.html\">\n            <tr ng-repeat=\"item in $data\">\n              <td data-title=\"\'资源名\'\" ng-bind=\"item.name\" class=\"text-align-center\"></td>\n            </tr>\n          </table>\n        </div>\n        <!--角色组添加用户-->\n        <div loading-container=\"resourceList.settings().$loading\" ng-show=\"!isEdit\">\n          <table class=\"table table-hover\" ng-table=\"resourceList\" template-pagination=\"src/common/pagination.html\">\n            <tr ng-repeat=\"item in $data\">\n              <td data-title=\"\'选择\'\" class=\"text-align-left\">\n                <div class=\"checkbox\">\n                  <label for=\"{{item.id}}\">\n                    <input type=\"checkbox\" id=\"{{item.id}}\" ng-model=\"resourceCheckedList[$index]\" ng-true-value=\"{{item.id}}\" ng-false-value=\"null\" ng-checked=\"resourceIsExisted(item.id)\">\n                  </label>\n                </div>\n              </td>\n              <td data-title=\"\'name\'\" ng-bind=\"item.name\" class=\"text-align-center\"></td>\n              <td data-title=\"\'source_name\'\" ng-bind=\"item.source_name\" class=\"text-align-center\"></td>\n              <td data-title=\"\'状态\'\" ng-bind=\"item.del | disabled\" class=\"text-align-center\"></td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </section>\n    <div class=\"form-actions\">\n      <div class=\"text-center\">\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"edit()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-edit\"></span>编辑\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\" ng-click=\"delete()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-remove\"></span>删除\n        </button>\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"update()\" ng-show=\"!isEdit\">保存</button>\n        <button type=\"submit\" class=\"btn btn-default\" ng-click=\"back()\" ng-show=\"!isEdit\">取消</button>\n      </div>\n    </div>\n  </fieldset>\n</fixed-content>");
$templateCache.put("src/module/management/resource/resource/item/item.html","<fixed-content title=\"title\" go-state=\"\'management.resource.resource\'\">\n  <fieldset>\n    <legend ng-bind=\"legend\"></legend>\n    <form class=\"form-horizontal\" role=\"form\">\n      <div class=\"form-group\">\n        <label for=\"nick-name\" class=\"col-sm-2 control-label\">资源名</label>\n        <div class=\"col-sm-10\">\n          <input type=\"text\" class=\"form-control\" id=\"nick-name\" placeholder=\"资源名\" ng-model=\"resource.resource_name\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"source_name\" class=\"col-sm-2 control-label\">source_name</label>\n        <div class=\"col-sm-10\">\n          <input type=\"text\" class=\"form-control\" id=\"source_name\" placeholder=\"source_name\" ng-model=\"resource.source_name\" ng-disabled=\"isEdit\" ng-required=\"true\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"col-sm-offset-2 col-sm-10\">\n          <div class=\"checkbox\">\n            <input type=\"checkbox\" id=\"is-del\" ng-model=\"resource.status\" ng-true-value=\"0\" ng-false-value=\"1\" ng-disabled=\"isEdit\" ng-required=\"true\">\n            <label for=\"is-del\">\n              禁用\n            </label>\n          </div>\n        </div>\n      </div>\n    </form>\n    <div class=\"form-actions\">\n      <div class=\"col-sm-offset-2 col-sm-10\">\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"edit()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-edit\"></span>编辑\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\" ng-click=\"delete()\" ng-show=\"isEdit\">\n          <span class=\"glyphicon glyphicon-remove\"></span>删除\n        </button>\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"update()\" ng-show=\"!isEdit\">保存</button>\n        <button type=\"submit\" class=\"btn btn-default\" ng-click=\"cancel()\" ng-show=\"!isEdit\">取消</button>\n      </div>\n    </div>\n  </fieldset>\n</fixed-content>");}]);